export const AIRPORTS_ARRAY = [
  {
    id: "GKA",
    name: "Goroka Airport",
    city: "Goroka",
    country: "Papua New Guinea",
    lat: -6.081689834590001,
    lng: 145.391998291,
  },
  {
    id: "MAG",
    name: "Madang Airport",
    city: "Madang",
    country: "Papua New Guinea",
    lat: -5.20707988739,
    lng: 145.789001465,
  },
  {
    id: "HGU",
    name: "Mount Hagen Kagamuga Airport",
    city: "Mount Hagen",
    country: "Papua New Guinea",
    lat: -5.826789855957031,
    lng: 144.29600524902344,
  },
  {
    id: "LAE",
    name: "Nadzab Airport",
    city: "Nadzab",
    country: "Papua New Guinea",
    lat: -6.569803,
    lng: 146.725977,
  },
  {
    id: "POM",
    name: "Port Moresby Jacksons International Airport",
    city: "Port Moresby",
    country: "Papua New Guinea",
    lat: -9.443380355834961,
    lng: 147.22000122070312,
  },
  {
    id: "WWK",
    name: "Wewak International Airport",
    city: "Wewak",
    country: "Papua New Guinea",
    lat: -3.58383011818,
    lng: 143.669006348,
  },
  {
    id: "UAK",
    name: "Narsarsuaq Airport",
    city: "Narssarssuaq",
    country: "Greenland",
    lat: 61.1604995728,
    lng: -45.4259986877,
  },
  {
    id: "GOH",
    name: "Godthaab / Nuuk Airport",
    city: "Godthaab",
    country: "Greenland",
    lat: 64.19090271,
    lng: -51.6781005859,
  },
  {
    id: "SFJ",
    name: "Kangerlussuaq Airport",
    city: "Sondrestrom",
    country: "Greenland",
    lat: 67.0122218992,
    lng: -50.7116031647,
  },
  {
    id: "THU",
    name: "Thule Air Base",
    city: "Thule",
    country: "Greenland",
    lat: 76.5311965942,
    lng: -68.7032012939,
  },
  {
    id: "AEY",
    name: "Akureyri Airport",
    city: "Akureyri",
    country: "Iceland",
    lat: 65.66000366210938,
    lng: -18.07270050048828,
  },
  {
    id: "EGS",
    name: "Egilsstaðir Airport",
    city: "Egilsstadir",
    country: "Iceland",
    lat: 65.2833023071289,
    lng: -14.401399612426758,
  },
  {
    id: "HFN",
    name: "Hornafjörður Airport",
    city: "Hofn",
    country: "Iceland",
    lat: 64.295601,
    lng: -15.2272,
  },
  {
    id: "HZK",
    name: "Húsavík Airport",
    city: "Husavik",
    country: "Iceland",
    lat: 65.952301,
    lng: -17.426001,
  },
  {
    id: "IFJ",
    name: "Ísafjörður Airport",
    city: "Isafjordur",
    country: "Iceland",
    lat: 66.05809783935547,
    lng: -23.135299682617188,
  },
  {
    id: "KEF",
    name: "Keflavik International Airport",
    city: "Keflavik",
    country: "Iceland",
    lat: 63.985000610352,
    lng: -22.605600357056,
  },
  {
    id: "PFJ",
    name: "Patreksfjörður Airport",
    city: "Patreksfjordur",
    country: "Iceland",
    lat: 65.555801,
    lng: -23.965,
  },
  {
    id: "RKV",
    name: "Reykjavik Airport",
    city: "Reykjavik",
    country: "Iceland",
    lat: 64.1299972534,
    lng: -21.9405994415,
  },
  {
    id: "SIJ",
    name: "Siglufjörður Airport",
    city: "Siglufjordur",
    country: "Iceland",
    lat: 66.133301,
    lng: -18.9167,
  },
  {
    id: "VEY",
    name: "Vestmannaeyjar Airport",
    city: "Vestmannaeyjar",
    country: "Iceland",
    lat: 63.42430114746094,
    lng: -20.278900146484375,
  },
  {
    id: "YAM",
    name: "Sault Ste Marie Airport",
    city: "Sault Sainte Marie",
    country: "Canada",
    lat: 46.48500061035156,
    lng: -84.5093994140625,
  },
  {
    id: "N",
    name: "Winnipeg / St. Andrews Airport",
    city: "Winnipeg",
    country: "Canada",
    lat: 50.0564002991,
    lng: -97.03250122070001,
  },
  {
    id: "N",
    name: "Halifax / CFB Shearwater Heliport",
    city: "Halifax",
    country: "Canada",
    lat: 44.639702,
    lng: -63.499401,
  },
  {
    id: "YAY",
    name: "St. Anthony Airport",
    city: "St. Anthony",
    country: "Canada",
    lat: 51.3918991089,
    lng: -56.083099365200006,
  },
  {
    id: "YAZ",
    name: "Tofino / Long Beach Airport",
    city: "Tofino",
    country: "Canada",
    lat: 49.079833,
    lng: -125.775583,
  },
  {
    id: "YBB",
    name: "Kugaaruk Airport",
    city: "Pelly Bay",
    country: "Canada",
    lat: 68.534401,
    lng: -89.808098,
  },
  {
    id: "YBC",
    name: "Baie Comeau Airport",
    city: "Baie Comeau",
    country: "Canada",
    lat: 49.13249969482422,
    lng: -68.20439910888672,
  },
  {
    id: "YBG",
    name: "CFB Bagotville",
    city: "Bagotville",
    country: "Canada",
    lat: 48.33060073852539,
    lng: -70.99639892578125,
  },
  {
    id: "YBK",
    name: "Baker Lake Airport",
    city: "Baker Lake",
    country: "Canada",
    lat: 64.29889678960001,
    lng: -96.077796936,
  },
  {
    id: "YBL",
    name: "Campbell River Airport",
    city: "Campbell River",
    country: "Canada",
    lat: 49.950801849365234,
    lng: -125.27100372314453,
  },
  {
    id: "YBR",
    name: "Brandon Municipal Airport",
    city: "Brandon",
    country: "Canada",
    lat: 49.91,
    lng: -99.951897,
  },
  {
    id: "YCB",
    name: "Cambridge Bay Airport",
    city: "Cambridge Bay",
    country: "Canada",
    lat: 69.1081008911,
    lng: -105.138000488,
  },
  {
    id: "YCD",
    name: "Nanaimo Airport",
    city: "Nanaimo",
    country: "Canada",
    lat: 49.054970224899996,
    lng: -123.869862556,
  },
  {
    id: "YCG",
    name: "Castlegar/West Kootenay Regional Airport",
    city: "Castlegar",
    country: "Canada",
    lat: 49.2963981628,
    lng: -117.632003784,
  },
  {
    id: "YCH",
    name: "Miramichi Airport",
    city: "Chatham",
    country: "Canada",
    lat: 47.007801,
    lng: -65.449203,
  },
  {
    id: "YCL",
    name: "Charlo Airport",
    city: "Charlo",
    country: "Canada",
    lat: 47.990799,
    lng: -66.330299,
  },
  {
    id: "YCO",
    name: "Kugluktuk Airport",
    city: "Coppermine",
    country: "Canada",
    lat: 67.816704,
    lng: -115.143997,
  },
  {
    id: "YCT",
    name: "Coronation Airport",
    city: "Coronation",
    country: "Canada",
    lat: 52.0750007629,
    lng: -111.444999695,
  },
  {
    id: "YCW",
    name: "Chilliwack Airport",
    city: "Chilliwack",
    country: "Canada",
    lat: 49.1528015137,
    lng: -121.939002991,
  },
  {
    id: "YCY",
    name: "Clyde River Airport",
    city: "Clyde River",
    country: "Canada",
    lat: 70.4860992432,
    lng: -68.5167007446,
  },
  {
    id: "YZS",
    name: "Coral Harbour Airport",
    city: "Coral Harbour",
    country: "Canada",
    lat: 64.1932983398,
    lng: -83.3593978882,
  },
  {
    id: "YDA",
    name: "Dawson City Airport",
    city: "Dawson",
    country: "Canada",
    lat: 64.04309844970703,
    lng: -139.1280059814453,
  },
  {
    id: "YDB",
    name: "Burwash Airport",
    city: "Burwash",
    country: "Canada",
    lat: 61.37110137939453,
    lng: -139.04100036621094,
  },
  {
    id: "N",
    name: "Princeton Airport",
    city: "Princeton",
    country: "Canada",
    lat: 49.4681015015,
    lng: -120.511001587,
  },
  {
    id: "YDF",
    name: "Deer Lake Airport",
    city: "Deer Lake",
    country: "Canada",
    lat: 49.21080017089844,
    lng: -57.39139938354492,
  },
  {
    id: "YDL",
    name: "Dease Lake Airport",
    city: "Dease Lake",
    country: "Canada",
    lat: 58.4221992493,
    lng: -130.031997681,
  },
  {
    id: "YDN",
    name: "Dauphin Barker Airport",
    city: "Dauphin",
    country: "Canada",
    lat: 51.100799560546875,
    lng: -100.052001953125,
  },
  {
    id: "YDQ",
    name: "Dawson Creek Airport",
    city: "Dawson Creek",
    country: "Canada",
    lat: 55.7422981262207,
    lng: -120.18299865722656,
  },
  {
    id: "YEG",
    name: "Edmonton International Airport",
    city: "Edmonton",
    country: "Canada",
    lat: 53.309700012200004,
    lng: -113.580001831,
  },
  {
    id: "YEK",
    name: "Arviat Airport",
    city: "Eskimo Point",
    country: "Canada",
    lat: 61.0942001343,
    lng: -94.07080078119999,
  },
  {
    id: "YEN",
    name: "Estevan Airport",
    city: "Estevan",
    country: "Canada",
    lat: 49.2103004456,
    lng: -102.966003418,
  },
  {
    id: "YET",
    name: "Edson Airport",
    city: "Edson",
    country: "Canada",
    lat: 53.578899383499994,
    lng: -116.464996338,
  },
  {
    id: "YEU",
    name: "Eureka Airport",
    city: "Eureka",
    country: "Canada",
    lat: 79.9946975708,
    lng: -85.814201355,
  },
  {
    id: "YEV",
    name: "Inuvik Mike Zubko Airport",
    city: "Inuvik",
    country: "Canada",
    lat: 68.30419921880001,
    lng: -133.483001709,
  },
  {
    id: "YFB",
    name: "Iqaluit Airport",
    city: "Iqaluit",
    country: "Canada",
    lat: 63.756402,
    lng: -68.555801,
  },
  {
    id: "YFC",
    name: "Fredericton Airport",
    city: "Fredericton",
    country: "Canada",
    lat: 45.868900299072266,
    lng: -66.53720092773438,
  },
  {
    id: "YFE",
    name: "Forestville Airport",
    city: "Forestville",
    country: "Canada",
    lat: 48.74610137939453,
    lng: -69.09719848632812,
  },
  {
    id: "YFO",
    name: "Flin Flon Airport",
    city: "Flin Flon",
    country: "Canada",
    lat: 54.6781005859375,
    lng: -101.68199920654297,
  },
  {
    id: "YFR",
    name: "Fort Resolution Airport",
    city: "Fort Resolution",
    country: "Canada",
    lat: 61.1808013916,
    lng: -113.690002441,
  },
  {
    id: "YFS",
    name: "Fort Simpson Airport",
    city: "Fort Simpson",
    country: "Canada",
    lat: 61.76020050048828,
    lng: -121.23699951171875,
  },
  {
    id: "YGK",
    name: "Kingston Norman Rogers Airport",
    city: "Kingston",
    country: "Canada",
    lat: 44.22529983520508,
    lng: -76.5969009399414,
  },
  {
    id: "YGL",
    name: "La Grande Rivière Airport",
    city: "La Grande Riviere",
    country: "Canada",
    lat: 53.625301361083984,
    lng: -77.7042007446289,
  },
  {
    id: "YGP",
    name: "Gaspé (Michel-Pouliot) Airport",
    city: "Gaspe",
    country: "Canada",
    lat: 48.7752990723,
    lng: -64.4785995483,
  },
  {
    id: "YGQ",
    name: "Geraldton Greenstone Regional Airport",
    city: "Geraldton",
    country: "Canada",
    lat: 49.77830123901367,
    lng: -86.93939971923828,
  },
  {
    id: "YGR",
    name: "Îles-de-la-Madeleine Airport",
    city: "Iles De La Madeleine",
    country: "Canada",
    lat: 47.42470169067383,
    lng: -61.778099060058594,
  },
  {
    id: "YHB",
    name: "Hudson Bay Airport",
    city: "Hudson Bay",
    country: "Canada",
    lat: 52.8166999817,
    lng: -102.310997009,
  },
  {
    id: "YHD",
    name: "Dryden Regional Airport",
    city: "Dryden",
    country: "Canada",
    lat: 49.831699,
    lng: -92.744202,
  },
  {
    id: "YHI",
    name: "Ulukhaktok Holman Airport",
    city: "Holman Island",
    country: "Canada",
    lat: 70.76280212402344,
    lng: -117.80599975585938,
  },
  {
    id: "YHK",
    name: "Gjoa Haven Airport",
    city: "Gjoa Haven",
    country: "Canada",
    lat: 68.635597229,
    lng: -95.84970092770001,
  },
  {
    id: "YHM",
    name: "John C. Munro Hamilton International Airport",
    city: "Hamilton",
    country: "Canada",
    lat: 43.173599243199995,
    lng: -79.93499755859999,
  },
  {
    id: "YHU",
    name: "Montréal / Saint-Hubert Airport",
    city: "Montreal",
    country: "Canada",
    lat: 45.5175018311,
    lng: -73.4169006348,
  },
  {
    id: "YHY",
    name: "Hay River / Merlyn Carter Airport",
    city: "Hay River",
    country: "Canada",
    lat: 60.8396987915,
    lng: -115.782997131,
  },
  {
    id: "YHZ",
    name: "Halifax / Stanfield International Airport",
    city: "Halifax",
    country: "Canada",
    lat: 44.8807983398,
    lng: -63.5085983276,
  },
  {
    id: "YIB",
    name: "Atikokan Municipal Airport",
    city: "Atikokan",
    country: "Canada",
    lat: 48.7738990784,
    lng: -91.6386032104,
  },
  {
    id: "YIO",
    name: "Pond Inlet Airport",
    city: "Pond Inlet",
    country: "Canada",
    lat: 72.6832962036,
    lng: -77.9666976929,
  },
  {
    id: "YJN",
    name: "St Jean Airport",
    city: "St. Jean",
    country: "Canada",
    lat: 45.29439926147461,
    lng: -73.28109741210938,
  },
  {
    id: "YJT",
    name: "Stephenville Airport",
    city: "Stephenville",
    country: "Canada",
    lat: 48.5442008972168,
    lng: -58.54999923706055,
  },
  {
    id: "YKA",
    name: "Kamloops Airport",
    city: "Kamloops",
    country: "Canada",
    lat: 50.7022018433,
    lng: -120.444000244,
  },
  {
    id: "YKF",
    name: "Waterloo Airport",
    city: "Waterloo",
    country: "Canada",
    lat: 43.460800170899994,
    lng: -80.3786010742,
  },
  {
    id: "YKL",
    name: "Schefferville Airport",
    city: "Schefferville",
    country: "Canada",
    lat: 54.805301666259766,
    lng: -66.8052978515625,
  },
  {
    id: "YKY",
    name: "Kindersley Airport",
    city: "Kindersley",
    country: "Canada",
    lat: 51.5175018311,
    lng: -109.180999756,
  },
  {
    id: "YKZ",
    name: "Buttonville Municipal Airport",
    city: "Toronto",
    country: "Canada",
    lat: 43.86220169067383,
    lng: -79.37000274658203,
  },
  {
    id: "YLD",
    name: "Chapleau Airport",
    city: "Chapleau",
    country: "Canada",
    lat: 47.81999969482422,
    lng: -83.3467025756836,
  },
  {
    id: "YLJ",
    name: "Meadow Lake Airport",
    city: "Meadow Lake",
    country: "Canada",
    lat: 54.125301361083984,
    lng: -108.52300262451172,
  },
  {
    id: "YLL",
    name: "Lloydminster Airport",
    city: "Lloydminster",
    country: "Canada",
    lat: 53.309200286865234,
    lng: -110.072998046875,
  },
  {
    id: "YLT",
    name: "Alert Airport",
    city: "Alert",
    country: "Canada",
    lat: 82.51779937740001,
    lng: -62.2806015015,
  },
  {
    id: "YLW",
    name: "Kelowna International Airport",
    city: "Kelowna",
    country: "Canada",
    lat: 49.9561004639,
    lng: -119.377998352,
  },
  {
    id: "YMA",
    name: "Mayo Airport",
    city: "Mayo",
    country: "Canada",
    lat: 63.61640167236328,
    lng: -135.8679962158203,
  },
  {
    id: "YMJ",
    name: "Moose Jaw Air Vice Marshal C. M. McEwen Airport",
    city: "Moose Jaw",
    country: "Canada",
    lat: 50.330299377441406,
    lng: -105.55899810791016,
  },
  {
    id: "YMM",
    name: "Fort McMurray Airport",
    city: "Fort Mcmurray",
    country: "Canada",
    lat: 56.653301239,
    lng: -111.222000122,
  },
  {
    id: "YMO",
    name: "Moosonee Airport",
    city: "Moosonee",
    country: "Canada",
    lat: 51.291099548339844,
    lng: -80.60780334472656,
  },
  {
    id: "YMW",
    name: "Maniwaki Airport",
    city: "Maniwaki",
    country: "Canada",
    lat: 46.2728004456,
    lng: -75.9906005859,
  },
  {
    id: "YMX",
    name: "Montreal International (Mirabel) Airport",
    city: "Montreal",
    country: "Canada",
    lat: 45.679501,
    lng: -74.038696,
  },
  {
    id: "YNA",
    name: "Natashquan Airport",
    city: "Natashquan",
    country: "Canada",
    lat: 50.189998626708984,
    lng: -61.78919982910156,
  },
  {
    id: "YND",
    name: "Ottawa / Gatineau Airport",
    city: "Gatineau",
    country: "Canada",
    lat: 45.521701812699995,
    lng: -75.5635986328,
  },
  {
    id: "YNM",
    name: "Matagami Airport",
    city: "Matagami",
    country: "Canada",
    lat: 49.76169967651367,
    lng: -77.80280303955078,
  },
  {
    id: "YOC",
    name: "Old Crow Airport",
    city: "Old Crow",
    country: "Canada",
    lat: 67.57060241699219,
    lng: -139.83900451660156,
  },
  {
    id: "YOD",
    name: "CFB Cold Lake",
    city: "Cold Lake",
    country: "Canada",
    lat: 54.404998779296875,
    lng: -110.27899932861328,
  },
  {
    id: "YOJ",
    name: "High Level Airport",
    city: "High Level",
    country: "Canada",
    lat: 58.62139892578125,
    lng: -117.16500091552734,
  },
  {
    id: "YOW",
    name: "Ottawa Macdonald-Cartier International Airport",
    city: "Ottawa",
    country: "Canada",
    lat: 45.3224983215332,
    lng: -75.66919708251953,
  },
  {
    id: "YPA",
    name: "Prince Albert Glass Field",
    city: "Prince Albert",
    country: "Canada",
    lat: 53.214199066199996,
    lng: -105.672996521,
  },
  {
    id: "YPE",
    name: "Peace River Airport",
    city: "Peace River",
    country: "Canada",
    lat: 56.226898,
    lng: -117.446999,
  },
  {
    id: "YPG",
    name: "Southport Airport",
    city: "Portage-la-prairie",
    country: "Canada",
    lat: 49.903099,
    lng: -98.273817,
  },
  {
    id: "N",
    name: "Pitt Meadows Airport",
    city: "Pitt Meadows",
    country: "Canada",
    lat: 49.21609878540039,
    lng: -122.70999908447266,
  },
  {
    id: "YPL",
    name: "Pickle Lake Airport",
    city: "Pickle Lake",
    country: "Canada",
    lat: 51.4463996887207,
    lng: -90.21420288085938,
  },
  {
    id: "YPN",
    name: "Port Menier Airport",
    city: "Port Menier",
    country: "Canada",
    lat: 49.83639907836914,
    lng: -64.2885971069336,
  },
  {
    id: "YPQ",
    name: "Peterborough Airport",
    city: "Peterborough",
    country: "Canada",
    lat: 44.22999954223633,
    lng: -78.36329650878906,
  },
  {
    id: "YPR",
    name: "Prince Rupert Airport",
    city: "Prince Pupert",
    country: "Canada",
    lat: 54.286098480199996,
    lng: -130.445007324,
  },
  {
    id: "YPY",
    name: "Fort Chipewyan Airport",
    city: "Fort Chipewyan",
    country: "Canada",
    lat: 58.7672004699707,
    lng: -111.11699676513672,
  },
  {
    id: "YQA",
    name: "Muskoka Airport",
    city: "Muskoka",
    country: "Canada",
    lat: 44.974700927734375,
    lng: -79.30329895019531,
  },
  {
    id: "YQB",
    name: "Quebec Jean Lesage International Airport",
    city: "Quebec",
    country: "Canada",
    lat: 46.7911,
    lng: -71.393303,
  },
  {
    id: "YQF",
    name: "Red Deer Regional Airport",
    city: "Red Deer Industrial",
    country: "Canada",
    lat: 52.18220138549805,
    lng: -113.89399719238281,
  },
  {
    id: "YQG",
    name: "Windsor Airport",
    city: "Windsor",
    country: "Canada",
    lat: 42.27560043334961,
    lng: -82.95559692382812,
  },
  {
    id: "YQH",
    name: "Watson Lake Airport",
    city: "Watson Lake",
    country: "Canada",
    lat: 60.11640167236328,
    lng: -128.82200622558594,
  },
  {
    id: "YQK",
    name: "Kenora Airport",
    city: "Kenora",
    country: "Canada",
    lat: 49.788299560546875,
    lng: -94.36309814453125,
  },
  {
    id: "YQL",
    name: "Lethbridge County Airport",
    city: "Lethbridge",
    country: "Canada",
    lat: 49.6302986145,
    lng: -112.800003052,
  },
  {
    id: "YQM",
    name: "Greater Moncton International Airport",
    city: "Moncton",
    country: "Canada",
    lat: 46.11220169067383,
    lng: -64.67859649658203,
  },
  {
    id: "YQQ",
    name: "Comox Airport",
    city: "Comox",
    country: "Canada",
    lat: 49.71080017089844,
    lng: -124.88700103759766,
  },
  {
    id: "YQR",
    name: "Regina International Airport",
    city: "Regina",
    country: "Canada",
    lat: 50.43190002441406,
    lng: -104.66600036621094,
  },
  {
    id: "YQT",
    name: "Thunder Bay Airport",
    city: "Thunder Bay",
    country: "Canada",
    lat: 48.37189865112305,
    lng: -89.32389831542969,
  },
  {
    id: "YQU",
    name: "Grande Prairie Airport",
    city: "Grande Prairie",
    country: "Canada",
    lat: 55.1796989441,
    lng: -118.885002136,
  },
  {
    id: "YQV",
    name: "Yorkton Municipal Airport",
    city: "Yorkton",
    country: "Canada",
    lat: 51.26470184326172,
    lng: -102.46199798583984,
  },
  {
    id: "YQW",
    name: "North Battleford Airport",
    city: "North Battleford",
    country: "Canada",
    lat: 52.76919937133789,
    lng: -108.24400329589844,
  },
  {
    id: "YQX",
    name: "Gander International Airport",
    city: "Gander",
    country: "Canada",
    lat: 48.9369010925293,
    lng: -54.56809997558594,
  },
  {
    id: "YQY",
    name: "Sydney / J.A. Douglas McCurdy Airport",
    city: "Sydney",
    country: "Canada",
    lat: 46.1614,
    lng: -60.047798,
  },
  {
    id: "YQZ",
    name: "Quesnel Airport",
    city: "Quesnel",
    country: "Canada",
    lat: 53.026100158691406,
    lng: -122.51000213623047,
  },
  {
    id: "YRB",
    name: "Resolute Bay Airport",
    city: "Resolute",
    country: "Canada",
    lat: 74.7169036865,
    lng: -94.9693984985,
  },
  {
    id: "YRI",
    name: "Rivière-du-Loup Airport",
    city: "Riviere Du Loup",
    country: "Canada",
    lat: 47.764400482177734,
    lng: -69.58470153808594,
  },
  {
    id: "YRJ",
    name: "Roberval Airport",
    city: "Roberval",
    country: "Canada",
    lat: 48.52000045776367,
    lng: -72.2656021118164,
  },
  {
    id: "YRM",
    name: "Rocky Mountain House Airport",
    city: "Rocky Mountain House",
    country: "Canada",
    lat: 52.4296989441,
    lng: -114.903999329,
  },
  {
    id: "YRT",
    name: "Rankin Inlet Airport",
    city: "Rankin Inlet",
    country: "Canada",
    lat: 62.8114013672,
    lng: -92.1157989502,
  },
  {
    id: "YSB",
    name: "Sudbury Airport",
    city: "Sudbury",
    country: "Canada",
    lat: 46.625,
    lng: -80.79889678955078,
  },
  {
    id: "YSC",
    name: "Sherbrooke Airport",
    city: "Sherbrooke",
    country: "Canada",
    lat: 45.4385986328125,
    lng: -71.69139862060547,
  },
  {
    id: "YSJ",
    name: "Saint John Airport",
    city: "St. John",
    country: "Canada",
    lat: 45.31610107421875,
    lng: -65.89029693603516,
  },
  {
    id: "YSM",
    name: "Fort Smith Airport",
    city: "Fort Smith",
    country: "Canada",
    lat: 60.020301818847656,
    lng: -111.96199798583984,
  },
  {
    id: "YSR",
    name: "Nanisivik Airport",
    city: "Nanisivik",
    country: "Canada",
    lat: 72.982201,
    lng: -84.613602,
  },
  {
    id: "YSU",
    name: "Summerside Airport",
    city: "Summerside",
    country: "Canada",
    lat: 46.44060134887695,
    lng: -63.83359909057617,
  },
  {
    id: "YSY",
    name: "Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport",
    city: "Sachs Harbour",
    country: "Canada",
    lat: 71.9938964844,
    lng: -125.242996216,
  },
  {
    id: "YTE",
    name: "Cape Dorset Airport",
    city: "Cape Dorset",
    country: "Canada",
    lat: 64.2300033569,
    lng: -76.5267028809,
  },
  {
    id: "YTH",
    name: "Thompson Airport",
    city: "Thompson",
    country: "Canada",
    lat: 55.80110168457031,
    lng: -97.86419677734375,
  },
  {
    id: "YTR",
    name: "CFB Trenton",
    city: "Trenton",
    country: "Canada",
    lat: 44.118900299072266,
    lng: -77.5280990600586,
  },
  {
    id: "YTS",
    name: "Timmins/Victor M. Power",
    city: "Timmins",
    country: "Canada",
    lat: 48.569698333699996,
    lng: -81.376701355,
  },
  {
    id: "YTZ",
    name: "Billy Bishop Toronto City Centre Airport",
    city: "Toronto",
    country: "Canada",
    lat: 43.627499,
    lng: -79.396202,
  },
  {
    id: "YUB",
    name: "Tuktoyaktuk Airport",
    city: "Tuktoyaktuk",
    country: "Canada",
    lat: 69.43329620361328,
    lng: -133.0260009765625,
  },
  {
    id: "YUL",
    name: "Montreal / Pierre Elliott Trudeau International Airport",
    city: "Montreal",
    country: "Canada",
    lat: 45.4706001282,
    lng: -73.7407989502,
  },
  {
    id: "YUT",
    name: "Repulse Bay Airport",
    city: "Repulse Bay",
    country: "Canada",
    lat: 66.5214004517,
    lng: -86.22470092770001,
  },
  {
    id: "YUX",
    name: "Hall Beach Airport",
    city: "Hall Beach",
    country: "Canada",
    lat: 68.77610015869999,
    lng: -81.2425,
  },
  {
    id: "YUY",
    name: "Rouyn Noranda Airport",
    city: "Rouyn",
    country: "Canada",
    lat: 48.20610046386719,
    lng: -78.83560180664062,
  },
  {
    id: "YVC",
    name: "La Ronge Airport",
    city: "La Ronge",
    country: "Canada",
    lat: 55.151401519800004,
    lng: -105.262001038,
  },
  {
    id: "YVG",
    name: "Vermilion Airport",
    city: "Vermillion",
    country: "Canada",
    lat: 53.355800628699996,
    lng: -110.823997498,
  },
  {
    id: "YVM",
    name: "Qikiqtarjuaq Airport",
    city: "Broughton Island",
    country: "Canada",
    lat: 67.5457992554,
    lng: -64.03140258789999,
  },
  {
    id: "YVO",
    name: "Val-d'Or Airport",
    city: "Val D'or",
    country: "Canada",
    lat: 48.0532989502,
    lng: -77.7827987671,
  },
  {
    id: "YVP",
    name: "Kuujjuaq Airport",
    city: "Quujjuaq",
    country: "Canada",
    lat: 58.096099853515625,
    lng: -68.4269027709961,
  },
  {
    id: "YVQ",
    name: "Norman Wells Airport",
    city: "Norman Wells",
    country: "Canada",
    lat: 65.28160095214844,
    lng: -126.7979965209961,
  },
  {
    id: "YVR",
    name: "Vancouver International Airport",
    city: "Vancouver",
    country: "Canada",
    lat: 49.193901062,
    lng: -123.183998108,
  },
  {
    id: "YVT",
    name: "Buffalo Narrows Airport",
    city: "Buffalo Narrows",
    country: "Canada",
    lat: 55.8418998718,
    lng: -108.417999268,
  },
  {
    id: "YVV",
    name: "Wiarton Airport",
    city: "Wiarton",
    country: "Canada",
    lat: 44.7458,
    lng: -81.107201,
  },
  {
    id: "YWA",
    name: "Petawawa Airport",
    city: "Petawawa",
    country: "Canada",
    lat: 45.95220184326172,
    lng: -77.31919860839844,
  },
  {
    id: "YWG",
    name: "Winnipeg / James Armstrong Richardson International Airport",
    city: "Winnipeg",
    country: "Canada",
    lat: 49.909999847399995,
    lng: -97.2398986816,
  },
  {
    id: "YWK",
    name: "Wabush Airport",
    city: "Wabush",
    country: "Canada",
    lat: 52.92190170288086,
    lng: -66.8644027709961,
  },
  {
    id: "YWL",
    name: "Williams Lake Airport",
    city: "Williams Lake",
    country: "Canada",
    lat: 52.1831016541,
    lng: -122.054000854,
  },
  {
    id: "YWY",
    name: "Wrigley Airport",
    city: "Wrigley",
    country: "Canada",
    lat: 63.20940017700195,
    lng: -123.43699645996094,
  },
  {
    id: "YXC",
    name: "Cranbrook/Canadian Rockies International Airport",
    city: "Cranbrook",
    country: "Canada",
    lat: 49.610801696777,
    lng: -115.78199768066,
  },
  {
    id: "YXD",
    name: "Edmonton City Centre (Blatchford Field) Airport",
    city: "Edmonton",
    country: "Canada",
    lat: 53.5724983215,
    lng: -113.521003723,
  },
  {
    id: "YXE",
    name: "Saskatoon John G. Diefenbaker International Airport",
    city: "Saskatoon",
    country: "Canada",
    lat: 52.170799255371094,
    lng: -106.69999694824219,
  },
  {
    id: "YXH",
    name: "Medicine Hat Airport",
    city: "Medicine Hat",
    country: "Canada",
    lat: 50.01890182495117,
    lng: -110.72100067138672,
  },
  {
    id: "YXJ",
    name: "Fort St John Airport",
    city: "Fort Saint John",
    country: "Canada",
    lat: 56.23809814453125,
    lng: -120.73999786376953,
  },
  {
    id: "YXL",
    name: "Sioux Lookout Airport",
    city: "Sioux Lookout",
    country: "Canada",
    lat: 50.11389923095703,
    lng: -91.9052963256836,
  },
  {
    id: "YXP",
    name: "Pangnirtung Airport",
    city: "Pangnirtung",
    country: "Canada",
    lat: 66.1449966431,
    lng: -65.71360015869999,
  },
  {
    id: "YXR",
    name: "Earlton (Timiskaming Regional) Airport",
    city: "Earlton",
    country: "Canada",
    lat: 47.697400654599996,
    lng: -79.8473453522,
  },
  {
    id: "YXS",
    name: "Prince George Airport",
    city: "Prince George",
    country: "Canada",
    lat: 53.8894004822,
    lng: -122.679000854,
  },
  {
    id: "YXT",
    name: "Northwest Regional Airport Terrace-Kitimat",
    city: "Terrace",
    country: "Canada",
    lat: 54.468498,
    lng: -128.576009,
  },
  {
    id: "YXU",
    name: "London Airport",
    city: "London",
    country: "Canada",
    lat: 43.035599,
    lng: -81.1539,
  },
  {
    id: "YXX",
    name: "Abbotsford Airport",
    city: "Abbotsford",
    country: "Canada",
    lat: 49.025299072265625,
    lng: -122.36100006103516,
  },
  {
    id: "YXY",
    name: "Whitehorse / Erik Nielsen International Airport",
    city: "Whitehorse",
    country: "Canada",
    lat: 60.7095985413,
    lng: -135.067001343,
  },
  {
    id: "YYB",
    name: "North Bay Jack Garland Airport",
    city: "North Bay",
    country: "Canada",
    lat: 46.363602,
    lng: -79.422798,
  },
  {
    id: "YYC",
    name: "Calgary International Airport",
    city: "Calgary",
    country: "Canada",
    lat: 51.113899231,
    lng: -114.019996643,
  },
  {
    id: "YYD",
    name: "Smithers Airport",
    city: "Smithers",
    country: "Canada",
    lat: 54.82469940185547,
    lng: -127.18299865722656,
  },
  {
    id: "YYE",
    name: "Fort Nelson Airport",
    city: "Fort Nelson",
    country: "Canada",
    lat: 58.8363990784,
    lng: -122.597000122,
  },
  {
    id: "YYF",
    name: "Penticton Airport",
    city: "Penticton",
    country: "Canada",
    lat: 49.46310043334961,
    lng: -119.60199737548828,
  },
  {
    id: "YYG",
    name: "Charlottetown Airport",
    city: "Charlottetown",
    country: "Canada",
    lat: 46.290000915527344,
    lng: -63.12110137939453,
  },
  {
    id: "YYH",
    name: "Taloyoak Airport",
    city: "Spence Bay",
    country: "Canada",
    lat: 69.5466995239,
    lng: -93.5766983032,
  },
  {
    id: "YYJ",
    name: "Victoria International Airport",
    city: "Victoria",
    country: "Canada",
    lat: 48.646900177,
    lng: -123.426002502,
  },
  {
    id: "YYL",
    name: "Lynn Lake Airport",
    city: "Lynn Lake",
    country: "Canada",
    lat: 56.86389923095703,
    lng: -101.07599639892578,
  },
  {
    id: "YYN",
    name: "Swift Current Airport",
    city: "Swift Current",
    country: "Canada",
    lat: 50.291900634799994,
    lng: -107.691001892,
  },
  {
    id: "YYQ",
    name: "Churchill Airport",
    city: "Churchill",
    country: "Canada",
    lat: 58.739200592041016,
    lng: -94.06500244140625,
  },
  {
    id: "YYR",
    name: "Goose Bay Airport",
    city: "Goose Bay",
    country: "Canada",
    lat: 53.3191986084,
    lng: -60.4258003235,
  },
  {
    id: "YYT",
    name: "St. John's International Airport",
    city: "St. John's",
    country: "Canada",
    lat: 47.618598938,
    lng: -52.7518997192,
  },
  {
    id: "YYU",
    name: "Kapuskasing Airport",
    city: "Kapuskasing",
    country: "Canada",
    lat: 49.41389846801758,
    lng: -82.46749877929688,
  },
  {
    id: "YYW",
    name: "Armstrong Airport",
    city: "Armstrong",
    country: "Canada",
    lat: 50.29029846191406,
    lng: -88.90969848632812,
  },
  {
    id: "YYY",
    name: "Mont Joli Airport",
    city: "Mont Joli",
    country: "Canada",
    lat: 48.60860061645508,
    lng: -68.20809936523438,
  },
  {
    id: "YYZ",
    name: "Lester B. Pearson International Airport",
    city: "Toronto",
    country: "Canada",
    lat: 43.6772003174,
    lng: -79.63059997559999,
  },
  {
    id: "YZD",
    name: "Downsview Airport",
    city: "Toronto",
    country: "Canada",
    lat: 43.74250030517578,
    lng: -79.4655990600586,
  },
  {
    id: "YZE",
    name: "Gore Bay Manitoulin Airport",
    city: "Gore Bay",
    country: "Canada",
    lat: 45.88529968261719,
    lng: -82.56780242919922,
  },
  {
    id: "YZF",
    name: "Yellowknife Airport",
    city: "Yellowknife",
    country: "Canada",
    lat: 62.462799072265625,
    lng: -114.44000244140625,
  },
  {
    id: "YZH",
    name: "Slave Lake Airport",
    city: "Slave Lake",
    country: "Canada",
    lat: 55.2930984497,
    lng: -114.777000427,
  },
  {
    id: "YZP",
    name: "Sandspit Airport",
    city: "Sandspit",
    country: "Canada",
    lat: 53.25429916379999,
    lng: -131.813995361,
  },
  {
    id: "YZR",
    name: "Chris Hadfield Airport",
    city: "Sarnia",
    country: "Canada",
    lat: 42.9994010925293,
    lng: -82.30889892578125,
  },
  {
    id: "YZT",
    name: "Port Hardy Airport",
    city: "Port Hardy",
    country: "Canada",
    lat: 50.680599212646484,
    lng: -127.36699676513672,
  },
  {
    id: "YZU",
    name: "Whitecourt Airport",
    city: "Whitecourt",
    country: "Canada",
    lat: 54.14390182495117,
    lng: -115.78700256347656,
  },
  {
    id: "YZV",
    name: "Sept-Îles Airport",
    city: "Sept-iles",
    country: "Canada",
    lat: 50.22330093383789,
    lng: -66.2656021118164,
  },
  {
    id: "YZW",
    name: "Teslin Airport",
    city: "Teslin",
    country: "Canada",
    lat: 60.17279815673828,
    lng: -132.7429962158203,
  },
  {
    id: "YZX",
    name: "CFB Greenwood",
    city: "Greenwood",
    country: "Canada",
    lat: 44.98440170288086,
    lng: -64.91690063476562,
  },
  {
    id: "ZFA",
    name: "Faro Airport",
    city: "Faro",
    country: "Canada",
    lat: 62.20750045776367,
    lng: -133.37600708007812,
  },
  {
    id: "ZFM",
    name: "Fort Mcpherson Airport",
    city: "Fort Mcpherson",
    country: "Canada",
    lat: 67.40750122070312,
    lng: -134.86099243164062,
  },
  {
    id: "QLD",
    name: "Blida Airport",
    city: "Blida",
    country: "Algeria",
    lat: 36.50360107421875,
    lng: 2.8141698837280273,
  },
  {
    id: "BUJ",
    name: "Bou Saada Airport",
    city: "Bou Saada",
    country: "Algeria",
    lat: 35.33250045776367,
    lng: 4.206389904022217,
  },
  {
    id: "BJA",
    name: "Soummam Airport",
    city: "Bejaja",
    country: "Algeria",
    lat: 36.7120018005,
    lng: 5.0699200630200005,
  },
  {
    id: "ALG",
    name: "Houari Boumediene Airport",
    city: "Algier",
    country: "Algeria",
    lat: 36.691001892089844,
    lng: 3.215409994125366,
  },
  {
    id: "DJG",
    name: "Djanet Inedbirene Airport",
    city: "Djanet",
    country: "Algeria",
    lat: 24.292801,
    lng: 9.45244,
  },
  {
    id: "N",
    name: "Boufarik Airport",
    city: "Boufarik",
    country: "Algeria",
    lat: 36.545799,
    lng: 2.87611,
  },
  {
    id: "N",
    name: "Reggane Airport",
    city: "Reggan",
    country: "Algeria",
    lat: 26.7101,
    lng: 0.285647,
  },
  {
    id: "VVZ",
    name: "Illizi Takhamalt Airport",
    city: "Illizi",
    country: "Algeria",
    lat: 26.7234992981,
    lng: 8.62265014648,
  },
  {
    id: "N",
    name: "Ain Oussera Airport",
    city: "Ain Oussera",
    country: "Algeria",
    lat: 35.52539825439453,
    lng: 2.8787100315093994,
  },
  {
    id: "TMR",
    name: "Aguenar – Hadj Bey Akhamok Airport",
    city: "Tamanrasset",
    country: "Algeria",
    lat: 22.8115005493,
    lng: 5.45107984543,
  },
  {
    id: "GJL",
    name: "Jijel Ferhat Abbas Airport",
    city: "Jijel",
    country: "Algeria",
    lat: 36.7951011658,
    lng: 5.87361001968,
  },
  {
    id: "MZW",
    name: "Mecheria Airport",
    city: "Mecheria",
    country: "Algeria",
    lat: 33.535900116,
    lng: -0.242353007197,
  },
  {
    id: "N",
    name: "Relizane Airport",
    city: "Relizane",
    country: "Algeria",
    lat: 35.752201,
    lng: 0.626272,
  },
  {
    id: "AAE",
    name: "Rabah Bitat Airport",
    city: "Annaba",
    country: "Algeria",
    lat: 36.822201,
    lng: 7.809174,
  },
  {
    id: "CZL",
    name: "Mohamed Boudiaf International Airport",
    city: "Constantine",
    country: "Algeria",
    lat: 36.2760009765625,
    lng: 6.620389938354492,
  },
  {
    id: "TEE",
    name: "Cheikh Larbi Tébessi Airport",
    city: "Tebessa",
    country: "Algeria",
    lat: 35.4315986633,
    lng: 8.12071990967,
  },
  {
    id: "HRM",
    name: "Hassi R'Mel Airport",
    city: "Tilrempt",
    country: "Algeria",
    lat: 32.93040084838867,
    lng: 3.311539888381958,
  },
  {
    id: "TID",
    name: "Bou Chekif Airport",
    city: "Tiaret",
    country: "Algeria",
    lat: 35.3410987854,
    lng: 1.46315002441,
  },
  {
    id: "N",
    name: "Bou Sfer Airport",
    city: "Bou Sfer",
    country: "Algeria",
    lat: 35.73540115356445,
    lng: -0.8053889870643616,
  },
  {
    id: "TIN",
    name: "Tindouf Airport",
    city: "Tindouf",
    country: "Algeria",
    lat: 27.7003993988,
    lng: -8.167099952700001,
  },
  {
    id: "CFK",
    name: "Ech Cheliff Airport",
    city: "Ech-cheliff",
    country: "Algeria",
    lat: 36.2126998901,
    lng: 1.33176994324,
  },
  {
    id: "TAF",
    name: "Tafaraoui Airport",
    city: "Oran",
    country: "Algeria",
    lat: 35.54240036010742,
    lng: -0.5322780013084412,
  },
  {
    id: "TLM",
    name: "Zenata – Messali El Hadj Airport",
    city: "Tlemcen",
    country: "Algeria",
    lat: 35.0167007446,
    lng: -1.45000004768,
  },
  {
    id: "ORN",
    name: "Es Senia Airport",
    city: "Oran",
    country: "Algeria",
    lat: 35.6239013672,
    lng: -0.6211829781529999,
  },
  {
    id: "BFW",
    name: "Sidi Bel Abbes Airport",
    city: "Sidi Bel Abbes",
    country: "Algeria",
    lat: 35.1717987061,
    lng: -0.593275010586,
  },
  {
    id: "MUW",
    name: "Ghriss Airport",
    city: "Ghriss",
    country: "Algeria",
    lat: 35.207698822021484,
    lng: 0.14714199304580688,
  },
  {
    id: "AZR",
    name: "Touat Cheikh Sidi Mohamed Belkebir Airport",
    city: "Adrar",
    country: "Algeria",
    lat: 27.837600708007812,
    lng: -0.18641400337219238,
  },
  {
    id: "BSK",
    name: "Biskra Airport",
    city: "Biskra",
    country: "Algeria",
    lat: 34.793300628699996,
    lng: 5.73823022842,
  },
  {
    id: "ELG",
    name: "El Golea Airport",
    city: "El Golea",
    country: "Algeria",
    lat: 30.571300506591797,
    lng: 2.8595900535583496,
  },
  {
    id: "GHA",
    name: "Noumérat - Moufdi Zakaria Airport",
    city: "Ghardaia",
    country: "Algeria",
    lat: 32.38410186767578,
    lng: 3.794110059738159,
  },
  {
    id: "HME",
    name: "Oued Irara Airport",
    city: "Hassi Messaoud",
    country: "Algeria",
    lat: 31.673000335699996,
    lng: 6.140439987180001,
  },
  {
    id: "INZ",
    name: "In Salah Airport",
    city: "In Salah",
    country: "Algeria",
    lat: 27.250999450699997,
    lng: 2.51202011108,
  },
  {
    id: "TGR",
    name: "Touggourt Sidi Madhi Airport",
    city: "Touggourt",
    country: "Algeria",
    lat: 33.06779861450195,
    lng: 6.088669776916504,
  },
  {
    id: "LOO",
    name: "Laghouat Airport",
    city: "Laghouat",
    country: "Algeria",
    lat: 33.764400482199996,
    lng: 2.92833995819,
  },
  {
    id: "TMX",
    name: "Timimoun Airport",
    city: "Timimoun",
    country: "Algeria",
    lat: 29.2371006012,
    lng: 0.276033014059,
  },
  {
    id: "OGX",
    name: "Ain el Beida Airport",
    city: "Ouargla",
    country: "Algeria",
    lat: 31.917200088500977,
    lng: 5.412779808044434,
  },
  {
    id: "IAM",
    name: "In Aménas Airport",
    city: "Zarzaitine",
    country: "Algeria",
    lat: 28.0515,
    lng: 9.64291,
  },
  {
    id: "COO",
    name: "Cadjehoun Airport",
    city: "Cotonou",
    country: "Benin",
    lat: 6.357230186462402,
    lng: 2.384350061416626,
  },
  {
    id: "OUA",
    name: "Ouagadougou Airport",
    city: "Ouagadougou",
    country: "Burkina Faso",
    lat: 12.3532,
    lng: -1.51242,
  },
  {
    id: "BOY",
    name: "Bobo Dioulasso Airport",
    city: "Bobo-dioulasso",
    country: "Burkina Faso",
    lat: 11.160099983215332,
    lng: -4.33096981048584,
  },
  {
    id: "ACC",
    name: "Kotoka International Airport",
    city: "Accra",
    country: "Ghana",
    lat: 5.605189800262451,
    lng: -0.16678600013256073,
  },
  {
    id: "TML",
    name: "Tamale Airport",
    city: "Tamale",
    country: "Ghana",
    lat: 9.55718994140625,
    lng: -0.8632140159606934,
  },
  {
    id: "N",
    name: "Wa Airport",
    city: "Wa",
    country: "Ghana",
    lat: 10.0826997756958,
    lng: -2.507689952850342,
  },
  {
    id: "NYI",
    name: "Sunyani Airport",
    city: "Sunyani",
    country: "Ghana",
    lat: 7.361830234527588,
    lng: -2.3287599086761475,
  },
  {
    id: "TKD",
    name: "Takoradi Airport",
    city: "Takoradi",
    country: "Ghana",
    lat: 4.896059989929199,
    lng: -1.7747600078582764,
  },
  {
    id: "ABJ",
    name: "Port Bouet Airport",
    city: "Abidjan",
    country: "Cote d'Ivoire",
    lat: 5.261390209197998,
    lng: -3.9262900352478027,
  },
  {
    id: "BYK",
    name: "Bouaké Airport",
    city: "Bouake",
    country: "Cote d'Ivoire",
    lat: 7.738800048828125,
    lng: -5.073669910430908,
  },
  {
    id: "DJO",
    name: "Daloa Airport",
    city: "Daloa",
    country: "Cote d'Ivoire",
    lat: 6.792809963226318,
    lng: -6.473189830780029,
  },
  {
    id: "HGO",
    name: "Korhogo Airport",
    city: "Korhogo",
    country: "Cote d'Ivoire",
    lat: 9.38718032837,
    lng: -5.55666017532,
  },
  {
    id: "MJC",
    name: "Man Airport",
    city: "Man",
    country: "Cote d'Ivoire",
    lat: 7.272069931030273,
    lng: -7.58735990524292,
  },
  {
    id: "SPY",
    name: "San Pedro Airport",
    city: "San Pedro",
    country: "Cote d'Ivoire",
    lat: 4.746719837188721,
    lng: -6.660820007324219,
  },
  {
    id: "ASK",
    name: "Yamoussoukro Airport",
    city: "Yamoussoukro",
    country: "Cote d'Ivoire",
    lat: 6.9031701088,
    lng: -5.36558008194,
  },
  {
    id: "ABV",
    name: "Nnamdi Azikiwe International Airport",
    city: "Abuja",
    country: "Nigeria",
    lat: 9.006790161132812,
    lng: 7.263169765472412,
  },
  {
    id: "AKR",
    name: "Akure Airport",
    city: "Akure",
    country: "Nigeria",
    lat: 7.246739864349365,
    lng: 5.3010101318359375,
  },
  {
    id: "BNI",
    name: "Benin Airport",
    city: "Benin",
    country: "Nigeria",
    lat: 6.316979885101318,
    lng: 5.5995001792907715,
  },
  {
    id: "CBQ",
    name: "Margaret Ekpo International Airport",
    city: "Calabar",
    country: "Nigeria",
    lat: 4.976019859313965,
    lng: 8.347200393676758,
  },
  {
    id: "ENU",
    name: "Akanu Ibiam International Airport",
    city: "Enugu",
    country: "Nigeria",
    lat: 6.474269866943359,
    lng: 7.561960220336914,
  },
  {
    id: "N",
    name: "Gusau Airport",
    city: "Gusau",
    country: "Nigeria",
    lat: 12.1717,
    lng: 6.69611,
  },
  {
    id: "IBA",
    name: "Ibadan Airport",
    city: "Ibadan",
    country: "Nigeria",
    lat: 7.362460136413574,
    lng: 3.97832989692688,
  },
  {
    id: "ILR",
    name: "Ilorin International Airport",
    city: "Ilorin",
    country: "Nigeria",
    lat: 8.440210342407227,
    lng: 4.493919849395752,
  },
  {
    id: "JOS",
    name: "Yakubu Gowon Airport",
    city: "Jos",
    country: "Nigeria",
    lat: 9.639829635620117,
    lng: 8.869050025939941,
  },
  {
    id: "KAD",
    name: "Kaduna Airport",
    city: "Kaduna",
    country: "Nigeria",
    lat: 10.696000099182129,
    lng: 7.320109844207764,
  },
  {
    id: "KAN",
    name: "Mallam Aminu International Airport",
    city: "Kano",
    country: "Nigeria",
    lat: 12.0476,
    lng: 8.52462,
  },
  {
    id: "MIU",
    name: "Maiduguri International Airport",
    city: "Maiduguri",
    country: "Nigeria",
    lat: 11.855299949645996,
    lng: 13.080900192260742,
  },
  {
    id: "MDI",
    name: "Makurdi Airport",
    city: "Makurdi",
    country: "Nigeria",
    lat: 7.70388,
    lng: 8.61394,
  },
  {
    id: "LOS",
    name: "Murtala Muhammed International Airport",
    city: "Lagos",
    country: "Nigeria",
    lat: 6.5773701667785645,
    lng: 3.321160078048706,
  },
  {
    id: "MXJ",
    name: "Minna Airport",
    city: "Minna",
    country: "Nigeria",
    lat: 9.652170181274414,
    lng: 6.462259769439697,
  },
  {
    id: "PHC",
    name: "Port Harcourt International Airport",
    city: "Port Hartcourt",
    country: "Nigeria",
    lat: 5.0154900550842285,
    lng: 6.94959020614624,
  },
  {
    id: "SKO",
    name: "Sadiq Abubakar III International Airport",
    city: "Sokoto",
    country: "Nigeria",
    lat: 12.916299819946289,
    lng: 5.207190036773682,
  },
  {
    id: "YOL",
    name: "Yola Airport",
    city: "Yola",
    country: "Nigeria",
    lat: 9.257550239562988,
    lng: 12.430399894714355,
  },
  {
    id: "ZAR",
    name: "Zaria Airport",
    city: "Zaria",
    country: "Nigeria",
    lat: 11.1302,
    lng: 7.68581,
  },
  {
    id: "MFQ",
    name: "Maradi Airport",
    city: "Maradi",
    country: "Niger",
    lat: 13.5024995803833,
    lng: 7.1267499923706055,
  },
  {
    id: "NIM",
    name: "Diori Hamani International Airport",
    city: "Niamey",
    country: "Niger",
    lat: 13.4815,
    lng: 2.18361,
  },
  {
    id: "THZ",
    name: "Tahoua Airport",
    city: "Tahoua",
    country: "Niger",
    lat: 14.875699996948242,
    lng: 5.265359878540039,
  },
  {
    id: "AJY",
    name: "Mano Dayak International Airport",
    city: "Agadez",
    country: "Niger",
    lat: 16.965999603271484,
    lng: 8.000109672546387,
  },
  {
    id: "N",
    name: "Dirkou Airport",
    city: "Dirkou",
    country: "Niger",
    lat: 18.968700408935547,
    lng: 12.86870002746582,
  },
  {
    id: "N",
    name: "Diffa Airport",
    city: "Diffa",
    country: "Niger",
    lat: 13.372900009155273,
    lng: 12.626700401306152,
  },
  {
    id: "ZND",
    name: "Zinder Airport",
    city: "Zinder",
    country: "Niger",
    lat: 13.779000282287598,
    lng: 8.983759880065918,
  },
  {
    id: "MIR",
    name: "Monastir Habib Bourguiba International Airport",
    city: "Monastir",
    country: "Tunisia",
    lat: 35.75809860229492,
    lng: 10.75469970703125,
  },
  {
    id: "TUN",
    name: "Tunis Carthage International Airport",
    city: "Tunis",
    country: "Tunisia",
    lat: 36.85100173950195,
    lng: 10.22719955444336,
  },
  {
    id: "N",
    name: "Sidi Ahmed Air Base",
    city: "Bizerte",
    country: "Tunisia",
    lat: 37.245398,
    lng: 9.79145,
  },
  {
    id: "N",
    name: "Remada Air Base",
    city: "Remada",
    country: "Tunisia",
    lat: 32.30619812011719,
    lng: 10.382100105285645,
  },
  {
    id: "GAF",
    name: "Gafsa Ksar International Airport",
    city: "Gafsa",
    country: "Tunisia",
    lat: 34.422000885009766,
    lng: 8.822500228881836,
  },
  {
    id: "GAE",
    name: "Gabès Matmata International Airport",
    city: "Gabes",
    country: "Tunisia",
    lat: 33.87689971923828,
    lng: 10.103300094604492,
  },
  {
    id: "N",
    name: "Borj El Amri Airport",
    city: "Bordj El Amri",
    country: "Tunisia",
    lat: 36.72129821777344,
    lng: 9.94314956665039,
  },
  {
    id: "DJE",
    name: "Djerba Zarzis International Airport",
    city: "Djerba",
    country: "Tunisia",
    lat: 33.875,
    lng: 10.775500297546387,
  },
  {
    id: "EBM",
    name: "El Borma Airport",
    city: "El Borma",
    country: "Tunisia",
    lat: 31.704299926757812,
    lng: 9.254619598388672,
  },
  {
    id: "SFA",
    name: "Sfax Thyna International Airport",
    city: "Sfax",
    country: "Tunisia",
    lat: 34.71799850463867,
    lng: 10.690999984741211,
  },
  {
    id: "TOE",
    name: "Tozeur Nefta International Airport",
    city: "Tozeur",
    country: "Tunisia",
    lat: 33.939701080322266,
    lng: 8.110560417175293,
  },
  {
    id: "LRL",
    name: "Niamtougou International Airport",
    city: "Niatougou",
    country: "Togo",
    lat: 9.767330169677734,
    lng: 1.091249942779541,
  },
  {
    id: "LFW",
    name: "Lomé-Tokoin Airport",
    city: "Lome",
    country: "Togo",
    lat: 6.165609836578369,
    lng: 1.2545100450515747,
  },
  {
    id: "ANR",
    name: "Antwerp International Airport (Deurne)",
    city: "Antwerp",
    country: "Belgium",
    lat: 51.1893997192,
    lng: 4.46027994156,
  },
  {
    id: "N",
    name: "Beauvechain Air Base",
    city: "Beauvechain",
    country: "Belgium",
    lat: 50.75859832763672,
    lng: 4.768330097198486,
  },
  {
    id: "N",
    name: "Kleine Brogel Air Base",
    city: "Kleine Brogel",
    country: "Belgium",
    lat: 51.168301,
    lng: 5.47,
  },
  {
    id: "BRU",
    name: "Brussels Airport",
    city: "Brussels",
    country: "Belgium",
    lat: 50.901401519800004,
    lng: 4.48443984985,
  },
  {
    id: "N",
    name: "Jehonville Air Base",
    city: "Bertrix",
    country: "Belgium",
    lat: 49.891700744628906,
    lng: 5.2238898277282715,
  },
  {
    id: "CRL",
    name: "Brussels South Charleroi Airport",
    city: "Charleroi",
    country: "Belgium",
    lat: 50.459202,
    lng: 4.45382,
  },
  {
    id: "N",
    name: "Chièvres Air Base",
    city: "Chievres",
    country: "Belgium",
    lat: 50.575801849365234,
    lng: 3.8310000896453857,
  },
  {
    id: "N",
    name: "Koksijde Air Base",
    city: "Koksijde",
    country: "Belgium",
    lat: 51.090301513671875,
    lng: 2.652780055999756,
  },
  {
    id: "N",
    name: "Florennes Air Base",
    city: "Florennes",
    country: "Belgium",
    lat: 50.2433013916,
    lng: 4.64583015442,
  },
  {
    id: "KJK",
    name: "Wevelgem Airport",
    city: "Kortrijk-vevelgem",
    country: "Belgium",
    lat: 50.817199707,
    lng: 3.20472002029,
  },
  {
    id: "LGG",
    name: "Liège Airport",
    city: "Liege",
    country: "Belgium",
    lat: 50.63740158081055,
    lng: 5.443220138549805,
  },
  {
    id: "OST",
    name: "Ostend-Bruges International Airport",
    city: "Ostend",
    country: "Belgium",
    lat: 51.198898315399994,
    lng: 2.8622200489,
  },
  {
    id: "N",
    name: "Zutendaal Air Base",
    city: "Zutendaal",
    country: "Belgium",
    lat: 50.9474983215332,
    lng: 5.590559959411621,
  },
  {
    id: "N",
    name: "Brustem Airfield Sint Truiden",
    city: "Sint-truiden",
    country: "Belgium",
    lat: 50.791901,
    lng: 5.20167,
  },
  {
    id: "N",
    name: "Saint Hubert Air Base",
    city: "St.-hubert",
    country: "Belgium",
    lat: 50.034400939941406,
    lng: 5.440810203552246,
  },
  {
    id: "N",
    name: "Ursel Air Base",
    city: "Ursel",
    country: "Belgium",
    lat: 51.14419937133789,
    lng: 3.475559949874878,
  },
  {
    id: "N",
    name: "Weelde Air Base",
    city: "Weelde",
    country: "Belgium",
    lat: 51.394798278808594,
    lng: 4.9601898193359375,
  },
  {
    id: "OBL",
    name: "Zoersel (Oostmalle) Airfield",
    city: "Zoersel",
    country: "Belgium",
    lat: 51.264702,
    lng: 4.75333,
  },
  {
    id: "N",
    name: "Flugplatz Bautzen",
    city: "Bautzen",
    country: "Germany",
    lat: 51.193611,
    lng: 14.519722,
  },
  {
    id: "AOC",
    name: "Altenburg-Nobitz Airport",
    city: "Altenburg",
    country: "Germany",
    lat: 50.981945,
    lng: 12.506389,
  },
  {
    id: "N",
    name: "Dessau Airfield",
    city: "Dessau",
    country: "Germany",
    lat: 51.831694,
    lng: 12.190962,
  },
  {
    id: "N",
    name: "Eisenhüttenstadt Airfield",
    city: "Eisenhuettenstadt",
    country: "Germany",
    lat: 52.195856,
    lng: 14.58753,
  },
  {
    id: "N",
    name: "Großenhain Airport",
    city: "Suhl",
    country: "Germany",
    lat: 51.30805587768555,
    lng: 13.555556297302246,
  },
  {
    id: "N",
    name: "Merseburg Airport",
    city: "Muehlhausen",
    country: "Germany",
    lat: 51.3630556,
    lng: 11.9408333,
  },
  {
    id: "N",
    name: "Halle-Oppin Airport",
    city: "Halle",
    country: "Germany",
    lat: 51.552223,
    lng: 12.053889,
  },
  {
    id: "IES",
    name: "Riesa-Göhlis Airport",
    city: "Riesa",
    country: "Germany",
    lat: 51.2936096191,
    lng: 13.3561105728,
  },
  {
    id: "REB",
    name: "Rechlin-Lärz Airport",
    city: "Rechlin-laerz",
    country: "Germany",
    lat: 53.306388855,
    lng: 12.7522220612,
  },
  {
    id: "N",
    name: "Strausberg Airport",
    city: "Strausberg",
    country: "Germany",
    lat: 52.5805549621582,
    lng: 13.916666984558105,
  },
  {
    id: "QXH",
    name: "Schönhagen Airport",
    city: "Schoenhagen",
    country: "Germany",
    lat: 52.203609,
    lng: 13.156389,
  },
  {
    id: "BBH",
    name: "Barth Airport",
    city: "Barth",
    country: "Germany",
    lat: 54.338253,
    lng: 12.710515,
  },
  {
    id: "N",
    name: "Jena-Schöngleina Airfield",
    city: "Jena",
    country: "Germany",
    lat: 50.915279,
    lng: 11.714444,
  },
  {
    id: "N",
    name: "Kyritz Airport",
    city: "Kyritz",
    country: "Germany",
    lat: 52.918888092041016,
    lng: 12.425277709960938,
  },
  {
    id: "ZMG",
    name: 'Magdeburg "City" Airport',
    city: "Magdeburg",
    country: "Germany",
    lat: 52.073612,
    lng: 11.626389,
  },
  {
    id: "N",
    name: "Rothenburg/Görlitz Airport",
    city: "Rothenburg/ol",
    country: "Germany",
    lat: 51.36333465576172,
    lng: 14.949999809265137,
  },
  {
    id: "N",
    name: "Anklam Airfield",
    city: "Anklam",
    country: "Germany",
    lat: 53.832779,
    lng: 13.668611,
  },
  {
    id: "CBU",
    name: "Cottbus-Drewitz Airport",
    city: "Cottbus",
    country: "Germany",
    lat: 51.889442,
    lng: 14.531944,
  },
  {
    id: "N",
    name: "Kamenz Airport",
    city: "Kamenz",
    country: "Germany",
    lat: 51.29694366455078,
    lng: 14.1274995803833,
  },
  {
    id: "SXF",
    name: "Berlin-Schönefeld Airport",
    city: "Berlin",
    country: "Germany",
    lat: 52.380001,
    lng: 13.5225,
  },
  {
    id: "DRS",
    name: "Dresden Airport",
    city: "Dresden",
    country: "Germany",
    lat: 51.1328010559082,
    lng: 13.767200469970703,
  },
  {
    id: "ERF",
    name: "Erfurt Airport",
    city: "Erfurt",
    country: "Germany",
    lat: 50.979801177978516,
    lng: 10.958100318908691,
  },
  {
    id: "FRA",
    name: "Frankfurt am Main Airport",
    city: "Frankfurt",
    country: "Germany",
    lat: 50.033333,
    lng: 8.570556,
  },
  {
    id: "FMO",
    name: "Münster Osnabrück Airport",
    city: "Munster",
    country: "Germany",
    lat: 52.134601593,
    lng: 7.68483018875,
  },
  {
    id: "HAM",
    name: "Hamburg Airport",
    city: "Hamburg",
    country: "Germany",
    lat: 53.630401611328,
    lng: 9.9882297515869,
  },
  {
    id: "THF",
    name: "Berlin-Tempelhof International Airport",
    city: "Berlin",
    country: "Germany",
    lat: 52.472999572753906,
    lng: 13.403900146484375,
  },
  {
    id: "CGN",
    name: "Cologne Bonn Airport",
    city: "Cologne",
    country: "Germany",
    lat: 50.8658981323,
    lng: 7.1427397728,
  },
  {
    id: "DUS",
    name: "Düsseldorf Airport",
    city: "Duesseldorf",
    country: "Germany",
    lat: 51.289501,
    lng: 6.76678,
  },
  {
    id: "MUC",
    name: "Munich Airport",
    city: "Munich",
    country: "Germany",
    lat: 48.353802,
    lng: 11.7861,
  },
  {
    id: "NUE",
    name: "Nuremberg Airport",
    city: "Nuernberg",
    country: "Germany",
    lat: 49.498699,
    lng: 11.078056,
  },
  {
    id: "LEJ",
    name: "Leipzig/Halle Airport",
    city: "Leipzig",
    country: "Germany",
    lat: 51.423889,
    lng: 12.236389,
  },
  {
    id: "SCN",
    name: "Saarbrücken Airport",
    city: "Saarbruecken",
    country: "Germany",
    lat: 49.214599609400004,
    lng: 7.10950994492,
  },
  {
    id: "STR",
    name: "Stuttgart Airport",
    city: "Stuttgart",
    country: "Germany",
    lat: 48.689899444599995,
    lng: 9.22196006775,
  },
  {
    id: "TXL",
    name: "Berlin-Tegel Airport",
    city: "Berlin",
    country: "Germany",
    lat: 52.5597,
    lng: 13.2877,
  },
  {
    id: "HAJ",
    name: "Hannover Airport",
    city: "Hannover",
    country: "Germany",
    lat: 52.461101532,
    lng: 9.685079574580001,
  },
  {
    id: "BRE",
    name: "Bremen Airport",
    city: "Bremen",
    country: "Germany",
    lat: 53.0475006104,
    lng: 8.78666973114,
  },
  {
    id: "QEF",
    name: "Frankfurt-Egelsbach Airport",
    city: "Egelsbach",
    country: "Germany",
    lat: 49.959999,
    lng: 8.645833,
  },
  {
    id: "HHN",
    name: "Frankfurt-Hahn Airport",
    city: "Hahn",
    country: "Germany",
    lat: 49.9487,
    lng: 7.26389,
  },
  {
    id: "MHG",
    name: "Mannheim-City Airport",
    city: "Mannheim",
    country: "Germany",
    lat: 49.473057,
    lng: 8.514167,
  },
  {
    id: "N",
    name: "Allendorf/Eder Airport",
    city: "Allendorf",
    country: "Germany",
    lat: 51.03499984741211,
    lng: 8.680832862854004,
  },
  {
    id: "N",
    name: "Worms Airport",
    city: "Worms",
    country: "Germany",
    lat: 49.606945,
    lng: 8.368333,
  },
  {
    id: "N",
    name: "Mainz-Finthen Airport",
    city: "Mainz",
    country: "Germany",
    lat: 49.967499,
    lng: 8.147222,
  },
  {
    id: "EIB",
    name: "Eisenach-Kindel Airport",
    city: "Eisenach",
    country: "Germany",
    lat: 50.991604,
    lng: 10.47973,
  },
  {
    id: "SGE",
    name: "Siegerland Airport",
    city: "Siegerland",
    country: "Germany",
    lat: 50.707698822021484,
    lng: 8.082969665527344,
  },
  {
    id: "XFW",
    name: "Hamburg-Finkenwerder Airport",
    city: "Hamburg",
    country: "Germany",
    lat: 53.5352783203125,
    lng: 9.835556030273438,
  },
  {
    id: "KEL",
    name: "Kiel-Holtenau Airport",
    city: "Kiel",
    country: "Germany",
    lat: 54.37944412231445,
    lng: 10.145277976989746,
  },
  {
    id: "LBC",
    name: "Lübeck Blankensee Airport",
    city: "Luebeck",
    country: "Germany",
    lat: 53.8054008484,
    lng: 10.7192001343,
  },
  {
    id: "N",
    name: "Flugplatz Dahlemer Binz",
    city: "Dahlemer Binz",
    country: "Germany",
    lat: 50.405555725,
    lng: 6.5288891792,
  },
  {
    id: "N",
    name: "Meinerzhagen Airport",
    city: "Meinerzhagen",
    country: "Germany",
    lat: 51.099998474121094,
    lng: 7.599999904632568,
  },
  {
    id: "N",
    name: "Arnsberg-Menden Airport",
    city: "Arnsberg",
    country: "Germany",
    lat: 51.483890533447266,
    lng: 7.8983330726623535,
  },
  {
    id: "ESS",
    name: "Essen Mulheim Airport",
    city: "Essen",
    country: "Germany",
    lat: 51.40230178833008,
    lng: 6.9373297691345215,
  },
  {
    id: "BFE",
    name: "Bielefeld Airport",
    city: "Bielefeld",
    country: "Germany",
    lat: 51.964722,
    lng: 8.544444,
  },
  {
    id: "MGL",
    name: "Mönchengladbach Airport",
    city: "Moenchengladbach",
    country: "Germany",
    lat: 51.230278,
    lng: 6.504444,
  },
  {
    id: "PAD",
    name: "Paderborn Lippstadt Airport",
    city: "Paderborn",
    country: "Germany",
    lat: 51.614101409899995,
    lng: 8.616319656369999,
  },
  {
    id: "N",
    name: "Stadtlohn-Vreden Airport",
    city: "Stadtlohn",
    country: "Germany",
    lat: 51.99583435058594,
    lng: 6.8405561447143555,
  },
  {
    id: "DTM",
    name: "Dortmund Airport",
    city: "Dortmund",
    country: "Germany",
    lat: 51.51829910279999,
    lng: 7.61223983765,
  },
  {
    id: "AGB",
    name: "Augsburg Airport",
    city: "Augsburg",
    country: "Germany",
    lat: 48.425278,
    lng: 10.931667,
  },
  {
    id: "N",
    name: "Biberach a.d. Riß Airfield",
    city: "Biberach",
    country: "Germany",
    lat: 48.111111,
    lng: 9.762778,
  },
  {
    id: "N",
    name: "Eggenfelden Airport",
    city: "Eggenfelden",
    country: "Germany",
    lat: 48.39611053466797,
    lng: 12.723610877990723,
  },
  {
    id: "N",
    name: "Mindelheim-Mattsies Airfield",
    city: "Mindelheim",
    country: "Germany",
    lat: 48.106945,
    lng: 10.525,
  },
  {
    id: "OBF",
    name: "Oberpfaffenhofen Airport",
    city: "Oberpfaffenhofen",
    country: "Germany",
    lat: 48.081402,
    lng: 11.2831,
  },
  {
    id: "RBM",
    name: "Straubing Airport",
    city: "Straubing",
    country: "Germany",
    lat: 48.90083312988281,
    lng: 12.516667366027832,
  },
  {
    id: "N",
    name: "Vilshofen Airport",
    city: "Vilshofen",
    country: "Germany",
    lat: 48.6349983215332,
    lng: 13.195555686950684,
  },
  {
    id: "N",
    name: "Leutkirch-Unterzeil Airport",
    city: "Leutkirch",
    country: "Germany",
    lat: 47.858890533447266,
    lng: 10.014166831970215,
  },
  {
    id: "FDH",
    name: "Friedrichshafen Airport",
    city: "Friedrichshafen",
    country: "Germany",
    lat: 47.671298980699994,
    lng: 9.51148986816,
  },
  {
    id: "SZW",
    name: "Schwerin Parchim Airport",
    city: "Parchim",
    country: "Germany",
    lat: 53.426998,
    lng: 11.7834,
  },
  {
    id: "N",
    name: "Stendal-Borstel Airport",
    city: "Stendal",
    country: "Germany",
    lat: 52.62888717651367,
    lng: 11.818611145019531,
  },
  {
    id: "N",
    name: "Aalen-Heidenheim/Elchingen Airport",
    city: "Aalen-heidenheim",
    country: "Germany",
    lat: 48.77777862548828,
    lng: 10.264721870422363,
  },
  {
    id: "BYU",
    name: "Bayreuth Airport",
    city: "Bayreuth",
    country: "Germany",
    lat: 49.985001,
    lng: 11.64,
  },
  {
    id: "URD",
    name: "Burg Feuerstein Airport",
    city: "Burg Feuerstein",
    country: "Germany",
    lat: 49.794166564941,
    lng: 11.133610725403,
  },
  {
    id: "HOQ",
    name: "Hof-Plauen Airport",
    city: "Hof",
    country: "Germany",
    lat: 50.288612365722656,
    lng: 11.856389045715332,
  },
  {
    id: "N",
    name: "Haßfurt-Schweinfurt Airport",
    city: "Hassfurt",
    country: "Germany",
    lat: 50.0180549621582,
    lng: 10.529443740844727,
  },
  {
    id: "N",
    name: "Koblenz-Winningen Airfield",
    city: "Koblenz",
    country: "Germany",
    lat: 50.325558,
    lng: 7.528611,
  },
  {
    id: "N",
    name: "Trier-Föhren Airport",
    city: "Trier",
    country: "Germany",
    lat: 49.863888,
    lng: 6.7875,
  },
  {
    id: "N",
    name: "Speyer Airfield",
    city: "Speyer",
    country: "Germany",
    lat: 49.304722,
    lng: 8.451389,
  },
  {
    id: "ZQW",
    name: "Zweibrücken Airport",
    city: "Zweibruecken",
    country: "Germany",
    lat: 49.2094,
    lng: 7.40056,
  },
  {
    id: "ZQL",
    name: "Donaueschingen-Villingen Airport",
    city: "Donaueschingen",
    country: "Germany",
    lat: 47.97333145139999,
    lng: 8.52222156525,
  },
  {
    id: "N",
    name: "Freiburg i. Br. Airport",
    city: "Freiburg",
    country: "Germany",
    lat: 48.022777557400005,
    lng: 7.83249998093,
  },
  {
    id: "N",
    name: "Mengen-Hohentengen Airport",
    city: "Mengen",
    country: "Germany",
    lat: 48.053890228271484,
    lng: 9.372777938842773,
  },
  {
    id: "N",
    name: "Adolf Würth Airport",
    city: "Schwaebisch Hall",
    country: "Germany",
    lat: 49.1183319092,
    lng: 9.783888816829998,
  },
  {
    id: "N",
    name: "Finsterwalde/Schacksdorf Airport",
    city: "Soest",
    country: "Germany",
    lat: 51.607498,
    lng: 13.743611,
  },
  {
    id: "BWE",
    name: "Braunschweig-Wolfsburg Airport",
    city: "Braunschweig",
    country: "Germany",
    lat: 52.319199,
    lng: 10.5561,
  },
  {
    id: "KSF",
    name: "Kassel-Calden Airport",
    city: "Kassel",
    country: "Germany",
    lat: 51.417273,
    lng: 9.384967,
  },
  {
    id: "N",
    name: "Hildesheim Airport",
    city: "Hildesheim",
    country: "Germany",
    lat: 52.18138885498047,
    lng: 9.946389198303223,
  },
  {
    id: "BRV",
    name: "Bremerhaven Airport",
    city: "Bremerhaven",
    country: "Germany",
    lat: 53.506943,
    lng: 8.572778,
  },
  {
    id: "EME",
    name: "Emden Airport",
    city: "Emden",
    country: "Germany",
    lat: 53.391109,
    lng: 7.2275,
  },
  {
    id: "N",
    name: "Leer-Papenburg Airport",
    city: "Leer",
    country: "Germany",
    lat: 53.271942138671875,
    lng: 7.441667079925537,
  },
  {
    id: "WVN",
    name: "Wilhelmshaven-Mariensiel Airport",
    city: "Wilhelmshaven",
    country: "Germany",
    lat: 53.502220153808594,
    lng: 8.05222225189209,
  },
  {
    id: "BMK",
    name: "Borkum Airport",
    city: "Borkum",
    country: "Germany",
    lat: 53.59639,
    lng: 6.709167,
  },
  {
    id: "NRD",
    name: "Norderney Airport",
    city: "Norderney",
    country: "Germany",
    lat: 53.70694351196289,
    lng: 7.230000019073486,
  },
  {
    id: "FLF",
    name: "Flensburg-Schäferhaus Airport",
    city: "Flensburg",
    country: "Germany",
    lat: 54.77333450317383,
    lng: 9.378889083862305,
  },
  {
    id: "N",
    name: "Rendsburg-Schachtholm Airport",
    city: "Rendsburg",
    country: "Germany",
    lat: 54.220001220703125,
    lng: 9.599444389343262,
  },
  {
    id: "GWT",
    name: "Westerland Sylt Airport",
    city: "Westerland",
    country: "Germany",
    lat: 54.9132003784,
    lng: 8.34047031403,
  },
  {
    id: "N",
    name: "Ämari Air Base",
    city: "Armari Air Force Base",
    country: "Estonia",
    lat: 59.26029968261719,
    lng: 24.208499908447266,
  },
  {
    id: "KDL",
    name: "Kärdla Airport",
    city: "Kardla",
    country: "Estonia",
    lat: 58.99079895019531,
    lng: 22.830699920654297,
  },
  {
    id: "URE",
    name: "Kuressaare Airport",
    city: "Kuressaare",
    country: "Estonia",
    lat: 58.22990036010742,
    lng: 22.50950050354004,
  },
  {
    id: "EPU",
    name: "Pärnu Airport",
    city: "Parnu",
    country: "Estonia",
    lat: 58.41899871826172,
    lng: 24.47279930114746,
  },
  {
    id: "TLL",
    name: "Lennart Meri Tallinn Airport",
    city: "Tallinn-ulemiste International",
    country: "Estonia",
    lat: 59.41329956049999,
    lng: 24.832799911499997,
  },
  {
    id: "TAY",
    name: "Tartu Airport",
    city: "Tartu",
    country: "Estonia",
    lat: 58.3074989319,
    lng: 26.690399169900004,
  },
  {
    id: "ENF",
    name: "Enontekio Airport",
    city: "Enontekio",
    country: "Finland",
    lat: 68.362602233887,
    lng: 23.424299240112,
  },
  {
    id: "N",
    name: "Eura Airport",
    city: "Eura",
    country: "Finland",
    lat: 61.1161003112793,
    lng: 22.201400756835938,
  },
  {
    id: "KEV",
    name: "Halli Airport",
    city: "Halli",
    country: "Finland",
    lat: 61.856039,
    lng: 24.786686,
  },
  {
    id: "HEM",
    name: "Helsinki Malmi Airport",
    city: "Helsinki",
    country: "Finland",
    lat: 60.254600524902344,
    lng: 25.042800903320312,
  },
  {
    id: "HEL",
    name: "Helsinki Vantaa Airport",
    city: "Helsinki",
    country: "Finland",
    lat: 60.317199707031,
    lng: 24.963300704956,
  },
  {
    id: "N",
    name: "Hameenkyro Airport",
    city: "Hameenkyro",
    country: "Finland",
    lat: 61.689701080322266,
    lng: 23.073699951171875,
  },
  {
    id: "N",
    name: "Hanko Airport",
    city: "Hanko",
    country: "Finland",
    lat: 59.848899841308594,
    lng: 23.083599090576172,
  },
  {
    id: "HYV",
    name: "Hyvinkää Airfield",
    city: "Hyvinkaa",
    country: "Finland",
    lat: 60.6543998718,
    lng: 24.8810997009,
  },
  {
    id: "N",
    name: "Kiikala Airport",
    city: "Kikala",
    country: "Finland",
    lat: 60.4625015259,
    lng: 23.6525001526,
  },
  {
    id: "N",
    name: "Immola Airport",
    city: "Immola",
    country: "Finland",
    lat: 61.24919891357422,
    lng: 28.90369987487793,
  },
  {
    id: "KTQ",
    name: "Kitee Airport",
    city: "Kitee",
    country: "Finland",
    lat: 62.1661,
    lng: 30.073601,
  },
  {
    id: "IVL",
    name: "Ivalo Airport",
    city: "Ivalo",
    country: "Finland",
    lat: 68.607299804688,
    lng: 27.405300140381,
  },
  {
    id: "JOE",
    name: "Joensuu Airport",
    city: "Joensuu",
    country: "Finland",
    lat: 62.662899017334,
    lng: 29.607500076294,
  },
  {
    id: "JYV",
    name: "Jyvaskyla Airport",
    city: "Jyvaskyla",
    country: "Finland",
    lat: 62.399501800537,
    lng: 25.678300857544,
  },
  {
    id: "KAU",
    name: "Kauhava Airport",
    city: "Kauhava",
    country: "Finland",
    lat: 63.127102,
    lng: 23.051399,
  },
  {
    id: "KEM",
    name: "Kemi-Tornio Airport",
    city: "Kemi",
    country: "Finland",
    lat: 65.778701782227,
    lng: 24.582099914551,
  },
  {
    id: "KAJ",
    name: "Kajaani Airport",
    city: "Kajaani",
    country: "Finland",
    lat: 64.285499572754,
    lng: 27.692399978638,
  },
  {
    id: "KHJ",
    name: "Kauhajoki Airport",
    city: "Kauhajoki",
    country: "Finland",
    lat: 62.4625015259,
    lng: 22.3931007385,
  },
  {
    id: "KOK",
    name: "Kokkola-Pietarsaari Airport",
    city: "Kruunupyy",
    country: "Finland",
    lat: 63.721199035645,
    lng: 23.143100738525,
  },
  {
    id: "N",
    name: "Kemijarvi Airport",
    city: "Kemijarvi",
    country: "Finland",
    lat: 66.712898,
    lng: 27.156799,
  },
  {
    id: "KAO",
    name: "Kuusamo Airport",
    city: "Kuusamo",
    country: "Finland",
    lat: 65.987602233887,
    lng: 29.239400863647,
  },
  {
    id: "KTT",
    name: "Kittilä Airport",
    city: "Kittila",
    country: "Finland",
    lat: 67.700996398926,
    lng: 24.846799850464,
  },
  {
    id: "KUO",
    name: "Kuopio Airport",
    city: "Kuopio",
    country: "Finland",
    lat: 63.007099151611,
    lng: 27.797800064087,
  },
  {
    id: "QLF",
    name: "Lahti Vesivehmaa Airport",
    city: "Vesivehmaa",
    country: "Finland",
    lat: 61.144199,
    lng: 25.693501,
  },
  {
    id: "LPP",
    name: "Lappeenranta Airport",
    city: "Lappeenranta",
    country: "Finland",
    lat: 61.044601,
    lng: 28.144743,
  },
  {
    id: "MHQ",
    name: "Mariehamn Airport",
    city: "Mariehamn",
    country: "Finland",
    lat: 60.122200012207,
    lng: 19.898199081421,
  },
  {
    id: "N",
    name: "Menkijarvi Airport",
    city: "Menkijarvi",
    country: "Finland",
    lat: 62.94670104980469,
    lng: 23.51889991760254,
  },
  {
    id: "MIK",
    name: "Mikkeli Airport",
    city: "Mikkeli",
    country: "Finland",
    lat: 61.6866,
    lng: 27.201799,
  },
  {
    id: "N",
    name: "Nummela Airport",
    city: "Nummela",
    country: "Finland",
    lat: 60.333900451699996,
    lng: 24.2964000702,
  },
  {
    id: "OUL",
    name: "Oulu Airport",
    city: "Oulu",
    country: "Finland",
    lat: 64.930099487305,
    lng: 25.354600906372,
  },
  {
    id: "N",
    name: "Piikajarvi Airport",
    city: "Piikajarvi",
    country: "Finland",
    lat: 61.245601654052734,
    lng: 22.19339942932129,
  },
  {
    id: "POR",
    name: "Pori Airport",
    city: "Pori",
    country: "Finland",
    lat: 61.461700439453,
    lng: 21.799999237061,
  },
  {
    id: "N",
    name: "Pudasjärvi Airport",
    city: "Pudasjarvi",
    country: "Finland",
    lat: 65.4021987915,
    lng: 26.946899414100002,
  },
  {
    id: "N",
    name: "Pyhäsalmi Airport",
    city: "Pyhasalmi",
    country: "Finland",
    lat: 63.7318992615,
    lng: 25.926300048799998,
  },
  {
    id: "N",
    name: "Raahe Pattijoki Airport",
    city: "Pattijoki",
    country: "Finland",
    lat: 64.6881027222,
    lng: 24.6958007812,
  },
  {
    id: "N",
    name: "Rantasalmi Airport",
    city: "Rantasalmi",
    country: "Finland",
    lat: 62.0654983521,
    lng: 28.3565006256,
  },
  {
    id: "RVN",
    name: "Rovaniemi Airport",
    city: "Rovaniemi",
    country: "Finland",
    lat: 66.564796447754,
    lng: 25.830400466919,
  },
  {
    id: "N",
    name: "Rayskala Airport",
    city: "Rayskala",
    country: "Finland",
    lat: 60.74470138549805,
    lng: 24.107799530029297,
  },
  {
    id: "SVL",
    name: "Savonlinna Airport",
    city: "Savonlinna",
    country: "Finland",
    lat: 61.943099975586,
    lng: 28.945100784302,
  },
  {
    id: "N",
    name: "Selanpaa Airport",
    city: "Selanpaa",
    country: "Finland",
    lat: 61.062400817871094,
    lng: 26.798900604248047,
  },
  {
    id: "SOT",
    name: "Sodankyla Airport",
    city: "Sodankyla",
    country: "Finland",
    lat: 67.3949966431,
    lng: 26.6191005707,
  },
  {
    id: "TMP",
    name: "Tampere-Pirkkala Airport",
    city: "Tampere",
    country: "Finland",
    lat: 61.414100646973,
    lng: 23.604400634766,
  },
  {
    id: "N",
    name: "Teisko Airport",
    city: "Teisko",
    country: "Finland",
    lat: 61.7733,
    lng: 24.027,
  },
  {
    id: "TKU",
    name: "Turku Airport",
    city: "Turku",
    country: "Finland",
    lat: 60.514099121094,
    lng: 22.262800216675,
  },
  {
    id: "UTI",
    name: "Utti Air Base",
    city: "Utti",
    country: "Finland",
    lat: 60.89640045166,
    lng: 26.938400268555,
  },
  {
    id: "VAA",
    name: "Vaasa Airport",
    city: "Vaasa",
    country: "Finland",
    lat: 63.050701141357,
    lng: 21.762199401855,
  },
  {
    id: "VRK",
    name: "Varkaus Airport",
    city: "Varkaus",
    country: "Finland",
    lat: 62.171100616455,
    lng: 27.868600845337,
  },
  {
    id: "YLI",
    name: "Ylivieska Airfield",
    city: "Ylivieska-raudaskyla",
    country: "Finland",
    lat: 64.0547222,
    lng: 24.7252778,
  },
  {
    id: "BFS",
    name: "Belfast International Airport",
    city: "Belfast",
    country: "United Kingdom",
    lat: 54.6575012207,
    lng: -6.2158298492399995,
  },
  {
    id: "ENK",
    name: "St Angelo Airport",
    city: "Enniskillen",
    country: "United Kingdom",
    lat: 54.39889907836914,
    lng: -7.651669979095459,
  },
  {
    id: "BHD",
    name: "George Best Belfast City Airport",
    city: "Belfast",
    country: "United Kingdom",
    lat: 54.618099212646484,
    lng: -5.872499942779541,
  },
  {
    id: "LDY",
    name: "City of Derry Airport",
    city: "Londonderry",
    country: "United Kingdom",
    lat: 55.04280090332031,
    lng: -7.161109924316406,
  },
  {
    id: "BHX",
    name: "Birmingham International Airport",
    city: "Birmingham",
    country: "United Kingdom",
    lat: 52.453899383499994,
    lng: -1.74802994728,
  },
  {
    id: "CVT",
    name: "Coventry Airport",
    city: "Coventry",
    country: "United Kingdom",
    lat: 52.3697013855,
    lng: -1.4797199964499999,
  },
  {
    id: "N",
    name: "Leicester Airport",
    city: "Leicester",
    country: "United Kingdom",
    lat: 52.6077995300293,
    lng: -1.03193998336792,
  },
  {
    id: "GLO",
    name: "Gloucestershire Airport",
    city: "Golouchestershire",
    country: "United Kingdom",
    lat: 51.89419937133789,
    lng: -2.167220115661621,
  },
  {
    id: "N",
    name: "Wolverhampton Halfpenny Green Airport",
    city: "Halfpenny Green",
    country: "United Kingdom",
    lat: 52.51750183105469,
    lng: -2.2594399452209473,
  },
  {
    id: "GBA",
    name: "Cotswold Airport",
    city: "Pailton",
    country: "United Kingdom",
    lat: 51.668095,
    lng: -2.05694,
  },
  {
    id: "N",
    name: "Turweston Airport",
    city: "Turweston",
    country: "United Kingdom",
    lat: 52.0407981873,
    lng: -1.09555995464,
  },
  {
    id: "N",
    name: "Wellesbourne Mountford Airport",
    city: "Wellesbourne",
    country: "United Kingdom",
    lat: 52.19219970703125,
    lng: -1.6144399642944336,
  },
  {
    id: "MAN",
    name: "Manchester Airport",
    city: "Manchester",
    country: "United Kingdom",
    lat: 53.35369873046875,
    lng: -2.2749500274658203,
  },
  {
    id: "N",
    name: "Manchester Woodford Airport",
    city: "Woodfort",
    country: "United Kingdom",
    lat: 53.3381,
    lng: -2.14889,
  },
  {
    id: "N",
    name: "Royal Marines Base Chivenor Airport",
    city: "Chivenor",
    country: "United Kingdom",
    lat: 51.08720016479492,
    lng: -4.1503400802612305,
  },
  {
    id: "NQY",
    name: "Newquay Cornwall Airport",
    city: "Newquai",
    country: "United Kingdom",
    lat: 50.44060134887695,
    lng: -4.995409965515137,
  },
  {
    id: "LYE",
    name: "RAF Lyneham",
    city: "Lyneham",
    country: "United Kingdom",
    lat: 51.5051,
    lng: -1.99343,
  },
  {
    id: "N",
    name: "MoD Boscombe Down Airport",
    city: "Boscombe Down",
    country: "United Kingdom",
    lat: 51.152198791503906,
    lng: -1.7474100589752197,
  },
  {
    id: "N",
    name: "RNAS Culdrose",
    city: "Culdrose",
    country: "United Kingdom",
    lat: 50.08610153198242,
    lng: -5.255710124969482,
  },
  {
    id: "N",
    name: "MoD St. Athan",
    city: "St. Athan",
    country: "United Kingdom",
    lat: 51.4048,
    lng: -3.43575,
  },
  {
    id: "YEO",
    name: "RNAS Yeovilton",
    city: "Yeovilton",
    country: "United Kingdom",
    lat: 51.0093994140625,
    lng: -2.638819932937622,
  },
  {
    id: "HAW",
    name: "Haverfordwest Airport",
    city: "Haverfordwest",
    country: "United Kingdom",
    lat: 51.833099365234375,
    lng: -4.9611101150512695,
  },
  {
    id: "CWL",
    name: "Cardiff International Airport",
    city: "Cardiff",
    country: "United Kingdom",
    lat: 51.39670181274414,
    lng: -3.343329906463623,
  },
  {
    id: "SWS",
    name: "Swansea Airport",
    city: "Swansea",
    country: "United Kingdom",
    lat: 51.60530090332031,
    lng: -4.0678300857543945,
  },
  {
    id: "BRS",
    name: "Bristol Airport",
    city: "Bristol",
    country: "United Kingdom",
    lat: 51.382702,
    lng: -2.71909,
  },
  {
    id: "LPL",
    name: "Liverpool John Lennon Airport",
    city: "Liverpool",
    country: "United Kingdom",
    lat: 53.33359909057617,
    lng: -2.849720001220703,
  },
  {
    id: "LTN",
    name: "London Luton Airport",
    city: "London",
    country: "United Kingdom",
    lat: 51.874698638916016,
    lng: -0.36833301186561584,
  },
  {
    id: "PLH",
    name: "Plymouth City Airport",
    city: "Plymouth",
    country: "United Kingdom",
    lat: 50.422798,
    lng: -4.10583,
  },
  {
    id: "BOH",
    name: "Bournemouth Airport",
    city: "Bournemouth",
    country: "United Kingdom",
    lat: 50.779998779296875,
    lng: -1.8424999713897705,
  },
  {
    id: "SOU",
    name: "Southampton Airport",
    city: "Southampton",
    country: "United Kingdom",
    lat: 50.95029830932617,
    lng: -1.3567999601364136,
  },
  {
    id: "QLA",
    name: "Lasham Airport",
    city: "Lasham",
    country: "United Kingdom",
    lat: 51.187198638916016,
    lng: -1.0334999561309814,
  },
  {
    id: "ACI",
    name: "Alderney Airport",
    city: "Alderney",
    country: "Guernsey",
    lat: 49.706104,
    lng: -2.21472,
  },
  {
    id: "GCI",
    name: "Guernsey Airport",
    city: "Guernsey",
    country: "Guernsey",
    lat: 49.435001373291016,
    lng: -2.6019699573516846,
  },
  {
    id: "JER",
    name: "Jersey Airport",
    city: "Jersey",
    country: "Jersey",
    lat: 49.20790100097656,
    lng: -2.195509910583496,
  },
  {
    id: "ESH",
    name: "Shoreham Airport",
    city: "Shoreham By Sea",
    country: "United Kingdom",
    lat: 50.835602,
    lng: -0.297222,
  },
  {
    id: "BQH",
    name: "London Biggin Hill Airport",
    city: "Biggin Hill",
    country: "United Kingdom",
    lat: 51.33079910279999,
    lng: 0.0324999988079,
  },
  {
    id: "LGW",
    name: "London Gatwick Airport",
    city: "London",
    country: "United Kingdom",
    lat: 51.148102,
    lng: -0.190278,
  },
  {
    id: "LCY",
    name: "London City Airport",
    city: "London",
    country: "United Kingdom",
    lat: 51.505299,
    lng: 0.055278,
  },
  {
    id: "FAB",
    name: "Farnborough Airport",
    city: "Farnborough",
    country: "United Kingdom",
    lat: 51.2757987976,
    lng: -0.776332974434,
  },
  {
    id: "N",
    name: "Chalgrove Airport",
    city: "Chalsgrove",
    country: "United Kingdom",
    lat: 51.67610168457031,
    lng: -1.0808299779891968,
  },
  {
    id: "BBS",
    name: "Blackbushe Airport",
    city: "Blackbushe",
    country: "United Kingdom",
    lat: 51.32389831542969,
    lng: -0.8475000262260437,
  },
  {
    id: "LHR",
    name: "London Heathrow Airport",
    city: "London",
    country: "United Kingdom",
    lat: 51.4706,
    lng: -0.461941,
  },
  {
    id: "SEN",
    name: "Southend Airport",
    city: "Southend",
    country: "United Kingdom",
    lat: 51.5713996887207,
    lng: 0.6955559849739075,
  },
  {
    id: "LYX",
    name: "Lydd Airport",
    city: "Lydd",
    country: "United Kingdom",
    lat: 50.95610046386719,
    lng: 0.9391670227050781,
  },
  {
    id: "MSE",
    name: "Kent International Airport",
    city: "Manston",
    country: "United Kingdom",
    lat: 51.342201,
    lng: 1.34611,
  },
  {
    id: "N",
    name: "Brough Airport",
    city: "Brough",
    country: "United Kingdom",
    lat: 53.7197,
    lng: -0.566333,
  },
  {
    id: "CAX",
    name: "Carlisle Airport",
    city: "Carlisle",
    country: "United Kingdom",
    lat: 54.9375,
    lng: -2.8091700077056885,
  },
  {
    id: "N",
    name: "Retford Gamston Airport",
    city: "Repton",
    country: "United Kingdom",
    lat: 53.280601501464844,
    lng: -0.9513890147209167,
  },
  {
    id: "BLK",
    name: "Blackpool International Airport",
    city: "Blackpool",
    country: "United Kingdom",
    lat: 53.77170181274414,
    lng: -3.0286099910736084,
  },
  {
    id: "HUY",
    name: "Humberside Airport",
    city: "Humberside",
    country: "United Kingdom",
    lat: 53.57440185546875,
    lng: -0.350832998752594,
  },
  {
    id: "BWF",
    name: "Barrow Walney Island Airport",
    city: "Barrow Island",
    country: "United Kingdom",
    lat: 54.1286111,
    lng: -3.2675,
  },
  {
    id: "LBA",
    name: "Leeds Bradford Airport",
    city: "Leeds",
    country: "United Kingdom",
    lat: 53.86589813232422,
    lng: -1.6605700254440308,
  },
  {
    id: "WRT",
    name: "Warton Airport",
    city: "Warton",
    country: "United Kingdom",
    lat: 53.745098,
    lng: -2.88306,
  },
  {
    id: "CEG",
    name: "Hawarden Airport",
    city: "Hawarden",
    country: "United Kingdom",
    lat: 53.1781005859375,
    lng: -2.9777801036834717,
  },
  {
    id: "IOM",
    name: "Isle of Man Airport",
    city: "Isle Of Man",
    country: "Isle of Man",
    lat: 54.08330154418945,
    lng: -4.623889923095703,
  },
  {
    id: "NCL",
    name: "Newcastle Airport",
    city: "Newcastle",
    country: "United Kingdom",
    lat: 55.037498474121094,
    lng: -1.6916699409484863,
  },
  {
    id: "MME",
    name: "Durham Tees Valley Airport",
    city: "Teesside",
    country: "United Kingdom",
    lat: 54.50920104980469,
    lng: -1.4294099807739258,
  },
  {
    id: "EMA",
    name: "East Midlands Airport",
    city: "East Midlands",
    country: "United Kingdom",
    lat: 52.8311004639,
    lng: -1.32806003094,
  },
  {
    id: "N",
    name: "Llanbedr Airport",
    city: "Llanbedr",
    country: "United Kingdom",
    lat: 52.811698913574,
    lng: -4.1235799789429,
  },
  {
    id: "N",
    name: "RAF Ternhill",
    city: "Ternhill",
    country: "United Kingdom",
    lat: 52.87120056152344,
    lng: -2.533560037612915,
  },
  {
    id: "N",
    name: "RAF Shawbury",
    city: "Shawbury",
    country: "United Kingdom",
    lat: 52.79819869995117,
    lng: -2.6680400371551514,
  },
  {
    id: "N",
    name: "RAF Woodvale",
    city: "Woodvale",
    country: "United Kingdom",
    lat: 53.5816,
    lng: -3.05552,
  },
  {
    id: "KOI",
    name: "Kirkwall Airport",
    city: "Kirkwall",
    country: "United Kingdom",
    lat: 58.957801818847656,
    lng: -2.9049999713897705,
  },
  {
    id: "LSI",
    name: "Sumburgh Airport",
    city: "Sumburgh",
    country: "United Kingdom",
    lat: 59.87889862060547,
    lng: -1.2955600023269653,
  },
  {
    id: "WIC",
    name: "Wick Airport",
    city: "Wick",
    country: "United Kingdom",
    lat: 58.458900451660156,
    lng: -3.09306001663208,
  },
  {
    id: "ABZ",
    name: "Aberdeen Dyce Airport",
    city: "Aberdeen",
    country: "United Kingdom",
    lat: 57.201900482177734,
    lng: -2.197779893875122,
  },
  {
    id: "INV",
    name: "Inverness Airport",
    city: "Inverness",
    country: "United Kingdom",
    lat: 57.54249954223633,
    lng: -4.047500133514404,
  },
  {
    id: "GLA",
    name: "Glasgow International Airport",
    city: "Glasgow",
    country: "United Kingdom",
    lat: 55.8718986511,
    lng: -4.43306016922,
  },
  {
    id: "EDI",
    name: "Edinburgh Airport",
    city: "Edinburgh",
    country: "United Kingdom",
    lat: 55.95000076293945,
    lng: -3.372499942779541,
  },
  {
    id: "ILY",
    name: "Islay Airport",
    city: "Islay",
    country: "United Kingdom",
    lat: 55.68190002441406,
    lng: -6.256669998168945,
  },
  {
    id: "PIK",
    name: "Glasgow Prestwick Airport",
    city: "Prestwick",
    country: "United Kingdom",
    lat: 55.5093994140625,
    lng: -4.586669921875,
  },
  {
    id: "BEB",
    name: "Benbecula Airport",
    city: "Benbecula",
    country: "United Kingdom",
    lat: 57.48109817504883,
    lng: -7.3627800941467285,
  },
  {
    id: "SCS",
    name: "Scatsta Airport",
    city: "Scatsta",
    country: "United Kingdom",
    lat: 60.43280029296875,
    lng: -1.2961100339889526,
  },
  {
    id: "DND",
    name: "Dundee Airport",
    city: "Dundee",
    country: "United Kingdom",
    lat: 56.45249938964844,
    lng: -3.025830030441284,
  },
  {
    id: "SYY",
    name: "Stornoway Airport",
    city: "Stornoway",
    country: "United Kingdom",
    lat: 58.215599060058594,
    lng: -6.331110000610352,
  },
  {
    id: "TRE",
    name: "Tiree Airport",
    city: "Tiree",
    country: "United Kingdom",
    lat: 56.49919891357422,
    lng: -6.869170188903809,
  },
  {
    id: "ADX",
    name: "RAF Leuchars",
    city: "Leuchars",
    country: "United Kingdom",
    lat: 56.37289810180664,
    lng: -2.8684399127960205,
  },
  {
    id: "LMO",
    name: "RAF Lossiemouth",
    city: "Lossiemouth",
    country: "United Kingdom",
    lat: 57.7052001953125,
    lng: -3.339169979095459,
  },
  {
    id: "CBG",
    name: "Cambridge Airport",
    city: "Cambridge",
    country: "United Kingdom",
    lat: 52.205002,
    lng: 0.175,
  },
  {
    id: "N",
    name: "Peterborough Business Airport",
    city: "Peterborough",
    country: "United Kingdom",
    lat: 52.468101501464844,
    lng: -0.2511110007762909,
  },
  {
    id: "NWI",
    name: "Norwich International Airport",
    city: "Norwich",
    country: "United Kingdom",
    lat: 52.6758003235,
    lng: 1.28278005123,
  },
  {
    id: "STN",
    name: "London Stansted Airport",
    city: "London",
    country: "United Kingdom",
    lat: 51.8849983215,
    lng: 0.234999999404,
  },
  {
    id: "N",
    name: "North Weald Airport",
    city: "North Weald",
    country: "United Kingdom",
    lat: 51.721698761,
    lng: 0.154166996479,
  },
  {
    id: "N",
    name: "Sheffield City Heliport",
    city: "Fowlmere",
    country: "United Kingdom",
    lat: 53.394299,
    lng: -1.38849,
  },
  {
    id: "N",
    name: "Cranfield Airport",
    city: "Cranfield",
    country: "United Kingdom",
    lat: 52.0722007751,
    lng: -0.616666972637,
  },
  {
    id: "EXT",
    name: "Exeter International Airport",
    city: "Exeter",
    country: "United Kingdom",
    lat: 50.73440170288086,
    lng: -3.4138898849487305,
  },
  {
    id: "FZO",
    name: "Bristol Filton Airport",
    city: "Bristol",
    country: "United Kingdom",
    lat: 51.5194015503,
    lng: -2.59083008766,
  },
  {
    id: "OXF",
    name: "Oxford (Kidlington) Airport",
    city: "Oxford",
    country: "United Kingdom",
    lat: 51.8368988037,
    lng: -1.32000005245,
  },
  {
    id: "BEX",
    name: "RAF Benson",
    city: "Benson",
    country: "United Kingdom",
    lat: 51.616401672399995,
    lng: -1.09582996368,
  },
  {
    id: "LKZ",
    name: "RAF Lakenheath",
    city: "Lakenheath",
    country: "United Kingdom",
    lat: 52.409301757799994,
    lng: 0.56099998951,
  },
  {
    id: "MHZ",
    name: "RAF Mildenhall",
    city: "Mildenhall",
    country: "United Kingdom",
    lat: 52.361900329589844,
    lng: 0.48640599846839905,
  },
  {
    id: "N",
    name: "RAF Wattisham",
    city: "Wattisham",
    country: "United Kingdom",
    lat: 52.1273002625,
    lng: 0.956264019012,
  },
  {
    id: "QUY",
    name: "RAF Wyton",
    city: "Wyton",
    country: "United Kingdom",
    lat: 52.3572006226,
    lng: -0.107832998037,
  },
  {
    id: "FFD",
    name: "RAF Fairford",
    city: "Fairford",
    country: "United Kingdom",
    lat: 51.6822013855,
    lng: -1.7900300025900002,
  },
  {
    id: "BZZ",
    name: "RAF Brize Norton",
    city: "Brize Norton",
    country: "United Kingdom",
    lat: 51.75,
    lng: -1.58362,
  },
  {
    id: "ODH",
    name: "RAF Odiham",
    city: "Odiham",
    country: "United Kingdom",
    lat: 51.2341003418,
    lng: -0.94282501936,
  },
  {
    id: "N",
    name: "DCAE Cosford Air Base",
    city: "Cosford",
    country: "United Kingdom",
    lat: 52.639999,
    lng: -2.30558,
  },
  {
    id: "NHT",
    name: "RAF Northolt",
    city: "Northolt",
    country: "United Kingdom",
    lat: 51.553001403799996,
    lng: -0.418166995049,
  },
  {
    id: "QCY",
    name: "RAF Coningsby",
    city: "Coningsby",
    country: "United Kingdom",
    lat: 53.0929985046,
    lng: -0.166014000773,
  },
  {
    id: "N",
    name: "RAF Dishforth",
    city: "Dishforth",
    country: "United Kingdom",
    lat: 54.1371994019,
    lng: -1.42025005817,
  },
  {
    id: "N",
    name: "Leeming Airport",
    city: "Leeming",
    country: "United Kingdom",
    lat: 54.2924,
    lng: -1.5354,
  },
  {
    id: "N",
    name: "Leeds East Airport",
    city: "Church Fenton",
    country: "United Kingdom",
    lat: 53.834301,
    lng: -1.1955,
  },
  {
    id: "BEQ",
    name: "RAF Honington",
    city: "Honington",
    country: "United Kingdom",
    lat: 52.34260177612305,
    lng: 0.7729390263557434,
  },
  {
    id: "N",
    name: "RAF Cottesmore",
    city: "Cottesmore",
    country: "United Kingdom",
    lat: 52.735699,
    lng: -0.648769,
  },
  {
    id: "SQZ",
    name: "RAF Scampton",
    city: "Scampton",
    country: "United Kingdom",
    lat: 53.307800293,
    lng: -0.550832986832,
  },
  {
    id: "N",
    name: "RAF Wittering",
    city: "Wittering",
    country: "United Kingdom",
    lat: 52.612598,
    lng: -0.476453,
  },
  {
    id: "HRT",
    name: "RAF Linton-On-Ouse",
    city: "Linton-on-ouse",
    country: "United Kingdom",
    lat: 54.0489006042,
    lng: -1.2527500391,
  },
  {
    id: "WTN",
    name: "RAF Waddington",
    city: "Waddington",
    country: "United Kingdom",
    lat: 53.1661987305,
    lng: -0.523810982704,
  },
  {
    id: "N",
    name: "RAF Topcliffe",
    city: "Topcliffe",
    country: "United Kingdom",
    lat: 54.205501556399994,
    lng: -1.3820899725,
  },
  {
    id: "N",
    name: "RAF Cranwell",
    city: "Cranwell",
    country: "United Kingdom",
    lat: 53.0303001404,
    lng: -0.48324200511,
  },
  {
    id: "N",
    name: "RAF Barkston Heath",
    city: "Barkston Heath",
    country: "United Kingdom",
    lat: 52.962200164799995,
    lng: -0.561625003815,
  },
  {
    id: "KNF",
    name: "RAF Marham",
    city: "Marham",
    country: "United Kingdom",
    lat: 52.648395,
    lng: 0.550692,
  },
  {
    id: "MPN",
    name: "Mount Pleasant Airport",
    city: "Mount Pleasant",
    country: "Falkland Islands",
    lat: -51.82279968261719,
    lng: -58.447200775146484,
  },
  {
    id: "AMS",
    name: "Amsterdam Airport Schiphol",
    city: "Amsterdam",
    country: "Netherlands",
    lat: 52.308601,
    lng: 4.76389,
  },
  {
    id: "N",
    name: "Budel Airfield Kempen",
    city: "Weert",
    country: "Netherlands",
    lat: 51.255299,
    lng: 5.60139,
  },
  {
    id: "MST",
    name: "Maastricht Aachen Airport",
    city: "Maastricht",
    country: "Netherlands",
    lat: 50.911701,
    lng: 5.77014,
  },
  {
    id: "N",
    name: "Deelen Air Base",
    city: "Deelen",
    country: "Netherlands",
    lat: 52.0606,
    lng: 5.87306,
  },
  {
    id: "N",
    name: "Drachten Airport",
    city: "Drachten",
    country: "Netherlands",
    lat: 53.1192016602,
    lng: 6.12972021103,
  },
  {
    id: "EIN",
    name: "Eindhoven Airport",
    city: "Eindhoven",
    country: "Netherlands",
    lat: 51.4500999451,
    lng: 5.37452983856,
  },
  {
    id: "GRQ",
    name: "Eelde Airport",
    city: "Groningen",
    country: "Netherlands",
    lat: 53.1197013855,
    lng: 6.57944011688,
  },
  {
    id: "GLZ",
    name: "Gilze Rijen Air Base",
    city: "Gilze-rijen",
    country: "Netherlands",
    lat: 51.56740188598633,
    lng: 4.931829929351807,
  },
  {
    id: "DHR",
    name: "De Kooy Airport",
    city: "De Kooy",
    country: "Netherlands",
    lat: 52.92340087890625,
    lng: 4.780620098114014,
  },
  {
    id: "LEY",
    name: "Lelystad Airport",
    city: "Lelystad",
    country: "Netherlands",
    lat: 52.4603,
    lng: 5.52722,
  },
  {
    id: "LWR",
    name: "Leeuwarden Air Base",
    city: "Leeuwarden",
    country: "Netherlands",
    lat: 53.228599548339844,
    lng: 5.760560035705566,
  },
  {
    id: "RTM",
    name: "Rotterdam The Hague Airport",
    city: "Rotterdam",
    country: "Netherlands",
    lat: 51.956902,
    lng: 4.43722,
  },
  {
    id: "UTC",
    name: "Soesterberg Air Base",
    city: "Soesterberg",
    country: "Netherlands",
    lat: 52.1273002625,
    lng: 5.27618980408,
  },
  {
    id: "ENS",
    name: "Twente Airport",
    city: "Enschede",
    country: "Netherlands",
    lat: 52.275833,
    lng: 6.889167,
  },
  {
    id: "LID",
    name: "Valkenburg Naval Air Base",
    city: "Valkenburg",
    country: "Netherlands",
    lat: 52.166099548300004,
    lng: 4.41794013977,
  },
  {
    id: "WOE",
    name: "Woensdrecht Air Base",
    city: "Woensdrecht",
    country: "Netherlands",
    lat: 51.4491,
    lng: 4.34203,
  },
  {
    id: "ORK",
    name: "Cork Airport",
    city: "Cork",
    country: "Ireland",
    lat: 51.84130096435547,
    lng: -8.491109848022461,
  },
  {
    id: "GWY",
    name: "Galway Airport",
    city: "Galway",
    country: "Ireland",
    lat: 53.300201416015625,
    lng: -8.941590309143066,
  },
  {
    id: "DUB",
    name: "Dublin Airport",
    city: "Dublin",
    country: "Ireland",
    lat: 53.421299,
    lng: -6.27007,
  },
  {
    id: "NOC",
    name: "Ireland West Knock Airport",
    city: "Connaught",
    country: "Ireland",
    lat: 53.910301208496094,
    lng: -8.818490028381348,
  },
  {
    id: "KIR",
    name: "Kerry Airport",
    city: "Kerry",
    country: "Ireland",
    lat: 52.18090057373047,
    lng: -9.52377986907959,
  },
  {
    id: "N",
    name: "Casement Air Base",
    city: "Casement",
    country: "Ireland",
    lat: 53.301700592,
    lng: -6.451330184940001,
  },
  {
    id: "SNN",
    name: "Shannon Airport",
    city: "Shannon",
    country: "Ireland",
    lat: 52.702,
    lng: -8.92482,
  },
  {
    id: "SXL",
    name: "Sligo Airport",
    city: "Sligo",
    country: "Ireland",
    lat: 54.280200958252,
    lng: -8.5992097854614,
  },
  {
    id: "WAT",
    name: "Waterford Airport",
    city: "Waterford",
    country: "Ireland",
    lat: 52.187198638916016,
    lng: -7.0869598388671875,
  },
  {
    id: "AAR",
    name: "Aarhus Airport",
    city: "Aarhus",
    country: "Denmark",
    lat: 56.2999992371,
    lng: 10.619000434899998,
  },
  {
    id: "BLL",
    name: "Billund Airport",
    city: "Billund",
    country: "Denmark",
    lat: 55.7402992249,
    lng: 9.15178012848,
  },
  {
    id: "CPH",
    name: "Copenhagen Kastrup Airport",
    city: "Copenhagen",
    country: "Denmark",
    lat: 55.617900848389,
    lng: 12.656000137329,
  },
  {
    id: "EBJ",
    name: "Esbjerg Airport",
    city: "Esbjerg",
    country: "Denmark",
    lat: 55.525902,
    lng: 8.5534,
  },
  {
    id: "N",
    name: "Grønholt Hillerød Airport",
    city: "Gronholt",
    country: "Denmark",
    lat: 55.94139862060547,
    lng: 12.382200241088867,
  },
  {
    id: "KRP",
    name: "Karup Airport",
    city: "Karup",
    country: "Denmark",
    lat: 56.29750061035156,
    lng: 9.124629974365234,
  },
  {
    id: "BYR",
    name: "Læsø Airport",
    city: "Laeso",
    country: "Denmark",
    lat: 57.277198791503906,
    lng: 11.000100135803223,
  },
  {
    id: "MRW",
    name: "Lolland Falster Maribo Airport",
    city: "Maribo",
    country: "Denmark",
    lat: 54.699299,
    lng: 11.4401,
  },
  {
    id: "ODE",
    name: "Odense Airport",
    city: "Odense",
    country: "Denmark",
    lat: 55.47669982910156,
    lng: 10.330900192260742,
  },
  {
    id: "N",
    name: "Kruså-Padborg Airport",
    city: "Krusa-padborg",
    country: "Denmark",
    lat: 54.87030029296875,
    lng: 9.279009819030762,
  },
  {
    id: "RKE",
    name: "Copenhagen Roskilde Airport",
    city: "Copenhagen",
    country: "Denmark",
    lat: 55.585601806640625,
    lng: 12.131400108337402,
  },
  {
    id: "RNN",
    name: "Bornholm Airport",
    city: "Ronne",
    country: "Denmark",
    lat: 55.06330108642578,
    lng: 14.759599685668945,
  },
  {
    id: "SGD",
    name: "Sønderborg Airport",
    city: "Soenderborg",
    country: "Denmark",
    lat: 54.96440124511719,
    lng: 9.791729927062988,
  },
  {
    id: "SKS",
    name: "Skrydstrup Air Base",
    city: "Skrydstrup",
    country: "Denmark",
    lat: 55.221048,
    lng: 9.26702,
  },
  {
    id: "SQW",
    name: "Skive Airport",
    city: "Skive",
    country: "Denmark",
    lat: 56.550201416015625,
    lng: 9.172980308532715,
  },
  {
    id: "TED",
    name: "Thisted Airport",
    city: "Thisted",
    country: "Denmark",
    lat: 57.06880187988281,
    lng: 8.705220222473145,
  },
  {
    id: "N",
    name: "Kolding Vamdrup Airfield",
    city: "Kolding",
    country: "Denmark",
    lat: 55.436298,
    lng: 9.33092,
  },
  {
    id: "FAE",
    name: "Vagar Airport",
    city: "Vagar",
    country: "Faroe Islands",
    lat: 62.0635986328125,
    lng: -7.277219772338867,
  },
  {
    id: "N",
    name: "Vesthimmerlands Flyveplads",
    city: "Vesthimmerland",
    country: "Denmark",
    lat: 56.846901,
    lng: 9.45861,
  },
  {
    id: "STA",
    name: "Stauning Airport",
    city: "Stauning",
    country: "Denmark",
    lat: 55.9901008605957,
    lng: 8.353910446166992,
  },
  {
    id: "AAL",
    name: "Aalborg Airport",
    city: "Aalborg",
    country: "Denmark",
    lat: 57.0927589138,
    lng: 9.84924316406,
  },
  {
    id: "LUX",
    name: "Luxembourg-Findel International Airport",
    city: "Luxemburg",
    country: "Luxembourg",
    lat: 49.6233333,
    lng: 6.2044444,
  },
  {
    id: "AES",
    name: "Ålesund Airport",
    city: "Alesund",
    country: "Norway",
    lat: 62.5625,
    lng: 6.119699954986572,
  },
  {
    id: "ANX",
    name: "Andøya Airport",
    city: "Andoya",
    country: "Norway",
    lat: 69.292503356934,
    lng: 16.144199371338,
  },
  {
    id: "ALF",
    name: "Alta Airport",
    city: "Alta",
    country: "Norway",
    lat: 69.976097106934,
    lng: 23.371700286865,
  },
  {
    id: "N",
    name: "Bømoen Airport",
    city: "Voss",
    country: "Norway",
    lat: 60.63890075683594,
    lng: 6.501500129699707,
  },
  {
    id: "BNN",
    name: "Brønnøysund Airport",
    city: "Bronnoysund",
    country: "Norway",
    lat: 65.461097717285,
    lng: 12.217499732971,
  },
  {
    id: "BOO",
    name: "Bodø Airport",
    city: "Bodo",
    country: "Norway",
    lat: 67.26920318603516,
    lng: 14.365300178527832,
  },
  {
    id: "BGO",
    name: "Bergen Airport Flesland",
    city: "Bergen",
    country: "Norway",
    lat: 60.29339981,
    lng: 5.218140125,
  },
  {
    id: "BJF",
    name: "Båtsfjord Airport",
    city: "Batsfjord",
    country: "Norway",
    lat: 70.60050201416,
    lng: 29.691400527954,
  },
  {
    id: "KRS",
    name: "Kristiansand Airport",
    city: "Kristiansand",
    country: "Norway",
    lat: 58.204201,
    lng: 8.08537,
  },
  {
    id: "DLD",
    name: "Geilo Airport Dagali",
    city: "Geilo",
    country: "Norway",
    lat: 60.417301177978516,
    lng: 8.518349647521973,
  },
  {
    id: "BDU",
    name: "Bardufoss Airport",
    city: "Bardufoss",
    country: "Norway",
    lat: 69.055801391602,
    lng: 18.540399551392,
  },
  {
    id: "EVE",
    name: "Harstad/Narvik Airport, Evenes",
    city: "Harstad/Narvik",
    country: "Norway",
    lat: 68.491302490234,
    lng: 16.678100585938,
  },
  {
    id: "VDB",
    name: "Leirin Airport",
    city: "Fagernes",
    country: "Norway",
    lat: 61.015598297119,
    lng: 9.2880601882935,
  },
  {
    id: "FRO",
    name: "Florø Airport",
    city: "Floro",
    country: "Norway",
    lat: 61.583599090576,
    lng: 5.0247201919556,
  },
  {
    id: "OSL",
    name: "Oslo Lufthavn",
    city: "Oslo",
    country: "Norway",
    lat: 60.121,
    lng: 11.0502,
  },
  {
    id: "HAU",
    name: "Haugesund Airport",
    city: "Haugesund",
    country: "Norway",
    lat: 59.34529876709,
    lng: 5.2083601951599,
  },
  {
    id: "HAA",
    name: "Hasvik Airport",
    city: "Hasvik",
    country: "Norway",
    lat: 70.486701965332,
    lng: 22.139699935913,
  },
  {
    id: "KSU",
    name: "Kristiansund Airport (Kvernberget)",
    city: "Kristiansund",
    country: "Norway",
    lat: 63.111801147461,
    lng: 7.824520111084,
  },
  {
    id: "N",
    name: "Kjeller Airport",
    city: "Kjeller",
    country: "Norway",
    lat: 59.9692993164,
    lng: 11.036100387600001,
  },
  {
    id: "KKN",
    name: "Kirkenes Airport (Høybuktmoen)",
    city: "Kirkenes",
    country: "Norway",
    lat: 69.725799560547,
    lng: 29.891300201416,
  },
  {
    id: "FAN",
    name: "Lista Airport",
    city: "Farsund",
    country: "Norway",
    lat: 58.0994987487793,
    lng: 6.626049995422363,
  },
  {
    id: "MOL",
    name: "Molde Airport",
    city: "Molde",
    country: "Norway",
    lat: 62.744701385498,
    lng: 7.2624998092651,
  },
  {
    id: "MJF",
    name: "Mosjøen Airport (Kjærstad)",
    city: "Mosjoen",
    country: "Norway",
    lat: 65.783996582031,
    lng: 13.214900016785,
  },
  {
    id: "LKL",
    name: "Banak Airport",
    city: "Lakselv",
    country: "Norway",
    lat: 70.068801879883,
    lng: 24.973499298096,
  },
  {
    id: "NTB",
    name: "Notodden Airport",
    city: "Notodden",
    country: "Norway",
    lat: 59.565701,
    lng: 9.21222,
  },
  {
    id: "OLA",
    name: "Ørland Airport",
    city: "Orland",
    country: "Norway",
    lat: 63.69889831542969,
    lng: 9.604000091552734,
  },
  {
    id: "RRS",
    name: "Røros Airport",
    city: "Roros",
    country: "Norway",
    lat: 62.578399658203,
    lng: 11.342300415039,
  },
  {
    id: "RYG",
    name: "Moss Airport, Rygge",
    city: "Rygge",
    country: "Norway",
    lat: 59.378817,
    lng: 10.785439,
  },
  {
    id: "LYR",
    name: "Svalbard Airport, Longyear",
    city: "Svalbard",
    country: "Norway",
    lat: 78.246101379395,
    lng: 15.465600013733,
  },
  {
    id: "SKE",
    name: "Skien Airport",
    city: "Skien",
    country: "Norway",
    lat: 59.185001373291016,
    lng: 9.566940307617188,
  },
  {
    id: "SRP",
    name: "Stord Airport",
    city: "Stord",
    country: "Norway",
    lat: 59.791900634765625,
    lng: 5.340849876403809,
  },
  {
    id: "SSJ",
    name: "Sandnessjøen Airport (Stokka)",
    city: "Sandnessjoen",
    country: "Norway",
    lat: 65.956802368164,
    lng: 12.468899726868,
  },
  {
    id: "TOS",
    name: "Tromsø Airport,",
    city: "Tromso",
    country: "Norway",
    lat: 69.68329620361328,
    lng: 18.918899536132812,
  },
  {
    id: "TRF",
    name: "Sandefjord Airport, Torp",
    city: "Sandefjord",
    country: "Norway",
    lat: 59.1866989136,
    lng: 10.258600235,
  },
  {
    id: "TRD",
    name: "Trondheim Airport Værnes",
    city: "Trondheim",
    country: "Norway",
    lat: 63.4578018,
    lng: 10.9239998,
  },
  {
    id: "SVG",
    name: "Stavanger Airport Sola",
    city: "Stavanger",
    country: "Norway",
    lat: 58.876701354,
    lng: 5.6377801895,
  },
  {
    id: "N",
    name: "Babice Airport",
    city: "Warsaw",
    country: "Poland",
    lat: 52.26850128173828,
    lng: 20.910999298095703,
  },
  {
    id: "GDN",
    name: "Gdańsk Lech Wałęsa Airport",
    city: "Gdansk",
    country: "Poland",
    lat: 54.377601623535156,
    lng: 18.46619987487793,
  },
  {
    id: "KRK",
    name: "Kraków John Paul II International Airport",
    city: "Krakow",
    country: "Poland",
    lat: 50.077702,
    lng: 19.7848,
  },
  {
    id: "N",
    name: "Muchowiec Airport",
    city: "Katowice",
    country: "Poland",
    lat: 50.23809814453125,
    lng: 19.03420066833496,
  },
  {
    id: "KTW",
    name: "Katowice International Airport",
    city: "Katowice",
    country: "Poland",
    lat: 50.4743,
    lng: 19.08,
  },
  {
    id: "N",
    name: "Mielec Airport",
    city: "Mielec",
    country: "Poland",
    lat: 50.32229995727539,
    lng: 21.462099075317383,
  },
  {
    id: "POZ",
    name: "Poznań-Ławica Airport",
    city: "Poznan",
    country: "Poland",
    lat: 52.421001434299995,
    lng: 16.8262996674,
  },
  {
    id: "RZE",
    name: "Rzeszów-Jasionka Airport",
    city: "Rzeszow",
    country: "Poland",
    lat: 50.1100006104,
    lng: 22.0189990997,
  },
  {
    id: "SZZ",
    name: 'Szczecin-Goleniów "Solidarność" Airport',
    city: "Szczecin",
    country: "Poland",
    lat: 53.584701538100006,
    lng: 14.902199745199999,
  },
  {
    id: "OSP",
    name: "Redzikowo Air Base",
    city: "Slupsk",
    country: "Poland",
    lat: 54.47890090942383,
    lng: 17.107500076293945,
  },
  {
    id: "N",
    name: "Swidwin Military Air Base",
    city: "Shapaja",
    country: "Poland",
    lat: 53.790599823,
    lng: 15.826299667399999,
  },
  {
    id: "WAW",
    name: "Warsaw Chopin Airport",
    city: "Warsaw",
    country: "Poland",
    lat: 52.1656990051,
    lng: 20.967100143399996,
  },
  {
    id: "WRO",
    name: "Copernicus Wrocław Airport",
    city: "Wroclaw",
    country: "Poland",
    lat: 51.1026992798,
    lng: 16.885799408,
  },
  {
    id: "IEG",
    name: "Zielona Góra-Babimost Airport",
    city: "Zielona Gora",
    country: "Poland",
    lat: 52.138500213600004,
    lng: 15.7986001968,
  },
  {
    id: "N",
    name: "Malmen Air Base",
    city: "Linkoeping",
    country: "Sweden",
    lat: 58.40230178833008,
    lng: 15.525699615478516,
  },
  {
    id: "N",
    name: "Bråvalla Air Base",
    city: "Norrkoeping",
    country: "Sweden",
    lat: 58.61090087890625,
    lng: 16.103599548339844,
  },
  {
    id: "N",
    name: "Uppsala Airport",
    city: "Uppsala",
    country: "Sweden",
    lat: 59.897300720214844,
    lng: 17.588600158691406,
  },
  {
    id: "RNB",
    name: "Ronneby Airport",
    city: "Ronneby",
    country: "Sweden",
    lat: 56.266700744629,
    lng: 15.265000343323,
  },
  {
    id: "N",
    name: "Råda Air Base",
    city: "Rada",
    country: "Sweden",
    lat: 58.49810028076172,
    lng: 13.053199768066406,
  },
  {
    id: "GOT",
    name: "Gothenburg-Landvetter Airport",
    city: "Gothenborg",
    country: "Sweden",
    lat: 57.662799835205,
    lng: 12.279800415039,
  },
  {
    id: "JKG",
    name: "Jönköping Airport",
    city: "Joenkoeping",
    country: "Sweden",
    lat: 57.757598876953125,
    lng: 14.068699836730957,
  },
  {
    id: "N",
    name: "Falköping Airport",
    city: "Falkoping",
    country: "Sweden",
    lat: 58.1697998046875,
    lng: 13.587800025939941,
  },
  {
    id: "LDK",
    name: "Lidköping-Hovby Airport",
    city: "Lidkoping",
    country: "Sweden",
    lat: 58.4655,
    lng: 13.1744,
  },
  {
    id: "GSE",
    name: "Gothenburg City Airport",
    city: "Gothenborg",
    country: "Sweden",
    lat: 57.7747,
    lng: 11.8704,
  },
  {
    id: "KVB",
    name: "Skövde Airport",
    city: "Skovde",
    country: "Sweden",
    lat: 58.45640182495117,
    lng: 13.972700119018555,
  },
  {
    id: "THN",
    name: "Trollhättan-Vänersborg Airport",
    city: "Trollhattan",
    country: "Sweden",
    lat: 58.31809997558594,
    lng: 12.345000267028809,
  },
  {
    id: "N",
    name: "Karlsborg Air Base",
    city: "Karlsborg",
    country: "Sweden",
    lat: 58.51380157470703,
    lng: 14.507100105285645,
  },
  {
    id: "N",
    name: "Såtenäs Air Base",
    city: "Satenas",
    country: "Sweden",
    lat: 58.42639923095703,
    lng: 12.714400291442871,
  },
  {
    id: "N",
    name: "Barkarby Airport",
    city: "Stockholm",
    country: "Sweden",
    lat: 59.4144743644,
    lng: 17.8821372986,
  },
  {
    id: "KSK",
    name: "Karlskoga Airport",
    city: "Karlskoga",
    country: "Sweden",
    lat: 59.34590148925781,
    lng: 14.49590015411377,
  },
  {
    id: "MXX",
    name: "Mora Airport",
    city: "Mora",
    country: "Sweden",
    lat: 60.957901,
    lng: 14.5114,
  },
  {
    id: "NYO",
    name: "Stockholm Skavsta Airport",
    city: "Stockholm",
    country: "Sweden",
    lat: 58.78860092163086,
    lng: 16.912200927734375,
  },
  {
    id: "N",
    name: "Arvika Airport",
    city: "Arvika",
    country: "Sweden",
    lat: 59.6759,
    lng: 12.6394,
  },
  {
    id: "N",
    name: "Emmaboda Airfield",
    city: "Emmaboda",
    country: "Sweden",
    lat: 56.610802,
    lng: 15.6048,
  },
  {
    id: "N",
    name: "Feringe Airport",
    city: "Ljungby",
    country: "Sweden",
    lat: 56.9502983093,
    lng: 13.921699523900001,
  },
  {
    id: "KID",
    name: "Kristianstad Airport",
    city: "Kristianstad",
    country: "Sweden",
    lat: 55.92169952392578,
    lng: 14.08549976348877,
  },
  {
    id: "N",
    name: "Landskrona Airport",
    city: "Landskrona",
    country: "Sweden",
    lat: 55.94599914550781,
    lng: 12.869999885559082,
  },
  {
    id: "OSK",
    name: "Oskarshamn Airport",
    city: "Oskarshamn",
    country: "Sweden",
    lat: 57.350498,
    lng: 16.497999,
  },
  {
    id: "N",
    name: "Anderstorp Airport",
    city: "Anderstorp",
    country: "Sweden",
    lat: 57.264198303222656,
    lng: 13.59939956665039,
  },
  {
    id: "KLR",
    name: "Kalmar Airport",
    city: "Kalkmar",
    country: "Sweden",
    lat: 56.68550109863281,
    lng: 16.287599563598633,
  },
  {
    id: "MMX",
    name: "Malmö Sturup Airport",
    city: "Malmoe",
    country: "Sweden",
    lat: 55.536305364,
    lng: 13.376197814900001,
  },
  {
    id: "HAD",
    name: "Halmstad Airport",
    city: "Halmstad",
    country: "Sweden",
    lat: 56.69110107421875,
    lng: 12.820199966430664,
  },
  {
    id: "N",
    name: "Hagshult Air Base",
    city: "Hagshult",
    country: "Sweden",
    lat: 57.292198,
    lng: 14.1372,
  },
  {
    id: "VXO",
    name: "Växjö Kronoberg Airport",
    city: "Vaxjo",
    country: "Sweden",
    lat: 56.929100036621094,
    lng: 14.727999687194824,
  },
  {
    id: "N",
    name: "Hallviken Airport",
    city: "Hallviken",
    country: "Sweden",
    lat: 63.73830032348633,
    lng: 15.45829963684082,
  },
  {
    id: "N",
    name: "Hedlanda Airport",
    city: "Hede",
    country: "Sweden",
    lat: 62.40890121459999,
    lng: 13.747200012199999,
  },
  {
    id: "EVG",
    name: "Sveg Airport",
    city: "Sveg",
    country: "Sweden",
    lat: 62.04779815673828,
    lng: 14.422900199890137,
  },
  {
    id: "GEV",
    name: "Gällivare Airport",
    city: "Gallivare",
    country: "Sweden",
    lat: 67.13240051269531,
    lng: 20.814599990844727,
  },
  {
    id: "HUV",
    name: "Hudiksvall Airport",
    city: "Hudiksvall",
    country: "Sweden",
    lat: 61.7681007385,
    lng: 17.0806999207,
  },
  {
    id: "N",
    name: "Jokkmokk Airport",
    city: "Jokkmokk",
    country: "Sweden",
    lat: 66.49620056152344,
    lng: 20.147199630737305,
  },
  {
    id: "KRF",
    name: "Kramfors Sollefteå Airport",
    city: "Kramfors",
    country: "Sweden",
    lat: 63.04859924316406,
    lng: 17.76889991760254,
  },
  {
    id: "LYC",
    name: "Lycksele Airport",
    city: "Lycksele",
    country: "Sweden",
    lat: 64.54830169677734,
    lng: 18.71619987487793,
  },
  {
    id: "N",
    name: "Optand Airport",
    city: "Optand",
    country: "Sweden",
    lat: 63.12860107421875,
    lng: 14.802800178527832,
  },
  {
    id: "SDL",
    name: "Sundsvall-Härnösand Airport",
    city: "Sundsvall",
    country: "Sweden",
    lat: 62.528099060058594,
    lng: 17.443899154663086,
  },
  {
    id: "OER",
    name: "Örnsköldsvik Airport",
    city: "Ornskoldsvik",
    country: "Sweden",
    lat: 63.40829849243164,
    lng: 18.989999771118164,
  },
  {
    id: "N",
    name: "Piteå Airport",
    city: "Pitea",
    country: "Sweden",
    lat: 65.39830017089844,
    lng: 21.260799407958984,
  },
  {
    id: "KRN",
    name: "Kiruna Airport",
    city: "Kiruna",
    country: "Sweden",
    lat: 67.821998596191,
    lng: 20.336799621582,
  },
  {
    id: "N",
    name: "Orsa Airport",
    city: "Orsa",
    country: "Sweden",
    lat: 61.189998626708984,
    lng: 14.712599754333496,
  },
  {
    id: "SFT",
    name: "Skellefteå Airport",
    city: "Skelleftea",
    country: "Sweden",
    lat: 64.62480163574219,
    lng: 21.076900482177734,
  },
  {
    id: "N",
    name: "Sättna Airport",
    city: "Sattna",
    country: "Sweden",
    lat: 62.4814,
    lng: 17.002899,
  },
  {
    id: "UME",
    name: "Umeå Airport",
    city: "Umea",
    country: "Sweden",
    lat: 63.791801452637,
    lng: 20.282800674438,
  },
  {
    id: "VHM",
    name: "Vilhelmina Airport",
    city: "Vilhelmina",
    country: "Sweden",
    lat: 64.5791015625,
    lng: 16.833599090576172,
  },
  {
    id: "AJR",
    name: "Arvidsjaur Airport",
    city: "Arvidsjaur",
    country: "Sweden",
    lat: 65.59030151367188,
    lng: 19.28190040588379,
  },
  {
    id: "ORB",
    name: "Örebro Airport",
    city: "Orebro",
    country: "Sweden",
    lat: 59.22370147705078,
    lng: 15.038000106811523,
  },
  {
    id: "VST",
    name: "Stockholm Västerås Airport",
    city: "Vasteras",
    country: "Sweden",
    lat: 59.58940124511719,
    lng: 16.63360023498535,
  },
  {
    id: "LLA",
    name: "Luleå Airport",
    city: "Lulea",
    country: "Sweden",
    lat: 65.543800354004,
    lng: 22.121999740601,
  },
  {
    id: "N",
    name: "Vidsel Air Base",
    city: "Vidsel",
    country: "Sweden",
    lat: 65.87529754638672,
    lng: 20.149900436401367,
  },
  {
    id: "N",
    name: "Arboga Airport",
    city: "Arboga",
    country: "Sweden",
    lat: 59.386600494384766,
    lng: 15.924099922180176,
  },
  {
    id: "ARN",
    name: "Stockholm-Arlanda Airport",
    city: "Stockholm",
    country: "Sweden",
    lat: 59.651901245117,
    lng: 17.918600082397,
  },
  {
    id: "BMA",
    name: "Stockholm-Bromma Airport",
    city: "Stockholm",
    country: "Sweden",
    lat: 59.354400634765625,
    lng: 17.941699981689453,
  },
  {
    id: "BLE",
    name: "Borlange Airport",
    city: "Borlange",
    country: "Sweden",
    lat: 60.422000885009766,
    lng: 15.515199661254883,
  },
  {
    id: "HLF",
    name: "Hultsfred Airport",
    city: "Hultsfred",
    country: "Sweden",
    lat: 57.525799,
    lng: 15.8233,
  },
  {
    id: "GVX",
    name: "Gävle Sandviken Airport",
    city: "Gavle",
    country: "Sweden",
    lat: 60.593299865722656,
    lng: 16.951400756835938,
  },
  {
    id: "LPI",
    name: "Linköping City Airport",
    city: "Linkoeping",
    country: "Sweden",
    lat: 58.4062004089,
    lng: 15.680500030500001,
  },
  {
    id: "NRK",
    name: "Norrköping Airport",
    city: "Norrkoeping",
    country: "Sweden",
    lat: 58.586299896240234,
    lng: 16.250600814819336,
  },
  {
    id: "EKT",
    name: "Eskilstuna Airport",
    city: "Eskilstuna",
    country: "Sweden",
    lat: 59.35110092163086,
    lng: 16.70840072631836,
  },
  {
    id: "VBY",
    name: "Visby Airport",
    city: "Visby",
    country: "Sweden",
    lat: 57.662799835205,
    lng: 18.346200942993,
  },
  {
    id: "N",
    name: "Kalixfors Airport",
    city: "Kalixfors",
    country: "Sweden",
    lat: 67.76480102539062,
    lng: 20.257200241088867,
  },
  {
    id: "SPM",
    name: "Spangdahlem Air Base",
    city: "Spangdahlem",
    country: "Germany",
    lat: 49.9726982117,
    lng: 6.69250011444,
  },
  {
    id: "RMS",
    name: "Ramstein Air Base",
    city: "Ramstein",
    country: "Germany",
    lat: 49.4369010925293,
    lng: 7.600279808044434,
  },
  {
    id: "GHF",
    name: "[Duplicate] Giebelstadt Army Air Field",
    city: "Giebelstadt",
    country: "Germany",
    lat: 49.648101806599996,
    lng: 9.966489791870002,
  },
  {
    id: "N",
    name: "Bückeburg Air Base",
    city: "Brueckeburg",
    country: "Germany",
    lat: 52.2785,
    lng: 9.08217,
  },
  {
    id: "ZCN",
    name: "Celle Airport",
    city: "Celle",
    country: "Germany",
    lat: 52.59120178222656,
    lng: 10.022100448608398,
  },
  {
    id: "N",
    name: "Rheine Bentlage Air Base",
    city: "Rheine-brentlange",
    country: "Germany",
    lat: 52.291199,
    lng: 7.387,
  },
  {
    id: "FRZ",
    name: "Fritzlar Airport",
    city: "Fritzlar",
    country: "Germany",
    lat: 51.1146,
    lng: 9.286,
  },
  {
    id: "N",
    name: "Laupheim Air Base",
    city: "Laupheim",
    country: "Germany",
    lat: 48.220299,
    lng: 9.91002,
  },
  {
    id: "N",
    name: "Mendig Airfield",
    city: "Mendig",
    country: "Germany",
    lat: 50.366001,
    lng: 7.31533,
  },
  {
    id: "N",
    name: "Niederstetten Army Air Base",
    city: "Niederstetten",
    country: "Germany",
    lat: 49.391945,
    lng: 9.958889,
  },
  {
    id: "N",
    name: "Roth Airport",
    city: "Roth",
    country: "Germany",
    lat: 49.217498779296875,
    lng: 11.100199699401855,
  },
  {
    id: "N",
    name: "Fassberg Air Base",
    city: "Fassberg",
    country: "Germany",
    lat: 52.919399,
    lng: 10.185827,
  },
  {
    id: "N",
    name: "Grafenwohr Army Air Field",
    city: "Grafenwoehr",
    country: "Germany",
    lat: 49.698699951171875,
    lng: 11.940199851989746,
  },
  {
    id: "ZNF",
    name: "Hanau Army Air Field",
    city: "Hanau",
    country: "Germany",
    lat: 50.169201,
    lng: 8.96159,
  },
  {
    id: "N",
    name: "Hohenfels Army Air Field",
    city: "Hohenfels",
    country: "Germany",
    lat: 49.218101501464844,
    lng: 11.836099624633789,
  },
  {
    id: "KZG",
    name: "Flugplatz Kitzingen",
    city: "Kitzingen",
    country: "Germany",
    lat: 49.743099,
    lng: 10.2006,
  },
  {
    id: "FCN",
    name: "Nordholz Naval Airbase",
    city: "Nordholz",
    country: "Germany",
    lat: 53.7677001953,
    lng: 8.658499717709999,
  },
  {
    id: "N",
    name: "Diepholz Air Base",
    city: "Diepholz",
    country: "Germany",
    lat: 52.585556,
    lng: 8.342222,
  },
  {
    id: "GKE",
    name: "Geilenkirchen Air Base",
    city: "Geilenkirchen",
    country: "Germany",
    lat: 50.9608,
    lng: 6.04242,
  },
  {
    id: "N",
    name: "Hohn Air Base",
    city: "Hohn",
    country: "Germany",
    lat: 54.312199,
    lng: 9.53817,
  },
  {
    id: "N",
    name: "Jever Air Base",
    city: "Jever",
    country: "Germany",
    lat: 53.533501,
    lng: 7.88867,
  },
  {
    id: "RLG",
    name: "Rostock-Laage Airport",
    city: "Laage",
    country: "Germany",
    lat: 53.9182014465,
    lng: 12.278300285299999,
  },
  {
    id: "N",
    name: "Nörvenich Air Base",
    city: "Noervenich",
    country: "Germany",
    lat: 50.8312,
    lng: 6.65817,
  },
  {
    id: "WBG",
    name: "Schleswig Air Base",
    city: "Schleswig",
    country: "Germany",
    lat: 54.459301,
    lng: 9.51633,
  },
  {
    id: "N",
    name: "Wittmundhafen Airport",
    city: "Wittmundhafen",
    country: "Germany",
    lat: 53.54779815673828,
    lng: 7.667329788208008,
  },
  {
    id: "N",
    name: "Wunstorf Air Base",
    city: "Wunstorf",
    country: "Germany",
    lat: 52.457298,
    lng: 9.42717,
  },
  {
    id: "N",
    name: "Vilseck Army Air Field",
    city: "Vilseck",
    country: "Germany",
    lat: 49.63359832763672,
    lng: 11.767200469970703,
  },
  {
    id: "N",
    name: "Coleman Army Air Field",
    city: "Coleman",
    country: "Germany",
    lat: 49.5635986328125,
    lng: 8.463390350341797,
  },
  {
    id: "WIE",
    name: "Wiesbaden Army Airfield",
    city: "Wiesbaden",
    country: "Germany",
    lat: 50.049800872802734,
    lng: 8.325400352478027,
  },
  {
    id: "N",
    name: "Landsberg Lech Air Base",
    city: "Landsberg",
    country: "Germany",
    lat: 48.070599,
    lng: 10.906,
  },
  {
    id: "N",
    name: "Büchel Air Base",
    city: "Buechel",
    country: "Germany",
    lat: 50.1738014221,
    lng: 7.06333017349,
  },
  {
    id: "N",
    name: "Erding Airport",
    city: "Erding",
    country: "Germany",
    lat: 48.32229995727539,
    lng: 11.948699951171875,
  },
  {
    id: "FEL",
    name: "Fürstenfeldbruck Air Base",
    city: "Fuerstenfeldbruck",
    country: "Germany",
    lat: 48.205555,
    lng: 11.266944,
  },
  {
    id: "N",
    name: "Holzdorf Air Base",
    city: "Holzdorf",
    country: "Germany",
    lat: 51.767799,
    lng: 13.1677,
  },
  {
    id: "IGS",
    name: "Ingolstadt Manching Airport",
    city: "Ingolstadt",
    country: "Germany",
    lat: 48.7156982421875,
    lng: 11.534000396728516,
  },
  {
    id: "N",
    name: "Lechfeld Air Base",
    city: "Lechfeld",
    country: "Germany",
    lat: 48.185504,
    lng: 10.8612,
  },
  {
    id: "N",
    name: "Neuburg AFB",
    city: "Neuburg",
    country: "Germany",
    lat: 48.710999,
    lng: 11.2115,
  },
  {
    id: "GUT",
    name: "Gütersloh Air Base",
    city: "Guetersloh",
    country: "Germany",
    lat: 51.922798,
    lng: 8.30633,
  },
  {
    id: "ALJ",
    name: "Alexander Bay Airport",
    city: "Alexander Bay",
    country: "South Africa",
    lat: -28.575001,
    lng: 16.5333,
  },
  {
    id: "AGZ",
    name: "Aggeneys Airport",
    city: "Aggeneys",
    country: "South Africa",
    lat: -29.28179931640625,
    lng: 18.813899993896484,
  },
  {
    id: "N",
    name: "Brakpan Airport",
    city: "Brakpan",
    country: "South Africa",
    lat: -26.23859977722168,
    lng: 28.301799774169922,
  },
  {
    id: "BIY",
    name: "Bisho Airport",
    city: "Bisho",
    country: "South Africa",
    lat: -32.8970985413,
    lng: 27.279100418099997,
  },
  {
    id: "BFN",
    name: "Bram Fischer International Airport",
    city: "Bloemfontein",
    country: "South Africa",
    lat: -29.092699050900002,
    lng: 26.302400589,
  },
  {
    id: "N",
    name: "Bethlehem Airport",
    city: "Bethlehem",
    country: "South Africa",
    lat: -28.2483997345,
    lng: 28.3360996246,
  },
  {
    id: "N",
    name: "Hendrik Potgieter Airport",
    city: "Bothaville",
    country: "South Africa",
    lat: -27.36680030822754,
    lng: 26.629199981689453,
  },
  {
    id: "CPT",
    name: "Cape Town International Airport",
    city: "Cape Town",
    country: "South Africa",
    lat: -33.9648017883,
    lng: 18.6016998291,
  },
  {
    id: "N",
    name: "Calvinia Airport",
    city: "Calvinia",
    country: "South Africa",
    lat: -31.50029945373535,
    lng: 19.725900650024414,
  },
  {
    id: "DUR",
    name: "King Shaka International Airport",
    city: "Durban",
    country: "South Africa",
    lat: -29.6144444444,
    lng: 31.1197222222,
  },
  {
    id: "ELS",
    name: "Ben Schoeman Airport",
    city: "East London",
    country: "South Africa",
    lat: -33.0355987549,
    lng: 27.825899124099998,
  },
  {
    id: "N",
    name: "Ermelo Airport",
    city: "Ermelo",
    country: "South Africa",
    lat: -26.4955997467041,
    lng: 29.979799270629883,
  },
  {
    id: "FCB",
    name: "Ficksburg Sentraoes Airport",
    city: "Ficksburg",
    country: "South Africa",
    lat: -28.82309913635254,
    lng: 27.908899307250977,
  },
  {
    id: "GCJ",
    name: "Grand Central Airport",
    city: "Johannesburg",
    country: "South Africa",
    lat: -25.986299514799995,
    lng: 28.1401004791,
  },
  {
    id: "GRJ",
    name: "George Airport",
    city: "George",
    country: "South Africa",
    lat: -34.0056,
    lng: 22.378902,
  },
  {
    id: "N",
    name: "Graaff Reinet Airport",
    city: "Graaff Reinet",
    country: "South Africa",
    lat: -32.193599700927734,
    lng: 24.541400909423828,
  },
  {
    id: "N",
    name: "Grahamstown Airport",
    city: "Grahamstown",
    country: "South Africa",
    lat: -33.284698486328125,
    lng: 26.49810028076172,
  },
  {
    id: "N",
    name: "Greytown Airport",
    city: "Greytown",
    country: "South Africa",
    lat: -29.1219997406,
    lng: 30.586700439499996,
  },
  {
    id: "N",
    name: "Harmony Airport",
    city: "Harmony",
    country: "South Africa",
    lat: -28.078699111938477,
    lng: 26.8612003326416,
  },
  {
    id: "HRS",
    name: "Harrismith Airport",
    city: "Harrismith",
    country: "South Africa",
    lat: -28.23509979248047,
    lng: 29.106199264526367,
  },
  {
    id: "HDS",
    name: "Hoedspruit Air Force Base Airport",
    city: "Hoedspruit",
    country: "South Africa",
    lat: -24.368600845299998,
    lng: 31.0487003326,
  },
  {
    id: "N",
    name: "Gariep Dam Airport",
    city: "Hendrik Verwoerddam",
    country: "South Africa",
    lat: -30.56220054626465,
    lng: 25.52829933166504,
  },
  {
    id: "JNB",
    name: "OR Tambo International Airport",
    city: "Johannesburg",
    country: "South Africa",
    lat: -26.1392,
    lng: 28.246,
  },
  {
    id: "KXE",
    name: "P C Pelser Airport",
    city: "Klerksdorp",
    country: "South Africa",
    lat: -26.8710994720459,
    lng: 26.718000411987305,
  },
  {
    id: "KIM",
    name: "Kimberley Airport",
    city: "Kimberley",
    country: "South Africa",
    lat: -28.802799224900003,
    lng: 24.7651996613,
  },
  {
    id: "N",
    name: "Krugersdorp Airport",
    city: "Krugersdorp",
    country: "South Africa",
    lat: -26.0808259199,
    lng: 27.7259149551,
  },
  {
    id: "N",
    name: "Kroonstad Airport",
    city: "Kroonstad",
    country: "South Africa",
    lat: -27.660600662231445,
    lng: 27.315799713134766,
  },
  {
    id: "KMH",
    name: "Johan Pienaar Airport",
    city: "Kuruman",
    country: "South Africa",
    lat: -27.45669937133789,
    lng: 23.411399841308594,
  },
  {
    id: "KLZ",
    name: "Kleinsee Airport",
    city: "Kleinsee",
    country: "South Africa",
    lat: -29.6884002686,
    lng: 17.093999862700002,
  },
  {
    id: "HLA",
    name: "Lanseria Airport",
    city: "Johannesburg",
    country: "South Africa",
    lat: -25.938499450699997,
    lng: 27.9260997772,
  },
  {
    id: "N",
    name: "Lichtenburg Airport",
    city: "Lichtenburg",
    country: "South Africa",
    lat: -26.17569923400879,
    lng: 26.184600830078125,
  },
  {
    id: "N",
    name: "Makhado Air Force Base Airport",
    city: "Lambertsbaai",
    country: "South Africa",
    lat: -23.159900665283203,
    lng: 29.696500778198242,
  },
  {
    id: "SDB",
    name: "Langebaanweg Airport",
    city: "Langebaanweg",
    country: "South Africa",
    lat: -32.968898773199996,
    lng: 18.1602993011,
  },
  {
    id: "LAY",
    name: "Ladysmith Airport",
    city: "Ladysmith",
    country: "South Africa",
    lat: -28.5816993713,
    lng: 29.749700546299998,
  },
  {
    id: "N",
    name: "Middelburg Airport",
    city: "Middelburg",
    country: "South Africa",
    lat: -25.684799194335938,
    lng: 29.440200805664062,
  },
  {
    id: "MGH",
    name: "Margate Airport",
    city: "Margate",
    country: "South Africa",
    lat: -30.8574008942,
    lng: 30.343000412,
  },
  {
    id: "N",
    name: "Marble Hall Airport",
    city: "Marble Hall",
    country: "South Africa",
    lat: -24.989099502563477,
    lng: 29.283100128173828,
  },
  {
    id: "N",
    name: "Majuba Power Station Airport",
    city: "Majuba Power Station",
    country: "South Africa",
    lat: -27.079299926799997,
    lng: 29.7784996033,
  },
  {
    id: "LLE",
    name: "Riverside Airport",
    city: "Malalane",
    country: "South Africa",
    lat: -25.4300003052,
    lng: 31.5767002106,
  },
  {
    id: "N",
    name: "Morningside Farm Airport",
    city: "Musina",
    country: "South Africa",
    lat: -25.7045001984,
    lng: 26.9090003967,
  },
  {
    id: "MZQ",
    name: "Mkuze Airport",
    city: "Mkuze",
    country: "South Africa",
    lat: -27.626100540161133,
    lng: 32.0443000793457,
  },
  {
    id: "NCS",
    name: "Newcastle Airport",
    city: "Newcastle",
    country: "South Africa",
    lat: -27.7705993652,
    lng: 29.976900100699996,
  },
  {
    id: "N",
    name: "Nylstroom Airfield",
    city: "Nylstroom",
    country: "South Africa",
    lat: -24.686100006103516,
    lng: 28.434900283813477,
  },
  {
    id: "OVG",
    name: "Overberg Airport",
    city: "Overberg",
    country: "South Africa",
    lat: -34.554901123,
    lng: 20.250699996900003,
  },
  {
    id: "OUH",
    name: "Oudtshoorn Airport",
    city: "Oudtshoorn",
    country: "South Africa",
    lat: -33.6069984436,
    lng: 22.188999176,
  },
  {
    id: "PLZ",
    name: "Port Elizabeth Airport",
    city: "Port Elizabeth",
    country: "South Africa",
    lat: -33.9849014282,
    lng: 25.6173000336,
  },
  {
    id: "PBZ",
    name: "Plettenberg Bay Airport",
    city: "Plettenberg Bay",
    country: "South Africa",
    lat: -34.0881601675,
    lng: 23.3287234306,
  },
  {
    id: "PHW",
    name: "Hendrik Van Eck Airport",
    city: "Phalaborwa",
    country: "South Africa",
    lat: -23.937200546299998,
    lng: 31.1553993225,
  },
  {
    id: "N",
    name: "Pietersburg Municipal Airport",
    city: "Polokwane",
    country: "South Africa",
    lat: -23.9260997772,
    lng: 29.4843997955,
  },
  {
    id: "JOH",
    name: "Port St Johns Airport",
    city: "Port Saint Johns",
    country: "South Africa",
    lat: -31.605899810791016,
    lng: 29.519800186157227,
  },
  {
    id: "PZB",
    name: "Pietermaritzburg Airport",
    city: "Pietermaritzburg",
    country: "South Africa",
    lat: -29.649000167799997,
    lng: 30.3987007141,
  },
  {
    id: "NTY",
    name: "Pilanesberg International Airport",
    city: "Pilanesberg",
    country: "South Africa",
    lat: -25.333799362199997,
    lng: 27.173400878900004,
  },
  {
    id: "PTG",
    name: "Polokwane International Airport",
    city: "Potgietersrus",
    country: "South Africa",
    lat: -23.845269,
    lng: 29.458615,
  },
  {
    id: "PCF",
    name: "Potchefstroom Airport",
    city: "Potchefstroom",
    country: "South Africa",
    lat: -26.670999527,
    lng: 27.0818996429,
  },
  {
    id: "N",
    name: "Parys Airport",
    city: "Parys",
    country: "South Africa",
    lat: -26.889299392700195,
    lng: 27.503400802612305,
  },
  {
    id: "UTW",
    name: "Queenstown Airport",
    city: "Queenstown",
    country: "South Africa",
    lat: -31.92020034790039,
    lng: 26.882200241088867,
  },
  {
    id: "RCB",
    name: "Richards Bay Airport",
    city: "Richard's Bay",
    country: "South Africa",
    lat: -28.740999221800003,
    lng: 32.0920982361,
  },
  {
    id: "N",
    name: "Rustenburg Airport",
    city: "Rustenburg",
    country: "South Africa",
    lat: -25.6443004608,
    lng: 27.271099090599996,
  },
  {
    id: "ROD",
    name: "Robertson Airport",
    city: "Robertson",
    country: "South Africa",
    lat: -33.812198638916016,
    lng: 19.902799606323242,
  },
  {
    id: "SBU",
    name: "Springbok Airport",
    city: "Springbok",
    country: "South Africa",
    lat: -29.689300537109375,
    lng: 17.939599990844727,
  },
  {
    id: "ZEC",
    name: "Secunda Airport",
    city: "Secunda",
    country: "South Africa",
    lat: -26.52409935,
    lng: 29.170099258399997,
  },
  {
    id: "N",
    name: "Saldanha /Vredenburg Airport",
    city: "Saldanha",
    country: "South Africa",
    lat: -32.964099884,
    lng: 17.9692993164,
  },
  {
    id: "N",
    name: "Springs Airfield",
    city: "Springs",
    country: "South Africa",
    lat: -26.2494004736,
    lng: 28.3982715607,
  },
  {
    id: "N",
    name: "Swartkop Air Force Base",
    city: "Swartkop",
    country: "South Africa",
    lat: -25.8097000122,
    lng: 28.164600372299997,
  },
  {
    id: "SIS",
    name: "Sishen Airport",
    city: "Sishen",
    country: "South Africa",
    lat: -27.6485996246,
    lng: 22.9993000031,
  },
  {
    id: "N",
    name: "Hendrik Swellengrebel Airport",
    city: "Swellendam",
    country: "South Africa",
    lat: -34.04819869995117,
    lng: 20.474599838256836,
  },
  {
    id: "SZK",
    name: "Skukuza Airport",
    city: "Skukuza",
    country: "South Africa",
    lat: -24.960899353,
    lng: 31.5886993408,
  },
  {
    id: "N",
    name: "Tommys Field Airport",
    city: "Tommy's Field",
    country: "South Africa",
    lat: -28.260000228881836,
    lng: 22.993200302124023,
  },
  {
    id: "N",
    name: "New Tempe Airport",
    city: "Bloemfontein",
    country: "South Africa",
    lat: -29.032899856567383,
    lng: 26.15760040283203,
  },
  {
    id: "N",
    name: "Tutuka Power Station Airport",
    city: "Tutuka",
    country: "South Africa",
    lat: -26.776599884,
    lng: 29.3388004303,
  },
  {
    id: "LTA",
    name: "Tzaneen Airport",
    city: "Tzaneen",
    country: "South Africa",
    lat: -23.8243999481,
    lng: 30.329299926799997,
  },
  {
    id: "ULD",
    name: "Prince Mangosuthu Buthelezi Airport",
    city: "Ulundi",
    country: "South Africa",
    lat: -28.3206005096,
    lng: 31.4165000916,
  },
  {
    id: "UTN",
    name: "Pierre Van Ryneveld Airport",
    city: "Upington",
    country: "South Africa",
    lat: -28.39909935,
    lng: 21.260200500499998,
  },
  {
    id: "UTT",
    name: "K. D. Matanzima Airport",
    city: "Umtata",
    country: "South Africa",
    lat: -31.546363184900002,
    lng: 28.6733551025,
  },
  {
    id: "VRU",
    name: "Vryburg Airport",
    city: "Vryburg",
    country: "South Africa",
    lat: -26.9824008942,
    lng: 24.7287998199,
  },
  {
    id: "VIR",
    name: "Virginia Airport",
    city: "Durban",
    country: "South Africa",
    lat: -29.770599365234375,
    lng: 31.058399200439453,
  },
  {
    id: "VRE",
    name: "Vredendal Airport",
    city: "Vredendal",
    country: "South Africa",
    lat: -31.641000747680664,
    lng: 18.5447998046875,
  },
  {
    id: "N",
    name: "Vereeniging Airport",
    city: "Vereeniging",
    country: "South Africa",
    lat: -26.566400528,
    lng: 27.9608001709,
  },
  {
    id: "PRY",
    name: "Wonderboom Airport",
    city: "Pretoria",
    country: "South Africa",
    lat: -25.6539,
    lng: 28.224199,
  },
  {
    id: "N",
    name: "Witbank Airport",
    city: "Witbank",
    country: "South Africa",
    lat: -25.832300186199998,
    lng: 29.1919994354,
  },
  {
    id: "WKF",
    name: "Waterkloof Air Force Base",
    city: "Waterkloof",
    country: "South Africa",
    lat: -25.829999923699997,
    lng: 28.222499847399998,
  },
  {
    id: "N",
    name: "Welkom Airport",
    city: "Welkom",
    country: "South Africa",
    lat: -27.996824511099998,
    lng: 26.663333892799997,
  },
  {
    id: "N",
    name: "Ysterplaat Air Force Base",
    city: "Ysterplaat",
    country: "South Africa",
    lat: -33.90019989013672,
    lng: 18.498300552368164,
  },
  {
    id: "N",
    name: "Zeerust Airport",
    city: "Zeerust",
    country: "South Africa",
    lat: -25.599000930786133,
    lng: 26.042299270629883,
  },
  {
    id: "FRW",
    name: "Francistown Airport",
    city: "Francistown",
    country: "Botswana",
    lat: -21.15959930419922,
    lng: 27.47450065612793,
  },
  {
    id: "JWA",
    name: "Jwaneng Airport",
    city: "Jwaneng",
    country: "Botswana",
    lat: -24.6023006439209,
    lng: 24.69099998474121,
  },
  {
    id: "BBK",
    name: "Kasane Airport",
    city: "Kasane",
    country: "Botswana",
    lat: -17.83289909362793,
    lng: 25.162399291992188,
  },
  {
    id: "MUB",
    name: "Maun Airport",
    city: "Maun",
    country: "Botswana",
    lat: -19.97260093688965,
    lng: 23.431100845336914,
  },
  {
    id: "GBE",
    name: "Sir Seretse Khama International Airport",
    city: "Gaberone",
    country: "Botswana",
    lat: -24.555201,
    lng: 25.9182,
  },
  {
    id: "PKW",
    name: "Selebi Phikwe Airport",
    city: "Selebi-phikwe",
    country: "Botswana",
    lat: -22.0583,
    lng: 27.8288,
  },
  {
    id: "BZV",
    name: "Maya-Maya Airport",
    city: "Brazzaville",
    country: "Congo (Brazzaville)",
    lat: -4.251699924468994,
    lng: 15.253000259399414,
  },
  {
    id: "FTX",
    name: "Owando Airport",
    city: "Owando",
    country: "Congo (Kinshasa)",
    lat: -0.5313500165939331,
    lng: 15.95009994506836,
  },
  {
    id: "OUE",
    name: "Ouesso Airport",
    city: "Ouesso",
    country: "Congo (Kinshasa)",
    lat: 1.6159900426899998,
    lng: 16.0379009247,
  },
  {
    id: "PNR",
    name: "Pointe Noire Airport",
    city: "Pointe-noire",
    country: "Congo (Brazzaville)",
    lat: -4.816030025482178,
    lng: 11.88659954071045,
  },
  {
    id: "MTS",
    name: "Matsapha Airport",
    city: "Manzini",
    country: "Swaziland",
    lat: -26.52899932861328,
    lng: 31.3075008392334,
  },
  {
    id: "BGF",
    name: "Bangui M'Poko International Airport",
    city: "Bangui",
    country: "Central African Republic",
    lat: 4.39847993850708,
    lng: 18.518800735473633,
  },
  {
    id: "BBT",
    name: "Berbérati Airport",
    city: "Berberati",
    country: "Central African Republic",
    lat: 4.2215800285339355,
    lng: 15.786399841308594,
  },
  {
    id: "BSG",
    name: "Bata Airport",
    city: "Bata",
    country: "Equatorial Guinea",
    lat: 1.9054700136184692,
    lng: 9.805680274963379,
  },
  {
    id: "SSG",
    name: "Malabo Airport",
    city: "Malabo",
    country: "Equatorial Guinea",
    lat: 3.755270004272461,
    lng: 8.708720207214355,
  },
  {
    id: "ASI",
    name: "RAF Ascension Island",
    city: "Wide Awake",
    country: "Saint Helena",
    lat: -7.9696,
    lng: -14.3937,
  },
  {
    id: "MRU",
    name: "Sir Seewoosagur Ramgoolam International Airport",
    city: "Plaisance",
    country: "Mauritius",
    lat: -20.430201,
    lng: 57.683601,
  },
  {
    id: "RRG",
    name: "Sir Charles Gaetan Duval Airport",
    city: "Rodriguez Island",
    country: "Mauritius",
    lat: -19.7577,
    lng: 63.361,
  },
  {
    id: "NKW",
    name: "Diego Garcia Naval Support Facility",
    city: "Diego Garcia Island",
    country: "British Indian Ocean Territory",
    lat: -7.31327,
    lng: 72.411102,
  },
  {
    id: "TKC",
    name: "Tiko Airport",
    city: "Tiko",
    country: "Cameroon",
    lat: 4.08919000626,
    lng: 9.360529899600001,
  },
  {
    id: "DLA",
    name: "Douala International Airport",
    city: "Douala",
    country: "Cameroon",
    lat: 4.0060801506,
    lng: 9.719479560849999,
  },
  {
    id: "MVR",
    name: "Salak Airport",
    city: "Maroua",
    country: "Cameroon",
    lat: 10.451399803161621,
    lng: 14.257399559020996,
  },
  {
    id: "FOM",
    name: "Foumban Nkounja Airport",
    city: "Foumban",
    country: "Cameroon",
    lat: 5.636919975280762,
    lng: 10.750800132751465,
  },
  {
    id: "NGE",
    name: "N'Gaoundéré Airport",
    city: "N'gaoundere",
    country: "Cameroon",
    lat: 7.3570098876953125,
    lng: 13.559200286865234,
  },
  {
    id: "GOU",
    name: "Garoua International Airport",
    city: "Garoua",
    country: "Cameroon",
    lat: 9.33588981628418,
    lng: 13.370100021362305,
  },
  {
    id: "BFX",
    name: "Bafoussam Airport",
    city: "Bafoussam",
    country: "Cameroon",
    lat: 5.536920070650001,
    lng: 10.354599952700001,
  },
  {
    id: "BPC",
    name: "Bamenda Airport",
    city: "Bamenda",
    country: "Cameroon",
    lat: 6.039239883422852,
    lng: 10.122599601745605,
  },
  {
    id: "YAO",
    name: "Yaoundé Airport",
    city: "Yaounde",
    country: "Cameroon",
    lat: 3.8360400199890137,
    lng: 11.523500442504883,
  },
  {
    id: "CGJ",
    name: "Kasompe Airport",
    city: "Kasompe",
    country: "Zambia",
    lat: -12.572799682617,
    lng: 27.893899917603,
  },
  {
    id: "LVI",
    name: "Livingstone Airport",
    city: "Livingstone",
    country: "Zambia",
    lat: -17.821800231933594,
    lng: 25.82270050048828,
  },
  {
    id: "LUN",
    name: "Kenneth Kaunda International Airport Lusaka",
    city: "Lusaka",
    country: "Zambia",
    lat: -15.3308000565,
    lng: 28.4526004791,
  },
  {
    id: "MFU",
    name: "Mfuwe Airport",
    city: "Mfuwe",
    country: "Zambia",
    lat: -13.258899688720703,
    lng: 31.936599731445312,
  },
  {
    id: "MNR",
    name: "Mongu Airport",
    city: "Mongu",
    country: "Zambia",
    lat: -15.254500389099121,
    lng: 23.16230010986328,
  },
  {
    id: "NLA",
    name: "Simon Mwansa Kapwepwe International Airport",
    city: "Ndola",
    country: "Zambia",
    lat: -12.998100280762,
    lng: 28.66489982605,
  },
  {
    id: "KIW",
    name: "Southdowns Airport",
    city: "Southdowns",
    country: "Zambia",
    lat: -12.900500297546387,
    lng: 28.149900436401367,
  },
  {
    id: "HAH",
    name: "Prince Said Ibrahim International Airport",
    city: "Moroni",
    country: "Comoros",
    lat: -11.5337,
    lng: 43.2719,
  },
  {
    id: "NWA",
    name: "Mohéli Bandar Es Eslam Airport",
    city: "Moheli",
    country: "Comoros",
    lat: -12.298100471496582,
    lng: 43.76639938354492,
  },
  {
    id: "AJN",
    name: "Ouani Airport",
    city: "Anjouan",
    country: "Comoros",
    lat: -12.131699562072754,
    lng: 44.430301666259766,
  },
  {
    id: "DZA",
    name: "Dzaoudzi Pamandzi International Airport",
    city: "Dzaoudzi",
    country: "Mayotte",
    lat: -12.804699897766113,
    lng: 45.28110122680664,
  },
  {
    id: "RUN",
    name: "Roland Garros Airport",
    city: "St.-denis",
    country: "Reunion",
    lat: -20.887100219726562,
    lng: 55.51029968261719,
  },
  {
    id: "ZSE",
    name: "Pierrefonds Airport",
    city: "St.-pierre",
    country: "Reunion",
    lat: -21.320899963378906,
    lng: 55.42499923706055,
  },
  {
    id: "TNR",
    name: "Ivato Airport",
    city: "Antananarivo",
    country: "Madagascar",
    lat: -18.7969,
    lng: 47.478802,
  },
  {
    id: "ZVA",
    name: "Miandrivazo Airport",
    city: "Miandrivazo",
    country: "Madagascar",
    lat: -19.56279945373535,
    lng: 45.450801849365234,
  },
  {
    id: "SMS",
    name: "Sainte Marie Airport",
    city: "Sainte Marie",
    country: "Madagascar",
    lat: -17.093900680541992,
    lng: 49.815799713134766,
  },
  {
    id: "TMM",
    name: "Toamasina Airport",
    city: "Toamasina",
    country: "Madagascar",
    lat: -18.109500885009766,
    lng: 49.39250183105469,
  },
  {
    id: "MOQ",
    name: "Morondava Airport",
    city: "Morondava",
    country: "Madagascar",
    lat: -20.284700393676758,
    lng: 44.31760025024414,
  },
  {
    id: "DIE",
    name: "Arrachart Airport",
    city: "Antsiranana",
    country: "Madagascar",
    lat: -12.34939956665039,
    lng: 49.29169845581055,
  },
  {
    id: "WMR",
    name: "Mananara Nord Airport",
    city: "Mananara",
    country: "Madagascar",
    lat: -16.16390037536621,
    lng: 49.773799896240234,
  },
  {
    id: "ZWA",
    name: "Andapa Airport",
    city: "Andapa",
    country: "Madagascar",
    lat: -14.651700019836426,
    lng: 49.620601654052734,
  },
  {
    id: "AMB",
    name: "Ambilobe Airport",
    city: "Ambilobe",
    country: "Madagascar",
    lat: -13.188400268554688,
    lng: 48.987998962402344,
  },
  {
    id: "ANM",
    name: "Antsirabato Airport",
    city: "Antalaha",
    country: "Madagascar",
    lat: -14.99940013885498,
    lng: 50.3202018737793,
  },
  {
    id: "HVA",
    name: "Analalava Airport",
    city: "Analalava",
    country: "Madagascar",
    lat: -14.62969970703125,
    lng: 47.76380157470703,
  },
  {
    id: "MJN",
    name: "Amborovy Airport",
    city: "Mahajanga",
    country: "Madagascar",
    lat: -15.6668417421,
    lng: 46.351232528699995,
  },
  {
    id: "NOS",
    name: "Fascene Airport",
    city: "Nosy-be",
    country: "Madagascar",
    lat: -13.3121004105,
    lng: 48.3148002625,
  },
  {
    id: "BPY",
    name: "Besalampy Airport",
    city: "Besalampy",
    country: "Madagascar",
    lat: -16.744530296500002,
    lng: 44.4824838638,
  },
  {
    id: "WMN",
    name: "Maroantsetra Airport",
    city: "Maroantsetra",
    country: "Madagascar",
    lat: -15.436699867248535,
    lng: 49.68830108642578,
  },
  {
    id: "SVB",
    name: "Sambava Airport",
    city: "Sambava",
    country: "Madagascar",
    lat: -14.278599739074707,
    lng: 50.17470169067383,
  },
  {
    id: "VOH",
    name: "Vohimarina Airport",
    city: "Vohemar",
    country: "Madagascar",
    lat: -13.375800132751465,
    lng: 50.00279998779297,
  },
  {
    id: "WAI",
    name: "Ambalabe Airport",
    city: "Antsohihy",
    country: "Madagascar",
    lat: -14.898799896240234,
    lng: 47.993900299072266,
  },
  {
    id: "IVA",
    name: "Ampampamena Airport",
    city: "Ampampamena",
    country: "Madagascar",
    lat: -13.484816,
    lng: 48.632702,
  },
  {
    id: "FTU",
    name: "Tôlanaro Airport",
    city: "Tolagnaro",
    country: "Madagascar",
    lat: -25.03809928894043,
    lng: 46.95610046386719,
  },
  {
    id: "WFI",
    name: "Fianarantsoa Airport",
    city: "Fianarantsoa",
    country: "Madagascar",
    lat: -21.441600799560547,
    lng: 47.111698150634766,
  },
  {
    id: "RVA",
    name: "Farafangana Airport",
    city: "Farafangana",
    country: "Madagascar",
    lat: -22.805299758911133,
    lng: 47.82059860229492,
  },
  {
    id: "WVK",
    name: "Manakara Airport",
    city: "Manakara",
    country: "Madagascar",
    lat: -22.119699478149414,
    lng: 48.02170181274414,
  },
  {
    id: "MNJ",
    name: "Mananjary Airport",
    city: "Mananjary",
    country: "Madagascar",
    lat: -21.201799392700195,
    lng: 48.358299255371094,
  },
  {
    id: "MXM",
    name: "Morombe Airport",
    city: "Morombe",
    country: "Madagascar",
    lat: -21.7539005279541,
    lng: 43.3754997253418,
  },
  {
    id: "TLE",
    name: "Toliara Airport",
    city: "Toliara",
    country: "Madagascar",
    lat: -23.383399963378906,
    lng: 43.72850036621094,
  },
  {
    id: "SSY",
    name: "Mbanza Congo Airport",
    city: "M'banza-congo",
    country: "Angola",
    lat: -6.269899845123291,
    lng: 14.246999740600586,
  },
  {
    id: "BUG",
    name: "Benguela Airport",
    city: "Benguela",
    country: "Angola",
    lat: -12.609000206,
    lng: 13.4036998749,
  },
  {
    id: "CAB",
    name: "Cabinda Airport",
    city: "Cabinda",
    country: "Angola",
    lat: -5.59699010848999,
    lng: 12.188400268554688,
  },
  {
    id: "NOV",
    name: "Nova Lisboa Airport",
    city: "Huambo",
    country: "Angola",
    lat: -12.808899879455566,
    lng: 15.760499954223633,
  },
  {
    id: "SVP",
    name: "Kuito Airport",
    city: "Kuito",
    country: "Angola",
    lat: -12.404600143433,
    lng: 16.947399139404,
  },
  {
    id: "N",
    name: "Lobito Airport",
    city: "Lobito",
    country: "Angola",
    lat: -12.371199607849121,
    lng: 13.536600112915039,
  },
  {
    id: "LAD",
    name: "Quatro de Fevereiro Airport",
    city: "Luanda",
    country: "Angola",
    lat: -8.85837,
    lng: 13.2312,
  },
  {
    id: "MEG",
    name: "Malanje Airport",
    city: "Malanje",
    country: "Angola",
    lat: -9.525090217590332,
    lng: 16.312400817871094,
  },
  {
    id: "SPP",
    name: "Menongue Airport",
    city: "Menongue",
    country: "Angola",
    lat: -14.657600402832031,
    lng: 17.71980094909668,
  },
  {
    id: "GXG",
    name: "Negage Airport",
    city: "Negage",
    country: "Angola",
    lat: -7.754509925842285,
    lng: 15.287699699401855,
  },
  {
    id: "PBN",
    name: "Porto Amboim Airport",
    city: "Porto Amboim",
    country: "Angola",
    lat: -10.722000122070312,
    lng: 13.76550006866455,
  },
  {
    id: "VHC",
    name: "Saurimo Airport",
    city: "Saurimo",
    country: "Angola",
    lat: -9.689069747924805,
    lng: 20.431900024414062,
  },
  {
    id: "SZA",
    name: "Soyo Airport",
    city: "Soyo",
    country: "Angola",
    lat: -6.141089916229248,
    lng: 12.371800422668457,
  },
  {
    id: "SDD",
    name: "Lubango Airport",
    city: "Lubango",
    country: "Angola",
    lat: -14.924699783325195,
    lng: 13.574999809265137,
  },
  {
    id: "LUO",
    name: "Luena Airport",
    city: "Luena",
    country: "Angola",
    lat: -11.768099784851074,
    lng: 19.8976993560791,
  },
  {
    id: "UGO",
    name: "Uige Airport",
    city: "Uige",
    country: "Angola",
    lat: -7.60306978225708,
    lng: 15.027799606323242,
  },
  {
    id: "XGN",
    name: "Xangongo Airport",
    city: "Xangongo",
    country: "Angola",
    lat: -16.755399703979492,
    lng: 14.965299606323242,
  },
  {
    id: "OYE",
    name: "Oyem Airport",
    city: "Oyem",
    country: "Gabon",
    lat: 1.5431100130081177,
    lng: 11.581399917602539,
  },
  {
    id: "OKN",
    name: "Okondja Airport",
    city: "Okondja",
    country: "Gabon",
    lat: -0.6652140021324158,
    lng: 13.673100471496582,
  },
  {
    id: "LBQ",
    name: "Lambarene Airport",
    city: "Lambarene",
    country: "Gabon",
    lat: -0.7043889760971069,
    lng: 10.245699882507324,
  },
  {
    id: "BMM",
    name: "Bitam Airport",
    city: "Bitam",
    country: "Gabon",
    lat: 2.0756399631500244,
    lng: 11.493200302124023,
  },
  {
    id: "POG",
    name: "Port Gentil Airport",
    city: "Port Gentil",
    country: "Gabon",
    lat: -0.7117390036582947,
    lng: 8.754380226135254,
  },
  {
    id: "OMB",
    name: "Omboue Hopital Airport",
    city: "Omboue Hospial",
    country: "Gabon",
    lat: -1.5747300386428833,
    lng: 9.262689590454102,
  },
  {
    id: "MKU",
    name: "Makokou Airport",
    city: "Makokou",
    country: "Gabon",
    lat: 0.5792109966278076,
    lng: 12.890899658203125,
  },
  {
    id: "LBV",
    name: "Libreville Leon M'ba International Airport",
    city: "Libreville",
    country: "Gabon",
    lat: 0.458600014448,
    lng: 9.412280082699999,
  },
  {
    id: "MVB",
    name: "M'Vengue El Hadj Omar Bongo Ondimba International Airport",
    city: "Franceville",
    country: "Gabon",
    lat: -1.6561599969863892,
    lng: 13.437999725341797,
  },
  {
    id: "PCP",
    name: "Principe Airport",
    city: "Principe",
    country: "Sao Tome and Principe",
    lat: 1.6629400253295898,
    lng: 7.411739826202393,
  },
  {
    id: "TMS",
    name: "São Tomé International Airport",
    city: "Sao Tome",
    country: "Sao Tome and Principe",
    lat: 0.3781749904155731,
    lng: 6.7121500968933105,
  },
  {
    id: "BEW",
    name: "Beira Airport",
    city: "Beira",
    country: "Mozambique",
    lat: -19.79640007019043,
    lng: 34.90760040283203,
  },
  {
    id: "INH",
    name: "Inhambane Airport",
    city: "Inhambane",
    country: "Mozambique",
    lat: -23.876399993896484,
    lng: 35.40850067138672,
  },
  {
    id: "VXC",
    name: "Lichinga Airport",
    city: "Lichinga",
    country: "Mozambique",
    lat: -13.274,
    lng: 35.2663,
  },
  {
    id: "LFB",
    name: "Lumbo Airport",
    city: "Lumbo",
    country: "Mozambique",
    lat: -15.0331001282,
    lng: 40.671699523899996,
  },
  {
    id: "MPM",
    name: "Maputo Airport",
    city: "Maputo",
    country: "Mozambique",
    lat: -25.920799,
    lng: 32.572601,
  },
  {
    id: "MUD",
    name: "Mueda Airport",
    city: "Mueda",
    country: "Mozambique",
    lat: -11.672900199890137,
    lng: 39.5630989074707,
  },
  {
    id: "MZB",
    name: "Mocímboa da Praia Airport",
    city: "Mocimboa Da Praia",
    country: "Mozambique",
    lat: -11.361800193786621,
    lng: 40.35490036010742,
  },
  {
    id: "N",
    name: "Marrupa Airport",
    city: "Marrupa",
    country: "Mozambique",
    lat: -13.225099563598633,
    lng: 37.552101135253906,
  },
  {
    id: "MNC",
    name: "Nacala Airport",
    city: "Nacala",
    country: "Mozambique",
    lat: -14.488200187683105,
    lng: 40.71220016479492,
  },
  {
    id: "APL",
    name: "Nampula Airport",
    city: "Nampula",
    country: "Mozambique",
    lat: -15.105600357055664,
    lng: 39.28179931640625,
  },
  {
    id: "POL",
    name: "Pemba Airport",
    city: "Pemba",
    country: "Mozambique",
    lat: -12.991762161254883,
    lng: 40.52401351928711,
  },
  {
    id: "UEL",
    name: "Quelimane Airport",
    city: "Quelimane",
    country: "Mozambique",
    lat: -17.855499267578125,
    lng: 36.86909866333008,
  },
  {
    id: "N",
    name: "Songo Airport",
    city: "Songo",
    country: "Mozambique",
    lat: -15.602700233459473,
    lng: 32.77320098876953,
  },
  {
    id: "TET",
    name: "Chingozi Airport",
    city: "Tete",
    country: "Mozambique",
    lat: -16.104799270629883,
    lng: 33.640201568603516,
  },
  {
    id: "N",
    name: "Ulongwe Airport",
    city: "Ulongwe",
    country: "Mozambique",
    lat: -14.70460033416748,
    lng: 34.35240173339844,
  },
  {
    id: "VNX",
    name: "Vilankulo Airport",
    city: "Vilankulu",
    country: "Mozambique",
    lat: -22.018400192260742,
    lng: 35.31330108642578,
  },
  {
    id: "N",
    name: "Alphonse Airport",
    city: "Alphonse",
    country: "Seychelles",
    lat: -7.00478,
    lng: 52.7262,
  },
  {
    id: "DES",
    name: "Desroches Airport",
    city: "Desroches",
    country: "Seychelles",
    lat: -5.6967,
    lng: 53.6558,
  },
  {
    id: "N",
    name: "Farquhar Airport",
    city: "Farquhar",
    country: "Seychelles",
    lat: -10.1096,
    lng: 51.176102,
  },
  {
    id: "SEZ",
    name: "Seychelles International Airport",
    city: "Mahe",
    country: "Seychelles",
    lat: -4.67434,
    lng: 55.521801,
  },
  {
    id: "PRI",
    name: "Praslin Airport",
    city: "Praslin",
    country: "Seychelles",
    lat: -4.3192901611328125,
    lng: 55.69139862060547,
  },
  {
    id: "N",
    name: "Coetivy Airport",
    city: "Coetivy",
    country: "Seychelles",
    lat: -7.13457,
    lng: 56.278198,
  },
  {
    id: "AEH",
    name: "Abeche Airport",
    city: "Abeche",
    country: "Chad",
    lat: 13.847000122070312,
    lng: 20.84429931640625,
  },
  {
    id: "MQQ",
    name: "Moundou Airport",
    city: "Moundou",
    country: "Chad",
    lat: 8.624409675598145,
    lng: 16.071399688720703,
  },
  {
    id: "NDJ",
    name: "N'Djamena International Airport",
    city: "N'djamena",
    country: "Chad",
    lat: 12.1337,
    lng: 15.034,
  },
  {
    id: "FYT",
    name: "Faya Largeau Airport",
    city: "Faya-largeau",
    country: "Chad",
    lat: 17.91710090637207,
    lng: 19.111099243164062,
  },
  {
    id: "BUQ",
    name: "Joshua Mqabuko Nkomo International Airport",
    city: "Bulawayo",
    country: "Zimbabwe",
    lat: -20.017401,
    lng: 28.617901,
  },
  {
    id: "N",
    name: "Charles Prince Airport",
    city: "Harare",
    country: "Zimbabwe",
    lat: -17.75160026550293,
    lng: 30.924699783325195,
  },
  {
    id: "BFO",
    name: "Buffalo Range Airport",
    city: "Chiredzi",
    country: "Zimbabwe",
    lat: -21.008101,
    lng: 31.5786,
  },
  {
    id: "VFA",
    name: "Victoria Falls International Airport",
    city: "Victoria Falls",
    country: "Zimbabwe",
    lat: -18.09589958190918,
    lng: 25.839000701904297,
  },
  {
    id: "HRE",
    name: "Robert Gabriel Mugabe International Airport",
    city: "Harare",
    country: "Zimbabwe",
    lat: -17.931801,
    lng: 31.0928,
  },
  {
    id: "KAB",
    name: "Kariba International Airport",
    city: "Kariba",
    country: "Zimbabwe",
    lat: -16.519800186157227,
    lng: 28.885000228881836,
  },
  {
    id: "N",
    name: "Mutoko Airport",
    city: "Mutoko",
    country: "Zimbabwe",
    lat: -17.431900024414062,
    lng: 32.18450164794922,
  },
  {
    id: "UTA",
    name: "Mutare Airport",
    city: "Mutare",
    country: "Zimbabwe",
    lat: -18.997499465942,
    lng: 32.627201080322,
  },
  {
    id: "MVZ",
    name: "Masvingo International Airport",
    city: "Masvingo",
    country: "Zimbabwe",
    lat: -20.055299758911133,
    lng: 30.859100341796875,
  },
  {
    id: "N",
    name: "Zvishavane Airport",
    city: "Zvishavane",
    country: "Zimbabwe",
    lat: -20.289499282836914,
    lng: 30.088199615478516,
  },
  {
    id: "GWE",
    name: "Thornhill Air Base",
    city: "Gwert",
    country: "Zimbabwe",
    lat: -19.436399459838867,
    lng: 29.861900329589844,
  },
  {
    id: "HWN",
    name: "Hwange National Park Airport",
    city: "Hwange National Park",
    country: "Zimbabwe",
    lat: -18.629899978637695,
    lng: 27.020999908447266,
  },
  {
    id: "BLZ",
    name: "Chileka International Airport",
    city: "Blantyre",
    country: "Malawi",
    lat: -15.679100036621094,
    lng: 34.9739990234375,
  },
  {
    id: "KGJ",
    name: "Karonga Airport",
    city: "Karonga",
    country: "Malawi",
    lat: -9.953570365905762,
    lng: 33.893001556396484,
  },
  {
    id: "KBQ",
    name: "Kasungu Airport",
    city: "Kasungu",
    country: "Malawi",
    lat: -13.014599800109863,
    lng: 33.46860122680664,
  },
  {
    id: "LLW",
    name: "Lilongwe International Airport",
    city: "Lilongwe",
    country: "Malawi",
    lat: -13.7894001007,
    lng: 33.78099823,
  },
  {
    id: "ZZU",
    name: "Mzuzu Airport",
    city: "Mzuzu",
    country: "Malawi",
    lat: -11.444700241088867,
    lng: 34.01179885864258,
  },
  {
    id: "MSU",
    name: "Moshoeshoe I International Airport",
    city: "Maseru",
    country: "Lesotho",
    lat: -29.462299346923828,
    lng: 27.552499771118164,
  },
  {
    id: "N",
    name: "Mejametalana Airbase",
    city: "Maseru",
    country: "Lesotho",
    lat: -29.304100036621094,
    lng: 27.50349998474121,
  },
  {
    id: "FIH",
    name: "Ndjili International Airport",
    city: "Kinshasa",
    country: "Congo (Kinshasa)",
    lat: -4.38575,
    lng: 15.4446,
  },
  {
    id: "NLO",
    name: "Ndolo Airport",
    city: "Kinshasa",
    country: "Congo (Kinshasa)",
    lat: -4.32666015625,
    lng: 15.327500343323,
  },
  {
    id: "MNB",
    name: "Muanda Airport",
    city: "Muanda",
    country: "Congo (Kinshasa)",
    lat: -5.9308600425720215,
    lng: 12.351799964904785,
  },
  {
    id: "N",
    name: "Kitona Base Airport",
    city: "Kitona Base",
    country: "Congo (Kinshasa)",
    lat: -5.918059825897217,
    lng: 12.447699546813965,
  },
  {
    id: "FDU",
    name: "Bandundu Airport",
    city: "Bandoundu",
    country: "Congo (Kinshasa)",
    lat: -3.3113200664520264,
    lng: 17.38170051574707,
  },
  {
    id: "KKW",
    name: "Kikwit Airport",
    city: "Kikwit",
    country: "Congo (Kinshasa)",
    lat: -5.035769939422607,
    lng: 18.785600662231445,
  },
  {
    id: "MDK",
    name: "Mbandaka Airport",
    city: "Mbandaka",
    country: "Congo (Kinshasa)",
    lat: 0.0226000007242,
    lng: 18.2887001038,
  },
  {
    id: "BDT",
    name: "Gbadolite Airport",
    city: "Gbadolite",
    country: "Congo (Kinshasa)",
    lat: 4.253210067749023,
    lng: 20.975299835205078,
  },
  {
    id: "GMA",
    name: "Gemena Airport",
    city: "Gemena",
    country: "Congo (Kinshasa)",
    lat: 3.2353699207299997,
    lng: 19.771299362199997,
  },
  {
    id: "KLI",
    name: "Kotakoli Airport",
    city: "Kotakoli",
    country: "Congo (Kinshasa)",
    lat: 4.157639980316162,
    lng: 21.65089988708496,
  },
  {
    id: "LIQ",
    name: "Lisala Airport",
    city: "Lisala",
    country: "Congo (Kinshasa)",
    lat: 2.17066,
    lng: 21.496901,
  },
  {
    id: "FKI",
    name: "Bangoka International Airport",
    city: "Kisangani",
    country: "Congo (Kinshasa)",
    lat: 0.481638997793,
    lng: 25.3379993439,
  },
  {
    id: "IRP",
    name: "Matari Airport",
    city: "Isiro",
    country: "Congo (Kinshasa)",
    lat: 2.8276100158691406,
    lng: 27.588300704956055,
  },
  {
    id: "BUX",
    name: "Bunia Airport",
    city: "Bunia",
    country: "Congo (Kinshasa)",
    lat: 1.5657199621200562,
    lng: 30.220800399780273,
  },
  {
    id: "BZU",
    name: "Buta Zega Airport",
    city: "Buta Zega",
    country: "Congo (Kinshasa)",
    lat: 2.818350076675415,
    lng: 24.793699264526367,
  },
  {
    id: "BKY",
    name: "Bukavu Kavumu Airport",
    city: "Bukavu/kavumu",
    country: "Congo (Kinshasa)",
    lat: -2.3089799880981445,
    lng: 28.808799743652344,
  },
  {
    id: "GOM",
    name: "Goma International Airport",
    city: "Goma",
    country: "Congo (Kinshasa)",
    lat: -1.6708099842071533,
    lng: 29.238500595092773,
  },
  {
    id: "KND",
    name: "Kindu Airport",
    city: "Kindu",
    country: "Congo (Kinshasa)",
    lat: -2.91917991638,
    lng: 25.915399551399997,
  },
  {
    id: "FBM",
    name: "Lubumbashi International Airport",
    city: "Lubumashi",
    country: "Congo (Kinshasa)",
    lat: -11.5913000107,
    lng: 27.5308990479,
  },
  {
    id: "KWZ",
    name: "Kolwezi Airport",
    city: "Kolwezi",
    country: "Congo (Kinshasa)",
    lat: -10.765899658203125,
    lng: 25.505699157714844,
  },
  {
    id: "FMI",
    name: "Kalemie Airport",
    city: "Kalemie",
    country: "Congo (Kinshasa)",
    lat: -5.8755598068237305,
    lng: 29.25,
  },
  {
    id: "KMN",
    name: "Kamina Base Airport",
    city: "Kamina Base",
    country: "Congo (Kinshasa)",
    lat: -8.642020225524902,
    lng: 25.252899169921875,
  },
  {
    id: "KGA",
    name: "Kananga Airport",
    city: "Kananga",
    country: "Congo (Kinshasa)",
    lat: -5.90005016327,
    lng: 22.4692001343,
  },
  {
    id: "MJM",
    name: "Mbuji Mayi Airport",
    city: "Mbuji-mayi",
    country: "Congo (Kinshasa)",
    lat: -6.121240139010001,
    lng: 23.569000244099996,
  },
  {
    id: "BKO",
    name: "Modibo Keita International Airport",
    city: "Bamako",
    country: "Mali",
    lat: 12.5335,
    lng: -7.94994,
  },
  {
    id: "GAQ",
    name: "Gao Airport",
    city: "Gao",
    country: "Mali",
    lat: 16.24839973449707,
    lng: -0.005456000100821257,
  },
  {
    id: "KYS",
    name: "Kayes Dag Dag Airport",
    city: "Kayes",
    country: "Mali",
    lat: 14.481200218200684,
    lng: -11.404399871826172,
  },
  {
    id: "MZI",
    name: "Mopti Airport",
    city: "Mopti",
    country: "Mali",
    lat: 14.5128002167,
    lng: -4.0795598030099995,
  },
  {
    id: "TOM",
    name: "Timbuktu Airport",
    city: "Tombouctou",
    country: "Mali",
    lat: 16.730499267578125,
    lng: -3.007580041885376,
  },
  {
    id: "N",
    name: "Tessalit Airport",
    city: "Tessalit",
    country: "Mali",
    lat: 20.243000030517578,
    lng: 0.9773079752922058,
  },
  {
    id: "BJL",
    name: "Banjul International Airport",
    city: "Banjul",
    country: "Gambia",
    lat: 13.338000297546387,
    lng: -16.65220069885254,
  },
  {
    id: "FUE",
    name: "Fuerteventura Airport",
    city: "Fuerteventura",
    country: "Spain",
    lat: 28.452699661254883,
    lng: -13.863800048828125,
  },
  {
    id: "VDE",
    name: "Hierro Airport",
    city: "Hierro",
    country: "Spain",
    lat: 27.814800262451172,
    lng: -17.887100219726562,
  },
  {
    id: "SPC",
    name: "La Palma Airport",
    city: "Santa Cruz De La Palma",
    country: "Spain",
    lat: 28.626499,
    lng: -17.7556,
  },
  {
    id: "LPA",
    name: "Gran Canaria Airport",
    city: "Gran Canaria",
    country: "Spain",
    lat: 27.931900024414062,
    lng: -15.38659954071045,
  },
  {
    id: "ACE",
    name: "Lanzarote Airport",
    city: "Arrecife",
    country: "Spain",
    lat: 28.945499,
    lng: -13.6052,
  },
  {
    id: "TFS",
    name: "Tenerife South Airport",
    city: "Tenerife",
    country: "Spain",
    lat: 28.044500351,
    lng: -16.5725002289,
  },
  {
    id: "TFN",
    name: "Tenerife Norte Airport",
    city: "Tenerife",
    country: "Spain",
    lat: 28.4827003479,
    lng: -16.3414993286,
  },
  {
    id: "MLN",
    name: "Melilla Airport",
    city: "Melilla",
    country: "Spain",
    lat: 35.279800415,
    lng: -2.9562599659,
  },
  {
    id: "FNA",
    name: "Lungi International Airport",
    city: "Freetown",
    country: "Sierra Leone",
    lat: 8.61644,
    lng: -13.1955,
  },
  {
    id: "N",
    name: "Cufar Airport",
    city: "Cufar",
    country: "Guinea-Bissau",
    lat: 11.2878999710083,
    lng: -15.180500030517578,
  },
  {
    id: "MLW",
    name: "Spriggs Payne Airport",
    city: "Monrovia",
    country: "Liberia",
    lat: 6.289060115814209,
    lng: -10.758700370788574,
  },
  {
    id: "ROB",
    name: "Roberts International Airport",
    city: "Monrovia",
    country: "Liberia",
    lat: 6.23379,
    lng: -10.3623,
  },
  {
    id: "AGA",
    name: "Al Massira Airport",
    city: "Agadir",
    country: "Morocco",
    lat: 30.325000762939453,
    lng: -9.413069725036621,
  },
  {
    id: "TTA",
    name: "Tan Tan Airport",
    city: "Tan Tan",
    country: "Morocco",
    lat: 28.448200225830078,
    lng: -11.161299705505371,
  },
  {
    id: "FEZ",
    name: "Saïss Airport",
    city: "Fes",
    country: "Morocco",
    lat: 33.9272994995,
    lng: -4.977960109709999,
  },
  {
    id: "N",
    name: "Ifrane Airport",
    city: "Ifrane",
    country: "Morocco",
    lat: 33.50529861450195,
    lng: -5.152900218963623,
  },
  {
    id: "ERH",
    name: "Moulay Ali Cherif Airport",
    city: "Er-rachidia",
    country: "Morocco",
    lat: 31.9475002289,
    lng: -4.39833021164,
  },
  {
    id: "MEK",
    name: "Bassatine Airport",
    city: "Meknes",
    country: "Morocco",
    lat: 33.87910079956055,
    lng: -5.515120029449463,
  },
  {
    id: "OUD",
    name: "Angads Airport",
    city: "Oujda",
    country: "Morocco",
    lat: 34.787200927734375,
    lng: -1.92399001121521,
  },
  {
    id: "GMD",
    name: "Ben Slimane Airport",
    city: "Ben Slimane",
    country: "Morocco",
    lat: 33.655399,
    lng: -7.22145,
  },
  {
    id: "RBA",
    name: "Rabat-Salé Airport",
    city: "Rabat",
    country: "Morocco",
    lat: 34.051498,
    lng: -6.75152,
  },
  {
    id: "CMN",
    name: "Mohammed V International Airport",
    city: "Casablanca",
    country: "Morocco",
    lat: 33.36750030517578,
    lng: -7.589970111846924,
  },
  {
    id: "RAK",
    name: "Menara Airport",
    city: "Marrakech",
    country: "Morocco",
    lat: 31.606899261499997,
    lng: -8.03629970551,
  },
  {
    id: "NNA",
    name: "Kenitra Airport",
    city: "Kentira",
    country: "Morocco",
    lat: 34.29890060424805,
    lng: -6.595880031585693,
  },
  {
    id: "OZZ",
    name: "Ouarzazate Airport",
    city: "Ouarzazate",
    country: "Morocco",
    lat: 30.9391002655,
    lng: -6.909430027010001,
  },
  {
    id: "AHU",
    name: "Cherif Al Idrissi Airport",
    city: "Al Hociema",
    country: "Morocco",
    lat: 35.177101135253906,
    lng: -3.83951997756958,
  },
  {
    id: "TTU",
    name: "Saniat R'mel Airport",
    city: "Tetouan",
    country: "Morocco",
    lat: 35.594299316406,
    lng: -5.320020198822,
  },
  {
    id: "TNG",
    name: "Ibn Batouta Airport",
    city: "Tanger",
    country: "Morocco",
    lat: 35.726898193400004,
    lng: -5.91689014435,
  },
  {
    id: "ZIG",
    name: "Ziguinchor Airport",
    city: "Ziguinchor",
    country: "Senegal",
    lat: 12.5556,
    lng: -16.281799,
  },
  {
    id: "CSK",
    name: "Cap Skirring Airport",
    city: "Cap Skiring",
    country: "Senegal",
    lat: 12.39533,
    lng: -16.748,
  },
  {
    id: "KLC",
    name: "Kaolack Airport",
    city: "Kaolack",
    country: "Senegal",
    lat: 14.146900177001953,
    lng: -16.051300048828125,
  },
  {
    id: "DKR",
    name: "Léopold Sédar Senghor International Airport",
    city: "Dakar",
    country: "Senegal",
    lat: 14.739700317382812,
    lng: -17.49020004272461,
  },
  {
    id: "XLS",
    name: "Saint Louis Airport",
    city: "St. Louis",
    country: "Senegal",
    lat: 16.050800323486328,
    lng: -16.463199615478516,
  },
  {
    id: "BXE",
    name: "Bakel Airport",
    city: "Bakel",
    country: "Senegal",
    lat: 14.847299575805664,
    lng: -12.468299865722656,
  },
  {
    id: "KGG",
    name: "Kédougou Airport",
    city: "Kedougou",
    country: "Senegal",
    lat: 12.57229995727539,
    lng: -12.22029972076416,
  },
  {
    id: "TUD",
    name: "Tambacounda Airport",
    city: "Tambacounda",
    country: "Senegal",
    lat: 13.736800193786621,
    lng: -13.65310001373291,
  },
  {
    id: "AEO",
    name: "Aioun el Atrouss Airport",
    city: "Aioun El Atrouss",
    country: "Mauritania",
    lat: 16.711299896240234,
    lng: -9.637880325317383,
  },
  {
    id: "TIY",
    name: "Tidjikja Airport",
    city: "Tidjikja",
    country: "Mauritania",
    lat: 18.570100784301758,
    lng: -11.423500061035156,
  },
  {
    id: "KFA",
    name: "Kiffa Airport",
    city: "Kiffa",
    country: "Mauritania",
    lat: 16.59000015258789,
    lng: -11.406200408935547,
  },
  {
    id: "EMN",
    name: "Néma Airport",
    city: "Nema",
    country: "Mauritania",
    lat: 16.621999740600586,
    lng: -7.3165998458862305,
  },
  {
    id: "KED",
    name: "Kaédi Airport",
    city: "Kaedi",
    country: "Mauritania",
    lat: 16.159500122070312,
    lng: -13.507599830627441,
  },
  {
    id: "NKC",
    name: "Nouakchott–Oumtounsy International Airport",
    city: "Nouakschott",
    country: "Mauritania",
    lat: 18.31,
    lng: -15.9697222,
  },
  {
    id: "SEY",
    name: "Sélibaby Airport",
    city: "Selibabi",
    country: "Mauritania",
    lat: 15.179699897766113,
    lng: -12.207300186157227,
  },
  {
    id: "ATR",
    name: "Atar International Airport",
    city: "Atar",
    country: "Mauritania",
    lat: 20.506799697875977,
    lng: -13.04319953918457,
  },
  {
    id: "NDB",
    name: "Nouadhibou International Airport",
    city: "Nouadhibou",
    country: "Mauritania",
    lat: 20.9330997467041,
    lng: -17.030000686645508,
  },
  {
    id: "N",
    name: "Bir Moghrein Airport",
    city: "Bir Moghrein",
    country: "Mauritania",
    lat: 25.2367000579834,
    lng: -11.588700294494629,
  },
  {
    id: "FIG",
    name: "Fria Airport",
    city: "Fira",
    country: "Guinea",
    lat: 10.350600242615,
    lng: -13.569199562073,
  },
  {
    id: "FAA",
    name: "Faranah Airport",
    city: "Faranah",
    country: "Guinea",
    lat: 10.0354995728,
    lng: -10.7698001862,
  },
  {
    id: "LEK",
    name: "Tata Airport",
    city: "Labe",
    country: "Guinea",
    lat: 11.326100349426,
    lng: -12.286800384521,
  },
  {
    id: "SID",
    name: "Amílcar Cabral International Airport",
    city: "Amilcar Cabral",
    country: "Cape Verde",
    lat: 16.7414,
    lng: -22.9494,
  },
  {
    id: "BVC",
    name: "Rabil Airport",
    city: "Boa Vista",
    country: "Cape Verde",
    lat: 16.136499404907227,
    lng: -22.888900756835938,
  },
  {
    id: "MMO",
    name: "Maio Airport",
    city: "Maio",
    country: "Cape Verde",
    lat: 15.155900001525879,
    lng: -23.213699340820312,
  },
  {
    id: "SNE",
    name: "Preguiça Airport",
    city: "Sao Nocolau Island",
    country: "Cape Verde",
    lat: 16.58839988708496,
    lng: -24.284700393676758,
  },
  {
    id: "VXE",
    name: "São Pedro Airport",
    city: "Sao Vicente Island",
    country: "Cape Verde",
    lat: 16.833200454711914,
    lng: -25.055299758911133,
  },
  {
    id: "ADD",
    name: "Addis Ababa Bole International Airport",
    city: "Addis Ababa",
    country: "Ethiopia",
    lat: 8.97789001465,
    lng: 38.799301147499996,
  },
  {
    id: "N",
    name: "Lideta Army Airport",
    city: "Addis Ababa",
    country: "Ethiopia",
    lat: 9.003685,
    lng: 38.725498,
  },
  {
    id: "AMH",
    name: "Arba Minch Airport",
    city: "Arba Minch",
    country: "Ethiopia",
    lat: 6.0393900871276855,
    lng: 37.59049987792969,
  },
  {
    id: "AXU",
    name: "Axum Airport",
    city: "Axum",
    country: "Ethiopia",
    lat: 14.14680004119873,
    lng: 38.77280044555664,
  },
  {
    id: "BJR",
    name: "Bahir Dar Airport",
    city: "Bahar Dar",
    country: "Ethiopia",
    lat: 11.608099937438965,
    lng: 37.32160186767578,
  },
  {
    id: "DIR",
    name: "Aba Tenna Dejazmach Yilma International Airport",
    city: "Dire Dawa",
    country: "Ethiopia",
    lat: 9.624699592590332,
    lng: 41.85419845581055,
  },
  {
    id: "GMB",
    name: "Gambella Airport",
    city: "Gambella",
    country: "Ethiopia",
    lat: 8.12876033782959,
    lng: 34.5630989074707,
  },
  {
    id: "GDQ",
    name: "Gonder Airport",
    city: "Gondar",
    country: "Ethiopia",
    lat: 12.51990032196045,
    lng: 37.433998107910156,
  },
  {
    id: "JIM",
    name: "Jimma Airport",
    city: "Jimma",
    country: "Ethiopia",
    lat: 7.66609001159668,
    lng: 36.81660079956055,
  },
  {
    id: "LLI",
    name: "Lalibella Airport",
    city: "Lalibella",
    country: "Ethiopia",
    lat: 11.975000381469727,
    lng: 38.97999954223633,
  },
  {
    id: "MQX",
    name: "Mekele Airport",
    city: "Makale",
    country: "Ethiopia",
    lat: 13.467399597167969,
    lng: 39.53350067138672,
  },
  {
    id: "ASO",
    name: "Asosa Airport",
    city: "Asosa",
    country: "Ethiopia",
    lat: 10.018500328063965,
    lng: 34.586299896240234,
  },
  {
    id: "BJM",
    name: "Bujumbura International Airport",
    city: "Bujumbura",
    country: "Burundi",
    lat: -3.3240199089050293,
    lng: 29.318500518798828,
  },
  {
    id: "HGA",
    name: "Egal International Airport",
    city: "Hargeisa",
    country: "Somalia",
    lat: 9.518170356750488,
    lng: 44.08879852294922,
  },
  {
    id: "BBO",
    name: "Berbera Airport",
    city: "Berbera",
    country: "Somalia",
    lat: 10.389200210571289,
    lng: 44.94110107421875,
  },
  {
    id: "KMU",
    name: "Kisimayu Airport",
    city: "Kismayu",
    country: "Somalia",
    lat: -0.3773530125617981,
    lng: 42.45920181274414,
  },
  {
    id: "ALY",
    name: "El Nouzha Airport",
    city: "Alexandria",
    country: "Egypt",
    lat: 31.183900833129883,
    lng: 29.94890022277832,
  },
  {
    id: "ABS",
    name: "Abu Simbel Airport",
    city: "Abu Simbel",
    country: "Egypt",
    lat: 22.375999450699997,
    lng: 31.611700058,
  },
  {
    id: "CAI",
    name: "Cairo International Airport",
    city: "Cairo",
    country: "Egypt",
    lat: 30.12190055847168,
    lng: 31.40559959411621,
  },
  {
    id: "CWE",
    name: "Cairo West Airport",
    city: "Cairo",
    country: "Egypt",
    lat: 30.116399765,
    lng: 30.915399551399997,
  },
  {
    id: "HRG",
    name: "Hurghada International Airport",
    city: "Hurghada",
    country: "Egypt",
    lat: 27.178300857543945,
    lng: 33.799400329589844,
  },
  {
    id: "EGH",
    name: "El Gora Airport",
    city: "El Gorah",
    country: "Egypt",
    lat: 31.068559,
    lng: 34.129629,
  },
  {
    id: "LXR",
    name: "Luxor International Airport",
    city: "Luxor",
    country: "Egypt",
    lat: 25.671,
    lng: 32.7066,
  },
  {
    id: "MUH",
    name: "Mersa Matruh Airport",
    city: "Mersa-matruh",
    country: "Egypt",
    lat: 31.3253993988,
    lng: 27.221700668300002,
  },
  {
    id: "PSD",
    name: "Port Said Airport",
    city: "Port Said",
    country: "Egypt",
    lat: 31.279399871826172,
    lng: 32.2400016784668,
  },
  {
    id: "SKV",
    name: "St Catherine International Airport",
    city: "St. Catherine",
    country: "Egypt",
    lat: 28.685300827,
    lng: 34.0625,
  },
  {
    id: "ASW",
    name: "Aswan International Airport",
    city: "Aswan",
    country: "Egypt",
    lat: 23.9643993378,
    lng: 32.8199996948,
  },
  {
    id: "ELT",
    name: "El Tor Airport",
    city: "El-tor",
    country: "Egypt",
    lat: 28.208999633789062,
    lng: 33.64550018310547,
  },
  {
    id: "EDL",
    name: "Eldoret International Airport",
    city: "Eldoret",
    country: "Kenya",
    lat: 0.4044579863548279,
    lng: 35.23889923095703,
  },
  {
    id: "GGM",
    name: "Kakamega Airport",
    city: "Kakamega",
    country: "Kenya",
    lat: 0.271342009306,
    lng: 34.7873001099,
  },
  {
    id: "KIS",
    name: "Kisumu Airport",
    city: "Kisumu",
    country: "Kenya",
    lat: -0.0861390009522438,
    lng: 34.72890090942383,
  },
  {
    id: "KTL",
    name: "Kitale Airport",
    city: "Kitale",
    country: "Kenya",
    lat: 0.9719889760017395,
    lng: 34.95859909057617,
  },
  {
    id: "LOK",
    name: "Lodwar Airport",
    city: "Lodwar",
    country: "Kenya",
    lat: 3.1219699382781982,
    lng: 35.608699798583984,
  },
  {
    id: "LAU",
    name: "Manda Airstrip",
    city: "Lamu",
    country: "Kenya",
    lat: -2.252419948577881,
    lng: 40.91310119628906,
  },
  {
    id: "MBA",
    name: "Mombasa Moi International Airport",
    city: "Mombasa",
    country: "Kenya",
    lat: -4.034830093383789,
    lng: 39.594200134277344,
  },
  {
    id: "N",
    name: "Naivasha Airport",
    city: "Naivasha",
    country: "Kenya",
    lat: -0.787953,
    lng: 36.433494,
  },
  {
    id: "WIL",
    name: "Nairobi Wilson Airport",
    city: "Nairobi",
    country: "Kenya",
    lat: -1.321720004081726,
    lng: 36.81480026245117,
  },
  {
    id: "N",
    name: "Moi Air Base",
    city: "Nairobi",
    country: "Kenya",
    lat: -1.2772699594499999,
    lng: 36.8623008728,
  },
  {
    id: "WJR",
    name: "Wajir Airport",
    city: "Wajir",
    country: "Kenya",
    lat: 1.73324,
    lng: 40.091599,
  },
  {
    id: "N",
    name: "Bu Attifel Airport",
    city: "Buattifel",
    country: "Libya",
    lat: 28.795400619506836,
    lng: 22.080900192260742,
  },
  {
    id: "N",
    name: "Warehouse 59e Airport",
    city: "Giallo",
    country: "Libya",
    lat: 28.638500213623047,
    lng: 21.437999725341797,
  },
  {
    id: "GHT",
    name: "Ghat Airport",
    city: "Ghat",
    country: "Libya",
    lat: 25.1455993652,
    lng: 10.142600059500001,
  },
  {
    id: "AKF",
    name: "Kufra Airport",
    city: "Kufra",
    country: "Libya",
    lat: 24.178699493408203,
    lng: 23.31399917602539,
  },
  {
    id: "BEN",
    name: "Benina International Airport",
    city: "Benghazi",
    country: "Libya",
    lat: 32.096801757799994,
    lng: 20.2695007324,
  },
  {
    id: "SEB",
    name: "Sabha Airport",
    city: "Sebha",
    country: "Libya",
    lat: 26.98699951171875,
    lng: 14.47249984741211,
  },
  {
    id: "TIP",
    name: "Tripoli International Airport",
    city: "Tripoli",
    country: "Libya",
    lat: 32.6635017395,
    lng: 13.1590003967,
  },
  {
    id: "LMQ",
    name: "Marsa Brega Airport",
    city: "Marsa Brega",
    country: "Libya",
    lat: 30.37809944152832,
    lng: 19.576400756835938,
  },
  {
    id: "N",
    name: "Ras Lanuf Oil Airport",
    city: "Ras Lanouf V 40",
    country: "Libya",
    lat: 30.5,
    lng: 18.52720069885254,
  },
  {
    id: "HUQ",
    name: "Hon Airport",
    city: "Hon",
    country: "Libya",
    lat: 29.11009979248047,
    lng: 15.96560001373291,
  },
  {
    id: "N",
    name: "Dahra Airport",
    city: "Dahra",
    country: "Libya",
    lat: 29.47260093688965,
    lng: 17.934900283813477,
  },
  {
    id: "LTD",
    name: "Ghadames East Airport",
    city: "Ghadames",
    country: "Libya",
    lat: 30.15169906616211,
    lng: 9.715310096740723,
  },
  {
    id: "N",
    name: "Zella 74 Airport",
    city: "Zella 74",
    country: "Libya",
    lat: 28.58989906311035,
    lng: 17.293899536132812,
  },
  {
    id: "GYI",
    name: "Gisenyi Airport",
    city: "Gisenyi",
    country: "Rwanda",
    lat: -1.6771999597549438,
    lng: 29.258899688720703,
  },
  {
    id: "KGL",
    name: "Kigali International Airport",
    city: "Kigali",
    country: "Rwanda",
    lat: -1.96863,
    lng: 30.1395,
  },
  {
    id: "KME",
    name: "Kamembe Airport",
    city: "Kamembe",
    country: "Rwanda",
    lat: -2.462239980697632,
    lng: 28.907899856567383,
  },
  {
    id: "DOG",
    name: "Dongola Airport",
    city: "Dongola",
    country: "Sudan",
    lat: 19.153900146499996,
    lng: 30.430099487299998,
  },
  {
    id: "RSS",
    name: "Damazin Airport",
    city: "Damazin",
    country: "Sudan",
    lat: 11.7859,
    lng: 34.3367,
  },
  {
    id: "ELF",
    name: "El Fasher Airport",
    city: "El Fasher",
    country: "Sudan",
    lat: 13.614899635314941,
    lng: 25.324600219726562,
  },
  {
    id: "KSL",
    name: "Kassala Airport",
    city: "Kassala",
    country: "Sudan",
    lat: 15.387499809265137,
    lng: 36.328800201416016,
  },
  {
    id: "KDX",
    name: "Kadugli Airport",
    city: "Kadugli",
    country: "Sudan",
    lat: 11.137999534600002,
    lng: 29.7010993958,
  },
  {
    id: "EBD",
    name: "El Obeid Airport",
    city: "El Obeid",
    country: "Sudan",
    lat: 13.153200149536133,
    lng: 30.23270034790039,
  },
  {
    id: "JUB",
    name: "Juba International Airport",
    city: "Juba",
    country: "South Sudan",
    lat: 4.87201023102,
    lng: 31.6011009216,
  },
  {
    id: "MAK",
    name: "Malakal Airport",
    city: "Malakal",
    country: "Sudan",
    lat: 9.55897045135498,
    lng: 31.65220069885254,
  },
  {
    id: "KRT",
    name: "Khartoum International Airport",
    city: "Khartoum",
    country: "Sudan",
    lat: 15.589500427246094,
    lng: 32.553199768066406,
  },
  {
    id: "ARK",
    name: "Arusha Airport",
    city: "Arusha",
    country: "Tanzania",
    lat: -3.3677899837493896,
    lng: 36.63330078125,
  },
  {
    id: "DAR",
    name: "Julius Nyerere International Airport",
    city: "Dar Es Salaam",
    country: "Tanzania",
    lat: -6.87811,
    lng: 39.202599,
  },
  {
    id: "DOD",
    name: "Dodoma Airport",
    city: "Dodoma",
    country: "Tanzania",
    lat: -6.170440196990967,
    lng: 35.752601623535156,
  },
  {
    id: "IRI",
    name: "Iringa Airport",
    city: "Iringa",
    country: "Tanzania",
    lat: -7.668630123138428,
    lng: 35.75210189819336,
  },
  {
    id: "JRO",
    name: "Kilimanjaro International Airport",
    city: "Kilimanjaro",
    country: "Tanzania",
    lat: -3.42940998077,
    lng: 37.0745010376,
  },
  {
    id: "LKY",
    name: "Lake Manyara Airport",
    city: "Lake Manyara",
    country: "Tanzania",
    lat: -3.376310110092163,
    lng: 35.81829833984375,
  },
  {
    id: "MYW",
    name: "Mtwara Airport",
    city: "Mtwara",
    country: "Tanzania",
    lat: -10.339099884033203,
    lng: 40.181800842285156,
  },
  {
    id: "MWZ",
    name: "Mwanza Airport",
    city: "Mwanza",
    country: "Tanzania",
    lat: -2.4444899559020996,
    lng: 32.932701110839844,
  },
  {
    id: "PMA",
    name: "Pemba Airport",
    city: "Pemba",
    country: "Tanzania",
    lat: -5.257259845733643,
    lng: 39.8114013671875,
  },
  {
    id: "TGT",
    name: "Tanga Airport",
    city: "Tanga",
    country: "Tanzania",
    lat: -5.092360019683838,
    lng: 39.07120132446289,
  },
  {
    id: "ZNZ",
    name: "Abeid Amani Karume International Airport",
    city: "Zanzibar",
    country: "Tanzania",
    lat: -6.22202,
    lng: 39.224899,
  },
  {
    id: "EBB",
    name: "Entebbe International Airport",
    city: "Entebbe",
    country: "Uganda",
    lat: 0.042386,
    lng: 32.443501,
  },
  {
    id: "SRT",
    name: "Soroti Airport",
    city: "Soroti",
    country: "Uganda",
    lat: 1.7276899814605713,
    lng: 33.622798919677734,
  },
  {
    id: "TIA",
    name: "Tirana International Airport Mother Teresa",
    city: "Tirana",
    country: "Albania",
    lat: 41.4146995544,
    lng: 19.7206001282,
  },
  {
    id: "BOJ",
    name: "Burgas Airport",
    city: "Bourgas",
    country: "Bulgaria",
    lat: 42.56959915161133,
    lng: 27.515199661254883,
  },
  {
    id: "GOZ",
    name: "Gorna Oryahovitsa Airport",
    city: "Gorna Orechovica",
    country: "Bulgaria",
    lat: 43.15140151977539,
    lng: 25.712900161743164,
  },
  {
    id: "PDV",
    name: "Plovdiv International Airport",
    city: "Plovdiv",
    country: "Bulgaria",
    lat: 42.067799,
    lng: 24.8508,
  },
  {
    id: "SOF",
    name: "Sofia Airport",
    city: "Sofia",
    country: "Bulgaria",
    lat: 42.696693420410156,
    lng: 23.411436080932617,
  },
  {
    id: "SZR",
    name: "Stara Zagora Airport",
    city: "Stara Zagora",
    country: "Bulgaria",
    lat: 42.3766667,
    lng: 25.655,
  },
  {
    id: "VAR",
    name: "Varna Airport",
    city: "Varna",
    country: "Bulgaria",
    lat: 43.232101,
    lng: 27.8251,
  },
  {
    id: "LCA",
    name: "Larnaca International Airport",
    city: "Larnaca",
    country: "Cyprus",
    lat: 34.875099182128906,
    lng: 33.624900817871094,
  },
  {
    id: "PFO",
    name: "Paphos International Airport",
    city: "Paphos",
    country: "Cyprus",
    lat: 34.71799850463867,
    lng: 32.48569869995117,
  },
  {
    id: "AKT",
    name: "RAF Akrotiri",
    city: "Akrotiri",
    country: "Cyprus",
    lat: 34.590401,
    lng: 32.9879,
  },
  {
    id: "DBV",
    name: "Dubrovnik Airport",
    city: "Dubrovnik",
    country: "Croatia",
    lat: 42.5614013671875,
    lng: 18.268199920654297,
  },
  {
    id: "N",
    name: "Osijek-Čepin Airfield",
    city: "Cepin",
    country: "Croatia",
    lat: 45.5427778,
    lng: 18.6319444,
  },
  {
    id: "OSI",
    name: "Osijek Airport",
    city: "Osijek",
    country: "Croatia",
    lat: 45.46269989013672,
    lng: 18.810199737548828,
  },
  {
    id: "PUY",
    name: "Pula Airport",
    city: "Pula",
    country: "Croatia",
    lat: 44.89350128173828,
    lng: 13.922200202941895,
  },
  {
    id: "N",
    name: "Grobnicko Polje Airport",
    city: "Grobnik",
    country: "Croatia",
    lat: 45.37950134277344,
    lng: 14.503800392150879,
  },
  {
    id: "RJK",
    name: "Rijeka Airport",
    city: "Rijeka",
    country: "Croatia",
    lat: 45.21689987182617,
    lng: 14.570300102233887,
  },
  {
    id: "SPU",
    name: "Split Airport",
    city: "Split",
    country: "Croatia",
    lat: 43.53889846801758,
    lng: 16.29800033569336,
  },
  {
    id: "N",
    name: "Varaždin Airport",
    city: "Varazdin",
    country: "Croatia",
    lat: 46.294647216796875,
    lng: 16.382932662963867,
  },
  {
    id: "ZAG",
    name: "Zagreb Airport",
    city: "Zagreb",
    country: "Croatia",
    lat: 45.7429008484,
    lng: 16.0687999725,
  },
  {
    id: "ZAD",
    name: "Zadar Airport",
    city: "Zadar",
    country: "Croatia",
    lat: 44.108299,
    lng: 15.3467,
  },
  {
    id: "N",
    name: "Udbina Air Base",
    city: "Udbina",
    country: "Croatia",
    lat: 44.55759811401367,
    lng: 15.774399757385254,
  },
  {
    id: "ABC",
    name: "Albacete-Los Llanos Airport",
    city: "Albacete",
    country: "Spain",
    lat: 38.9485015869,
    lng: -1.8635200262099998,
  },
  {
    id: "ALC",
    name: "Alicante International Airport",
    city: "Alicante",
    country: "Spain",
    lat: 38.28219985961914,
    lng: -0.5581560134887695,
  },
  {
    id: "LEI",
    name: "Almería International Airport",
    city: "Almeria",
    country: "Spain",
    lat: 36.84389877319336,
    lng: -2.3701000213623047,
  },
  {
    id: "OVD",
    name: "Asturias Airport",
    city: "Aviles",
    country: "Spain",
    lat: 43.5635986328125,
    lng: -6.0346198081970215,
  },
  {
    id: "ODB",
    name: "Córdoba Airport",
    city: "Cordoba",
    country: "Spain",
    lat: 37.84199905395508,
    lng: -4.848879814147949,
  },
  {
    id: "BIO",
    name: "Bilbao Airport",
    city: "Bilbao",
    country: "Spain",
    lat: 43.30110168457031,
    lng: -2.9106099605560303,
  },
  {
    id: "BCN",
    name: "Barcelona International Airport",
    city: "Barcelona",
    country: "Spain",
    lat: 41.2971,
    lng: 2.07846,
  },
  {
    id: "BJZ",
    name: "Badajoz Airport",
    city: "Badajoz",
    country: "Spain",
    lat: 38.891300201416016,
    lng: -6.8213300704956055,
  },
  {
    id: "LCG",
    name: "A Coruña Airport",
    city: "La Coruna",
    country: "Spain",
    lat: 43.302101,
    lng: -8.37726,
  },
  {
    id: "N",
    name: "Armilla Air Base",
    city: "Granada",
    country: "Spain",
    lat: 37.1332016,
    lng: -3.63568997,
  },
  {
    id: "GRO",
    name: "Girona Airport",
    city: "Gerona",
    country: "Spain",
    lat: 41.901000977,
    lng: 2.7605500221,
  },
  {
    id: "GRX",
    name: "Federico Garcia Lorca Airport",
    city: "Granada",
    country: "Spain",
    lat: 37.18870162963867,
    lng: -3.777359962463379,
  },
  {
    id: "N",
    name: "Getafe Air Base",
    city: "Madrid",
    country: "Spain",
    lat: 40.29410171508789,
    lng: -3.723829984664917,
  },
  {
    id: "IBZ",
    name: "Ibiza Airport",
    city: "Ibiza",
    country: "Spain",
    lat: 38.872898101800004,
    lng: 1.3731199502899998,
  },
  {
    id: "XRY",
    name: "Jerez Airport",
    city: "Jerez",
    country: "Spain",
    lat: 36.744598388671875,
    lng: -6.060110092163086,
  },
  {
    id: "MJV",
    name: "San Javier Airport",
    city: "Murcia",
    country: "Spain",
    lat: 37.775001525878906,
    lng: -0.8123890161514282,
  },
  {
    id: "MAD",
    name: "Adolfo Suárez Madrid–Barajas Airport",
    city: "Madrid",
    country: "Spain",
    lat: 40.471926,
    lng: -3.56264,
  },
  {
    id: "AGP",
    name: "Málaga Airport",
    city: "Malaga",
    country: "Spain",
    lat: 36.67490005493164,
    lng: -4.499110221862793,
  },
  {
    id: "MAH",
    name: "Menorca Airport",
    city: "Menorca",
    country: "Spain",
    lat: 39.86259841918945,
    lng: 4.218649864196777,
  },
  {
    id: "OZP",
    name: "Moron Air Base",
    city: "Sevilla",
    country: "Spain",
    lat: 37.17490005493164,
    lng: -5.615940093994141,
  },
  {
    id: "N",
    name: "Ocaña Airport",
    city: "Ocana",
    country: "Spain",
    lat: 39.9375,
    lng: -3.5033299922943115,
  },
  {
    id: "PNA",
    name: "Pamplona Airport",
    city: "Pamplona",
    country: "Spain",
    lat: 42.77000045776367,
    lng: -1.6463299989700317,
  },
  {
    id: "N",
    name: "Alcantarilla Air Base",
    city: "Murcia",
    country: "Spain",
    lat: 37.951099,
    lng: -1.23032,
  },
  {
    id: "REU",
    name: "Reus Air Base",
    city: "Reus",
    country: "Spain",
    lat: 41.14739990234375,
    lng: 1.1671700477600098,
  },
  {
    id: "ROZ",
    name: "Rota Naval Station Airport",
    city: "Rota",
    country: "Spain",
    lat: 36.645198822,
    lng: -6.34946012497,
  },
  {
    id: "SLM",
    name: "Salamanca Airport",
    city: "Salamanca",
    country: "Spain",
    lat: 40.95209884643555,
    lng: -5.501989841461182,
  },
  {
    id: "N",
    name: "Son Bonet Airport",
    city: "Son Bonet",
    country: "Spain",
    lat: 39.598899841308594,
    lng: 2.70278000831604,
  },
  {
    id: "N",
    name: "San Luis Airport",
    city: "San Luis",
    country: "Spain",
    lat: 39.86220169067383,
    lng: 4.25832986831665,
  },
  {
    id: "EAS",
    name: "San Sebastian Airport",
    city: "San Sebastian",
    country: "Spain",
    lat: 43.35649871826172,
    lng: -1.7906099557876587,
  },
  {
    id: "SCQ",
    name: "Santiago de Compostela Airport",
    city: "Santiago",
    country: "Spain",
    lat: 42.89630126953125,
    lng: -8.415140151977539,
  },
  {
    id: "LEU",
    name: "Pirineus - la Seu d'Urgel Airport",
    city: "Seo De Urgel",
    country: "Spain",
    lat: 42.3386,
    lng: 1.40917,
  },
  {
    id: "TOJ",
    name: "Torrejón Airport",
    city: "Madrid",
    country: "Spain",
    lat: 40.496700286865234,
    lng: -3.4458699226379395,
  },
  {
    id: "VLC",
    name: "Valencia Airport",
    city: "Valencia",
    country: "Spain",
    lat: 39.4893,
    lng: -0.481625,
  },
  {
    id: "VLL",
    name: "Valladolid Airport",
    city: "Valladolid",
    country: "Spain",
    lat: 41.7061004639,
    lng: -4.85194015503,
  },
  {
    id: "VIT",
    name: "Vitoria/Foronda Airport",
    city: "Vitoria",
    country: "Spain",
    lat: 42.8828010559082,
    lng: -2.7244699001312256,
  },
  {
    id: "VGO",
    name: "Vigo Airport",
    city: "Vigo",
    country: "Spain",
    lat: 42.2318000793457,
    lng: -8.62677001953125,
  },
  {
    id: "SDR",
    name: "Santander Airport",
    city: "Santander",
    country: "Spain",
    lat: 43.427101135253906,
    lng: -3.82000994682312,
  },
  {
    id: "ZAZ",
    name: "Zaragoza Air Base",
    city: "Zaragoza",
    country: "Spain",
    lat: 41.66619873046875,
    lng: -1.0415500402450562,
  },
  {
    id: "SVQ",
    name: "Sevilla Airport",
    city: "Sevilla",
    country: "Spain",
    lat: 37.417999267578125,
    lng: -5.8931097984313965,
  },
  {
    id: "CQF",
    name: "Calais-Dunkerque Airport",
    city: "Calais",
    country: "France",
    lat: 50.962100982666016,
    lng: 1.954759955406189,
  },
  {
    id: "N",
    name: "Péronne-Saint-Quentin Airport",
    city: "Peronne",
    country: "France",
    lat: 49.8685,
    lng: 3.02958,
  },
  {
    id: "N",
    name: "Nangis-Les Loges Airport",
    city: "Nangis",
    country: "France",
    lat: 48.59619903564453,
    lng: 3.0067899227142334,
  },
  {
    id: "N",
    name: "Bagnoles-de-l'Orne-Couterne Airport",
    city: "Bagnole-de-l'orne",
    country: "France",
    lat: 48.545799255371094,
    lng: -0.38744398951530457,
  },
  {
    id: "BYF",
    name: "Albert-Bray Airport",
    city: "Albert",
    country: "France",
    lat: 49.9715003967,
    lng: 2.69765996933,
  },
  {
    id: "LTQ",
    name: "Le Touquet-Côte d'Opale Airport",
    city: "Le Tourquet",
    country: "France",
    lat: 50.517398834228516,
    lng: 1.6205899715423584,
  },
  {
    id: "XVS",
    name: "Valenciennes-Denain Airport",
    city: "Valenciennes",
    country: "France",
    lat: 50.325801849365234,
    lng: 3.4612600803375244,
  },
  {
    id: "N",
    name: "Amiens-Glisy Airport",
    city: "Amiens",
    country: "France",
    lat: 49.873004,
    lng: 2.387074,
  },
  {
    id: "AGF",
    name: "Agen-La Garenne Airport",
    city: "Agen",
    country: "France",
    lat: 44.17470169067383,
    lng: 0.5905560255050659,
  },
  {
    id: "N",
    name: "Cazaux (BA 120) Air Base",
    city: "Cazaux",
    country: "France",
    lat: 44.53329849243164,
    lng: -1.125,
  },
  {
    id: "BOD",
    name: "Bordeaux-Mérignac Airport",
    city: "Bordeaux",
    country: "France",
    lat: 44.828300476100004,
    lng: -0.715556025505,
  },
  {
    id: "EGC",
    name: "Bergerac-Roumanière Airport",
    city: "Bergerac",
    country: "France",
    lat: 44.82529830932617,
    lng: 0.5186110138893127,
  },
  {
    id: "N",
    name: "Toulouse-Francazal (BA 101) Air Base",
    city: "Toulouse",
    country: "France",
    lat: 43.54560089111328,
    lng: 1.3674999475479126,
  },
  {
    id: "CNG",
    name: "Cognac-Châteaubernard (BA 709) Air Base",
    city: "Cognac",
    country: "France",
    lat: 45.65829849243164,
    lng: -0.3174999952316284,
  },
  {
    id: "PIS",
    name: "Poitiers-Biard Airport",
    city: "Poitiers",
    country: "France",
    lat: 46.58769989013672,
    lng: 0.30666598677635193,
  },
  {
    id: "MCU",
    name: "Montluçon-Guéret Airport",
    city: "Montlucon-gueret",
    country: "France",
    lat: 46.222599029541016,
    lng: 2.363960027694702,
  },
  {
    id: "LIG",
    name: "Limoges Airport",
    city: "Limoges",
    country: "France",
    lat: 45.86280059814453,
    lng: 1.1794400215148926,
  },
  {
    id: "N",
    name: "Mont-de-Marsan (BA 118) Air Base",
    city: "Mont-de-marsan",
    country: "France",
    lat: 43.911701,
    lng: -0.5075,
  },
  {
    id: "NIT",
    name: "Niort-Souché Airport",
    city: "Niort",
    country: "France",
    lat: 46.313477,
    lng: -0.394529,
  },
  {
    id: "TLS",
    name: "Toulouse-Blagnac Airport",
    city: "Toulouse",
    country: "France",
    lat: 43.629101,
    lng: 1.36382,
  },
  {
    id: "PUF",
    name: "Pau Pyrénées Airport",
    city: "Pau",
    country: "France",
    lat: 43.380001068115234,
    lng: -0.41861099004745483,
  },
  {
    id: "N",
    name: "Muret-Lherm Airport",
    city: "La Rochelle",
    country: "France",
    lat: 43.44889831542969,
    lng: 1.2633299827575684,
  },
  {
    id: "LDE",
    name: "Tarbes-Lourdes-Pyrénées Airport",
    city: "Tarbes",
    country: "France",
    lat: 43.1786994934082,
    lng: -0.006438999902456999,
  },
  {
    id: "ANG",
    name: "Angoulême-Brie-Champniers Airport",
    city: "Angouleme",
    country: "France",
    lat: 45.72919845581055,
    lng: 0.22145600616931915,
  },
  {
    id: "BVE",
    name: "Brive Souillac Airport",
    city: "Brive",
    country: "France",
    lat: 45.039722,
    lng: 1.485556,
  },
  {
    id: "PGX",
    name: "Périgueux-Bassillac Airport",
    city: "Perigueux",
    country: "France",
    lat: 45.19810104370117,
    lng: 0.815555989742279,
  },
  {
    id: "BIQ",
    name: "Biarritz-Anglet-Bayonne Airport",
    city: "Biarritz-bayonne",
    country: "France",
    lat: 43.4683333,
    lng: -1.5311111,
  },
  {
    id: "ZAO",
    name: "Cahors-Lalbenque Airport",
    city: "Cahors",
    country: "France",
    lat: 44.35139846801758,
    lng: 1.4752800464630127,
  },
  {
    id: "N",
    name: "Saint-Girons-Antichan Airport",
    city: "St.-girons",
    country: "France",
    lat: 43.0078010559082,
    lng: 1.1031500101089478,
  },
  {
    id: "N",
    name: "Arcachon-La Teste-de-Buch Airport",
    city: "Arcachon",
    country: "France",
    lat: 44.596401,
    lng: -1.11083,
  },
  {
    id: "LBI",
    name: "Albi-Le Séquestre Airport",
    city: "Albi",
    country: "France",
    lat: 43.91389846801758,
    lng: 2.1130599975585938,
  },
  {
    id: "DCM",
    name: "Castres-Mazamet Airport",
    city: "Castres",
    country: "France",
    lat: 43.55630111694336,
    lng: 2.289180040359497,
  },
  {
    id: "N",
    name: "Toulouse-Lasbordes Airport",
    city: "Toulouse",
    country: "France",
    lat: 43.58610153198242,
    lng: 1.499169945716858,
  },
  {
    id: "N",
    name: "Millau-Larzac Airfield",
    city: "Millau",
    country: "France",
    lat: 43.9893,
    lng: 3.183,
  },
  {
    id: "N",
    name: "Graulhet-Montdragon Airport",
    city: "Graulhet",
    country: "France",
    lat: 43.77109909057617,
    lng: 2.0108299255371094,
  },
  {
    id: "RDZ",
    name: "Rodez-Marcillac Airport",
    city: "Rodez",
    country: "France",
    lat: 44.407901763916016,
    lng: 2.4826700687408447,
  },
  {
    id: "N",
    name: "Ussel-Thalamy Airport",
    city: "Ussel",
    country: "France",
    lat: 45.534698486328125,
    lng: 2.4238901138305664,
  },
  {
    id: "N",
    name: "Villeneuve-sur-Lot Airport",
    city: "Villeneuve-sur-lot",
    country: "France",
    lat: 44.39690017700195,
    lng: 0.7588890194892883,
  },
  {
    id: "RYN",
    name: "Royan-Médis Airport",
    city: "Royan",
    country: "France",
    lat: 45.62810134887695,
    lng: -0.9725000262260437,
  },
  {
    id: "N",
    name: "Mimizan Airport",
    city: "Mimizan",
    country: "France",
    lat: 44.145928,
    lng: -1.16432,
  },
  {
    id: "N",
    name: "Aire-sur-l'Adour Airport",
    city: "Aire-sur-l'adour",
    country: "France",
    lat: 43.70940017700195,
    lng: -0.245278000831604,
  },
  {
    id: "XMW",
    name: "Montauban Airport",
    city: "Montauban",
    country: "France",
    lat: 44.025699615478516,
    lng: 1.3780399560928345,
  },
  {
    id: "N",
    name: "Auch-Lamothe Airport",
    city: "Auch",
    country: "France",
    lat: 43.687801,
    lng: 0.601667,
  },
  {
    id: "N",
    name: "Libourne-Artigues-de-Lussac Airport",
    city: "Libourne",
    country: "France",
    lat: 44.982498,
    lng: -0.134722,
  },
  {
    id: "N",
    name: "Pamiers-Les Pujols Airport",
    city: "Pamiers",
    country: "France",
    lat: 43.090599060058594,
    lng: 1.69582998752594,
  },
  {
    id: "N",
    name: "Marmande-Virazeil Airport",
    city: "Marmande",
    country: "France",
    lat: 44.4989013671875,
    lng: 0.20051400363445282,
  },
  {
    id: "RCO",
    name: "Rochefort-Saint-Agnant (BA 721) Airport",
    city: "Rochefort",
    country: "France",
    lat: 45.88779830932617,
    lng: -0.9830560088157654,
  },
  {
    id: "N",
    name: "Pontivy Airport",
    city: "Pontivy",
    country: "France",
    lat: 48.05849838256836,
    lng: -2.92182993888855,
  },
  {
    id: "N",
    name: "Aubigny-sur-Nère Airport",
    city: "Aubigny-sur-nere",
    country: "France",
    lat: 47.480556,
    lng: 2.394167,
  },
  {
    id: "N",
    name: "Guiscriff Scaer Airport",
    city: "Guiscriff-scaer",
    country: "France",
    lat: 48.0525016784668,
    lng: -3.664720058441162,
  },
  {
    id: "N",
    name: "Ancenis Airport",
    city: "Ancenis",
    country: "France",
    lat: 47.40810012817383,
    lng: -1.1775000095367432,
  },
  {
    id: "N",
    name: "Brienne-le-Château Airport",
    city: "Brienne-le Chateau",
    country: "France",
    lat: 48.4297981262207,
    lng: 4.48222017288208,
  },
  {
    id: "CMR",
    name: "Colmar-Houssen Airport",
    city: "Colmar",
    country: "France",
    lat: 48.109901428222656,
    lng: 7.359010219573975,
  },
  {
    id: "N",
    name: "Beaune-Challanges Airport",
    city: "Beaune",
    country: "France",
    lat: 47.005901,
    lng: 4.89342,
  },
  {
    id: "DLE",
    name: "Dole-Tavaux Airport",
    city: "Dole",
    country: "France",
    lat: 47.042686,
    lng: 5.435063,
  },
  {
    id: "N",
    name: "Joigny Airport",
    city: "Joigny",
    country: "France",
    lat: 47.9921989440918,
    lng: 3.3922200202941895,
  },
  {
    id: "N",
    name: "Verdun-Le Rozelier Airfield",
    city: "Verdun",
    country: "France",
    lat: 49.122398,
    lng: 5.46905,
  },
  {
    id: "OBS",
    name: "Aubenas-Ardèche Méridional Airport",
    city: "Aubenas-vals-lanas",
    country: "France",
    lat: 44.544203,
    lng: 4.372192,
  },
  {
    id: "LPY",
    name: "Le Puy-Loudes Airport",
    city: "Le Puy",
    country: "France",
    lat: 45.0806999206543,
    lng: 3.762890100479126,
  },
  {
    id: "N",
    name: "Saint-Flour-Coltines Airport",
    city: "St.-flour",
    country: "France",
    lat: 45.07640075683594,
    lng: 2.99360990524292,
  },
  {
    id: "N",
    name: "Bourg-Ceyzériat Airport",
    city: "Bourg",
    country: "France",
    lat: 46.20090103149414,
    lng: 5.292029857635498,
  },
  {
    id: "N",
    name: "Villefranche-Tarare Airport",
    city: "Vilefrance",
    country: "France",
    lat: 45.919983,
    lng: 4.634931,
  },
  {
    id: "N",
    name: "Moulins-Montbeugny Airport",
    city: "Moulins",
    country: "France",
    lat: 46.53459930419922,
    lng: 3.423719882965088,
  },
  {
    id: "N",
    name: "Saint-Affrique-Belmont Airport",
    city: "St.-afrique-belmont",
    country: "France",
    lat: 43.823299407958984,
    lng: 2.7452800273895264,
  },
  {
    id: "N",
    name: "Cassagnes-Bégonhès Airport",
    city: "Cassagnes-beghones",
    country: "France",
    lat: 44.177799224853516,
    lng: 2.515000104904175,
  },
  {
    id: "ETZ",
    name: "Metz-Nancy-Lorraine Airport",
    city: "Metz",
    country: "France",
    lat: 48.9821014404,
    lng: 6.25131988525,
  },
  {
    id: "BIA",
    name: "Bastia-Poretta Airport",
    city: "Bastia",
    country: "France",
    lat: 42.55270004272461,
    lng: 9.48373031616211,
  },
  {
    id: "CLY",
    name: "Calvi-Sainte-Catherine Airport",
    city: "Calvi",
    country: "France",
    lat: 42.5244444,
    lng: 8.7930556,
  },
  {
    id: "FSC",
    name: "Figari Sud-Corse Airport",
    city: "Figari",
    country: "France",
    lat: 41.5005989074707,
    lng: 9.097780227661133,
  },
  {
    id: "AJA",
    name: "Ajaccio-Napoléon Bonaparte Airport",
    city: "Ajaccio",
    country: "France",
    lat: 41.92359924316406,
    lng: 8.8029203414917,
  },
  {
    id: "PRP",
    name: "Propriano Airport",
    city: "Propriano",
    country: "France",
    lat: 41.66059875488281,
    lng: 8.889749526977539,
  },
  {
    id: "SOZ",
    name: "Solenzara (BA 126) Air Base",
    city: "Solenzara",
    country: "France",
    lat: 41.924400329589844,
    lng: 9.406000137329102,
  },
  {
    id: "N",
    name: "Corte Airport",
    city: "Corte",
    country: "France",
    lat: 42.29359817504883,
    lng: 9.193059921264648,
  },
  {
    id: "AUF",
    name: "Auxerre-Branches Airport",
    city: "Auxerre",
    country: "France",
    lat: 47.85020065307617,
    lng: 3.497109889984131,
  },
  {
    id: "CMF",
    name: "Chambéry-Savoie Airport",
    city: "Chambery",
    country: "France",
    lat: 45.638099670410156,
    lng: 5.880229949951172,
  },
  {
    id: "CFE",
    name: "Clermont-Ferrand Auvergne Airport",
    city: "Clermont-Ferrand",
    country: "France",
    lat: 45.7867012024,
    lng: 3.1691699028,
  },
  {
    id: "BOU",
    name: "Bourges Airport",
    city: "Bourges",
    country: "France",
    lat: 47.058101654052734,
    lng: 2.3702800273895264,
  },
  {
    id: "N",
    name: "Chambéry-Challes-les-Eaux Airport",
    city: "Chambery",
    country: "France",
    lat: 45.5611000061,
    lng: 5.975759983060001,
  },
  {
    id: "N",
    name: "Chalon-Champforgeuil Airport",
    city: "Chalon",
    country: "France",
    lat: 46.82609939575195,
    lng: 4.817629814147949,
  },
  {
    id: "QNJ",
    name: "Annemasse Airport",
    city: "Annemasse",
    country: "France",
    lat: 46.1920013428,
    lng: 6.268390178680001,
  },
  {
    id: "LYS",
    name: "Lyon Saint-Exupéry Airport",
    city: "Lyon",
    country: "France",
    lat: 45.725556,
    lng: 5.081111,
  },
  {
    id: "N",
    name: "Mâcon-Charnay Airport",
    city: "Macon",
    country: "France",
    lat: 46.295101,
    lng: 4.79577,
  },
  {
    id: "SYT",
    name: "Saint-Yan Airport",
    city: "St.-yan",
    country: "France",
    lat: 46.412498474121094,
    lng: 4.0132598876953125,
  },
  {
    id: "RNE",
    name: "Roanne-Renaison Airport",
    city: "Roanne",
    country: "France",
    lat: 46.05830001831055,
    lng: 4.001389980316162,
  },
  {
    id: "NCY",
    name: "Annecy-Haute-Savoie-Mont Blanc Airport",
    city: "Annecy",
    country: "France",
    lat: 45.9308333,
    lng: 6.1063889,
  },
  {
    id: "GNB",
    name: "Grenoble-Isère Airport",
    city: "Grenoble",
    country: "France",
    lat: 45.36289978027344,
    lng: 5.329370021820068,
  },
  {
    id: "N",
    name: "Montluçon-Domérat Airport",
    city: "Montlucon",
    country: "France",
    lat: 46.352501,
    lng: 2.57049,
  },
  {
    id: "VAF",
    name: "Valence-Chabeuil Airport",
    city: "Valence",
    country: "France",
    lat: 44.9216,
    lng: 4.9699,
  },
  {
    id: "VHY",
    name: "Vichy-Charmeil Airport",
    city: "Vichy",
    country: "France",
    lat: 46.169700622558594,
    lng: 3.4037399291992188,
  },
  {
    id: "AUR",
    name: "Aurillac Airport",
    city: "Aurillac",
    country: "France",
    lat: 44.89139938354492,
    lng: 2.4219400882720947,
  },
  {
    id: "CHR",
    name: 'Châteauroux-Déols "Marcel Dassault" Airport',
    city: "Chateauroux",
    country: "France",
    lat: 46.860278,
    lng: 1.721111,
  },
  {
    id: "LYN",
    name: "Lyon-Bron Airport",
    city: "Lyon",
    country: "France",
    lat: 45.72719955444336,
    lng: 4.944270133972168,
  },
  {
    id: "N",
    name: "Aix-en-Provence (BA 114) Airport",
    city: "Aix-les-milles",
    country: "France",
    lat: 43.5056,
    lng: 5.36778,
  },
  {
    id: "N",
    name: "Le Luc-Le Cannet Airport",
    city: "Le Luc",
    country: "France",
    lat: 43.384700775146484,
    lng: 6.387139797210693,
  },
  {
    id: "CEQ",
    name: "Cannes-Mandelieu Airport",
    city: "Cannes",
    country: "France",
    lat: 43.542,
    lng: 6.95348,
  },
  {
    id: "EBU",
    name: "Saint-Étienne-Bouthéon Airport",
    city: "St-Etienne",
    country: "France",
    lat: 45.54059982299805,
    lng: 4.296390056610107,
  },
  {
    id: "N",
    name: "Istres Le Tubé/Istres Air Base (BA 125) Airport",
    city: "Istres",
    country: "France",
    lat: 43.522701,
    lng: 4.92384,
  },
  {
    id: "CCF",
    name: "Carcassonne Airport",
    city: "Carcassonne",
    country: "France",
    lat: 43.215999603271484,
    lng: 2.3063199520111084,
  },
  {
    id: "MRS",
    name: "Marseille Provence Airport",
    city: "Marseille",
    country: "France",
    lat: 43.439271922,
    lng: 5.22142410278,
  },
  {
    id: "NCE",
    name: "Nice-Côte d'Azur Airport",
    city: "Nice",
    country: "France",
    lat: 43.6584014893,
    lng: 7.215869903560001,
  },
  {
    id: "XOG",
    name: "Orange-Caritat (BA 115) Air Base",
    city: "Orange",
    country: "France",
    lat: 44.140499114990234,
    lng: 4.866720199584961,
  },
  {
    id: "PGF",
    name: "Perpignan-Rivesaltes (Llabanère) Airport",
    city: "Perpignan",
    country: "France",
    lat: 42.74039840698242,
    lng: 2.8706700801849365,
  },
  {
    id: "CTT",
    name: "Le Castellet Airport",
    city: "Le Castellet",
    country: "France",
    lat: 43.252498626708984,
    lng: 5.785190105438232,
  },
  {
    id: "N",
    name: "Alès-Deaux Airport",
    city: "Ales",
    country: "France",
    lat: 44.069698,
    lng: 4.14212,
  },
  {
    id: "MPL",
    name: "Montpellier-Méditerranée Airport",
    city: "Montpellier",
    country: "France",
    lat: 43.57619857788086,
    lng: 3.96301007270813,
  },
  {
    id: "BZR",
    name: "Béziers-Vias Airport",
    city: "Beziers",
    country: "France",
    lat: 43.32350158691406,
    lng: 3.3538999557495117,
  },
  {
    id: "AVN",
    name: "Avignon-Caumont Airport",
    city: "Avignon",
    country: "France",
    lat: 43.90729904174805,
    lng: 4.901830196380615,
  },
  {
    id: "N",
    name: "Salon-de-Provence (BA 701) Air Base",
    city: "Salon",
    country: "France",
    lat: 43.60639953613281,
    lng: 5.109250068664551,
  },
  {
    id: "N",
    name: "Lézignan-Corbières Airfield",
    city: "Lezignan-corbieres",
    country: "France",
    lat: 43.1758,
    lng: 2.73417,
  },
  {
    id: "MEN",
    name: "Mende-Brenoux Airfield",
    city: "Mende",
    country: "France",
    lat: 44.502102,
    lng: 3.53282,
  },
  {
    id: "N",
    name: "Carpentras Airport",
    city: "Carpentras",
    country: "France",
    lat: 44.02980041503906,
    lng: 5.078060150146484,
  },
  {
    id: "N",
    name: "Avord (BA 702) Air Base",
    city: "Avord",
    country: "France",
    lat: 47.053299,
    lng: 2.6325,
  },
  {
    id: "BVA",
    name: "Paris Beauvais Tillé Airport",
    city: "Beauvais",
    country: "France",
    lat: 49.45439910888672,
    lng: 2.1127800941467285,
  },
  {
    id: "N",
    name: "Châteaudun (BA 279) Air Base",
    city: "Chateaudun",
    country: "France",
    lat: 48.058102,
    lng: 1.37662,
  },
  {
    id: "N",
    name: "Saumur-Saint-Florent Airport",
    city: "Saumur",
    country: "France",
    lat: 47.256802,
    lng: -0.115142,
  },
  {
    id: "EVX",
    name: "Évreux-Fauville (BA 105) Air Base",
    city: "Evreux",
    country: "France",
    lat: 49.02870178222656,
    lng: 1.2198599576950073,
  },
  {
    id: "LEH",
    name: "Le Havre Octeville Airport",
    city: "Le Havre",
    country: "France",
    lat: 49.53390121459961,
    lng: 0.08805599808692932,
  },
  {
    id: "XAB",
    name: "Abbeville",
    city: "Abbeville",
    country: "France",
    lat: 50.143501,
    lng: 1.831891,
  },
  {
    id: "ORE",
    name: "Orléans-Bricy (BA 123) Air Base",
    city: "Orleans",
    country: "France",
    lat: 47.9878005981,
    lng: 1.7605600357100002,
  },
  {
    id: "XCR",
    name: "Châlons-Vatry Airport",
    city: "Chalons",
    country: "France",
    lat: 48.7733333333,
    lng: 4.206111111,
  },
  {
    id: "URO",
    name: "Rouen Airport",
    city: "Rouen",
    country: "France",
    lat: 49.38420104980469,
    lng: 1.1748000383377075,
  },
  {
    id: "TUF",
    name: "Tours-Val-de-Loire Airport",
    city: "Tours",
    country: "France",
    lat: 47.4322013855,
    lng: 0.727605998516,
  },
  {
    id: "CET",
    name: "Cholet Le Pontreau Airport",
    city: "Cholet",
    country: "France",
    lat: 47.08209991455078,
    lng: -0.8770639896392822,
  },
  {
    id: "LVA",
    name: "Laval-Entrammes Airport",
    city: "Laval",
    country: "France",
    lat: 48.03139877319336,
    lng: -0.7429860234260559,
  },
  {
    id: "N",
    name: "Orléans-Saint-Denis-de-l'Hôtel Airport",
    city: "Orleans",
    country: "France",
    lat: 47.8969,
    lng: 2.16333,
  },
  {
    id: "LBG",
    name: "Paris-Le Bourget Airport",
    city: "Paris",
    country: "France",
    lat: 48.969398498535156,
    lng: 2.441390037536621,
  },
  {
    id: "CSF",
    name: "Creil Air Base",
    city: "Creil",
    country: "France",
    lat: 49.253501892089844,
    lng: 2.5191400051116943,
  },
  {
    id: "CDG",
    name: "Charles de Gaulle International Airport",
    city: "Paris",
    country: "France",
    lat: 49.012798,
    lng: 2.55,
  },
  {
    id: "N",
    name: "Coulommiers-Voisins Airport",
    city: "Coulommiers",
    country: "France",
    lat: 48.83769989013672,
    lng: 3.016119956970215,
  },
  {
    id: "N",
    name: "Melun-Villaroche Air Base",
    city: "Melun",
    country: "France",
    lat: 48.604698181152344,
    lng: 2.6711199283599854,
  },
  {
    id: "TNF",
    name: "Toussus-le-Noble Airport",
    city: "Toussous-le-noble",
    country: "France",
    lat: 48.75189971923828,
    lng: 2.1061899662017822,
  },
  {
    id: "ORY",
    name: "Paris-Orly Airport",
    city: "Paris",
    country: "France",
    lat: 48.7233333,
    lng: 2.3794444,
  },
  {
    id: "POX",
    name: "Pontoise - Cormeilles-en-Vexin Airport",
    city: "Pontoise",
    country: "France",
    lat: 49.096667,
    lng: 2.040833,
  },
  {
    id: "VIY",
    name: "Villacoublay-Vélizy (BA 107) Air Base",
    city: "Villacoublay",
    country: "France",
    lat: 48.7741667,
    lng: 2.1916667,
  },
  {
    id: "N",
    name: "Reims-Prunay Airport",
    city: "Reims",
    country: "France",
    lat: 49.20869827270508,
    lng: 4.156579971313477,
  },
  {
    id: "N",
    name: "Troyes-Barberey Airport",
    city: "Troyes",
    country: "France",
    lat: 48.322102,
    lng: 4.0167,
  },
  {
    id: "N",
    name: "Lunéville-Croismare Airport",
    city: "Luneville",
    country: "France",
    lat: 48.593299865722656,
    lng: 6.543459892272949,
  },
  {
    id: "N",
    name: "Étain-Rouvres Air Base",
    city: "Etain",
    country: "France",
    lat: 49.226898193359375,
    lng: 5.672220230102539,
  },
  {
    id: "N",
    name: "Autun-Bellevue Airport",
    city: "Autun",
    country: "France",
    lat: 46.96730041503906,
    lng: 4.260570049285889,
  },
  {
    id: "NVS",
    name: "Nevers-Fourchambault Airport",
    city: "Nevers",
    country: "France",
    lat: 47.002601623535156,
    lng: 3.1133298873901367,
  },
  {
    id: "N",
    name: "Cambrai-Épinoy (BA 103) Air Base",
    city: "Cambrai",
    country: "France",
    lat: 50.221802,
    lng: 3.15424,
  },
  {
    id: "XME",
    name: "Maubeuge-Élesmes Airport",
    city: "Maubeuge",
    country: "France",
    lat: 50.31050109863281,
    lng: 4.033120155334473,
  },
  {
    id: "N",
    name: "Besançon-La Vèze Airport",
    city: "Besancon-la-veze",
    country: "France",
    lat: 47.2066,
    lng: 6.083681,
  },
  {
    id: "N",
    name: "Phalsbourg-Bourscheid Air Base",
    city: "Phalsbourg",
    country: "France",
    lat: 48.7680556,
    lng: 7.205,
  },
  {
    id: "LIL",
    name: "Lille-Lesquin Airport",
    city: "Lille",
    country: "France",
    lat: 50.563332,
    lng: 3.086886,
  },
  {
    id: "HZB",
    name: "Merville-Calonne Airport",
    city: "Merville",
    country: "France",
    lat: 50.61840057373047,
    lng: 2.642240047454834,
  },
  {
    id: "XCZ",
    name: "Charleville-Mézières Airport",
    city: "Charleville",
    country: "France",
    lat: 49.78390121459961,
    lng: 4.647079944610596,
  },
  {
    id: "N",
    name: "Vesoul-Frotey Airport",
    city: "Vesoul-frotey",
    country: "France",
    lat: 47.6376,
    lng: 6.20392,
  },
  {
    id: "BES",
    name: "Brest Bretagne Airport",
    city: "Brest",
    country: "France",
    lat: 48.447898864746094,
    lng: -4.418540000915527,
  },
  {
    id: "CER",
    name: "Cherbourg-Maupertus Airport",
    city: "Cherbourg",
    country: "France",
    lat: 49.65010070800781,
    lng: -1.4702800512313843,
  },
  {
    id: "DNR",
    name: "Dinard-Pleurtuit-Saint-Malo Airport",
    city: "Dinard",
    country: "France",
    lat: 48.58769989013672,
    lng: -2.0799601078033447,
  },
  {
    id: "LBY",
    name: "La Baule-Escoublac Airport",
    city: "La Baule",
    country: "France",
    lat: 47.289398193359375,
    lng: -2.3463900089263916,
  },
  {
    id: "GFR",
    name: "Granville Airport",
    city: "Granville",
    country: "France",
    lat: 48.88309860229492,
    lng: -1.564170002937317,
  },
  {
    id: "DOL",
    name: "Deauville-Saint-Gatien Airport",
    city: "Deauville",
    country: "France",
    lat: 49.3652992249,
    lng: 0.154305994511,
  },
  {
    id: "LRT",
    name: "Lorient South Brittany (Bretagne Sud) Airport",
    city: "Lorient",
    country: "France",
    lat: 47.76060104370117,
    lng: -3.440000057220459,
  },
  {
    id: "EDM",
    name: "La Roche-sur-Yon Airport",
    city: "La Roche-sur-yon",
    country: "France",
    lat: 46.701900482177734,
    lng: -1.3786300420761108,
  },
  {
    id: "LDV",
    name: "Landivisiau Air Base",
    city: "Landivisiau",
    country: "France",
    lat: 48.53030014038086,
    lng: -4.151639938354492,
  },
  {
    id: "CFR",
    name: "Caen-Carpiquet Airport",
    city: "Caen",
    country: "France",
    lat: 49.173301696777344,
    lng: -0.44999998807907104,
  },
  {
    id: "N",
    name: "Lanvéoc-Poulmic Air Base",
    city: "Lanvedoc",
    country: "France",
    lat: 48.281700134277344,
    lng: -4.4450201988220215,
  },
  {
    id: "LME",
    name: "Le Mans-Arnage Airport",
    city: "Le Mans",
    country: "France",
    lat: 47.94860076904297,
    lng: 0.20166699588298798,
  },
  {
    id: "RNS",
    name: "Rennes-Saint-Jacques Airport",
    city: "Rennes",
    country: "France",
    lat: 48.069499969499994,
    lng: -1.73478996754,
  },
  {
    id: "LAI",
    name: "Lannion-Côte de Granit Airport",
    city: "Lannion",
    country: "France",
    lat: 48.754398,
    lng: -3.47166,
  },
  {
    id: "UIP",
    name: "Quimper-Cornouaille Airport",
    city: "Quimper",
    country: "France",
    lat: 47.974998474121094,
    lng: -4.167789936065674,
  },
  {
    id: "NTE",
    name: "Nantes Atlantique Airport",
    city: "Nantes",
    country: "France",
    lat: 47.153198242200006,
    lng: -1.61073005199,
  },
  {
    id: "SBK",
    name: "Saint-Brieuc-Armor Airport",
    city: "St.-brieuc Armor",
    country: "France",
    lat: 48.5378,
    lng: -2.85444,
  },
  {
    id: "MXN",
    name: "Morlaix-Ploujean Airport",
    city: "Morlaix",
    country: "France",
    lat: 48.6031990051,
    lng: -3.81577992439,
  },
  {
    id: "VNE",
    name: "Vannes-Meucon Airport",
    city: "Vannes",
    country: "France",
    lat: 47.72330093383789,
    lng: -2.718559980392456,
  },
  {
    id: "SNR",
    name: "Saint-Nazaire-Montoir Airport",
    city: "St.-nazaire",
    country: "France",
    lat: 47.3105556,
    lng: -2.1566667,
  },
  {
    id: "BSL",
    name: "EuroAirport Basel-Mulhouse-Freiburg Airport",
    city: "Mulhouse",
    country: "France",
    lat: 47.59,
    lng: 7.5291667,
  },
  {
    id: "N",
    name: "Colmar-Meyenheim Air Base",
    city: "Colmar",
    country: "France",
    lat: 47.922000885,
    lng: 7.39967012405,
  },
  {
    id: "DIJ",
    name: "Dijon-Bourgogne Airport",
    city: "Dijon",
    country: "France",
    lat: 47.268902,
    lng: 5.09,
  },
  {
    id: "MZM",
    name: "Metz-Frescaty (BA 128) Air Base",
    city: "Metz",
    country: "France",
    lat: 49.07170104980469,
    lng: 6.131669998168945,
  },
  {
    id: "EPL",
    name: "Épinal-Mirecourt Airport",
    city: "Epinal",
    country: "France",
    lat: 48.325001,
    lng: 6.06998,
  },
  {
    id: "N",
    name: "Haguenau Airport",
    city: "Haguenau",
    country: "France",
    lat: 48.7943000793,
    lng: 7.81760978699,
  },
  {
    id: "N",
    name: "Saint-Dizier-Robinson (BA 113) Air Base",
    city: "St.-dizier",
    country: "France",
    lat: 48.63600158691406,
    lng: 4.899419784545898,
  },
  {
    id: "N",
    name: "Montbéliard-Courcelles Airfield",
    city: "Montbeliard",
    country: "France",
    lat: 47.487,
    lng: 6.79054,
  },
  {
    id: "ENC",
    name: "Nancy-Essey Airport",
    city: "Nancy",
    country: "France",
    lat: 48.692100524902344,
    lng: 6.230460166931152,
  },
  {
    id: "N",
    name: "Nancy-Ochey (BA 133) Air Base",
    city: "Nancy",
    country: "France",
    lat: 48.583099365234375,
    lng: 5.954999923706055,
  },
  {
    id: "N",
    name: "Pontarlier Airport",
    city: "Pontarlier",
    country: "France",
    lat: 46.90399932861328,
    lng: 6.3273701667785645,
  },
  {
    id: "RHE",
    name: "Reims-Champagne (BA 112) Air Base",
    city: "Reims",
    country: "France",
    lat: 49.310001,
    lng: 4.05,
  },
  {
    id: "SXB",
    name: "Strasbourg Airport",
    city: "Strasbourg",
    country: "France",
    lat: 48.538299560546875,
    lng: 7.628230094909668,
  },
  {
    id: "N",
    name: "Luxeuil-Saint-Sauveur (BA 116) Air Base",
    city: "Luxeuil",
    country: "France",
    lat: 47.7830556,
    lng: 6.36416667,
  },
  {
    id: "N",
    name: "Cuers-Pierrefeu Airport",
    city: "Cuers",
    country: "France",
    lat: 43.247798919677734,
    lng: 6.126699924468994,
  },
  {
    id: "TLN",
    name: "Toulon-Hyères Airport",
    city: "Hyeres",
    country: "France",
    lat: 43.0973014832,
    lng: 6.14602994919,
  },
  {
    id: "FNI",
    name: "Nîmes-Arles-Camargue Airport",
    city: "Nimes",
    country: "France",
    lat: 43.75740051269531,
    lng: 4.4163498878479,
  },
  {
    id: "MQC",
    name: "Miquelon Airport",
    city: "Miquelon",
    country: "Saint Pierre and Miquelon",
    lat: 47.095500946,
    lng: -56.3802986145,
  },
  {
    id: "FSP",
    name: "St Pierre Airport",
    city: "St.-pierre",
    country: "Saint Pierre and Miquelon",
    lat: 46.762901306152344,
    lng: -56.173099517822266,
  },
  {
    id: "N",
    name: "Ambérieu Air Base (BA 278)",
    city: "Amberieu",
    country: "France",
    lat: 45.987301,
    lng: 5.32844,
  },
  {
    id: "N",
    name: "Damblain Airport",
    city: "Damblain",
    country: "France",
    lat: 48.086299896240234,
    lng: 5.664060115814209,
  },
  {
    id: "PYR",
    name: "Andravida Air Base",
    city: "Andravida",
    country: "Greece",
    lat: 37.9207,
    lng: 21.292601,
  },
  {
    id: "AGQ",
    name: "Agrinion Air Base",
    city: "Agrinion",
    country: "Greece",
    lat: 38.602001,
    lng: 21.3512001,
  },
  {
    id: "AXD",
    name: "Dimokritos Airport",
    city: "Alexandroupolis",
    country: "Greece",
    lat: 40.855899810791016,
    lng: 25.956300735473633,
  },
  {
    id: "N",
    name: "Alexandria Airport",
    city: "Alexandria",
    country: "Greece",
    lat: 40.651100158691406,
    lng: 22.48870086669922,
  },
  {
    id: "VOL",
    name: "Nea Anchialos Airport",
    city: "Nea Anghialos",
    country: "Greece",
    lat: 39.219600677490234,
    lng: 22.794300079345703,
  },
  {
    id: "N",
    name: "Elefsis Airport",
    city: "Elefsis",
    country: "Greece",
    lat: 38.06380081176758,
    lng: 23.555999755859375,
  },
  {
    id: "JKH",
    name: "Chios Island National Airport",
    city: "Chios",
    country: "Greece",
    lat: 38.34320068359375,
    lng: 26.140600204467773,
  },
  {
    id: "IOA",
    name: "Ioannina Airport",
    city: "Ioannina",
    country: "Greece",
    lat: 39.6963996887207,
    lng: 20.822500228881836,
  },
  {
    id: "HER",
    name: "Heraklion International Nikos Kazantzakis Airport",
    city: "Heraklion",
    country: "Greece",
    lat: 35.3396987915,
    lng: 25.180299758900002,
  },
  {
    id: "KSO",
    name: "Kastoria National Airport",
    city: "Kastoria",
    country: "Greece",
    lat: 40.4463005066,
    lng: 21.2821998596,
  },
  {
    id: "KIT",
    name: "Kithira Airport",
    city: "Kithira",
    country: "Greece",
    lat: 36.2742996216,
    lng: 23.0170001984,
  },
  {
    id: "EFL",
    name: "Kefallinia Airport",
    city: "Keffallinia",
    country: "Greece",
    lat: 38.12009811401367,
    lng: 20.500499725341797,
  },
  {
    id: "KLX",
    name: "Kalamata Airport",
    city: "Kalamata",
    country: "Greece",
    lat: 37.06829833984375,
    lng: 22.02549934387207,
  },
  {
    id: "N",
    name: "Amigdhaleon Airport",
    city: "Kavala",
    country: "Greece",
    lat: 40.972801208496094,
    lng: 24.341400146484375,
  },
  {
    id: "KGS",
    name: "Kos Airport",
    city: "Kos",
    country: "Greece",
    lat: 36.79330062866211,
    lng: 27.091699600219727,
  },
  {
    id: "AOK",
    name: "Karpathos Airport",
    city: "Karpathos",
    country: "Greece",
    lat: 35.4213981628418,
    lng: 27.145999908447266,
  },
  {
    id: "CFU",
    name: "Ioannis Kapodistrias International Airport",
    city: "Kerkyra/corfu",
    country: "Greece",
    lat: 39.601898193359375,
    lng: 19.911699295043945,
  },
  {
    id: "KSJ",
    name: "Kasos Airport",
    city: "Kasos",
    country: "Greece",
    lat: 35.4213981628,
    lng: 26.909999847399998,
  },
  {
    id: "KVA",
    name: "Alexander the Great International Airport",
    city: "Kavala",
    country: "Greece",
    lat: 40.913299560546875,
    lng: 24.619199752807617,
  },
  {
    id: "KZI",
    name: "Filippos Airport",
    city: "Kozani",
    country: "Greece",
    lat: 40.28609848022461,
    lng: 21.84079933166504,
  },
  {
    id: "LRS",
    name: "Leros Airport",
    city: "Leros",
    country: "Greece",
    lat: 37.184898,
    lng: 26.800301,
  },
  {
    id: "LXS",
    name: "Limnos Airport",
    city: "Limnos",
    country: "Greece",
    lat: 39.917098999,
    lng: 25.236299514799995,
  },
  {
    id: "LRA",
    name: "Larisa Airport",
    city: "Larissa",
    country: "Greece",
    lat: 39.650253,
    lng: 22.4655,
  },
  {
    id: "N",
    name: "Megara Airport",
    city: "Megara",
    country: "Greece",
    lat: 37.98109817504883,
    lng: 23.365400314331055,
  },
  {
    id: "JMK",
    name: "Mikonos Airport",
    city: "Mykonos",
    country: "Greece",
    lat: 37.43510055541992,
    lng: 25.348100662231445,
  },
  {
    id: "MJT",
    name: "Mytilene International Airport",
    city: "Mytilini",
    country: "Greece",
    lat: 39.0567016602,
    lng: 26.5983009338,
  },
  {
    id: "PVK",
    name: "Aktion National Airport",
    city: "Preveza",
    country: "Greece",
    lat: 38.925498962402344,
    lng: 20.765300750732422,
  },
  {
    id: "N",
    name: "Maritsa Airport",
    city: "Rhodos",
    country: "Greece",
    lat: 36.38309860229492,
    lng: 28.10890007019043,
  },
  {
    id: "RHO",
    name: "Diagoras Airport",
    city: "Rhodos",
    country: "Greece",
    lat: 36.405399322509766,
    lng: 28.086200714111328,
  },
  {
    id: "GPA",
    name: "Araxos Airport",
    city: "Patras",
    country: "Greece",
    lat: 38.1511,
    lng: 21.4256,
  },
  {
    id: "CHQ",
    name: "Chania International Airport",
    city: "Chania",
    country: "Greece",
    lat: 35.531700134277344,
    lng: 24.149700164794922,
  },
  {
    id: "JSI",
    name: "Skiathos Island National Airport",
    city: "Skiathos",
    country: "Greece",
    lat: 39.177101135253906,
    lng: 23.503700256347656,
  },
  {
    id: "SMI",
    name: "Samos Airport",
    city: "Samos",
    country: "Greece",
    lat: 37.689998626708984,
    lng: 26.911699295043945,
  },
  {
    id: "SPJ",
    name: "Sparti Airport",
    city: "Sparti",
    country: "Greece",
    lat: 36.973899841308594,
    lng: 22.52630043029785,
  },
  {
    id: "JTR",
    name: "Santorini Airport",
    city: "Thira",
    country: "Greece",
    lat: 36.399200439453125,
    lng: 25.479299545288086,
  },
  {
    id: "JSH",
    name: "Sitia Airport",
    city: "Sitia",
    country: "Greece",
    lat: 35.21609878540039,
    lng: 26.101299285888672,
  },
  {
    id: "N",
    name: "Stefanovikion Air Base",
    city: "Stefanovikion",
    country: "Greece",
    lat: 39.48,
    lng: 22.7672,
  },
  {
    id: "SKU",
    name: "Skiros Airport",
    city: "Skiros",
    country: "Greece",
    lat: 38.9676017761,
    lng: 24.4871997833,
  },
  {
    id: "N",
    name: "Tanagra Air Base",
    city: "Tanagra",
    country: "Greece",
    lat: 38.339802,
    lng: 23.565001,
  },
  {
    id: "N",
    name: "Kasteli Airport",
    city: "Kasteli",
    country: "Greece",
    lat: 35.192001,
    lng: 25.327,
  },
  {
    id: "N",
    name: "Tripolis Airport",
    city: "Tripolis",
    country: "Greece",
    lat: 37.530601501464844,
    lng: 22.403600692749023,
  },
  {
    id: "SKG",
    name: "Thessaloniki Macedonia International Airport",
    city: "Thessaloniki",
    country: "Greece",
    lat: 40.51969909667969,
    lng: 22.97089958190918,
  },
  {
    id: "N",
    name: "Tatoi Airport",
    city: "Dekelia",
    country: "Greece",
    lat: 38.1088981628418,
    lng: 23.78380012512207,
  },
  {
    id: "ZTH",
    name: 'Zakynthos International Airport "Dionysios Solomos"',
    city: "Zakynthos",
    country: "Greece",
    lat: 37.7509,
    lng: 20.8843,
  },
  {
    id: "BUD",
    name: "Budapest Liszt Ferenc International Airport",
    city: "Budapest",
    country: "Hungary",
    lat: 47.42976,
    lng: 19.261093,
  },
  {
    id: "DEB",
    name: "Debrecen International Airport",
    city: "Debrecen",
    country: "Hungary",
    lat: 47.48889923095703,
    lng: 21.615299224853516,
  },
  {
    id: "N",
    name: "Kecskemét Airport",
    city: "Kecskemet",
    country: "Hungary",
    lat: 46.91749954223633,
    lng: 19.74920082092285,
  },
  {
    id: "N",
    name: "Nyíregyháza Airport",
    city: "Nyirregyhaza",
    country: "Hungary",
    lat: 47.9838981628418,
    lng: 21.69230079650879,
  },
  {
    id: "N",
    name: "Őcsény Airport",
    city: "Ocseny",
    country: "Hungary",
    lat: 46.30390167236328,
    lng: 18.76919937133789,
  },
  {
    id: "N",
    name: "Szentkirályszabadja Airport",
    city: "Azentkilyszabadja",
    country: "Hungary",
    lat: 47.07789993286133,
    lng: 17.968399047851562,
  },
  {
    id: "N",
    name: "Szolnok Air Base",
    city: "Szolnok",
    country: "Hungary",
    lat: 47.122897,
    lng: 20.2355,
  },
  {
    id: "N",
    name: "Amendola Air Base",
    city: "Amendola",
    country: "Italy",
    lat: 41.541401,
    lng: 15.7181,
  },
  {
    id: "CRV",
    name: "Crotone Airport",
    city: "Crotone",
    country: "Italy",
    lat: 38.9972,
    lng: 17.0802,
  },
  {
    id: "BRI",
    name: "Bari Karol Wojtyła Airport",
    city: "Bari",
    country: "Italy",
    lat: 41.138901,
    lng: 16.760599,
  },
  {
    id: "FOG",
    name: 'Foggia "Gino Lisa" Airport',
    city: "Foggia",
    country: "Italy",
    lat: 41.432899,
    lng: 15.535,
  },
  {
    id: "TAR",
    name: 'Taranto-Grottaglie "Marcello Arlotta" Airport',
    city: "Grottaglie",
    country: "Italy",
    lat: 40.517502,
    lng: 17.4032,
  },
  {
    id: "LCC",
    name: "Lecce Galatina Air Base",
    city: "Lecce",
    country: "Italy",
    lat: 40.239201,
    lng: 18.133301,
  },
  {
    id: "PSR",
    name: "Pescara International Airport",
    city: "Pescara",
    country: "Italy",
    lat: 42.431702,
    lng: 14.1811,
  },
  {
    id: "BDS",
    name: "Brindisi – Salento Airport",
    city: "Brindisi",
    country: "Italy",
    lat: 40.6576,
    lng: 17.947001,
  },
  {
    id: "N",
    name: "Gioia Del Colle Air Base",
    city: "Gioia Del Colle",
    country: "Italy",
    lat: 40.767799,
    lng: 16.9333,
  },
  {
    id: "SUF",
    name: "Lamezia Terme Airport",
    city: "Lamezia",
    country: "Italy",
    lat: 38.905399,
    lng: 16.2423,
  },
  {
    id: "CTA",
    name: "Catania-Fontanarossa Airport",
    city: "Catania",
    country: "Italy",
    lat: 37.466801,
    lng: 15.0664,
  },
  {
    id: "LMP",
    name: "Lampedusa Airport",
    city: "Lampedusa",
    country: "Italy",
    lat: 35.497898,
    lng: 12.6181,
  },
  {
    id: "PNL",
    name: "Pantelleria Airport",
    city: "Pantelleria",
    country: "Italy",
    lat: 36.816502,
    lng: 11.9689,
  },
  {
    id: "PMO",
    name: "Falcone–Borsellino Airport",
    city: "Palermo",
    country: "Italy",
    lat: 38.175999,
    lng: 13.091,
  },
  {
    id: "N",
    name: "Palermo-Boccadifalco Airport",
    city: "Palermo",
    country: "Italy",
    lat: 38.110802,
    lng: 13.3133,
  },
  {
    id: "REG",
    name: "Reggio Calabria Airport",
    city: "Reggio Calabria",
    country: "Italy",
    lat: 38.071201,
    lng: 15.6516,
  },
  {
    id: "TPS",
    name: "Vincenzo Florio Airport Trapani-Birgi",
    city: "Trapani",
    country: "Italy",
    lat: 37.9114,
    lng: 12.488,
  },
  {
    id: "NSY",
    name: "Sigonella Navy Air Base",
    city: "Sigonella",
    country: "Italy",
    lat: 37.401699,
    lng: 14.9224,
  },
  {
    id: "AHO",
    name: "Alghero-Fertilia Airport",
    city: "Alghero",
    country: "Italy",
    lat: 40.632099,
    lng: 8.29077,
  },
  {
    id: "DCI",
    name: "Decimomannu Air Base",
    city: "Decimomannu",
    country: "Italy",
    lat: 39.354198,
    lng: 8.97248,
  },
  {
    id: "CAG",
    name: "Cagliari Elmas Airport",
    city: "Cagliari",
    country: "Italy",
    lat: 39.251499,
    lng: 9.05428,
  },
  {
    id: "OLB",
    name: "Olbia Costa Smeralda Airport",
    city: "Olbia",
    country: "Italy",
    lat: 40.898701,
    lng: 9.51763,
  },
  {
    id: "TTB",
    name: "Tortolì Airport",
    city: "Tortoli",
    country: "Italy",
    lat: 39.9188,
    lng: 9.68298,
  },
  {
    id: "N",
    name: "Torino-Aeritalia Airport",
    city: "Turin",
    country: "Italy",
    lat: 45.086399,
    lng: 7.60337,
  },
  {
    id: "N",
    name: "Milano-Bresso Airfield",
    city: "Milano",
    country: "Italy",
    lat: 45.542198,
    lng: 9.20333,
  },
  {
    id: "MXP",
    name: "Malpensa International Airport",
    city: "Milano",
    country: "Italy",
    lat: 45.6306,
    lng: 8.72811,
  },
  {
    id: "BGY",
    name: "Il Caravaggio International Airport",
    city: "Bergamo",
    country: "Italy",
    lat: 45.673901,
    lng: 9.70417,
  },
  {
    id: "TRN",
    name: "Turin Airport",
    city: "Torino",
    country: "Italy",
    lat: 45.200802,
    lng: 7.64963,
  },
  {
    id: "ALL",
    name: "Villanova D'Albenga International Airport",
    city: "Albenga",
    country: "Italy",
    lat: 44.050598,
    lng: 8.12743,
  },
  {
    id: "GOA",
    name: "Genoa Cristoforo Colombo Airport",
    city: "Genoa",
    country: "Italy",
    lat: 44.4133,
    lng: 8.8375,
  },
  {
    id: "LIN",
    name: "Milano Linate Airport",
    city: "Milan",
    country: "Italy",
    lat: 45.445099,
    lng: 9.27674,
  },
  {
    id: "N",
    name: "Cameri Air Base [MIL]",
    city: "Cameri",
    country: "Italy",
    lat: 45.529598,
    lng: 8.66922,
  },
  {
    id: "PMF",
    name: "Parma Airport",
    city: "Parma",
    country: "Italy",
    lat: 44.824501,
    lng: 10.2964,
  },
  {
    id: "N",
    name: "Piacenza San Damiano Air Base",
    city: "Piacenza",
    country: "Italy",
    lat: 44.913102,
    lng: 9.723322,
  },
  {
    id: "CUF",
    name: "Cuneo International Airport",
    city: "Cuneo",
    country: "Italy",
    lat: 44.547001,
    lng: 7.62322,
  },
  {
    id: "AVB",
    name: "Aviano Air Base",
    city: "Aviano",
    country: "Italy",
    lat: 46.031898,
    lng: 12.596503,
  },
  {
    id: "BZO",
    name: "Bolzano Airport",
    city: "Bolzano",
    country: "Italy",
    lat: 46.460201,
    lng: 11.3264,
  },
  {
    id: "N",
    name: "Cervia Air Base",
    city: "Cervia",
    country: "Italy",
    lat: 44.224201,
    lng: 12.3072,
  },
  {
    id: "BLQ",
    name: "Bologna Guglielmo Marconi Airport",
    city: "Bologna",
    country: "Italy",
    lat: 44.5354,
    lng: 11.2887,
  },
  {
    id: "TSF",
    name: "Treviso-Sant'Angelo Airport",
    city: "Treviso",
    country: "Italy",
    lat: 45.648399,
    lng: 12.1944,
  },
  {
    id: "N",
    name: "Rivolto Air Base",
    city: "Rivolto",
    country: "Italy",
    lat: 45.978699,
    lng: 13.0493,
  },
  {
    id: "FRL",
    name: "Forlì Airport",
    city: "Forli",
    country: "Italy",
    lat: 44.194801,
    lng: 12.0701,
  },
  {
    id: "N",
    name: "Ghedi Air Base",
    city: "Ghedi",
    country: "Italy",
    lat: 45.432201,
    lng: 10.2677,
  },
  {
    id: "N",
    name: "Verona-Boscomantico Airport",
    city: "Verona",
    country: "Italy",
    lat: 45.472,
    lng: 10.9279,
  },
  {
    id: "VBS",
    name: "Brescia Airport",
    city: "Brescia",
    country: "Italy",
    lat: 45.428902,
    lng: 10.3306,
  },
  {
    id: "TRS",
    name: "Trieste–Friuli Venezia Giulia Airport",
    city: "Ronchi De Legionari",
    country: "Italy",
    lat: 45.827499,
    lng: 13.4722,
  },
  {
    id: "RMI",
    name: "Federico Fellini International Airport",
    city: "Rimini",
    country: "Italy",
    lat: 44.020302,
    lng: 12.6117,
  },
  {
    id: "N",
    name: "Istrana Air Base",
    city: "Treviso",
    country: "Italy",
    lat: 45.684898,
    lng: 12.0829,
  },
  {
    id: "VIC",
    name: "Vicenza Airport",
    city: "Vicenza",
    country: "Italy",
    lat: 45.573399,
    lng: 11.5295,
  },
  {
    id: "QPA",
    name: "Padova Airport",
    city: "Padova",
    country: "Italy",
    lat: 45.395802,
    lng: 11.8479,
  },
  {
    id: "VRN",
    name: "Verona Villafranca Airport",
    city: "Villafranca",
    country: "Italy",
    lat: 45.395699,
    lng: 10.8885,
  },
  {
    id: "VCE",
    name: "Venice Marco Polo Airport",
    city: "Venice",
    country: "Italy",
    lat: 45.505299,
    lng: 12.3519,
  },
  {
    id: "SAY",
    name: "Siena-Ampugnano Airport",
    city: "Siena",
    country: "Italy",
    lat: 43.256302,
    lng: 11.255,
  },
  {
    id: "CIA",
    name: "Ciampino–G. B. Pastine International Airport",
    city: "Rome",
    country: "Italy",
    lat: 41.7994,
    lng: 12.5949,
  },
  {
    id: "N",
    name: "Pratica Di Mare Air Base",
    city: "Pratica Di Mare",
    country: "Italy",
    lat: 41.654499,
    lng: 12.4452,
  },
  {
    id: "FCO",
    name: "Leonardo da Vinci–Fiumicino Airport",
    city: "Rome",
    country: "Italy",
    lat: 41.8002778,
    lng: 12.2388889,
  },
  {
    id: "N",
    name: "Guidonia Air Base",
    city: "Guidonia",
    country: "Italy",
    lat: 41.990299,
    lng: 12.7408,
  },
  {
    id: "EBA",
    name: "Marina Di Campo Airport",
    city: "Marina Di Campo",
    country: "Italy",
    lat: 42.7603,
    lng: 10.2394,
  },
  {
    id: "QLT",
    name: "Latina Air Base",
    city: "Latina",
    country: "Italy",
    lat: 41.5424,
    lng: 12.909,
  },
  {
    id: "N",
    name: "Grazzanise Air Base",
    city: "Grazzanise",
    country: "Italy",
    lat: 41.060799,
    lng: 14.0819,
  },
  {
    id: "NAP",
    name: "Naples International Airport",
    city: "Naples",
    country: "Italy",
    lat: 40.886002,
    lng: 14.2908,
  },
  {
    id: "PSA",
    name: "Pisa International Airport",
    city: "Pisa",
    country: "Italy",
    lat: 43.683899,
    lng: 10.3927,
  },
  {
    id: "FLR",
    name: "Peretola Airport",
    city: "Florence",
    country: "Italy",
    lat: 43.810001,
    lng: 11.2051,
  },
  {
    id: "GRS",
    name: "Grosseto Air Base",
    city: "Grosseto",
    country: "Italy",
    lat: 42.759701,
    lng: 11.0719,
  },
  {
    id: "N",
    name: "Urbe Airport",
    city: "Rome",
    country: "Italy",
    lat: 41.9519,
    lng: 12.4989,
  },
  {
    id: "N",
    name: "Viterbo Airport",
    city: "Viterbo",
    country: "Italy",
    lat: 42.430199,
    lng: 12.0642,
  },
  {
    id: "PEG",
    name: "Perugia San Francesco d'Assisi – Umbria International Airport",
    city: "Perugia",
    country: "Italy",
    lat: 43.095901,
    lng: 12.5132,
  },
  {
    id: "N",
    name: "Cerklje Airport",
    city: "Cerklje",
    country: "Slovenia",
    lat: 45.900001525879,
    lng: 15.530200004578,
  },
  {
    id: "LJU",
    name: "Ljubljana Jože Pučnik Airport",
    city: "Ljubljana",
    country: "Slovenia",
    lat: 46.223701,
    lng: 14.4576,
  },
  {
    id: "MBX",
    name: "Maribor Airport",
    city: "Maribor",
    country: "Slovenia",
    lat: 46.47990036010742,
    lng: 15.686100006103516,
  },
  {
    id: "POW",
    name: "Portoroz Airport",
    city: "Portoroz",
    country: "Slovenia",
    lat: 45.4734001159668,
    lng: 13.614999771118164,
  },
  {
    id: "N",
    name: "Slovenj Gradec Airport",
    city: "Slovenj Gradec",
    country: "Slovenia",
    lat: 46.47200012207031,
    lng: 15.116999626159668,
  },
  {
    id: "N",
    name: "České Budějovice Airport",
    city: "Ceske Budejovice",
    country: "Czech Republic",
    lat: 48.9463996887207,
    lng: 14.427499771118164,
  },
  {
    id: "N",
    name: "Čáslav Air Base",
    city: "Caslav",
    country: "Czech Republic",
    lat: 49.939701080322266,
    lng: 15.381799697875977,
  },
  {
    id: "N",
    name: "Hradec Králové Airport",
    city: "Hradec Kralove",
    country: "Czech Republic",
    lat: 50.253201,
    lng: 15.8452,
  },
  {
    id: "N",
    name: "Hořovice Airport",
    city: "Horovice",
    country: "Czech Republic",
    lat: 49.84809875488281,
    lng: 13.893500328063965,
  },
  {
    id: "N",
    name: "Kbely Air Base",
    city: "Praha",
    country: "Czech Republic",
    lat: 50.12139892578125,
    lng: 14.543600082397461,
  },
  {
    id: "UHE",
    name: "Kunovice Airport",
    city: "Kunovice",
    country: "Czech Republic",
    lat: 49.02939987182617,
    lng: 17.439699172973633,
  },
  {
    id: "KLV",
    name: "Karlovy Vary International Airport",
    city: "Karlovy Vary",
    country: "Czech Republic",
    lat: 50.202999114990234,
    lng: 12.914999961853027,
  },
  {
    id: "N",
    name: "Plzeň-Líně Airport",
    city: "Line",
    country: "Czech Republic",
    lat: 49.675201416016,
    lng: 13.274600028992,
  },
  {
    id: "N",
    name: "Mnichovo Hradiště Airport",
    city: "Mnichovo Hradiste",
    country: "Czech Republic",
    lat: 50.540199279785156,
    lng: 15.006600379943848,
  },
  {
    id: "OSR",
    name: "Ostrava Leos Janáček Airport",
    city: "Ostrava",
    country: "Czech Republic",
    lat: 49.6963005065918,
    lng: 18.111099243164062,
  },
  {
    id: "N",
    name: "Náměšť Air Base",
    city: "Namest",
    country: "Czech Republic",
    lat: 49.16579818725586,
    lng: 16.124900817871094,
  },
  {
    id: "PED",
    name: "Pardubice Airport",
    city: "Pardubice",
    country: "Czech Republic",
    lat: 50.01340103149414,
    lng: 15.73859977722168,
  },
  {
    id: "N",
    name: "Pribram Airport",
    city: "Pribram",
    country: "Czech Republic",
    lat: 49.7201,
    lng: 14.1006,
  },
  {
    id: "PRV",
    name: "Přerov Air Base",
    city: "Prerov",
    country: "Czech Republic",
    lat: 49.42580032348633,
    lng: 17.404699325561523,
  },
  {
    id: "PRG",
    name: "Václav Havel Airport Prague",
    city: "Prague",
    country: "Czech Republic",
    lat: 50.1008,
    lng: 14.26,
  },
  {
    id: "BRQ",
    name: "Brno-Tuřany Airport",
    city: "Brno",
    country: "Czech Republic",
    lat: 49.15129852294922,
    lng: 16.694400787353516,
  },
  {
    id: "VOD",
    name: "Vodochody Airport",
    city: "Vodochody",
    country: "Czech Republic",
    lat: 50.216599,
    lng: 14.3958,
  },
  {
    id: "TLV",
    name: "Ben Gurion International Airport",
    city: "Tel-aviv",
    country: "Israel",
    lat: 32.01139831542969,
    lng: 34.88669967651367,
  },
  {
    id: "BEV",
    name: "Beersheba (Teyman) Airport",
    city: "Beer-sheba",
    country: "Israel",
    lat: 31.287000656128,
    lng: 34.722999572754,
  },
  {
    id: "N",
    name: "Tel Nof Air Base",
    city: "Tel-nof",
    country: "Israel",
    lat: 31.8395004272,
    lng: 34.8218002319,
  },
  {
    id: "N",
    name: "Ein Shemer Airfield",
    city: "Eyn-shemer",
    country: "Israel",
    lat: 32.440799713134766,
    lng: 35.0077018737793,
  },
  {
    id: "ETH",
    name: "Eilat Airport",
    city: "Elat",
    country: "Israel",
    lat: 29.56130027770996,
    lng: 34.96009826660156,
  },
  {
    id: "EIY",
    name: "Ein Yahav Airfield",
    city: "Eyn-yahav",
    country: "Israel",
    lat: 30.621700286865234,
    lng: 35.20330047607422,
  },
  {
    id: "HFA",
    name: "Haifa International Airport",
    city: "Haifa",
    country: "Israel",
    lat: 32.80939865112305,
    lng: 35.04309844970703,
  },
  {
    id: "N",
    name: "Hatzor Air Base",
    city: "Haztor",
    country: "Israel",
    lat: 31.7625007629,
    lng: 34.727199554399995,
  },
  {
    id: "RPN",
    name: "Ben Ya'akov Airport",
    city: "Rosh Pina",
    country: "Israel",
    lat: 32.98099899291992,
    lng: 35.5718994140625,
  },
  {
    id: "N",
    name: "Megiddo Airport",
    city: "Megido Airstrip",
    country: "Israel",
    lat: 32.5973014831543,
    lng: 35.22880172729492,
  },
  {
    id: "MTZ",
    name: "Bar Yehuda Airfield",
    city: "Metzada",
    country: "Israel",
    lat: 31.32819938659668,
    lng: 35.38859939575195,
  },
  {
    id: "VTM",
    name: "Nevatim Air Base",
    city: "Nevatim",
    country: "Israel",
    lat: 31.208299636799996,
    lng: 35.012298584,
  },
  {
    id: "VDA",
    name: "Ovda International Airport",
    city: "Ovda",
    country: "Israel",
    lat: 29.94029998779297,
    lng: 34.93579864501953,
  },
  {
    id: "N",
    name: "Ramat David Air Base",
    city: "Ramat David",
    country: "Israel",
    lat: 32.66510009765625,
    lng: 35.179500579833984,
  },
  {
    id: "MIP",
    name: "Ramon Air Base",
    city: "Ramon",
    country: "Israel",
    lat: 30.776100158691406,
    lng: 34.66669845581055,
  },
  {
    id: "SDV",
    name: "Sde Dov Airport",
    city: "Tel-aviv",
    country: "Israel",
    lat: 32.11470031738281,
    lng: 34.78219985961914,
  },
  {
    id: "MLA",
    name: "Malta International Airport",
    city: "Malta",
    country: "Malta",
    lat: 35.857498,
    lng: 14.4775,
  },
  {
    id: "N",
    name: "Wiener Neustadt East Airport",
    city: "Wiener Neustadt Ost",
    country: "Austria",
    lat: 47.843299865722656,
    lng: 16.260099411010742,
  },
  {
    id: "N",
    name: "Wels Airport",
    city: "Wels",
    country: "Austria",
    lat: 48.18330001831055,
    lng: 14.040900230407715,
  },
  {
    id: "GRZ",
    name: "Graz Airport",
    city: "Graz",
    country: "Austria",
    lat: 46.9911003112793,
    lng: 15.439599990844727,
  },
  {
    id: "INN",
    name: "Innsbruck Airport",
    city: "Innsbruck",
    country: "Austria",
    lat: 47.260201,
    lng: 11.344,
  },
  {
    id: "LNZ",
    name: "Linz Hörsching Airport",
    city: "Linz",
    country: "Austria",
    lat: 48.2332,
    lng: 14.1875,
  },
  {
    id: "SZG",
    name: "Salzburg Airport",
    city: "Salzburg",
    country: "Austria",
    lat: 47.793300628699996,
    lng: 13.0043001175,
  },
  {
    id: "VIE",
    name: "Vienna International Airport",
    city: "Vienna",
    country: "Austria",
    lat: 48.110298156738,
    lng: 16.569700241089,
  },
  {
    id: "N",
    name: "Hinterstoisser Air Base",
    city: "Zeltweg",
    country: "Austria",
    lat: 47.202801,
    lng: 14.7442,
  },
  {
    id: "AVR",
    name: "Alverca Air Base",
    city: "Alverca",
    country: "Portugal",
    lat: 38.883301,
    lng: -9.0301,
  },
  {
    id: "SMA",
    name: "Santa Maria Airport",
    city: "Santa Maria (island)",
    country: "Portugal",
    lat: 36.97140121459961,
    lng: -25.17060089111328,
  },
  {
    id: "BGC",
    name: "Bragança Airport",
    city: "Braganca",
    country: "Portugal",
    lat: 41.8578,
    lng: -6.70713,
  },
  {
    id: "BYJ",
    name: "Beja Airport / Airbase",
    city: "Beja (madeira)",
    country: "Portugal",
    lat: 38.078899,
    lng: -7.9324,
  },
  {
    id: "BGZ",
    name: "Braga Municipal Aerodrome",
    city: "Braga",
    country: "Portugal",
    lat: 41.5871009827,
    lng: -8.445139884949999,
  },
  {
    id: "N",
    name: "Aerodromo Municipal de Coimbra",
    city: "Coimba",
    country: "Portugal",
    lat: 40.158758,
    lng: -8.470815,
  },
  {
    id: "CAT",
    name: "Cascais Airport",
    city: "Cascais",
    country: "Portugal",
    lat: 38.724998,
    lng: -9.35523,
  },
  {
    id: "N",
    name: "Coimbra Hospital Covões Heliport",
    city: "Covilha",
    country: "Portugal",
    lat: 40.194812,
    lng: -8.460207,
  },
  {
    id: "N",
    name: "Évora Airport",
    city: "Evora",
    country: "Portugal",
    lat: 38.533501,
    lng: -7.88964,
  },
  {
    id: "FLW",
    name: "Flores Airport",
    city: "Flores",
    country: "Portugal",
    lat: 39.455299377441406,
    lng: -31.131399154663086,
  },
  {
    id: "FAO",
    name: "Faro Airport",
    city: "Faro",
    country: "Portugal",
    lat: 37.0144004822,
    lng: -7.96590995789,
  },
  {
    id: "GRW",
    name: "Graciosa Airport",
    city: "Graciosa Island",
    country: "Portugal",
    lat: 39.092201232910156,
    lng: -28.029800415039062,
  },
  {
    id: "HOR",
    name: "Horta Airport",
    city: "Horta",
    country: "Portugal",
    lat: 38.519901275634766,
    lng: -28.715900421142578,
  },
  {
    id: "TER",
    name: "Lajes Airport",
    city: "Lajes (terceira Island)",
    country: "Portugal",
    lat: 38.761799,
    lng: -27.090799,
  },
  {
    id: "QLR",
    name: "Monte Real Air Base",
    city: "Monte Real",
    country: "Portugal",
    lat: 39.828335,
    lng: -8.8875,
  },
  {
    id: "N",
    name: "Montijo Air Base",
    city: "Montijo",
    country: "Portugal",
    lat: 38.703899,
    lng: -9.03592,
  },
  {
    id: "N",
    name: "Ovar Air Base",
    city: "Ovar",
    country: "Portugal",
    lat: 40.915901,
    lng: -8.64592,
  },
  {
    id: "PDL",
    name: "João Paulo II Airport",
    city: "Ponta Delgada",
    country: "Portugal",
    lat: 37.7411994934,
    lng: -25.6979007721,
  },
  {
    id: "PIX",
    name: "Pico Airport",
    city: "Pico",
    country: "Portugal",
    lat: 38.554298,
    lng: -28.441299,
  },
  {
    id: "PRM",
    name: "Portimão Airport",
    city: "Portimao",
    country: "Portugal",
    lat: 37.1493,
    lng: -8.58396,
  },
  {
    id: "OPO",
    name: "Francisco de Sá Carneiro Airport",
    city: "Porto",
    country: "Portugal",
    lat: 41.2481002808,
    lng: -8.68138980865,
  },
  {
    id: "PXO",
    name: "Porto Santo Airport",
    city: "Porto Santo",
    country: "Portugal",
    lat: 33.0733985901,
    lng: -16.3500003815,
  },
  {
    id: "LIS",
    name: "Humberto Delgado Airport (Lisbon Portela Airport)",
    city: "Lisbon",
    country: "Portugal",
    lat: 38.7813,
    lng: -9.13592,
  },
  {
    id: "SJZ",
    name: "São Jorge Airport",
    city: "Sao Jorge Island",
    country: "Portugal",
    lat: 38.66550064086914,
    lng: -28.175800323486328,
  },
  {
    id: "N",
    name: "Sintra Air Base",
    city: "Sintra",
    country: "Portugal",
    lat: 38.8311,
    lng: -9.33955,
  },
  {
    id: "N",
    name: "Tancos Airbase",
    city: "Tancos",
    country: "Portugal",
    lat: 39.475101,
    lng: -8.36458,
  },
  {
    id: "VRL",
    name: "Vila Real Airport",
    city: "Vila Real",
    country: "Portugal",
    lat: 41.2743,
    lng: -7.72047,
  },
  {
    id: "VSE",
    name: "Aerodromo Goncalves Lobato (Viseu Airport)",
    city: "Viseu",
    country: "Portugal",
    lat: 40.725498,
    lng: -7.88899,
  },
  {
    id: "OMO",
    name: "Mostar International Airport",
    city: "Mostar",
    country: "Bosnia and Herzegovina",
    lat: 43.282901763916016,
    lng: 17.84589958190918,
  },
  {
    id: "SJJ",
    name: "Sarajevo International Airport",
    city: "Sarajevo",
    country: "Bosnia and Herzegovina",
    lat: 43.82460021972656,
    lng: 18.331499099731445,
  },
  {
    id: "ARW",
    name: "Arad International Airport",
    city: "Arad",
    country: "Romania",
    lat: 46.17660140991211,
    lng: 21.261999130249023,
  },
  {
    id: "BCM",
    name: "Bacău Airport",
    city: "Bacau",
    country: "Romania",
    lat: 46.52190017700195,
    lng: 26.91029930114746,
  },
  {
    id: "BAY",
    name: "Tautii Magheraus Airport",
    city: "Baia Mare",
    country: "Romania",
    lat: 47.65840148925781,
    lng: 23.469999313354492,
  },
  {
    id: "BBU",
    name: "Băneasa International Airport",
    city: "Bucharest",
    country: "Romania",
    lat: 44.50320053100586,
    lng: 26.102100372314453,
  },
  {
    id: "CND",
    name: "Mihail Kogălniceanu International Airport",
    city: "Constanta",
    country: "Romania",
    lat: 44.36220169067383,
    lng: 28.488300323486328,
  },
  {
    id: "CLJ",
    name: "Cluj-Napoca International Airport",
    city: "Cluj-napoca",
    country: "Romania",
    lat: 46.78519821166992,
    lng: 23.686199188232422,
  },
  {
    id: "CSB",
    name: "Caransebeş Airport",
    city: "Caransebes",
    country: "Romania",
    lat: 45.41999816894531,
    lng: 22.253299713134766,
  },
  {
    id: "CRA",
    name: "Craiova Airport",
    city: "Craiova",
    country: "Romania",
    lat: 44.31809997558594,
    lng: 23.888599395751953,
  },
  {
    id: "IAS",
    name: "Iaşi Airport",
    city: "Iasi",
    country: "Romania",
    lat: 47.17850112915039,
    lng: 27.6205997467041,
  },
  {
    id: "OMR",
    name: "Oradea International Airport",
    city: "Oradea",
    country: "Romania",
    lat: 47.025299072265625,
    lng: 21.90250015258789,
  },
  {
    id: "OTP",
    name: "Henri Coandă International Airport",
    city: "Bucharest",
    country: "Romania",
    lat: 44.5711111,
    lng: 26.085,
  },
  {
    id: "SBZ",
    name: "Sibiu International Airport",
    city: "Sibiu",
    country: "Romania",
    lat: 45.78559875488281,
    lng: 24.091299057006836,
  },
  {
    id: "SUJ",
    name: "Satu Mare Airport",
    city: "Satu Mare",
    country: "Romania",
    lat: 47.70330047607422,
    lng: 22.885700225830078,
  },
  {
    id: "SCV",
    name: "Suceava Stefan cel Mare Airport",
    city: "Suceava",
    country: "Romania",
    lat: 47.6875,
    lng: 26.35409927368164,
  },
  {
    id: "TCE",
    name: "Tulcea Airport",
    city: "Tulcea",
    country: "Romania",
    lat: 45.0625,
    lng: 28.71430015563965,
  },
  {
    id: "TGM",
    name: "Transilvania Târgu Mureş International Airport",
    city: "Tirgu Mures",
    country: "Romania",
    lat: 46.46770095825195,
    lng: 24.412500381469727,
  },
  {
    id: "TSR",
    name: "Timişoara Traian Vuia Airport",
    city: "Timisoara",
    country: "Romania",
    lat: 45.809898376464844,
    lng: 21.337900161743164,
  },
  {
    id: "N",
    name: "Les Eplatures Airport",
    city: "Les Eplatures",
    country: "Switzerland",
    lat: 47.083900451699996,
    lng: 6.792840003970001,
  },
  {
    id: "GVA",
    name: "Geneva Cointrin International Airport",
    city: "Geneva",
    country: "Switzerland",
    lat: 46.23809814453125,
    lng: 6.108950138092041,
  },
  {
    id: "N",
    name: "Saanen Airport",
    city: "Saanen",
    country: "Switzerland",
    lat: 46.4874992371,
    lng: 7.25083017349,
  },
  {
    id: "SIR",
    name: "Sion Airport",
    city: "Sion",
    country: "Switzerland",
    lat: 46.219600677500004,
    lng: 7.326759815220001,
  },
  {
    id: "N",
    name: "Alpnach Air Base",
    city: "Alpnach",
    country: "Switzerland",
    lat: 46.943901,
    lng: 8.28417,
  },
  {
    id: "N",
    name: "Dübendorf Air Base",
    city: "Dubendorf",
    country: "Switzerland",
    lat: 47.398601532,
    lng: 8.648229599,
  },
  {
    id: "EML",
    name: "Emmen Air Base",
    city: "Emmen",
    country: "Switzerland",
    lat: 47.092444,
    lng: 8.305184,
  },
  {
    id: "N",
    name: "Mollis Airport",
    city: "Mollis",
    country: "Switzerland",
    lat: 47.07889938354492,
    lng: 9.06482982635498,
  },
  {
    id: "N",
    name: "Meiringen Airport",
    city: "Meiringen",
    country: "Switzerland",
    lat: 46.74330139160156,
    lng: 8.109999656677246,
  },
  {
    id: "N",
    name: "Payerne Air Base",
    city: "Payerne",
    country: "Switzerland",
    lat: 46.8432,
    lng: 6.91506004333,
  },
  {
    id: "LUG",
    name: "Lugano Airport",
    city: "Lugano",
    country: "Switzerland",
    lat: 46.00429916379999,
    lng: 8.9105796814,
  },
  {
    id: "BRN",
    name: "Bern Belp Airport",
    city: "Bern",
    country: "Switzerland",
    lat: 46.914100647,
    lng: 7.497149944309999,
  },
  {
    id: "ZHI",
    name: "Grenchen Airport",
    city: "Grenchen",
    country: "Switzerland",
    lat: 47.181599,
    lng: 7.41719,
  },
  {
    id: "ZRH",
    name: "Zürich Airport",
    city: "Zurich",
    country: "Switzerland",
    lat: 47.464699,
    lng: 8.54917,
  },
  {
    id: "ACH",
    name: "St Gallen Altenrhein Airport",
    city: "Altenrhein",
    country: "Switzerland",
    lat: 47.4850006104,
    lng: 9.560770034789998,
  },
  {
    id: "SMV",
    name: "Samedan Airport",
    city: "Samedan",
    country: "Switzerland",
    lat: 46.53409957885742,
    lng: 9.884110450744629,
  },
  {
    id: "N",
    name: "Güvercinlik Airport",
    city: "Ankara",
    country: "Turkey",
    lat: 39.9350013733,
    lng: 32.7407989502,
  },
  {
    id: "ESB",
    name: "Esenboğa International Airport",
    city: "Ankara",
    country: "Turkey",
    lat: 40.128101348899996,
    lng: 32.995098114,
  },
  {
    id: "ANK",
    name: "Etimesgut Air Base",
    city: "Ankara",
    country: "Turkey",
    lat: 39.949798584,
    lng: 32.6885986328,
  },
  {
    id: "N",
    name: "Akıncı Air Base",
    city: "Ankara",
    country: "Turkey",
    lat: 40.078899383499994,
    lng: 32.5656013489,
  },
  {
    id: "ADA",
    name: "Adana Airport",
    city: "Adana",
    country: "Turkey",
    lat: 36.9822006226,
    lng: 35.280399322499996,
  },
  {
    id: "UAB",
    name: "İncirlik Air Base",
    city: "Adana",
    country: "Turkey",
    lat: 37.002101898199996,
    lng: 35.4258995056,
  },
  {
    id: "AFY",
    name: "Afyon Airport",
    city: "Afyon",
    country: "Turkey",
    lat: 38.726398468,
    lng: 30.6011009216,
  },
  {
    id: "AYT",
    name: "Antalya International Airport",
    city: "Antalya",
    country: "Turkey",
    lat: 36.898701,
    lng: 30.800501,
  },
  {
    id: "GZT",
    name: "Gaziantep International Airport",
    city: "Gaziantep",
    country: "Turkey",
    lat: 36.9472007751,
    lng: 37.4786987305,
  },
  {
    id: "N",
    name: "İskenderun Airport",
    city: "Iskenderun",
    country: "Turkey",
    lat: 36.5744552612,
    lng: 36.1534194946,
  },
  {
    id: "KYA",
    name: "Konya Airport",
    city: "Konya",
    country: "Turkey",
    lat: 37.979,
    lng: 32.561901,
  },
  {
    id: "N",
    name: "Malatya Tulga Airport",
    city: "Malatya",
    country: "Turkey",
    lat: 38.353699,
    lng: 38.253899,
  },
  {
    id: "MZH",
    name: "Amasya Merzifon Airport",
    city: "Merzifon",
    country: "Turkey",
    lat: 40.829399,
    lng: 35.521999,
  },
  {
    id: "VAS",
    name: "Sivas Nuri Demirağ Airport",
    city: "Sivas",
    country: "Turkey",
    lat: 39.813801,
    lng: 36.9035,
  },
  {
    id: "MLX",
    name: "Malatya Erhaç Airport",
    city: "Malatya",
    country: "Turkey",
    lat: 38.435298919699996,
    lng: 38.0909996033,
  },
  {
    id: "ASR",
    name: "Kayseri Erkilet Airport",
    city: "Kayseri",
    country: "Turkey",
    lat: 38.770401001,
    lng: 35.4953994751,
  },
  {
    id: "N",
    name: "Sivrihisar Airport",
    city: "Sivrihisar",
    country: "Turkey",
    lat: 39.451499938964844,
    lng: 31.365299224853516,
  },
  {
    id: "TJK",
    name: "Tokat Airport",
    city: "Tokat",
    country: "Turkey",
    lat: 40.307430267333984,
    lng: 36.367408752441406,
  },
  {
    id: "DNZ",
    name: "Çardak Airport",
    city: "Denizli",
    country: "Turkey",
    lat: 37.7855987549,
    lng: 29.7012996674,
  },
  {
    id: "ISL",
    name: "Atatürk International Airport",
    city: "Istanbul",
    country: "Turkey",
    lat: 40.976898,
    lng: 28.8146,
  },
  {
    id: "BZI",
    name: "Balıkesir Merkez Airport",
    city: "Balikesir",
    country: "Turkey",
    lat: 39.619300842285156,
    lng: 27.926000595092773,
  },
  {
    id: "BDM",
    name: "Bandırma Airport",
    city: "Bandirma",
    country: "Turkey",
    lat: 40.31800079345703,
    lng: 27.977699279785156,
  },
  {
    id: "ESK",
    name: "Eskişehir Air Base",
    city: "Eskisehir",
    country: "Turkey",
    lat: 39.7840995789,
    lng: 30.582099914599997,
  },
  {
    id: "ADB",
    name: "Adnan Menderes International Airport",
    city: "Izmir",
    country: "Turkey",
    lat: 38.2924003601,
    lng: 27.156999588,
  },
  {
    id: "N",
    name: "Gaziemir Airport",
    city: "Izmir",
    country: "Turkey",
    lat: 38.31909942626953,
    lng: 27.159400939941406,
  },
  {
    id: "IGL",
    name: "Çiğli Airport",
    city: "Izmir",
    country: "Turkey",
    lat: 38.513000488299994,
    lng: 27.010099411,
  },
  {
    id: "N",
    name: "Isparta Airport",
    city: "Isparta",
    country: "Turkey",
    lat: 37.78512191772461,
    lng: 30.59001922607422,
  },
  {
    id: "N",
    name: "Kütahya Airport",
    city: "Kutahya",
    country: "Turkey",
    lat: 39.426700592041016,
    lng: 30.01689910888672,
  },
  {
    id: "N",
    name: "Yalova Airport",
    city: "Yalova",
    country: "Turkey",
    lat: 40.68439865112305,
    lng: 29.375699996948242,
  },
  {
    id: "KCO",
    name: "Cengiz Topel Airport",
    city: "Topel",
    country: "Turkey",
    lat: 40.73500061035156,
    lng: 30.08329963684082,
  },
  {
    id: "DLM",
    name: "Dalaman International Airport",
    city: "Dalaman",
    country: "Turkey",
    lat: 36.7131004333,
    lng: 28.7924995422,
  },
  {
    id: "N",
    name: "Akhisar Airport",
    city: "Akhisar",
    country: "Turkey",
    lat: 38.80889892578125,
    lng: 27.833900451660156,
  },
  {
    id: "BXN",
    name: "Imsık Airport",
    city: "Bodrum",
    country: "Turkey",
    lat: 37.140098571777344,
    lng: 27.669700622558594,
  },
  {
    id: "N",
    name: "Samandıra Air Base",
    city: "Istanbul",
    country: "Turkey",
    lat: 40.99300003051758,
    lng: 29.21649932861328,
  },
  {
    id: "EZS",
    name: "Elazığ Airport",
    city: "Elazig",
    country: "Turkey",
    lat: 38.6068992615,
    lng: 39.2914009094,
  },
  {
    id: "DIY",
    name: "Diyarbakir Airport",
    city: "Diyabakir",
    country: "Turkey",
    lat: 37.893901825,
    lng: 40.201000213600004,
  },
  {
    id: "ERC",
    name: "Erzincan Airport",
    city: "Erzincan",
    country: "Turkey",
    lat: 39.7102012634,
    lng: 39.527000427199994,
  },
  {
    id: "ERZ",
    name: "Erzurum International Airport",
    city: "Erzurum",
    country: "Turkey",
    lat: 39.9565010071,
    lng: 41.17020034789999,
  },
  {
    id: "TZX",
    name: "Trabzon International Airport",
    city: "Trabzon",
    country: "Turkey",
    lat: 40.99509811401367,
    lng: 39.78969955444336,
  },
  {
    id: "VAN",
    name: "Van Ferit Melen Airport",
    city: "Van",
    country: "Turkey",
    lat: 38.46820068359375,
    lng: 43.332298278808594,
  },
  {
    id: "BAL",
    name: "Batman Airport",
    city: "Batman",
    country: "Turkey",
    lat: 37.929000854499996,
    lng: 41.1166000366,
  },
  {
    id: "SXZ",
    name: "Siirt Airport",
    city: "Siirt",
    country: "Turkey",
    lat: 37.97890090942383,
    lng: 41.84040069580078,
  },
  {
    id: "N",
    name: "Kaklıç Airport",
    city: "Izmir",
    country: "Turkey",
    lat: 38.517601013183594,
    lng: 26.977399826049805,
  },
  {
    id: "N",
    name: "Selçuk Efes Airport",
    city: "Izmir",
    country: "Turkey",
    lat: 37.95069885253906,
    lng: 27.32900047302246,
  },
  {
    id: "BZY",
    name: "Bălți International Airport",
    city: "Saltsy",
    country: "Moldova",
    lat: 47.843056,
    lng: 27.777222,
  },
  {
    id: "KIV",
    name: "Chişinău International Airport",
    city: "Chisinau",
    country: "Moldova",
    lat: 46.92770004272461,
    lng: 28.930999755859375,
  },
  {
    id: "OHD",
    name: "Ohrid St. Paul the Apostle Airport",
    city: "Ohrid",
    country: "Macedonia",
    lat: 41.18,
    lng: 20.7423,
  },
  {
    id: "SKP",
    name: "Skopje Alexander the Great Airport",
    city: "Skopje",
    country: "Macedonia",
    lat: 41.961601,
    lng: 21.621401,
  },
  {
    id: "GIB",
    name: "Gibraltar Airport",
    city: "Gibraltar",
    country: "Gibraltar",
    lat: 36.1511993408,
    lng: -5.3496599197400005,
  },
  {
    id: "BEG",
    name: "Belgrade Nikola Tesla Airport",
    city: "Belgrade",
    country: "Serbia",
    lat: 44.8184013367,
    lng: 20.3090991974,
  },
  {
    id: "INI",
    name: "Nis Airport",
    city: "Nis",
    country: "Serbia",
    lat: 43.337299,
    lng: 21.853701,
  },
  {
    id: "TGD",
    name: "Podgorica Airport",
    city: "Podgorica",
    country: "Montenegro",
    lat: 42.359402,
    lng: 19.2519,
  },
  {
    id: "PRN",
    name: "Priština International Airport",
    city: "Pristina",
    country: "Serbia",
    lat: 42.5728,
    lng: 21.035801,
  },
  {
    id: "TIV",
    name: "Tivat Airport",
    city: "Tivat",
    country: "Montenegro",
    lat: 42.404701232910156,
    lng: 18.72330093383789,
  },
  {
    id: "N",
    name: "Vršac International Airport",
    city: "Vrsac",
    country: "Serbia",
    lat: 45.1469,
    lng: 21.3099,
  },
  {
    id: "BTS",
    name: "M. R. Štefánik Airport",
    city: "Bratislava",
    country: "Slovakia",
    lat: 48.17020034790039,
    lng: 17.21269989013672,
  },
  {
    id: "KSC",
    name: "Košice Airport",
    city: "Kosice",
    country: "Slovakia",
    lat: 48.66310119628906,
    lng: 21.241100311279297,
  },
  {
    id: "N",
    name: "Kuchyňa Air Base",
    city: "Malacky",
    country: "Slovakia",
    lat: 48.402000427246094,
    lng: 17.11840057373047,
  },
  {
    id: "PZY",
    name: "Piešťany Airport",
    city: "Piestany",
    country: "Slovakia",
    lat: 48.62519836425781,
    lng: 17.828399658203125,
  },
  {
    id: "SLD",
    name: "Sliač Airport",
    city: "Sliac",
    country: "Slovakia",
    lat: 48.63779830932617,
    lng: 19.13409996032715,
  },
  {
    id: "N",
    name: "Trenčín Airport",
    city: "Trencin",
    country: "Slovakia",
    lat: 48.8650016785,
    lng: 17.9923000336,
  },
  {
    id: "TAT",
    name: "Poprad-Tatry Airport",
    city: "Poprad",
    country: "Slovakia",
    lat: 49.073600769,
    lng: 20.2411003113,
  },
  {
    id: "NCA",
    name: "North Caicos Airport",
    city: "North Caicos",
    country: "Turks and Caicos Islands",
    lat: 21.9175,
    lng: -71.939598,
  },
  {
    id: "PLS",
    name: "Providenciales Airport",
    city: "Providenciales",
    country: "Turks and Caicos Islands",
    lat: 21.77359962463379,
    lng: -72.26589965820312,
  },
  {
    id: "XSC",
    name: "South Caicos Airport",
    city: "South Caicos",
    country: "Turks and Caicos Islands",
    lat: 21.515699386599998,
    lng: -71.528503418,
  },
  {
    id: "N",
    name: "Arroyo Barril Airport",
    city: "Samana",
    country: "Dominican Republic",
    lat: 19.198600769,
    lng: -69.42980194089999,
  },
  {
    id: "BRX",
    name: "Maria Montez International Airport",
    city: "Barahona",
    country: "Dominican Republic",
    lat: 18.25149917602539,
    lng: -71.12039947509766,
  },
  {
    id: "CBJ",
    name: "Cabo Rojo Airport",
    city: "Cabo Rojo",
    country: "Dominican Republic",
    lat: 17.929000854492188,
    lng: -71.6447982788086,
  },
  {
    id: "LRM",
    name: "Casa De Campo International Airport",
    city: "La Romana",
    country: "Dominican Republic",
    lat: 18.450700759887695,
    lng: -68.91179656982422,
  },
  {
    id: "PUJ",
    name: "Punta Cana International Airport",
    city: "Punta Cana",
    country: "Dominican Republic",
    lat: 18.567399978599997,
    lng: -68.36340332030001,
  },
  {
    id: "POP",
    name: "Gregorio Luperon International Airport",
    city: "Puerto Plata",
    country: "Dominican Republic",
    lat: 19.75790023803711,
    lng: -70.56999969482422,
  },
  {
    id: "SDQ",
    name: "Las Américas International Airport",
    city: "Santo Domingo",
    country: "Dominican Republic",
    lat: 18.42970085144,
    lng: -69.668899536133,
  },
  {
    id: "N",
    name: "San Isidro Air Base",
    city: "San Isidoro",
    country: "Dominican Republic",
    lat: 18.503700256347656,
    lng: -69.76170349121094,
  },
  {
    id: "STI",
    name: "Cibao International Airport",
    city: "Santiago",
    country: "Dominican Republic",
    lat: 19.406099319458008,
    lng: -70.60469818115234,
  },
  {
    id: "N",
    name: "Bananera Airport",
    city: "Bananera",
    country: "Guatemala",
    lat: 15.47350025177002,
    lng: -88.83719635009766,
  },
  {
    id: "CBV",
    name: "Coban Airport",
    city: "Coban",
    country: "Guatemala",
    lat: 15.468999862670898,
    lng: -90.40670013427734,
  },
  {
    id: "GUA",
    name: "La Aurora Airport",
    city: "Guatemala City",
    country: "Guatemala",
    lat: 14.5833,
    lng: -90.527496,
  },
  {
    id: "RER",
    name: "Retalhuleu Airport",
    city: "Retalhuleu",
    country: "Guatemala",
    lat: 14.520999908447266,
    lng: -91.69730377197266,
  },
  {
    id: "GSJ",
    name: "San José Airport",
    city: "San Jose",
    country: "Guatemala",
    lat: 13.936200141899999,
    lng: -90.83580017090001,
  },
  {
    id: "LCE",
    name: "Goloson International Airport",
    city: "La Ceiba",
    country: "Honduras",
    lat: 15.7425,
    lng: -86.852997,
  },
  {
    id: "SAP",
    name: "Ramón Villeda Morales International Airport",
    city: "San Pedro Sula",
    country: "Honduras",
    lat: 15.4526,
    lng: -87.923599,
  },
  {
    id: "GJA",
    name: "La Laguna Airport",
    city: "Guanaja",
    country: "Honduras",
    lat: 16.4454,
    lng: -85.906601,
  },
  {
    id: "RTB",
    name: "Juan Manuel Galvez International Airport",
    city: "Roatan",
    country: "Honduras",
    lat: 16.316799,
    lng: -86.523003,
  },
  {
    id: "TEA",
    name: "Tela Airport",
    city: "Tela",
    country: "Honduras",
    lat: 15.7759,
    lng: -87.4758,
  },
  {
    id: "TGU",
    name: "Toncontín International Airport",
    city: "Tegucigalpa",
    country: "Honduras",
    lat: 14.06089973449707,
    lng: -87.21720123291016,
  },
  {
    id: "TJI",
    name: "Trujillo Airport",
    city: "Trujillo",
    country: "Honduras",
    lat: 15.9268,
    lng: -85.938202,
  },
  {
    id: "OCJ",
    name: "Boscobel Aerodrome",
    city: "Ocho Rios",
    country: "Jamaica",
    lat: 18.404199600219727,
    lng: -76.96900177001953,
  },
  {
    id: "KIN",
    name: "Norman Manley International Airport",
    city: "Kingston",
    country: "Jamaica",
    lat: 17.935699462890625,
    lng: -76.7874984741211,
  },
  {
    id: "MBJ",
    name: "Sangster International Airport",
    city: "Montego Bay",
    country: "Jamaica",
    lat: 18.503700256347656,
    lng: -77.91339874267578,
  },
  {
    id: "POT",
    name: "Ken Jones Airport",
    city: "Port Antonio",
    country: "Jamaica",
    lat: 18.1987991333,
    lng: -76.53450012210001,
  },
  {
    id: "KTP",
    name: "Tinson Pen Airport",
    city: "Kingston",
    country: "Jamaica",
    lat: 17.98859977722168,
    lng: -76.82379913330078,
  },
  {
    id: "ACA",
    name: "General Juan N Alvarez International Airport",
    city: "Acapulco",
    country: "Mexico",
    lat: 16.757099151611328,
    lng: -99.75399780273438,
  },
  {
    id: "NTR",
    name: "Del Norte International Airport",
    city: "Monterrey",
    country: "Mexico",
    lat: 25.865601,
    lng: -100.237,
  },
  {
    id: "AGU",
    name: "Jesús Terán Paredo International Airport",
    city: "Aguascalientes",
    country: "Mexico",
    lat: 21.705601,
    lng: -102.318001,
  },
  {
    id: "HUX",
    name: "Bahías de Huatulco International Airport",
    city: "Huatulco",
    country: "Mexico",
    lat: 15.7753,
    lng: -96.262604,
  },
  {
    id: "CVJ",
    name: "General Mariano Matamoros Airport",
    city: "Cuernavaca",
    country: "Mexico",
    lat: 18.834800720214844,
    lng: -99.26129913330078,
  },
  {
    id: "ACN",
    name: "Ciudad Acuña New International Airport",
    city: "Ciudad Acuna",
    country: "Mexico",
    lat: 29.332899,
    lng: -101.098998,
  },
  {
    id: "CME",
    name: "Ciudad del Carmen International Airport",
    city: "Ciudad Del Carmen",
    country: "Mexico",
    lat: 18.65369987487793,
    lng: -91.79900360107422,
  },
  {
    id: "NCG",
    name: "Nuevo Casas Grandes Airport",
    city: "Nuevo Casas Grandes",
    country: "Mexico",
    lat: 30.3974,
    lng: -107.875,
  },
  {
    id: "N",
    name: "Chilpancingo Airport",
    city: "Chilpancingo",
    country: "Mexico",
    lat: 17.574239,
    lng: -99.515424,
  },
  {
    id: "CUL",
    name: "Bachigualato Federal International Airport",
    city: "Culiacan",
    country: "Mexico",
    lat: 24.7644996643,
    lng: -107.474998474,
  },
  {
    id: "CTM",
    name: "Chetumal International Airport",
    city: "Chetumal",
    country: "Mexico",
    lat: 18.50469970703125,
    lng: -88.32679748535156,
  },
  {
    id: "CEN",
    name: "Ciudad Obregón International Airport",
    city: "Ciudad Obregon",
    country: "Mexico",
    lat: 27.39259910583496,
    lng: -109.83300018310547,
  },
  {
    id: "CPE",
    name: "Ingeniero Alberto Acuña Ongay International Airport",
    city: "Campeche",
    country: "Mexico",
    lat: 19.816799163800003,
    lng: -90.5002975464,
  },
  {
    id: "CJS",
    name: "Abraham González International Airport",
    city: "Ciudad Juarez",
    country: "Mexico",
    lat: 31.63610076904297,
    lng: -106.42900085449219,
  },
  {
    id: "CUU",
    name: "General Roberto Fierro Villalobos International Airport",
    city: "Chihuahua",
    country: "Mexico",
    lat: 28.702899932900003,
    lng: -105.964996338,
  },
  {
    id: "CVM",
    name: "General Pedro Jose Mendez International Airport",
    city: "Ciudad Victoria",
    country: "Mexico",
    lat: 23.7033004761,
    lng: -98.9564971924,
  },
  {
    id: "CZM",
    name: "Cozumel International Airport",
    city: "Cozumel",
    country: "Mexico",
    lat: 20.52239990234375,
    lng: -86.92559814453125,
  },
  {
    id: "DGO",
    name: "General Guadalupe Victoria International Airport",
    city: "Durango",
    country: "Mexico",
    lat: 24.1242008209,
    lng: -104.527999878,
  },
  {
    id: "TPQ",
    name: "Amado Nervo National Airport",
    city: "Tepic",
    country: "Mexico",
    lat: 21.4195,
    lng: -104.843002,
  },
  {
    id: "ESE",
    name: "Ensenada International Airport",
    city: "Ensenada",
    country: "Mexico",
    lat: 31.7953,
    lng: -116.602997,
  },
  {
    id: "GDL",
    name: "Don Miguel Hidalgo Y Costilla International Airport",
    city: "Guadalajara",
    country: "Mexico",
    lat: 20.521799087524414,
    lng: -103.31099700927734,
  },
  {
    id: "GYM",
    name: "General José María Yáñez International Airport",
    city: "Guaymas",
    country: "Mexico",
    lat: 27.9689998626709,
    lng: -110.92500305175781,
  },
  {
    id: "TCN",
    name: "Tehuacan Airport",
    city: "Tehuacan",
    country: "Mexico",
    lat: 18.49720001220703,
    lng: -97.4198989868164,
  },
  {
    id: "HMO",
    name: "General Ignacio P. Garcia International Airport",
    city: "Hermosillo",
    country: "Mexico",
    lat: 29.095899581900003,
    lng: -111.047996521,
  },
  {
    id: "CLQ",
    name: "Licenciado Miguel de la Madrid Airport",
    city: "Colima",
    country: "Mexico",
    lat: 19.277,
    lng: -103.577002,
  },
  {
    id: "ISJ",
    name: "Isla Mujeres Airport",
    city: "Isla Mujeres",
    country: "Mexico",
    lat: 21.2450008392334,
    lng: -86.73999786376953,
  },
  {
    id: "SLW",
    name: "Plan De Guadalupe International Airport",
    city: "Saltillo",
    country: "Mexico",
    lat: 25.54949951171875,
    lng: -100.92900085449219,
  },
  {
    id: "IZT",
    name: "Ixtepec Airport",
    city: "Iztepec",
    country: "Mexico",
    lat: 16.449301,
    lng: -95.093697,
  },
  {
    id: "LZC",
    name: "Lázaro Cárdenas Airport",
    city: "Lazard Cardenas",
    country: "Mexico",
    lat: 18.0016994476,
    lng: -102.221000671,
  },
  {
    id: "LMM",
    name: "Valle del Fuerte International Airport",
    city: "Los Mochis",
    country: "Mexico",
    lat: 25.6851997375,
    lng: -109.081001282,
  },
  {
    id: "BJX",
    name: "Del Bajío International Airport",
    city: "Del Bajio",
    country: "Mexico",
    lat: 20.9935,
    lng: -101.481003,
  },
  {
    id: "LAP",
    name: "Manuel Márquez de León International Airport",
    city: "La Paz",
    country: "Mexico",
    lat: 24.072700500499998,
    lng: -110.361999512,
  },
  {
    id: "LTO",
    name: "Loreto International Airport",
    city: "Loreto",
    country: "Mexico",
    lat: 25.989200592041016,
    lng: -111.3479995727539,
  },
  {
    id: "MAM",
    name: "General Servando Canales International Airport",
    city: "Matamoros",
    country: "Mexico",
    lat: 25.7698993683,
    lng: -97.5252990723,
  },
  {
    id: "MID",
    name: "Licenciado Manuel Crescencio Rejon Int Airport",
    city: "Merida",
    country: "Mexico",
    lat: 20.937000274699997,
    lng: -89.657699585,
  },
  {
    id: "MXL",
    name: "General Rodolfo Sánchez Taboada International Airport",
    city: "Mexicali",
    country: "Mexico",
    lat: 32.6306,
    lng: -115.241997,
  },
  {
    id: "MLM",
    name: "General Francisco J. Mujica International Airport",
    city: "Morelia",
    country: "Mexico",
    lat: 19.849899292,
    lng: -101.025001526,
  },
  {
    id: "MTT",
    name: "Minatitlán/Coatzacoalcos National Airport",
    city: "Minatitlan",
    country: "Mexico",
    lat: 18.1033992767,
    lng: -94.58070373540001,
  },
  {
    id: "LOV",
    name: "Monclova International Airport",
    city: "Monclova",
    country: "Mexico",
    lat: 26.9557,
    lng: -101.470001,
  },
  {
    id: "MEX",
    name: "Licenciado Benito Juarez International Airport",
    city: "Mexico City",
    country: "Mexico",
    lat: 19.4363,
    lng: -99.072098,
  },
  {
    id: "MTY",
    name: "General Mariano Escobedo International Airport",
    city: "Monterrey",
    country: "Mexico",
    lat: 25.7784996033,
    lng: -100.107002258,
  },
  {
    id: "MZT",
    name: "General Rafael Buelna International Airport",
    city: "Mazatlan",
    country: "Mexico",
    lat: 23.1613998413,
    lng: -106.26599884,
  },
  {
    id: "NOG",
    name: "Nogales International Airport",
    city: "Nogales",
    country: "Mexico",
    lat: 31.22610092163086,
    lng: -110.97599792480469,
  },
  {
    id: "NLD",
    name: "Quetzalcóatl International Airport",
    city: "Nuevo Laredo",
    country: "Mexico",
    lat: 27.4438991547,
    lng: -99.5705032349,
  },
  {
    id: "OAX",
    name: "Xoxocotlán International Airport",
    city: "Oaxaca",
    country: "Mexico",
    lat: 16.9999008179,
    lng: -96.726600647,
  },
  {
    id: "PAZ",
    name: "El Tajín National Airport",
    city: "Poza Rico",
    country: "Mexico",
    lat: 20.6026992798,
    lng: -97.46080017090001,
  },
  {
    id: "PBC",
    name: "Hermanos Serdán International Airport",
    city: "Puebla",
    country: "Mexico",
    lat: 19.1581001282,
    lng: -98.3713989258,
  },
  {
    id: "N",
    name: "Ingeniero Juan Guillermo Villasana Airport",
    city: "Pachuca",
    country: "Mexico",
    lat: 20.0774,
    lng: -98.782501,
  },
  {
    id: "PPE",
    name: "Mar de Cortés International Airport",
    city: "Punta Penasco",
    country: "Mexico",
    lat: 31.351987,
    lng: -113.305177,
  },
  {
    id: "PDS",
    name: "Piedras Negras International Airport",
    city: "Piedras Negras",
    country: "Mexico",
    lat: 28.627399,
    lng: -100.535004,
  },
  {
    id: "UPN",
    name: "Licenciado y General Ignacio Lopez Rayon Airport",
    city: "Uruapan",
    country: "Mexico",
    lat: 19.396699905395508,
    lng: -102.03900146484375,
  },
  {
    id: "PVR",
    name: "Licenciado Gustavo Díaz Ordaz International Airport",
    city: "Puerto Vallarta",
    country: "Mexico",
    lat: 20.680099487304688,
    lng: -105.25399780273438,
  },
  {
    id: "PXM",
    name: "Puerto Escondido International Airport",
    city: "Puerto Escondido",
    country: "Mexico",
    lat: 15.8769,
    lng: -97.089103,
  },
  {
    id: "QRO",
    name: "Querétaro Intercontinental Airport",
    city: "Queretaro",
    country: "Mexico",
    lat: 20.6173,
    lng: -100.185997,
  },
  {
    id: "REX",
    name: "General Lucio Blanco International Airport",
    city: "Reynosa",
    country: "Mexico",
    lat: 26.0089,
    lng: -98.2285,
  },
  {
    id: "SJD",
    name: "Los Cabos International Airport",
    city: "San Jose Del Cabo",
    country: "Mexico",
    lat: 23.15180015563965,
    lng: -109.72100067138672,
  },
  {
    id: "SFH",
    name: "San Felipe International Airport",
    city: "San Filipe",
    country: "Mexico",
    lat: 30.930200576782,
    lng: -114.80899810791,
  },
  {
    id: "SLP",
    name: "Ponciano Arriaga International Airport",
    city: "San Luis Potosi",
    country: "Mexico",
    lat: 22.254299163800003,
    lng: -100.930999756,
  },
  {
    id: "N",
    name: "Tlaxcala Airport",
    city: "Tlaxcala",
    country: "Mexico",
    lat: 19.537992,
    lng: -98.173492,
  },
  {
    id: "N",
    name: "Terán Air Base",
    city: "Tuxtla Gutierrez",
    country: "Mexico",
    lat: 16.739901,
    lng: -93.173301,
  },
  {
    id: "TRC",
    name: "Francisco Sarabia International Airport",
    city: "Torreon",
    country: "Mexico",
    lat: 25.568300247199996,
    lng: -103.411003113,
  },
  {
    id: "TGZ",
    name: "Angel Albino Corzo International Airport",
    city: "Tuxtla Gutierrez",
    country: "Mexico",
    lat: 16.5636005402,
    lng: -93.02249908450001,
  },
  {
    id: "TIJ",
    name: "General Abelardo L. Rodríguez International Airport",
    city: "Tijuana",
    country: "Mexico",
    lat: 32.541099548339844,
    lng: -116.97000122070312,
  },
  {
    id: "TAM",
    name: "General Francisco Javier Mina International Airport",
    city: "Tampico",
    country: "Mexico",
    lat: 22.2964000702,
    lng: -97.8658981323,
  },
  {
    id: "TSL",
    name: "Tamuin Airport",
    city: "Tamuin",
    country: "Mexico",
    lat: 22.0383,
    lng: -98.806502,
  },
  {
    id: "TLC",
    name: "Licenciado Adolfo Lopez Mateos International Airport",
    city: "Toluca",
    country: "Mexico",
    lat: 19.3370990753,
    lng: -99.56600189210002,
  },
  {
    id: "TAP",
    name: "Tapachula International Airport",
    city: "Tapachula",
    country: "Mexico",
    lat: 14.7943000793,
    lng: -92.3700027466,
  },
  {
    id: "CUN",
    name: "Cancún International Airport",
    city: "Cancun",
    country: "Mexico",
    lat: 21.036500930800003,
    lng: -86.8770980835,
  },
  {
    id: "VSA",
    name: "Carlos Rovirosa Pérez International Airport",
    city: "Villahermosa",
    country: "Mexico",
    lat: 17.996999740600586,
    lng: -92.81739807128906,
  },
  {
    id: "VER",
    name: "General Heriberto Jara International Airport",
    city: "Vera Cruz",
    country: "Mexico",
    lat: 19.1459007263,
    lng: -96.1873016357,
  },
  {
    id: "ZCL",
    name: "General Leobardo C. Ruiz International Airport",
    city: "Zacatecas",
    country: "Mexico",
    lat: 22.8971004486,
    lng: -102.68699646,
  },
  {
    id: "ZIH",
    name: "Ixtapa Zihuatanejo International Airport",
    city: "Zihuatanejo",
    country: "Mexico",
    lat: 17.601600647,
    lng: -101.460998535,
  },
  {
    id: "ZMM",
    name: "Zamora Airport",
    city: "Zamora",
    country: "Mexico",
    lat: 20.045,
    lng: -102.276001,
  },
  {
    id: "ZLO",
    name: "Playa De Oro International Airport",
    city: "Manzanillo",
    country: "Mexico",
    lat: 19.144800186199998,
    lng: -104.558998108,
  },
  {
    id: "N",
    name: "Zapopan Airport",
    city: "Zapopan",
    country: "Mexico",
    lat: 20.747922,
    lng: -103.461709,
  },
  {
    id: "BEF",
    name: "Bluefields Airport",
    city: "Bluefields",
    country: "Nicaragua",
    lat: 11.991000175476074,
    lng: -83.77410125732422,
  },
  {
    id: "N",
    name: "Los Brasiles Airport",
    city: "Los Brasiles",
    country: "Nicaragua",
    lat: 12.1899995803833,
    lng: -86.35389709472656,
  },
  {
    id: "N",
    name: "Leon (Fanor Urroz) Airport",
    city: "Leon",
    country: "Nicaragua",
    lat: 12.429200172424316,
    lng: -86.90280151367188,
  },
  {
    id: "MGA",
    name: "Augusto C. Sandino (Managua) International Airport",
    city: "Managua",
    country: "Nicaragua",
    lat: 12.141500473022461,
    lng: -86.16819763183594,
  },
  {
    id: "PUZ",
    name: "Puerto Cabezas Airport",
    city: "Puerto Cabezas",
    country: "Nicaragua",
    lat: 14.047200202941895,
    lng: -83.38670349121094,
  },
  {
    id: "BOC",
    name: "Bocas Del Toro International Airport",
    city: "Bocas Del Toro",
    country: "Panama",
    lat: 9.340849876403809,
    lng: -82.25080108642578,
  },
  {
    id: "CHX",
    name: "Cap Manuel Niño International Airport",
    city: "Changuinola",
    country: "Panama",
    lat: 9.458962,
    lng: -82.515062,
  },
  {
    id: "DAV",
    name: "Enrique Malek International Airport",
    city: "David",
    country: "Panama",
    lat: 8.390999794006348,
    lng: -82.43499755859375,
  },
  {
    id: "BLB",
    name: "Panama Pacific International Airport",
    city: "Howard",
    country: "Panama",
    lat: 8.91479,
    lng: -79.599602,
  },
  {
    id: "PAC",
    name: "Marcos A. Gelabert International Airport",
    city: "Panama",
    country: "Panama",
    lat: 8.973340034484863,
    lng: -79.55560302734375,
  },
  {
    id: "SYP",
    name: "Ruben Cantu Airport",
    city: "Santiago",
    country: "Panama",
    lat: 8.085599899291992,
    lng: -80.94529724121094,
  },
  {
    id: "PTY",
    name: "Tocumen International Airport",
    city: "Panama City",
    country: "Panama",
    lat: 9.0713596344,
    lng: -79.3834991455,
  },
  {
    id: "BAI",
    name: "Buenos Aires Airport",
    city: "Buenos Aires",
    country: "Costa Rica",
    lat: 9.163949,
    lng: -83.330171,
  },
  {
    id: "OTR",
    name: "Coto 47 Airport",
    city: "Coto 47",
    country: "Costa Rica",
    lat: 8.60155963897705,
    lng: -82.96859741210938,
  },
  {
    id: "JAP",
    name: "Chacarita Airport",
    city: "Chacarita",
    country: "Costa Rica",
    lat: 9.98141002655,
    lng: -84.7726974487,
  },
  {
    id: "N",
    name: "El Carmen de Siquirres Airport",
    city: "El Carmen",
    country: "Costa Rica",
    lat: 10.20199966430664,
    lng: -83.47219848632812,
  },
  {
    id: "N",
    name: "Finca 10 / Nuevo Palmar Sur Airport",
    city: "Finca 10",
    country: "Costa Rica",
    lat: 8.916350364685059,
    lng: -83.5073013305664,
  },
  {
    id: "GLF",
    name: "Golfito Airport",
    city: "Golfito",
    country: "Costa Rica",
    lat: 8.654009819030762,
    lng: -83.18219757080078,
  },
  {
    id: "GPL",
    name: "Guapiles Airport",
    city: "Guapiles",
    country: "Costa Rica",
    lat: 10.2172002792,
    lng: -83.79699707030001,
  },
  {
    id: "LIR",
    name: "Daniel Oduber Quiros International Airport",
    city: "Liberia",
    country: "Costa Rica",
    lat: 10.5933,
    lng: -85.544403,
  },
  {
    id: "LSL",
    name: "Los Chiles Airport",
    city: "Los Chiles",
    country: "Costa Rica",
    lat: 11.035300254821777,
    lng: -84.70610046386719,
  },
  {
    id: "LIO",
    name: "Limon International Airport",
    city: "Limon",
    country: "Costa Rica",
    lat: 9.95796012878418,
    lng: -83.02200317382812,
  },
  {
    id: "NOB",
    name: "Nosara Airport",
    city: "Nosara Beach",
    country: "Costa Rica",
    lat: 9.976490020750001,
    lng: -85.65299987790002,
  },
  {
    id: "SJO",
    name: "Juan Santamaria International Airport",
    city: "San Jose",
    country: "Costa Rica",
    lat: 9.993860244750977,
    lng: -84.20880126953125,
  },
  {
    id: "N",
    name: "Pandora Airport",
    city: "Pandora",
    country: "Costa Rica",
    lat: 9.732170104980469,
    lng: -82.98320007324219,
  },
  {
    id: "PMZ",
    name: "Palmar Sur Airport",
    city: "Palmar Sur",
    country: "Costa Rica",
    lat: 8.951029777526855,
    lng: -83.46859741210938,
  },
  {
    id: "XQP",
    name: "Quepos Managua Airport",
    city: "Quepos",
    country: "Costa Rica",
    lat: 9.443160057067871,
    lng: -84.12979888916016,
  },
  {
    id: "N",
    name: "Santa Clara De Guapiles Airport",
    city: "Santa Clara",
    country: "Costa Rica",
    lat: 10.288299560546875,
    lng: -83.7135009765625,
  },
  {
    id: "TOO",
    name: "San Vito De Java Airport",
    city: "San Vito De Jaba",
    country: "Costa Rica",
    lat: 8.826109886169434,
    lng: -82.95890045166016,
  },
  {
    id: "SAL",
    name: "Monseñor Óscar Arnulfo Romero International Airport",
    city: "San Salvador",
    country: "El Salvador",
    lat: 13.4409,
    lng: -89.055702,
  },
  {
    id: "N",
    name: "Ilopango International Airport",
    city: "San Salvador",
    country: "El Salvador",
    lat: 13.69950008392334,
    lng: -89.11990356445312,
  },
  {
    id: "CYA",
    name: "Les Cayes Airport",
    city: "Cayes",
    country: "Haiti",
    lat: 18.271099090576172,
    lng: -73.78829956054688,
  },
  {
    id: "CAP",
    name: "Cap Haitien International Airport",
    city: "Cap Haitien",
    country: "Haiti",
    lat: 19.733,
    lng: -72.194702,
  },
  {
    id: "JAK",
    name: "Jacmel Airport",
    city: "Jacmel",
    country: "Haiti",
    lat: 18.241100311279297,
    lng: -72.51850128173828,
  },
  {
    id: "PAP",
    name: "Toussaint Louverture International Airport",
    city: "Port-au-prince",
    country: "Haiti",
    lat: 18.579999923706055,
    lng: -72.2925033569336,
  },
  {
    id: "BCA",
    name: "Gustavo Rizo Airport",
    city: "Baracoa Playa",
    country: "Cuba",
    lat: 20.365299224853516,
    lng: -74.5062026977539,
  },
  {
    id: "BYM",
    name: "Carlos Manuel de Cespedes Airport",
    city: "Bayamo",
    country: "Cuba",
    lat: 20.396400451660156,
    lng: -76.62139892578125,
  },
  {
    id: "AVI",
    name: "Maximo Gomez Airport",
    city: "Ciego De Avila",
    country: "Cuba",
    lat: 22.027099609375,
    lng: -78.78959655761719,
  },
  {
    id: "CCC",
    name: "Jardines Del Rey Airport",
    city: "Cunagua",
    country: "Cuba",
    lat: 22.461000442499998,
    lng: -78.32839965820001,
  },
  {
    id: "CFG",
    name: "Jaime Gonzalez Airport",
    city: "Cienfuegos",
    country: "Cuba",
    lat: 22.149999618530273,
    lng: -80.41419982910156,
  },
  {
    id: "CYO",
    name: "Vilo Acuña International Airport",
    city: "Cayo Largo del Sur",
    country: "Cuba",
    lat: 21.6165008545,
    lng: -81.5459976196,
  },
  {
    id: "CMW",
    name: "Ignacio Agramonte International Airport",
    city: "Camaguey",
    country: "Cuba",
    lat: 21.420299530029297,
    lng: -77.84750366210938,
  },
  {
    id: "SCU",
    name: "Antonio Maceo International Airport",
    city: "Santiago De Cuba",
    country: "Cuba",
    lat: 19.96980094909668,
    lng: -75.83540344238281,
  },
  {
    id: "N",
    name: "Florida Airport",
    city: "Florida",
    country: "Cuba",
    lat: 21.49970054626465,
    lng: -78.20279693603516,
  },
  {
    id: "NBW",
    name: "Leeward Point Field",
    city: "Guantanamo",
    country: "Cuba",
    lat: 19.906499862671,
    lng: -75.207099914551,
  },
  {
    id: "GAO",
    name: "Mariana Grajales Airport",
    city: "Guantanamo",
    country: "Cuba",
    lat: 20.08530044555664,
    lng: -75.1583023071289,
  },
  {
    id: "HAV",
    name: "José Martí International Airport",
    city: "Havana",
    country: "Cuba",
    lat: 22.989200592041016,
    lng: -82.40910339355469,
  },
  {
    id: "HOG",
    name: "Frank Pais International Airport",
    city: "Holguin",
    country: "Cuba",
    lat: 20.785600662231445,
    lng: -76.31510162353516,
  },
  {
    id: "LCL",
    name: "La Coloma Airport",
    city: "La Coloma",
    country: "Cuba",
    lat: 22.33609962463379,
    lng: -83.64189910888672,
  },
  {
    id: "MOA",
    name: "Orestes Acosta Airport",
    city: "Moa",
    country: "Cuba",
    lat: 20.653900146484375,
    lng: -74.92220306396484,
  },
  {
    id: "MZO",
    name: "Sierra Maestra Airport",
    city: "Manzanillo",
    country: "Cuba",
    lat: 20.28809928894043,
    lng: -77.08920288085938,
  },
  {
    id: "GER",
    name: "Rafael Cabrera Airport",
    city: "Nueva Gerona",
    country: "Cuba",
    lat: 21.834699630737305,
    lng: -82.78379821777344,
  },
  {
    id: "UPB",
    name: "Playa Baracoa Airport",
    city: "Baracoa Playa",
    country: "Cuba",
    lat: 23.032800674399997,
    lng: -82.5793991089,
  },
  {
    id: "QPD",
    name: "Pinar Del Rio Airport",
    city: "Pinar Del Rio Norte",
    country: "Cuba",
    lat: 22.42140007019043,
    lng: -83.67839813232422,
  },
  {
    id: "N",
    name: "San Antonio De Los Banos Airport",
    city: "San Antonio De Banos",
    country: "Cuba",
    lat: 22.87150001525879,
    lng: -82.5093002319336,
  },
  {
    id: "SNU",
    name: "Abel Santamaria Airport",
    city: "Santa Clara",
    country: "Cuba",
    lat: 22.49220085144043,
    lng: -79.943603515625,
  },
  {
    id: "N",
    name: "Joaquín de Agüero Airport",
    city: "Santa Lucia",
    country: "Cuba",
    lat: 21.509455906699998,
    lng: -77.02059745790001,
  },
  {
    id: "SZJ",
    name: "Siguanea Airport",
    city: "Siguanea",
    country: "Cuba",
    lat: 21.642499923706055,
    lng: -82.9551010131836,
  },
  {
    id: "USS",
    name: "Sancti Spiritus Airport",
    city: "Sancti Spiritus",
    country: "Cuba",
    lat: 21.9704,
    lng: -79.442703,
  },
  {
    id: "VRA",
    name: "Juan Gualberto Gomez International Airport",
    city: "Varadero",
    country: "Cuba",
    lat: 23.034400939941406,
    lng: -81.435302734375,
  },
  {
    id: "VTU",
    name: "Hermanos Ameijeiras Airport",
    city: "Las Tunas",
    country: "Cuba",
    lat: 20.987600326538086,
    lng: -76.93579864501953,
  },
  {
    id: "CYB",
    name: "Gerrard Smith International Airport",
    city: "Cayman Brac",
    country: "Cayman Islands",
    lat: 19.687000274658203,
    lng: -79.88279724121094,
  },
  {
    id: "GCM",
    name: "Owen Roberts International Airport",
    city: "Georgetown",
    country: "Cayman Islands",
    lat: 19.292800903299998,
    lng: -81.3576965332,
  },
  {
    id: "MAY",
    name: "Clarence A. Bain Airport",
    city: "Clarence Bain",
    country: "Bahamas",
    lat: 24.287700653076172,
    lng: -77.68460083007812,
  },
  {
    id: "ASD",
    name: "Andros Town Airport",
    city: "Andros Town",
    country: "Bahamas",
    lat: 24.697900772094727,
    lng: -77.79560089111328,
  },
  {
    id: "MHH",
    name: "Leonard M Thompson International Airport",
    city: "Marsh Harbor",
    country: "Bahamas",
    lat: 26.5114,
    lng: -77.083503,
  },
  {
    id: "SAQ",
    name: "San Andros Airport",
    city: "San Andros",
    country: "Bahamas",
    lat: 25.053800582885742,
    lng: -78.04900360107422,
  },
  {
    id: "AXP",
    name: "Spring Point Airport",
    city: "Spring Point",
    country: "Bahamas",
    lat: 22.441799163800003,
    lng: -73.97090148930002,
  },
  {
    id: "N",
    name: "Sandy Point Airport",
    city: "Sandy Point",
    country: "Bahamas",
    lat: 26.004600524902344,
    lng: -77.39550018310547,
  },
  {
    id: "TCB",
    name: "Treasure Cay Airport",
    city: "Treasure Cay",
    country: "Bahamas",
    lat: 26.745300293,
    lng: -77.3912963867,
  },
  {
    id: "CCZ",
    name: "Chub Cay Airport",
    city: "Chub Cay",
    country: "Bahamas",
    lat: 25.41710090637207,
    lng: -77.88089752197266,
  },
  {
    id: "GHC",
    name: "Great Harbour Cay Airport",
    city: "Bullocks Harbour",
    country: "Bahamas",
    lat: 25.7383,
    lng: -77.840103,
  },
  {
    id: "BIM",
    name: "South Bimini Airport",
    city: "Alice Town",
    country: "Bahamas",
    lat: 25.6998996735,
    lng: -79.2647018433,
  },
  {
    id: "GGT",
    name: "Exuma International Airport",
    city: "Great Exuma",
    country: "Bahamas",
    lat: 23.5625991821,
    lng: -75.8779983521,
  },
  {
    id: "N",
    name: "George Town Airport",
    city: "George Town",
    country: "Bahamas",
    lat: 23.4666996002,
    lng: -75.78170013430001,
  },
  {
    id: "ELH",
    name: "North Eleuthera Airport",
    city: "North Eleuthera",
    country: "Bahamas",
    lat: 25.474899292,
    lng: -76.6835021973,
  },
  {
    id: "GHB",
    name: "Governor's Harbour Airport",
    city: "Governor's Harbor",
    country: "Bahamas",
    lat: 25.2847003937,
    lng: -76.3310012817,
  },
  {
    id: "NMC",
    name: "Normans Cay Airport",
    city: "Norman's Cay",
    country: "Bahamas",
    lat: 24.59429931640625,
    lng: -76.82019805908203,
  },
  {
    id: "RSD",
    name: "Rock Sound Airport",
    city: "Rock Sound",
    country: "Bahamas",
    lat: 24.8950787333,
    lng: -76.1768817902,
  },
  {
    id: "TYM",
    name: "Staniel Cay Airport",
    city: "Staniel Cay",
    country: "Bahamas",
    lat: 24.169099807739258,
    lng: -76.43910217285156,
  },
  {
    id: "FPO",
    name: "Grand Bahama International Airport",
    city: "Freeport",
    country: "Bahamas",
    lat: 26.5587005615,
    lng: -78.695602417,
  },
  {
    id: "IGA",
    name: "Inagua Airport",
    city: "Matthew Town",
    country: "Bahamas",
    lat: 20.975000381469727,
    lng: -73.66690063476562,
  },
  {
    id: "LGI",
    name: "Deadman's Cay Airport",
    city: "Dead Man's Cay",
    country: "Bahamas",
    lat: 23.1790008545,
    lng: -75.09359741210001,
  },
  {
    id: "SML",
    name: "Stella Maris Airport",
    city: "Stella Maris",
    country: "Bahamas",
    lat: 23.582317,
    lng: -75.268621,
  },
  {
    id: "MYG",
    name: "Mayaguana Airport",
    city: "Mayaguana",
    country: "Bahamas",
    lat: 22.379499,
    lng: -73.013494,
  },
  {
    id: "NAS",
    name: "Lynden Pindling International Airport",
    city: "Nassau",
    country: "Bahamas",
    lat: 25.0389995575,
    lng: -77.46620178219999,
  },
  {
    id: "DCT",
    name: "Duncan Town Airport",
    city: "Duncan Town",
    country: "Bahamas",
    lat: 22.181800842285156,
    lng: -75.72949981689453,
  },
  {
    id: "RCY",
    name: "Rum Cay Airport",
    city: "Port Nelson",
    country: "Bahamas",
    lat: 23.68440055847168,
    lng: -74.83619689941406,
  },
  {
    id: "ZSA",
    name: "San Salvador Airport",
    city: "Cockburn Town",
    country: "Bahamas",
    lat: 24.06329917907715,
    lng: -74.52400207519531,
  },
  {
    id: "BZE",
    name: "Philip S. W. Goldson International Airport",
    city: "Belize City",
    country: "Belize",
    lat: 17.539100646972656,
    lng: -88.30819702148438,
  },
  {
    id: "AIT",
    name: "Aitutaki Airport",
    city: "Aitutaki",
    country: "Cook Islands",
    lat: -18.830900192260742,
    lng: -159.76400756835938,
  },
  {
    id: "RAR",
    name: "Rarotonga International Airport",
    city: "Avarua",
    country: "Cook Islands",
    lat: -21.2026996613,
    lng: -159.805999756,
  },
  {
    id: "NAN",
    name: "Nadi International Airport",
    city: "Nandi",
    country: "Fiji",
    lat: -17.755399703979492,
    lng: 177.4429931640625,
  },
  {
    id: "SUV",
    name: "Nausori International Airport",
    city: "Nausori",
    country: "Fiji",
    lat: -18.04330062866211,
    lng: 178.5590057373047,
  },
  {
    id: "TBU",
    name: "Fua'amotu International Airport",
    city: "Tongatapu",
    country: "Tonga",
    lat: -21.241199493408203,
    lng: -175.14999389648438,
  },
  {
    id: "VAV",
    name: "Vava'u International Airport",
    city: "Vava'u",
    country: "Tonga",
    lat: -18.58530044555664,
    lng: -173.96200561523438,
  },
  {
    id: "TRW",
    name: "Bonriki International Airport",
    city: "Tarawa",
    country: "Kiribati",
    lat: 1.3816399574279785,
    lng: 173.14700317382812,
  },
  {
    id: "TBF",
    name: "Tabiteuea North Airport",
    city: "Tabiteuea North",
    country: "Kiribati",
    lat: -1.2244700193405151,
    lng: 174.7760009765625,
  },
  {
    id: "WLS",
    name: "Hihifo Airport",
    city: "Wallis",
    country: "Wallis and Futuna",
    lat: -13.2383003235,
    lng: -176.199005127,
  },
  {
    id: "APW",
    name: "Faleolo International Airport",
    city: "Faleolo",
    country: "Samoa",
    lat: -13.829999923706055,
    lng: -172.00799560546875,
  },
  {
    id: "PPG",
    name: "Pago Pago International Airport",
    city: "Pago Pago",
    country: "American Samoa",
    lat: -14.3310003281,
    lng: -170.710006714,
  },
  {
    id: "RUR",
    name: "Rurutu Airport",
    city: "Rurutu",
    country: "French Polynesia",
    lat: -22.434099197387695,
    lng: -151.36099243164062,
  },
  {
    id: "TUB",
    name: "Tubuai Airport",
    city: "Tubuai",
    country: "French Polynesia",
    lat: -23.365400314331055,
    lng: -149.5240020751953,
  },
  {
    id: "AAA",
    name: "Anaa Airport",
    city: "Anaa",
    country: "French Polynesia",
    lat: -17.35260009765625,
    lng: -145.50999450683594,
  },
  {
    id: "FGU",
    name: "Fangatau Airport",
    city: "Fangatau",
    country: "French Polynesia",
    lat: -15.819899559020996,
    lng: -140.88699340820312,
  },
  {
    id: "TIH",
    name: "Tikehau Airport",
    city: "Tikehau",
    country: "French Polynesia",
    lat: -15.119600296020508,
    lng: -148.2310028076172,
  },
  {
    id: "REA",
    name: "Reao Airport",
    city: "Reao",
    country: "French Polynesia",
    lat: -18.465900421142578,
    lng: -136.44000244140625,
  },
  {
    id: "FAV",
    name: "Fakarava Airport",
    city: "Fakarava",
    country: "French Polynesia",
    lat: -16.054100036621094,
    lng: -145.65699768066406,
  },
  {
    id: "XMH",
    name: "Manihi Airport",
    city: "Manihi",
    country: "French Polynesia",
    lat: -14.436800003051758,
    lng: -146.07000732421875,
  },
  {
    id: "GMR",
    name: "Totegegie Airport",
    city: "Totegegie",
    country: "French Polynesia",
    lat: -23.07990074157715,
    lng: -134.88999938964844,
  },
  {
    id: "KKR",
    name: "Kaukura Airport",
    city: "Kaukura Atoll",
    country: "French Polynesia",
    lat: -15.663299560546875,
    lng: -146.88499450683594,
  },
  {
    id: "MKP",
    name: "Makemo Airport",
    city: "Makemo",
    country: "French Polynesia",
    lat: -16.583900451660156,
    lng: -143.6580047607422,
  },
  {
    id: "PKP",
    name: "Puka Puka Airport",
    city: "Puka Puka",
    country: "French Polynesia",
    lat: -14.809499740600586,
    lng: -138.81300354003906,
  },
  {
    id: "TKP",
    name: "Takapoto Airport",
    city: "Takapoto",
    country: "French Polynesia",
    lat: -14.709500312805176,
    lng: -145.24600219726562,
  },
  {
    id: "AXR",
    name: "Arutua Airport",
    city: "Arutua",
    country: "French Polynesia",
    lat: -15.248299598693848,
    lng: -146.61700439453125,
  },
  {
    id: "MVT",
    name: "Mataiva Airport",
    city: "Mataiva",
    country: "French Polynesia",
    lat: -14.8681001663208,
    lng: -148.7169952392578,
  },
  {
    id: "TKX",
    name: "Takaroa Airport",
    city: "Takaroa",
    country: "French Polynesia",
    lat: -14.45580005645752,
    lng: -145.02499389648438,
  },
  {
    id: "NHV",
    name: "Nuku Hiva Airport",
    city: "Nuku Hiva",
    country: "French Polynesia",
    lat: -8.795599937438965,
    lng: -140.22900390625,
  },
  {
    id: "BOB",
    name: "Bora Bora Airport",
    city: "Bora Bora",
    country: "French Polynesia",
    lat: -16.444400787353516,
    lng: -151.75100708007812,
  },
  {
    id: "RGI",
    name: "Rangiroa Airport",
    city: "Rangiroa",
    country: "French Polynesia",
    lat: -14.954299926757812,
    lng: -147.66099548339844,
  },
  {
    id: "HUH",
    name: "Huahine-Fare Airport",
    city: "Huahine Island",
    country: "French Polynesia",
    lat: -16.68720054626465,
    lng: -151.02200317382812,
  },
  {
    id: "MOZ",
    name: "Moorea Airport",
    city: "Moorea",
    country: "French Polynesia",
    lat: -17.49,
    lng: -149.761993,
  },
  {
    id: "HOI",
    name: "Hao Airport",
    city: "Hao Island",
    country: "French Polynesia",
    lat: -18.074800491333008,
    lng: -140.9459991455078,
  },
  {
    id: "MAU",
    name: "Maupiti Airport",
    city: "Maupiti",
    country: "French Polynesia",
    lat: -16.42650032043457,
    lng: -152.24400329589844,
  },
  {
    id: "RFP",
    name: "Raiatea Airport",
    city: "Raiatea Island",
    country: "French Polynesia",
    lat: -16.7229,
    lng: -151.466003,
  },
  {
    id: "VLI",
    name: "Bauerfield International Airport",
    city: "Port-vila",
    country: "Vanuatu",
    lat: -17.699300765991,
    lng: 168.32000732422,
  },
  {
    id: "KNQ",
    name: "Koné Airport",
    city: "Kone",
    country: "New Caledonia",
    lat: -21.05430030822754,
    lng: 164.83700561523438,
  },
  {
    id: "KOC",
    name: "Koumac Airport",
    city: "Koumac",
    country: "New Caledonia",
    lat: -20.546300888061523,
    lng: 164.25599670410156,
  },
  {
    id: "LIF",
    name: "Lifou Airport",
    city: "Lifou",
    country: "New Caledonia",
    lat: -20.774799346923828,
    lng: 167.24000549316406,
  },
  {
    id: "GEA",
    name: "Nouméa Magenta Airport",
    city: "Noumea",
    country: "New Caledonia",
    lat: -22.25830078125,
    lng: 166.47300720214844,
  },
  {
    id: "MEE",
    name: "Maré Airport",
    city: "Mare",
    country: "New Caledonia",
    lat: -21.481700897216797,
    lng: 168.03799438476562,
  },
  {
    id: "TOU",
    name: "Touho Airport",
    city: "Touho",
    country: "New Caledonia",
    lat: -20.790000915527344,
    lng: 165.25900268554688,
  },
  {
    id: "UVE",
    name: "Ouvéa Airport",
    city: "Ouvea",
    country: "New Caledonia",
    lat: -20.640600204467773,
    lng: 166.572998046875,
  },
  {
    id: "NOU",
    name: "La Tontouta International Airport",
    city: "Noumea",
    country: "New Caledonia",
    lat: -22.01460075378418,
    lng: 166.21299743652344,
  },
  {
    id: "AKL",
    name: "Auckland International Airport",
    city: "Auckland",
    country: "New Zealand",
    lat: -37.008098602299995,
    lng: 174.792007446,
  },
  {
    id: "TUO",
    name: "Taupo Airport",
    city: "Taupo",
    country: "New Zealand",
    lat: -38.73970031738281,
    lng: 176.08399963378906,
  },
  {
    id: "AMZ",
    name: "Ardmore Airport",
    city: "Ardmore",
    country: "New Zealand",
    lat: -37.029701232910156,
    lng: 174.97300720214844,
  },
  {
    id: "CHC",
    name: "Christchurch International Airport",
    city: "Christchurch",
    country: "New Zealand",
    lat: -43.48939895629883,
    lng: 172.53199768066406,
  },
  {
    id: "CHT",
    name: "Chatham Islands-Tuuta Airport",
    city: "Chatham Island",
    country: "New Zealand",
    lat: -43.810001373291016,
    lng: -176.45700073242188,
  },
  {
    id: "DUD",
    name: "Dunedin Airport",
    city: "Dunedin",
    country: "New Zealand",
    lat: -45.9281005859375,
    lng: 170.197998046875,
  },
  {
    id: "GIS",
    name: "Gisborne Airport",
    city: "Gisborne",
    country: "New Zealand",
    lat: -38.663299560546875,
    lng: 177.97799682617188,
  },
  {
    id: "GTN",
    name: "Glentanner Airport",
    city: "Glentanner",
    country: "New Zealand",
    lat: -43.906700134277344,
    lng: 170.1280059814453,
  },
  {
    id: "HKK",
    name: "Hokitika Airfield",
    city: "Hokitika",
    country: "New Zealand",
    lat: -42.713600158691406,
    lng: 170.98500061035156,
  },
  {
    id: "HLZ",
    name: "Hamilton International Airport",
    city: "Hamilton",
    country: "New Zealand",
    lat: -37.8666992188,
    lng: 175.332000732,
  },
  {
    id: "N",
    name: "Hastings Aerodrome",
    city: "Hastings",
    country: "New Zealand",
    lat: -39.646702,
    lng: 176.766998,
  },
  {
    id: "KKE",
    name: "Kerikeri Airport",
    city: "Kerikeri",
    country: "New Zealand",
    lat: -35.26279830932617,
    lng: 173.91200256347656,
  },
  {
    id: "KAT",
    name: "Kaitaia Airport",
    city: "Kaitaia",
    country: "New Zealand",
    lat: -35.06999969482422,
    lng: 173.28500366210938,
  },
  {
    id: "ALR",
    name: "Alexandra Airport",
    city: "Alexandra",
    country: "New Zealand",
    lat: -45.211700439453125,
    lng: 169.3730010986328,
  },
  {
    id: "MON",
    name: "Mount Cook Airport",
    city: "Mount Cook",
    country: "New Zealand",
    lat: -43.76499938964844,
    lng: 170.13299560546875,
  },
  {
    id: "TEU",
    name: "Manapouri Airport",
    city: "Manapouri",
    country: "New Zealand",
    lat: -45.53310012817383,
    lng: 167.64999389648438,
  },
  {
    id: "MRO",
    name: "Hood Airport",
    city: "Masterton",
    country: "New Zealand",
    lat: -40.97330093383789,
    lng: 175.63400268554688,
  },
  {
    id: "NPL",
    name: "New Plymouth Airport",
    city: "New Plymouth",
    country: "New Zealand",
    lat: -39.00859832763672,
    lng: 174.1790008544922,
  },
  {
    id: "NSN",
    name: "Nelson Airport",
    city: "Nelson",
    country: "New Zealand",
    lat: -41.298301696777344,
    lng: 173.2209930419922,
  },
  {
    id: "IVC",
    name: "Invercargill Airport",
    city: "Invercargill",
    country: "New Zealand",
    lat: -46.41239929199219,
    lng: 168.31300354003906,
  },
  {
    id: "OHA",
    name: "RNZAF Base Ohakea",
    city: "Ohakea",
    country: "New Zealand",
    lat: -40.20600128173828,
    lng: 175.38800048828125,
  },
  {
    id: "OAM",
    name: "Oamaru Airport",
    city: "Oamaru",
    country: "New Zealand",
    lat: -44.970001220703125,
    lng: 171.08200073242188,
  },
  {
    id: "PMR",
    name: "Palmerston North Airport",
    city: "Palmerston North",
    country: "New Zealand",
    lat: -40.32059860229492,
    lng: 175.61700439453125,
  },
  {
    id: "PPQ",
    name: "Paraparaumu Airport",
    city: "Paraparaumu",
    country: "New Zealand",
    lat: -40.904701232910156,
    lng: 174.98899841308594,
  },
  {
    id: "ZQN",
    name: "Queenstown International Airport",
    city: "Queenstown International",
    country: "New Zealand",
    lat: -45.0210990906,
    lng: 168.738998413,
  },
  {
    id: "ROT",
    name: "Rotorua Regional Airport",
    city: "Rotorua",
    country: "New Zealand",
    lat: -38.10919952392578,
    lng: 176.31700134277344,
  },
  {
    id: "N",
    name: "Waiouru Airport",
    city: "Waiouru",
    country: "New Zealand",
    lat: -39.4463996887207,
    lng: 175.6580047607422,
  },
  {
    id: "N",
    name: "South Pole Station Airport",
    city: "Stephen's Island",
    country: "Antarctica",
    lat: -90.0,
    lng: 0.0,
  },
  {
    id: "TRG",
    name: "Tauranga Airport",
    city: "Tauranga",
    country: "New Zealand",
    lat: -37.67190170288086,
    lng: 176.1959991455078,
  },
  {
    id: "TIU",
    name: "Timaru Airport",
    city: "Timaru",
    country: "New Zealand",
    lat: -44.302799224853516,
    lng: 171.22500610351562,
  },
  {
    id: "TWZ",
    name: "Pukaki Airport",
    city: "Pukaki",
    country: "New Zealand",
    lat: -44.2350006104,
    lng: 170.117996216,
  },
  {
    id: "BHE",
    name: "Woodbourne Airport",
    city: "Woodbourne",
    country: "New Zealand",
    lat: -41.5182991027832,
    lng: 173.8699951171875,
  },
  {
    id: "N",
    name: "Williams Field",
    city: "Weydon",
    country: "Antarctica",
    lat: -77.86740112304688,
    lng: 167.0570068359375,
  },
  {
    id: "WKA",
    name: "Wanaka Airport",
    city: "Wanaka",
    country: "New Zealand",
    lat: -44.722198486328,
    lng: 169.24600219727,
  },
  {
    id: "N",
    name: "Wigram Airport",
    city: "Wigram",
    country: "New Zealand",
    lat: -43.5511016846,
    lng: 172.552993774,
  },
  {
    id: "WHK",
    name: "Whakatane Airport",
    city: "Whakatane",
    country: "New Zealand",
    lat: -37.92060089111328,
    lng: 176.91400146484375,
  },
  {
    id: "WLG",
    name: "Wellington International Airport",
    city: "Wellington",
    country: "New Zealand",
    lat: -41.3272018433,
    lng: 174.804992676,
  },
  {
    id: "WIR",
    name: "Wairoa Airport",
    city: "Wairoa",
    country: "New Zealand",
    lat: -39.006900787353516,
    lng: 177.40699768066406,
  },
  {
    id: "N",
    name: "RNZAF Base Auckland-Whenuapai",
    city: "Whenuapai",
    country: "New Zealand",
    lat: -36.78779983520508,
    lng: 174.6300048828125,
  },
  {
    id: "WRE",
    name: "Whangarei Airport",
    city: "Whangarei",
    country: "New Zealand",
    lat: -35.7682991027832,
    lng: 174.36500549316406,
  },
  {
    id: "WSZ",
    name: "Westport Airport",
    city: "Westport",
    country: "New Zealand",
    lat: -41.73809814453125,
    lng: 171.58099365234375,
  },
  {
    id: "WAG",
    name: "Wanganui Airport",
    city: "Wanganui",
    country: "New Zealand",
    lat: -39.96220016479492,
    lng: 175.02499389648438,
  },
  {
    id: "HEA",
    name: "Herat Airport",
    city: "Herat",
    country: "Afghanistan",
    lat: 34.209999084472656,
    lng: 62.22829818725586,
  },
  {
    id: "JAA",
    name: "Jalalabad Airport",
    city: "Jalalabad",
    country: "Afghanistan",
    lat: 34.39979934692383,
    lng: 70.49859619140625,
  },
  {
    id: "KBL",
    name: "Hamid Karzai International Airport",
    city: "Kabul",
    country: "Afghanistan",
    lat: 34.565899,
    lng: 69.212303,
  },
  {
    id: "KDH",
    name: "Kandahar Airport",
    city: "Kandahar",
    country: "Afghanistan",
    lat: 31.505800247192383,
    lng: 65.8478012084961,
  },
  {
    id: "MMZ",
    name: "Maimana Airport",
    city: "Maimama",
    country: "Afghanistan",
    lat: 35.93080139160156,
    lng: 64.76090240478516,
  },
  {
    id: "MZR",
    name: "Mazar I Sharif Airport",
    city: "Mazar-i-sharif",
    country: "Afghanistan",
    lat: 36.70690155029297,
    lng: 67.20970153808594,
  },
  {
    id: "OAH",
    name: "Shindand Airport",
    city: "Shindand",
    country: "Afghanistan",
    lat: 33.3913002014,
    lng: 62.2610015869,
  },
  {
    id: "N",
    name: "Sheberghan Airport",
    city: "Sheberghan",
    country: "Afghanistan",
    lat: 36.75080108642578,
    lng: 65.91320037841797,
  },
  {
    id: "UND",
    name: "Konduz Airport",
    city: "Kunduz",
    country: "Afghanistan",
    lat: 36.66510009765625,
    lng: 68.91079711914062,
  },
  {
    id: "BAH",
    name: "Bahrain International Airport",
    city: "Bahrain",
    country: "Bahrain",
    lat: 26.27079963684082,
    lng: 50.63359832763672,
  },
  {
    id: "N",
    name: "Sheik Isa Air Base",
    city: "Bahrain",
    country: "Bahrain",
    lat: 25.918399810791016,
    lng: 50.590599060058594,
  },
  {
    id: "AHB",
    name: "Abha Regional Airport",
    city: "Abha",
    country: "Saudi Arabia",
    lat: 18.240400314299997,
    lng: 42.65660095210001,
  },
  {
    id: "HOF",
    name: "Al Ahsa Airport",
    city: "Al-ahsa",
    country: "Saudi Arabia",
    lat: 25.28529930114746,
    lng: 49.485198974609375,
  },
  {
    id: "ABT",
    name: "Al Baha Airport",
    city: "El-baha",
    country: "Saudi Arabia",
    lat: 20.2961006165,
    lng: 41.6343002319,
  },
  {
    id: "BHH",
    name: "Bisha Airport",
    city: "Bisha",
    country: "Saudi Arabia",
    lat: 19.984399795532227,
    lng: 42.62089920043945,
  },
  {
    id: "N",
    name: "Abqaiq Airport",
    city: "Abqaiq",
    country: "Saudi Arabia",
    lat: 25.911300659179688,
    lng: 49.59120178222656,
  },
  {
    id: "DMM",
    name: "King Fahd International Airport",
    city: "Dammam",
    country: "Saudi Arabia",
    lat: 26.471200942993164,
    lng: 49.79790115356445,
  },
  {
    id: "DHA",
    name: "King Abdulaziz Air Base",
    city: "Dhahran",
    country: "Saudi Arabia",
    lat: 26.265399932900003,
    lng: 50.152000427199994,
  },
  {
    id: "GIZ",
    name: "Jizan Regional Airport",
    city: "Gizan",
    country: "Saudi Arabia",
    lat: 16.901100158691406,
    lng: 42.58580017089844,
  },
  {
    id: "ELQ",
    name: "Gassim Airport",
    city: "Gassim",
    country: "Saudi Arabia",
    lat: 26.302799224853516,
    lng: 43.77439880371094,
  },
  {
    id: "URY",
    name: "Gurayat Domestic Airport",
    city: "Guriat",
    country: "Saudi Arabia",
    lat: 31.412413,
    lng: 37.278898,
  },
  {
    id: "HAS",
    name: "Ha'il Airport",
    city: "Hail",
    country: "Saudi Arabia",
    lat: 27.437901,
    lng: 41.686298,
  },
  {
    id: "QJB",
    name: "Jubail Airport",
    city: "Jubail",
    country: "Saudi Arabia",
    lat: 27.038999557495117,
    lng: 49.40510177612305,
  },
  {
    id: "N",
    name: "King Faisal Naval Base",
    city: "Jeddah",
    country: "Saudi Arabia",
    lat: 21.348100662231445,
    lng: 39.17300033569336,
  },
  {
    id: "JED",
    name: "King Abdulaziz International Airport",
    city: "Jeddah",
    country: "Saudi Arabia",
    lat: 21.6796,
    lng: 39.156502,
  },
  {
    id: "KMC",
    name: "King Khaled Military City Airport",
    city: "King Khalid Mil.city",
    country: "Saudi Arabia",
    lat: 27.9009,
    lng: 45.528198,
  },
  {
    id: "MED",
    name: "Prince Mohammad Bin Abdulaziz Airport",
    city: "Madinah",
    country: "Saudi Arabia",
    lat: 24.5534,
    lng: 39.705101,
  },
  {
    id: "EAM",
    name: "Nejran Airport",
    city: "Nejran",
    country: "Saudi Arabia",
    lat: 17.611400604248047,
    lng: 44.4192008972168,
  },
  {
    id: "AQI",
    name: "Al Qaisumah/Hafr Al Batin Airport",
    city: "Hafr Al-batin",
    country: "Saudi Arabia",
    lat: 28.335199,
    lng: 46.125099,
  },
  {
    id: "N",
    name: "Pump Station 3 Airport",
    city: "Petroline 3",
    country: "Saudi Arabia",
    lat: 25.17449951171875,
    lng: 47.488399505615234,
  },
  {
    id: "N",
    name: "Pump Station 6 Airport",
    city: "Petroline 6",
    country: "Saudi Arabia",
    lat: 24.71030044555664,
    lng: 44.964500427246094,
  },
  {
    id: "N",
    name: "Pump Station 10 Airport",
    city: "Petroline 10",
    country: "Saudi Arabia",
    lat: 24.1072998046875,
    lng: 41.0359992980957,
  },
  {
    id: "N",
    name: "Rabigh Airport",
    city: "Rabigh",
    country: "Saudi Arabia",
    lat: 22.702600479125977,
    lng: 39.069801330566406,
  },
  {
    id: "RAH",
    name: "Rafha Domestic Airport",
    city: "Rafha",
    country: "Saudi Arabia",
    lat: 29.626399993896484,
    lng: 43.4906005859375,
  },
  {
    id: "RUH",
    name: "King Khaled International Airport",
    city: "Riyadh",
    country: "Saudi Arabia",
    lat: 24.957599639892578,
    lng: 46.69879913330078,
  },
  {
    id: "N",
    name: "Ras Mishab Airport",
    city: "Rash Mishab",
    country: "Saudi Arabia",
    lat: 28.079599380493164,
    lng: 48.611000061035156,
  },
  {
    id: "RAE",
    name: "Arar Domestic Airport",
    city: "Arar",
    country: "Saudi Arabia",
    lat: 30.906600952148438,
    lng: 41.13819885253906,
  },
  {
    id: "N",
    name: "Ras Tanura Airport",
    city: "Ras Tanura",
    country: "Saudi Arabia",
    lat: 26.723100662231445,
    lng: 50.030799865722656,
  },
  {
    id: "SHW",
    name: "Sharurah Airport",
    city: "Sharurah",
    country: "Saudi Arabia",
    lat: 17.466899871826172,
    lng: 47.12139892578125,
  },
  {
    id: "SLF",
    name: "Sulayel Airport",
    city: "Sulayel",
    country: "Saudi Arabia",
    lat: 20.46470069885254,
    lng: 45.619598388671875,
  },
  {
    id: "TUU",
    name: "Tabuk Airport",
    city: "Tabuk",
    country: "Saudi Arabia",
    lat: 28.3654,
    lng: 36.6189,
  },
  {
    id: "TIF",
    name: "Ta’if Regional Airport",
    city: "Taif",
    country: "Saudi Arabia",
    lat: 21.483001,
    lng: 40.543442,
  },
  {
    id: "N",
    name: "Thumamah Airport",
    city: "Thumamah",
    country: "Saudi Arabia",
    lat: 25.21299934387207,
    lng: 46.64099884033203,
  },
  {
    id: "N",
    name: "Ras Tanajib Airport",
    city: "Ras Tanajib",
    country: "Saudi Arabia",
    lat: 27.867799758911133,
    lng: 48.769100189208984,
  },
  {
    id: "TUI",
    name: "Turaif Domestic Airport",
    city: "Turaif",
    country: "Saudi Arabia",
    lat: 31.692188,
    lng: 38.731544,
  },
  {
    id: "EJH",
    name: "Al Wajh Domestic Airport",
    city: "Wejh",
    country: "Saudi Arabia",
    lat: 26.19860076904297,
    lng: 36.47639846801758,
  },
  {
    id: "YNB",
    name: "Prince Abdulmohsin Bin Abdulaziz Airport",
    city: "Yenbo",
    country: "Saudi Arabia",
    lat: 24.144199,
    lng: 38.0634,
  },
  {
    id: "ABD",
    name: "Abadan Airport",
    city: "Abadan",
    country: "Iran",
    lat: 30.371099472,
    lng: 48.2282981873,
  },
  {
    id: "DEF",
    name: "Dezful Airport",
    city: "Dezful",
    country: "Iran",
    lat: 32.434399,
    lng: 48.397598,
  },
  {
    id: "AKW",
    name: "Aghajari Airport",
    city: "Aghajari",
    country: "Iran",
    lat: 30.7444,
    lng: 49.6772,
  },
  {
    id: "GCH",
    name: "Gachsaran Airport",
    city: "Gachsaran",
    country: "Iran",
    lat: 30.337600708,
    lng: 50.827999115,
  },
  {
    id: "N",
    name: "Shahid Asyaee Airport",
    city: "Masjed Soleiman",
    country: "Iran",
    lat: 32.00239944458008,
    lng: 49.27040100097656,
  },
  {
    id: "OMI",
    name: "Omidiyeh Airport",
    city: "Omidyeh",
    country: "Iran",
    lat: 30.8351993560791,
    lng: 49.5349006652832,
  },
  {
    id: "MRX",
    name: "Mahshahr Airport",
    city: "Bandar Mahshahr",
    country: "Iran",
    lat: 30.55620002746582,
    lng: 49.15190124511719,
  },
  {
    id: "AWZ",
    name: "Ahwaz Airport",
    city: "Ahwaz",
    country: "Iran",
    lat: 31.337400436399996,
    lng: 48.7620010376,
  },
  {
    id: "AEU",
    name: "Abu Musa Island Airport",
    city: "Abumusa I.",
    country: "Iran",
    lat: 25.8757,
    lng: 55.033001,
  },
  {
    id: "BUZ",
    name: "Bushehr Airport",
    city: "Bushehr",
    country: "Iran",
    lat: 28.9447994232,
    lng: 50.8345985413,
  },
  {
    id: "N",
    name: "Bastak Airport",
    city: "Bastak",
    country: "Iran",
    lat: 27.21269989013672,
    lng: 54.318599700927734,
  },
  {
    id: "N",
    name: "Asaloyeh Airport",
    city: "Golbandi",
    country: "Iran",
    lat: 27.4814,
    lng: 52.615501,
  },
  {
    id: "KIH",
    name: "Kish International Airport",
    city: "Kish Island",
    country: "Iran",
    lat: 26.5261993408,
    lng: 53.980201721200004,
  },
  {
    id: "BDH",
    name: "Bandar Lengeh Airport",
    city: "Bandar Lengeh",
    country: "Iran",
    lat: 26.531999588,
    lng: 54.824798584,
  },
  {
    id: "KHK",
    name: "Khark Island Airport",
    city: "Khark Island",
    country: "Iran",
    lat: 29.260299682617188,
    lng: 50.32389831542969,
  },
  {
    id: "SXI",
    name: "Sirri Island Airport",
    city: "Siri Island",
    country: "Iran",
    lat: 25.908899307250977,
    lng: 54.539398193359375,
  },
  {
    id: "LVP",
    name: "Lavan Island Airport",
    city: "Lavan Island",
    country: "Iran",
    lat: 26.810300827026367,
    lng: 53.356300354003906,
  },
  {
    id: "KSH",
    name: "Shahid Ashrafi Esfahani Airport",
    city: "Bakhtaran",
    country: "Iran",
    lat: 34.3459014893,
    lng: 47.1581001282,
  },
  {
    id: "SDG",
    name: "Sanandaj Airport",
    city: "Sanandaj",
    country: "Iran",
    lat: 35.24589920043945,
    lng: 47.00920104980469,
  },
  {
    id: "IFH",
    name: "Hesa Airport",
    city: "Daran",
    country: "Iran",
    lat: 32.92890167236328,
    lng: 51.561100006103516,
  },
  {
    id: "N",
    name: "Shahid Vatan Pour Air Base",
    city: "Esfahan",
    country: "Iran",
    lat: 32.56700134277344,
    lng: 51.69160079956055,
  },
  {
    id: "KKS",
    name: "Kashan Airport",
    city: "Kashan",
    country: "Iran",
    lat: 33.895302,
    lng: 51.577,
  },
  {
    id: "IFN",
    name: "Esfahan Shahid Beheshti International Airport",
    city: "Esfahan",
    country: "Iran",
    lat: 32.75080108642578,
    lng: 51.86130142211914,
  },
  {
    id: "N",
    name: "Badr Air Base",
    city: "Sepah",
    country: "Iran",
    lat: 32.62110137939453,
    lng: 51.696998596191406,
  },
  {
    id: "RAS",
    name: "Sardar-e-Jangal Airport",
    city: "Rasht",
    country: "Iran",
    lat: 37.323333,
    lng: 49.617778,
  },
  {
    id: "AJK",
    name: "Arak Airport",
    city: "Arak",
    country: "Iran",
    lat: 34.138099670410156,
    lng: 49.8473014831543,
  },
  {
    id: "N",
    name: "Ghazvin Azadi Airport",
    city: "Abe-ali",
    country: "Iran",
    lat: 35.95209884643555,
    lng: 50.450801849365234,
  },
  {
    id: "N",
    name: "Kushke Nosrat Airport",
    city: "Kushke Nosrat",
    country: "Iran",
    lat: 34.98400115966797,
    lng: 50.80619812011719,
  },
  {
    id: "N",
    name: "Doshan Tappeh Air Base",
    city: "Teheran",
    country: "Iran",
    lat: 35.702999114990234,
    lng: 51.475101470947266,
  },
  {
    id: "N",
    name: "Ghale Morghi Airport",
    city: "Teheran",
    country: "Iran",
    lat: 35.644798278808594,
    lng: 51.380699157714844,
  },
  {
    id: "THR",
    name: "Mehrabad International Airport",
    city: "Teheran",
    country: "Iran",
    lat: 35.68920135498047,
    lng: 51.31340026855469,
  },
  {
    id: "GZW",
    name: "Qazvin Airport",
    city: "Ghazvin",
    country: "Iran",
    lat: 36.240101,
    lng: 50.0471,
  },
  {
    id: "N",
    name: "Naja Airport",
    city: "Khoram Dareh",
    country: "Iran",
    lat: 35.77629852294922,
    lng: 50.88100051879883,
  },
  {
    id: "BND",
    name: "Bandar Abbas International Airport",
    city: "Bandar Abbas",
    country: "Iran",
    lat: 27.218299865722656,
    lng: 56.37779998779297,
  },
  {
    id: "JYR",
    name: "Jiroft Airport",
    city: "Jiroft",
    country: "Iran",
    lat: 28.726900100699996,
    lng: 57.67029953,
  },
  {
    id: "KER",
    name: "Kerman Airport",
    city: "Kerman",
    country: "Iran",
    lat: 30.274400711099997,
    lng: 56.9510993958,
  },
  {
    id: "HDR",
    name: "Havadarya Airport",
    city: "Bandar Abbas",
    country: "Iran",
    lat: 27.158300399780273,
    lng: 56.17250061035156,
  },
  {
    id: "N",
    name: "Dayrestan Airport",
    city: "Gheshm I.",
    country: "Iran",
    lat: 26.754600524902344,
    lng: 55.902400970458984,
  },
  {
    id: "SYJ",
    name: "Sirjan Airport",
    city: "Sirjan",
    country: "Iran",
    lat: 29.550899505615234,
    lng: 55.672698974609375,
  },
  {
    id: "XBJ",
    name: "Birjand Airport",
    city: "Birjand",
    country: "Iran",
    lat: 32.898101806640625,
    lng: 59.2661018371582,
  },
  {
    id: "CKT",
    name: "Sarakhs Airport",
    city: "Sarakhs",
    country: "Iran",
    lat: 36.50120162963867,
    lng: 61.06489944458008,
  },
  {
    id: "RUD",
    name: "Shahroud Airport",
    city: "Emam Shahr",
    country: "Iran",
    lat: 36.4253005981,
    lng: 55.104198455799995,
  },
  {
    id: "TCX",
    name: "Tabas Airport",
    city: "Tabas",
    country: "Iran",
    lat: 33.6678009033,
    lng: 56.8927001953,
  },
  {
    id: "KLM",
    name: "Kalaleh Airport",
    city: "Kalaleh",
    country: "Iran",
    lat: 37.3833007812,
    lng: 55.4519996643,
  },
  {
    id: "RZR",
    name: "Ramsar Airport",
    city: "Ramsar",
    country: "Iran",
    lat: 36.9099006652832,
    lng: 50.67959976196289,
  },
  {
    id: "FAZ",
    name: "Fasa Airport",
    city: "Fasa",
    country: "Iran",
    lat: 28.891799926757812,
    lng: 53.72330093383789,
  },
  {
    id: "JAR",
    name: "Jahrom Airport",
    city: "Jahrom",
    country: "Iran",
    lat: 28.586700439499996,
    lng: 53.5791015625,
  },
  {
    id: "LFM",
    name: "Lamerd Airport",
    city: "Lamerd",
    country: "Iran",
    lat: 27.3726997375,
    lng: 53.18880081179999,
  },
  {
    id: "SYZ",
    name: "Shiraz Shahid Dastghaib International Airport",
    city: "Shiraz",
    country: "Iran",
    lat: 29.539199829101562,
    lng: 52.58980178833008,
  },
  {
    id: "KHY",
    name: "Khoy Airport",
    city: "Khoy",
    country: "Iran",
    lat: 38.4275016784668,
    lng: 44.97359848022461,
  },
  {
    id: "TBZ",
    name: "Tabriz International Airport",
    city: "Tabriz",
    country: "Iran",
    lat: 38.1338996887207,
    lng: 46.23500061035156,
  },
  {
    id: "JWN",
    name: "Zanjan Airport",
    city: "Zanjan",
    country: "Iran",
    lat: 36.7737007141,
    lng: 48.3594017029,
  },
  {
    id: "AZD",
    name: "Shahid Sadooghi Airport",
    city: "Yazd",
    country: "Iran",
    lat: 31.9048995972,
    lng: 54.2765007019,
  },
  {
    id: "ACZ",
    name: "Zabol Airport",
    city: "Zabol",
    country: "Iran",
    lat: 31.09830093383789,
    lng: 61.54389953613281,
  },
  {
    id: "ZBR",
    name: "Konarak Airport",
    city: "Chah Bahar",
    country: "Iran",
    lat: 25.443300247199996,
    lng: 60.3820991516,
  },
  {
    id: "ZAH",
    name: "Zahedan International Airport",
    city: "Zahedan",
    country: "Iran",
    lat: 29.47570037841797,
    lng: 60.90620040893555,
  },
  {
    id: "IHR",
    name: "Iran Shahr Airport",
    city: "Iran Shahr",
    country: "Iran",
    lat: 27.2360992432,
    lng: 60.7200012207,
  },
  {
    id: "N",
    name: "Saravan Airport",
    city: "Saravan",
    country: "Iran",
    lat: 27.419300079345703,
    lng: 62.315799713134766,
  },
  {
    id: "AMM",
    name: "Queen Alia International Airport",
    city: "Amman",
    country: "Jordan",
    lat: 31.7226009369,
    lng: 35.9931983948,
  },
  {
    id: "ADJ",
    name: "Amman-Marka International Airport",
    city: "Amman",
    country: "Jordan",
    lat: 31.972700119018555,
    lng: 35.991600036621094,
  },
  {
    id: "AQJ",
    name: "Aqaba King Hussein International Airport",
    city: "Aqaba",
    country: "Jordan",
    lat: 29.611600875854492,
    lng: 35.01810073852539,
  },
  {
    id: "N",
    name: "Prince Hassan Air Base",
    city: "Hotel Four",
    country: "Jordan",
    lat: 32.160702,
    lng: 37.149399,
  },
  {
    id: "N",
    name: "Jerusalem Airport",
    city: "Jerusalem",
    country: "West Bank",
    lat: 31.864700317383,
    lng: 35.219200134277,
  },
  {
    id: "OMF",
    name: "King Hussein Air College",
    city: "Mafraq",
    country: "Jordan",
    lat: 32.3564,
    lng: 36.259201,
  },
  {
    id: "KWI",
    name: "Kuwait International Airport",
    city: "Kuwait",
    country: "Kuwait",
    lat: 29.226600646972656,
    lng: 47.96889877319336,
  },
  {
    id: "BEY",
    name: "Beirut Rafic Hariri International Airport",
    city: "Beirut",
    country: "Lebanon",
    lat: 33.820899963378906,
    lng: 35.488399505615234,
  },
  {
    id: "KYE",
    name: "Rene Mouawad Air Base",
    city: "Kleiat",
    country: "Lebanon",
    lat: 34.589298248291016,
    lng: 36.01129913330078,
  },
  {
    id: "AUH",
    name: "Abu Dhabi International Airport",
    city: "Abu Dhabi",
    country: "United Arab Emirates",
    lat: 24.433000564575195,
    lng: 54.651100158691406,
  },
  {
    id: "AZI",
    name: "Bateen Airport",
    city: "Abu Dhabi",
    country: "United Arab Emirates",
    lat: 24.428300857543945,
    lng: 54.458099365234375,
  },
  {
    id: "N",
    name: "Al Hamra Aux Airport",
    city: "Al Hamra",
    country: "United Arab Emirates",
    lat: 24.073999404907227,
    lng: 52.463600158691406,
  },
  {
    id: "N",
    name: "Jebel Dhana Airport",
    city: "Jebel Dhana",
    country: "United Arab Emirates",
    lat: 24.187400817871094,
    lng: 52.61399841308594,
  },
  {
    id: "DHF",
    name: "Al Dhafra Air Base",
    city: "Abu Dhabi",
    country: "United Arab Emirates",
    lat: 24.248199462900004,
    lng: 54.547698974599996,
  },
  {
    id: "N",
    name: "Arzanah Airport",
    city: "Arzana",
    country: "United Arab Emirates",
    lat: 24.780500411987305,
    lng: 52.559898376464844,
  },
  {
    id: "N",
    name: "Das Island Airport",
    city: "Das Island",
    country: "United Arab Emirates",
    lat: 25.14620018005371,
    lng: 52.87369918823242,
  },
  {
    id: "N",
    name: "Zirku Airport",
    city: "Zirku",
    country: "United Arab Emirates",
    lat: 24.862491607666016,
    lng: 53.07714080810547,
  },
  {
    id: "DXB",
    name: "Dubai International Airport",
    city: "Dubai",
    country: "United Arab Emirates",
    lat: 25.2527999878,
    lng: 55.3643989563,
  },
  {
    id: "FJR",
    name: "Fujairah International Airport",
    city: "Fujeirah",
    country: "United Arab Emirates",
    lat: 25.112199783325195,
    lng: 56.32400131225586,
  },
  {
    id: "RKT",
    name: "Ras Al Khaimah International Airport",
    city: "Ras Al Khaimah",
    country: "United Arab Emirates",
    lat: 25.613500595092773,
    lng: 55.93880081176758,
  },
  {
    id: "SHJ",
    name: "Sharjah International Airport",
    city: "Sharjah",
    country: "United Arab Emirates",
    lat: 25.32859992980957,
    lng: 55.5172004699707,
  },
  {
    id: "KHS",
    name: "Khasab Air Base",
    city: "Khasab",
    country: "Oman",
    lat: 26.17099952697754,
    lng: 56.2406005859375,
  },
  {
    id: "MSH",
    name: "Masirah Air Base",
    city: "Masirah",
    country: "Oman",
    lat: 20.675399780273438,
    lng: 58.890499114990234,
  },
  {
    id: "MCT",
    name: "Muscat International Airport",
    city: "Muscat",
    country: "Oman",
    lat: 23.593299865722656,
    lng: 58.284400939941406,
  },
  {
    id: "SLL",
    name: "Salalah Airport",
    city: "Salalah",
    country: "Oman",
    lat: 17.038700103759766,
    lng: 54.09130096435547,
  },
  {
    id: "TTH",
    name: "Thumrait Air Base",
    city: "Thumrait",
    country: "Oman",
    lat: 17.666000366210938,
    lng: 54.024600982666016,
  },
  {
    id: "BHW",
    name: "Bhagatanwala Airport",
    city: "Bhagtanwala",
    country: "Pakistan",
    lat: 32.056098938,
    lng: 72.94840240479999,
  },
  {
    id: "LYP",
    name: "Faisalabad International Airport",
    city: "Faisalabad",
    country: "Pakistan",
    lat: 31.364999771118164,
    lng: 72.99479675292969,
  },
  {
    id: "GWD",
    name: "Gwadar International Airport",
    city: "Gwadar",
    country: "Pakistan",
    lat: 25.233299255371094,
    lng: 62.329498291015625,
  },
  {
    id: "GIL",
    name: "Gilgit Airport",
    city: "Gilgit",
    country: "Pakistan",
    lat: 35.918800354003906,
    lng: 74.33360290527344,
  },
  {
    id: "JAG",
    name: "Shahbaz Air Base",
    city: "Jacobsbad",
    country: "Pakistan",
    lat: 28.28420066833496,
    lng: 68.44969940185547,
  },
  {
    id: "KHI",
    name: "Jinnah International Airport",
    city: "Karachi",
    country: "Pakistan",
    lat: 24.9065,
    lng: 67.160797,
  },
  {
    id: "LHE",
    name: "Alama Iqbal International Airport",
    city: "Lahore",
    country: "Pakistan",
    lat: 31.5216007232666,
    lng: 74.40360260009766,
  },
  {
    id: "N",
    name: "Walton Airport",
    city: "Lahore",
    country: "Pakistan",
    lat: 31.494800567626953,
    lng: 74.34619903564453,
  },
  {
    id: "XJM",
    name: "Mangla Airport",
    city: "Mangla",
    country: "Pakistan",
    lat: 33.05009841918945,
    lng: 73.63839721679688,
  },
  {
    id: "MFG",
    name: "Muzaffarabad Airport",
    city: "Muzaffarabad",
    country: "Pakistan",
    lat: 34.3390007019043,
    lng: 73.50859832763672,
  },
  {
    id: "MWD",
    name: "Mianwali Air Base",
    city: "Mianwali",
    country: "Pakistan",
    lat: 32.5630989074707,
    lng: 71.5707015991211,
  },
  {
    id: "MJD",
    name: "Moenjodaro Airport",
    city: "Moenjodaro",
    country: "Pakistan",
    lat: 27.3351993560791,
    lng: 68.14309692382812,
  },
  {
    id: "N",
    name: "Masroor Air Base",
    city: "Karachi",
    country: "Pakistan",
    lat: 24.893600463867188,
    lng: 66.93879699707031,
  },
  {
    id: "MUX",
    name: "Multan International Airport",
    city: "Multan",
    country: "Pakistan",
    lat: 30.20319938659668,
    lng: 71.41909790039062,
  },
  {
    id: "WNS",
    name: "Shaheed Benazirabad Airport",
    city: "Nawabshah",
    country: "Pakistan",
    lat: 26.2194,
    lng: 68.390099,
  },
  {
    id: "N",
    name: "Okara Cantonment Airstrip",
    city: "Okara",
    country: "Pakistan",
    lat: 30.740999221800003,
    lng: 73.3576965332,
  },
  {
    id: "PJG",
    name: "Panjgur Airport",
    city: "Panjgur",
    country: "Pakistan",
    lat: 26.954500198364258,
    lng: 64.13249969482422,
  },
  {
    id: "PSI",
    name: "Pasni Airport",
    city: "Pasni",
    country: "Pakistan",
    lat: 25.29050064086914,
    lng: 63.34510040283203,
  },
  {
    id: "PEW",
    name: "Peshawar International Airport",
    city: "Peshawar",
    country: "Pakistan",
    lat: 33.993900299072266,
    lng: 71.51460266113281,
  },
  {
    id: "N",
    name: "Qasim Airport",
    city: "Qasim",
    country: "Pakistan",
    lat: 33.56019973754883,
    lng: 73.033203125,
  },
  {
    id: "UET",
    name: "Quetta International Airport",
    city: "Quetta",
    country: "Pakistan",
    lat: 30.251399993896484,
    lng: 66.93779754638672,
  },
  {
    id: "RYK",
    name: "Shaikh Zaid Airport",
    city: "Rahim Yar Khan",
    country: "Pakistan",
    lat: 28.383899688720703,
    lng: 70.27960205078125,
  },
  {
    id: "N",
    name: "Benazir Bhutto International Airport",
    city: "Islamabad",
    country: "Pakistan",
    lat: 33.616699,
    lng: 73.099197,
  },
  {
    id: "N",
    name: "Risalpur Air Base",
    city: "Risalpur",
    country: "Pakistan",
    lat: 34.08110046386719,
    lng: 71.97260284423828,
  },
  {
    id: "RAZ",
    name: "Rawalakot Airport",
    city: "Rawala Kot",
    country: "Pakistan",
    lat: 33.849700927734375,
    lng: 73.79810333251953,
  },
  {
    id: "SKZ",
    name: "Sukkur Airport",
    city: "Sukkur",
    country: "Pakistan",
    lat: 27.722000122070312,
    lng: 68.79170227050781,
  },
  {
    id: "SDT",
    name: "Saidu Sharif Airport",
    city: "Saidu Sharif",
    country: "Pakistan",
    lat: 34.8135986328125,
    lng: 72.35279846191406,
  },
  {
    id: "SUL",
    name: "Sui Airport",
    city: "Sui",
    country: "Pakistan",
    lat: 28.645099639892578,
    lng: 69.1769027709961,
  },
  {
    id: "BDN",
    name: "Talhar Airport",
    city: "Talhar",
    country: "Pakistan",
    lat: 24.84149932861328,
    lng: 68.8384017944336,
  },
  {
    id: "WAF",
    name: "Wana Airport",
    city: "Wana",
    country: "Pakistan",
    lat: 32.3046989440918,
    lng: 69.57039642333984,
  },
  {
    id: "PZH",
    name: "Zhob Airport",
    city: "Zhob",
    country: "Pakistan",
    lat: 31.358400344848633,
    lng: 69.4636001586914,
  },
  {
    id: "BSR",
    name: "Basrah International Airport",
    city: "Basrah",
    country: "Iraq",
    lat: 30.549100875854492,
    lng: 47.66210174560547,
  },
  {
    id: "ALP",
    name: "Aleppo International Airport",
    city: "Aleppo",
    country: "Syria",
    lat: 36.18069839477539,
    lng: 37.22439956665039,
  },
  {
    id: "DAM",
    name: "Damascus International Airport",
    city: "Damascus",
    country: "Syria",
    lat: 33.4114990234375,
    lng: 36.51559829711914,
  },
  {
    id: "DEZ",
    name: "Deir ez-Zor Air Base",
    city: "Deire Zor",
    country: "Syria",
    lat: 35.2854,
    lng: 40.175999,
  },
  {
    id: "LTK",
    name: "Bassel Al-Assad International Airport",
    city: "Latakia",
    country: "Syria",
    lat: 35.401100158691406,
    lng: 35.948699951171875,
  },
  {
    id: "PMS",
    name: "Palmyra Airport",
    city: "Palmyra",
    country: "Syria",
    lat: 34.5574,
    lng: 38.316898,
  },
  {
    id: "DIA",
    name: "Doha International Airport",
    city: "Doha",
    country: "Qatar",
    lat: 25.261101,
    lng: 51.565102,
  },
  {
    id: "CIS",
    name: "Canton Island Airport",
    city: "Canton Island",
    country: "Kiribati",
    lat: -2.7681200504300003,
    lng: -171.710006714,
  },
  {
    id: "ROP",
    name: "Rota International Airport",
    city: "Rota",
    country: "Northern Mariana Islands",
    lat: 14.174300193786621,
    lng: 145.2429962158203,
  },
  {
    id: "SPN",
    name: "Saipan International Airport",
    city: "Saipan",
    country: "Northern Mariana Islands",
    lat: 15.119,
    lng: 145.729004,
  },
  {
    id: "UAM",
    name: "Andersen Air Force Base",
    city: "Andersen",
    country: "Guam",
    lat: 13.584,
    lng: 144.929998,
  },
  {
    id: "GUM",
    name: "Antonio B. Won Pat International Airport",
    city: "Agana",
    country: "Guam",
    lat: 13.4834003448,
    lng: 144.796005249,
  },
  {
    id: "TIQ",
    name: "Tinian International Airport",
    city: "West Tinian",
    country: "Northern Mariana Islands",
    lat: 14.999199867248535,
    lng: 145.61900329589844,
  },
  {
    id: "MAJ",
    name: "Marshall Islands International Airport",
    city: "Majuro",
    country: "Marshall Islands",
    lat: 7.064760208129883,
    lng: 171.27200317382812,
  },
  {
    id: "N",
    name: "Dyess Army Air Field",
    city: "Kwajalein",
    country: "Marshall Islands",
    lat: 9.396889686580002,
    lng: 167.470993042,
  },
  {
    id: "KWA",
    name: "Bucholz Army Air Field",
    city: "Kwajalein",
    country: "Marshall Islands",
    lat: 8.720120429992676,
    lng: 167.73199462890625,
  },
  {
    id: "CXI",
    name: "Cassidy International Airport",
    city: "Kiritimati",
    country: "Kiribati",
    lat: 1.9861600399017334,
    lng: -157.35000610351562,
  },
  {
    id: "MDY",
    name: "Henderson Field",
    city: "Midway",
    country: "Midway Islands",
    lat: 28.20170021057129,
    lng: -177.38099670410156,
  },
  {
    id: "TKK",
    name: "Chuuk International Airport",
    city: "Chuuk",
    country: "Micronesia",
    lat: 7.461870193481445,
    lng: 151.84300231933594,
  },
  {
    id: "PNI",
    name: "Pohnpei International Airport",
    city: "Pohnpei",
    country: "Micronesia",
    lat: 6.985099792480469,
    lng: 158.20899963378906,
  },
  {
    id: "ROR",
    name: "Babelthuap Airport",
    city: "Babelthuap",
    country: "Palau",
    lat: 7.36731,
    lng: 134.544236,
  },
  {
    id: "KSA",
    name: "Kosrae International Airport",
    city: "Kosrae",
    country: "Micronesia",
    lat: 5.35698,
    lng: 162.957993,
  },
  {
    id: "YAP",
    name: "Yap International Airport",
    city: "Yap",
    country: "Micronesia",
    lat: 9.49891,
    lng: 138.082993,
  },
  {
    id: "KNH",
    name: "Kinmen Airport",
    city: "Kinmen",
    country: "Taiwan",
    lat: 24.4279,
    lng: 118.359001,
  },
  {
    id: "N",
    name: "Pingtung South Airport",
    city: "Pingtung",
    country: "Taiwan",
    lat: 22.672399520874023,
    lng: 120.46199798583984,
  },
  {
    id: "N",
    name: "Longtan Air Base",
    city: "Longtang",
    country: "Taiwan",
    lat: 24.855100631713867,
    lng: 121.23799896240234,
  },
  {
    id: "TTT",
    name: "Taitung Airport",
    city: "Fengnin",
    country: "Taiwan",
    lat: 22.7549991607666,
    lng: 121.10199737548828,
  },
  {
    id: "GNI",
    name: "Lyudao Airport",
    city: "Green Island",
    country: "Taiwan",
    lat: 22.673900604248047,
    lng: 121.46600341796875,
  },
  {
    id: "KHH",
    name: "Kaohsiung International Airport",
    city: "Kaohsiung",
    country: "Taiwan",
    lat: 22.57710075378418,
    lng: 120.3499984741211,
  },
  {
    id: "CYI",
    name: "Chiayi Airport",
    city: "Chiayi",
    country: "Taiwan",
    lat: 23.46179962158203,
    lng: 120.39299774169922,
  },
  {
    id: "KYD",
    name: "Lanyu Airport",
    city: "Lanyu",
    country: "Taiwan",
    lat: 22.027000427246094,
    lng: 121.53500366210938,
  },
  {
    id: "RMQ",
    name: "Taichung Ching Chuang Kang Airport",
    city: "Taichung",
    country: "Taiwan",
    lat: 24.264699935913086,
    lng: 120.62100219726562,
  },
  {
    id: "TNN",
    name: "Tainan Airport",
    city: "Tainan",
    country: "Taiwan",
    lat: 22.95039939880371,
    lng: 120.20600128173828,
  },
  {
    id: "HSZ",
    name: "Hsinchu Air Base",
    city: "Hsinchu",
    country: "Taiwan",
    lat: 24.8180007935,
    lng: 120.939002991,
  },
  {
    id: "MZG",
    name: "Makung Airport",
    city: "Makung",
    country: "Taiwan",
    lat: 23.568700790405273,
    lng: 119.62799835205078,
  },
  {
    id: "N",
    name: "Chihhang Air Base",
    city: "Taitung",
    country: "Taiwan",
    lat: 22.793100357055664,
    lng: 121.18199920654297,
  },
  {
    id: "PIF",
    name: "Pingtung North Airport",
    city: "Pingtung",
    country: "Taiwan",
    lat: 22.700199127197266,
    lng: 120.48200225830078,
  },
  {
    id: "TSA",
    name: "Taipei Songshan Airport",
    city: "Taipei",
    country: "Taiwan",
    lat: 25.069400787353516,
    lng: 121.552001953125,
  },
  {
    id: "TPE",
    name: "Taiwan Taoyuan International Airport",
    city: "Taipei",
    country: "Taiwan",
    lat: 25.0777,
    lng: 121.233002,
  },
  {
    id: "WOT",
    name: "Wang-an Airport",
    city: "Wang An",
    country: "Taiwan",
    lat: 23.367372512817383,
    lng: 119.50277709960938,
  },
  {
    id: "HUN",
    name: "Hualien Airport",
    city: "Hualien",
    country: "Taiwan",
    lat: 24.023099899291992,
    lng: 121.61799621582031,
  },
  {
    id: "NRT",
    name: "Narita International Airport",
    city: "Tokyo",
    country: "Japan",
    lat: 35.7647018433,
    lng: 140.386001587,
  },
  {
    id: "MMJ",
    name: "Matsumoto Airport",
    city: "Matsumoto",
    country: "Japan",
    lat: 36.16680145263672,
    lng: 137.92300415039062,
  },
  {
    id: "IBR",
    name: "Hyakuri Airport",
    city: "Ibaraki",
    country: "Japan",
    lat: 36.181098938,
    lng: 140.414993286,
  },
  {
    id: "MUS",
    name: "Minami Torishima Airport",
    city: "Minami Tori Shima",
    country: "Japan",
    lat: 24.2896995544,
    lng: 153.979003906,
  },
  {
    id: "IWO",
    name: "Iwo Jima Airport",
    city: "Iwojima",
    country: "Japan",
    lat: 24.784000396728516,
    lng: 141.322998046875,
  },
  {
    id: "SHM",
    name: "Nanki Shirahama Airport",
    city: "Nanki-shirahama",
    country: "Japan",
    lat: 33.6622009277,
    lng: 135.363998413,
  },
  {
    id: "N",
    name: "Kohnan Airport",
    city: "Kohnan",
    country: "Japan",
    lat: 34.59080123901367,
    lng: 133.93299865722656,
  },
  {
    id: "OBO",
    name: "Tokachi-Obihiro Airport",
    city: "Obihiro",
    country: "Japan",
    lat: 42.7332992554,
    lng: 143.216995239,
  },
  {
    id: "CTS",
    name: "New Chitose Airport",
    city: "Sapporo",
    country: "Japan",
    lat: 42.77519989013672,
    lng: 141.69200134277344,
  },
  {
    id: "HKD",
    name: "Hakodate Airport",
    city: "Hakodate",
    country: "Japan",
    lat: 41.7700004578,
    lng: 140.822006226,
  },
  {
    id: "N",
    name: "Chitose Air Base",
    city: "Chitose",
    country: "Japan",
    lat: 42.79449844359999,
    lng: 141.666000366,
  },
  {
    id: "MMB",
    name: "Memanbetsu Airport",
    city: "Memanbetsu",
    country: "Japan",
    lat: 43.8805999756,
    lng: 144.164001465,
  },
  {
    id: "SHB",
    name: "Nakashibetsu Airport",
    city: "Nakashibetsu",
    country: "Japan",
    lat: 43.5774993896,
    lng: 144.960006714,
  },
  {
    id: "N",
    name: "Tokachi Airport",
    city: "Tokachi",
    country: "Japan",
    lat: 42.890499114990234,
    lng: 143.1580047607422,
  },
  {
    id: "WKJ",
    name: "Wakkanai Airport",
    city: "Wakkanai",
    country: "Japan",
    lat: 45.4042015076,
    lng: 141.800994873,
  },
  {
    id: "IKI",
    name: "Iki Airport",
    city: "Iki",
    country: "Japan",
    lat: 33.7490005493,
    lng: 129.785003662,
  },
  {
    id: "UBJ",
    name: "Yamaguchi Ube Airport",
    city: "Yamaguchi",
    country: "Japan",
    lat: 33.930000305200004,
    lng: 131.279006958,
  },
  {
    id: "TSJ",
    name: "Tsushima Airport",
    city: "Tsushima",
    country: "Japan",
    lat: 34.2849006653,
    lng: 129.330993652,
  },
  {
    id: "MBE",
    name: "Monbetsu Airport",
    city: "Monbetsu",
    country: "Japan",
    lat: 44.303901672399995,
    lng: 143.404006958,
  },
  {
    id: "AKJ",
    name: "Asahikawa Airport",
    city: "Asahikawa",
    country: "Japan",
    lat: 43.670799255371094,
    lng: 142.44700622558594,
  },
  {
    id: "OIR",
    name: "Okushiri Airport",
    city: "Okushiri",
    country: "Japan",
    lat: 42.0717010498,
    lng: 139.432998657,
  },
  {
    id: "RIS",
    name: "Rishiri Airport",
    city: "Rishiri Island",
    country: "Japan",
    lat: 45.2420005798,
    lng: 141.186004639,
  },
  {
    id: "N",
    name: "Ashiya Airport",
    city: "Ashiya",
    country: "Japan",
    lat: 33.88309860229492,
    lng: 130.6529998779297,
  },
  {
    id: "KUM",
    name: "Yakushima Airport",
    city: "Yakushima",
    country: "Japan",
    lat: 30.3855991364,
    lng: 130.658996582,
  },
  {
    id: "FUJ",
    name: "Fukue Airport",
    city: "Fukue",
    country: "Japan",
    lat: 32.66630172729492,
    lng: 128.83299255371094,
  },
  {
    id: "FUK",
    name: "Fukuoka Airport",
    city: "Fukuoka",
    country: "Japan",
    lat: 33.585899353027344,
    lng: 130.4510040283203,
  },
  {
    id: "TNE",
    name: "New Tanegashima Airport",
    city: "Tanegashima",
    country: "Japan",
    lat: 30.605100631699997,
    lng: 130.990997314,
  },
  {
    id: "KOJ",
    name: "Kagoshima Airport",
    city: "Kagoshima",
    country: "Japan",
    lat: 31.80340003967285,
    lng: 130.718994140625,
  },
  {
    id: "KMI",
    name: "Miyazaki Airport",
    city: "Miyazaki",
    country: "Japan",
    lat: 31.877199173,
    lng: 131.449005127,
  },
  {
    id: "N",
    name: "Nyutabaru Airport",
    city: "Nyutabaru",
    country: "Japan",
    lat: 32.08359909057617,
    lng: 131.4510040283203,
  },
  {
    id: "OIT",
    name: "Oita Airport",
    city: "Oita",
    country: "Japan",
    lat: 33.479400634799994,
    lng: 131.736999512,
  },
  {
    id: "KKJ",
    name: "Kitakyūshū Airport",
    city: "Kitakyushu",
    country: "Japan",
    lat: 33.8459014893,
    lng: 131.035003662,
  },
  {
    id: "KMJ",
    name: "Kumamoto Airport",
    city: "Kumamoto",
    country: "Japan",
    lat: 32.83729934692383,
    lng: 130.85499572753906,
  },
  {
    id: "NGS",
    name: "Nagasaki Airport",
    city: "Nagasaki",
    country: "Japan",
    lat: 32.916900634799994,
    lng: 129.914001465,
  },
  {
    id: "N",
    name: "Kanoya Airport",
    city: "Kanoya",
    country: "Japan",
    lat: 31.367599487304688,
    lng: 130.84500122070312,
  },
  {
    id: "N",
    name: "Tsuiki Air Field",
    city: "Tsuiki",
    country: "Japan",
    lat: 33.6850013733,
    lng: 131.039993286,
  },
  {
    id: "ASJ",
    name: "Amami Airport",
    city: "Amami",
    country: "Japan",
    lat: 28.430599212646484,
    lng: 129.71299743652344,
  },
  {
    id: "OKE",
    name: "Okierabu Airport",
    city: "Okierabu",
    country: "Japan",
    lat: 27.4255008698,
    lng: 128.701004028,
  },
  {
    id: "TKN",
    name: "Tokunoshima Airport",
    city: "Tokunoshima",
    country: "Japan",
    lat: 27.83639907836914,
    lng: 128.88099670410156,
  },
  {
    id: "FKJ",
    name: "Fukui Airport",
    city: "Fukui",
    country: "Japan",
    lat: 36.1427993774,
    lng: 136.223999023,
  },
  {
    id: "QGU",
    name: "Gifu Airport",
    city: "Gifu",
    country: "Japan",
    lat: 35.394100189208984,
    lng: 136.8699951171875,
  },
  {
    id: "N",
    name: "Hamamatsu Airport",
    city: "Hamamatsu",
    country: "Japan",
    lat: 34.75019836425781,
    lng: 137.7030029296875,
  },
  {
    id: "KMQ",
    name: "Komatsu Airport",
    city: "Kanazawa",
    country: "Japan",
    lat: 36.39459991455078,
    lng: 136.40699768066406,
  },
  {
    id: "OKI",
    name: "Oki Airport",
    city: "Oki Island",
    country: "Japan",
    lat: 36.18109893798828,
    lng: 133.3249969482422,
  },
  {
    id: "TOY",
    name: "Toyama Airport",
    city: "Toyama",
    country: "Japan",
    lat: 36.64830017089844,
    lng: 137.18800354003906,
  },
  {
    id: "N",
    name: "Shizuhama Airport",
    city: "Yaizu",
    country: "Japan",
    lat: 34.812801361083984,
    lng: 138.29800415039062,
  },
  {
    id: "HIJ",
    name: "Hiroshima Airport",
    city: "Hiroshima",
    country: "Japan",
    lat: 34.4361000061,
    lng: 132.919006348,
  },
  {
    id: "OKJ",
    name: "Okayama Airport",
    city: "Okayama",
    country: "Japan",
    lat: 34.7569007874,
    lng: 133.854995728,
  },
  {
    id: "IZO",
    name: "Izumo Airport",
    city: "Izumo",
    country: "Japan",
    lat: 35.4136009216,
    lng: 132.88999939,
  },
  {
    id: "N",
    name: "Hofu Airport",
    city: "Hofu",
    country: "Japan",
    lat: 34.034698486328125,
    lng: 131.5489959716797,
  },
  {
    id: "YGJ",
    name: "Miho Yonago Airport",
    city: "Miho",
    country: "Japan",
    lat: 35.4921989440918,
    lng: 133.23599243164062,
  },
  {
    id: "KCZ",
    name: "Kōchi Ryōma Airport",
    city: "Kochi",
    country: "Japan",
    lat: 33.546101,
    lng: 133.669006,
  },
  {
    id: "MYJ",
    name: "Matsuyama Airport",
    city: "Matsuyama",
    country: "Japan",
    lat: 33.82720184326172,
    lng: 132.6999969482422,
  },
  {
    id: "ITM",
    name: "Osaka International Airport",
    city: "Osaka",
    country: "Japan",
    lat: 34.785499572753906,
    lng: 135.43800354003906,
  },
  {
    id: "TTJ",
    name: "Tottori Airport",
    city: "Tottori",
    country: "Japan",
    lat: 35.5301017761,
    lng: 134.167007446,
  },
  {
    id: "TKS",
    name: "Tokushima Airport/JMSDF Air Base",
    city: "Tokushima",
    country: "Japan",
    lat: 34.132801,
    lng: 134.606995,
  },
  {
    id: "TAK",
    name: "Takamatsu Airport",
    city: "Takamatsu",
    country: "Japan",
    lat: 34.214199066199996,
    lng: 134.01600647,
  },
  {
    id: "N",
    name: "Yao Airport",
    city: "Osaka",
    country: "Japan",
    lat: 34.59629821777344,
    lng: 135.60299682617188,
  },
  {
    id: "N",
    name: "Ozuki Airport",
    city: "Ozuki",
    country: "Japan",
    lat: 34.0452995300293,
    lng: 131.052001953125,
  },
  {
    id: "AOJ",
    name: "Aomori Airport",
    city: "Aomori",
    country: "Japan",
    lat: 40.73469924926758,
    lng: 140.6909942626953,
  },
  {
    id: "GAJ",
    name: "Yamagata Airport",
    city: "Yamagata",
    country: "Japan",
    lat: 38.411899566699994,
    lng: 140.371002197,
  },
  {
    id: "SDS",
    name: "Sado Airport",
    city: "Sado",
    country: "Japan",
    lat: 38.0601997375,
    lng: 138.414001465,
  },
  {
    id: "HHE",
    name: "Hachinohe Airport",
    city: "Hachinoe",
    country: "Japan",
    lat: 40.556400299072266,
    lng: 141.46600341796875,
  },
  {
    id: "HNA",
    name: "Hanamaki Airport",
    city: "Hanamaki",
    country: "Japan",
    lat: 39.4286003112793,
    lng: 141.13499450683594,
  },
  {
    id: "AXT",
    name: "Akita Airport",
    city: "Akita",
    country: "Japan",
    lat: 39.6156005859375,
    lng: 140.218994140625,
  },
  {
    id: "MSJ",
    name: "Misawa Air Base",
    city: "Misawa",
    country: "Japan",
    lat: 40.703201293899994,
    lng: 141.367996216,
  },
  {
    id: "SDJ",
    name: "Sendai Airport",
    city: "Sendai",
    country: "Japan",
    lat: 38.1397018433,
    lng: 140.917007446,
  },
  {
    id: "N",
    name: "Matsushima Air Base",
    city: "Matsushima",
    country: "Japan",
    lat: 38.4048995972,
    lng: 141.220001221,
  },
  {
    id: "NJA",
    name: "Atsugi Naval Air Facility",
    city: "Atsugi",
    country: "Japan",
    lat: 35.4546012878418,
    lng: 139.4499969482422,
  },
  {
    id: "N",
    name: "Tateyama Airport",
    city: "Tateyama",
    country: "Japan",
    lat: 34.987099,
    lng: 139.828995,
  },
  {
    id: "HAC",
    name: "Hachijojima Airport",
    city: "Hachijojima",
    country: "Japan",
    lat: 33.1150016785,
    lng: 139.785995483,
  },
  {
    id: "N",
    name: "Iruma Air Base",
    city: "Iruma",
    country: "Japan",
    lat: 35.84189987182617,
    lng: 139.41099548339844,
  },
  {
    id: "N",
    name: "Kisarazu Airport",
    city: "Kisarazu",
    country: "Japan",
    lat: 35.39830017089844,
    lng: 139.91000366210938,
  },
  {
    id: "N",
    name: "Shimofusa Airport",
    city: "Shimofusa",
    country: "Japan",
    lat: 35.79890060424805,
    lng: 140.01100158691406,
  },
  {
    id: "OIM",
    name: "Oshima Airport",
    city: "Oshima",
    country: "Japan",
    lat: 34.782001495399996,
    lng: 139.36000061,
  },
  {
    id: "N",
    name: "Kastner Army Heliport",
    city: "Zama",
    country: "Japan",
    lat: 35.5138015747,
    lng: 139.393997192,
  },
  {
    id: "HND",
    name: "Tokyo Haneda International Airport",
    city: "Tokyo",
    country: "Japan",
    lat: 35.552299,
    lng: 139.779999,
  },
  {
    id: "OKO",
    name: "Yokota Air Base",
    city: "Yokota",
    country: "Japan",
    lat: 35.74850082397461,
    lng: 139.34800720214844,
  },
  {
    id: "KWJ",
    name: "Gwangju Airport",
    city: "Kwangju",
    country: "South Korea",
    lat: 35.123173,
    lng: 126.805444,
  },
  {
    id: "CHN",
    name: "Jeon Ju Airport (G-703)",
    city: "Jhunju",
    country: "South Korea",
    lat: 35.87808,
    lng: 127.119112,
  },
  {
    id: "RSU",
    name: "Yeosu Airport",
    city: "Yeosu",
    country: "South Korea",
    lat: 34.84230041503906,
    lng: 127.61699676513672,
  },
  {
    id: "N",
    name: "Sokcho Airport",
    city: "Sokch'o",
    country: "South Korea",
    lat: 38.142601013183594,
    lng: 128.5989990234375,
  },
  {
    id: "KAG",
    name: "Gangneung Airport (K-18)",
    city: "Kangnung",
    country: "South Korea",
    lat: 37.753601,
    lng: 128.943915,
  },
  {
    id: "CJU",
    name: "Jeju International Airport",
    city: "Cheju",
    country: "South Korea",
    lat: 33.51129913330078,
    lng: 126.49299621582031,
  },
  {
    id: "CHF",
    name: "Jinhae Airbase/Airport (G-813/K-10)",
    city: "Chinhae",
    country: "South Korea",
    lat: 35.140248,
    lng: 128.696229,
  },
  {
    id: "PUS",
    name: "Gimhae International Airport",
    city: "Busan",
    country: "South Korea",
    lat: 35.1795005798,
    lng: 128.93800354,
  },
  {
    id: "USN",
    name: "Ulsan Airport",
    city: "Ulsan",
    country: "South Korea",
    lat: 35.59349823,
    lng: 129.352005005,
  },
  {
    id: "N",
    name: "A 511 Airport",
    city: "Pyongtaek",
    country: "South Korea",
    lat: 36.96220016479492,
    lng: 127.03099822998047,
  },
  {
    id: "SSN",
    name: "Seoul Air Base (K-16)",
    city: "Seoul East",
    country: "South Korea",
    lat: 37.444744,
    lng: 127.112718,
  },
  {
    id: "OSN",
    name: "Osan Air Base",
    city: "Osan",
    country: "South Korea",
    lat: 37.090599,
    lng: 127.029999,
  },
  {
    id: "GMP",
    name: "Gimpo International Airport",
    city: "Seoul",
    country: "South Korea",
    lat: 37.5583,
    lng: 126.791,
  },
  {
    id: "SWU",
    name: "Suwon Airport",
    city: "Suwon",
    country: "South Korea",
    lat: 37.23939895629883,
    lng: 127.00700378417969,
  },
  {
    id: "KPO",
    name: "Pohang Airport (G-815/K-3)",
    city: "Pohang",
    country: "South Korea",
    lat: 35.987955,
    lng: 129.420383,
  },
  {
    id: "TAE",
    name: "Daegu Airport",
    city: "Taegu",
    country: "South Korea",
    lat: 35.896872,
    lng: 128.65531,
  },
  {
    id: "YEC",
    name: "Yecheon Airbase",
    city: "Yechon",
    country: "South Korea",
    lat: 36.630373,
    lng: 128.34971,
  },
  {
    id: "OKA",
    name: "Naha Airport",
    city: "Okinawa",
    country: "Japan",
    lat: 26.1958007812,
    lng: 127.646003723,
  },
  {
    id: "N",
    name: "Ie Shima Auxiliary Air Base",
    city: "Iejima",
    country: "Japan",
    lat: 26.725757598876953,
    lng: 127.76490020751953,
  },
  {
    id: "DNA",
    name: "Kadena Air Base",
    city: "Kadena",
    country: "Japan",
    lat: 26.3556,
    lng: 127.767998,
  },
  {
    id: "ISG",
    name: "New Ishigaki Airport",
    city: "Ishigaki",
    country: "Japan",
    lat: 24.396389,
    lng: 124.245,
  },
  {
    id: "UEO",
    name: "Kumejima Airport",
    city: "Kumejima",
    country: "Japan",
    lat: 26.363500595092773,
    lng: 126.71399688720703,
  },
  {
    id: "MMD",
    name: "Minami-Daito Airport",
    city: "Minami Daito",
    country: "Japan",
    lat: 25.8465003967,
    lng: 131.263000488,
  },
  {
    id: "MMY",
    name: "Miyako Airport",
    city: "Miyako",
    country: "Japan",
    lat: 24.782800674399997,
    lng: 125.294998169,
  },
  {
    id: "KTD",
    name: "Kitadaito Airport",
    city: "Kitadaito",
    country: "Japan",
    lat: 25.9447002411,
    lng: 131.32699585,
  },
  {
    id: "SHI",
    name: "Shimojishima Airport",
    city: "Shimojishima",
    country: "Japan",
    lat: 24.8267002106,
    lng: 125.144996643,
  },
  {
    id: "TRA",
    name: "Tarama Airport",
    city: "Tarama",
    country: "Japan",
    lat: 24.653900146499996,
    lng: 124.675003052,
  },
  {
    id: "RNJ",
    name: "Yoron Airport",
    city: "Yoron",
    country: "Japan",
    lat: 27.0440006256,
    lng: 128.401992798,
  },
  {
    id: "N",
    name: "Futenma Marine Corps Air Station",
    city: "Futema",
    country: "Japan",
    lat: 26.27429962158203,
    lng: 127.75599670410156,
  },
  {
    id: "OGN",
    name: "Yonaguni Airport",
    city: "Yonaguni Jima",
    country: "Japan",
    lat: 24.466899871826172,
    lng: 122.97799682617188,
  },
  {
    id: "MNL",
    name: "Ninoy Aquino International Airport",
    city: "Manila",
    country: "Philippines",
    lat: 14.5086,
    lng: 121.019997,
  },
  {
    id: "CBO",
    name: "Awang Airport",
    city: "Cotabato",
    country: "Philippines",
    lat: 7.1652398109436035,
    lng: 124.20999908447266,
  },
  {
    id: "N",
    name: "Cagayan De Oro Airport",
    city: "Ladag",
    country: "Philippines",
    lat: 8.41562,
    lng: 124.611,
  },
  {
    id: "PAG",
    name: "Pagadian Airport",
    city: "Pagadian",
    country: "Philippines",
    lat: 7.83073144787,
    lng: 123.461179733,
  },
  {
    id: "GES",
    name: "General Santos International Airport",
    city: "Romblon",
    country: "Philippines",
    lat: 6.05800008774,
    lng: 125.096000671,
  },
  {
    id: "ZAM",
    name: "Zamboanga International Airport",
    city: "Zamboanga",
    country: "Philippines",
    lat: 6.922420024871826,
    lng: 122.05999755859375,
  },
  {
    id: "BAG",
    name: "Loakan Airport",
    city: "Baguio",
    country: "Philippines",
    lat: 16.375099182128906,
    lng: 120.62000274658203,
  },
  {
    id: "DTE",
    name: "Daet Airport",
    city: "Daet",
    country: "Philippines",
    lat: 14.129199981689453,
    lng: 122.9800033569336,
  },
  {
    id: "N",
    name: "Basa Air Base",
    city: "Floridablanca",
    country: "Philippines",
    lat: 14.98724,
    lng: 120.492554,
  },
  {
    id: "N",
    name: "Lingayen Airport",
    city: "Lingayen",
    country: "Philippines",
    lat: 16.034799575805664,
    lng: 120.24099731445312,
  },
  {
    id: "SJI",
    name: "San Jose Airport",
    city: "San Jose",
    country: "Philippines",
    lat: 12.361499786399998,
    lng: 121.04699707,
  },
  {
    id: "N",
    name: "Fernando Air Base",
    city: "Lipa",
    country: "Philippines",
    lat: 13.954999923706055,
    lng: 121.125,
  },
  {
    id: "MBO",
    name: "Mamburao Airport",
    city: "Mamburao",
    country: "Philippines",
    lat: 13.208100318908691,
    lng: 120.6050033569336,
  },
  {
    id: "N",
    name: "Vigan Airport",
    city: "Vigan",
    country: "Philippines",
    lat: 17.555299758911133,
    lng: 120.35600280761719,
  },
  {
    id: "BQA",
    name: "Dr.Juan C. Angara Airport",
    city: "Baler",
    country: "Philippines",
    lat: 15.729309,
    lng: 121.500034,
  },
  {
    id: "N",
    name: "Bagabag Airport",
    city: "Bagabag",
    country: "Philippines",
    lat: 16.6192,
    lng: 121.251999,
  },
  {
    id: "TAC",
    name: "Daniel Z. Romualdez Airport",
    city: "Tacloban",
    country: "Philippines",
    lat: 11.228035,
    lng: 125.027761,
  },
  {
    id: "BCD",
    name: "Bacolod-Silay Airport",
    city: "Bacolod",
    country: "Philippines",
    lat: 10.7764,
    lng: 123.014999,
  },
  {
    id: "DGT",
    name: "Sibulan Airport",
    city: "Dumaguete",
    country: "Philippines",
    lat: 9.3337097168,
    lng: 123.300003052,
  },
  {
    id: "MPH",
    name: "Godofredo P. Ramos Airport",
    city: "Caticlan",
    country: "Philippines",
    lat: 11.9245,
    lng: 121.954002,
  },
  {
    id: "N",
    name: "Guiuan Airport",
    city: "Guiuan",
    country: "Philippines",
    lat: 11.0354995728,
    lng: 125.741996765,
  },
  {
    id: "ILO",
    name: "Iloilo International Airport",
    city: "Iloilo",
    country: "Philippines",
    lat: 10.833017,
    lng: 122.493358,
  },
  {
    id: "KLO",
    name: "Kalibo International Airport",
    city: "Kalibo",
    country: "Philippines",
    lat: 11.679400444,
    lng: 122.375999451,
  },
  {
    id: "PPS",
    name: "Puerto Princesa Airport",
    city: "Puerto Princesa",
    country: "Philippines",
    lat: 9.742119789123535,
    lng: 118.75900268554688,
  },
  {
    id: "EUQ",
    name: "Evelio Javier Airport",
    city: "San Jose",
    country: "Philippines",
    lat: 10.765999794,
    lng: 121.932998657,
  },
  {
    id: "COC",
    name: "Comodoro Pierrestegui Airport",
    city: "Concordia",
    country: "Argentina",
    lat: -31.2969,
    lng: -57.9966,
  },
  {
    id: "GHU",
    name: "Gualeguaychu Airport",
    city: "Gualeguaychu",
    country: "Argentina",
    lat: -33.0103,
    lng: -58.6131,
  },
  {
    id: "JNI",
    name: "Junin Airport",
    city: "Junin",
    country: "Argentina",
    lat: -34.5459,
    lng: -60.9306,
  },
  {
    id: "PRA",
    name: "General Urquiza Airport",
    city: "Parana",
    country: "Argentina",
    lat: -31.7948,
    lng: -60.4804,
  },
  {
    id: "ROS",
    name: "Islas Malvinas Airport",
    city: "Rosario",
    country: "Argentina",
    lat: -32.9036,
    lng: -60.785,
  },
  {
    id: "SFN",
    name: "Sauce Viejo Airport",
    city: "Santa Fe",
    country: "Argentina",
    lat: -31.7117,
    lng: -60.8117,
  },
  {
    id: "AEP",
    name: "Jorge Newbery Airpark",
    city: "Buenos Aires",
    country: "Argentina",
    lat: -34.5592,
    lng: -58.4156,
  },
  {
    id: "COR",
    name: "Ingeniero Ambrosio Taravella Airport",
    city: "Cordoba",
    country: "Argentina",
    lat: -31.323601,
    lng: -64.208,
  },
  {
    id: "N",
    name: "Chamical Airport",
    city: "Gobernador Gordillo",
    country: "Argentina",
    lat: -30.34530067,
    lng: -66.29360198,
  },
  {
    id: "FDO",
    name: "San Fernando Airport",
    city: "San Fernando",
    country: "Argentina",
    lat: -34.4532,
    lng: -58.5896,
  },
  {
    id: "N",
    name: "Mariano Moreno Airport",
    city: "Jose C. Paz",
    country: "Argentina",
    lat: -34.5606,
    lng: -58.7896,
  },
  {
    id: "LPG",
    name: "La Plata Airport",
    city: "La Plata",
    country: "Argentina",
    lat: -34.9722,
    lng: -57.8947,
  },
  {
    id: "N",
    name: "Moron Airport",
    city: "Moron",
    country: "Argentina",
    lat: -34.6763,
    lng: -58.6428,
  },
  {
    id: "EPA",
    name: "El Palomar Airport",
    city: "El Palomar",
    country: "Argentina",
    lat: -34.6099,
    lng: -58.6126,
  },
  {
    id: "HOS",
    name: "Chos Malal Airport",
    city: "Chosmadal",
    country: "Argentina",
    lat: -37.444698333699996,
    lng: -70.2225036621,
  },
  {
    id: "GNR",
    name: "Dr. Arturo H. Illia Airport",
    city: "Fuerte Gral Roca",
    country: "Argentina",
    lat: -39.0007019043,
    lng: -67.6204986572,
  },
  {
    id: "MDZ",
    name: "El Plumerillo Airport",
    city: "Mendoza",
    country: "Argentina",
    lat: -32.8316993713,
    lng: -68.7929000854,
  },
  {
    id: "LGS",
    name: "Comodoro D.R. Salomón Airport",
    city: "Malargue",
    country: "Argentina",
    lat: -35.493598938,
    lng: -69.5743026733,
  },
  {
    id: "AFA",
    name: "Suboficial Ay Santiago Germano Airport",
    city: "San Rafael",
    country: "Argentina",
    lat: -34.588299,
    lng: -68.4039,
  },
  {
    id: "CTC",
    name: "Catamarca Airport",
    city: "Catamarca",
    country: "Argentina",
    lat: -28.5956001282,
    lng: -65.751701355,
  },
  {
    id: "SDE",
    name: "Vicecomodoro Angel D. La Paz Aragonés Airport",
    city: "Santiago Del Estero",
    country: "Argentina",
    lat: -27.765556335399996,
    lng: -64.3099975586,
  },
  {
    id: "N",
    name: "Tinogasta Airport",
    city: "Tinogasta",
    country: "Argentina",
    lat: -28.0377998352,
    lng: -67.5802993774,
  },
  {
    id: "IRJ",
    name: "Capitan V A Almonacid Airport",
    city: "La Rioja",
    country: "Argentina",
    lat: -29.3815994263,
    lng: -66.7957992554,
  },
  {
    id: "N",
    name: "Chilecito Airport",
    city: "Chilecito",
    country: "Argentina",
    lat: -29.2238998413,
    lng: -67.4389038086,
  },
  {
    id: "TUC",
    name: "Teniente Benjamin Matienzo Airport",
    city: "Tucuman",
    country: "Argentina",
    lat: -26.8409,
    lng: -65.104897,
  },
  {
    id: "UAQ",
    name: "Domingo Faustino Sarmiento Airport",
    city: "San Juan",
    country: "Argentina",
    lat: -31.571501,
    lng: -68.418198,
  },
  {
    id: "RCU",
    name: "Area De Material Airport",
    city: "Rio Cuarto",
    country: "Argentina",
    lat: -33.0850982666,
    lng: -64.2612991333,
  },
  {
    id: "VDR",
    name: "Villa Dolores Airport",
    city: "Villa Dolores",
    country: "Argentina",
    lat: -31.9451999664,
    lng: -65.1463012695,
  },
  {
    id: "N",
    name: "La Quiaca Airport",
    city: "Laboulaye",
    country: "Argentina",
    lat: -22.1506004333,
    lng: -65.57749938959999,
  },
  {
    id: "N",
    name: "Marcos Juarez Airport",
    city: "Marcos Juarez",
    country: "Argentina",
    lat: -32.6836,
    lng: -62.157801,
  },
  {
    id: "VME",
    name: "Villa Reynolds Airport",
    city: "Villa Reynolds",
    country: "Argentina",
    lat: -33.7299003601,
    lng: -65.3873977661,
  },
  {
    id: "LUQ",
    name: "Brigadier Mayor D Cesar Raul Ojeda Airport",
    city: "San Luis",
    country: "Argentina",
    lat: -33.2732009888,
    lng: -66.3563995361,
  },
  {
    id: "CNQ",
    name: "Corrientes Airport",
    city: "Corrientes",
    country: "Argentina",
    lat: -27.4455,
    lng: -58.7619,
  },
  {
    id: "RES",
    name: "Resistencia International Airport",
    city: "Resistencia",
    country: "Argentina",
    lat: -27.45,
    lng: -59.0561,
  },
  {
    id: "FMA",
    name: "Formosa Airport",
    city: "Formosa",
    country: "Argentina",
    lat: -26.2127,
    lng: -58.2281,
  },
  {
    id: "IGR",
    name: "Cataratas Del Iguazú International Airport",
    city: "Iguazu Falls",
    country: "Argentina",
    lat: -25.737301,
    lng: -54.4734,
  },
  {
    id: "AOL",
    name: "Paso De Los Libres Airport",
    city: "Paso De Los Libres",
    country: "Argentina",
    lat: -29.6894,
    lng: -57.1521,
  },
  {
    id: "MCS",
    name: "Monte Caseros Airport",
    city: "Monte Caseros",
    country: "Argentina",
    lat: -30.2719,
    lng: -57.6402,
  },
  {
    id: "PSS",
    name: "Libertador Gral D Jose De San Martin Airport",
    city: "Posadas",
    country: "Argentina",
    lat: -27.3858,
    lng: -55.9707,
  },
  {
    id: "PRQ",
    name: "Termal Airport",
    city: "Presidencia R.s.pena",
    country: "Argentina",
    lat: -26.753611,
    lng: -60.492222,
  },
  {
    id: "SLA",
    name: "Martin Miguel De Guemes International Airport",
    city: "Salta",
    country: "Argentina",
    lat: -24.856000900299996,
    lng: -65.4861984253,
  },
  {
    id: "JUJ",
    name: "Gobernador Horacio Guzman International Airport",
    city: "Jujuy",
    country: "Argentina",
    lat: -24.392799,
    lng: -65.097801,
  },
  {
    id: "ORA",
    name: "Orán Airport",
    city: "Oran",
    country: "Argentina",
    lat: -23.1527996063,
    lng: -64.3292007446,
  },
  {
    id: "N",
    name: "Laboulaye Airport",
    city: "La Quiaca",
    country: "Argentina",
    lat: -34.1353988647,
    lng: -63.36230087279999,
  },
  {
    id: "ELO",
    name: "El Dorado Airport",
    city: "El Dorado",
    country: "Argentina",
    lat: -26.3974990845,
    lng: -54.5746994019,
  },
  {
    id: "OYA",
    name: "Goya Airport",
    city: "Goya",
    country: "Argentina",
    lat: -29.1058,
    lng: -59.2189,
  },
  {
    id: "N",
    name: "Oberá Airport",
    city: "Obera",
    country: "Argentina",
    lat: -27.5181999207,
    lng: -55.1241989136,
  },
  {
    id: "RCQ",
    name: "Reconquista Airport",
    city: "Reconquista",
    country: "Argentina",
    lat: -29.2103,
    lng: -59.68,
  },
  {
    id: "UZU",
    name: "Curuzu Cuatia Airport",
    city: "Curuzu Cuatia",
    country: "Argentina",
    lat: -29.7706,
    lng: -57.9789,
  },
  {
    id: "EHL",
    name: "El Bolson Airport",
    city: "El Bolson",
    country: "Argentina",
    lat: -41.9431991577,
    lng: -71.5323028564,
  },
  {
    id: "CRD",
    name: "General E. Mosconi Airport",
    city: "Comodoro Rivadavia",
    country: "Argentina",
    lat: -45.7853,
    lng: -67.4655,
  },
  {
    id: "EQS",
    name: "Brigadier Antonio Parodi Airport",
    city: "Esquel",
    country: "Argentina",
    lat: -42.908000946,
    lng: -71.139503479,
  },
  {
    id: "REL",
    name: "Almirante Marco Andres Zar Airport",
    city: "Trelew",
    country: "Argentina",
    lat: -43.2105,
    lng: -65.2703,
  },
  {
    id: "VDM",
    name: "Gobernador Castello Airport",
    city: "Viedma",
    country: "Argentina",
    lat: -40.8692,
    lng: -63.0004,
  },
  {
    id: "PMY",
    name: "El Tehuelche Airport",
    city: "Puerto Madryn",
    country: "Argentina",
    lat: -42.7592,
    lng: -65.1027,
  },
  {
    id: "N",
    name: "Marambio Base",
    city: "Marambio Base",
    country: "Antarctica",
    lat: -64.2382965088,
    lng: -56.6307983398,
  },
  {
    id: "PUD",
    name: "Puerto Deseado Airport",
    city: "Puerto Deseado",
    country: "Argentina",
    lat: -47.7353,
    lng: -65.9041,
  },
  {
    id: "RGA",
    name: "Hermes Quijada International Airport",
    city: "Rio Grande",
    country: "Argentina",
    lat: -53.7777,
    lng: -67.7494,
  },
  {
    id: "RGL",
    name: "Piloto Civil N. Fernández Airport",
    city: "Rio Gallegos",
    country: "Argentina",
    lat: -51.6089,
    lng: -69.3126,
  },
  {
    id: "USH",
    name: "Malvinas Argentinas Airport",
    city: "Ushuaia",
    country: "Argentina",
    lat: -54.8433,
    lng: -68.2958,
  },
  {
    id: "ULA",
    name: "Capitan D Daniel Vazquez Airport",
    city: "San Julian",
    country: "Argentina",
    lat: -49.3068,
    lng: -67.8026,
  },
  {
    id: "PMQ",
    name: "Perito Moreno Airport",
    city: "Perito Moreno",
    country: "Argentina",
    lat: -46.537899,
    lng: -70.978699,
  },
  {
    id: "RZA",
    name: "Santa Cruz Airport",
    city: "Santa Cruz",
    country: "Argentina",
    lat: -50.0165,
    lng: -68.5792,
  },
  {
    id: "BHI",
    name: "Comandante Espora Airport",
    city: "Bahia Blanca",
    country: "Argentina",
    lat: -38.725,
    lng: -62.1693,
  },
  {
    id: "CSZ",
    name: "Brigadier D.H.E. Ruiz Airport",
    city: "Colonel Suarez",
    country: "Argentina",
    lat: -37.446098,
    lng: -61.889301,
  },
  {
    id: "OVR",
    name: "Olavarria Airport",
    city: "Olavarria",
    country: "Argentina",
    lat: -36.8899993896,
    lng: -60.216598510699995,
  },
  {
    id: "GPO",
    name: "General Pico Airport",
    city: "General Pico",
    country: "Argentina",
    lat: -35.6962013245,
    lng: -63.7583007812,
  },
  {
    id: "OYO",
    name: "Tres Arroyos Airport",
    city: "Tres Arroyos",
    country: "Argentina",
    lat: -38.3869,
    lng: -60.3297,
  },
  {
    id: "N",
    name: "Bolivar Airport",
    city: "Bolivar",
    country: "Argentina",
    lat: -36.1866,
    lng: -61.0764,
  },
  {
    id: "MDQ",
    name: "Ástor Piazzola International Airport",
    city: "Mar Del Plata",
    country: "Argentina",
    lat: -37.9342,
    lng: -57.5733,
  },
  {
    id: "NQN",
    name: "Presidente Peron Airport",
    city: "Neuquen",
    country: "Argentina",
    lat: -38.949001,
    lng: -68.155701,
  },
  {
    id: "PEH",
    name: "Comodoro Pedro Zanni Airport",
    city: "Pehuajo",
    country: "Argentina",
    lat: -35.8446,
    lng: -61.8576,
  },
  {
    id: "RSA",
    name: "Santa Rosa Airport",
    city: "Santa Rosa",
    country: "Argentina",
    lat: -36.588299,
    lng: -64.275703,
  },
  {
    id: "BRC",
    name: "San Carlos De Bariloche Airport",
    city: "San Carlos De Bariloche",
    country: "Argentina",
    lat: -41.151199,
    lng: -71.157501,
  },
  {
    id: "TDL",
    name: "Héroes De Malvinas Airport",
    city: "Tandil",
    country: "Argentina",
    lat: -37.2374000549,
    lng: -59.2279014587,
  },
  {
    id: "VLG",
    name: "Villa Gesell Airport",
    city: "Villa Gesell",
    country: "Argentina",
    lat: -37.2354,
    lng: -57.0292,
  },
  {
    id: "CUT",
    name: "Cutral-Co Airport",
    city: "Cutralco",
    country: "Argentina",
    lat: -38.939701080300004,
    lng: -69.2646026611,
  },
  {
    id: "CPC",
    name: "Aviador C. Campos Airport",
    city: "San Martin Des Andes",
    country: "Argentina",
    lat: -40.075401,
    lng: -71.137299,
  },
  {
    id: "CDJ",
    name: "Conceição do Araguaia Airport",
    city: "Conceicao Do Araguaia",
    country: "Brazil",
    lat: -8.348349571228027,
    lng: -49.30149841308594,
  },
  {
    id: "N",
    name: "Campo Délio Jardim de Mattos Airport",
    city: "Rio De Janeiro",
    country: "Brazil",
    lat: -22.875099,
    lng: -43.384701,
  },
  {
    id: "N",
    name: "Amapá Airport",
    city: "Amapa",
    country: "Brazil",
    lat: 2.07751,
    lng: -50.8582,
  },
  {
    id: "AQA",
    name: "Araraquara Airport",
    city: "Araracuara",
    country: "Brazil",
    lat: -21.812000274699997,
    lng: -48.1329994202,
  },
  {
    id: "AJU",
    name: "Santa Maria Airport",
    city: "Aracaju",
    country: "Brazil",
    lat: -10.984000206,
    lng: -37.0703010559,
  },
  {
    id: "AFL",
    name: "Piloto Osvaldo Marques Dias Airport",
    city: "Alta Floresta",
    country: "Brazil",
    lat: -9.8663892746,
    lng: -56.1049995422,
  },
  {
    id: "ARU",
    name: "Araçatuba Airport",
    city: "Aracatuba",
    country: "Brazil",
    lat: -21.1413002014,
    lng: -50.4247016907,
  },
  {
    id: "BEL",
    name: "Val de Cans/Júlio Cezar Ribeiro International Airport",
    city: "Belem",
    country: "Brazil",
    lat: -1.3792500495900002,
    lng: -48.4762992859,
  },
  {
    id: "BGX",
    name: "Comandante Gustavo Kraemer Airport",
    city: "Bage",
    country: "Brazil",
    lat: -31.39049911499,
    lng: -54.112201690674,
  },
  {
    id: "PLU",
    name: "Pampulha - Carlos Drummond de Andrade Airport",
    city: "Belo Horizonte",
    country: "Brazil",
    lat: -19.851200103759766,
    lng: -43.950599670410156,
  },
  {
    id: "BFH",
    name: "Bacacheri Airport",
    city: "Curitiba",
    country: "Brazil",
    lat: -25.4050998688,
    lng: -49.23199844359999,
  },
  {
    id: "N",
    name: "Major Brigadeiro Doorgal Borges Airport",
    city: "Barbacena",
    country: "Brazil",
    lat: -21.2672,
    lng: -43.761101,
  },
  {
    id: "BSB",
    name: "Presidente Juscelino Kubistschek International Airport",
    city: "Brasilia",
    country: "Brazil",
    lat: -15.86916732788086,
    lng: -47.920833587646484,
  },
  {
    id: "BAU",
    name: "Bauru Airport",
    city: "Bauru",
    country: "Brazil",
    lat: -22.3449993134,
    lng: -49.0537986755,
  },
  {
    id: "BVB",
    name: "Atlas Brasil Cantanhede Airport",
    city: "Boa Vista",
    country: "Brazil",
    lat: 2.84138894081,
    lng: -60.6922225952,
  },
  {
    id: "BPG",
    name: "Barra do Garças Airport",
    city: "Barra Do Garcas",
    country: "Brazil",
    lat: -15.861300468400001,
    lng: -52.3889007568,
  },
  {
    id: "CAC",
    name: "Cascavel Airport",
    city: "Cascavel",
    country: "Brazil",
    lat: -25.0002994537,
    lng: -53.500801086399996,
  },
  {
    id: "N",
    name: "Cachimbo Airport",
    city: "Itaituba",
    country: "Brazil",
    lat: -9.33393955231,
    lng: -54.9654006958,
  },
  {
    id: "CNF",
    name: "Tancredo Neves International Airport",
    city: "Belo Horizonte",
    country: "Brazil",
    lat: -19.62444305419922,
    lng: -43.97194290161133,
  },
  {
    id: "CGR",
    name: "Campo Grande Airport",
    city: "Campo Grande",
    country: "Brazil",
    lat: -20.468700408900002,
    lng: -54.6725006104,
  },
  {
    id: "XAP",
    name: "Serafin Enoss Bertaso Airport",
    city: "Chapeco",
    country: "Brazil",
    lat: -27.134199142456,
    lng: -52.656600952148,
  },
  {
    id: "CLN",
    name: "Brig. Lysias Augusto Rodrigues Airport",
    city: "Carolina",
    country: "Brazil",
    lat: -7.32043981552124,
    lng: -47.45869827270508,
  },
  {
    id: "CCM",
    name: "Diomício Freitas Airport",
    city: "Criciuma",
    country: "Brazil",
    lat: -28.7244434357,
    lng: -49.4213905334,
  },
  {
    id: "N",
    name: "Canoas Air Force Base",
    city: "Porto Alegre",
    country: "Brazil",
    lat: -29.945928,
    lng: -51.144413,
  },
  {
    id: "CAW",
    name: "Bartolomeu Lisandro Airport",
    city: "Campos",
    country: "Brazil",
    lat: -21.698299408,
    lng: -41.301700592,
  },
  {
    id: "CMG",
    name: "Corumbá International Airport",
    city: "Corumba",
    country: "Brazil",
    lat: -19.0119438171,
    lng: -57.6713905334,
  },
  {
    id: "CWB",
    name: "Afonso Pena Airport",
    city: "Curitiba",
    country: "Brazil",
    lat: -25.5284996033,
    lng: -49.1758003235,
  },
  {
    id: "CRQ",
    name: "Caravelas Airport",
    city: "Caravelas",
    country: "Brazil",
    lat: -17.652299880981,
    lng: -39.253101348877,
  },
  {
    id: "CXJ",
    name: "Hugo Cantergiani Regional Airport",
    city: "Caxias Do Sul",
    country: "Brazil",
    lat: -29.197099685699996,
    lng: -51.1875,
  },
  {
    id: "CGB",
    name: "Marechal Rondon Airport",
    city: "Cuiaba",
    country: "Brazil",
    lat: -15.6528997421,
    lng: -56.1166992188,
  },
  {
    id: "CZS",
    name: "Cruzeiro do Sul Airport",
    city: "Cruzeiro do Sul",
    country: "Brazil",
    lat: -7.59990978241,
    lng: -72.7695007324,
  },
  {
    id: "PPB",
    name: "Presidente Prudente Airport",
    city: "President Prudente",
    country: "Brazil",
    lat: -22.1751003265,
    lng: -51.4245986938,
  },
  {
    id: "MAO",
    name: "Eduardo Gomes International Airport",
    city: "Manaus",
    country: "Brazil",
    lat: -3.0386099815368652,
    lng: -60.04970169067383,
  },
  {
    id: "JCR",
    name: "Jacareacanga Airport",
    city: "Jacare-acanga",
    country: "Brazil",
    lat: -6.233160018920898,
    lng: -57.77690124511719,
  },
  {
    id: "N",
    name: "São Pedro da Aldeia Airport",
    city: "Sao Pedro Da Aldeia",
    country: "Brazil",
    lat: -22.81290054321289,
    lng: -42.09260177612305,
  },
  {
    id: "IGU",
    name: "Cataratas International Airport",
    city: "Foz Do Iguacu",
    country: "Brazil",
    lat: -25.600278854370117,
    lng: -54.48500061035156,
  },
  {
    id: "FLN",
    name: "Hercílio Luz International Airport",
    city: "Florianopolis",
    country: "Brazil",
    lat: -27.670278549194336,
    lng: -48.5525016784668,
  },
  {
    id: "FEN",
    name: "Fernando de Noronha Airport",
    city: "Fernando Do Noronha",
    country: "Brazil",
    lat: -3.85493,
    lng: -32.423302,
  },
  {
    id: "N",
    name: "Furnas Airport",
    city: "Alpinopolis",
    country: "Brazil",
    lat: -20.702800750732422,
    lng: -46.33530044555664,
  },
  {
    id: "FOR",
    name: "Pinto Martins International Airport",
    city: "Fortaleza",
    country: "Brazil",
    lat: -3.776279926300049,
    lng: -38.53260040283203,
  },
  {
    id: "GIG",
    name: "Rio Galeão – Tom Jobim International Airport",
    city: "Rio De Janeiro",
    country: "Brazil",
    lat: -22.8099994659,
    lng: -43.2505569458,
  },
  {
    id: "GJM",
    name: "Guajará-Mirim Airport",
    city: "Guajara-mirim",
    country: "Brazil",
    lat: -10.786399841308594,
    lng: -65.28479766845703,
  },
  {
    id: "GYN",
    name: "Santa Genoveva Airport",
    city: "Goiania",
    country: "Brazil",
    lat: -16.631999969482422,
    lng: -49.220699310302734,
  },
  {
    id: "N",
    name: "EMBRAER - Unidade Gavião Peixoto Airport",
    city: "Macae",
    country: "Brazil",
    lat: -21.773700714111328,
    lng: -48.40510177612305,
  },
  {
    id: "GRU",
    name: "Guarulhos - Governador André Franco Montoro International Airport",
    city: "Sao Paulo",
    country: "Brazil",
    lat: -23.435556411743164,
    lng: -46.47305679321289,
  },
  {
    id: "GUJ",
    name: "Guaratinguetá Airport",
    city: "Guaratingueta",
    country: "Brazil",
    lat: -22.79159927368164,
    lng: -45.20479965209961,
  },
  {
    id: "ATM",
    name: "Altamira Airport",
    city: "Altamira",
    country: "Brazil",
    lat: -3.2539100646973,
    lng: -52.254001617432,
  },
  {
    id: "ITA",
    name: "Itacoatiara Airport",
    city: "Itaituba",
    country: "Brazil",
    lat: -3.1272599697113037,
    lng: -58.481201171875,
  },
  {
    id: "ITB",
    name: "Itaituba Airport",
    city: "Itaituba",
    country: "Brazil",
    lat: -4.2423400878906,
    lng: -56.000701904297,
  },
  {
    id: "IOS",
    name: "Bahia - Jorge Amado Airport",
    city: "Ilheus",
    country: "Brazil",
    lat: -14.815999984741,
    lng: -39.033199310303,
  },
  {
    id: "IPN",
    name: "Usiminas Airport",
    city: "Ipatinga",
    country: "Brazil",
    lat: -19.470699310303,
    lng: -42.487598419189,
  },
  {
    id: "ITR",
    name: "Francisco Vilela do Amaral Airport",
    city: "Itumbiara",
    country: "Brazil",
    lat: -18.4447002411,
    lng: -49.2134017944,
  },
  {
    id: "IMP",
    name: "Prefeito Renato Moreira Airport",
    city: "Imperatriz",
    country: "Brazil",
    lat: -5.53129,
    lng: -47.459999,
  },
  {
    id: "N",
    name: "Belém/Brigadeiro Protásio de Oliveira Airport",
    city: "Belem",
    country: "Brazil",
    lat: -1.4141600132,
    lng: -48.4607009888,
  },
  {
    id: "JDF",
    name: "Francisco de Assis Airport",
    city: "Juiz De Fora",
    country: "Brazil",
    lat: -21.791500091552734,
    lng: -43.38679885864258,
  },
  {
    id: "JPA",
    name: "Presidente Castro Pinto International Airport",
    city: "Joao Pessoa",
    country: "Brazil",
    lat: -7.145833015440001,
    lng: -34.9486122131,
  },
  {
    id: "JOI",
    name: "Lauro Carneiro de Loyola Airport",
    city: "Joinville",
    country: "Brazil",
    lat: -26.22450065612793,
    lng: -48.797401428222656,
  },
  {
    id: "CPV",
    name: "Presidente João Suassuna Airport",
    city: "Campina Grande",
    country: "Brazil",
    lat: -7.26992,
    lng: -35.8964,
  },
  {
    id: "VCP",
    name: "Viracopos International Airport",
    city: "Campinas",
    country: "Brazil",
    lat: -23.0074005127,
    lng: -47.1344985962,
  },
  {
    id: "LAJ",
    name: "Lages Airport",
    city: "Lajes",
    country: "Brazil",
    lat: -27.782100677499997,
    lng: -50.28150177,
  },
  {
    id: "LIP",
    name: "Lins Airport",
    city: "Lins",
    country: "Brazil",
    lat: -21.663999557495,
    lng: -49.730499267578,
  },
  {
    id: "LDB",
    name: "Governador José Richa Airport",
    city: "Londrina",
    country: "Brazil",
    lat: -23.333599090599996,
    lng: -51.1301002502,
  },
  {
    id: "LAZ",
    name: "Bom Jesus da Lapa Airport",
    city: "Bom Jesus Da Lapa",
    country: "Brazil",
    lat: -13.2621002197,
    lng: -43.4081001282,
  },
  {
    id: "N",
    name: "Lagoa Santa Airport",
    city: "Lagoa Santa",
    country: "Brazil",
    lat: -19.66160011291504,
    lng: -43.896400451660156,
  },
  {
    id: "MAB",
    name: "João Correa da Rocha Airport",
    city: "Maraba",
    country: "Brazil",
    lat: -5.36858987808,
    lng: -49.138000488299994,
  },
  {
    id: "MEU",
    name: "Monte Dourado Airport",
    city: "Almeirim",
    country: "Brazil",
    lat: -0.889839,
    lng: -52.6022,
  },
  {
    id: "MGF",
    name: "Regional de Maringá - Sílvio Nane Junior Airport",
    city: "Maringa",
    country: "Brazil",
    lat: -23.479444503799996,
    lng: -52.01222229,
  },
  {
    id: "MOC",
    name: "Mário Ribeiro Airport",
    city: "Montes Claros",
    country: "Brazil",
    lat: -16.706899642899998,
    lng: -43.818901062,
  },
  {
    id: "PLL",
    name: "Ponta Pelada Airport",
    city: "Manaus",
    country: "Brazil",
    lat: -3.1460399627685547,
    lng: -59.98630142211914,
  },
  {
    id: "MCZ",
    name: "Zumbi dos Palmares Airport",
    city: "Maceio",
    country: "Brazil",
    lat: -9.510809898376465,
    lng: -35.79169845581055,
  },
  {
    id: "MCP",
    name: "Alberto Alcolumbre Airport",
    city: "Macapa",
    country: "Brazil",
    lat: 0.0506640002131,
    lng: -51.0722007751,
  },
  {
    id: "MVF",
    name: "Dix-Sept Rosado Airport",
    city: "Mocord",
    country: "Brazil",
    lat: -5.2019200324999995,
    lng: -37.3642997742,
  },
  {
    id: "N",
    name: "Campo de Marte Airport",
    city: "Sao Paulo",
    country: "Brazil",
    lat: -23.5090999603,
    lng: -46.6377983093,
  },
  {
    id: "MNX",
    name: "Manicoré Airport",
    city: "Manicore",
    country: "Brazil",
    lat: -5.8113799095154,
    lng: -61.278301239014,
  },
  {
    id: "NVT",
    name: "Ministro Victor Konder International Airport",
    city: "Navegantes",
    country: "Brazil",
    lat: -26.879999,
    lng: -48.651402,
  },
  {
    id: "GEL",
    name: "Santo Ângelo Airport",
    city: "Santo Angelo",
    country: "Brazil",
    lat: -28.2817,
    lng: -54.169102,
  },
  {
    id: "NAT",
    name: "Governador Aluízio Alves International Airport",
    city: "Natal",
    country: "Brazil",
    lat: -5.768056,
    lng: -35.376111,
  },
  {
    id: "OYK",
    name: "Oiapoque Airport",
    city: "Oioiapoque",
    country: "Brazil",
    lat: 3.85548996925354,
    lng: -51.79690170288086,
  },
  {
    id: "POA",
    name: "Salgado Filho Airport",
    city: "Porto Alegre",
    country: "Brazil",
    lat: -29.994400024414062,
    lng: -51.1713981628418,
  },
  {
    id: "PHB",
    name: "Prefeito Doutor João Silva Filho Airport",
    city: "Parnaiba",
    country: "Brazil",
    lat: -2.89374995232,
    lng: -41.73199844359999,
  },
  {
    id: "POO",
    name: "Poços de Caldas - Embaixador Walther Moreira Salles Airport",
    city: "Pocos De Caldas",
    country: "Brazil",
    lat: -21.843000411987,
    lng: -46.567901611328,
  },
  {
    id: "PFB",
    name: "Lauro Kurtz Airport",
    city: "Passo Fundo",
    country: "Brazil",
    lat: -28.243999,
    lng: -52.326599,
  },
  {
    id: "PET",
    name: "João Simões Lopes Neto International Airport",
    city: "Pelotas",
    country: "Brazil",
    lat: -31.718399,
    lng: -52.327702,
  },
  {
    id: "PNZ",
    name: "Senador Nilo Coelho Airport",
    city: "Petrolina",
    country: "Brazil",
    lat: -9.362409591674805,
    lng: -40.56909942626953,
  },
  {
    id: "PNB",
    name: "Porto Nacional Airport",
    city: "Porto Nacional",
    country: "Brazil",
    lat: -10.719400405883789,
    lng: -48.39970016479492,
  },
  {
    id: "PMG",
    name: "Ponta Porã Airport",
    city: "Ponta Pora",
    country: "Brazil",
    lat: -22.54960060119629,
    lng: -55.702598571777344,
  },
  {
    id: "PVH",
    name: "Governador Jorge Teixeira de Oliveira Airport",
    city: "Porto Velho",
    country: "Brazil",
    lat: -8.70928955078125,
    lng: -63.90230178833008,
  },
  {
    id: "RBR",
    name: "Plácido de Castro Airport",
    city: "Rio Branco",
    country: "Brazil",
    lat: -9.868888854980469,
    lng: -67.89805603027344,
  },
  {
    id: "REC",
    name: "Guararapes - Gilberto Freyre International Airport",
    city: "Recife",
    country: "Brazil",
    lat: -8.126489639282227,
    lng: -34.92359924316406,
  },
  {
    id: "SDU",
    name: "Santos Dumont Airport",
    city: "Rio De Janeiro",
    country: "Brazil",
    lat: -22.910499572799996,
    lng: -43.1631011963,
  },
  {
    id: "RAO",
    name: "Leite Lopes Airport",
    city: "Ribeirao Preto",
    country: "Brazil",
    lat: -21.136388778686523,
    lng: -47.776668548583984,
  },
  {
    id: "SNZ",
    name: "Santa Cruz Air Force Base",
    city: "Rio De Janeiro",
    country: "Brazil",
    lat: -22.9324,
    lng: -43.719101,
  },
  {
    id: "SJK",
    name: "Professor Urbano Ernesto Stumpf Airport",
    city: "Sao Jose Dos Campos",
    country: "Brazil",
    lat: -23.22920036315918,
    lng: -45.86149978637695,
  },
  {
    id: "SLZ",
    name: "Marechal Cunha Machado International Airport",
    city: "Sao Luis",
    country: "Brazil",
    lat: -2.585360050201416,
    lng: -44.234100341796875,
  },
  {
    id: "CGH",
    name: "Congonhas Airport",
    city: "Sao Paulo",
    country: "Brazil",
    lat: -23.626110076904297,
    lng: -46.65638732910156,
  },
  {
    id: "SJP",
    name: "Prof. Eribelto Manoel Reino State Airport",
    city: "Sao Jose Do Rio Preto",
    country: "Brazil",
    lat: -20.816600799599996,
    lng: -49.40650177,
  },
  {
    id: "SSZ",
    name: "Base Aérea de Santos Airport",
    city: "Santos",
    country: "Brazil",
    lat: -23.928056716918945,
    lng: -46.299720764160156,
  },
  {
    id: "SSA",
    name: "Deputado Luiz Eduardo Magalhães International Airport",
    city: "Salvador",
    country: "Brazil",
    lat: -12.9086112976,
    lng: -38.3224983215,
  },
  {
    id: "TMT",
    name: "Trombetas Airport",
    city: "Oriximina",
    country: "Brazil",
    lat: -1.489599943161,
    lng: -56.396800994873,
  },
  {
    id: "THE",
    name: "Senador Petrônio Portela Airport",
    city: "Teresina",
    country: "Brazil",
    lat: -5.0599398613,
    lng: -42.8235015869,
  },
  {
    id: "TFF",
    name: "Tefé Airport",
    city: "Tefe",
    country: "Brazil",
    lat: -3.38294005394,
    lng: -64.7240982056,
  },
  {
    id: "TRQ",
    name: "Tarauacá Airport",
    city: "Tarauaca",
    country: "Brazil",
    lat: -8.1552600860596,
    lng: -70.783302307129,
  },
  {
    id: "TEC",
    name: "Telêmaco Borba Airport",
    city: "Telemaco Borba",
    country: "Brazil",
    lat: -24.317800521850586,
    lng: -50.6515998840332,
  },
  {
    id: "N",
    name: "Tiriós Airport",
    city: "Obidos Tirios",
    country: "Brazil",
    lat: 2.22347,
    lng: -55.946098,
  },
  {
    id: "TBT",
    name: "Tabatinga Airport",
    city: "Tabatinga",
    country: "Brazil",
    lat: -4.2556700706482,
    lng: -69.93579864502,
  },
  {
    id: "TUR",
    name: "Tucuruí Airport",
    city: "Tucurui",
    country: "Brazil",
    lat: -3.7860100269318,
    lng: -49.72029876709,
  },
  {
    id: "SJL",
    name: "São Gabriel da Cachoeira Airport",
    city: "Sao Gabriel",
    country: "Brazil",
    lat: -0.14835,
    lng: -66.9855,
  },
  {
    id: "PAV",
    name: "Paulo Afonso Airport",
    city: "Paulo Alfonso",
    country: "Brazil",
    lat: -9.4008798599243,
    lng: -38.250598907471,
  },
  {
    id: "URG",
    name: "Rubem Berta Airport",
    city: "Uruguaiana",
    country: "Brazil",
    lat: -29.7821998596,
    lng: -57.0382003784,
  },
  {
    id: "UDI",
    name: "Ten. Cel. Aviador César Bombonato Airport",
    city: "Uberlandia",
    country: "Brazil",
    lat: -18.883612,
    lng: -48.225277,
  },
  {
    id: "UBA",
    name: "Mário de Almeida Franco Airport",
    city: "Uberaba",
    country: "Brazil",
    lat: -19.764722824097,
    lng: -47.966110229492,
  },
  {
    id: "VAG",
    name: "Major Brigadeiro Trompowsky Airport",
    city: "Varginha",
    country: "Brazil",
    lat: -21.5900993347,
    lng: -45.4733009338,
  },
  {
    id: "BVH",
    name: "Brigadeiro Camarão Airport",
    city: "Vilhena",
    country: "Brazil",
    lat: -12.694399833679,
    lng: -60.098300933838,
  },
  {
    id: "VIX",
    name: "Eurico de Aguiar Salles Airport",
    city: "Vitoria",
    country: "Brazil",
    lat: -20.258057,
    lng: -40.286388,
  },
  {
    id: "N",
    name: "Iauaretê Airport",
    city: "Iauarete",
    country: "Brazil",
    lat: 0.6075000166893,
    lng: -69.18579864502,
  },
  {
    id: "QPS",
    name: "Campo Fontenelle Airport",
    city: "Piracununga",
    country: "Brazil",
    lat: -21.984600067138672,
    lng: -47.334800720214844,
  },
  {
    id: "ARI",
    name: "Chacalluta Airport",
    city: "Arica",
    country: "Chile",
    lat: -18.348499,
    lng: -70.338699,
  },
  {
    id: "BBA",
    name: "Balmaceda Airport",
    city: "Balmaceda",
    country: "Chile",
    lat: -45.916099548339844,
    lng: -71.68949890136719,
  },
  {
    id: "N",
    name: "El Bosque Airport",
    city: "Santiago",
    country: "Chile",
    lat: -33.561798095703125,
    lng: -70.68840026855469,
  },
  {
    id: "CCH",
    name: "Chile Chico Airport",
    city: "Chile Chico",
    country: "Chile",
    lat: -46.58330154418945,
    lng: -71.6874008178711,
  },
  {
    id: "CJC",
    name: "El Loa Airport",
    city: "Calama",
    country: "Chile",
    lat: -22.498199462890625,
    lng: -68.90360260009766,
  },
  {
    id: "YAI",
    name: "Gral. Bernardo O´Higgins Airport",
    city: "Chillan",
    country: "Chile",
    lat: -36.58250045776367,
    lng: -72.03140258789062,
  },
  {
    id: "PUQ",
    name: "Pdte. Carlos Ibañez del Campo Airport",
    city: "Punta Arenas",
    country: "Chile",
    lat: -53.002602,
    lng: -70.854599,
  },
  {
    id: "GXQ",
    name: "Teniente Vidal Airport",
    city: "Coyhaique",
    country: "Chile",
    lat: -45.594200134277344,
    lng: -72.1061019897461,
  },
  {
    id: "IQQ",
    name: "Diego Aracena Airport",
    city: "Iquique",
    country: "Chile",
    lat: -20.535200119018555,
    lng: -70.1812973022461,
  },
  {
    id: "SCL",
    name: "Comodoro Arturo Merino Benítez International Airport",
    city: "Santiago",
    country: "Chile",
    lat: -33.393001556396484,
    lng: -70.78579711914062,
  },
  {
    id: "ANF",
    name: "Andrés Sabella Gálvez International Airport",
    city: "Antofagasta",
    country: "Chile",
    lat: -23.444501,
    lng: -70.445099,
  },
  {
    id: "WPR",
    name: "Capitan Fuentes Martinez Airport Airport",
    city: "Porvenir",
    country: "Chile",
    lat: -53.253700256347656,
    lng: -70.31919860839844,
  },
  {
    id: "FFU",
    name: "Futaleufú Airport",
    city: "Futaleufu",
    country: "Chile",
    lat: -43.18920135498047,
    lng: -71.8510971069336,
  },
  {
    id: "LSQ",
    name: "María Dolores Airport",
    city: "Los Angeles",
    country: "Chile",
    lat: -37.40169906616211,
    lng: -72.42539978027344,
  },
  {
    id: "WPU",
    name: "Guardiamarina Zañartu Airport",
    city: "Puerto Williams",
    country: "Chile",
    lat: -54.93109893798828,
    lng: -67.62629699707031,
  },
  {
    id: "CCP",
    name: "Carriel Sur Airport",
    city: "Concepcion",
    country: "Chile",
    lat: -36.772701,
    lng: -73.063103,
  },
  {
    id: "IPC",
    name: "Mataveri Airport",
    city: "Easter Island",
    country: "Chile",
    lat: -27.1648006439,
    lng: -109.42199707,
  },
  {
    id: "ZOS",
    name: "Cañal Bajo Carlos - Hott Siebert Airport",
    city: "Osorno",
    country: "Chile",
    lat: -40.61119842529297,
    lng: -73.06099700927734,
  },
  {
    id: "VLR",
    name: "Vallenar Airport",
    city: "Vallenar",
    country: "Chile",
    lat: -28.596399307250977,
    lng: -70.75599670410156,
  },
  {
    id: "QRC",
    name: "De La Independencia Airport",
    city: "Rancagua",
    country: "Chile",
    lat: -34.17369842529297,
    lng: -70.77570343017578,
  },
  {
    id: "TNM",
    name: "Teniente Rodolfo Marsh Martin Base",
    city: "Isla Rey Jorge",
    country: "Antarctica",
    lat: -62.1907997131,
    lng: -58.9866981506,
  },
  {
    id: "LSC",
    name: "La Florida Airport",
    city: "La Serena",
    country: "Chile",
    lat: -29.916201,
    lng: -71.199501,
  },
  {
    id: "N",
    name: "Eulogio Sánchez Airport",
    city: "Santiago",
    country: "Chile",
    lat: -33.456298828125,
    lng: -70.54669952392578,
  },
  {
    id: "PZS",
    name: "Maquehue Airport",
    city: "Temuco",
    country: "Chile",
    lat: -38.766799926758,
    lng: -72.637100219727,
  },
  {
    id: "PMC",
    name: "El Tepual Airport",
    city: "Puerto Montt",
    country: "Chile",
    lat: -41.438899993896484,
    lng: -73.09400177001953,
  },
  {
    id: "WCH",
    name: "Chaitén Airport",
    city: "Chaiten",
    country: "Chile",
    lat: -42.93280029296875,
    lng: -72.6990966796875,
  },
  {
    id: "ZAL",
    name: "Pichoy Airport",
    city: "Valdivia",
    country: "Chile",
    lat: -39.6500015259,
    lng: -73.0860977173,
  },
  {
    id: "ATF",
    name: "Chachoán Airport",
    city: "Ambato",
    country: "Ecuador",
    lat: -1.2120699882507324,
    lng: -78.57460021972656,
  },
  {
    id: "N",
    name: "Hacienda Clementina Airport",
    city: "Clementia",
    country: "Ecuador",
    lat: -1.7062699794769287,
    lng: -79.37889862060547,
  },
  {
    id: "OCC",
    name: "Francisco De Orellana Airport",
    city: "Coca",
    country: "Ecuador",
    lat: -0.4628860056400299,
    lng: -76.98680114746094,
  },
  {
    id: "CUE",
    name: "Mariscal Lamar Airport",
    city: "Cuenca",
    country: "Ecuador",
    lat: -2.88947,
    lng: -78.984398,
  },
  {
    id: "GPS",
    name: "Seymour Airport",
    city: "Galapagos",
    country: "Ecuador",
    lat: -0.45375800132751465,
    lng: -90.26589965820312,
  },
  {
    id: "GYE",
    name: "José Joaquín de Olmedo International Airport",
    city: "Guayaquil",
    country: "Ecuador",
    lat: -2.1574199199699997,
    lng: -79.88359832760001,
  },
  {
    id: "N",
    name: "Gualaquiza Airport",
    city: "Gualaquiza",
    country: "Ecuador",
    lat: -3.4232099056243896,
    lng: -78.56700134277344,
  },
  {
    id: "N",
    name: "Atahualpa Airport",
    city: "Ibarra",
    country: "Ecuador",
    lat: 0.33841899037361145,
    lng: -78.13639831542969,
  },
  {
    id: "N",
    name: "Km 192 Airport",
    city: "Km-192",
    country: "Ecuador",
    lat: 0.18420299887657166,
    lng: -79.39199829101562,
  },
  {
    id: "N",
    name: "Hacienda La Julia Airport",
    city: "La Julia",
    country: "Ecuador",
    lat: -1.7043800354003906,
    lng: -79.55229949951172,
  },
  {
    id: "LTX",
    name: "Cotopaxi International Airport",
    city: "Latacunga",
    country: "Ecuador",
    lat: -0.906833,
    lng: -78.615799,
  },
  {
    id: "MRR",
    name: "Jose Maria Velasco Ibarra Airport",
    city: "Macara",
    country: "Ecuador",
    lat: -4.37823009491,
    lng: -79.94100189210002,
  },
  {
    id: "XMS",
    name: "Coronel E Carvajal Airport",
    city: "Macas",
    country: "Ecuador",
    lat: -2.2991700172424316,
    lng: -78.12079620361328,
  },
  {
    id: "MCH",
    name: "General Manuel Serrano Airport",
    city: "Machala",
    country: "Ecuador",
    lat: -3.2689,
    lng: -79.961601,
  },
  {
    id: "N",
    name: "El Carmen Airport",
    city: "Montalvo",
    country: "Ecuador",
    lat: -2.067009925842285,
    lng: -76.97570037841797,
  },
  {
    id: "MEC",
    name: "Eloy Alfaro International Airport",
    city: "Manta",
    country: "Ecuador",
    lat: -0.9460780024528503,
    lng: -80.67880249023438,
  },
  {
    id: "N",
    name: "Maragrosa Airport",
    city: "Maragrosa",
    country: "Ecuador",
    lat: -2.851099967956543,
    lng: -79.80359649658203,
  },
  {
    id: "N",
    name: "Amable Calle Gutierrez Airport",
    city: "Pasaje",
    country: "Ecuador",
    lat: -3.3196699619293213,
    lng: -79.76920318603516,
  },
  {
    id: "PVO",
    name: "Reales Tamarindos Airport",
    city: "Portoviejo",
    country: "Ecuador",
    lat: -1.0416500568389893,
    lng: -80.47219848632812,
  },
  {
    id: "N",
    name: "Quevedo Airport",
    city: "Quevedo",
    country: "Ecuador",
    lat: -0.9894000291824341,
    lng: -79.46510314941406,
  },
  {
    id: "UIO",
    name: "Mariscal Sucre International Airport",
    city: "Quito",
    country: "Ecuador",
    lat: -0.129166666667,
    lng: -78.3575,
  },
  {
    id: "N",
    name: "Chimborazo Airport",
    city: "Riobamba",
    country: "Ecuador",
    lat: -1.6534299850463867,
    lng: -78.65609741210938,
  },
  {
    id: "ETR",
    name: "Santa Rosa International Airport",
    city: "Santa Rosa",
    country: "Ecuador",
    lat: -3.441986,
    lng: -79.996957,
  },
  {
    id: "SNC",
    name: "General Ulpiano Paez Airport",
    city: "Salinas",
    country: "Ecuador",
    lat: -2.20499,
    lng: -80.988899,
  },
  {
    id: "N",
    name: "Santo Domingo de Los Colorados Airport",
    city: "Santo Domingo",
    country: "Ecuador",
    lat: -0.2482219934463501,
    lng: -79.21440124511719,
  },
  {
    id: "N",
    name: "Taura Airport",
    city: "Taura",
    country: "Ecuador",
    lat: -2.261039972305298,
    lng: -79.6801986694336,
  },
  {
    id: "N",
    name: "Mayor Galo Torres Airport",
    city: "Tena",
    country: "Ecuador",
    lat: -0.9867669939994812,
    lng: -77.81950378417969,
  },
  {
    id: "TPC",
    name: "Tarapoa Airport",
    city: "Tarapoa",
    country: "Ecuador",
    lat: -0.12295600026845932,
    lng: -76.33779907226562,
  },
  {
    id: "TUA",
    name: "Teniente Coronel Luis a Mantilla Airport",
    city: "Tulcan",
    country: "Ecuador",
    lat: 0.8095059990882874,
    lng: -77.70809936523438,
  },
  {
    id: "ASU",
    name: "Silvio Pettirossi International Airport",
    city: "Asuncion",
    country: "Paraguay",
    lat: -25.239999771118164,
    lng: -57.52000045776367,
  },
  {
    id: "AYO",
    name: "Juan De Ayolas Airport",
    city: "Ayolas",
    country: "Paraguay",
    lat: -27.370554,
    lng: -56.854064,
  },
  {
    id: "CIO",
    name: "Teniente Col Carmelo Peralta Airport",
    city: "Conception",
    country: "Paraguay",
    lat: -23.442363,
    lng: -57.427253,
  },
  {
    id: "N",
    name: "Itaipú Airport",
    city: "Itaipu",
    country: "Paraguay",
    lat: -25.407519,
    lng: -54.619377,
  },
  {
    id: "ESG",
    name: "Dr. Luis Maria Argaña International Airport",
    city: "Mariscal Estigarribia",
    country: "Paraguay",
    lat: -22.049999237060547,
    lng: -60.619998931884766,
  },
  {
    id: "PIL",
    name: "Carlos Miguel Gimenez Airport",
    city: "Pilar",
    country: "Paraguay",
    lat: -26.881224,
    lng: -58.318026,
  },
  {
    id: "AXM",
    name: "El Eden Airport",
    city: "Armenia",
    country: "Colombia",
    lat: 4.45278,
    lng: -75.7664,
  },
  {
    id: "PUU",
    name: "Tres De Mayo Airport",
    city: "Puerto Asis",
    country: "Colombia",
    lat: 0.505228,
    lng: -76.5008,
  },
  {
    id: "ELB",
    name: "Las Flores Airport",
    city: "El Banco",
    country: "Colombia",
    lat: 9.04554,
    lng: -73.9749,
  },
  {
    id: "BGA",
    name: "Palonegro Airport",
    city: "Bucaramanga",
    country: "Colombia",
    lat: 7.1265,
    lng: -73.1848,
  },
  {
    id: "BOG",
    name: "El Dorado International Airport",
    city: "Bogota",
    country: "Colombia",
    lat: 4.70159,
    lng: -74.1469,
  },
  {
    id: "BAQ",
    name: "Ernesto Cortissoz International Airport",
    city: "Barranquilla",
    country: "Colombia",
    lat: 10.8896,
    lng: -74.7808,
  },
  {
    id: "BSC",
    name: "José Celestino Mutis Airport",
    city: "Bahia Solano",
    country: "Colombia",
    lat: 6.20292,
    lng: -77.3947,
  },
  {
    id: "BUN",
    name: "Gerardo Tobar López Airport",
    city: "Buenaventura",
    country: "Colombia",
    lat: 3.81963,
    lng: -76.9898,
  },
  {
    id: "CUC",
    name: "Camilo Daza International Airport",
    city: "Cucuta",
    country: "Colombia",
    lat: 7.92757,
    lng: -72.5115,
  },
  {
    id: "CTG",
    name: "Rafael Nuñez International Airport",
    city: "Cartagena",
    country: "Colombia",
    lat: 10.4424,
    lng: -75.513,
  },
  {
    id: "CLO",
    name: "Alfonso Bonilla Aragon International Airport",
    city: "Cali",
    country: "Colombia",
    lat: 3.54322,
    lng: -76.3816,
  },
  {
    id: "TCO",
    name: "La Florida Airport",
    city: "Tumaco",
    country: "Colombia",
    lat: 1.81442,
    lng: -78.7492,
  },
  {
    id: "CZU",
    name: "Las Brujas Airport",
    city: "Corozal",
    country: "Colombia",
    lat: 9.33274,
    lng: -75.2856,
  },
  {
    id: "EJA",
    name: "Yariguíes Airport",
    city: "Barrancabermeja",
    country: "Colombia",
    lat: 7.02433,
    lng: -73.8068,
  },
  {
    id: "FLA",
    name: "Gustavo Artunduaga Paredes Airport",
    city: "Florencia",
    country: "Colombia",
    lat: 1.58919,
    lng: -75.5644,
  },
  {
    id: "GIR",
    name: "Santiago Vila Airport",
    city: "Girardot",
    country: "Colombia",
    lat: 4.27624,
    lng: -74.7967,
  },
  {
    id: "GPI",
    name: "Juan Casiano Airport",
    city: "Guapi",
    country: "Colombia",
    lat: 2.57013,
    lng: -77.8986,
  },
  {
    id: "N",
    name: "Guaymaral Airport",
    city: "Guaymaral",
    country: "Colombia",
    lat: 4.81233,
    lng: -74.0649,
  },
  {
    id: "IBE",
    name: "Perales Airport",
    city: "Ibague",
    country: "Colombia",
    lat: 4.42161,
    lng: -75.1333,
  },
  {
    id: "IPI",
    name: "San Luis Airport",
    city: "Ipiales",
    country: "Colombia",
    lat: 0.861925,
    lng: -77.6718,
  },
  {
    id: "APO",
    name: "Antonio Roldan Betancourt Airport",
    city: "Carepa",
    country: "Colombia",
    lat: 7.81196,
    lng: -76.7164,
  },
  {
    id: "MCJ",
    name: "Jorge Isaac Airport",
    city: "La Mina",
    country: "Colombia",
    lat: 11.2325,
    lng: -72.4901,
  },
  {
    id: "LET",
    name: "Alfredo Vásquez Cobo International Airport",
    city: "Leticia",
    country: "Colombia",
    lat: -4.19355,
    lng: -69.9432,
  },
  {
    id: "EOH",
    name: "Enrique Olaya Herrera Airport",
    city: "Medellin",
    country: "Colombia",
    lat: 6.220549,
    lng: -75.590582,
  },
  {
    id: "MGN",
    name: "Baracoa Airport",
    city: "Magangue",
    country: "Colombia",
    lat: 9.28474,
    lng: -74.8461,
  },
  {
    id: "MTR",
    name: "Los Garzones Airport",
    city: "Monteria",
    country: "Colombia",
    lat: 8.82374,
    lng: -75.8258,
  },
  {
    id: "MVP",
    name: "Fabio Alberto Leon Bentley Airport",
    city: "Mitu",
    country: "Colombia",
    lat: 1.25366,
    lng: -70.2339,
  },
  {
    id: "MZL",
    name: "La Nubia Airport",
    city: "Manizales",
    country: "Colombia",
    lat: 5.0296,
    lng: -75.4647,
  },
  {
    id: "NVA",
    name: "Benito Salas Airport",
    city: "Neiva",
    country: "Colombia",
    lat: 2.95015,
    lng: -75.294,
  },
  {
    id: "OCV",
    name: "Aguas Claras Airport",
    city: "Ocana",
    country: "Colombia",
    lat: 8.31506,
    lng: -73.3583,
  },
  {
    id: "OTU",
    name: "Otu Airport",
    city: "Otu",
    country: "Colombia",
    lat: 7.01037,
    lng: -74.7155,
  },
  {
    id: "N",
    name: "Puerto Bolívar Airport",
    city: "Puerto Bolivar",
    country: "Colombia",
    lat: 12.2215,
    lng: -71.9848,
  },
  {
    id: "PCR",
    name: "German Olano Airport",
    city: "Puerto Carreno",
    country: "Colombia",
    lat: 6.18472,
    lng: -67.4932,
  },
  {
    id: "PEI",
    name: "Matecaña International Airport",
    city: "Pereira",
    country: "Colombia",
    lat: 4.81267,
    lng: -75.7395,
  },
  {
    id: "PTX",
    name: "Pitalito Airport",
    city: "Pitalito",
    country: "Colombia",
    lat: 1.85777,
    lng: -76.0857,
  },
  {
    id: "PPN",
    name: "Guillermo León Valencia Airport",
    city: "Popayan",
    country: "Colombia",
    lat: 2.4544,
    lng: -76.6093,
  },
  {
    id: "PSO",
    name: "Antonio Narino Airport",
    city: "Pasto",
    country: "Colombia",
    lat: 1.39625,
    lng: -77.2915,
  },
  {
    id: "PVA",
    name: "El Embrujo Airport",
    city: "Providencia",
    country: "Colombia",
    lat: 13.3569,
    lng: -81.3583,
  },
  {
    id: "MQU",
    name: "Mariquita Airport",
    city: "Mariquita",
    country: "Colombia",
    lat: 5.21256,
    lng: -74.8836,
  },
  {
    id: "MDE",
    name: "Jose Maria Córdova International Airport",
    city: "Rio Negro",
    country: "Colombia",
    lat: 6.16454,
    lng: -75.4231,
  },
  {
    id: "RCH",
    name: "Almirante Padilla Airport",
    city: "Rio Hacha",
    country: "Colombia",
    lat: 11.5262,
    lng: -72.926,
  },
  {
    id: "SJE",
    name: "Jorge E. Gonzalez Torres Airport",
    city: "San Jose Del Guaviare",
    country: "Colombia",
    lat: 2.57969,
    lng: -72.6394,
  },
  {
    id: "SMR",
    name: "Simón Bolívar International Airport",
    city: "Santa Marta",
    country: "Colombia",
    lat: 11.1196,
    lng: -74.2306,
  },
  {
    id: "ADZ",
    name: "Gustavo Rojas Pinilla International Airport",
    city: "San Andres Island",
    country: "Colombia",
    lat: 12.5836,
    lng: -81.7112,
  },
  {
    id: "SVI",
    name: "Eduardo Falla Solano Airport",
    city: "San Vincente De Caguan",
    country: "Colombia",
    lat: 2.15217,
    lng: -74.7663,
  },
  {
    id: "TME",
    name: "Gustavo Vargas Airport",
    city: "Tame",
    country: "Colombia",
    lat: 6.45108,
    lng: -71.7603,
  },
  {
    id: "AUC",
    name: "Santiago Perez Airport",
    city: "Arauca",
    country: "Colombia",
    lat: 7.06888,
    lng: -70.7369,
  },
  {
    id: "UIB",
    name: "El Caraño Airport",
    city: "Quibdo",
    country: "Colombia",
    lat: 5.69076,
    lng: -76.6412,
  },
  {
    id: "ULQ",
    name: "Heriberto Gíl Martínez Airport",
    city: "Tulua",
    country: "Colombia",
    lat: 4.08836,
    lng: -76.2351,
  },
  {
    id: "VUP",
    name: "Alfonso López Pumarejo Airport",
    city: "Valledupar",
    country: "Colombia",
    lat: 10.435,
    lng: -73.2495,
  },
  {
    id: "VVC",
    name: "Vanguardia Airport",
    city: "Villavicencio",
    country: "Colombia",
    lat: 4.16787,
    lng: -73.6138,
  },
  {
    id: "BJO",
    name: "Bermejo Airport",
    city: "Bermejo",
    country: "Bolivia",
    lat: -22.7733001709,
    lng: -64.31289672850001,
  },
  {
    id: "CBB",
    name: "Jorge Wilsterman International Airport",
    city: "Cochabamba",
    country: "Bolivia",
    lat: -17.421100616455078,
    lng: -66.1771011352539,
  },
  {
    id: "CCA",
    name: "Chimore Airport",
    city: "Chapacura",
    country: "Bolivia",
    lat: -16.976834,
    lng: -65.145568,
  },
  {
    id: "CIJ",
    name: "Capitán Aníbal Arab Airport",
    city: "Cobija",
    country: "Bolivia",
    lat: -11.040399551400002,
    lng: -68.7829971313,
  },
  {
    id: "LPB",
    name: "El Alto International Airport",
    city: "La Paz",
    country: "Bolivia",
    lat: -16.5132999420166,
    lng: -68.19229888916016,
  },
  {
    id: "ORU",
    name: "Juan Mendoza Airport",
    city: "Oruro",
    country: "Bolivia",
    lat: -17.962600708,
    lng: -67.0762023926,
  },
  {
    id: "POI",
    name: "Capitan Nicolas Rojas Airport",
    city: "Potosi",
    country: "Bolivia",
    lat: -19.5431003571,
    lng: -65.72370147710001,
  },
  {
    id: "PSZ",
    name: "Capitán Av. Salvador Ogaya G. airport",
    city: "Puerto Suarez",
    country: "Bolivia",
    lat: -18.975301,
    lng: -57.820599,
  },
  {
    id: "SBL",
    name: "Santa Ana Del Yacuma Airport",
    city: "Santa Ana",
    country: "Bolivia",
    lat: -13.762200355500001,
    lng: -65.4352035522,
  },
  {
    id: "SRE",
    name: "Juana Azurduy De Padilla Airport",
    city: "Sucre",
    country: "Bolivia",
    lat: -19.007099151611328,
    lng: -65.2886962890625,
  },
  {
    id: "TJA",
    name: "Capitan Oriel Lea Plaza Airport",
    city: "Tarija",
    country: "Bolivia",
    lat: -21.5557003021,
    lng: -64.7013015747,
  },
  {
    id: "TDD",
    name: "Teniente Av. Jorge Henrich Arauz Airport",
    city: "Trinidad",
    country: "Bolivia",
    lat: -14.8186998367,
    lng: -64.9179992676,
  },
  {
    id: "VLM",
    name: "Teniente Coronel Rafael Pabón Airport",
    city: "Villa Montes",
    country: "Bolivia",
    lat: -21.255199432399998,
    lng: -63.4056015015,
  },
  {
    id: "VVI",
    name: "Viru Viru International Airport",
    city: "Santa Cruz",
    country: "Bolivia",
    lat: -17.6448,
    lng: -63.135399,
  },
  {
    id: "BYC",
    name: "Yacuiba Airport",
    city: "Yacuiba",
    country: "Bolivia",
    lat: -21.960899353027344,
    lng: -63.65169906616211,
  },
  {
    id: "PBM",
    name: "Johan Adolf Pengel International Airport",
    city: "Zandery",
    country: "Suriname",
    lat: 5.4528298377999995,
    lng: -55.1878013611,
  },
  {
    id: "CAY",
    name: "Cayenne-Rochambeau Airport",
    city: "Cayenne",
    country: "French Guiana",
    lat: 4.819809913639999,
    lng: -52.360401153599994,
  },
  {
    id: "OYP",
    name: "Saint-Georges-de-l'Oyapock Airport",
    city: "St.-georges Oyapock",
    country: "French Guiana",
    lat: 3.89759993553,
    lng: -51.8041000366,
  },
  {
    id: "N",
    name: "Huancabamba Airport",
    city: "Huancabamba",
    country: "Peru",
    lat: -5.256770133972168,
    lng: -79.44290161132812,
  },
  {
    id: "AOP",
    name: "Alferez FAP Alfredo Vladimir Sara Bauer Airport",
    city: "Andoas",
    country: "Peru",
    lat: -2.79612994194,
    lng: -76.46659851070001,
  },
  {
    id: "N",
    name: "Teniente General Gerardo Pérez Pinedo Airport",
    city: "Atalaya",
    country: "Peru",
    lat: -10.7291002274,
    lng: -73.7665023804,
  },
  {
    id: "IBP",
    name: "Iberia Airport",
    city: "Iberia",
    country: "Peru",
    lat: -11.411600112915039,
    lng: -69.48870086669922,
  },
  {
    id: "PCL",
    name: "Cap FAP David Abenzur Rengifo International Airport",
    city: "Pucallpa",
    country: "Peru",
    lat: -8.37794017791748,
    lng: -74.57430267333984,
  },
  {
    id: "CHM",
    name: "Teniente FAP Jaime A De Montreuil Morales Airport",
    city: "Chimbote",
    country: "Peru",
    lat: -9.149609565734863,
    lng: -78.5238037109375,
  },
  {
    id: "N",
    name: "Puerto Esperanza Airport",
    city: "Puerto Esperanza",
    country: "Peru",
    lat: -9.7681303024292,
    lng: -70.70649719238281,
  },
  {
    id: "N",
    name: "Cesar Torke Podesta Airport",
    city: "Moquegua",
    country: "Peru",
    lat: -17.179000854492188,
    lng: -70.93080139160156,
  },
  {
    id: "CIX",
    name: "Capitan FAP Jose A Quinones Gonzales International Airport",
    city: "Chiclayo",
    country: "Peru",
    lat: -6.787479877471924,
    lng: -79.8281021118164,
  },
  {
    id: "AYP",
    name: "Coronel FAP Alfredo Mendivil Duarte Airport",
    city: "Ayacucho",
    country: "Peru",
    lat: -13.154800415039062,
    lng: -74.20439910888672,
  },
  {
    id: "ANS",
    name: "Andahuaylas Airport",
    city: "Andahuaylas",
    country: "Peru",
    lat: -13.706399917602539,
    lng: -73.35040283203125,
  },
  {
    id: "ATA",
    name: "Comandante FAP German Arias Graziani Airport",
    city: "Anta",
    country: "Peru",
    lat: -9.347439765930176,
    lng: -77.59839630126953,
  },
  {
    id: "LIM",
    name: "Jorge Chávez International Airport",
    city: "Lima",
    country: "Peru",
    lat: -12.0219,
    lng: -77.114305,
  },
  {
    id: "JJI",
    name: "Juanjui Airport",
    city: "Juanjui",
    country: "Peru",
    lat: -7.169099807739258,
    lng: -76.72859954833984,
  },
  {
    id: "JAU",
    name: "Francisco Carle Airport",
    city: "Jauja",
    country: "Peru",
    lat: -11.7831001282,
    lng: -75.47339630130001,
  },
  {
    id: "JUL",
    name: "Inca Manco Capac International Airport",
    city: "Juliaca",
    country: "Peru",
    lat: -15.467100143432617,
    lng: -70.158203125,
  },
  {
    id: "ILQ",
    name: "Ilo Airport",
    city: "Ilo",
    country: "Peru",
    lat: -17.69499969482422,
    lng: -71.34400177001953,
  },
  {
    id: "N",
    name: "Las Palmas Air Base",
    city: "Las Palmas",
    country: "Peru",
    lat: -12.16069984436,
    lng: -76.998901367188,
  },
  {
    id: "TBP",
    name: "Capitan FAP Pedro Canga Rodriguez Airport",
    city: "Tumbes",
    country: "Peru",
    lat: -3.55253005027771,
    lng: -80.38140106201172,
  },
  {
    id: "YMS",
    name: "Moises Benzaquen Rengifo Airport",
    city: "Yurimaguas",
    country: "Peru",
    lat: -5.893770217895508,
    lng: -76.11820220947266,
  },
  {
    id: "N",
    name: "Collique Airport",
    city: "Collique",
    country: "Peru",
    lat: -11.92870044708252,
    lng: -77.06109619140625,
  },
  {
    id: "CHH",
    name: "Chachapoyas Airport",
    city: "Chachapoyas",
    country: "Peru",
    lat: -6.201809883117676,
    lng: -77.8561019897461,
  },
  {
    id: "IQT",
    name: "Coronel FAP Francisco Secada Vignetta International Airport",
    city: "Iquitos",
    country: "Peru",
    lat: -3.7847399711608887,
    lng: -73.30879974365234,
  },
  {
    id: "AQP",
    name: "Rodríguez Ballón International Airport",
    city: "Arequipa",
    country: "Peru",
    lat: -16.3411006927,
    lng: -71.5830993652,
  },
  {
    id: "N",
    name: "Capitán FAP Leonardo Alvariño Herr Airport",
    city: "San Ramon",
    country: "Peru",
    lat: -11.128600120544434,
    lng: -75.35050201416016,
  },
  {
    id: "TRU",
    name: "Capitan FAP Carlos Martinez De Pinillos International Airport",
    city: "Trujillo",
    country: "Peru",
    lat: -8.08141040802002,
    lng: -79.10880279541016,
  },
  {
    id: "PIO",
    name: "Capitán FAP Renán Elías Olivera International Airport",
    city: "Pisco",
    country: "Peru",
    lat: -13.74489974975586,
    lng: -76.22029876708984,
  },
  {
    id: "TPP",
    name: "Cadete FAP Guillermo Del Castillo Paredes Airport",
    city: "Tarapoto",
    country: "Peru",
    lat: -6.508739948272705,
    lng: -76.37319946289062,
  },
  {
    id: "TCQ",
    name: "Coronel FAP Carlos Ciriani Santa Rosa International Airport",
    city: "Tacna",
    country: "Peru",
    lat: -18.053300857500002,
    lng: -70.2758026123,
  },
  {
    id: "PEM",
    name: "Padre Aldamiz International Airport",
    city: "Puerto Maldonado",
    country: "Peru",
    lat: -12.6135997772,
    lng: -69.2285995483,
  },
  {
    id: "PIU",
    name: "Capitán FAP Guillermo Concha Iberico International Airport",
    city: "Piura",
    country: "Peru",
    lat: -5.20574998856,
    lng: -80.61640167239999,
  },
  {
    id: "TYL",
    name: "Capitan Montes Airport",
    city: "Talara",
    country: "Peru",
    lat: -4.5766401290894,
    lng: -81.254096984863,
  },
  {
    id: "CUZ",
    name: "Alejandro Velasco Astete International Airport",
    city: "Cuzco",
    country: "Peru",
    lat: -13.535699844400002,
    lng: -71.9387969971,
  },
  {
    id: "N",
    name: "Angel S Adami Airport",
    city: "Montevideo",
    country: "Uruguay",
    lat: -34.7892,
    lng: -56.264702,
  },
  {
    id: "DZO",
    name: "Santa Bernardina International Airport",
    city: "Durazno",
    country: "Uruguay",
    lat: -33.3588981628418,
    lng: -56.49919891357422,
  },
  {
    id: "MVD",
    name: "Carrasco International /General C L Berisso Airport",
    city: "Montevideo",
    country: "Uruguay",
    lat: -34.838402,
    lng: -56.0308,
  },
  {
    id: "STY",
    name: "Nueva Hesperides International Airport",
    city: "Salto",
    country: "Uruguay",
    lat: -31.438499450683594,
    lng: -57.98529815673828,
  },
  {
    id: "AGV",
    name: "Oswaldo Guevara Mujica Airport",
    city: "Acarigua",
    country: "Venezuela",
    lat: 9.553375244140625,
    lng: -69.23786926269531,
  },
  {
    id: "AAO",
    name: "Anaco Airport",
    city: "Anaco",
    country: "Venezuela",
    lat: 9.430225372314453,
    lng: -64.4707260131836,
  },
  {
    id: "N",
    name: "San Fernando de Atabapo Airport",
    city: "San Fernando Deatabapo",
    country: "Venezuela",
    lat: 4.05104017258,
    lng: -67.6996994019,
  },
  {
    id: "BLA",
    name: "General José Antonio Anzoategui International Airport",
    city: "Barcelona",
    country: "Venezuela",
    lat: 10.111111,
    lng: -64.692222,
  },
  {
    id: "BNS",
    name: "Barinas Airport",
    city: "Barinas",
    country: "Venezuela",
    lat: 8.615,
    lng: -70.21416667,
  },
  {
    id: "N",
    name: "El Libertador Airbase",
    city: "Maracaibo",
    country: "Venezuela",
    lat: 10.183375358600001,
    lng: -67.55731964110001,
  },
  {
    id: "BRM",
    name: "Barquisimeto International Airport",
    city: "Barquisimeto",
    country: "Venezuela",
    lat: 10.042746543884277,
    lng: -69.3586196899414,
  },
  {
    id: "CBL",
    name: 'Aeropuerto "General Tomas de Heres". Ciudad Bolivar',
    city: "Ciudad Bolivar",
    country: "Venezuela",
    lat: 8.12216091156,
    lng: -63.5369567871,
  },
  {
    id: "CXA",
    name: "Caicara del Orinoco Airport",
    city: "Caicara De Orinoco",
    country: "Venezuela",
    lat: 7.625510215759277,
    lng: -66.16280364990234,
  },
  {
    id: "N",
    name: "San Carlos Airport",
    city: "San Carlos",
    country: "Venezuela",
    lat: 9.647720336914062,
    lng: -68.57469940185547,
  },
  {
    id: "CLZ",
    name: "Calabozo Airport",
    city: "Calabozo",
    country: "Venezuela",
    lat: 8.92465591430664,
    lng: -67.4170913696289,
  },
  {
    id: "CAJ",
    name: "Canaima Airport",
    city: "Canaima",
    country: "Venezuela",
    lat: 6.231988906860352,
    lng: -62.85443115234375,
  },
  {
    id: "VCR",
    name: "Carora Airport",
    city: "Carora",
    country: "Venezuela",
    lat: 10.175602912902832,
    lng: -70.06521606445312,
  },
  {
    id: "CUP",
    name: "General Francisco Bermúdez Airport",
    city: "Carupano",
    country: "Venezuela",
    lat: 10.660014152526855,
    lng: -63.261680603027344,
  },
  {
    id: "CZE",
    name: "José Leonardo Chirinos Airport",
    city: "Coro",
    country: "Venezuela",
    lat: 11.41494369506836,
    lng: -69.68090057373047,
  },
  {
    id: "N",
    name: "Oscar Machado Zuluaga Airport",
    city: "Caracas",
    country: "Venezuela",
    lat: 10.286110877990723,
    lng: -66.81610870361328,
  },
  {
    id: "CUM",
    name: "Cumaná (Antonio José de Sucre) Airport",
    city: "Cumana",
    country: "Venezuela",
    lat: 10.450332641601562,
    lng: -64.1304702758789,
  },
  {
    id: "N",
    name: "Capitán Manuel Ríos Airbase",
    city: "Carrizal",
    country: "Venezuela",
    lat: 9.372650146484375,
    lng: -66.92279815673828,
  },
  {
    id: "EOR",
    name: "El Dorado Airport",
    city: "El Dorado",
    country: "Venezuela",
    lat: 6.733333110809326,
    lng: -61.58333206176758,
  },
  {
    id: "EOZ",
    name: "Elorza Airport",
    city: "Elorza",
    country: "Venezuela",
    lat: 7.0833330154418945,
    lng: -69.53333282470703,
  },
  {
    id: "GDO",
    name: "Guasdalito Airport",
    city: "Guasdualito",
    country: "Venezuela",
    lat: 7.233333110809326,
    lng: -70.80000305175781,
  },
  {
    id: "GUI",
    name: "Guiria Airport",
    city: "Guiria",
    country: "Venezuela",
    lat: 10.574077606200001,
    lng: -62.3126678467,
  },
  {
    id: "GUQ",
    name: "Guanare Airport",
    city: "Guanare",
    country: "Venezuela",
    lat: 9.026944160461426,
    lng: -69.7551498413086,
  },
  {
    id: "HGE",
    name: "Higuerote Airport",
    city: "Higuerote",
    country: "Venezuela",
    lat: 10.462474,
    lng: -66.092779,
  },
  {
    id: "ICC",
    name: "Andrés Miguel Salazar Marcano Airport",
    city: "Isla De Coche",
    country: "Venezuela",
    lat: 10.794432,
    lng: -63.98159,
  },
  {
    id: "LSP",
    name: "Josefa Camejo International Airport",
    city: "Paraguana",
    country: "Venezuela",
    lat: 11.78077507019043,
    lng: -70.15149688720703,
  },
  {
    id: "N",
    name: "San Juan de Los Morros Airport",
    city: "San Juan De Los Morros",
    country: "Venezuela",
    lat: 9.906952857971191,
    lng: -67.379638671875,
  },
  {
    id: "LFR",
    name: "La Fria Airport",
    city: "La Fria",
    country: "Venezuela",
    lat: 8.239167213439941,
    lng: -72.27102661132812,
  },
  {
    id: "N",
    name: "La Orchila Airport",
    city: "La Orchila",
    country: "Venezuela",
    lat: 11.80720043182373,
    lng: -66.17960357666016,
  },
  {
    id: "MAR",
    name: "La Chinita International Airport",
    city: "Maracaibo",
    country: "Venezuela",
    lat: 10.5582084656,
    lng: -71.7278594971,
  },
  {
    id: "MRD",
    name: "Alberto Carnevalli Airport",
    city: "Merida",
    country: "Venezuela",
    lat: 8.582078,
    lng: -71.161041,
  },
  {
    id: "PMV",
    name: "Del Caribe Santiago Mariño International Airport",
    city: "Porlamar",
    country: "Venezuela",
    lat: 10.912603378295898,
    lng: -63.96659851074219,
  },
  {
    id: "CCS",
    name: "Simón Bolívar International Airport",
    city: "Caracas",
    country: "Venezuela",
    lat: 10.601194,
    lng: -66.991222,
  },
  {
    id: "MUN",
    name: "Maturín Airport",
    city: "Maturin",
    country: "Venezuela",
    lat: 9.75452995300293,
    lng: -63.14739990234375,
  },
  {
    id: "PYH",
    name: "Cacique Aramare Airport",
    city: "Puerto Ayacucho",
    country: "Venezuela",
    lat: 5.6199898719788,
    lng: -67.606101989746,
  },
  {
    id: "PBL",
    name: "General Bartolome Salom International Airport",
    city: "Puerto Cabello",
    country: "Venezuela",
    lat: 10.480500221252441,
    lng: -68.072998046875,
  },
  {
    id: "SCI",
    name: "Paramillo Airport",
    city: "San Cristobal",
    country: "Venezuela",
    lat: 7.8013200759887695,
    lng: -72.2029037475586,
  },
  {
    id: "PZO",
    name: "General Manuel Carlos Piar International Airport",
    city: "Guayana",
    country: "Venezuela",
    lat: 8.288530349731445,
    lng: -62.760398864746094,
  },
  {
    id: "PTM",
    name: "Palmarito Airport",
    city: "Palmarito",
    country: "Venezuela",
    lat: 7.566669940948486,
    lng: -70.18329620361328,
  },
  {
    id: "SVZ",
    name: "San Antonio Del Tachira Airport",
    city: "San Antonio",
    country: "Venezuela",
    lat: 7.840829849243164,
    lng: -72.439697265625,
  },
  {
    id: "SBB",
    name: "Santa Bárbara de Barinas Airport",
    city: "Santa Barbara",
    country: "Venezuela",
    lat: 7.803514003753662,
    lng: -71.16571807861328,
  },
  {
    id: "SNV",
    name: "Santa Elena de Uairen Airport",
    city: "Santa Ana De Uairen",
    country: "Venezuela",
    lat: 4.554999828338623,
    lng: -61.150001525878906,
  },
  {
    id: "STD",
    name: "Mayor Buenaventura Vivas International Airport",
    city: "Santo Domingo",
    country: "Venezuela",
    lat: 7.56538,
    lng: -72.035103,
  },
  {
    id: "SNF",
    name: "Sub Teniente Nestor Arias Airport",
    city: "San Felipe",
    country: "Venezuela",
    lat: 10.2787,
    lng: -68.755203,
  },
  {
    id: "SFD",
    name: "San Fernando De Apure Airport",
    city: "San Fernando De Apure",
    country: "Venezuela",
    lat: 7.883319854736328,
    lng: -67.44400024414062,
  },
  {
    id: "SOM",
    name: "San Tomé Airport",
    city: "San Tome",
    country: "Venezuela",
    lat: 8.9451465606689,
    lng: -64.151084899902,
  },
  {
    id: "STB",
    name: "Santa Bárbara del Zulia Airport",
    city: "Santa Barbara",
    country: "Venezuela",
    lat: 8.974550247192383,
    lng: -71.94325256347656,
  },
  {
    id: "TUV",
    name: "Tucupita Airport",
    city: "Tucupita",
    country: "Venezuela",
    lat: 9.088994026184082,
    lng: -62.094173431396484,
  },
  {
    id: "TMO",
    name: "Tumeremo Airport",
    city: "Tumeremo",
    country: "Venezuela",
    lat: 7.24938,
    lng: -61.52893,
  },
  {
    id: "VLN",
    name: "Arturo Michelena International Airport",
    city: "Valencia",
    country: "Venezuela",
    lat: 10.14973258972168,
    lng: -67.92839813232422,
  },
  {
    id: "VLV",
    name: "Dr. Antonio Nicolás Briceño Airport",
    city: "Valera",
    country: "Venezuela",
    lat: 9.34047794342041,
    lng: -70.58406066894531,
  },
  {
    id: "VDP",
    name: "Valle de La Pascua Airport",
    city: "Valle De La Pascua",
    country: "Venezuela",
    lat: 9.22202777863,
    lng: -65.9935836792,
  },
  {
    id: "N",
    name: "Linden Airport",
    city: "Linden",
    country: "Guyana",
    lat: 5.96592,
    lng: -58.270302,
  },
  {
    id: "LTM",
    name: "Lethem Airport",
    city: "Lethem",
    country: "Guyana",
    lat: 3.37276,
    lng: -59.789398,
  },
  {
    id: "ANU",
    name: "V.C. Bird International Airport",
    city: "Antigua",
    country: "Antigua and Barbuda",
    lat: 17.1367,
    lng: -61.792702,
  },
  {
    id: "BGI",
    name: "Sir Grantley Adams International Airport",
    city: "Bridgetown",
    country: "Barbados",
    lat: 13.0746002197,
    lng: -59.4925003052,
  },
  {
    id: "DCF",
    name: "Canefield Airport",
    city: "Canefield",
    country: "Dominica",
    lat: 15.336700439453125,
    lng: -61.3922004699707,
  },
  {
    id: "DOM",
    name: "Douglas-Charles Airport",
    city: "Dominica",
    country: "Dominica",
    lat: 15.547,
    lng: -61.299999,
  },
  {
    id: "FDF",
    name: "Martinique Aimé Césaire International Airport",
    city: "Fort-de-france",
    country: "Martinique",
    lat: 14.590999603271484,
    lng: -61.00320053100586,
  },
  {
    id: "SFG",
    name: "L'Espérance Airport",
    city: "St. Martin",
    country: "Guadeloupe",
    lat: 18.099899291992,
    lng: -63.047199249268,
  },
  {
    id: "PTP",
    name: "Pointe-à-Pitre Le Raizet",
    city: "Pointe-a-pitre",
    country: "Guadeloupe",
    lat: 16.265301,
    lng: -61.531799,
  },
  {
    id: "GND",
    name: "Point Salines International Airport",
    city: "Point Salines",
    country: "Grenada",
    lat: 12.004199981689453,
    lng: -61.78620147705078,
  },
  {
    id: "STT",
    name: "Cyril E. King Airport",
    city: "St. Thomas",
    country: "Virgin Islands",
    lat: 18.337299346923828,
    lng: -64.97339630126953,
  },
  {
    id: "STX",
    name: "Henry E Rohlsen Airport",
    city: "St. Croix Island",
    country: "Virgin Islands",
    lat: 17.701900482177734,
    lng: -64.79859924316406,
  },
  {
    id: "BQN",
    name: "Rafael Hernandez Airport",
    city: "Aguadilla",
    country: "Puerto Rico",
    lat: 18.49489974975586,
    lng: -67.12940216064453,
  },
  {
    id: "FAJ",
    name: "Diego Jimenez Torres Airport",
    city: "Fajardo",
    country: "Puerto Rico",
    lat: 18.308900833129883,
    lng: -65.66190338134766,
  },
  {
    id: "SIG",
    name: "Fernando Luis Ribas Dominicci Airport",
    city: "San Juan",
    country: "Puerto Rico",
    lat: 18.45680046081543,
    lng: -66.09809875488281,
  },
  {
    id: "MAZ",
    name: "Eugenio Maria De Hostos Airport",
    city: "Mayaguez",
    country: "Puerto Rico",
    lat: 18.255699157714844,
    lng: -67.14849853515625,
  },
  {
    id: "PSE",
    name: "Mercedita Airport",
    city: "Ponce",
    country: "Puerto Rico",
    lat: 18.00830078125,
    lng: -66.56300354003906,
  },
  {
    id: "SJU",
    name: "Luis Munoz Marin International Airport",
    city: "San Juan",
    country: "Puerto Rico",
    lat: 18.4393997192,
    lng: -66.0018005371,
  },
  {
    id: "SKB",
    name: "Robert L. Bradshaw International Airport",
    city: "Basse Terre",
    country: "Saint Kitts and Nevis",
    lat: 17.311199188232422,
    lng: -62.71870040893555,
  },
  {
    id: "SLU",
    name: "George F. L. Charles Airport",
    city: "Castries",
    country: "Saint Lucia",
    lat: 14.0202,
    lng: -60.992901,
  },
  {
    id: "UVF",
    name: "Hewanorra International Airport",
    city: "Hewandorra",
    country: "Saint Lucia",
    lat: 13.7332,
    lng: -60.952599,
  },
  {
    id: "AUA",
    name: "Queen Beatrix International Airport",
    city: "Oranjestad",
    country: "Aruba",
    lat: 12.5014,
    lng: -70.015198,
  },
  {
    id: "BON",
    name: "Flamingo International Airport",
    city: "Kralendijk",
    country: "Netherlands Antilles",
    lat: 12.130999565124512,
    lng: -68.26850128173828,
  },
  {
    id: "CUR",
    name: "Hato International Airport",
    city: "Willemstad",
    country: "Netherlands Antilles",
    lat: 12.1889,
    lng: -68.959801,
  },
  {
    id: "EUX",
    name: "F. D. Roosevelt Airport",
    city: "Oranjestad",
    country: "Netherlands Antilles",
    lat: 17.49650001525879,
    lng: -62.979400634765625,
  },
  {
    id: "SXM",
    name: "Princess Juliana International Airport",
    city: "Philipsburg",
    country: "Netherlands Antilles",
    lat: 18.041000366200002,
    lng: -63.1088981628,
  },
  {
    id: "AXA",
    name: "Clayton J Lloyd International Airport",
    city: "The Valley",
    country: "Anguilla",
    lat: 18.2048,
    lng: -63.055099,
  },
  {
    id: "TAB",
    name: "Tobago-Crown Point Airport",
    city: "Scarborough",
    country: "Trinidad and Tobago",
    lat: 11.149700164794922,
    lng: -60.83219909667969,
  },
  {
    id: "POS",
    name: "Piarco International Airport",
    city: "Port-of-spain",
    country: "Trinidad and Tobago",
    lat: 10.595399856567383,
    lng: -61.33720016479492,
  },
  {
    id: "EIS",
    name: "Terrance B. Lettsome International Airport",
    city: "Tortola",
    country: "British Virgin Islands",
    lat: 18.444799423217773,
    lng: -64.54299926757812,
  },
  {
    id: "CIW",
    name: "Canouan Airport",
    city: "Canouan Island",
    country: "Saint Vincent and the Grenadines",
    lat: 12.699,
    lng: -61.3424,
  },
  {
    id: "MQS",
    name: "Mustique Airport",
    city: "Mustique",
    country: "Saint Vincent and the Grenadines",
    lat: 12.887900352478027,
    lng: -61.180198669433594,
  },
  {
    id: "SVD",
    name: "Argyle International Airport",
    city: "Kingstown",
    country: "Saint Vincent and the Grenadines",
    lat: 13.156695,
    lng: -61.149945,
  },
  {
    id: "ALA",
    name: "Almaty Airport",
    city: "Alma-ata",
    country: "Kazakhstan",
    lat: 43.35210037231445,
    lng: 77.04049682617188,
  },
  {
    id: "BXH",
    name: "Balkhash Airport",
    city: "Balkhash",
    country: "Kazakhstan",
    lat: 46.8932991027832,
    lng: 75.00499725341797,
  },
  {
    id: "TSE",
    name: "Astana International Airport",
    city: "Tselinograd",
    country: "Kazakhstan",
    lat: 51.02220153808594,
    lng: 71.46690368652344,
  },
  {
    id: "DMB",
    name: "Taraz Airport",
    city: "Dzhambul",
    country: "Kazakhstan",
    lat: 42.853599548339844,
    lng: 71.30359649658203,
  },
  {
    id: "FRU",
    name: "Manas International Airport",
    city: "Bishkek",
    country: "Kyrgyzstan",
    lat: 43.0612983704,
    lng: 74.4776000977,
  },
  {
    id: "OSS",
    name: "Osh Airport",
    city: "Osh",
    country: "Kyrgyzstan",
    lat: 40.6090011597,
    lng: 72.793296814,
  },
  {
    id: "CIT",
    name: "Shymkent Airport",
    city: "Chimkent",
    country: "Kazakhstan",
    lat: 42.364200592041016,
    lng: 69.47889709472656,
  },
  {
    id: "URA",
    name: "Uralsk Airport",
    city: "Uralsk",
    country: "Kazakhstan",
    lat: 51.15079879760742,
    lng: 51.54309844970703,
  },
  {
    id: "PWQ",
    name: "Pavlodar Airport",
    city: "Pavlodar",
    country: "Kazakhstan",
    lat: 52.19499969482422,
    lng: 77.07389831542969,
  },
  {
    id: "PLX",
    name: "Semipalatinsk Airport",
    city: "Semiplatinsk",
    country: "Kazakhstan",
    lat: 50.351295,
    lng: 80.234398,
  },
  {
    id: "AKX",
    name: "Aktobe Airport",
    city: "Aktyubinsk",
    country: "Kazakhstan",
    lat: 50.2458,
    lng: 57.206699,
  },
  {
    id: "GYD",
    name: "Heydar Aliyev International Airport",
    city: "Baku",
    country: "Azerbaijan",
    lat: 40.467498779296875,
    lng: 50.04669952392578,
  },
  {
    id: "YKS",
    name: "Yakutsk Airport",
    city: "Yakutsk",
    country: "Russia",
    lat: 62.093299865722656,
    lng: 129.77099609375,
  },
  {
    id: "MJZ",
    name: "Mirny Airport",
    city: "Mirnyj",
    country: "Russia",
    lat: 62.534698486328125,
    lng: 114.03900146484375,
  },
  {
    id: "BQS",
    name: "Ignatyevo Airport",
    city: "Blagoveschensk",
    country: "Russia",
    lat: 50.42539978027344,
    lng: 127.41200256347656,
  },
  {
    id: "KHV",
    name: "Khabarovsk-Novy Airport",
    city: "Khabarovsk",
    country: "Russia",
    lat: 48.52799987793,
    lng: 135.18800354004,
  },
  {
    id: "PVS",
    name: "Provideniya Bay Airport",
    city: "Provideniya Bay",
    country: "Russia",
    lat: 64.37809753417969,
    lng: -173.2429962158203,
  },
  {
    id: "GDX",
    name: "Sokol Airport",
    city: "Magadan",
    country: "Russia",
    lat: 59.9109992980957,
    lng: 150.72000122070312,
  },
  {
    id: "PWE",
    name: "Pevek Airport",
    city: "Pevek",
    country: "Russia",
    lat: 69.783302307129,
    lng: 170.59700012207,
  },
  {
    id: "PKC",
    name: "Yelizovo Airport",
    city: "Petropavlovsk",
    country: "Russia",
    lat: 53.16790008544922,
    lng: 158.45399475097656,
  },
  {
    id: "UUS",
    name: "Yuzhno-Sakhalinsk Airport",
    city: "Yuzhno-sakhalinsk",
    country: "Russia",
    lat: 46.88869857788086,
    lng: 142.71800231933594,
  },
  {
    id: "VVO",
    name: "Vladivostok International Airport",
    city: "Vladivostok",
    country: "Russia",
    lat: 43.39899826049805,
    lng: 132.1479949951172,
  },
  {
    id: "HTA",
    name: "Chita-Kadala Airport",
    city: "Chita",
    country: "Russia",
    lat: 52.026299,
    lng: 113.306,
  },
  {
    id: "BTK",
    name: "Bratsk Airport",
    city: "Bratsk",
    country: "Russia",
    lat: 56.370601654052734,
    lng: 101.697998046875,
  },
  {
    id: "IKT",
    name: "Irkutsk Airport",
    city: "Irkutsk",
    country: "Russia",
    lat: 52.268001556396,
    lng: 104.38899993896,
  },
  {
    id: "UUD",
    name: "Ulan-Ude Airport (Mukhino)",
    city: "Ulan-ude",
    country: "Russia",
    lat: 51.80780029296875,
    lng: 107.43800354003906,
  },
  {
    id: "KBP",
    name: "Boryspil International Airport",
    city: "Kiev",
    country: "Ukraine",
    lat: 50.345001220703125,
    lng: 30.894699096679688,
  },
  {
    id: "DOK",
    name: "Donetsk International Airport",
    city: "Donetsk",
    country: "Ukraine",
    lat: 48.07360076904297,
    lng: 37.73970031738281,
  },
  {
    id: "DNK",
    name: "Dnipropetrovsk International Airport",
    city: "Dnepropetrovsk",
    country: "Ukraine",
    lat: 48.357200622558594,
    lng: 35.10060119628906,
  },
  {
    id: "SIP",
    name: "Simferopol International Airport",
    city: "Simferopol",
    country: "Ukraine",
    lat: 45.05220031738281,
    lng: 33.975101470947266,
  },
  {
    id: "IEV",
    name: "Kiev Zhuliany International Airport",
    city: "Kiev",
    country: "Ukraine",
    lat: 50.40194,
    lng: 30.45194,
  },
  {
    id: "LWO",
    name: "Lviv International Airport",
    city: "Lvov",
    country: "Ukraine",
    lat: 49.8125,
    lng: 23.956100463867188,
  },
  {
    id: "ODS",
    name: "Odessa International Airport",
    city: "Odessa",
    country: "Ukraine",
    lat: 46.42679977416992,
    lng: 30.67650032043457,
  },
  {
    id: "LED",
    name: "Pulkovo Airport",
    city: "St. Petersburg",
    country: "Russia",
    lat: 59.80030059814453,
    lng: 30.262500762939453,
  },
  {
    id: "MMK",
    name: "Murmansk Airport",
    city: "Murmansk",
    country: "Russia",
    lat: 68.78170013427734,
    lng: 32.75080108642578,
  },
  {
    id: "GME",
    name: "Gomel Airport",
    city: "Gomel",
    country: "Belarus",
    lat: 52.527000427246094,
    lng: 31.016700744628906,
  },
  {
    id: "VTB",
    name: "Vitebsk Vostochny Airport",
    city: "Vitebsk",
    country: "Belarus",
    lat: 55.126499176025,
    lng: 30.349599838257,
  },
  {
    id: "KGD",
    name: "Khrabrovo Airport",
    city: "Kaliningrad",
    country: "Russia",
    lat: 54.88999938964844,
    lng: 20.592599868774414,
  },
  {
    id: "MHP",
    name: "Minsk 1 Airport",
    city: "Minsk",
    country: "Belarus",
    lat: 53.864498138427734,
    lng: 27.53969955444336,
  },
  {
    id: "MSQ",
    name: "Minsk National Airport",
    city: "Minsk 2",
    country: "Belarus",
    lat: 53.882499694824,
    lng: 28.030700683594,
  },
  {
    id: "ABA",
    name: "Abakan Airport",
    city: "Abakan",
    country: "Russia",
    lat: 53.7400016784668,
    lng: 91.38500213623047,
  },
  {
    id: "BAX",
    name: "Barnaul Airport",
    city: "Barnaul",
    country: "Russia",
    lat: 53.363800048828125,
    lng: 83.53849792480469,
  },
  {
    id: "KEJ",
    name: "Kemerovo Airport",
    city: "Kemorovo",
    country: "Russia",
    lat: 55.27009963989258,
    lng: 86.1072006225586,
  },
  {
    id: "OMS",
    name: "Omsk Central Airport",
    city: "Omsk",
    country: "Russia",
    lat: 54.96699905395508,
    lng: 73.31050109863281,
  },
  {
    id: "KRR",
    name: "Krasnodar Pashkovsky International Airport",
    city: "Krasnodar",
    country: "Russia",
    lat: 45.034698486328,
    lng: 39.170501708984,
  },
  {
    id: "MCX",
    name: "Uytash Airport",
    city: "Makhachkala",
    country: "Russia",
    lat: 42.81679916381836,
    lng: 47.65230178833008,
  },
  {
    id: "MRV",
    name: "Mineralnyye Vody Airport",
    city: "Mineralnye Vody",
    country: "Russia",
    lat: 44.225101470947266,
    lng: 43.08190155029297,
  },
  {
    id: "STW",
    name: "Stavropol Shpakovskoye Airport",
    city: "Stavropol",
    country: "Russia",
    lat: 45.10919952392578,
    lng: 42.11280059814453,
  },
  {
    id: "ROV",
    name: "Platov International Airport",
    city: "Rostov",
    country: "Russia",
    lat: 47.493888,
    lng: 39.924722,
  },
  {
    id: "AER",
    name: "Sochi International Airport",
    city: "Sochi",
    country: "Russia",
    lat: 43.449902,
    lng: 39.9566,
  },
  {
    id: "ASF",
    name: "Astrakhan Airport",
    city: "Astrakhan",
    country: "Russia",
    lat: 46.2832984924,
    lng: 48.0063018799,
  },
  {
    id: "VOG",
    name: "Volgograd International Airport",
    city: "Volgograd",
    country: "Russia",
    lat: 48.782501220703125,
    lng: 44.34550094604492,
  },
  {
    id: "CEK",
    name: "Chelyabinsk Balandino Airport",
    city: "Chelyabinsk",
    country: "Russia",
    lat: 55.305801,
    lng: 61.5033,
  },
  {
    id: "MQF",
    name: "Magnitogorsk International Airport",
    city: "Magnetiogorsk",
    country: "Russia",
    lat: 53.39310073852539,
    lng: 58.755699157714844,
  },
  {
    id: "NJC",
    name: "Nizhnevartovsk Airport",
    city: "Nizhnevartovsk",
    country: "Russia",
    lat: 60.94929885864258,
    lng: 76.48359680175781,
  },
  {
    id: "PEE",
    name: "Bolshoye Savino Airport",
    city: "Perm",
    country: "Russia",
    lat: 57.914501190186,
    lng: 56.021198272705,
  },
  {
    id: "SGC",
    name: "Surgut Airport",
    city: "Surgut",
    country: "Russia",
    lat: 61.34370040893555,
    lng: 73.40180206298828,
  },
  {
    id: "SVX",
    name: "Koltsovo Airport",
    city: "Yekaterinburg",
    country: "Russia",
    lat: 56.743099212646,
    lng: 60.802700042725,
  },
  {
    id: "ASB",
    name: "Ashgabat International Airport",
    city: "Ashkhabad",
    country: "Turkmenistan",
    lat: 37.986801,
    lng: 58.361,
  },
  {
    id: "KRW",
    name: "Turkmenbashi Airport",
    city: "Krasnovodsk",
    country: "Turkmenistan",
    lat: 40.063301,
    lng: 53.007198,
  },
  {
    id: "CRZ",
    name: "Turkmenabat Airport",
    city: "Chardzhou",
    country: "Turkmenistan",
    lat: 39.08330154418945,
    lng: 63.61330032348633,
  },
  {
    id: "DYU",
    name: "Dushanbe Airport",
    city: "Dushanbe",
    country: "Tajikistan",
    lat: 38.543300628699996,
    lng: 68.8249969482,
  },
  {
    id: "BHK",
    name: "Bukhara Airport",
    city: "Bukhara",
    country: "Uzbekistan",
    lat: 39.775001525878906,
    lng: 64.4832992553711,
  },
  {
    id: "SKD",
    name: "Samarkand Airport",
    city: "Samarkand",
    country: "Uzbekistan",
    lat: 39.70050048828125,
    lng: 66.98380279541016,
  },
  {
    id: "TAS",
    name: "Tashkent International Airport",
    city: "Tashkent",
    country: "Uzbekistan",
    lat: 41.257900238,
    lng: 69.2811965942,
  },
  {
    id: "BZK",
    name: "Bryansk Airport",
    city: "Bryansk",
    country: "Russia",
    lat: 53.214199,
    lng: 34.176399,
  },
  {
    id: "SVO",
    name: "Sheremetyevo International Airport",
    city: "Moscow",
    country: "Russia",
    lat: 55.972599,
    lng: 37.4146,
  },
  {
    id: "KLD",
    name: "Migalovo Air Base",
    city: "Tver",
    country: "Russia",
    lat: 56.82469940185547,
    lng: 35.7577018737793,
  },
  {
    id: "VOZ",
    name: "Voronezh International Airport",
    city: "Voronezh",
    country: "Russia",
    lat: 51.81420135498047,
    lng: 39.22959899902344,
  },
  {
    id: "VKO",
    name: "Vnukovo International Airport",
    city: "Moscow",
    country: "Russia",
    lat: 55.5914993286,
    lng: 37.2615013123,
  },
  {
    id: "SCW",
    name: "Syktyvkar Airport",
    city: "Syktyvkar",
    country: "Russia",
    lat: 61.64699935913086,
    lng: 50.84510040283203,
  },
  {
    id: "KZN",
    name: "Kazan International Airport",
    city: "Kazan",
    country: "Russia",
    lat: 55.606201171875,
    lng: 49.278701782227,
  },
  {
    id: "REN",
    name: "Orenburg Central Airport",
    city: "Orenburg",
    country: "Russia",
    lat: 51.795799255371094,
    lng: 55.45669937133789,
  },
  {
    id: "UFA",
    name: "Ufa International Airport",
    city: "Ufa",
    country: "Russia",
    lat: 54.557498931885,
    lng: 55.874401092529,
  },
  {
    id: "KUF",
    name: "Kurumoch International Airport",
    city: "Samara",
    country: "Russia",
    lat: 53.504901885986,
    lng: 50.16429901123,
  },
  {
    id: "AMD",
    name: "Sardar Vallabhbhai Patel International Airport",
    city: "Ahmedabad",
    country: "India",
    lat: 23.0771999359,
    lng: 72.63469696039999,
  },
  {
    id: "AKD",
    name: "Akola Airport",
    city: "Akola",
    country: "India",
    lat: 20.698999,
    lng: 77.058601,
  },
  {
    id: "IXU",
    name: "Aurangabad Airport",
    city: "Aurangabad",
    country: "India",
    lat: 19.862699508666992,
    lng: 75.39810180664062,
  },
  {
    id: "BOM",
    name: "Chhatrapati Shivaji International Airport",
    city: "Mumbai",
    country: "India",
    lat: 19.0886993408,
    lng: 72.8678970337,
  },
  {
    id: "PAB",
    name: "Bilaspur Airport",
    city: "Bilaspur",
    country: "India",
    lat: 21.9884,
    lng: 82.111,
  },
  {
    id: "BHJ",
    name: "Bhuj Airport",
    city: "Bhuj",
    country: "India",
    lat: 23.2877998352,
    lng: 69.6701965332,
  },
  {
    id: "IXG",
    name: "Belgaum Airport",
    city: "Belgaum",
    country: "India",
    lat: 15.859299659700001,
    lng: 74.6183013916,
  },
  {
    id: "BDQ",
    name: "Vadodara Airport",
    city: "Baroda",
    country: "India",
    lat: 22.336201,
    lng: 73.226303,
  },
  {
    id: "BHO",
    name: "Raja Bhoj International Airport",
    city: "Bhopal",
    country: "India",
    lat: 23.2875003815,
    lng: 77.3374023438,
  },
  {
    id: "BHU",
    name: "Bhavnagar Airport",
    city: "Bhaunagar",
    country: "India",
    lat: 21.752199173,
    lng: 72.1852035522,
  },
  {
    id: "NMB",
    name: "Daman Airport",
    city: "Daman",
    country: "India",
    lat: 20.43440055847168,
    lng: 72.84320068359375,
  },
  {
    id: "N",
    name: "Deesa Airport",
    city: "Deesa",
    country: "India",
    lat: 24.267900466918945,
    lng: 72.20439910888672,
  },
  {
    id: "GUX",
    name: "Guna Airport",
    city: "Guna",
    country: "India",
    lat: 24.654699,
    lng: 77.347298,
  },
  {
    id: "GOI",
    name: "Dabolim Airport",
    city: "Goa",
    country: "India",
    lat: 15.3808002472,
    lng: 73.8313980103,
  },
  {
    id: "IDR",
    name: "Devi Ahilyabai Holkar Airport",
    city: "Indore",
    country: "India",
    lat: 22.7217998505,
    lng: 75.8011016846,
  },
  {
    id: "JLR",
    name: "Jabalpur Airport",
    city: "Jabalpur",
    country: "India",
    lat: 23.177799224853516,
    lng: 80.052001953125,
  },
  {
    id: "JGA",
    name: "Jamnagar Airport",
    city: "Jamnagar",
    country: "India",
    lat: 22.465499877929688,
    lng: 70.01260375976562,
  },
  {
    id: "IXY",
    name: "Kandla Airport",
    city: "Kandla",
    country: "India",
    lat: 23.1127,
    lng: 70.100304,
  },
  {
    id: "HJR",
    name: "Khajuraho Airport",
    city: "Khajuraho",
    country: "India",
    lat: 24.817199707,
    lng: 79.91860198970001,
  },
  {
    id: "KLH",
    name: "Kolhapur Airport",
    city: "Kolhapur",
    country: "India",
    lat: 16.6646995544,
    lng: 74.2893981934,
  },
  {
    id: "IXK",
    name: "Keshod Airport",
    city: "Keshod",
    country: "India",
    lat: 21.317100524902344,
    lng: 70.27040100097656,
  },
  {
    id: "NAG",
    name: "Dr. Babasaheb Ambedkar International Airport",
    city: "Nagpur",
    country: "India",
    lat: 21.092199325561523,
    lng: 79.04720306396484,
  },
  {
    id: "ISK",
    name: "Nashik Airport",
    city: "Nasik Road",
    country: "India",
    lat: 20.119101,
    lng: 73.912903,
  },
  {
    id: "PNQ",
    name: "Pune Airport",
    city: "Pune",
    country: "India",
    lat: 18.58209991455078,
    lng: 73.9197006225586,
  },
  {
    id: "PBD",
    name: "Porbandar Airport",
    city: "Porbandar",
    country: "India",
    lat: 21.6487007141,
    lng: 69.65720367429999,
  },
  {
    id: "RAJ",
    name: "Rajkot Airport",
    city: "Rajkot",
    country: "India",
    lat: 22.3092002869,
    lng: 70.77950286869999,
  },
  {
    id: "RPR",
    name: "Raipur Airport",
    city: "Raipur",
    country: "India",
    lat: 21.180401,
    lng: 81.7388,
  },
  {
    id: "SSE",
    name: "Solapur Airport",
    city: "Sholapur",
    country: "India",
    lat: 17.6280002594,
    lng: 75.93479919430001,
  },
  {
    id: "STV",
    name: "Surat Airport",
    city: "Surat",
    country: "India",
    lat: 21.1140995026,
    lng: 72.7417984009,
  },
  {
    id: "UDR",
    name: "Maharana Pratap Airport",
    city: "Udaipur",
    country: "India",
    lat: 24.617700576799997,
    lng: 73.89610290530001,
  },
  {
    id: "CMB",
    name: "Bandaranaike International Colombo Airport",
    city: "Colombo",
    country: "Sri Lanka",
    lat: 7.180759906768799,
    lng: 79.88410186767578,
  },
  {
    id: "ACJ",
    name: "Anuradhapura Air Force Base",
    city: "Anuradhapura",
    country: "Sri Lanka",
    lat: 8.30148983002,
    lng: 80.42790222170001,
  },
  {
    id: "BTC",
    name: "Batticaloa Airport",
    city: "Batticaloa",
    country: "Sri Lanka",
    lat: 7.70576,
    lng: 81.678802,
  },
  {
    id: "RML",
    name: "Colombo Ratmalana Airport",
    city: "Colombo",
    country: "Sri Lanka",
    lat: 6.821990013122559,
    lng: 79.88619995117188,
  },
  {
    id: "ADP",
    name: "Ampara Airport",
    city: "Galoya",
    country: "Sri Lanka",
    lat: 7.33776,
    lng: 81.62594,
  },
  {
    id: "JAF",
    name: "Kankesanturai Airport",
    city: "Jaffna",
    country: "Sri Lanka",
    lat: 9.792329788208008,
    lng: 80.07009887695312,
  },
  {
    id: "TRR",
    name: "China Bay Airport",
    city: "Trinciomalee",
    country: "Sri Lanka",
    lat: 8.5385103225708,
    lng: 81.18190002441406,
  },
  {
    id: "KZC",
    name: "Kampong Chhnang Airport",
    city: "Kompong Chnang",
    country: "Cambodia",
    lat: 12.255200386,
    lng: 104.564002991,
  },
  {
    id: "PNH",
    name: "Phnom Penh International Airport",
    city: "Phnom-penh",
    country: "Cambodia",
    lat: 11.546600341796875,
    lng: 104.84400177001953,
  },
  {
    id: "REP",
    name: "Siem Reap International Airport",
    city: "Siem-reap",
    country: "Cambodia",
    lat: 13.410699844400002,
    lng: 103.81300354,
  },
  {
    id: "TNX",
    name: "Stung Treng Airport",
    city: "Stung Treng",
    country: "Cambodia",
    lat: 13.531900405883789,
    lng: 106.01499938964844,
  },
  {
    id: "IXV",
    name: "Along Airport",
    city: "Along",
    country: "India",
    lat: 28.17530059814453,
    lng: 94.802001953125,
  },
  {
    id: "IXA",
    name: "Agartala Airport",
    city: "Agartala",
    country: "India",
    lat: 23.8869991302,
    lng: 91.24040222170001,
  },
  {
    id: "AJL",
    name: "Lengpui Airport",
    city: "Aizwal",
    country: "India",
    lat: 23.840599060099997,
    lng: 92.6196975708,
  },
  {
    id: "IXB",
    name: "Bagdogra Airport",
    city: "Baghdogra",
    country: "India",
    lat: 26.68120002746582,
    lng: 88.32859802246094,
  },
  {
    id: "N",
    name: "Bokaro Airport",
    city: "Bokaro",
    country: "India",
    lat: 23.64349937438965,
    lng: 86.1489028930664,
  },
  {
    id: "BBI",
    name: "Biju Patnaik Airport",
    city: "Bhubaneswar",
    country: "India",
    lat: 20.244400024399997,
    lng: 85.8178024292,
  },
  {
    id: "CCU",
    name: "Netaji Subhash Chandra Bose International Airport",
    city: "Kolkata",
    country: "India",
    lat: 22.654699325561523,
    lng: 88.44670104980469,
  },
  {
    id: "COH",
    name: "Cooch Behar Airport",
    city: "Cooch-behar",
    country: "India",
    lat: 26.330499649,
    lng: 89.4672012329,
  },
  {
    id: "DBD",
    name: "Dhanbad Airport",
    city: "Dhanbad",
    country: "India",
    lat: 23.833999633789062,
    lng: 86.42530059814453,
  },
  {
    id: "GAY",
    name: "Gaya Airport",
    city: "Gaya",
    country: "India",
    lat: 24.744300842285156,
    lng: 84.95120239257812,
  },
  {
    id: "N",
    name: "Hirakud Airport",
    city: "Hirakud",
    country: "India",
    lat: 21.5802001953125,
    lng: 84.00569915771484,
  },
  {
    id: "IMF",
    name: "Imphal Airport",
    city: "Imphal",
    country: "India",
    lat: 24.7600002289,
    lng: 93.896697998,
  },
  {
    id: "N",
    name: "Jharsuguda Airport",
    city: "Jharsuguda",
    country: "India",
    lat: 21.91349983215332,
    lng: 84.05039978027344,
  },
  {
    id: "IXW",
    name: "Sonari Airport",
    city: "Jamshedpur",
    country: "India",
    lat: 22.8132,
    lng: 86.1688,
  },
  {
    id: "JRH",
    name: "Jorhat Airport",
    city: "Jorhat",
    country: "India",
    lat: 26.7315006256,
    lng: 94.1754989624,
  },
  {
    id: "IXH",
    name: "Kailashahar Airport",
    city: "Kailashahar",
    country: "India",
    lat: 24.30820083618164,
    lng: 92.0072021484375,
  },
  {
    id: "IXS",
    name: "Silchar Airport",
    city: "Silchar",
    country: "India",
    lat: 24.9129009247,
    lng: 92.97869873050001,
  },
  {
    id: "IXI",
    name: "North Lakhimpur Airport",
    city: "Lilabari",
    country: "India",
    lat: 27.295499801635742,
    lng: 94.09760284423828,
  },
  {
    id: "DIB",
    name: "Dibrugarh Airport",
    city: "Mohanbari",
    country: "India",
    lat: 27.4839000702,
    lng: 95.0168991089,
  },
  {
    id: "MZU",
    name: "Muzaffarpur Airport",
    city: "Mazuffarpur",
    country: "India",
    lat: 26.11910057067871,
    lng: 85.3136978149414,
  },
  {
    id: "N",
    name: "Nawapara Airport",
    city: "Nawapara",
    country: "India",
    lat: 20.8700008392334,
    lng: 82.51959991455078,
  },
  {
    id: "N",
    name: "Panagarh Air Force Station",
    city: "Panagarh",
    country: "India",
    lat: 23.474300384499998,
    lng: 87.4274978638,
  },
  {
    id: "PAT",
    name: "Lok Nayak Jayaprakash Airport",
    city: "Patina",
    country: "India",
    lat: 25.591299057,
    lng: 85.0879974365,
  },
  {
    id: "N",
    name: "Purnea Airport",
    city: "Purnea",
    country: "India",
    lat: 25.759599685668945,
    lng: 87.41000366210938,
  },
  {
    id: "IXR",
    name: "Birsa Munda Airport",
    city: "Ranchi",
    country: "India",
    lat: 23.314300537100003,
    lng: 85.3217010498,
  },
  {
    id: "RRK",
    name: "Rourkela Airport",
    city: "Rourkela",
    country: "India",
    lat: 22.256701,
    lng: 84.814598,
  },
  {
    id: "N",
    name: "Utkela Airport",
    city: "Utkela",
    country: "India",
    lat: 20.097400665283203,
    lng: 83.18379974365234,
  },
  {
    id: "VTZ",
    name: "Vishakhapatnam Airport",
    city: "Vishakhapatnam",
    country: "India",
    lat: 17.721200943,
    lng: 83.2245025635,
  },
  {
    id: "ZER",
    name: "Ziro Airport",
    city: "Zero",
    country: "India",
    lat: 27.588301,
    lng: 93.828102,
  },
  {
    id: "CXB",
    name: "Cox's Bazar Airport",
    city: "Cox's Bazar",
    country: "Bangladesh",
    lat: 21.452199935913086,
    lng: 91.96389770507812,
  },
  {
    id: "CGP",
    name: "Shah Amanat International Airport",
    city: "Chittagong",
    country: "Bangladesh",
    lat: 22.24959945678711,
    lng: 91.81330108642578,
  },
  {
    id: "IRD",
    name: "Ishurdi Airport",
    city: "Ishurdi",
    country: "Bangladesh",
    lat: 24.15250015258789,
    lng: 89.04940032958984,
  },
  {
    id: "JSR",
    name: "Jessore Airport",
    city: "Jessore",
    country: "Bangladesh",
    lat: 23.183799743652344,
    lng: 89.16079711914062,
  },
  {
    id: "RJH",
    name: "Shah Mokhdum Airport",
    city: "Rajshahi",
    country: "Bangladesh",
    lat: 24.43720054626465,
    lng: 88.61650085449219,
  },
  {
    id: "SPD",
    name: "Saidpur Airport",
    city: "Saidpur",
    country: "Bangladesh",
    lat: 25.759199142456055,
    lng: 88.90889739990234,
  },
  {
    id: "ZYL",
    name: "Osmany International Airport",
    city: "Sylhet Osmani",
    country: "Bangladesh",
    lat: 24.963199615478516,
    lng: 91.8667984008789,
  },
  {
    id: "N",
    name: "Tejgaon Airport",
    city: "Dhaka",
    country: "Bangladesh",
    lat: 23.778799057006836,
    lng: 90.38269805908203,
  },
  {
    id: "DAC",
    name: "Hazrat Shahjalal International Airport",
    city: "Dhaka",
    country: "Bangladesh",
    lat: 23.843347,
    lng: 90.397783,
  },
  {
    id: "HKG",
    name: "Hong Kong International Airport",
    city: "Hong Kong",
    country: "Hong Kong",
    lat: 22.308901,
    lng: 113.915001,
  },
  {
    id: "N",
    name: "Shek Kong Air Base",
    city: "Sek Kong",
    country: "Hong Kong",
    lat: 22.436599731445312,
    lng: 114.08000183105469,
  },
  {
    id: "AGR",
    name: "Agra Airport",
    city: "Agra",
    country: "India",
    lat: 27.155799865722656,
    lng: 77.96089935302734,
  },
  {
    id: "IXD",
    name: "Allahabad Airport",
    city: "Allahabad",
    country: "India",
    lat: 25.440099716186523,
    lng: 81.73390197753906,
  },
  {
    id: "ATQ",
    name: "Sri Guru Ram Dass Jee International Airport",
    city: "Amritsar",
    country: "India",
    lat: 31.7096004486,
    lng: 74.7973022461,
  },
  {
    id: "BKB",
    name: "Nal Airport",
    city: "Bikaner",
    country: "India",
    lat: 28.070600509643555,
    lng: 73.20719909667969,
  },
  {
    id: "N",
    name: "Bakshi Ka Talab Air Force Station",
    city: "Bakshi Ka Talab",
    country: "India",
    lat: 26.988300323486328,
    lng: 80.89309692382812,
  },
  {
    id: "VNS",
    name: "Lal Bahadur Shastri Airport",
    city: "Varanasi",
    country: "India",
    lat: 25.4524002075,
    lng: 82.8592987061,
  },
  {
    id: "KUU",
    name: "Kullu Manali Airport",
    city: "Kulu",
    country: "India",
    lat: 31.876699447631836,
    lng: 77.15440368652344,
  },
  {
    id: "BUP",
    name: "Bhatinda Air Force Station",
    city: "Bhatinda",
    country: "India",
    lat: 30.270099639892578,
    lng: 74.75579833984375,
  },
  {
    id: "N",
    name: "Bhiwani Airport",
    city: "Bhiwani",
    country: "India",
    lat: 28.836999893188477,
    lng: 76.1791000366211,
  },
  {
    id: "BEK",
    name: "Bareilly Air Force Station",
    city: "Bareilly",
    country: "India",
    lat: 28.4221000671,
    lng: 79.45079803470001,
  },
  {
    id: "IXC",
    name: "Chandigarh Airport",
    city: "Chandigarh",
    country: "India",
    lat: 30.673500061035156,
    lng: 76.78849792480469,
  },
  {
    id: "KNU",
    name: "Kanpur Airport",
    city: "Kanpur",
    country: "India",
    lat: 26.404301,
    lng: 80.410103,
  },
  {
    id: "N",
    name: "Safdarjung Airport",
    city: "Delhi",
    country: "India",
    lat: 28.58449935913086,
    lng: 77.20580291748047,
  },
  {
    id: "DED",
    name: "Dehradun Airport",
    city: "Dehra Dun",
    country: "India",
    lat: 30.189699,
    lng: 78.180298,
  },
  {
    id: "DEL",
    name: "Indira Gandhi International Airport",
    city: "Delhi",
    country: "India",
    lat: 28.5665,
    lng: 77.103104,
  },
  {
    id: "GWL",
    name: "Gwalior Airport",
    city: "Gwalior",
    country: "India",
    lat: 26.29330062866211,
    lng: 78.22779846191406,
  },
  {
    id: "HSS",
    name: "Hissar Airport",
    city: "Hissar",
    country: "India",
    lat: 29.179399490356445,
    lng: 75.75530242919922,
  },
  {
    id: "N",
    name: "Jhansi Airport",
    city: "Jhansi",
    country: "India",
    lat: 25.491199493408203,
    lng: 78.55840301513672,
  },
  {
    id: "JDH",
    name: "Jodhpur Airport",
    city: "Jodhpur",
    country: "India",
    lat: 26.251100540161133,
    lng: 73.04889678955078,
  },
  {
    id: "JAI",
    name: "Jaipur International Airport",
    city: "Jaipur",
    country: "India",
    lat: 26.8242,
    lng: 75.812202,
  },
  {
    id: "JSA",
    name: "Jaisalmer Airport",
    city: "Jaisalmer",
    country: "India",
    lat: 26.888700485229492,
    lng: 70.86499786376953,
  },
  {
    id: "IXJ",
    name: "Jammu Airport",
    city: "Jammu",
    country: "India",
    lat: 32.6890983582,
    lng: 74.8374023438,
  },
  {
    id: "N",
    name: "Kanpur Civil Airport",
    city: "Kanpur",
    country: "India",
    lat: 26.441401,
    lng: 80.364899,
  },
  {
    id: "KTU",
    name: "Kota Airport",
    city: "Kota",
    country: "India",
    lat: 25.160200119,
    lng: 75.84559631350001,
  },
  {
    id: "LUH",
    name: "Ludhiana Airport",
    city: "Ludhiaha",
    country: "India",
    lat: 30.854700088500977,
    lng: 75.95259857177734,
  },
  {
    id: "IXL",
    name: "Leh Kushok Bakula Rimpochee Airport",
    city: "Leh",
    country: "India",
    lat: 34.1358985901,
    lng: 77.5465011597,
  },
  {
    id: "LKO",
    name: "Chaudhary Charan Singh International Airport",
    city: "Lucknow",
    country: "India",
    lat: 26.7605991364,
    lng: 80.8892974854,
  },
  {
    id: "IXP",
    name: "Pathankot Airport",
    city: "Pathankot",
    country: "India",
    lat: 32.233611,
    lng: 75.634444,
  },
  {
    id: "N",
    name: "Patiala Airport",
    city: "Patiala",
    country: "India",
    lat: 30.314800262451172,
    lng: 76.364501953125,
  },
  {
    id: "PGH",
    name: "Pantnagar Airport",
    city: "Nainital",
    country: "India",
    lat: 29.03339958190918,
    lng: 79.47370147705078,
  },
  {
    id: "N",
    name: "Fursatganj Airport",
    city: "Raibarelli",
    country: "India",
    lat: 26.24850082397461,
    lng: 81.38050079345703,
  },
  {
    id: "N",
    name: "Sarsawa Air Force Station",
    city: "Saharanpur",
    country: "India",
    lat: 29.993900299072266,
    lng: 77.42530059814453,
  },
  {
    id: "SXR",
    name: "Sheikh ul Alam Airport",
    city: "Srinagar",
    country: "India",
    lat: 33.987098693847656,
    lng: 74.77420043945312,
  },
  {
    id: "TNI",
    name: "Satna Airport",
    city: "Satna",
    country: "India",
    lat: 24.5623,
    lng: 80.854897,
  },
  {
    id: "LPQ",
    name: "Luang Phabang International Airport",
    city: "Luang Prabang",
    country: "Laos",
    lat: 19.897300720214844,
    lng: 102.16100311279297,
  },
  {
    id: "PKZ",
    name: "Pakse International Airport",
    city: "Pakse",
    country: "Laos",
    lat: 15.132100105285645,
    lng: 105.78099822998047,
  },
  {
    id: "N",
    name: "Phonesavanh Airport",
    city: "Phong Savanh",
    country: "Laos",
    lat: 19.45490074157715,
    lng: 103.21800231933594,
  },
  {
    id: "ZVK",
    name: "Savannakhet Airport",
    city: "Savannakhet",
    country: "Laos",
    lat: 16.55660057067871,
    lng: 104.76000213623047,
  },
  {
    id: "NEU",
    name: "Sam Neua Airport",
    city: "Sam Neua",
    country: "Laos",
    lat: 20.418399810791016,
    lng: 104.06700134277344,
  },
  {
    id: "VTE",
    name: "Wattay International Airport",
    city: "Vientiane",
    country: "Laos",
    lat: 17.988300323500003,
    lng: 102.56300354,
  },
  {
    id: "MFM",
    name: "Macau International Airport",
    city: "Macau",
    country: "Macau",
    lat: 22.149599,
    lng: 113.592003,
  },
  {
    id: "BWA",
    name: "Gautam Buddha Airport",
    city: "Bhairawa",
    country: "Nepal",
    lat: 27.505685,
    lng: 83.416293,
  },
  {
    id: "JKR",
    name: "Janakpur Airport",
    city: "Janakpur",
    country: "Nepal",
    lat: 26.708799362199997,
    lng: 85.9224014282,
  },
  {
    id: "KTM",
    name: "Tribhuvan International Airport",
    city: "Kathmandu",
    country: "Nepal",
    lat: 27.6966,
    lng: 85.3591,
  },
  {
    id: "PKR",
    name: "Pokhara Airport",
    city: "Pokhara",
    country: "Nepal",
    lat: 28.200899124145508,
    lng: 83.98210144042969,
  },
  {
    id: "SIF",
    name: "Simara Airport",
    city: "Simara",
    country: "Nepal",
    lat: 27.159500122070312,
    lng: 84.9801025390625,
  },
  {
    id: "BIR",
    name: "Biratnagar Airport",
    city: "Biratnagar",
    country: "Nepal",
    lat: 26.48150062561035,
    lng: 87.26399993896484,
  },
  {
    id: "AGX",
    name: "Agatti Airport",
    city: "Agatti Island",
    country: "India",
    lat: 10.823699951171875,
    lng: 72.1760025024414,
  },
  {
    id: "BLR",
    name: "Kempegowda International Airport",
    city: "Bangalore",
    country: "India",
    lat: 13.1979,
    lng: 77.706299,
  },
  {
    id: "BEP",
    name: "Bellary Airport",
    city: "Bellary",
    country: "India",
    lat: 15.162799835205078,
    lng: 76.88279724121094,
  },
  {
    id: "N",
    name: "Bidar Air Force Station",
    city: "Bidar",
    country: "India",
    lat: 17.908100128173828,
    lng: 77.48709869384766,
  },
  {
    id: "VGA",
    name: "Vijayawada Airport",
    city: "Vijayawada",
    country: "India",
    lat: 16.530399322509766,
    lng: 80.79679870605469,
  },
  {
    id: "CJB",
    name: "Coimbatore International Airport",
    city: "Coimbatore",
    country: "India",
    lat: 11.029999733,
    lng: 77.0434036255,
  },
  {
    id: "COK",
    name: "Cochin International Airport",
    city: "Kochi",
    country: "India",
    lat: 10.152,
    lng: 76.401901,
  },
  {
    id: "CCJ",
    name: "Calicut International Airport",
    city: "Calicut",
    country: "India",
    lat: 11.1367998123,
    lng: 75.95529937740001,
  },
  {
    id: "CDP",
    name: "Kadapa Airport",
    city: "Cuddapah",
    country: "India",
    lat: 14.51,
    lng: 78.772778,
  },
  {
    id: "CBD",
    name: "Car Nicobar Air Force Station",
    city: "Carnicobar",
    country: "India",
    lat: 9.152509689331055,
    lng: 92.8196029663086,
  },
  {
    id: "N",
    name: "Dundigul Air Force Academy",
    city: "Dundigul",
    country: "India",
    lat: 17.627199173,
    lng: 78.4033966064,
  },
  {
    id: "BPM",
    name: "Begumpet Airport",
    city: "Hyderabad",
    country: "India",
    lat: 17.4531002045,
    lng: 78.4675979614,
  },
  {
    id: "IXM",
    name: "Madurai Airport",
    city: "Madurai",
    country: "India",
    lat: 9.83450984955,
    lng: 78.09339904790001,
  },
  {
    id: "IXE",
    name: "Mangalore International Airport",
    city: "Mangalore",
    country: "India",
    lat: 12.9612998962,
    lng: 74.8900985718,
  },
  {
    id: "MAA",
    name: "Chennai International Airport",
    city: "Madras",
    country: "India",
    lat: 12.990005493164062,
    lng: 80.16929626464844,
  },
  {
    id: "N",
    name: "Nagarjuna Sagar Airport",
    city: "Nagarjunsagar",
    country: "India",
    lat: 16.542699813842773,
    lng: 79.3187026977539,
  },
  {
    id: "IXZ",
    name: "Vir Savarkar International Airport",
    city: "Port Blair",
    country: "India",
    lat: 11.641200065612793,
    lng: 92.72969818115234,
  },
  {
    id: "PNY",
    name: "Pondicherry Airport",
    city: "Pendicherry",
    country: "India",
    lat: 11.968,
    lng: 79.812,
  },
  {
    id: "RJA",
    name: "Rajahmundry Airport",
    city: "Rajahmundry",
    country: "India",
    lat: 17.1103992462,
    lng: 81.81819915770001,
  },
  {
    id: "SXV",
    name: "Salem Airport",
    city: "Salem",
    country: "India",
    lat: 11.78330039978,
    lng: 78.06559753418,
  },
  {
    id: "TJV",
    name: "Tanjore Air Force Base",
    city: "Tanjore",
    country: "India",
    lat: 10.722399711608887,
    lng: 79.10160064697266,
  },
  {
    id: "TIR",
    name: "Tirupati Airport",
    city: "Tirupeti",
    country: "India",
    lat: 13.632499694800002,
    lng: 79.543296814,
  },
  {
    id: "TRZ",
    name: "Tiruchirapally Civil Airport Airport",
    city: "Tiruchirappalli",
    country: "India",
    lat: 10.765399932861328,
    lng: 78.70970153808594,
  },
  {
    id: "TRV",
    name: "Trivandrum International Airport",
    city: "Trivandrum",
    country: "India",
    lat: 8.48211956024,
    lng: 76.9200973511,
  },
  {
    id: "N",
    name: "Tambaram Air Force Station",
    city: "Tambaram",
    country: "India",
    lat: 12.90719985961914,
    lng: 80.12190246582031,
  },
  {
    id: "PBH",
    name: "Paro Airport",
    city: "Thimphu",
    country: "Bhutan",
    lat: 27.403200149499998,
    lng: 89.42459869380001,
  },
  {
    id: "MLE",
    name: "Malé International Airport",
    city: "Male",
    country: "Maldives",
    lat: 4.191830158233643,
    lng: 73.52909851074219,
  },
  {
    id: "DMK",
    name: "Don Mueang International Airport",
    city: "Bangkok",
    country: "Thailand",
    lat: 13.9125995636,
    lng: 100.607002258,
  },
  {
    id: "KDT",
    name: "Kamphaeng Saen Airport",
    city: "Nakhon Pathom",
    country: "Thailand",
    lat: 14.1020002365,
    lng: 99.9171981812,
  },
  {
    id: "N",
    name: "Khok Kathiam Airport",
    city: "Lop Buri",
    country: "Thailand",
    lat: 14.8746004105,
    lng: 100.663002014,
  },
  {
    id: "UTP",
    name: "U-Tapao International Airport",
    city: "Pattaya",
    country: "Thailand",
    lat: 12.679900169372559,
    lng: 101.00499725341797,
  },
  {
    id: "N",
    name: "Watthana Nakhon Airport",
    city: "Prachin Buri",
    country: "Thailand",
    lat: 13.768799781799316,
    lng: 102.31500244140625,
  },
  {
    id: "LPT",
    name: "Lampang Airport",
    city: "Lampang",
    country: "Thailand",
    lat: 18.27090072631836,
    lng: 99.50420379638672,
  },
  {
    id: "PRH",
    name: "Phrae Airport",
    city: "Phrae",
    country: "Thailand",
    lat: 18.132200241088867,
    lng: 100.16500091552734,
  },
  {
    id: "HHQ",
    name: "Hua Hin Airport",
    city: "Prachuap Khiri Khan",
    country: "Thailand",
    lat: 12.6361999512,
    lng: 99.951499939,
  },
  {
    id: "TKH",
    name: "Takhli Airport",
    city: "Nakhon Sawan",
    country: "Thailand",
    lat: 15.277299881,
    lng: 100.29599762,
  },
  {
    id: "N",
    name: "Sak Long Airport",
    city: "Phetchabun",
    country: "Thailand",
    lat: 16.82430076599121,
    lng: 101.2509994506836,
  },
  {
    id: "N",
    name: "Nakhon Sawan Airport",
    city: "Nakhon Sawan",
    country: "Thailand",
    lat: 15.67300033569336,
    lng: 100.13700103759766,
  },
  {
    id: "PHS",
    name: "Phitsanulok Airport",
    city: "Phitsanulok",
    country: "Thailand",
    lat: 16.782899856567383,
    lng: 100.27899932861328,
  },
  {
    id: "N",
    name: "Khunan Phumipol Airport",
    city: "Tak",
    country: "Thailand",
    lat: 17.23419952392578,
    lng: 99.05789947509766,
  },
  {
    id: "N",
    name: "Khoun Khan Airport",
    city: "Satun",
    country: "Thailand",
    lat: 6.661399841308594,
    lng: 100.08000183105469,
  },
  {
    id: "NAW",
    name: "Narathiwat Airport",
    city: "Narathiwat",
    country: "Thailand",
    lat: 6.5199198722839355,
    lng: 101.74299621582031,
  },
  {
    id: "KBV",
    name: "Krabi Airport",
    city: "Krabi",
    country: "Thailand",
    lat: 8.09912014008,
    lng: 98.9861984253,
  },
  {
    id: "SGZ",
    name: "Songkhla Airport",
    city: "Songkhla",
    country: "Thailand",
    lat: 7.186560153961182,
    lng: 100.60800170898438,
  },
  {
    id: "PAN",
    name: "Pattani Airport",
    city: "Pattani",
    country: "Thailand",
    lat: 6.785459995269775,
    lng: 101.15399932861328,
  },
  {
    id: "USM",
    name: "Samui Airport",
    city: "Ko Samui",
    country: "Thailand",
    lat: 9.547789573669998,
    lng: 100.06199646,
  },
  {
    id: "N",
    name: "Cha Eian Airport",
    city: "Nakhon Si Thammarat",
    country: "Thailand",
    lat: 8.47115039825,
    lng: 99.9555969238,
  },
  {
    id: "HKT",
    name: "Phuket International Airport",
    city: "Phuket",
    country: "Thailand",
    lat: 8.1132,
    lng: 98.316902,
  },
  {
    id: "UNN",
    name: "Ranong Airport",
    city: "Ranong",
    country: "Thailand",
    lat: 9.777620315551758,
    lng: 98.58550262451172,
  },
  {
    id: "HDY",
    name: "Hat Yai International Airport",
    city: "Hat Yai",
    country: "Thailand",
    lat: 6.93320989609,
    lng: 100.392997742,
  },
  {
    id: "TST",
    name: "Trang Airport",
    city: "Trang",
    country: "Thailand",
    lat: 7.508739948272705,
    lng: 99.6166000366211,
  },
  {
    id: "UTH",
    name: "Udon Thani Airport",
    city: "Udon Thani",
    country: "Thailand",
    lat: 17.386400222800003,
    lng: 102.788002014,
  },
  {
    id: "SNO",
    name: "Sakon Nakhon Airport",
    city: "Sakon Nakhon",
    country: "Thailand",
    lat: 17.195100784301758,
    lng: 104.11900329589844,
  },
  {
    id: "PXR",
    name: "Surin Airport",
    city: "Surin",
    country: "Thailand",
    lat: 14.868300437927,
    lng: 103.49800109863,
  },
  {
    id: "LOE",
    name: "Loei Airport",
    city: "Loei",
    country: "Thailand",
    lat: 17.43910026550293,
    lng: 101.72200012207031,
  },
  {
    id: "N",
    name: "Khorat Airport",
    city: "Nakhon Ratchasima",
    country: "Thailand",
    lat: 14.9344997406,
    lng: 102.07900238,
  },
  {
    id: "N",
    name: "Rob Muang Airport",
    city: "Roi Et",
    country: "Thailand",
    lat: 16.07040023803711,
    lng: 103.64600372314453,
  },
  {
    id: "DAD",
    name: "Da Nang International Airport",
    city: "Danang",
    country: "Vietnam",
    lat: 16.043899536132812,
    lng: 108.1989974975586,
  },
  {
    id: "N",
    name: "Gia Lam Air Base",
    city: "Hanoi",
    country: "Vietnam",
    lat: 21.04050064086914,
    lng: 105.88600158691406,
  },
  {
    id: "N",
    name: "Kep Air Base",
    city: "Kep",
    country: "Vietnam",
    lat: 21.394599914599997,
    lng: 106.261001587,
  },
  {
    id: "HAN",
    name: "Noi Bai International Airport",
    city: "Hanoi",
    country: "Vietnam",
    lat: 21.221200942993164,
    lng: 105.80699920654297,
  },
  {
    id: "NHA",
    name: "Nha Trang Air Base",
    city: "Nhatrang",
    country: "Vietnam",
    lat: 12.2275,
    lng: 109.192001,
  },
  {
    id: "HUI",
    name: "Phu Bai Airport",
    city: "Hue",
    country: "Vietnam",
    lat: 16.401500701899998,
    lng: 107.70300293,
  },
  {
    id: "PQC",
    name: "Phu Quoc International Airport",
    city: "Phuquoc",
    country: "Vietnam",
    lat: 10.1698,
    lng: 103.9931,
  },
  {
    id: "SGN",
    name: "Tan Son Nhat International Airport",
    city: "Ho Chi Minh City",
    country: "Vietnam",
    lat: 10.8187999725,
    lng: 106.652000427,
  },
  {
    id: "VBA",
    name: "Ann Airport",
    city: "Ann",
    country: "Burma",
    lat: 19.769199,
    lng: 94.0261,
  },
  {
    id: "N",
    name: "Anisakan Airport",
    city: "Anisakan",
    country: "Burma",
    lat: 21.955400466918945,
    lng: 96.40609741210938,
  },
  {
    id: "NYU",
    name: "Bagan Airport",
    city: "Bagan",
    country: "Burma",
    lat: 21.178800582885742,
    lng: 94.9301986694336,
  },
  {
    id: "N",
    name: "Coco Island Airport",
    city: "Coco Island",
    country: "Burma",
    lat: 14.141500473022461,
    lng: 93.36849975585938,
  },
  {
    id: "HEH",
    name: "Heho Airport",
    city: "Heho",
    country: "Burma",
    lat: 20.746999740600586,
    lng: 96.79199981689453,
  },
  {
    id: "HOX",
    name: "Hommalinn Airport",
    city: "Hommalin",
    country: "Burma",
    lat: 24.899599075317383,
    lng: 94.91400146484375,
  },
  {
    id: "KET",
    name: "Kengtung Airport",
    city: "Kengtung",
    country: "Burma",
    lat: 21.301599502563477,
    lng: 99.63600158691406,
  },
  {
    id: "KYP",
    name: "Kyaukpyu Airport",
    city: "Kyaukpyu",
    country: "Burma",
    lat: 19.42639923095703,
    lng: 93.53479766845703,
  },
  {
    id: "LSH",
    name: "Lashio Airport",
    city: "Lashio",
    country: "Burma",
    lat: 22.9778995513916,
    lng: 97.752197265625,
  },
  {
    id: "N",
    name: "Lanywa Airport",
    city: "Lanywa",
    country: "Burma",
    lat: 20.940399169921875,
    lng: 94.82260131835938,
  },
  {
    id: "MDL",
    name: "Mandalay International Airport",
    city: "Mandalay",
    country: "Burma",
    lat: 21.702199935913086,
    lng: 95.97789764404297,
  },
  {
    id: "MGZ",
    name: "Myeik Airport",
    city: "Myeik",
    country: "Burma",
    lat: 12.439800262451172,
    lng: 98.62149810791016,
  },
  {
    id: "MYT",
    name: "Myitkyina Airport",
    city: "Myitkyina",
    country: "Burma",
    lat: 25.38360023498535,
    lng: 97.35189819335938,
  },
  {
    id: "MOE",
    name: "Momeik Airport",
    city: "Momeik",
    country: "Burma",
    lat: 23.092500686645508,
    lng: 96.64530181884766,
  },
  {
    id: "MOG",
    name: "Mong Hsat Airport",
    city: "Mong Hsat",
    country: "Burma",
    lat: 20.516799926757812,
    lng: 99.25679779052734,
  },
  {
    id: "N",
    name: "Nampong Air Base",
    city: "Nampong",
    country: "Burma",
    lat: 25.354400634799998,
    lng: 97.2951965332,
  },
  {
    id: "NMS",
    name: "Namsang Airport",
    city: "Namsang",
    country: "Burma",
    lat: 20.890499114990234,
    lng: 97.73590087890625,
  },
  {
    id: "PAA",
    name: "Hpa-N Airport",
    city: "Hpa-an",
    country: "Burma",
    lat: 16.893699645996094,
    lng: 97.67459869384766,
  },
  {
    id: "PBU",
    name: "Putao Airport",
    city: "Putao",
    country: "Burma",
    lat: 27.32990074157715,
    lng: 97.42630004882812,
  },
  {
    id: "PRU",
    name: "Pyay Airport",
    city: "Pyay",
    country: "Burma",
    lat: 18.824499130249023,
    lng: 95.26599884033203,
  },
  {
    id: "N",
    name: "Shante Air Base",
    city: "Shante",
    country: "Burma",
    lat: 20.941699981689453,
    lng: 95.91449737548828,
  },
  {
    id: "AKY",
    name: "Sittwe Airport",
    city: "Sittwe",
    country: "Burma",
    lat: 20.132699966430664,
    lng: 92.87259674072266,
  },
  {
    id: "SNW",
    name: "Thandwe Airport",
    city: "Thandwe",
    country: "Burma",
    lat: 18.4606990814209,
    lng: 94.30010223388672,
  },
  {
    id: "THL",
    name: "Tachileik Airport",
    city: "Tachilek",
    country: "Burma",
    lat: 20.483800888061523,
    lng: 99.9354019165039,
  },
  {
    id: "N",
    name: "Taungoo Airport",
    city: "Taungoo",
    country: "Burma",
    lat: 19.031299591064453,
    lng: 96.40119934082031,
  },
  {
    id: "RGN",
    name: "Yangon International Airport",
    city: "Yangon",
    country: "Burma",
    lat: 16.907300949099998,
    lng: 96.1332015991,
  },
  {
    id: "UPG",
    name: "Hasanuddin International Airport",
    city: "Ujung Pandang",
    country: "Indonesia",
    lat: -5.061629772186279,
    lng: 119.55400085449219,
  },
  {
    id: "BIK",
    name: "Frans Kaisiepo Airport",
    city: "Biak",
    country: "Indonesia",
    lat: -1.190019965171814,
    lng: 136.10800170898438,
  },
  {
    id: "NBX",
    name: "Nabire Airport",
    city: "Nabire",
    country: "Indonesia",
    lat: -3.36818,
    lng: 135.496002,
  },
  {
    id: "TIM",
    name: "Moses Kilangin Airport",
    city: "Timika",
    country: "Indonesia",
    lat: -4.528279781341553,
    lng: 136.88699340820312,
  },
  {
    id: "DJJ",
    name: "Sentani International Airport",
    city: "Jayapura",
    country: "Indonesia",
    lat: -2.5769500733,
    lng: 140.5160064698,
  },
  {
    id: "WMX",
    name: "Wamena Airport",
    city: "Wamena",
    country: "Indonesia",
    lat: -4.10251,
    lng: 138.957001,
  },
  {
    id: "MKQ",
    name: "Mopah Airport",
    city: "Merauke",
    country: "Indonesia",
    lat: -8.52029037475586,
    lng: 140.41799926757812,
  },
  {
    id: "GTO",
    name: "Jalaluddin Airport",
    city: "Gorontalo",
    country: "Indonesia",
    lat: 0.63711899519,
    lng: 122.849998474,
  },
  {
    id: "PLW",
    name: "Mutiara Airport",
    city: "Palu",
    country: "Indonesia",
    lat: -0.9185420274734497,
    lng: 119.91000366210938,
  },
  {
    id: "MDC",
    name: "Sam Ratulangi Airport",
    city: "Manado",
    country: "Indonesia",
    lat: 1.5492600202560425,
    lng: 124.9260025024414,
  },
  {
    id: "PSJ",
    name: "Kasiguncu Airport",
    city: "Poso",
    country: "Indonesia",
    lat: -1.41674995422,
    lng: 120.657997131,
  },
  {
    id: "OTI",
    name: "Pitu Airport",
    city: "Morotai Island",
    country: "Indonesia",
    lat: 2.0459899902300003,
    lng: 128.324996948,
  },
  {
    id: "TTE",
    name: "Sultan Khairun Babullah Airport",
    city: "Ternate",
    country: "Indonesia",
    lat: 0.831413984298706,
    lng: 127.38099670410156,
  },
  {
    id: "LUW",
    name: "Syukuran Aminuddin Amir Airport",
    city: "Luwuk",
    country: "Indonesia",
    lat: -1.03892,
    lng: 122.772003,
  },
  {
    id: "AMQ",
    name: "Pattimura Airport, Ambon",
    city: "Ambon",
    country: "Indonesia",
    lat: -3.7102599144,
    lng: 128.089004517,
  },
  {
    id: "FKQ",
    name: "Fakfak Airport",
    city: "Fak Fak",
    country: "Indonesia",
    lat: -2.9201900959014893,
    lng: 132.26699829101562,
  },
  {
    id: "KNG",
    name: "Kaimana Airport",
    city: "Kaimana",
    country: "Indonesia",
    lat: -3.6445200443267822,
    lng: 133.6959991455078,
  },
  {
    id: "BXB",
    name: "Babo Airport",
    city: "Babo",
    country: "Indonesia",
    lat: -2.5322399139404297,
    lng: 133.43899536132812,
  },
  {
    id: "MKW",
    name: "Rendani Airport",
    city: "Manokwari",
    country: "Indonesia",
    lat: -0.8918330073356628,
    lng: 134.0489959716797,
  },
  {
    id: "SOQ",
    name: "Dominique Edward Osok Airport",
    city: "Sorong",
    country: "Indonesia",
    lat: -0.894,
    lng: 131.287,
  },
  {
    id: "BTU",
    name: "Bintulu Airport",
    city: "Bintulu",
    country: "Malaysia",
    lat: 3.12385010719,
    lng: 113.019996643,
  },
  {
    id: "KCH",
    name: "Kuching International Airport",
    city: "Kuching",
    country: "Malaysia",
    lat: 1.4846999645233154,
    lng: 110.34700012207031,
  },
  {
    id: "LMN",
    name: "Limbang Airport",
    city: "Limbang",
    country: "Malaysia",
    lat: 4.808300018310547,
    lng: 115.01000213623047,
  },
  {
    id: "MUR",
    name: "Marudi Airport",
    city: "Marudi",
    country: "Malaysia",
    lat: 4.178979873657227,
    lng: 114.3290023803711,
  },
  {
    id: "MYY",
    name: "Miri Airport",
    city: "Miri",
    country: "Malaysia",
    lat: 4.322010040283203,
    lng: 113.98699951171875,
  },
  {
    id: "SBW",
    name: "Sibu Airport",
    city: "Sibu",
    country: "Malaysia",
    lat: 2.2616000175476074,
    lng: 111.98500061035156,
  },
  {
    id: "LDU",
    name: "Lahad Datu Airport",
    city: "Lahad Datu",
    country: "Malaysia",
    lat: 5.032249927520752,
    lng: 118.3239974975586,
  },
  {
    id: "BKI",
    name: "Kota Kinabalu International Airport",
    city: "Kota Kinabalu",
    country: "Malaysia",
    lat: 5.9372100830078125,
    lng: 116.0510025024414,
  },
  {
    id: "LBU",
    name: "Labuan Airport",
    city: "Labuan",
    country: "Malaysia",
    lat: 5.300680160522461,
    lng: 115.25,
  },
  {
    id: "TWU",
    name: "Tawau Airport",
    city: "Tawau",
    country: "Malaysia",
    lat: 4.320159912109375,
    lng: 118.12799835205078,
  },
  {
    id: "BWN",
    name: "Brunei International Airport",
    city: "Bandar Seri Begawan",
    country: "Brunei",
    lat: 4.944200038909912,
    lng: 114.9280014038086,
  },
  {
    id: "PKU",
    name: "Sultan Syarif Kasim Ii (Simpang Tiga) Airport",
    city: "Pekanbaru",
    country: "Indonesia",
    lat: 0.46078601479530334,
    lng: 101.44499969482422,
  },
  {
    id: "DUM",
    name: "Pinang Kampai Airport",
    city: "Dumai",
    country: "Indonesia",
    lat: 1.60919,
    lng: 101.433998,
  },
  {
    id: "CGK",
    name: "Soekarno-Hatta International Airport",
    city: "Jakarta",
    country: "Indonesia",
    lat: -6.1255698204,
    lng: 106.65599823,
  },
  {
    id: "GNS",
    name: "Binaka Airport",
    city: "Gunung Sitoli",
    country: "Indonesia",
    lat: 1.16638,
    lng: 97.704697,
  },
  {
    id: "AEG",
    name: "Aek Godang Airport",
    city: "Padang Sidempuan",
    country: "Indonesia",
    lat: 1.4001,
    lng: 99.430496,
  },
  {
    id: "PDG",
    name: "Minangkabau International Airport",
    city: "Padang",
    country: "Indonesia",
    lat: -0.786917,
    lng: 100.280998,
  },
  {
    id: "MES",
    name: "Soewondo Air Force Base",
    city: "Medan",
    country: "Indonesia",
    lat: 3.559167,
    lng: 98.671111,
  },
  {
    id: "FLZ",
    name: "Dr Ferdinand Lumban Tobing Airport",
    city: "Sibolga",
    country: "Indonesia",
    lat: 1.55594,
    lng: 98.888901,
  },
  {
    id: "NPO",
    name: "Nanga Pinoh Airport",
    city: "Nangapinoh",
    country: "Indonesia",
    lat: -0.34886899590492,
    lng: 111.74800109863,
  },
  {
    id: "KTG",
    name: "Ketapang(Rahadi Usman) Airport",
    city: "Ketapang",
    country: "Indonesia",
    lat: -1.816640019416809,
    lng: 109.96299743652344,
  },
  {
    id: "PNK",
    name: "Supadio Airport",
    city: "Pontianak",
    country: "Indonesia",
    lat: -0.15071099996566772,
    lng: 109.40399932861328,
  },
  {
    id: "DJB",
    name: "Sultan Thaha Airport",
    city: "Jambi",
    country: "Indonesia",
    lat: -1.6380200386047363,
    lng: 103.64399719238281,
  },
  {
    id: "BKS",
    name: "Fatmawati Soekarno Airport",
    city: "Bengkulu",
    country: "Indonesia",
    lat: -3.8637,
    lng: 102.338997,
  },
  {
    id: "PLM",
    name: "Sultan Mahmud Badaruddin II Airport",
    city: "Palembang",
    country: "Indonesia",
    lat: -2.8982501029968,
    lng: 104.69999694824,
  },
  {
    id: "RGT",
    name: "Japura Airport",
    city: "Rengat",
    country: "Indonesia",
    lat: -0.35280799865722656,
    lng: 102.33499908447266,
  },
  {
    id: "LSX",
    name: "Lhok Sukon Airport",
    city: "Lhok Sukon",
    country: "Indonesia",
    lat: 5.069509983062744,
    lng: 97.25920104980469,
  },
  {
    id: "BTJ",
    name: "Sultan Iskandar Muda International Airport",
    city: "Banda Aceh",
    country: "Indonesia",
    lat: 5.522872024010001,
    lng: 95.42063713070002,
  },
  {
    id: "N",
    name: "Kluang Airport",
    city: "Kluang",
    country: "Malaysia",
    lat: 2.04138994217,
    lng: 103.306999207,
  },
  {
    id: "AOR",
    name: "Sultan Abdul Halim Airport",
    city: "Alor Setar",
    country: "Malaysia",
    lat: 6.189670085906982,
    lng: 100.39800262451172,
  },
  {
    id: "BWH",
    name: "Butterworth Airport",
    city: "Butterworth",
    country: "Malaysia",
    lat: 5.4659199714660645,
    lng: 100.39099884033203,
  },
  {
    id: "KBR",
    name: "Sultan Ismail Petra Airport",
    city: "Kota Bahru",
    country: "Malaysia",
    lat: 6.1668500900268555,
    lng: 102.29299926757812,
  },
  {
    id: "KUA",
    name: "Kuantan Airport",
    city: "Kuantan",
    country: "Malaysia",
    lat: 3.7753899097442627,
    lng: 103.20899963378906,
  },
  {
    id: "KTE",
    name: "Kerteh Airport",
    city: "Kerteh",
    country: "Malaysia",
    lat: 4.537220001220703,
    lng: 103.427001953125,
  },
  {
    id: "N",
    name: "Simpang Airport",
    city: "Simpang",
    country: "Malaysia",
    lat: 3.1122500896453857,
    lng: 101.7030029296875,
  },
  {
    id: "IPH",
    name: "Sultan Azlan Shah Airport",
    city: "Ipoh",
    country: "Malaysia",
    lat: 4.567969799041748,
    lng: 101.09200286865234,
  },
  {
    id: "JHB",
    name: "Senai International Airport",
    city: "Johor Bahru",
    country: "Malaysia",
    lat: 1.64131,
    lng: 103.669998,
  },
  {
    id: "KUL",
    name: "Kuala Lumpur International Airport",
    city: "Kuala Lumpur",
    country: "Malaysia",
    lat: 2.745579957962,
    lng: 101.70999908447,
  },
  {
    id: "LGK",
    name: "Langkawi International Airport",
    city: "Langkawi",
    country: "Malaysia",
    lat: 6.329730033874512,
    lng: 99.72869873046875,
  },
  {
    id: "MKZ",
    name: "Malacca Airport",
    city: "Malacca",
    country: "Malaysia",
    lat: 2.2633600235,
    lng: 102.251998901,
  },
  {
    id: "TGG",
    name: "Sultan Mahmud Airport",
    city: "Kuala Terengganu",
    country: "Malaysia",
    lat: 5.3826398849487305,
    lng: 103.10299682617188,
  },
  {
    id: "PEN",
    name: "Penang International Airport",
    city: "Penang",
    country: "Malaysia",
    lat: 5.297140121459961,
    lng: 100.2770004272461,
  },
  {
    id: "UAI",
    name: "Suai Airport",
    city: "Suai",
    country: "East Timor",
    lat: -9.30331039428711,
    lng: 125.28700256347656,
  },
  {
    id: "DIL",
    name: "Presidente Nicolau Lobato International Airport",
    city: "Dili",
    country: "East Timor",
    lat: -8.54640007019,
    lng: 125.526000977,
  },
  {
    id: "BCH",
    name: "Cakung Airport",
    city: "Baucau",
    country: "East Timor",
    lat: -8.489029884339999,
    lng: 126.401000977,
  },
  {
    id: "N",
    name: "Sembawang Air Base",
    city: "Sembawang",
    country: "Singapore",
    lat: 1.4252599477767944,
    lng: 103.81300354003906,
  },
  {
    id: "QPG",
    name: "Paya Lebar Air Base",
    city: "Paya Lebar",
    country: "Singapore",
    lat: 1.3604199886322021,
    lng: 103.91000366210938,
  },
  {
    id: "TGA",
    name: "Tengah Air Base",
    city: "Tengah",
    country: "Singapore",
    lat: 1.38725996017,
    lng: 103.708999634,
  },
  {
    id: "XSP",
    name: "Seletar Airport",
    city: "Singapore",
    country: "Singapore",
    lat: 1.416949987411499,
    lng: 103.86799621582031,
  },
  {
    id: "SIN",
    name: "Singapore Changi Airport",
    city: "Singapore",
    country: "Singapore",
    lat: 1.35019,
    lng: 103.994003,
  },
  {
    id: "ACF",
    name: "Brisbane Archerfield Airport",
    city: "Brisbane",
    country: "Australia",
    lat: -27.5702991486,
    lng: 153.007995605,
  },
  {
    id: "ABM",
    name: "Northern Peninsula Airport",
    city: "Amberley",
    country: "Australia",
    lat: -10.9508,
    lng: 142.459,
  },
  {
    id: "ASP",
    name: "Alice Springs Airport",
    city: "Alice Springs",
    country: "Australia",
    lat: -23.806699752807617,
    lng: 133.90199279785156,
  },
  {
    id: "BNE",
    name: "Brisbane International Airport",
    city: "Brisbane",
    country: "Australia",
    lat: -27.384199142456055,
    lng: 153.11700439453125,
  },
  {
    id: "OOL",
    name: "Gold Coast Airport",
    city: "Coolangatta",
    country: "Australia",
    lat: -28.1644001007,
    lng: 153.505004883,
  },
  {
    id: "CNS",
    name: "Cairns International Airport",
    city: "Cairns",
    country: "Australia",
    lat: -16.885799408,
    lng: 145.755004883,
  },
  {
    id: "CTL",
    name: "Charleville Airport",
    city: "Charlieville",
    country: "Australia",
    lat: -26.4132995605,
    lng: 146.261993408,
  },
  {
    id: "ISA",
    name: "Mount Isa Airport",
    city: "Mount Isa",
    country: "Australia",
    lat: -20.663900375399997,
    lng: 139.488998413,
  },
  {
    id: "MCY",
    name: "Sunshine Coast Airport",
    city: "Maroochydore",
    country: "Australia",
    lat: -26.6033,
    lng: 153.091003,
  },
  {
    id: "MKY",
    name: "Mackay Airport",
    city: "Mackay",
    country: "Australia",
    lat: -21.171699523900003,
    lng: 149.179992676,
  },
  {
    id: "PPP",
    name: "Proserpine Whitsunday Coast Airport",
    city: "Prosserpine",
    country: "Australia",
    lat: -20.4950008392,
    lng: 148.552001953,
  },
  {
    id: "ROK",
    name: "Rockhampton Airport",
    city: "Rockhampton",
    country: "Australia",
    lat: -23.3819007874,
    lng: 150.475006104,
  },
  {
    id: "TSV",
    name: "Townsville Airport",
    city: "Townsville",
    country: "Australia",
    lat: -19.252500534057617,
    lng: 146.76499938964844,
  },
  {
    id: "WEI",
    name: "Weipa Airport",
    city: "Weipa",
    country: "Australia",
    lat: -12.6786003113,
    lng: 141.925003052,
  },
  {
    id: "AVV",
    name: "Avalon Airport",
    city: "Avalon",
    country: "Australia",
    lat: -38.039398,
    lng: 144.468994,
  },
  {
    id: "ABX",
    name: "Albury Airport",
    city: "Albury",
    country: "Australia",
    lat: -36.06779861450195,
    lng: 146.95799255371094,
  },
  {
    id: "MEB",
    name: "Melbourne Essendon Airport",
    city: "Melbourne",
    country: "Australia",
    lat: -37.7281,
    lng: 144.901993,
  },
  {
    id: "N",
    name: "RAAF Base East Sale",
    city: "East Sale",
    country: "Australia",
    lat: -38.098899841299996,
    lng: 147.149002075,
  },
  {
    id: "HBA",
    name: "Hobart International Airport",
    city: "Hobart",
    country: "Australia",
    lat: -42.836101532,
    lng: 147.509994507,
  },
  {
    id: "LST",
    name: "Launceston Airport",
    city: "Launceston",
    country: "Australia",
    lat: -41.54529953,
    lng: 147.214004517,
  },
  {
    id: "MBW",
    name: "Melbourne Moorabbin Airport",
    city: "Melbourne",
    country: "Australia",
    lat: -37.975799560546875,
    lng: 145.1020050048828,
  },
  {
    id: "MEL",
    name: "Melbourne International Airport",
    city: "Melbourne",
    country: "Australia",
    lat: -37.673302,
    lng: 144.843002,
  },
  {
    id: "N",
    name: "RAAF Williams, Point Cook Base",
    city: "Point Cook",
    country: "Australia",
    lat: -37.932201,
    lng: 144.753006,
  },
  {
    id: "ADL",
    name: "Adelaide International Airport",
    city: "Adelaide",
    country: "Australia",
    lat: -34.945,
    lng: 138.531006,
  },
  {
    id: "N",
    name: "RAAF Base Edinburgh",
    city: "Edinburgh",
    country: "Australia",
    lat: -34.70249938964844,
    lng: 138.62100219726562,
  },
  {
    id: "JAD",
    name: "Perth Jandakot Airport",
    city: "Perth",
    country: "Australia",
    lat: -32.09749984741211,
    lng: 115.88099670410156,
  },
  {
    id: "KTA",
    name: "Karratha Airport",
    city: "Karratha",
    country: "Australia",
    lat: -20.712200164799995,
    lng: 116.773002625,
  },
  {
    id: "KGI",
    name: "Kalgoorlie Boulder Airport",
    city: "Kalgoorlie",
    country: "Australia",
    lat: -30.789400100699996,
    lng: 121.461997986,
  },
  {
    id: "KNX",
    name: "Kununurra Airport",
    city: "Kununurra",
    country: "Australia",
    lat: -15.7781000137,
    lng: 128.707992554,
  },
  {
    id: "LEA",
    name: "Learmonth Airport",
    city: "Learmonth",
    country: "Australia",
    lat: -22.235599517799997,
    lng: 114.088996887,
  },
  {
    id: "PHE",
    name: "Port Hedland International Airport",
    city: "Port Hedland",
    country: "Australia",
    lat: -20.3777999878,
    lng: 118.625999451,
  },
  {
    id: "N",
    name: "Adelaide Parafield Airport",
    city: "Adelaide",
    country: "Australia",
    lat: -34.793300628699996,
    lng: 138.632995605,
  },
  {
    id: "PER",
    name: "Perth International Airport",
    city: "Perth",
    country: "Australia",
    lat: -31.94029998779297,
    lng: 115.96700286865234,
  },
  {
    id: "UMR",
    name: "Woomera Airfield",
    city: "Woomera",
    country: "Australia",
    lat: -31.14419937133789,
    lng: 136.81700134277344,
  },
  {
    id: "XCH",
    name: "Christmas Island Airport",
    city: "Christmas Island",
    country: "Christmas Island",
    lat: -10.450599670410156,
    lng: 105.69000244140625,
  },
  {
    id: "BWU",
    name: "Sydney Bankstown Airport",
    city: "Sydney",
    country: "Australia",
    lat: -33.924400329589844,
    lng: 150.98800659179688,
  },
  {
    id: "CBR",
    name: "Canberra International Airport",
    city: "Canberra",
    country: "Australia",
    lat: -35.30690002441406,
    lng: 149.19500732421875,
  },
  {
    id: "CFS",
    name: "Coffs Harbour Airport",
    city: "Coff's Harbour",
    country: "Australia",
    lat: -30.3206005096,
    lng: 153.115997314,
  },
  {
    id: "CDU",
    name: "Camden Airport",
    city: "Camden",
    country: "Australia",
    lat: -34.04029846191406,
    lng: 150.68699645996094,
  },
  {
    id: "DBO",
    name: "Dubbo City Regional Airport",
    city: "Dubbo",
    country: "Australia",
    lat: -32.2167015076,
    lng: 148.574996948,
  },
  {
    id: "NLK",
    name: "Norfolk Island International Airport",
    city: "Norfolk Island",
    country: "Norfolk Island",
    lat: -29.04159927368164,
    lng: 167.93899536132812,
  },
  {
    id: "XRH",
    name: "RAAF Base Richmond",
    city: "Richmond",
    country: "Australia",
    lat: -33.600601,
    lng: 150.781006,
  },
  {
    id: "SYD",
    name: "Sydney Kingsford Smith International Airport",
    city: "Sydney",
    country: "Australia",
    lat: -33.94609832763672,
    lng: 151.177001953125,
  },
  {
    id: "TMW",
    name: "Tamworth Airport",
    city: "Tamworth",
    country: "Australia",
    lat: -31.0839004517,
    lng: 150.847000122,
  },
  {
    id: "WGA",
    name: "Wagga Wagga City Airport",
    city: "Wagga Wagga",
    country: "Australia",
    lat: -35.1652984619,
    lng: 147.466003418,
  },
  {
    id: "PEK",
    name: "Beijing Capital International Airport",
    city: "Beijing",
    country: "China",
    lat: 40.080101013183594,
    lng: 116.58499908447266,
  },
  {
    id: "HLD",
    name: "Dongshan Airport",
    city: "Hailar",
    country: "China",
    lat: 49.2050018311,
    lng: 119.824996948,
  },
  {
    id: "TSN",
    name: "Tianjin Binhai International Airport",
    city: "Tianjin",
    country: "China",
    lat: 39.124401092499994,
    lng: 117.346000671,
  },
  {
    id: "TYN",
    name: "Taiyuan Wusu Airport",
    city: "Taiyuan",
    country: "China",
    lat: 37.74689865112305,
    lng: 112.62799835205078,
  },
  {
    id: "CAN",
    name: "Guangzhou Baiyun International Airport",
    city: "Guangzhou",
    country: "China",
    lat: 23.39240074157715,
    lng: 113.29900360107422,
  },
  {
    id: "CSX",
    name: "Changsha Huanghua International Airport",
    city: "Changcha",
    country: "China",
    lat: 28.189199447599997,
    lng: 113.220001221,
  },
  {
    id: "KWL",
    name: "Guilin Liangjiang International Airport",
    city: "Guilin",
    country: "China",
    lat: 25.21809959411621,
    lng: 110.03900146484375,
  },
  {
    id: "NNG",
    name: "Nanning Wuxu Airport",
    city: "Nanning",
    country: "China",
    lat: 22.608299255371094,
    lng: 108.1719970703125,
  },
  {
    id: "SZX",
    name: "Shenzhen Bao'an International Airport",
    city: "Shenzhen",
    country: "China",
    lat: 22.639299392700195,
    lng: 113.81099700927734,
  },
  {
    id: "CGO",
    name: "Zhengzhou Xinzheng International Airport",
    city: "Zhengzhou",
    country: "China",
    lat: 34.519699096699995,
    lng: 113.841003418,
  },
  {
    id: "WUH",
    name: "Wuhan Tianhe International Airport",
    city: "Wuhan",
    country: "China",
    lat: 30.7838,
    lng: 114.208,
  },
  {
    id: "FNJ",
    name: "Pyongyang Sunan International Airport",
    city: "Pyongyang",
    country: "North Korea",
    lat: 39.224098,
    lng: 125.669998,
  },
  {
    id: "LHW",
    name: "Lanzhou Zhongchuan Airport",
    city: "Lanzhou",
    country: "China",
    lat: 36.5152015686,
    lng: 103.620002747,
  },
  {
    id: "XIY",
    name: "Xi'an Xianyang International Airport",
    city: "Xi'an",
    country: "China",
    lat: 34.447102,
    lng: 108.751999,
  },
  {
    id: "ULN",
    name: "Chinggis Khaan International Airport",
    city: "Ulan Bator",
    country: "Mongolia",
    lat: 47.843102,
    lng: 106.766998,
  },
  {
    id: "JHG",
    name: "Xishuangbanna Gasa Airport",
    city: "Jinghonggasa",
    country: "China",
    lat: 21.973899841308594,
    lng: 100.76000213623047,
  },
  {
    id: "KMG",
    name: "Kunming Changshui International Airport",
    city: "Kunming",
    country: "China",
    lat: 25.1019444,
    lng: 102.9291667,
  },
  {
    id: "XMN",
    name: "Xiamen Gaoqi International Airport",
    city: "Xiamen",
    country: "China",
    lat: 24.54400062561035,
    lng: 118.12799835205078,
  },
  {
    id: "KHN",
    name: "Nanchang Changbei International Airport",
    city: "Nanchang",
    country: "China",
    lat: 28.864999771118164,
    lng: 115.9000015258789,
  },
  {
    id: "FOC",
    name: "Fuzhou Changle International Airport",
    city: "Fuzhou",
    country: "China",
    lat: 25.935100555419922,
    lng: 119.66300201416016,
  },
  {
    id: "HGH",
    name: "Hangzhou Xiaoshan International Airport",
    city: "Hangzhou",
    country: "China",
    lat: 30.22949981689453,
    lng: 120.43399810791016,
  },
  {
    id: "NGB",
    name: "Ningbo Lishe International Airport",
    city: "Ninbo",
    country: "China",
    lat: 29.82670021057129,
    lng: 121.46199798583984,
  },
  {
    id: "NKG",
    name: "Nanjing Lukou Airport",
    city: "Nanjing",
    country: "China",
    lat: 31.742000579833984,
    lng: 118.86199951171875,
  },
  {
    id: "HFE",
    name: "Hefei Luogang International Airport",
    city: "Hefei",
    country: "China",
    lat: 31.780000686645508,
    lng: 117.2979965209961,
  },
  {
    id: "TAO",
    name: "Liuting Airport",
    city: "Qingdao",
    country: "China",
    lat: 36.2661018372,
    lng: 120.374000549,
  },
  {
    id: "SHA",
    name: "Shanghai Hongqiao International Airport",
    city: "Shanghai",
    country: "China",
    lat: 31.197900772094727,
    lng: 121.33599853515625,
  },
  {
    id: "YNT",
    name: "Yantai Laishan Airport",
    city: "Yantai",
    country: "China",
    lat: 37.40169906616211,
    lng: 121.37200164794922,
  },
  {
    id: "CKG",
    name: "Chongqing Jiangbei International Airport",
    city: "Chongqing",
    country: "China",
    lat: 29.719200134277344,
    lng: 106.64199829101562,
  },
  {
    id: "KWE",
    name: "Longdongbao Airport",
    city: "Guiyang",
    country: "China",
    lat: 26.53849983215332,
    lng: 106.8010025024414,
  },
  {
    id: "CTU",
    name: "Chengdu Shuangliu International Airport",
    city: "Chengdu",
    country: "China",
    lat: 30.578500747680664,
    lng: 103.9469985961914,
  },
  {
    id: "XIC",
    name: "Xichang Qingshan Airport",
    city: "Xichang",
    country: "China",
    lat: 27.989099502563477,
    lng: 102.18399810791016,
  },
  {
    id: "KHG",
    name: "Kashgar Airport",
    city: "Kashi",
    country: "China",
    lat: 39.5429000854,
    lng: 76.0199966431,
  },
  {
    id: "HTN",
    name: "Hotan Airport",
    city: "Hotan",
    country: "China",
    lat: 37.03850173950195,
    lng: 79.86489868164062,
  },
  {
    id: "URC",
    name: "Ürümqi Diwopu International Airport",
    city: "Urumqi",
    country: "China",
    lat: 43.907100677490234,
    lng: 87.47419738769531,
  },
  {
    id: "HRB",
    name: "Taiping Airport",
    city: "Harbin",
    country: "China",
    lat: 45.6234016418457,
    lng: 126.25,
  },
  {
    id: "MDG",
    name: "Mudanjiang Hailang International Airport",
    city: "Mudanjiang",
    country: "China",
    lat: 44.5241012573,
    lng: 129.569000244,
  },
  {
    id: "DLC",
    name: "Zhoushuizi Airport",
    city: "Dalian",
    country: "China",
    lat: 38.9656982421875,
    lng: 121.53900146484375,
  },
  {
    id: "PVG",
    name: "Shanghai Pudong International Airport",
    city: "Shanghai",
    country: "China",
    lat: 31.143400192260742,
    lng: 121.80500030517578,
  },
  {
    id: "TOD",
    name: "Pulau Tioman Airport",
    city: "Tioman",
    country: "Malaysia",
    lat: 2.8181800842285156,
    lng: 104.16000366210938,
  },
  {
    id: "SZB",
    name: "Sultan Abdul Aziz Shah International Airport",
    city: "Kuala Lumpur",
    country: "Malaysia",
    lat: 3.130579948425293,
    lng: 101.54900360107422,
  },
  {
    id: "NTQ",
    name: "Noto Airport",
    city: "Wajima",
    country: "Japan",
    lat: 37.2930984497,
    lng: 136.962005615,
  },
  {
    id: "HBE",
    name: "Borg El Arab International Airport",
    city: "Alexandria",
    country: "Egypt",
    lat: 30.917699813842773,
    lng: 29.696399688720703,
  },
  {
    id: "BTI",
    name: "Barter Island LRRS Airport",
    city: "Barter Island",
    country: "United States",
    lat: 70.1340026855,
    lng: -143.582000732,
  },
  {
    id: "N",
    name: "Wainwright Air Station",
    city: "Fort Wainwright",
    country: "United States",
    lat: 70.61340332,
    lng: -159.8600006,
  },
  {
    id: "LUR",
    name: "Cape Lisburne LRRS Airport",
    city: "Cape Lisburne",
    country: "United States",
    lat: 68.87509918,
    lng: -166.1100006,
  },
  {
    id: "PIZ",
    name: "Point Lay LRRS Airport",
    city: "Point Lay",
    country: "United States",
    lat: 69.73290253,
    lng: -163.0050049,
  },
  {
    id: "ITO",
    name: "Hilo International Airport",
    city: "Hilo",
    country: "United States",
    lat: 19.721399307250977,
    lng: -155.04800415039062,
  },
  {
    id: "ORL",
    name: "Orlando Executive Airport",
    city: "Orlando",
    country: "United States",
    lat: 28.5455,
    lng: -81.332901,
  },
  {
    id: "BTT",
    name: "Bettles Airport",
    city: "Bettles",
    country: "United States",
    lat: 66.91390228,
    lng: -151.529007,
  },
  {
    id: "N",
    name: "Clear Airport",
    city: "Clear Mews",
    country: "United States",
    lat: 64.301201,
    lng: -149.119995,
  },
  {
    id: "UTO",
    name: "Indian Mountain LRRS Airport",
    city: "Indian Mountains",
    country: "United States",
    lat: 65.99279785,
    lng: -153.7039948,
  },
  {
    id: "FYU",
    name: "Fort Yukon Airport",
    city: "Fort Yukon",
    country: "United States",
    lat: 66.57150268554688,
    lng: -145.25,
  },
  {
    id: "SVW",
    name: "Sparrevohn LRRS Airport",
    city: "Sparrevohn",
    country: "United States",
    lat: 61.09740067,
    lng: -155.5740051,
  },
  {
    id: "FRN",
    name: "Bryant Army Heliport",
    city: "Fort Richardson",
    country: "United States",
    lat: 61.26639938,
    lng: -149.6529999,
  },
  {
    id: "TLJ",
    name: "Tatalina LRRS Airport",
    city: "Tatalina",
    country: "United States",
    lat: 62.894401550299996,
    lng: -155.977005005,
  },
  {
    id: "CZF",
    name: "Cape Romanzof LRRS Airport",
    city: "Cape Romanzof",
    country: "United States",
    lat: 61.78030014,
    lng: -166.0390015,
  },
  {
    id: "BED",
    name: "Laurence G Hanscom Field",
    city: "Bedford",
    country: "United States",
    lat: 42.47000122,
    lng: -71.28900146,
  },
  {
    id: "SNP",
    name: "St Paul Island Airport",
    city: "St. Paul Island",
    country: "United States",
    lat: 57.167301177978516,
    lng: -170.22000122070312,
  },
  {
    id: "EHM",
    name: "Cape Newenham LRRS Airport",
    city: "Cape Newenham",
    country: "United States",
    lat: 58.646400451699996,
    lng: -162.06300354,
  },
  {
    id: "STG",
    name: "St George Airport",
    city: "Point Barrow",
    country: "United States",
    lat: 56.578300476100004,
    lng: -169.662002563,
  },
  {
    id: "ILI",
    name: "Iliamna Airport",
    city: "Iliamna",
    country: "United States",
    lat: 59.75439835,
    lng: -154.9109955,
  },
  {
    id: "PTU",
    name: "Platinum Airport",
    city: "Port Moller",
    country: "United States",
    lat: 59.01139831542969,
    lng: -161.82000732421875,
  },
  {
    id: "BMX",
    name: "Big Mountain Airport",
    city: "Big Mountain",
    country: "United States",
    lat: 59.3611984253,
    lng: -155.259002686,
  },
  {
    id: "OSC",
    name: "Oscoda Wurtsmith Airport",
    city: "Oscoda",
    country: "United States",
    lat: 44.451599,
    lng: -83.394096,
  },
  {
    id: "OAR",
    name: "Marina Municipal Airport",
    city: "Fort Ord",
    country: "United States",
    lat: 36.68190002,
    lng: -121.762001,
  },
  {
    id: "MHR",
    name: "Sacramento Mather Airport",
    city: "Sacramento",
    country: "United States",
    lat: 38.55390167,
    lng: -121.2979965,
  },
  {
    id: "BYS",
    name: "Bicycle Lake Army Air Field",
    city: "Fort Irwin",
    country: "United States",
    lat: 35.2804985046,
    lng: -116.629997253,
  },
  {
    id: "N",
    name: "Twentynine Palms (Self) Airport",
    city: "Twenty Nine Palms",
    country: "United States",
    lat: 34.2961998,
    lng: -116.1620026,
  },
  {
    id: "FSM",
    name: "Fort Smith Regional Airport",
    city: "Fort Smith",
    country: "United States",
    lat: 35.33660125732422,
    lng: -94.36740112304688,
  },
  {
    id: "MRI",
    name: "Merrill Field",
    city: "Anchorage",
    country: "United States",
    lat: 61.2135009765625,
    lng: -149.843994140625,
  },
  {
    id: "GNT",
    name: "Grants-Milan Municipal Airport",
    city: "Grants",
    country: "United States",
    lat: 35.167301178,
    lng: -107.902000427,
  },
  {
    id: "PNC",
    name: "Ponca City Regional Airport",
    city: "Ponca City",
    country: "United States",
    lat: 36.73199844,
    lng: -97.09980011,
  },
  {
    id: "SVN",
    name: "Hunter Army Air Field",
    city: "Hunter Aaf",
    country: "United States",
    lat: 32.00999832,
    lng: -81.14569855,
  },
  {
    id: "GFK",
    name: "Grand Forks International Airport",
    city: "Grand Forks",
    country: "United States",
    lat: 47.949299,
    lng: -97.176102,
  },
  {
    id: "PBF",
    name: "Pine Bluff Regional Airport, Grider Field",
    city: "Pine Bluff",
    country: "United States",
    lat: 34.1731,
    lng: -91.9356,
  },
  {
    id: "NSE",
    name: "Whiting Field Naval Air Station - North",
    city: "Milton",
    country: "United States",
    lat: 30.7241993,
    lng: -87.02189636,
  },
  {
    id: "HNM",
    name: "Hana Airport",
    city: "Hana",
    country: "United States",
    lat: 20.79560089111328,
    lng: -156.01400756835938,
  },
  {
    id: "PRC",
    name: "Ernest A. Love Field",
    city: "Prescott",
    country: "United States",
    lat: 34.65449905,
    lng: -112.4199982,
  },
  {
    id: "TTN",
    name: "Trenton Mercer Airport",
    city: "Trenton",
    country: "United States",
    lat: 40.27669906616211,
    lng: -74.8134994506836,
  },
  {
    id: "BOS",
    name: "General Edward Lawrence Logan International Airport",
    city: "Boston",
    country: "United States",
    lat: 42.36429977,
    lng: -71.00520325,
  },
  {
    id: "SUU",
    name: "Travis Air Force Base",
    city: "Fairfield",
    country: "United States",
    lat: 38.262699127197,
    lng: -121.92700195312,
  },
  {
    id: "RME",
    name: "Griffiss International Airport",
    city: "Rome",
    country: "United States",
    lat: 43.23379898,
    lng: -75.40699768,
  },
  {
    id: "ENV",
    name: "Wendover Airport",
    city: "Wendover",
    country: "United States",
    lat: 40.7187004089,
    lng: -114.03099823,
  },
  {
    id: "BFM",
    name: "Mobile Downtown Airport",
    city: "Mobile",
    country: "United States",
    lat: 30.626800537100003,
    lng: -88.06809997559999,
  },
  {
    id: "OAK",
    name: "Metropolitan Oakland International Airport",
    city: "Oakland",
    country: "United States",
    lat: 37.721298,
    lng: -122.221001,
  },
  {
    id: "OMA",
    name: "Eppley Airfield",
    city: "Omaha",
    country: "United States",
    lat: 41.3032,
    lng: -95.894096,
  },
  {
    id: "N",
    name: "Port Angeles Cgas Airport",
    city: "Port Angeles",
    country: "United States",
    lat: 48.14149856567383,
    lng: -123.41400146484375,
  },
  {
    id: "OGG",
    name: "Kahului Airport",
    city: "Kahului",
    country: "United States",
    lat: 20.8986,
    lng: -156.429993,
  },
  {
    id: "ICT",
    name: "Wichita Eisenhower National Airport",
    city: "Wichita",
    country: "United States",
    lat: 37.649899,
    lng: -97.433098,
  },
  {
    id: "MCI",
    name: "Kansas City International Airport",
    city: "Kansas City",
    country: "United States",
    lat: 39.2976,
    lng: -94.713898,
  },
  {
    id: "MSN",
    name: "Dane County Regional Truax Field",
    city: "Madison",
    country: "United States",
    lat: 43.13990020751953,
    lng: -89.3375015258789,
  },
  {
    id: "DLG",
    name: "Dillingham Airport",
    city: "Dillingham",
    country: "United States",
    lat: 59.04470062,
    lng: -158.5050049,
  },
  {
    id: "HRO",
    name: "Boone County Airport",
    city: "Harrison",
    country: "United States",
    lat: 36.26150131225586,
    lng: -93.15470123291016,
  },
  {
    id: "PHX",
    name: "Phoenix Sky Harbor International Airport",
    city: "Phoenix",
    country: "United States",
    lat: 33.43429946899414,
    lng: -112.01200103759766,
  },
  {
    id: "BGR",
    name: "Bangor International Airport",
    city: "Bangor",
    country: "United States",
    lat: 44.80739974975586,
    lng: -68.8281021118164,
  },
  {
    id: "FXE",
    name: "Fort Lauderdale Executive Airport",
    city: "Fort Lauderdale",
    country: "United States",
    lat: 26.1972999573,
    lng: -80.1707000732,
  },
  {
    id: "GGG",
    name: "East Texas Regional Airport",
    city: "Longview",
    country: "United States",
    lat: 32.38399887084961,
    lng: -94.71150207519531,
  },
  {
    id: "AND",
    name: "Anderson Regional Airport",
    city: "Andersen",
    country: "United States",
    lat: 34.4945983887,
    lng: -82.70939636230001,
  },
  {
    id: "GEG",
    name: "Spokane International Airport",
    city: "Spokane",
    country: "United States",
    lat: 47.61989974975586,
    lng: -117.53399658203125,
  },
  {
    id: "HWO",
    name: "North Perry Airport",
    city: "Hollywood",
    country: "United States",
    lat: 26.0012,
    lng: -80.2407,
  },
  {
    id: "SFO",
    name: "San Francisco International Airport",
    city: "San Francisco",
    country: "United States",
    lat: 37.61899948120117,
    lng: -122.375,
  },
  {
    id: "CTB",
    name: "Cut Bank International Airport",
    city: "Cutbank",
    country: "United States",
    lat: 48.6083984375,
    lng: -112.375999451,
  },
  {
    id: "ARA",
    name: "Acadiana Regional Airport",
    city: "Louisiana",
    country: "United States",
    lat: 30.0378,
    lng: -91.883904,
  },
  {
    id: "GNV",
    name: "Gainesville Regional Airport",
    city: "Gainesville",
    country: "United States",
    lat: 29.6900997162,
    lng: -82.2717971802,
  },
  {
    id: "MEM",
    name: "Memphis International Airport",
    city: "Memphis",
    country: "United States",
    lat: 35.04240036010742,
    lng: -89.97669982910156,
  },
  {
    id: "DUG",
    name: "Bisbee Douglas International Airport",
    city: "Douglas",
    country: "United States",
    lat: 31.4689998627,
    lng: -109.603996277,
  },
  {
    id: "BIG",
    name: "Allen Army Airfield",
    city: "Delta Junction",
    country: "United States",
    lat: 63.9944992065,
    lng: -145.722000122,
  },
  {
    id: "CNW",
    name: "TSTC Waco Airport",
    city: "Waco",
    country: "United States",
    lat: 31.637800216699997,
    lng: -97.0740966797,
  },
  {
    id: "ANN",
    name: "Annette Island Airport",
    city: "Annette Island",
    country: "United States",
    lat: 55.04240036010742,
    lng: -131.57200622558594,
  },
  {
    id: "CAR",
    name: "Caribou Municipal Airport",
    city: "Caribou",
    country: "United States",
    lat: 46.871498107899995,
    lng: -68.0178985596,
  },
  {
    id: "LRF",
    name: "Little Rock Air Force Base",
    city: "Jacksonville",
    country: "United States",
    lat: 34.916900634799994,
    lng: -92.14969635010002,
  },
  {
    id: "HUA",
    name: "Redstone Army Air Field",
    city: "Redstone",
    country: "United States",
    lat: 34.67869949,
    lng: -86.68479919,
  },
  {
    id: "POB",
    name: "Pope Field",
    city: "Fort Bragg",
    country: "United States",
    lat: 35.1708984375,
    lng: -79.014503479004,
  },
  {
    id: "DHT",
    name: "Dalhart Municipal Airport",
    city: "Dalhart",
    country: "United States",
    lat: 36.0225982666,
    lng: -102.54699707,
  },
  {
    id: "DLF",
    name: "DLF Airport",
    city: "Del Rio",
    country: "United States",
    lat: 29.359501,
    lng: -100.778002,
  },
  {
    id: "LAX",
    name: "Los Angeles International Airport",
    city: "Los Angeles",
    country: "United States",
    lat: 33.94250107,
    lng: -118.4079971,
  },
  {
    id: "ANB",
    name: "Anniston Regional Airport",
    city: "Anniston",
    country: "United States",
    lat: 33.5882,
    lng: -85.8581,
  },
  {
    id: "CLE",
    name: "Cleveland Hopkins International Airport",
    city: "Cleveland",
    country: "United States",
    lat: 41.4117012024,
    lng: -81.8498001099,
  },
  {
    id: "DOV",
    name: "Dover Air Force Base",
    city: "Dover",
    country: "United States",
    lat: 39.12950134,
    lng: -75.46600342,
  },
  {
    id: "CVG",
    name: "Cincinnati Northern Kentucky International Airport",
    city: "Cincinnati",
    country: "United States",
    lat: 39.0488014221,
    lng: -84.6678009033,
  },
  {
    id: "FME",
    name: "Tipton Airport",
    city: "Fort Meade",
    country: "United States",
    lat: 39.08539962769999,
    lng: -76.7593994141,
  },
  {
    id: "N",
    name: "China Lake Naws (Armitage Field) Airport",
    city: "China Lake",
    country: "United States",
    lat: 35.6853981,
    lng: -117.6920013,
  },
  {
    id: "HON",
    name: "Huron Regional Airport",
    city: "Huron",
    country: "United States",
    lat: 44.38520050048828,
    lng: -98.22850036621094,
  },
  {
    id: "JNU",
    name: "Juneau International Airport",
    city: "Juneau",
    country: "United States",
    lat: 58.35499954223633,
    lng: -134.5760040283203,
  },
  {
    id: "LFT",
    name: "Lafayette Regional Airport",
    city: "Lafayette",
    country: "United States",
    lat: 30.20529938,
    lng: -91.98760223,
  },
  {
    id: "EWR",
    name: "Newark Liberty International Airport",
    city: "Newark",
    country: "United States",
    lat: 40.692501068115234,
    lng: -74.168701171875,
  },
  {
    id: "BOI",
    name: "Boise Air Terminal/Gowen Field",
    city: "Boise",
    country: "United States",
    lat: 43.5644,
    lng: -116.223,
  },
  {
    id: "INS",
    name: "Creech Air Force Base",
    city: "Indian Springs",
    country: "United States",
    lat: 36.587200164799995,
    lng: -115.672996521,
  },
  {
    id: "GCK",
    name: "Garden City Regional Airport",
    city: "Garden City",
    country: "United States",
    lat: 37.9275016785,
    lng: -100.723999023,
  },
  {
    id: "MOT",
    name: "Minot International Airport",
    city: "Minot",
    country: "United States",
    lat: 48.2593994140625,
    lng: -101.27999877929688,
  },
  {
    id: "HHI",
    name: "Wheeler Army Airfield",
    city: "Wahiawa",
    country: "United States",
    lat: 21.48349953,
    lng: -158.0399933,
  },
  {
    id: "MXF",
    name: "Maxwell Air Force Base",
    city: "Montgomery",
    country: "United States",
    lat: 32.3829,
    lng: -86.365799,
  },
  {
    id: "N",
    name: "Robinson Army Air Field",
    city: "Robinson",
    country: "United States",
    lat: 34.85010147,
    lng: -92.30020142,
  },
  {
    id: "DAL",
    name: "Dallas Love Field",
    city: "Dallas",
    country: "United States",
    lat: 32.847099,
    lng: -96.851799,
  },
  {
    id: "FCS",
    name: "Butts AAF (Fort Carson) Air Field",
    city: "Fort Carson",
    country: "United States",
    lat: 38.67839813,
    lng: -104.7570038,
  },
  {
    id: "HLN",
    name: "Helena Regional Airport",
    city: "Helena",
    country: "United States",
    lat: 46.6068000793457,
    lng: -111.98300170898438,
  },
  {
    id: "NKX",
    name: "Miramar Marine Corps Air Station - Mitscher Field",
    city: "Miramar",
    country: "United States",
    lat: 32.86840057,
    lng: -117.1429977,
  },
  {
    id: "LUF",
    name: "Luke Air Force Base",
    city: "Phoenix",
    country: "United States",
    lat: 33.534999847399995,
    lng: -112.383003235,
  },
  {
    id: "N",
    name: "Hurlburt Field",
    city: "Mary Esther",
    country: "United States",
    lat: 30.427799224853516,
    lng: -86.68930053710938,
  },
  {
    id: "HHR",
    name: "Jack Northrop Field Hawthorne Municipal Airport",
    city: "Hawthorne",
    country: "United States",
    lat: 33.922798,
    lng: -118.334999,
  },
  {
    id: "HUL",
    name: "Houlton International Airport",
    city: "Houlton",
    country: "United States",
    lat: 46.1231002808,
    lng: -67.792098999,
  },
  {
    id: "END",
    name: "Vance Air Force Base",
    city: "Enid",
    country: "United States",
    lat: 36.339199066199996,
    lng: -97.9164962769,
  },
  {
    id: "NTD",
    name: "Point Mugu Naval Air Station (Naval Base Ventura Co)",
    city: "Point Mugu",
    country: "United States",
    lat: 34.120300293,
    lng: -119.121002197,
  },
  {
    id: "EDW",
    name: "Edwards Air Force Base",
    city: "Edwards Afb",
    country: "United States",
    lat: 34.905399,
    lng: -117.884003,
  },
  {
    id: "LCH",
    name: "Lake Charles Regional Airport",
    city: "Lake Charles",
    country: "United States",
    lat: 30.126100540161133,
    lng: -93.22329711914062,
  },
  {
    id: "KOA",
    name: "Ellison Onizuka Kona International At Keahole Airport",
    city: "Kona",
    country: "United States",
    lat: 19.738783,
    lng: -156.045603,
  },
  {
    id: "MYR",
    name: "Myrtle Beach International Airport",
    city: "Myrtle Beach",
    country: "United States",
    lat: 33.6796989441,
    lng: -78.9282989502,
  },
  {
    id: "NLC",
    name: "Lemoore Naval Air Station (Reeves Field) Airport",
    city: "Lemoore",
    country: "United States",
    lat: 36.33300018,
    lng: -119.9520035,
  },
  {
    id: "ACK",
    name: "Nantucket Memorial Airport",
    city: "Nantucket",
    country: "United States",
    lat: 41.25310135,
    lng: -70.06020355,
  },
  {
    id: "FAF",
    name: "Felker Army Air Field",
    city: "Fort Eustis",
    country: "United States",
    lat: 37.132499694799996,
    lng: -76.60880279540001,
  },
  {
    id: "HOP",
    name: "Campbell AAF (Fort Campbell) Air Field",
    city: "Hopkinsville",
    country: "United States",
    lat: 36.668598175,
    lng: -87.49620056150002,
  },
  {
    id: "DCA",
    name: "Ronald Reagan Washington National Airport",
    city: "Washington",
    country: "United States",
    lat: 38.8521,
    lng: -77.037697,
  },
  {
    id: "NHK",
    name: "Patuxent River Naval Air Station (Trapnell Field)",
    city: "Patuxent River",
    country: "United States",
    lat: 38.285999,
    lng: -76.411797,
  },
  {
    id: "PSX",
    name: "Palacios Municipal Airport",
    city: "Palacios",
    country: "United States",
    lat: 28.727500915527,
    lng: -96.250999450684,
  },
  {
    id: "BYH",
    name: "Arkansas International Airport",
    city: "Blytheville",
    country: "United States",
    lat: 35.9642982483,
    lng: -89.94400024410001,
  },
  {
    id: "ACY",
    name: "Atlantic City International Airport",
    city: "Atlantic City",
    country: "United States",
    lat: 39.45759963989258,
    lng: -74.57720184326172,
  },
  {
    id: "TIK",
    name: "Tinker Air Force Base",
    city: "Oklahoma City",
    country: "United States",
    lat: 35.414699554443,
    lng: -97.386596679688,
  },
  {
    id: "ECG",
    name: "Elizabeth City Regional Airport & Coast Guard Air Station",
    city: "Elizabeth City",
    country: "United States",
    lat: 36.26060104,
    lng: -76.17459869,
  },
  {
    id: "PUB",
    name: "Pueblo Memorial Airport",
    city: "Pueblo",
    country: "United States",
    lat: 38.289100646972656,
    lng: -104.49700164794922,
  },
  {
    id: "PQI",
    name: "Northern Maine Regional Airport at Presque Isle",
    city: "Presque Isle",
    country: "United States",
    lat: 46.68899918,
    lng: -68.0447998,
  },
  {
    id: "GRF",
    name: "Gray Army Air Field",
    city: "Fort Lewis",
    country: "United States",
    lat: 47.07920074,
    lng: -122.5810013,
  },
  {
    id: "ADQ",
    name: "Kodiak Airport",
    city: "Kodiak",
    country: "United States",
    lat: 57.75,
    lng: -152.4940033,
  },
  {
    id: "UPP",
    name: "Upolu Airport",
    city: "Opolu",
    country: "United States",
    lat: 20.265300750732422,
    lng: -155.86000061035156,
  },
  {
    id: "FLL",
    name: "Fort Lauderdale Hollywood International Airport",
    city: "Fort Lauderdale",
    country: "United States",
    lat: 26.072599,
    lng: -80.152702,
  },
  {
    id: "N",
    name: "Muskogee-Davis Regional Airport",
    city: "Muskogee",
    country: "United States",
    lat: 35.656502,
    lng: -95.366699,
  },
  {
    id: "INL",
    name: "Falls International Airport",
    city: "International Falls",
    country: "United States",
    lat: 48.566200256347656,
    lng: -93.4030990600586,
  },
  {
    id: "SLC",
    name: "Salt Lake City International Airport",
    city: "Salt Lake City",
    country: "United States",
    lat: 40.78839874267578,
    lng: -111.97799682617188,
  },
  {
    id: "CDS",
    name: "Childress Municipal Airport",
    city: "Childress",
    country: "United States",
    lat: 34.4337997437,
    lng: -100.288002014,
  },
  {
    id: "BIX",
    name: "Keesler Air Force Base",
    city: "Biloxi",
    country: "United States",
    lat: 30.4104003906,
    lng: -88.92440032959999,
  },
  {
    id: "LSF",
    name: "Lawson Army Air Field (Fort Benning)",
    city: "Fort Benning",
    country: "United States",
    lat: 32.337299346900004,
    lng: -84.9913024902,
  },
  {
    id: "NQI",
    name: "Kingsville Naval Air Station",
    city: "Kingsville",
    country: "United States",
    lat: 27.5072002411,
    lng: -97.8097000122,
  },
  {
    id: "FRI",
    name: "Marshall Army Air Field",
    city: "Fort Riley",
    country: "United States",
    lat: 39.05530167,
    lng: -96.76450348,
  },
  {
    id: "MDT",
    name: "Harrisburg International Airport",
    city: "Harrisburg",
    country: "United States",
    lat: 40.1935005188,
    lng: -76.7633972168,
  },
  {
    id: "LNK",
    name: "Lincoln Airport",
    city: "Lincoln",
    country: "United States",
    lat: 40.85100173950195,
    lng: -96.75920104980469,
  },
  {
    id: "LAN",
    name: "Capital City Airport",
    city: "Lansing",
    country: "United States",
    lat: 42.77870178222656,
    lng: -84.58740234375,
  },
  {
    id: "MUE",
    name: "Waimea Kohala Airport",
    city: "Kamuela",
    country: "United States",
    lat: 20.001300811767578,
    lng: -155.66799926757812,
  },
  {
    id: "MSS",
    name: "Massena International Richards Field",
    city: "Massena",
    country: "United States",
    lat: 44.93579864501953,
    lng: -74.84559631347656,
  },
  {
    id: "HKY",
    name: "Hickory Regional Airport",
    city: "Hickory",
    country: "United States",
    lat: 35.74110031,
    lng: -81.38950348,
  },
  {
    id: "SPG",
    name: "Albert Whitted Airport",
    city: "St. Petersburg",
    country: "United States",
    lat: 27.7651,
    lng: -82.626999,
  },
  {
    id: "FMY",
    name: "Page Field",
    city: "Fort Myers",
    country: "United States",
    lat: 26.58659935,
    lng: -81.86329650879999,
  },
  {
    id: "IAH",
    name: "George Bush Intercontinental Houston Airport",
    city: "Houston",
    country: "United States",
    lat: 29.984399795532227,
    lng: -95.34140014648438,
  },
  {
    id: "N",
    name: "Millinocket Municipal Airport",
    city: "Millinocket",
    country: "United States",
    lat: 45.64780044555664,
    lng: -68.68560028076172,
  },
  {
    id: "ADW",
    name: "Joint Base Andrews",
    city: "Camp Springs",
    country: "United States",
    lat: 38.810799,
    lng: -76.866997,
  },
  {
    id: "INT",
    name: "Smith Reynolds Airport",
    city: "Winston-salem",
    country: "United States",
    lat: 36.13370132446289,
    lng: -80.22200012207031,
  },
  {
    id: "VCV",
    name: "Southern California Logistics Airport",
    city: "Victorville",
    country: "United States",
    lat: 34.597499847399995,
    lng: -117.383003235,
  },
  {
    id: "CEW",
    name: "Bob Sikes Airport",
    city: "Crestview",
    country: "United States",
    lat: 30.778799057,
    lng: -86.522102356,
  },
  {
    id: "N",
    name: "Wheeler Sack Army Air Field",
    city: "Fort Drum",
    country: "United States",
    lat: 44.05559921,
    lng: -75.71949768,
  },
  {
    id: "PHN",
    name: "St Clair County International Airport",
    city: "Port Huron",
    country: "United States",
    lat: 42.9109993,
    lng: -82.52890015,
  },
  {
    id: "BFL",
    name: "Meadows Field",
    city: "Bakersfield",
    country: "United States",
    lat: 35.43360138,
    lng: -119.0569992,
  },
  {
    id: "ELP",
    name: "El Paso International Airport",
    city: "El Paso",
    country: "United States",
    lat: 31.80719948,
    lng: -106.3779984,
  },
  {
    id: "HRL",
    name: "Valley International Airport",
    city: "Harlingen",
    country: "United States",
    lat: 26.228500366210938,
    lng: -97.65440368652344,
  },
  {
    id: "CAE",
    name: "Columbia Metropolitan Airport",
    city: "Columbia",
    country: "United States",
    lat: 33.93880081176758,
    lng: -81.11949920654297,
  },
  {
    id: "DMA",
    name: "Davis Monthan Air Force Base",
    city: "Tucson",
    country: "United States",
    lat: 32.1665000916,
    lng: -110.883003235,
  },
  {
    id: "NPA",
    name: "Pensacola Naval Air Station/Forrest Sherman Field",
    city: "Pensacola",
    country: "United States",
    lat: 30.35269928,
    lng: -87.31860352,
  },
  {
    id: "PNS",
    name: "Pensacola Regional Airport",
    city: "Pensacola",
    country: "United States",
    lat: 30.473400115967,
    lng: -87.186599731445,
  },
  {
    id: "RDR",
    name: "Grand Forks Air Force Base",
    city: "Red River",
    country: "United States",
    lat: 47.961101532,
    lng: -97.4011993408,
  },
  {
    id: "HOU",
    name: "William P Hobby Airport",
    city: "Houston",
    country: "United States",
    lat: 29.64539909,
    lng: -95.27890015,
  },
  {
    id: "BFK",
    name: "Buckley Air Force Base",
    city: "Buckley",
    country: "United States",
    lat: 39.701698303200004,
    lng: -104.751998901,
  },
  {
    id: "ORT",
    name: "Northway Airport",
    city: "Northway",
    country: "United States",
    lat: 62.9612999,
    lng: -141.9290009,
  },
  {
    id: "PAQ",
    name: 'Warren "Bud" Woods Palmer Municipal Airport',
    city: "Palmer",
    country: "United States",
    lat: 61.594898,
    lng: -149.08901,
  },
  {
    id: "PIT",
    name: "Pittsburgh International Airport",
    city: "Pittsburgh",
    country: "United States",
    lat: 40.49150085,
    lng: -80.23290253,
  },
  {
    id: "BRW",
    name: "Wiley Post Will Rogers Memorial Airport",
    city: "Barrow",
    country: "United States",
    lat: 71.285402,
    lng: -156.766008,
  },
  {
    id: "EFD",
    name: "Ellington Airport",
    city: "Houston",
    country: "United States",
    lat: 29.607299804700002,
    lng: -95.1587982178,
  },
  {
    id: "NUW",
    name: "Whidbey Island Naval Air Station (Ault Field)",
    city: "Whidbey Island",
    country: "United States",
    lat: 48.351799,
    lng: -122.655998,
  },
  {
    id: "ALI",
    name: "Alice International Airport",
    city: "Alice",
    country: "United States",
    lat: 27.740900039699998,
    lng: -98.02690124510002,
  },
  {
    id: "VAD",
    name: "Moody Air Force Base",
    city: "Valdosta",
    country: "United States",
    lat: 30.9678001404,
    lng: -83.1930007935,
  },
  {
    id: "MIA",
    name: "Miami International Airport",
    city: "Miami",
    country: "United States",
    lat: 25.79319953918457,
    lng: -80.29060363769531,
  },
  {
    id: "SEA",
    name: "Seattle Tacoma International Airport",
    city: "Seattle",
    country: "United States",
    lat: 47.449001,
    lng: -122.308998,
  },
  {
    id: "CHA",
    name: "Lovell Field",
    city: "Chattanooga",
    country: "United States",
    lat: 35.035301208496094,
    lng: -85.20379638671875,
  },
  {
    id: "BDR",
    name: "Igor I Sikorsky Memorial Airport",
    city: "Stratford",
    country: "United States",
    lat: 41.16350173950195,
    lng: -73.1261978149414,
  },
  {
    id: "JAN",
    name: "Jackson-Medgar Wiley Evers International Airport",
    city: "Jackson",
    country: "United States",
    lat: 32.3111991882,
    lng: -90.0758972168,
  },
  {
    id: "GLS",
    name: "Scholes International At Galveston Airport",
    city: "Galveston",
    country: "United States",
    lat: 29.265300750732422,
    lng: -94.86039733886719,
  },
  {
    id: "LGB",
    name: "Long Beach /Daugherty Field/ Airport",
    city: "Long Beach",
    country: "United States",
    lat: 33.81769943,
    lng: -118.1520004,
  },
  {
    id: "HDH",
    name: "Dillingham Airfield",
    city: "Dillingham",
    country: "United States",
    lat: 21.5795001984,
    lng: -158.197006226,
  },
  {
    id: "IPT",
    name: "Williamsport Regional Airport",
    city: "Williamsport",
    country: "United States",
    lat: 41.241798400878906,
    lng: -76.92109680175781,
  },
  {
    id: "IND",
    name: "Indianapolis International Airport",
    city: "Indianapolis",
    country: "United States",
    lat: 39.7173,
    lng: -86.294403,
  },
  {
    id: "SZL",
    name: "Whiteman Air Force Base",
    city: "Knobnoster",
    country: "United States",
    lat: 38.73030090332,
    lng: -93.547897338867,
  },
  {
    id: "AKC",
    name: "Akron Fulton International Airport",
    city: "Akron",
    country: "United States",
    lat: 41.0374984741,
    lng: -81.4669036865,
  },
  {
    id: "GWO",
    name: "Greenwood–Leflore Airport",
    city: "Greenwood",
    country: "United States",
    lat: 33.4943008423,
    lng: -90.0847015381,
  },
  {
    id: "HPN",
    name: "Westchester County Airport",
    city: "White Plains",
    country: "United States",
    lat: 41.06700134277344,
    lng: -73.70760345458984,
  },
  {
    id: "FOK",
    name: "Francis S Gabreski Airport",
    city: "West Hampton Beach",
    country: "United States",
    lat: 40.8437004089,
    lng: -72.6317977905,
  },
  {
    id: "JBR",
    name: "Jonesboro Municipal Airport",
    city: "Jonesboro",
    country: "United States",
    lat: 35.83169937133789,
    lng: -90.64640045166016,
  },
  {
    id: "XSD",
    name: "Tonopah Test Range Airport",
    city: "Tonopah",
    country: "United States",
    lat: 37.7988014221,
    lng: -116.78099823,
  },
  {
    id: "LNA",
    name: "Palm Beach County Park Airport",
    city: "West Palm Beach",
    country: "United States",
    lat: 26.59300041,
    lng: -80.08509827,
  },
  {
    id: "NZY",
    name: "North Island Naval Air Station-Halsey Field",
    city: "San Diego",
    country: "United States",
    lat: 32.69919968,
    lng: -117.2149963,
  },
  {
    id: "BIF",
    name: "Biggs Army Air Field (Fort Bliss)",
    city: "El Paso",
    country: "United States",
    lat: 31.84950066,
    lng: -106.3799973,
  },
  {
    id: "YUM",
    name: "Yuma MCAS/Yuma International Airport",
    city: "Yuma",
    country: "United States",
    lat: 32.65660095,
    lng: -114.6060028,
  },
  {
    id: "CNM",
    name: "Cavern City Air Terminal",
    city: "Carlsbad",
    country: "United States",
    lat: 32.337501525878906,
    lng: -104.26300048828125,
  },
  {
    id: "DLH",
    name: "Duluth International Airport",
    city: "Duluth",
    country: "United States",
    lat: 46.8420982361,
    lng: -92.19360351559999,
  },
  {
    id: "BET",
    name: "Bethel Airport",
    city: "Bethel",
    country: "United States",
    lat: 60.77980042,
    lng: -161.8379974,
  },
  {
    id: "LOU",
    name: "Bowman Field",
    city: "Louisville",
    country: "United States",
    lat: 38.2280006409,
    lng: -85.6636962891,
  },
  {
    id: "FHU",
    name: "Sierra Vista Municipal Libby Army Air Field",
    city: "Fort Huachuca",
    country: "United States",
    lat: 31.588499069213867,
    lng: -110.34400177001953,
  },
  {
    id: "LIH",
    name: "Lihue Airport",
    city: "Lihue",
    country: "United States",
    lat: 21.97599983215332,
    lng: -159.33900451660156,
  },
  {
    id: "HUF",
    name: "Terre Haute Regional Airport, Hulman Field",
    city: "Terre Haute",
    country: "United States",
    lat: 39.4515,
    lng: -87.307602,
  },
  {
    id: "HVR",
    name: "Havre City County Airport",
    city: "Havre",
    country: "United States",
    lat: 48.54299927,
    lng: -109.762001,
  },
  {
    id: "MWH",
    name: "Grant County International Airport",
    city: "Grant County Airport",
    country: "United States",
    lat: 47.20769882,
    lng: -119.3199997,
  },
  {
    id: "MPV",
    name: "Edward F Knapp State Airport",
    city: "Montpelier",
    country: "United States",
    lat: 44.20349884,
    lng: -72.56230164,
  },
  {
    id: "N",
    name: "San Nicolas Island Nolf Airport",
    city: "San Nicolas Island",
    country: "United States",
    lat: 33.23979949951172,
    lng: -119.45800018310547,
  },
  {
    id: "RIC",
    name: "Richmond International Airport",
    city: "Richmond",
    country: "United States",
    lat: 37.50519943237305,
    lng: -77.3197021484375,
  },
  {
    id: "SHV",
    name: "Shreveport Regional Airport",
    city: "Shreveport",
    country: "United States",
    lat: 32.446602,
    lng: -93.8256,
  },
  {
    id: "CDV",
    name: "Merle K (Mudhole) Smith Airport",
    city: "Cordova",
    country: "United States",
    lat: 60.4917984,
    lng: -145.4779968,
  },
  {
    id: "ORF",
    name: "Norfolk International Airport",
    city: "Norfolk",
    country: "United States",
    lat: 36.89459991455078,
    lng: -76.20120239257812,
  },
  {
    id: "BPT",
    name: "Southeast Texas Regional Airport",
    city: "Beaumont",
    country: "United States",
    lat: 29.9507999420166,
    lng: -94.02069854736328,
  },
  {
    id: "SAV",
    name: "Savannah Hilton Head International Airport",
    city: "Savannah",
    country: "United States",
    lat: 32.12760162,
    lng: -81.20210266,
  },
  {
    id: "HIF",
    name: "Hill Air Force Base",
    city: "Ogden",
    country: "United States",
    lat: 41.12403,
    lng: -111.973086,
  },
  {
    id: "OME",
    name: "Nome Airport",
    city: "Nome",
    country: "United States",
    lat: 64.51219940185547,
    lng: -165.44500732421875,
  },
  {
    id: "N",
    name: "Scappoose Industrial Airpark",
    city: "San Luis",
    country: "United States",
    lat: 45.770999908447266,
    lng: -122.86199951171875,
  },
  {
    id: "PIE",
    name: "St Petersburg Clearwater International Airport",
    city: "St. Petersburg",
    country: "United States",
    lat: 27.91020012,
    lng: -82.68740082,
  },
  {
    id: "MNM",
    name: "Menominee Regional Airport",
    city: "Macon",
    country: "United States",
    lat: 45.126701,
    lng: -87.638397,
  },
  {
    id: "CXO",
    name: "Conroe-North Houston Regional Airport",
    city: "Conroe",
    country: "United States",
    lat: 30.351801,
    lng: -95.414497,
  },
  {
    id: "SCC",
    name: "Deadhorse Airport",
    city: "Deadhorse",
    country: "United States",
    lat: 70.19470215,
    lng: -148.4649963,
  },
  {
    id: "SAT",
    name: "San Antonio International Airport",
    city: "San Antonio",
    country: "United States",
    lat: 29.533700942993164,
    lng: -98.46980285644531,
  },
  {
    id: "ROC",
    name: "Greater Rochester International Airport",
    city: "Rochester",
    country: "United States",
    lat: 43.118900299072266,
    lng: -77.67240142822266,
  },
  {
    id: "COF",
    name: "Patrick Air Force Base",
    city: "Coco Beach",
    country: "United States",
    lat: 28.2348995209,
    lng: -80.6100997925,
  },
  {
    id: "TEB",
    name: "Teterboro Airport",
    city: "Teterboro",
    country: "United States",
    lat: 40.85010147089999,
    lng: -74.060798645,
  },
  {
    id: "RCA",
    name: "Ellsworth Air Force Base",
    city: "Rapid City",
    country: "United States",
    lat: 44.14500046,
    lng: -103.1039963,
  },
  {
    id: "RDU",
    name: "Raleigh Durham International Airport",
    city: "Raleigh-durham",
    country: "United States",
    lat: 35.877601623535156,
    lng: -78.7874984741211,
  },
  {
    id: "DAY",
    name: "James M Cox Dayton International Airport",
    city: "Dayton",
    country: "United States",
    lat: 39.902400970458984,
    lng: -84.21939849853516,
  },
  {
    id: "ENA",
    name: "Kenai Municipal Airport",
    city: "Kenai",
    country: "United States",
    lat: 60.57310104370117,
    lng: -151.2449951171875,
  },
  {
    id: "MLC",
    name: "Mc Alester Regional Airport",
    city: "Mcalester",
    country: "United States",
    lat: 34.882401,
    lng: -95.783501,
  },
  {
    id: "IAG",
    name: "Niagara Falls International Airport",
    city: "Niagara Falls",
    country: "United States",
    lat: 43.1072998046875,
    lng: -78.94619750976562,
  },
  {
    id: "CFD",
    name: "Coulter Field",
    city: "Bryan",
    country: "United States",
    lat: 30.715700149499998,
    lng: -96.3313980103,
  },
  {
    id: "LIY",
    name: "Wright AAF (Fort Stewart)/Midcoast Regional Airport",
    city: "Wright",
    country: "United States",
    lat: 31.889099,
    lng: -81.562303,
  },
  {
    id: "PHF",
    name: "Newport News Williamsburg International Airport",
    city: "Newport News",
    country: "United States",
    lat: 37.13190079,
    lng: -76.49299622,
  },
  {
    id: "ESF",
    name: "Esler Regional Airport",
    city: "Alexandria",
    country: "United States",
    lat: 31.3948993683,
    lng: -92.2957992554,
  },
  {
    id: "LTS",
    name: "Altus Air Force Base",
    city: "Altus",
    country: "United States",
    lat: 34.667098999,
    lng: -99.2667007446,
  },
  {
    id: "TUS",
    name: "Tucson International Airport",
    city: "Tucson",
    country: "United States",
    lat: 32.1161003112793,
    lng: -110.94100189208984,
  },
  {
    id: "MIB",
    name: "Minot Air Force Base",
    city: "Minot",
    country: "United States",
    lat: 48.4156,
    lng: -101.358002,
  },
  {
    id: "BAB",
    name: "Beale Air Force Base",
    city: "Marysville",
    country: "United States",
    lat: 39.136100769,
    lng: -121.43699646,
  },
  {
    id: "IKK",
    name: "Greater Kankakee Airport",
    city: "Kankakee",
    country: "United States",
    lat: 41.07139968869999,
    lng: -87.8462982178,
  },
  {
    id: "GSB",
    name: "Seymour Johnson Air Force Base",
    city: "Goldsboro",
    country: "United States",
    lat: 35.33940125,
    lng: -77.96060181,
  },
  {
    id: "PVD",
    name: "Theodore Francis Green State Airport",
    city: "Providence",
    country: "United States",
    lat: 41.732601,
    lng: -71.420403,
  },
  {
    id: "SBY",
    name: "Salisbury Ocean City Wicomico Regional Airport",
    city: "Salisbury",
    country: "United States",
    lat: 38.34049987792969,
    lng: -75.51029968261719,
  },
  {
    id: "N",
    name: "Rancho Murieta Airport",
    city: "Rancho Murieta",
    country: "United States",
    lat: 38.48680114746094,
    lng: -121.10299682617188,
  },
  {
    id: "BUR",
    name: "Bob Hope Airport",
    city: "Burbank",
    country: "United States",
    lat: 34.20069885253906,
    lng: -118.35900115966797,
  },
  {
    id: "DTW",
    name: "Detroit Metropolitan Wayne County Airport",
    city: "Detroit",
    country: "United States",
    lat: 42.212398529052734,
    lng: -83.35340118408203,
  },
  {
    id: "TPA",
    name: "Tampa International Airport",
    city: "Tampa",
    country: "United States",
    lat: 27.975500106811523,
    lng: -82.533203125,
  },
  {
    id: "PMB",
    name: "Pembina Municipal Airport",
    city: "Pembina",
    country: "United States",
    lat: 48.9425010681,
    lng: -97.2407989502,
  },
  {
    id: "POE",
    name: "Polk Army Air Field",
    city: "Fort Polk",
    country: "United States",
    lat: 31.0447998,
    lng: -93.1917038,
  },
  {
    id: "EIL",
    name: "Eielson Air Force Base",
    city: "Fairbanks",
    country: "United States",
    lat: 64.66570282,
    lng: -147.102005,
  },
  {
    id: "HIB",
    name: "Range Regional Airport",
    city: "Hibbing",
    country: "United States",
    lat: 47.38660049,
    lng: -92.83899689,
  },
  {
    id: "LFK",
    name: "Angelina County Airport",
    city: "Lufkin",
    country: "United States",
    lat: 31.2339992523,
    lng: -94.75,
  },
  {
    id: "MAF",
    name: "Midland International Airport",
    city: "Midland",
    country: "United States",
    lat: 31.9424991607666,
    lng: -102.2020034790039,
  },
  {
    id: "GRB",
    name: "Austin Straubel International Airport",
    city: "Green Bay",
    country: "United States",
    lat: 44.48509979248047,
    lng: -88.12960052490234,
  },
  {
    id: "ADM",
    name: "Ardmore Municipal Airport",
    city: "Ardmore",
    country: "United States",
    lat: 34.30301,
    lng: -97.0196342,
  },
  {
    id: "WRI",
    name: "Mc Guire Air Force Base",
    city: "Wrightstown",
    country: "United States",
    lat: 40.0155983,
    lng: -74.59169769,
  },
  {
    id: "N",
    name: "Cherry Point MCAS /Cunningham Field/",
    city: "Cherry Point",
    country: "United States",
    lat: 34.90090179,
    lng: -76.88069916,
  },
  {
    id: "N",
    name: "Emanuel County Airport",
    city: "Santa Barbara",
    country: "United States",
    lat: 32.609100341796875,
    lng: -82.36990356445312,
  },
  {
    id: "AGS",
    name: "Augusta Regional At Bush Field",
    city: "Bush Field",
    country: "United States",
    lat: 33.36989974975586,
    lng: -81.9645004272461,
  },
  {
    id: "ISN",
    name: "Sloulin Field International Airport",
    city: "Williston",
    country: "United States",
    lat: 48.177898407,
    lng: -103.641998291,
  },
  {
    id: "LIT",
    name: "Bill & Hillary Clinton National Airport/Adams Field",
    city: "Little Rock",
    country: "United States",
    lat: 34.729400634799994,
    lng: -92.2242965698,
  },
  {
    id: "SWF",
    name: "Stewart International Airport",
    city: "Newburgh",
    country: "United States",
    lat: 41.50410079956055,
    lng: -74.10479736328125,
  },
  {
    id: "BDE",
    name: "Baudette International Airport",
    city: "Baudette",
    country: "United States",
    lat: 48.7284011841,
    lng: -94.612197876,
  },
  {
    id: "SAC",
    name: "Sacramento Executive Airport",
    city: "Sacramento",
    country: "United States",
    lat: 38.5125007629,
    lng: -121.492996216,
  },
  {
    id: "HOM",
    name: "Homer Airport",
    city: "Homer",
    country: "United States",
    lat: 59.645599365234375,
    lng: -151.4770050048828,
  },
  {
    id: "TBN",
    name: "Waynesville-St. Robert Regional Forney field",
    city: "Fort Leonardwood",
    country: "United States",
    lat: 37.74160004,
    lng: -92.14070129,
  },
  {
    id: "MGE",
    name: "Dobbins Air Reserve Base",
    city: "Marietta",
    country: "United States",
    lat: 33.91540146,
    lng: -84.51629639,
  },
  {
    id: "SKA",
    name: "Fairchild Air Force Base",
    city: "Spokane",
    country: "United States",
    lat: 47.6151008606,
    lng: -117.65599823,
  },
  {
    id: "HTL",
    name: "Roscommon County - Blodgett Memorial Airport",
    city: "Houghton Lake",
    country: "United States",
    lat: 44.359798,
    lng: -84.671095,
  },
  {
    id: "PAM",
    name: "Tyndall Air Force Base",
    city: "Panama City",
    country: "United States",
    lat: 30.0695991516,
    lng: -85.57540130619999,
  },
  {
    id: "DFW",
    name: "Dallas Fort Worth International Airport",
    city: "Dallas-Fort Worth",
    country: "United States",
    lat: 32.896801,
    lng: -97.038002,
  },
  {
    id: "MLB",
    name: "Melbourne International Airport",
    city: "Melbourne",
    country: "United States",
    lat: 28.102800369262695,
    lng: -80.64530181884766,
  },
  {
    id: "TCM",
    name: "McChord Air Force Base",
    city: "Tacoma",
    country: "United States",
    lat: 47.1376991272,
    lng: -122.475997925,
  },
  {
    id: "AUS",
    name: "Austin Bergstrom International Airport",
    city: "Austin",
    country: "United States",
    lat: 30.194499969482422,
    lng: -97.6698989868164,
  },
  {
    id: "LCK",
    name: "Rickenbacker International Airport",
    city: "Columbus",
    country: "United States",
    lat: 39.813801,
    lng: -82.927803,
  },
  {
    id: "MQT",
    name: "Sawyer International Airport",
    city: "Gwinn",
    country: "United States",
    lat: 46.353599548300004,
    lng: -87.395401001,
  },
  {
    id: "TYS",
    name: "McGhee Tyson Airport",
    city: "Knoxville",
    country: "United States",
    lat: 35.81100082,
    lng: -83.9940033,
  },
  {
    id: "HLR",
    name: "Hood Army Air Field",
    city: "Fort Hood",
    country: "United States",
    lat: 31.138700485199998,
    lng: -97.71450042720001,
  },
  {
    id: "STL",
    name: "St Louis Lambert International Airport",
    city: "St. Louis",
    country: "United States",
    lat: 38.748697,
    lng: -90.370003,
  },
  {
    id: "MIV",
    name: "Millville Municipal Airport",
    city: "Millville",
    country: "United States",
    lat: 39.367802,
    lng: -75.072197,
  },
  {
    id: "SPS",
    name: "Sheppard Air Force Base-Wichita Falls Municipal Airport",
    city: "Wichita Falls",
    country: "United States",
    lat: 33.9888,
    lng: -98.491898,
  },
  {
    id: "LUK",
    name: "Cincinnati Municipal Airport Lunken Field",
    city: "Cincinnati",
    country: "United States",
    lat: 39.10329819,
    lng: -84.41860199,
  },
  {
    id: "ATL",
    name: "Hartsfield Jackson Atlanta International Airport",
    city: "Atlanta",
    country: "United States",
    lat: 33.6367,
    lng: -84.428101,
  },
  {
    id: "MER",
    name: "Castle Airport",
    city: "Merced",
    country: "United States",
    lat: 37.38050079,
    lng: -120.5680008,
  },
  {
    id: "MCC",
    name: "Mc Clellan Airfield",
    city: "Sacramento",
    country: "United States",
    lat: 38.66759872,
    lng: -121.401001,
  },
  {
    id: "GRR",
    name: "Gerald R. Ford International Airport",
    city: "Grand Rapids",
    country: "United States",
    lat: 42.88079834,
    lng: -85.52279663,
  },
  {
    id: "INK",
    name: "Winkler County Airport",
    city: "Wink",
    country: "United States",
    lat: 31.779600143399996,
    lng: -103.200996399,
  },
  {
    id: "FAT",
    name: "Fresno Yosemite International Airport",
    city: "Fresno",
    country: "United States",
    lat: 36.77619934082031,
    lng: -119.71800231933594,
  },
  {
    id: "VRB",
    name: "Vero Beach Regional Airport",
    city: "Vero Beach",
    country: "United States",
    lat: 27.6556,
    lng: -80.417901,
  },
  {
    id: "IPL",
    name: "Imperial County Airport",
    city: "Imperial",
    country: "United States",
    lat: 32.834201812699995,
    lng: -115.57900238,
  },
  {
    id: "BNA",
    name: "Nashville International Airport",
    city: "Nashville",
    country: "United States",
    lat: 36.1245002746582,
    lng: -86.6781997680664,
  },
  {
    id: "LRD",
    name: "Laredo International Airport",
    city: "Laredo",
    country: "United States",
    lat: 27.543800354003906,
    lng: -99.46160125732422,
  },
  {
    id: "EDF",
    name: "Elmendorf Air Force Base",
    city: "Anchorage",
    country: "United States",
    lat: 61.250999450683594,
    lng: -149.8070068359375,
  },
  {
    id: "OTZ",
    name: "Ralph Wien Memorial Airport",
    city: "Kotzebue",
    country: "United States",
    lat: 66.88469696,
    lng: -162.598999,
  },
  {
    id: "AOO",
    name: "Altoona Blair County Airport",
    city: "Altoona",
    country: "United States",
    lat: 40.29639816,
    lng: -78.31999969,
  },
  {
    id: "DYS",
    name: "Dyess Air Force Base",
    city: "Abilene",
    country: "United States",
    lat: 32.4207992554,
    lng: -99.854598999,
  },
  {
    id: "ELD",
    name: "South Arkansas Regional At Goodwin Field",
    city: "El Dorado",
    country: "United States",
    lat: 33.22100067138672,
    lng: -92.81330108642578,
  },
  {
    id: "LGA",
    name: "La Guardia Airport",
    city: "New York",
    country: "United States",
    lat: 40.77719879,
    lng: -73.87259674,
  },
  {
    id: "TLH",
    name: "Tallahassee Regional Airport",
    city: "Tallahassee",
    country: "United States",
    lat: 30.396499633789062,
    lng: -84.35030364990234,
  },
  {
    id: "DPA",
    name: "Dupage Airport",
    city: "West Chicago",
    country: "United States",
    lat: 41.90779877,
    lng: -88.24859619,
  },
  {
    id: "ACT",
    name: "Waco Regional Airport",
    city: "Waco",
    country: "United States",
    lat: 31.611299514770508,
    lng: -97.23049926757812,
  },
  {
    id: "AUG",
    name: "Augusta State Airport",
    city: "Augusta",
    country: "United States",
    lat: 44.320598602299995,
    lng: -69.7973022461,
  },
  {
    id: "N",
    name: "Hillsboro Municipal Airport",
    city: "Hillsboro",
    country: "United States",
    lat: 32.08349991,
    lng: -97.09719849,
  },
  {
    id: "NIP",
    name: "Jacksonville Naval Air Station (Towers Field)",
    city: "Jacksonville",
    country: "United States",
    lat: 30.2358,
    lng: -81.680603,
  },
  {
    id: "MKL",
    name: "McKellar-Sipes Regional Airport",
    city: "Jackson",
    country: "United States",
    lat: 35.599899,
    lng: -88.915604,
  },
  {
    id: "MKK",
    name: "Molokai Airport",
    city: "Molokai",
    country: "United States",
    lat: 21.15290069580078,
    lng: -157.0959930419922,
  },
  {
    id: "FTK",
    name: "Godman Army Air Field",
    city: "Fort Knox",
    country: "United States",
    lat: 37.907100677500004,
    lng: -85.9720993042,
  },
  {
    id: "N",
    name: "New River MCAS /H/ /Mccutcheon Fld/ Airport",
    city: "Jacksonville",
    country: "United States",
    lat: 34.70840073,
    lng: -77.43969727,
  },
  {
    id: "SJT",
    name: "San Angelo Regional Mathis Field",
    city: "San Angelo",
    country: "United States",
    lat: 31.35770034790039,
    lng: -100.49600219726562,
  },
  {
    id: "CXL",
    name: "Calexico International Airport",
    city: "Calexico",
    country: "United States",
    lat: 32.6694984436,
    lng: -115.513000488,
  },
  {
    id: "CIC",
    name: "Chico Municipal Airport",
    city: "Chico",
    country: "United States",
    lat: 39.79539871,
    lng: -121.8580017,
  },
  {
    id: "BTV",
    name: "Burlington International Airport",
    city: "Burlington",
    country: "United States",
    lat: 44.471900939899996,
    lng: -73.15329742429999,
  },
  {
    id: "JAX",
    name: "Jacksonville International Airport",
    city: "Jacksonville",
    country: "United States",
    lat: 30.49410057067871,
    lng: -81.68789672851562,
  },
  {
    id: "DRO",
    name: "Durango La Plata County Airport",
    city: "Durango",
    country: "United States",
    lat: 37.1515007019,
    lng: -107.753997803,
  },
  {
    id: "IAD",
    name: "Washington Dulles International Airport",
    city: "Washington",
    country: "United States",
    lat: 38.94449997,
    lng: -77.45580292,
  },
  {
    id: "CLL",
    name: "Easterwood Field",
    city: "College Station",
    country: "United States",
    lat: 30.58860016,
    lng: -96.36380005,
  },
  {
    id: "SFF",
    name: "Felts Field",
    city: "Spokane",
    country: "United States",
    lat: 47.682800292969,
    lng: -117.32299804688,
  },
  {
    id: "MKE",
    name: "General Mitchell International Airport",
    city: "Milwaukee",
    country: "United States",
    lat: 42.947200775146484,
    lng: -87.89659881591797,
  },
  {
    id: "ABI",
    name: "Abilene Regional Airport",
    city: "Abilene",
    country: "United States",
    lat: 32.4113006592,
    lng: -99.68190002440001,
  },
  {
    id: "COU",
    name: "Columbia Regional Airport",
    city: "Columbia",
    country: "United States",
    lat: 38.81809997558594,
    lng: -92.21959686279297,
  },
  {
    id: "PDX",
    name: "Portland International Airport",
    city: "Portland",
    country: "United States",
    lat: 45.58869934,
    lng: -122.5979996,
  },
  {
    id: "TNT",
    name: "Dade Collier Training and Transition Airport",
    city: "Miami",
    country: "United States",
    lat: 25.861799240112,
    lng: -80.897003173828,
  },
  {
    id: "PBI",
    name: "Palm Beach International Airport",
    city: "West Palm Beach",
    country: "United States",
    lat: 26.68320083618164,
    lng: -80.09559631347656,
  },
  {
    id: "FTW",
    name: "Fort Worth Meacham International Airport",
    city: "Fort Worth",
    country: "United States",
    lat: 32.819801,
    lng: -97.362396,
  },
  {
    id: "OGS",
    name: "Ogdensburg International Airport",
    city: "Ogdensburg",
    country: "United States",
    lat: 44.6819000244,
    lng: -75.46549987790002,
  },
  {
    id: "FMH",
    name: "Cape Cod Coast Guard Air Station",
    city: "Falmouth",
    country: "United States",
    lat: 41.6584014893,
    lng: -70.5214004517,
  },
  {
    id: "BFI",
    name: "Boeing Field King County International Airport",
    city: "Seattle",
    country: "United States",
    lat: 47.529998779296875,
    lng: -122.302001953125,
  },
  {
    id: "SKF",
    name: "Lackland Air Force Base",
    city: "San Antonio",
    country: "United States",
    lat: 29.38419914,
    lng: -98.58110046,
  },
  {
    id: "HNL",
    name: "Daniel K Inouye International Airport",
    city: "Honolulu",
    country: "United States",
    lat: 21.32062,
    lng: -157.924228,
  },
  {
    id: "DSM",
    name: "Des Moines International Airport",
    city: "Des Moines",
    country: "United States",
    lat: 41.534000396728516,
    lng: -93.66310119628906,
  },
  {
    id: "EWN",
    name: "Coastal Carolina Regional Airport",
    city: "New Bern",
    country: "United States",
    lat: 35.0730018616,
    lng: -77.04290008539999,
  },
  {
    id: "SAN",
    name: "San Diego International Airport",
    city: "San Diego",
    country: "United States",
    lat: 32.7336006165,
    lng: -117.190002441,
  },
  {
    id: "MLU",
    name: "Monroe Regional Airport",
    city: "Monroe",
    country: "United States",
    lat: 32.51089859008789,
    lng: -92.0376968383789,
  },
  {
    id: "SSC",
    name: "Shaw Air Force Base",
    city: "Sumter",
    country: "United States",
    lat: 33.97269821,
    lng: -80.47059631,
  },
  {
    id: "ONT",
    name: "Ontario International Airport",
    city: "Ontario",
    country: "United States",
    lat: 34.055999755859375,
    lng: -117.60099792480469,
  },
  {
    id: "GVT",
    name: "Majors Airport",
    city: "Greenvile",
    country: "United States",
    lat: 33.0677986145,
    lng: -96.0652999878,
  },
  {
    id: "ROW",
    name: "Roswell International Air Center Airport",
    city: "Roswell",
    country: "United States",
    lat: 33.30160140991211,
    lng: -104.53099822998047,
  },
  {
    id: "DET",
    name: "Coleman A. Young Municipal Airport",
    city: "Detroit",
    country: "United States",
    lat: 42.40919876,
    lng: -83.00990295,
  },
  {
    id: "BRO",
    name: "Brownsville South Padre Island International Airport",
    city: "Brownsville",
    country: "United States",
    lat: 25.90679931640625,
    lng: -97.4259033203125,
  },
  {
    id: "DHN",
    name: "Dothan Regional Airport",
    city: "Dothan",
    country: "United States",
    lat: 31.321300506591797,
    lng: -85.44960021972656,
  },
  {
    id: "WWD",
    name: "Cape May County Airport",
    city: "Wildwood",
    country: "United States",
    lat: 39.008499145500004,
    lng: -74.9083023071,
  },
  {
    id: "NFL",
    name: "Fallon Naval Air Station",
    city: "Fallon",
    country: "United States",
    lat: 39.41659927,
    lng: -118.7009964,
  },
  {
    id: "MTC",
    name: "Selfridge Air National Guard Base Airport",
    city: "Mount Clemens",
    country: "United States",
    lat: 42.613463,
    lng: -82.836919,
  },
  {
    id: "FMN",
    name: "Four Corners Regional Airport",
    city: "Farmington",
    country: "United States",
    lat: 36.741199493399996,
    lng: -108.230003357,
  },
  {
    id: "CRP",
    name: "Corpus Christi International Airport",
    city: "Corpus Christi",
    country: "United States",
    lat: 27.77039909362793,
    lng: -97.5011978149414,
  },
  {
    id: "SYR",
    name: "Syracuse Hancock International Airport",
    city: "Syracuse",
    country: "United States",
    lat: 43.11119842529297,
    lng: -76.1063003540039,
  },
  {
    id: "NQX",
    name: "Naval Air Station Key West/Boca Chica Field",
    city: "Key West",
    country: "United States",
    lat: 24.57579994,
    lng: -81.68890381,
  },
  {
    id: "MDW",
    name: "Chicago Midway International Airport",
    city: "Chicago",
    country: "United States",
    lat: 41.785999,
    lng: -87.752403,
  },
  {
    id: "SJC",
    name: "Norman Y. Mineta San Jose International Airport",
    city: "San Jose",
    country: "United States",
    lat: 37.362598,
    lng: -121.929001,
  },
  {
    id: "HOB",
    name: "Lea County Regional Airport",
    city: "Hobbs",
    country: "United States",
    lat: 32.6875,
    lng: -103.2170029,
  },
  {
    id: "PNE",
    name: "Northeast Philadelphia Airport",
    city: "Philadelphia",
    country: "United States",
    lat: 40.081902,
    lng: -75.010597,
  },
  {
    id: "DEN",
    name: "Denver International Airport",
    city: "Denver",
    country: "United States",
    lat: 39.861698150635,
    lng: -104.672996521,
  },
  {
    id: "PHL",
    name: "Philadelphia International Airport",
    city: "Philadelphia",
    country: "United States",
    lat: 39.87189865112305,
    lng: -75.24109649658203,
  },
  {
    id: "SUX",
    name: "Sioux Gateway Col. Bud Day Field",
    city: "Sioux City",
    country: "United States",
    lat: 42.40259933,
    lng: -96.38439941,
  },
  {
    id: "MCN",
    name: "Middle Georgia Regional Airport",
    city: "Macon",
    country: "United States",
    lat: 32.69279861450195,
    lng: -83.64920043945312,
  },
  {
    id: "TCS",
    name: "Truth Or Consequences Municipal Airport",
    city: "Truth Or Consequences",
    country: "United States",
    lat: 33.2369003296,
    lng: -107.272003174,
  },
  {
    id: "PMD",
    name: "Palmdale Regional/USAF Plant 42 Airport",
    city: "Palmdale",
    country: "United States",
    lat: 34.62939835,
    lng: -118.0849991,
  },
  {
    id: "RND",
    name: "Randolph Air Force Base",
    city: "San Antonio",
    country: "United States",
    lat: 29.52969933,
    lng: -98.27890015,
  },
  {
    id: "NJK",
    name: "El Centro NAF Airport (Vraciu Field)",
    city: "El Centro",
    country: "United States",
    lat: 32.829201,
    lng: -115.671996,
  },
  {
    id: "CMH",
    name: "John Glenn Columbus International Airport",
    city: "Columbus",
    country: "United States",
    lat: 39.998001,
    lng: -82.891899,
  },
  {
    id: "FYV",
    name: "Drake Field",
    city: "Fayetteville",
    country: "United States",
    lat: 36.00510025024414,
    lng: -94.17009735107422,
  },
  {
    id: "FSI",
    name: "Henry Post Army Air Field (Fort Sill)",
    city: "Fort Sill",
    country: "United States",
    lat: 34.64979935,
    lng: -98.40219879,
  },
  {
    id: "N",
    name: "Princeton Municipal Airport",
    city: "Princeton",
    country: "United States",
    lat: 45.55989838,
    lng: -93.60820007,
  },
  {
    id: "FFO",
    name: "Wright-Patterson Air Force Base",
    city: "Dayton",
    country: "United States",
    lat: 39.8260993958,
    lng: -84.0483016968,
  },
  {
    id: "GAL",
    name: "Edward G. Pitka Sr Airport",
    city: "Galena",
    country: "United States",
    lat: 64.73619843,
    lng: -156.9369965,
  },
  {
    id: "N",
    name: "Chandler Municipal Airport",
    city: "Chandler",
    country: "United States",
    lat: 33.2691,
    lng: -111.810997,
  },
  {
    id: "MWL",
    name: "Mineral Wells Airport",
    city: "Mineral Wells",
    country: "United States",
    lat: 32.7816009521,
    lng: -98.0602035522,
  },
  {
    id: "IAB",
    name: "Mc Connell Air Force Base",
    city: "Wichita",
    country: "United States",
    lat: 37.62189865,
    lng: -97.26820374,
  },
  {
    id: "NBG",
    name: "New Orleans NAS JRB/Alvin Callender Field",
    city: "New Orleans",
    country: "United States",
    lat: 29.82530022,
    lng: -90.03500366,
  },
  {
    id: "BFT",
    name: "Beaufort County Airport",
    city: "Beaufort",
    country: "United States",
    lat: 32.4122009277,
    lng: -80.6343994141,
  },
  {
    id: "TXK",
    name: "Texarkana Regional Webb Field",
    city: "Texarkana",
    country: "United States",
    lat: 33.45370101928711,
    lng: -93.99099731445312,
  },
  {
    id: "PBG",
    name: "Plattsburgh International Airport",
    city: "Plattsburgh",
    country: "United States",
    lat: 44.650901794433594,
    lng: -73.46810150146484,
  },
  {
    id: "APG",
    name: "Phillips Army Air Field",
    city: "Aberdeen",
    country: "United States",
    lat: 39.466202,
    lng: -76.1688,
  },
  {
    id: "TCC",
    name: "Tucumcari Municipal Airport",
    city: "Tucumcari",
    country: "United States",
    lat: 35.182800293,
    lng: -103.602996826,
  },
  {
    id: "ANC",
    name: "Ted Stevens Anchorage International Airport",
    city: "Anchorage",
    country: "United States",
    lat: 61.174400329589844,
    lng: -149.99600219726562,
  },
  {
    id: "GRK",
    name: "Robert Gray  Army Air Field Airport",
    city: "Killeen",
    country: "United States",
    lat: 31.067199707,
    lng: -97.82890319820001,
  },
  {
    id: "N",
    name: "Black Rock Airport",
    city: "Zuni Pueblo",
    country: "United States",
    lat: 35.08319854736328,
    lng: -108.79199981689453,
  },
  {
    id: "BLI",
    name: "Bellingham International Airport",
    city: "Bellingham",
    country: "United States",
    lat: 48.79280090332031,
    lng: -122.53800201416016,
  },
  {
    id: "NQA",
    name: "Millington-Memphis Airport",
    city: "Millington",
    country: "United States",
    lat: 35.356701,
    lng: -89.8703,
  },
  {
    id: "EKN",
    name: "Elkins-Randolph Co-Jennings Randolph Field",
    city: "Elkins",
    country: "United States",
    lat: 38.88940048,
    lng: -79.85710144,
  },
  {
    id: "HFD",
    name: "Hartford Brainard Airport",
    city: "Hartford",
    country: "United States",
    lat: 41.736698150635,
    lng: -72.649398803711,
  },
  {
    id: "SFZ",
    name: "North Central State Airport",
    city: "Smithfield",
    country: "United States",
    lat: 41.9207992554,
    lng: -71.49140167239999,
  },
  {
    id: "MOB",
    name: "Mobile Regional Airport",
    city: "Mobile",
    country: "United States",
    lat: 30.691200256348,
    lng: -88.242797851562,
  },
  {
    id: "NUQ",
    name: "Moffett Federal Airfield",
    city: "Mountain View",
    country: "United States",
    lat: 37.4161,
    lng: -122.049004,
  },
  {
    id: "SAF",
    name: "Santa Fe Municipal Airport",
    city: "Santa Fe",
    country: "United States",
    lat: 35.617099762,
    lng: -106.088996887,
  },
  {
    id: "BKH",
    name: "Barking Sands Airport",
    city: "Barking Sands",
    country: "United States",
    lat: 22.022800445599998,
    lng: -159.785003662,
  },
  {
    id: "DRI",
    name: "Beauregard Regional Airport",
    city: "Deridder",
    country: "United States",
    lat: 30.8316993713,
    lng: -93.33989715579999,
  },
  {
    id: "BSF",
    name: "Bradshaw Army Airfield",
    city: "Bradshaw Field",
    country: "United States",
    lat: 19.760099411,
    lng: -155.554000854,
  },
  {
    id: "OLS",
    name: "Nogales International Airport",
    city: "Nogales",
    country: "United States",
    lat: 31.4177,
    lng: -110.848,
  },
  {
    id: "MCF",
    name: "Mac Dill Air Force Base",
    city: "Tampa",
    country: "United States",
    lat: 27.84930038,
    lng: -82.52120209,
  },
  {
    id: "BLV",
    name: "Scott AFB/Midamerica Airport",
    city: "Belleville",
    country: "United States",
    lat: 38.5452,
    lng: -89.835197,
  },
  {
    id: "OPF",
    name: "Opa-locka Executive Airport",
    city: "Miami",
    country: "United States",
    lat: 25.907,
    lng: -80.278397,
  },
  {
    id: "DRT",
    name: "Del Rio International Airport",
    city: "Del Rio",
    country: "United States",
    lat: 29.3742008209,
    lng: -100.927001953,
  },
  {
    id: "RSW",
    name: "Southwest Florida International Airport",
    city: "Fort Myers",
    country: "United States",
    lat: 26.53619956970215,
    lng: -81.75520324707031,
  },
  {
    id: "AKN",
    name: "King Salmon Airport",
    city: "King Salmon",
    country: "United States",
    lat: 58.67679977,
    lng: -156.6490021,
  },
  {
    id: "MUI",
    name: "Muir Army Air Field (Fort Indiantown Gap) Airport",
    city: "Muir",
    country: "United States",
    lat: 40.434799,
    lng: -76.569397,
  },
  {
    id: "JHM",
    name: "Kapalua Airport",
    city: "Lahania-kapalua",
    country: "United States",
    lat: 20.962900161743164,
    lng: -156.67300415039062,
  },
  {
    id: "JFK",
    name: "John F Kennedy International Airport",
    city: "New York",
    country: "United States",
    lat: 40.63980103,
    lng: -73.77890015,
  },
  {
    id: "HST",
    name: "Homestead ARB Airport",
    city: "Homestead",
    country: "United States",
    lat: 25.48859978,
    lng: -80.38359833,
  },
  {
    id: "RAL",
    name: "Riverside Municipal Airport",
    city: "Riverside",
    country: "United States",
    lat: 33.95190048,
    lng: -117.4449997,
  },
  {
    id: "FLV",
    name: "Sherman Army Air Field",
    city: "Fort Leavenworth",
    country: "United States",
    lat: 39.3683013916,
    lng: -94.9147033691,
  },
  {
    id: "WAL",
    name: "Wallops Flight Facility Airport",
    city: "Wallops Island",
    country: "United States",
    lat: 37.9402008057,
    lng: -75.4664001465,
  },
  {
    id: "HMN",
    name: "Holloman Air Force Base",
    city: "Alamogordo",
    country: "United States",
    lat: 32.8525009155,
    lng: -106.107002258,
  },
  {
    id: "NXX",
    name: "Willow Grove Naval Air Station/Joint Reserve Base",
    city: "Willow Grove",
    country: "United States",
    lat: 40.19979858,
    lng: -75.14820099,
  },
  {
    id: "CYS",
    name: "Cheyenne Regional Jerry Olson Field",
    city: "Cheyenne",
    country: "United States",
    lat: 41.15570068,
    lng: -104.8119965,
  },
  {
    id: "SCK",
    name: "Stockton Metropolitan Airport",
    city: "Stockton",
    country: "United States",
    lat: 37.894199371338,
    lng: -121.2379989624,
  },
  {
    id: "CHS",
    name: "Charleston Air Force Base-International Airport",
    city: "Charleston",
    country: "United States",
    lat: 32.89860153,
    lng: -80.04049683,
  },
  {
    id: "RNO",
    name: "Reno Tahoe International Airport",
    city: "Reno",
    country: "United States",
    lat: 39.49909973144531,
    lng: -119.76799774169922,
  },
  {
    id: "KTN",
    name: "Ketchikan International Airport",
    city: "Ketchikan",
    country: "United States",
    lat: 55.35559845,
    lng: -131.7140045,
  },
  {
    id: "YIP",
    name: "Willow Run Airport",
    city: "Detroit",
    country: "United States",
    lat: 42.23789978,
    lng: -83.53040314,
  },
  {
    id: "VBG",
    name: "Vandenberg Air Force Base",
    city: "Lompoc",
    country: "United States",
    lat: 34.7373008728,
    lng: -120.583999634,
  },
  {
    id: "BHM",
    name: "Birmingham-Shuttlesworth International Airport",
    city: "Birmingham",
    country: "United States",
    lat: 33.56290054,
    lng: -86.75350189,
  },
  {
    id: "NEL",
    name: "Lakehurst Maxfield Field Airport",
    city: "Lakehurst",
    country: "United States",
    lat: 40.03329849,
    lng: -74.353302,
  },
  {
    id: "SYA",
    name: "Eareckson Air Station",
    city: "Shemya",
    country: "United States",
    lat: 52.71229935,
    lng: 174.1139984,
  },
  {
    id: "LSV",
    name: "Nellis Air Force Base",
    city: "Las Vegas",
    country: "United States",
    lat: 36.2361984253,
    lng: -115.033996582,
  },
  {
    id: "RIV",
    name: "March ARB Airport",
    city: "Riverside",
    country: "United States",
    lat: 33.880699,
    lng: -117.259003,
  },
  {
    id: "MOD",
    name: "Modesto City Co-Harry Sham Field",
    city: "Modesto",
    country: "United States",
    lat: 37.62580109,
    lng: -120.9540024,
  },
  {
    id: "SMF",
    name: "Sacramento International Airport",
    city: "Sacramento",
    country: "United States",
    lat: 38.69540023803711,
    lng: -121.59100341796875,
  },
  {
    id: "UGN",
    name: "Waukegan National Airport",
    city: "Chicago",
    country: "United States",
    lat: 42.422199249268,
    lng: -87.867897033691,
  },
  {
    id: "COS",
    name: "City of Colorado Springs Municipal Airport",
    city: "Colorado Springs",
    country: "United States",
    lat: 38.805801,
    lng: -104.700996,
  },
  {
    id: "BUF",
    name: "Buffalo Niagara International Airport",
    city: "Buffalo",
    country: "United States",
    lat: 42.94049835,
    lng: -78.73220062,
  },
  {
    id: "SKY",
    name: "Griffing Sandusky Airport",
    city: "Sandusky",
    country: "United States",
    lat: 41.4333992004,
    lng: -82.6522979736,
  },
  {
    id: "PAE",
    name: "Snohomish County (Paine Field) Airport",
    city: "Everett",
    country: "United States",
    lat: 47.90629959,
    lng: -122.2819977,
  },
  {
    id: "MUO",
    name: "Mountain Home Air Force Base",
    city: "Mountain Home",
    country: "United States",
    lat: 43.043598,
    lng: -115.872002,
  },
  {
    id: "CDC",
    name: "Cedar City Regional Airport",
    city: "Cedar City",
    country: "United States",
    lat: 37.70100021362305,
    lng: -113.0989990234375,
  },
  {
    id: "BDL",
    name: "Bradley International Airport",
    city: "Windsor Locks",
    country: "United States",
    lat: 41.9388999939,
    lng: -72.68319702149999,
  },
  {
    id: "MFE",
    name: "Mc Allen Miller International Airport",
    city: "Mcallen",
    country: "United States",
    lat: 26.17580032,
    lng: -98.23860168,
  },
  {
    id: "NGU",
    name: "Norfolk Naval Station (Chambers Field)",
    city: "Norfolk",
    country: "United States",
    lat: 36.937599,
    lng: -76.289299,
  },
  {
    id: "CEF",
    name: "Westover ARB/Metropolitan Airport",
    city: "Chicopee Falls",
    country: "United States",
    lat: 42.19400024,
    lng: -72.53479767,
  },
  {
    id: "LBB",
    name: "Lubbock Preston Smith International Airport",
    city: "Lubbock",
    country: "United States",
    lat: 33.663601,
    lng: -101.822998,
  },
  {
    id: "ORD",
    name: "Chicago O'Hare International Airport",
    city: "Chicago",
    country: "United States",
    lat: 41.9786,
    lng: -87.9048,
  },
  {
    id: "BCT",
    name: "Boca Raton Airport",
    city: "Boca Raton",
    country: "United States",
    lat: 26.3784999847,
    lng: -80.1076965332,
  },
  {
    id: "FAI",
    name: "Fairbanks International Airport",
    city: "Fairbanks",
    country: "United States",
    lat: 64.81510162,
    lng: -147.8560028,
  },
  {
    id: "N",
    name: "Quantico MCAF /Turner field",
    city: "Quantico",
    country: "United States",
    lat: 38.50170135,
    lng: -77.30529785,
  },
  {
    id: "CVS",
    name: "Cannon Air Force Base",
    city: "Clovis",
    country: "United States",
    lat: 34.3828010559,
    lng: -103.321998596,
  },
  {
    id: "NGF",
    name: "Kaneohe Bay MCAS (Marion E. Carl Field) Airport",
    city: "Kaneohe Bay",
    country: "United States",
    lat: 21.4505004883,
    lng: -157.768005371,
  },
  {
    id: "OFF",
    name: "Offutt Air Force Base",
    city: "Omaha",
    country: "United States",
    lat: 41.118301391602,
    lng: -95.912498474121,
  },
  {
    id: "GKN",
    name: "Gulkana Airport",
    city: "Gulkana",
    country: "United States",
    lat: 62.1548996,
    lng: -145.4570007,
  },
  {
    id: "ART",
    name: "Watertown International Airport",
    city: "Watertown",
    country: "United States",
    lat: 43.99190139770508,
    lng: -76.02169799804688,
  },
  {
    id: "PSP",
    name: "Palm Springs International Airport",
    city: "Palm Springs",
    country: "United States",
    lat: 33.8297004699707,
    lng: -116.50700378417969,
  },
  {
    id: "AMA",
    name: "Rick Husband Amarillo International Airport",
    city: "Amarillo",
    country: "United States",
    lat: 35.219398,
    lng: -101.706001,
  },
  {
    id: "FOD",
    name: "Fort Dodge Regional Airport",
    city: "Fort Dodge",
    country: "United States",
    lat: 42.55149841,
    lng: -94.19259644,
  },
  {
    id: "BAD",
    name: "Barksdale Air Force Base",
    city: "Shreveport",
    country: "United States",
    lat: 32.5018005371,
    lng: -93.6626968384,
  },
  {
    id: "FOE",
    name: "Topeka Regional Airport - Forbes Field",
    city: "Topeka",
    country: "United States",
    lat: 38.950901031499995,
    lng: -95.66359710690001,
  },
  {
    id: "COT",
    name: "Cotulla-La Salle County Airport",
    city: "Cotulla",
    country: "United States",
    lat: 28.45669937,
    lng: -99.22029877,
  },
  {
    id: "ILM",
    name: "Wilmington International Airport",
    city: "Wilmington",
    country: "United States",
    lat: 34.270599365234375,
    lng: -77.90260314941406,
  },
  {
    id: "BTR",
    name: "Baton Rouge Metropolitan Airport",
    city: "Baton Rouge",
    country: "United States",
    lat: 30.533199,
    lng: -91.149597,
  },
  {
    id: "N",
    name: "Meridian Naval Air Station",
    city: "Meridian",
    country: "United States",
    lat: 32.55210114,
    lng: -88.55560303,
  },
  {
    id: "TYR",
    name: "Tyler Pounds Regional Airport",
    city: "Tyler",
    country: "United States",
    lat: 32.35409927368164,
    lng: -95.40239715576172,
  },
  {
    id: "BWI",
    name: "Baltimore/Washington International Thurgood Marshall Airport",
    city: "Baltimore",
    country: "United States",
    lat: 39.1754,
    lng: -76.668297,
  },
  {
    id: "HBR",
    name: "Hobart Regional Airport",
    city: "Hobart",
    country: "United States",
    lat: 34.991317,
    lng: -99.051313,
  },
  {
    id: "LNY",
    name: "Lanai Airport",
    city: "Lanai",
    country: "United States",
    lat: 20.785600662231445,
    lng: -156.9510040283203,
  },
  {
    id: "AEX",
    name: "Alexandria International Airport",
    city: "Alexandria",
    country: "United States",
    lat: 31.32740020751953,
    lng: -92.54979705810547,
  },
  {
    id: "WSD",
    name: "Condron Army Air Field",
    city: "White Sands",
    country: "United States",
    lat: 32.34149933,
    lng: -106.4029999,
  },
  {
    id: "CDB",
    name: "Cold Bay Airport",
    city: "Cold Bay",
    country: "United States",
    lat: 55.20610046386719,
    lng: -162.72500610351562,
  },
  {
    id: "TUL",
    name: "Tulsa International Airport",
    city: "Tulsa",
    country: "United States",
    lat: 36.19839859008789,
    lng: -95.88809967041016,
  },
  {
    id: "SIT",
    name: "Sitka Rocky Gutierrez Airport",
    city: "Sitka",
    country: "United States",
    lat: 57.04710006713867,
    lng: -135.36199951171875,
  },
  {
    id: "ISP",
    name: "Long Island Mac Arthur Airport",
    city: "Islip",
    country: "United States",
    lat: 40.79520035,
    lng: -73.10019684,
  },
  {
    id: "MSP",
    name: "Minneapolis-St Paul International/Wold-Chamberlain Airport",
    city: "Minneapolis",
    country: "United States",
    lat: 44.882,
    lng: -93.221802,
  },
  {
    id: "ILG",
    name: "New Castle Airport",
    city: "Wilmington",
    country: "United States",
    lat: 39.67869949,
    lng: -75.60649872,
  },
  {
    id: "DUT",
    name: "Unalaska Airport",
    city: "Unalaska",
    country: "United States",
    lat: 53.900100708,
    lng: -166.544006348,
  },
  {
    id: "MSY",
    name: "Louis Armstrong New Orleans International Airport",
    city: "New Orleans",
    country: "United States",
    lat: 29.99340057373047,
    lng: -90.25800323486328,
  },
  {
    id: "PWM",
    name: "Portland International Jetport Airport",
    city: "Portland",
    country: "United States",
    lat: 43.64619827,
    lng: -70.30930328,
  },
  {
    id: "OKC",
    name: "Will Rogers World Airport",
    city: "Oklahoma City",
    country: "United States",
    lat: 35.39310073852539,
    lng: -97.60070037841797,
  },
  {
    id: "ALB",
    name: "Albany International Airport",
    city: "Albany",
    country: "United States",
    lat: 42.74829864501953,
    lng: -73.80169677734375,
  },
  {
    id: "VDZ",
    name: "Valdez Pioneer Field",
    city: "Valdez",
    country: "United States",
    lat: 61.13389969,
    lng: -146.2480011,
  },
  {
    id: "LFI",
    name: "Langley Air Force Base",
    city: "Hampton",
    country: "United States",
    lat: 37.082901001,
    lng: -76.360496521,
  },
  {
    id: "SNA",
    name: "John Wayne Airport-Orange County Airport",
    city: "Santa Ana",
    country: "United States",
    lat: 33.67570114,
    lng: -117.8679962,
  },
  {
    id: "CBM",
    name: "Columbus Air Force Base",
    city: "Colombus",
    country: "United States",
    lat: 33.6437988281,
    lng: -88.44380187990001,
  },
  {
    id: "TMB",
    name: "Kendall-Tamiami Executive Airport",
    city: "Kendall-tamiami",
    country: "United States",
    lat: 25.6478996277,
    lng: -80.432800293,
  },
  {
    id: "NTU",
    name: "Oceana Naval Air Station",
    city: "Oceana",
    country: "United States",
    lat: 36.820702,
    lng: -76.033501,
  },
  {
    id: "GUS",
    name: "Grissom Air Reserve Base",
    city: "Peru",
    country: "United States",
    lat: 40.648101806599996,
    lng: -86.1520996094,
  },
  {
    id: "CPR",
    name: "Casper-Natrona County International Airport",
    city: "Casper",
    country: "United States",
    lat: 42.908001,
    lng: -106.463997,
  },
  {
    id: "VPS",
    name: "Destin-Ft Walton Beach Airport",
    city: "Valparaiso",
    country: "United States",
    lat: 30.4832,
    lng: -86.525398,
  },
  {
    id: "SEM",
    name: "Craig Field",
    city: "Selma",
    country: "United States",
    lat: 32.343898773193,
    lng: -86.987800598145,
  },
  {
    id: "EYW",
    name: "Key West International Airport",
    city: "Key West",
    country: "United States",
    lat: 24.556100845336914,
    lng: -81.75959777832031,
  },
  {
    id: "CLT",
    name: "Charlotte Douglas International Airport",
    city: "Charlotte",
    country: "United States",
    lat: 35.2140007019043,
    lng: -80.94309997558594,
  },
  {
    id: "LAS",
    name: "McCarran International Airport",
    city: "Las Vegas",
    country: "United States",
    lat: 36.08010101,
    lng: -115.1520004,
  },
  {
    id: "MCO",
    name: "Orlando International Airport",
    city: "Orlando",
    country: "United States",
    lat: 28.429399490356445,
    lng: -81.30899810791016,
  },
  {
    id: "FLO",
    name: "Florence Regional Airport",
    city: "Florence",
    country: "United States",
    lat: 34.18539810180664,
    lng: -79.7238998413086,
  },
  {
    id: "GTF",
    name: "Great Falls International Airport",
    city: "Great Falls",
    country: "United States",
    lat: 47.48199844,
    lng: -111.3710022,
  },
  {
    id: "YNG",
    name: "Youngstown Warren Regional Airport",
    city: "Youngstown",
    country: "United States",
    lat: 41.26070023,
    lng: -80.67910004,
  },
  {
    id: "FBK",
    name: "Ladd AAF Airfield",
    city: "Fort Wainwright",
    country: "United States",
    lat: 64.83750153,
    lng: -147.6139984,
  },
  {
    id: "N",
    name: "Mc Minnville Municipal Airport",
    city: "Mackminnville",
    country: "United States",
    lat: 45.19440079,
    lng: -123.1360016,
  },
  {
    id: "WRB",
    name: "Robins Air Force Base",
    city: "Macon",
    country: "United States",
    lat: 32.6400985718,
    lng: -83.5919036865,
  },
  {
    id: "BKK",
    name: "Suvarnabhumi Airport",
    city: "Bangkok",
    country: "Thailand",
    lat: 13.681099891662598,
    lng: 100.74700164794922,
  },
  {
    id: "NAH",
    name: "Naha Airport",
    city: "Naha",
    country: "Indonesia",
    lat: 3.6832098960876465,
    lng: 125.52799987792969,
  },
  {
    id: "MXB",
    name: "Andi Jemma Airport",
    city: "Masamba",
    country: "Indonesia",
    lat: -2.55803,
    lng: 120.323997,
  },
  {
    id: "SQR",
    name: "Soroako Airport",
    city: "Soroako",
    country: "Indonesia",
    lat: -2.5311999320983887,
    lng: 121.35800170898438,
  },
  {
    id: "TTR",
    name: "Pongtiku Airport",
    city: "Makale",
    country: "Indonesia",
    lat: -3.0447399616241,
    lng: 119.82199859619,
  },
  {
    id: "KDI",
    name: "Wolter Monginsidi Airport",
    city: "Kendari",
    country: "Indonesia",
    lat: -4.081610202789307,
    lng: 122.41799926757812,
  },
  {
    id: "SBG",
    name: "Maimun Saleh Airport",
    city: "Sabang",
    country: "Indonesia",
    lat: 5.87412977219,
    lng: 95.33969879150001,
  },
  {
    id: "TSY",
    name: "Cibeureum Airport",
    city: "Tasikmalaya",
    country: "Indonesia",
    lat: -7.346600055690001,
    lng: 108.246002197,
  },
  {
    id: "N",
    name: "Iswahyudi Airport",
    city: "Madiun",
    country: "Indonesia",
    lat: -7.615769863128662,
    lng: 111.43399810791016,
  },
  {
    id: "MLG",
    name: "Abdul Rachman Saleh Airport",
    city: "Malang",
    country: "Indonesia",
    lat: -7.926559925079999,
    lng: 112.714996338,
  },
  {
    id: "N",
    name: "Budiarto Airport",
    city: "Tangerang",
    country: "Indonesia",
    lat: -6.293171,
    lng: 106.57,
  },
  {
    id: "BDO",
    name: "Husein Sastranegara International Airport",
    city: "Bandung",
    country: "Indonesia",
    lat: -6.900629997253418,
    lng: 107.57599639892578,
  },
  {
    id: "CBN",
    name: "Penggung Airport",
    city: "Cirebon",
    country: "Indonesia",
    lat: -6.756140232090001,
    lng: 108.540000916,
  },
  {
    id: "JOG",
    name: "Adi Sutjipto International Airport",
    city: "Yogyakarta",
    country: "Indonesia",
    lat: -7.788179874420166,
    lng: 110.43199920654297,
  },
  {
    id: "CXP",
    name: "Tunggul Wulung Airport",
    city: "Cilacap",
    country: "Indonesia",
    lat: -7.645060062410001,
    lng: 109.033996582,
  },
  {
    id: "PCB",
    name: "Pondok Cabe Air Base",
    city: "Jakarta",
    country: "Indonesia",
    lat: -6.3369598388671875,
    lng: 106.76499938964844,
  },
  {
    id: "SRG",
    name: "Achmad Yani Airport",
    city: "Semarang",
    country: "Indonesia",
    lat: -6.97273,
    lng: 110.375,
  },
  {
    id: "BTH",
    name: "Hang Nadim International Airport",
    city: "Batam",
    country: "Indonesia",
    lat: 1.12102997303,
    lng: 104.119003296,
  },
  {
    id: "TJQ",
    name: "Buluh Tumbang (H A S Hanandjoeddin) Airport",
    city: "Tanjung Pandan",
    country: "Indonesia",
    lat: -2.74571990967,
    lng: 107.754997253,
  },
  {
    id: "PGK",
    name: "Pangkal Pinang (Depati Amir) Airport",
    city: "Pangkal Pinang",
    country: "Indonesia",
    lat: -2.16219997406,
    lng: 106.138999939,
  },
  {
    id: "TNJ",
    name: "Raja Haji Fisabilillah International Airport",
    city: "Tanjung Pinang",
    country: "Indonesia",
    lat: 0.922683000565,
    lng: 104.531997681,
  },
  {
    id: "SIQ",
    name: "Dabo Airport",
    city: "Singkep",
    country: "Indonesia",
    lat: -0.47918900847435,
    lng: 104.5790023803711,
  },
  {
    id: "BDJ",
    name: "Syamsudin Noor Airport",
    city: "Banjarmasin",
    country: "Indonesia",
    lat: -3.4423599243164062,
    lng: 114.76300048828125,
  },
  {
    id: "BTW",
    name: "Batu Licin Airport",
    city: "Batu Licin",
    country: "Indonesia",
    lat: -3.4124100208300003,
    lng: 115.995002747,
  },
  {
    id: "PKN",
    name: "Iskandar Airport",
    city: "Pangkalan Bun",
    country: "Indonesia",
    lat: -2.70519995689,
    lng: 111.672996521,
  },
  {
    id: "PKY",
    name: "Tjilik Riwut Airport",
    city: "Palangkaraya",
    country: "Indonesia",
    lat: -2.22513008118,
    lng: 113.943000793,
  },
  {
    id: "MOF",
    name: "Maumere(Wai Oti) Airport",
    city: "Maumere",
    country: "Indonesia",
    lat: -8.64064979553,
    lng: 122.236999512,
  },
  {
    id: "ENE",
    name: "Ende (H Hasan Aroeboesman) Airport",
    city: "Ende",
    country: "Indonesia",
    lat: -8.8492898941,
    lng: 121.661003113,
  },
  {
    id: "RTG",
    name: "Frans Sales Lega Airport",
    city: "Ruteng",
    country: "Indonesia",
    lat: -8.5970096588135,
    lng: 120.47699737549,
  },
  {
    id: "KOE",
    name: "El Tari Airport",
    city: "Kupang",
    country: "Indonesia",
    lat: -10.171600341796875,
    lng: 123.6709976196289,
  },
  {
    id: "LBJ",
    name: "Komodo Airport",
    city: "Labuhan Bajo",
    country: "Indonesia",
    lat: -8.48666,
    lng: 119.889,
  },
  {
    id: "BPN",
    name: "Sultan Aji Muhamad Sulaiman Airport",
    city: "Balikpapan",
    country: "Indonesia",
    lat: -1.26827001572,
    lng: 116.893997192,
  },
  {
    id: "TRK",
    name: "Juwata Airport",
    city: "Taraken",
    country: "Indonesia",
    lat: 3.326667,
    lng: 117.569444,
  },
  {
    id: "SRI",
    name: "Temindung Airport",
    city: "Samarinda",
    country: "Indonesia",
    lat: -0.484530985355,
    lng: 117.156997681,
  },
  {
    id: "TSX",
    name: "Tanjung Santan Airport",
    city: "Tanjung Santan",
    country: "Indonesia",
    lat: -0.0929730013013,
    lng: 117.45300293,
  },
  {
    id: "AMI",
    name: "Selaparang Airport",
    city: "Mataram",
    country: "Indonesia",
    lat: -8.560709953309999,
    lng: 116.095001221,
  },
  {
    id: "BMU",
    name: "Muhammad Salahuddin Airport",
    city: "Bima",
    country: "Indonesia",
    lat: -8.5396499633789,
    lng: 118.68699645996,
  },
  {
    id: "WGP",
    name: "Umbu Mehang Kunda Airport",
    city: "Waingapu",
    country: "Indonesia",
    lat: -9.66922,
    lng: 120.302002,
  },
  {
    id: "SUB",
    name: "Juanda International Airport",
    city: "Surabaya",
    country: "Indonesia",
    lat: -7.3798298835754395,
    lng: 112.78700256347656,
  },
  {
    id: "SOC",
    name: "Adi Sumarmo Wiryokusumo Airport",
    city: "Solo City",
    country: "Indonesia",
    lat: -7.516089916229248,
    lng: 110.75700378417969,
  },
  {
    id: "ICN",
    name: "Incheon International Airport",
    city: "Seoul",
    country: "South Korea",
    lat: 37.46910095214844,
    lng: 126.45099639892578,
  },
  {
    id: "CNX",
    name: "Chiang Mai International Airport",
    city: "Chiang Mai",
    country: "Thailand",
    lat: 18.766799926799997,
    lng: 98.962600708,
  },
  {
    id: "CEI",
    name: "Chiang Rai International Airport",
    city: "Chiang Rai",
    country: "Thailand",
    lat: 19.952299118,
    lng: 99.88289642330001,
  },
  {
    id: "NST",
    name: "Nakhon Si Thammarat Airport",
    city: "Nakhon Si Thammarat",
    country: "Thailand",
    lat: 8.539620399475098,
    lng: 99.9447021484375,
  },
  {
    id: "NAK",
    name: "Nakhon Ratchasima Airport",
    city: "Nakhon Ratchasima",
    country: "Thailand",
    lat: 14.94950008392334,
    lng: 102.31300354003906,
  },
  {
    id: "KOP",
    name: "Nakhon Phanom Airport",
    city: "Nakhon Phanom",
    country: "Thailand",
    lat: 17.383800506591797,
    lng: 104.64299774169922,
  },
  {
    id: "UBP",
    name: "Ubon Ratchathani Airport",
    city: "Ubon Ratchathani",
    country: "Thailand",
    lat: 15.2512998581,
    lng: 104.870002747,
  },
  {
    id: "KKC",
    name: "Khon Kaen Airport",
    city: "Khon Kaen",
    country: "Thailand",
    lat: 16.466600418099997,
    lng: 102.783996582,
  },
  {
    id: "THS",
    name: "Sukhothai Airport",
    city: "Sukhothai",
    country: "Thailand",
    lat: 17.238000869750977,
    lng: 99.81819915771484,
  },
  {
    id: "DPS",
    name: "Ngurah Rai (Bali) International Airport",
    city: "Denpasar",
    country: "Indonesia",
    lat: -8.7481698989868,
    lng: 115.16699981689,
  },
  {
    id: "ATH",
    name: "Eleftherios Venizelos International Airport",
    city: "Athens",
    country: "Greece",
    lat: 37.9364013672,
    lng: 23.9444999695,
  },
  {
    id: "NGO",
    name: "Chubu Centrair International Airport",
    city: "Nagoya",
    country: "Japan",
    lat: 34.8583984375,
    lng: 136.80499267578125,
  },
  {
    id: "UKB",
    name: "Kobe Airport",
    city: "Kobe",
    country: "Japan",
    lat: 34.6328010559082,
    lng: 135.2239990234375,
  },
  {
    id: "PUW",
    name: "Pullman Moscow Regional Airport",
    city: "Pullman",
    country: "United States",
    lat: 46.7439,
    lng: -117.110001,
  },
  {
    id: "LWS",
    name: "Lewiston Nez Perce County Airport",
    city: "Lewiston",
    country: "United States",
    lat: 46.3745002746582,
    lng: -117.01499938964844,
  },
  {
    id: "ELM",
    name: "Elmira Corning Regional Airport",
    city: "Elmira",
    country: "United States",
    lat: 42.1599006652832,
    lng: -76.8916015625,
  },
  {
    id: "ITH",
    name: "Ithaca Tompkins Regional Airport",
    city: "Ithaca",
    country: "United States",
    lat: 42.49100112915039,
    lng: -76.4583969116211,
  },
  {
    id: "MRY",
    name: "Monterey Peninsula Airport",
    city: "Monterey",
    country: "United States",
    lat: 36.58700180053711,
    lng: -121.84300231933594,
  },
  {
    id: "SBA",
    name: "Santa Barbara Municipal Airport",
    city: "Santa Barbara",
    country: "United States",
    lat: 34.42620087,
    lng: -119.8399963,
  },
  {
    id: "DAB",
    name: "Daytona Beach International Airport",
    city: "Daytona Beach",
    country: "United States",
    lat: 29.179899,
    lng: -81.058098,
  },
  {
    id: "LPX",
    name: "Liepāja International Airport",
    city: "Liepaja",
    country: "Latvia",
    lat: 56.51750183105469,
    lng: 21.096900939941406,
  },
  {
    id: "RIX",
    name: "Riga International Airport",
    city: "Riga",
    country: "Latvia",
    lat: 56.92359924316406,
    lng: 23.971099853515625,
  },
  {
    id: "SQQ",
    name: "Šiauliai International Airport",
    city: "Siauliai",
    country: "Lithuania",
    lat: 55.89390182495117,
    lng: 23.395000457763672,
  },
  {
    id: "HLJ",
    name: "Barysiai Airport",
    city: "Barysiai",
    country: "Lithuania",
    lat: 56.07059860229492,
    lng: 23.5580997467041,
  },
  {
    id: "KUN",
    name: "Kaunas International Airport",
    city: "Kaunas",
    country: "Lithuania",
    lat: 54.96390151977539,
    lng: 24.084800720214844,
  },
  {
    id: "N",
    name: "S. Darius and S. Girėnas Airfield",
    city: "Kaunas",
    country: "Lithuania",
    lat: 54.879799,
    lng: 23.8815,
  },
  {
    id: "PLQ",
    name: "Palanga International Airport",
    city: "Palanga",
    country: "Lithuania",
    lat: 55.973201751708984,
    lng: 21.093900680541992,
  },
  {
    id: "VNO",
    name: "Vilnius International Airport",
    city: "Vilnius",
    country: "Lithuania",
    lat: 54.634102,
    lng: 25.285801,
  },
  {
    id: "PNV",
    name: "Panevėžys Air Base",
    city: "Panevezys",
    country: "Lithuania",
    lat: 55.729400634765625,
    lng: 24.460800170898438,
  },
  {
    id: "N",
    name: "Erebuni Airport",
    city: "Yerevan",
    country: "Armenia",
    lat: 40.122100830099996,
    lng: 44.465000152600005,
  },
  {
    id: "N",
    name: "Stepanavan Airport",
    city: "Stepanavan",
    country: "Armenia",
    lat: 41.048500061,
    lng: 44.337200164799995,
  },
  {
    id: "EVN",
    name: "Zvartnots International Airport",
    city: "Yerevan",
    country: "Armenia",
    lat: 40.1473007202,
    lng: 44.3959007263,
  },
  {
    id: "LWN",
    name: "Gyumri Shirak Airport",
    city: "Gyumri",
    country: "Armenia",
    lat: 40.7504005432,
    lng: 43.859298706100006,
  },
  {
    id: "ASA",
    name: "Assab International Airport",
    city: "Assab",
    country: "Eritrea",
    lat: 13.071800231933594,
    lng: 42.64500045776367,
  },
  {
    id: "ASM",
    name: "Asmara International Airport",
    city: "Asmara",
    country: "Eritrea",
    lat: 15.291899681091309,
    lng: 38.910701751708984,
  },
  {
    id: "MSW",
    name: "Massawa International Airport",
    city: "Massawa",
    country: "Eritrea",
    lat: 15.670000076293945,
    lng: 39.37009811401367,
  },
  {
    id: "GZA",
    name: "Yasser Arafat International Airport",
    city: "Gaza",
    country: "Palestine",
    lat: 31.24640083313,
    lng: 34.276100158691,
  },
  {
    id: "BUS",
    name: "Batumi International Airport",
    city: "Batumi",
    country: "Georgia",
    lat: 41.6102981567,
    lng: 41.5997009277,
  },
  {
    id: "KUT",
    name: "Kopitnari Airport",
    city: "Kutaisi",
    country: "Georgia",
    lat: 42.176700592,
    lng: 42.4826011658,
  },
  {
    id: "TBS",
    name: "Tbilisi International Airport",
    city: "Tbilisi",
    country: "Georgia",
    lat: 41.6692008972,
    lng: 44.95470047,
  },
  {
    id: "RIY",
    name: "Mukalla International Airport",
    city: "Mukalla",
    country: "Yemen",
    lat: 14.662599563598633,
    lng: 49.375,
  },
  {
    id: "TAI",
    name: "Ta'izz International Airport",
    city: "Taiz",
    country: "Yemen",
    lat: 13.6859998703,
    lng: 44.139099121099996,
  },
  {
    id: "HOD",
    name: "Hodeidah International Airport",
    city: "Hodeidah",
    country: "Yemen",
    lat: 14.753000259399414,
    lng: 42.97629928588867,
  },
  {
    id: "ADE",
    name: "Aden International Airport",
    city: "Aden",
    country: "Yemen",
    lat: 12.829500198364258,
    lng: 45.02880096435547,
  },
  {
    id: "AXK",
    name: "Ataq Airport",
    city: "Ataq",
    country: "Yemen",
    lat: 14.551300048828125,
    lng: 46.82619857788086,
  },
  {
    id: "AAY",
    name: "Al Ghaidah International Airport",
    city: "Al Ghaidah Intl",
    country: "Yemen",
    lat: 16.191699981689453,
    lng: 52.17499923706055,
  },
  {
    id: "SAH",
    name: "Sana'a International Airport",
    city: "Sanaa",
    country: "Yemen",
    lat: 15.476300239562988,
    lng: 44.21969985961914,
  },
  {
    id: "BHN",
    name: "Beihan Airport",
    city: "Beihan",
    country: "Yemen",
    lat: 14.781999588012695,
    lng: 45.72010040283203,
  },
  {
    id: "SCT",
    name: "Socotra International Airport",
    city: "Socotra",
    country: "Yemen",
    lat: 12.63070011138916,
    lng: 53.905799865722656,
  },
  {
    id: "N",
    name: "Al Badie Airport",
    city: "Al Badie",
    country: "Yemen",
    lat: 18.71929931640625,
    lng: 50.83689880371094,
  },
  {
    id: "FMM",
    name: "Memmingen Allgau Airport",
    city: "Memmingen",
    country: "Germany",
    lat: 47.988800048799995,
    lng: 10.2395000458,
  },
  {
    id: "NAV",
    name: "Nevşehir Kapadokya Airport",
    city: "Nevsehir",
    country: "Turkey",
    lat: 38.7719,
    lng: 34.5345,
  },
  {
    id: "EZE",
    name: "Ministro Pistarini International Airport",
    city: "Buenos Aires",
    country: "Argentina",
    lat: -34.8222,
    lng: -58.5358,
  },
  {
    id: "EBL",
    name: "Erbil International Airport",
    city: "Erbil",
    country: "Iraq",
    lat: 36.23759841918945,
    lng: 43.963199615478516,
  },
  {
    id: "EMD",
    name: "Emerald Airport",
    city: "Emerald",
    country: "Australia",
    lat: -23.5674991608,
    lng: 148.179000854,
  },
  {
    id: "HEW",
    name: "Athen Helenikon Airport",
    city: "Athens",
    country: "Greece",
    lat: 37.893299,
    lng: 23.726101,
  },
  {
    id: "KIX",
    name: "Kansai International Airport",
    city: "Osaka",
    country: "Japan",
    lat: 34.42729949951172,
    lng: 135.24400329589844,
  },
  {
    id: "JRB",
    name: "Downtown-Manhattan/Wall St Heliport",
    city: "New York",
    country: "United States",
    lat: 40.70119858,
    lng: -74.00900269,
  },
  {
    id: "TAG",
    name: "Tagbilaran Airport",
    city: "Tagbilaran",
    country: "Philippines",
    lat: 9.665442,
    lng: 123.853533,
  },
  {
    id: "JAV",
    name: "Ilulissat Airport",
    city: "Ilulissat",
    country: "Greenland",
    lat: 69.2432022095,
    lng: -51.0570983887,
  },
  {
    id: "JCH",
    name: "Qasigiannguit Heliport",
    city: "Qasigiannguit",
    country: "Greenland",
    lat: 68.822815547,
    lng: -51.1734473705,
  },
  {
    id: "JEG",
    name: "Aasiaat Airport",
    city: "Aasiaat",
    country: "Greenland",
    lat: 68.7218017578,
    lng: -52.7846984863,
  },
  {
    id: "PMI",
    name: "Palma De Mallorca Airport",
    city: "Palma de Mallorca",
    country: "Spain",
    lat: 39.551700592,
    lng: 2.73881006241,
  },
  {
    id: "DRW",
    name: "Darwin International Airport",
    city: "Darwin",
    country: "Australia",
    lat: -12.41469955444336,
    lng: 130.8769989013672,
  },
  {
    id: "URT",
    name: "Surat Thani Airport",
    city: "Surat Thani",
    country: "Thailand",
    lat: 9.13259983063,
    lng: 99.135597229,
  },
  {
    id: "TKA",
    name: "Talkeetna Airport",
    city: "Talkeetna",
    country: "United States",
    lat: 62.320499420166,
    lng: -150.09399414062,
  },
  {
    id: "GZM",
    name: "Xewkija Heliport",
    city: "Gozo",
    country: "Malta",
    lat: 36.027199,
    lng: 14.2728,
  },
  {
    id: "HVN",
    name: "Tweed New Haven Airport",
    city: "New Haven",
    country: "United States",
    lat: 41.26369858,
    lng: -72.88680267,
  },
  {
    id: "AVL",
    name: "Asheville Regional Airport",
    city: "Asheville",
    country: "United States",
    lat: 35.43619918823242,
    lng: -82.54180145263672,
  },
  {
    id: "GSO",
    name: "Piedmont Triad International Airport",
    city: "Greensboro",
    country: "United States",
    lat: 36.097801208496094,
    lng: -79.93730163574219,
  },
  {
    id: "FSD",
    name: "Joe Foss Field Airport",
    city: "Sioux Falls",
    country: "United States",
    lat: 43.582000732400004,
    lng: -96.741897583,
  },
  {
    id: "AYQ",
    name: "Ayers Rock Connellan Airport",
    city: "Uluru",
    country: "Australia",
    lat: -25.1861,
    lng: 130.975998,
  },
  {
    id: "MHT",
    name: "Manchester-Boston Regional Airport",
    city: "Manchester NH",
    country: "United States",
    lat: 42.932598,
    lng: -71.435699,
  },
  {
    id: "APF",
    name: "Naples Municipal Airport",
    city: "Naples",
    country: "United States",
    lat: 26.1525993347,
    lng: -81.7752990723,
  },
  {
    id: "RDN",
    name: "LTS Pulau Redang Airport",
    city: "Redang",
    country: "Malaysia",
    lat: 5.765279769897461,
    lng: 103.00700378417969,
  },
  {
    id: "SDF",
    name: "Louisville International Standiford Field",
    city: "Louisville",
    country: "United States",
    lat: 38.1744,
    lng: -85.736,
  },
  {
    id: "CHO",
    name: "Charlottesville Albemarle Airport",
    city: "Charlottesville VA",
    country: "United States",
    lat: 38.13859939575195,
    lng: -78.4529037475586,
  },
  {
    id: "ROA",
    name: "Roanoke–Blacksburg Regional Airport",
    city: "Roanoke VA",
    country: "United States",
    lat: 37.3255,
    lng: -79.975403,
  },
  {
    id: "LEX",
    name: "Blue Grass Airport",
    city: "Lexington KY",
    country: "United States",
    lat: 38.0364990234375,
    lng: -84.60590362548828,
  },
  {
    id: "EVV",
    name: "Evansville Regional Airport",
    city: "Evansville",
    country: "United States",
    lat: 38.0369987488,
    lng: -87.5324020386,
  },
  {
    id: "ABQ",
    name: "Albuquerque International Sunport",
    city: "Albuquerque",
    country: "United States",
    lat: 35.040199,
    lng: -106.609001,
  },
  {
    id: "BZN",
    name: "Gallatin Field",
    city: "Bozeman",
    country: "United States",
    lat: 45.77750015,
    lng: -111.1529999,
  },
  {
    id: "BIL",
    name: "Billings Logan International Airport",
    city: "Billings",
    country: "United States",
    lat: 45.807701110839844,
    lng: -108.54299926757812,
  },
  {
    id: "BTM",
    name: "Bert Mooney Airport",
    city: "Butte",
    country: "United States",
    lat: 45.95479965209961,
    lng: -112.49700164794922,
  },
  {
    id: "TVC",
    name: "Cherry Capital Airport",
    city: "Traverse City",
    country: "United States",
    lat: 44.74140167236328,
    lng: -85.58219909667969,
  },
  {
    id: "FRS",
    name: "Mundo Maya International Airport",
    city: "Flores",
    country: "Guatemala",
    lat: 16.913799285899998,
    lng: -89.86640167239999,
  },
  {
    id: "BHB",
    name: "Hancock County-Bar Harbor Airport",
    city: "Bar Harbor",
    country: "United States",
    lat: 44.45000076,
    lng: -68.3615036,
  },
  {
    id: "RKD",
    name: "Knox County Regional Airport",
    city: "Rockland",
    country: "United States",
    lat: 44.06010056,
    lng: -69.09919739,
  },
  {
    id: "JAC",
    name: "Jackson Hole Airport",
    city: "Jacksn Hole",
    country: "United States",
    lat: 43.6072998046875,
    lng: -110.73799896240234,
  },
  {
    id: "RFD",
    name: "Chicago Rockford International Airport",
    city: "Rockford",
    country: "United States",
    lat: 42.19540023803711,
    lng: -89.09719848632812,
  },
  {
    id: "DME",
    name: "Domodedovo International Airport",
    city: "Moscow",
    country: "Russia",
    lat: 55.40879821777344,
    lng: 37.90629959106445,
  },
  {
    id: "SYX",
    name: "Sanya Phoenix International Airport",
    city: "Sanya",
    country: "China",
    lat: 18.302900314331055,
    lng: 109.41200256347656,
  },
  {
    id: "MFN",
    name: "Milford Sound Airport",
    city: "Milford Sound",
    country: "New Zealand",
    lat: -44.673301696777344,
    lng: 167.92300415039062,
  },
  {
    id: "LJG",
    name: "Lijiang Airport",
    city: "Lijiang",
    country: "China",
    lat: 26.6800003052,
    lng: 100.246002197,
  },
  {
    id: "GSP",
    name: "Greenville Spartanburg International Airport",
    city: "Greenville",
    country: "United States",
    lat: 34.8956985474,
    lng: -82.2189025879,
  },
  {
    id: "BMI",
    name: "Central Illinois Regional Airport at Bloomington-Normal",
    city: "Bloomington",
    country: "United States",
    lat: 40.47710037,
    lng: -88.91590118,
  },
  {
    id: "GPT",
    name: "Gulfport Biloxi International Airport",
    city: "Gulfport",
    country: "United States",
    lat: 30.40730094909668,
    lng: -89.07009887695312,
  },
  {
    id: "AZO",
    name: "Kalamazoo Battle Creek International Airport",
    city: "Kalamazoo",
    country: "United States",
    lat: 42.234901428222656,
    lng: -85.5521011352539,
  },
  {
    id: "TOL",
    name: "Toledo Express Airport",
    city: "Toledo",
    country: "United States",
    lat: 41.58679962,
    lng: -83.80780029,
  },
  {
    id: "FWA",
    name: "Fort Wayne International Airport",
    city: "Fort Wayne",
    country: "United States",
    lat: 40.97850037,
    lng: -85.19509888,
  },
  {
    id: "DEC",
    name: "Decatur Airport",
    city: "Decatur",
    country: "United States",
    lat: 39.834598541259766,
    lng: -88.8656997680664,
  },
  {
    id: "CID",
    name: "The Eastern Iowa Airport",
    city: "Cedar Rapids",
    country: "United States",
    lat: 41.884700775146484,
    lng: -91.71080017089844,
  },
  {
    id: "LSE",
    name: "La Crosse Municipal Airport",
    city: "La Crosse",
    country: "United States",
    lat: 43.879002,
    lng: -91.256699,
  },
  {
    id: "CWA",
    name: "Central Wisconsin Airport",
    city: "Wassau",
    country: "United States",
    lat: 44.7775993347,
    lng: -89.6668014526,
  },
  {
    id: "PIA",
    name: "General Wayne A. Downing Peoria International Airport",
    city: "Peoria",
    country: "United States",
    lat: 40.664199829100006,
    lng: -89.6932983398,
  },
  {
    id: "ATW",
    name: "Appleton International Airport",
    city: "Appleton",
    country: "United States",
    lat: 44.258098602299995,
    lng: -88.5190963745,
  },
  {
    id: "RST",
    name: "Rochester International Airport",
    city: "Rochester",
    country: "United States",
    lat: 43.90829849243164,
    lng: -92.5,
  },
  {
    id: "CMI",
    name: "University of Illinois Willard Airport",
    city: "Champaign",
    country: "United States",
    lat: 40.03919983,
    lng: -88.27809906,
  },
  {
    id: "MHK",
    name: "Manhattan Regional Airport",
    city: "Manhattan",
    country: "United States",
    lat: 39.14099884033203,
    lng: -96.6707992553711,
  },
  {
    id: "KGC",
    name: "Kingscote Airport",
    city: "Kingscote",
    country: "Australia",
    lat: -35.71390151977539,
    lng: 137.52099609375,
  },
  {
    id: "HVB",
    name: "Hervey Bay Airport",
    city: "Hervey Bay",
    country: "Australia",
    lat: -25.3188991547,
    lng: 152.880004883,
  },
  {
    id: "DLU",
    name: "Dali Airport",
    city: "Dali",
    country: "China",
    lat: 25.649401,
    lng: 100.319,
  },
  {
    id: "MZV",
    name: "Mulu Airport",
    city: "Mulu",
    country: "Malaysia",
    lat: 4.048329830169678,
    lng: 114.80500030517578,
  },
  {
    id: "SSH",
    name: "Sharm El Sheikh International Airport",
    city: "Sharm El Sheikh",
    country: "Egypt",
    lat: 27.9773006439,
    lng: 34.3950004578,
  },
  {
    id: "FKL",
    name: "Venango Regional Airport",
    city: "Franklin",
    country: "United States",
    lat: 41.3778991699,
    lng: -79.8603973389,
  },
  {
    id: "NBO",
    name: "Jomo Kenyatta International Airport",
    city: "Nairobi",
    country: "Kenya",
    lat: -1.31923997402,
    lng: 36.9277992249,
  },
  {
    id: "SEU",
    name: "Seronera Airport",
    city: "Seronera",
    country: "Tanzania",
    lat: -2.45806,
    lng: 34.822498,
  },
  {
    id: "FTE",
    name: "El Calafate Airport",
    city: "El Calafate",
    country: "Argentina",
    lat: -50.2803,
    lng: -72.053101,
  },
  {
    id: "ARM",
    name: "Armidale Airport",
    city: "Armidale",
    country: "Australia",
    lat: -30.528099060099997,
    lng: 151.617004395,
  },
  {
    id: "GJT",
    name: "Grand Junction Regional Airport",
    city: "Grand Junction",
    country: "United States",
    lat: 39.1223983765,
    lng: -108.527000427,
  },
  {
    id: "SGU",
    name: "St George Municipal Airport",
    city: "Saint George",
    country: "United States",
    lat: 37.036389,
    lng: -113.510306,
  },
  {
    id: "DWH",
    name: "David Wayne Hooks Memorial Airport",
    city: "Houston",
    country: "United States",
    lat: 30.0618000031,
    lng: -95.55280303960001,
  },
  {
    id: "N",
    name: "Port O'Connor Private Heliport",
    city: "Port O'Connor",
    country: "United States",
    lat: 28.429725,
    lng: -96.444419,
  },
  {
    id: "SRQ",
    name: "Sarasota Bradenton International Airport",
    city: "Sarasota",
    country: "United States",
    lat: 27.39539909362793,
    lng: -82.55439758300781,
  },
  {
    id: "BDA",
    name: "L.F. Wade International International Airport",
    city: "Bermuda",
    country: "Bermuda",
    lat: 32.36399841308594,
    lng: -64.67870330810547,
  },
  {
    id: "VNY",
    name: "Van Nuys Airport",
    city: "Van Nuys",
    country: "United States",
    lat: 34.209800720215,
    lng: -118.48999786377,
  },
  {
    id: "MLI",
    name: "Quad City International Airport",
    city: "Moline",
    country: "United States",
    lat: 41.44850158691406,
    lng: -90.50749969482422,
  },
  {
    id: "PFN",
    name: "Panama City-Bay Co International Airport",
    city: "Panama City",
    country: "United States",
    lat: 30.212099,
    lng: -85.6828,
  },
  {
    id: "HIR",
    name: "Honiara International Airport",
    city: "Honiara",
    country: "Solomon Islands",
    lat: -9.4280004501343,
    lng: 160.05499267578,
  },
  {
    id: "PPT",
    name: "Faa'a International Airport",
    city: "Papeete",
    country: "French Polynesia",
    lat: -17.553699,
    lng: -149.606995,
  },
  {
    id: "INU",
    name: "Nauru International Airport",
    city: "Nauru",
    country: "Nauru",
    lat: -0.547458,
    lng: 166.919006,
  },
  {
    id: "FUN",
    name: "Funafuti International Airport",
    city: "Funafuti",
    country: "Tuvalu",
    lat: -8.525,
    lng: 179.195999,
  },
  {
    id: "OVB",
    name: "Tolmachevo Airport",
    city: "Novosibirsk",
    country: "Russia",
    lat: 55.012599945068,
    lng: 82.650703430176,
  },
  {
    id: "N",
    name: "Samsø Airport",
    city: "Samsoe",
    country: "Denmark",
    lat: 55.88949966430664,
    lng: 10.613699913024902,
  },
  {
    id: "XKH",
    name: "Xieng Khouang Airport",
    city: "Phon Savan",
    country: "Laos",
    lat: 19.450001,
    lng: 103.157997,
  },
  {
    id: "BIS",
    name: "Bismarck Municipal Airport",
    city: "Bismarck",
    country: "United States",
    lat: 46.772701263427734,
    lng: -100.74600219726562,
  },
  {
    id: "TEX",
    name: "Telluride Regional Airport",
    city: "Telluride",
    country: "United States",
    lat: 37.9538002,
    lng: -107.9079971,
  },
  {
    id: "N",
    name: "Yinchuan Airport",
    city: "Yinchuan",
    country: "China",
    lat: 38.481899,
    lng: 106.009003,
  },
  {
    id: "HGN",
    name: "Mae Hong Son Airport",
    city: "Mae Hong Son",
    country: "Thailand",
    lat: 19.301300048828125,
    lng: 97.97579956054688,
  },
  {
    id: "RAP",
    name: "Rapid City Regional Airport",
    city: "Rapid City",
    country: "United States",
    lat: 44.0452995300293,
    lng: -103.05699920654297,
  },
  {
    id: "CLD",
    name: "Mc Clellan-Palomar Airport",
    city: "Carlsbad",
    country: "United States",
    lat: 33.12829971,
    lng: -117.2799988,
  },
  {
    id: "FNT",
    name: "Bishop International Airport",
    city: "Flint",
    country: "United States",
    lat: 42.96540069580078,
    lng: -83.74359893798828,
  },
  {
    id: "DVO",
    name: "Francisco Bangoy International Airport",
    city: "Davao",
    country: "Philippines",
    lat: 7.1255202293396,
    lng: 125.64600372314453,
  },
  {
    id: "FNC",
    name: "Madeira Airport",
    city: "Funchal",
    country: "Portugal",
    lat: 32.697899,
    lng: -16.7745,
  },
  {
    id: "STM",
    name: "Maestro Wilson Fonseca Airport",
    city: "Santarem",
    country: "Brazil",
    lat: -2.4247219562530518,
    lng: -54.785831451416016,
  },
  {
    id: "KOS",
    name: "Sihanoukville International Airport",
    city: "Sihanoukville",
    country: "Cambodia",
    lat: 10.57970047,
    lng: 103.637001038,
  },
  {
    id: "YOA",
    name: "Ekati Airport",
    city: "Ekati",
    country: "Canada",
    lat: 64.6988983154,
    lng: -110.614997864,
  },
  {
    id: "NPE",
    name: "Hawke's Bay Airport",
    city: "NAPIER",
    country: "New Zealand",
    lat: -39.465801,
    lng: 176.869995,
  },
  {
    id: "LEV",
    name: "Levuka Airfield",
    city: "Levuka",
    country: "Fiji",
    lat: -17.7110996246,
    lng: 178.759002686,
  },
  {
    id: "LXA",
    name: "Lhasa Gonggar Airport",
    city: "Lhasa",
    country: "China",
    lat: 29.2978000641,
    lng: 90.91190338130001,
  },
  {
    id: "RDD",
    name: "Redding Municipal Airport",
    city: "Redding",
    country: "United States",
    lat: 40.50899887,
    lng: -122.2929993,
  },
  {
    id: "EUG",
    name: "Mahlon Sweet Field",
    city: "Eugene",
    country: "United States",
    lat: 44.12459945678711,
    lng: -123.21199798583984,
  },
  {
    id: "IDA",
    name: "Idaho Falls Regional Airport",
    city: "Idaho Falls",
    country: "United States",
    lat: 43.514599,
    lng: -112.070999,
  },
  {
    id: "MFR",
    name: "Rogue Valley International Medford Airport",
    city: "Medford",
    country: "United States",
    lat: 42.37419891357422,
    lng: -122.87300109863281,
  },
  {
    id: "KBZ",
    name: "Kaikoura Airport",
    city: "Kaikoura",
    country: "New Zealand",
    lat: -42.42499923706055,
    lng: 173.60499572753906,
  },
  {
    id: "RDM",
    name: "Roberts Field",
    city: "Redmond-Bend",
    country: "United States",
    lat: 44.2541008,
    lng: -121.1500015,
  },
  {
    id: "PCN",
    name: "Picton Aerodrome",
    city: "Picton",
    country: "New Zealand",
    lat: -41.346099853516,
    lng: 173.95599365234,
  },
  {
    id: "WDH",
    name: "Hosea Kutako International Airport",
    city: "Windhoek",
    country: "Namibia",
    lat: -22.4799,
    lng: 17.4709,
  },
  {
    id: "YWH",
    name: "Victoria Harbour Seaplane Base",
    city: "Victoria",
    country: "Canada",
    lat: 48.4249858939,
    lng: -123.388867378,
  },
  {
    id: "N",
    name: "Coal Harbour Seaplane Base",
    city: "Vancouver",
    country: "Canada",
    lat: 50.5999984741,
    lng: -127.583000183,
  },
  {
    id: "TNA",
    name: "Yaoqiang Airport",
    city: "Jinan",
    country: "China",
    lat: 36.857200622558594,
    lng: 117.21600341796875,
  },
  {
    id: "CZX",
    name: "Changzhou Benniu Airport",
    city: "Changzhou",
    country: "China",
    lat: 31.919701,
    lng: 119.778999,
  },
  {
    id: "YBP",
    name: "Yibin Caiba Airport",
    city: "Yibin",
    country: "China",
    lat: 28.8005555556,
    lng: 104.545,
  },
  {
    id: "TJM",
    name: "Roshchino International Airport",
    city: "Tyumen",
    country: "Russia",
    lat: 57.189601898199996,
    lng: 65.3243026733,
  },
  {
    id: "CAK",
    name: "Akron Canton Regional Airport",
    city: "Akron",
    country: "United States",
    lat: 40.916099548339844,
    lng: -81.44219970703125,
  },
  {
    id: "HSV",
    name: "Huntsville International Carl T Jones Field",
    city: "Huntsville",
    country: "United States",
    lat: 34.637199401855,
    lng: -86.775100708008,
  },
  {
    id: "PKB",
    name: "Mid Ohio Valley Regional Airport",
    city: "PARKERSBURG",
    country: "United States",
    lat: 39.34510040283203,
    lng: -81.43920135498047,
  },
  {
    id: "MGM",
    name: "Montgomery Regional (Dannelly Field) Airport",
    city: "MONTGOMERY",
    country: "United States",
    lat: 32.30059814,
    lng: -86.39399719,
  },
  {
    id: "TRI",
    name: "Tri-Cities Regional TN/VA Airport",
    city: "BRISTOL",
    country: "United States",
    lat: 36.475201,
    lng: -82.407401,
  },
  {
    id: "PAH",
    name: "Barkley Regional Airport",
    city: "PADUCAH",
    country: "United States",
    lat: 37.06079864501953,
    lng: -88.7738037109375,
  },
  {
    id: "JIB",
    name: "Djibouti-Ambouli Airport",
    city: "Djibouti",
    country: "Djibouti",
    lat: 11.547300338745117,
    lng: 43.15950012207031,
  },
  {
    id: "HAK",
    name: "Haikou Meilan International Airport",
    city: "Haikou",
    country: "China",
    lat: 19.934900283813477,
    lng: 110.45899963378906,
  },
  {
    id: "MFA",
    name: "Mafia Island Airport",
    city: "Mafia Island",
    country: "Tanzania",
    lat: -7.917478,
    lng: 39.668502,
  },
  {
    id: "PGA",
    name: "Page Municipal Airport",
    city: "Page",
    country: "United States",
    lat: 36.92610168,
    lng: -111.447998,
  },
  {
    id: "UII",
    name: "Utila Airport",
    city: "Utila",
    country: "Honduras",
    lat: 16.1131,
    lng: -86.880302,
  },
  {
    id: "FCA",
    name: "Glacier Park International Airport",
    city: "Kalispell",
    country: "United States",
    lat: 48.31050109863281,
    lng: -114.25599670410156,
  },
  {
    id: "MBS",
    name: "MBS International Airport",
    city: "Saginaw",
    country: "United States",
    lat: 43.532901763916016,
    lng: -84.07959747314453,
  },
  {
    id: "BGM",
    name: "Greater Binghamton/Edwin A Link field",
    city: "Binghamton",
    country: "United States",
    lat: 42.20869827,
    lng: -75.97979736,
  },
  {
    id: "BGW",
    name: "Baghdad International Airport",
    city: "Baghdad",
    country: "Iraq",
    lat: 33.262500762900004,
    lng: 44.2346000671,
  },
  {
    id: "NNT",
    name: "Nan Airport",
    city: "Nan",
    country: "Thailand",
    lat: 18.807899475097656,
    lng: 100.78299713134766,
  },
  {
    id: "ROI",
    name: "Roi Et Airport",
    city: "Roi Et",
    country: "Thailand",
    lat: 16.11680030822754,
    lng: 103.77400207519531,
  },
  {
    id: "BFV",
    name: "Buri Ram Airport",
    city: "Buri Ram",
    country: "Thailand",
    lat: 15.229499816894531,
    lng: 103.25299835205078,
  },
  {
    id: "TDX",
    name: "Trat Airport",
    city: "Trat",
    country: "Thailand",
    lat: 12.274600029,
    lng: 102.319000244,
  },
  {
    id: "BLH",
    name: "Blythe Airport",
    city: "Blythe",
    country: "United States",
    lat: 33.6192016602,
    lng: -114.717002869,
  },
  {
    id: "IQA",
    name: "Al Asad Air Base",
    city: "Al Asad",
    country: "Iraq",
    lat: 33.7855987549,
    lng: 42.4412002563,
  },
  {
    id: "TQD",
    name: "Al Taqaddum Air Base",
    city: "Al Taqaddum",
    country: "Iraq",
    lat: 33.33810043335,
    lng: 43.597099304199,
  },
  {
    id: "XQC",
    name: "Joint Base Balad",
    city: "Al Bakr",
    country: "Iraq",
    lat: 33.940200805699995,
    lng: 44.361598968500005,
  },
  {
    id: "CRK",
    name: "Diosdado Macapagal International Airport",
    city: "Angeles City",
    country: "Philippines",
    lat: 15.186,
    lng: 120.559998,
  },
  {
    id: "SDK",
    name: "Sandakan Airport",
    city: "Sandakan",
    country: "Malaysia",
    lat: 5.900899887084961,
    lng: 118.05899810791016,
  },
  {
    id: "LXG",
    name: "Luang Namtha Airport",
    city: "Luang Namtha",
    country: "Laos",
    lat: 20.966999,
    lng: 101.400002,
  },
  {
    id: "ODY",
    name: "Oudomsay Airport",
    city: "Muang Xay",
    country: "Laos",
    lat: 20.68269920349121,
    lng: 101.99400329589844,
  },
  {
    id: "SHE",
    name: "Taoxian Airport",
    city: "Shenyang",
    country: "China",
    lat: 41.639801025390625,
    lng: 123.48300170898438,
  },
  {
    id: "DOY",
    name: "Dongying Shengli Airport",
    city: "Dongying",
    country: "China",
    lat: 37.5085983276,
    lng: 118.788002014,
  },
  {
    id: "MNI",
    name: "John A. Osborne Airport",
    city: "Geralds",
    country: "Montserrat",
    lat: 16.791400909423828,
    lng: -62.19329833984375,
  },
  {
    id: "PSG",
    name: "Petersburg James A Johnson Airport",
    city: "Petersburg",
    country: "United States",
    lat: 56.80170059,
    lng: -132.9450073,
  },
  {
    id: "LYA",
    name: "Luoyang Airport",
    city: "Luoyang",
    country: "China",
    lat: 34.741100311299995,
    lng: 112.388000488,
  },
  {
    id: "XUZ",
    name: "Xuzhou Guanyin Airport",
    city: "Xuzhou",
    country: "China",
    lat: 34.059056,
    lng: 117.555278,
  },
  {
    id: "MWQ",
    name: "Magway Airport",
    city: "Magwe",
    country: "Burma",
    lat: 20.1656,
    lng: 94.941399,
  },
  {
    id: "KHM",
    name: "Kanti Airport",
    city: "Khamti",
    country: "Burma",
    lat: 25.988300323486328,
    lng: 95.67440032958984,
  },
  {
    id: "DLI",
    name: "Lien Khuong Airport",
    city: "Dalat",
    country: "Vietnam",
    lat: 11.75,
    lng: 108.366997,
  },
  {
    id: "VDH",
    name: "Dong Hoi Airport",
    city: "Dong Hoi",
    country: "Vietnam",
    lat: 17.515,
    lng: 106.590556,
  },
  {
    id: "VKG",
    name: "Rach Gia Airport",
    city: "Rach Gia",
    country: "Vietnam",
    lat: 9.95802997234,
    lng: 105.132379532,
  },
  {
    id: "CAH",
    name: "Cà Mau Airport",
    city: "Ca Mau",
    country: "Vietnam",
    lat: 9.177667,
    lng: 105.177778,
  },
  {
    id: "VCL",
    name: "Chu Lai International Airport",
    city: "Chu Lai",
    country: "Vietnam",
    lat: 15.403300285299999,
    lng: 108.706001282,
  },
  {
    id: "TBB",
    name: "Dong Tac Airport",
    city: "Tuy Hoa",
    country: "Vietnam",
    lat: 13.049599647500001,
    lng: 109.333999634,
  },
  {
    id: "PYY",
    name: "Mae Hong Son Airport",
    city: "Pai",
    country: "Thailand",
    lat: 19.3719997406,
    lng: 98.43699646,
  },
  {
    id: "BWK",
    name: "Bol Airport",
    city: "Brac",
    country: "Croatia",
    lat: 43.285701751708984,
    lng: 16.67970085144043,
  },
  {
    id: "NSI",
    name: "Yaoundé Nsimalen International Airport",
    city: "Yaounde",
    country: "Cameroon",
    lat: 3.722559928894043,
    lng: 11.553299903869629,
  },
  {
    id: "CKY",
    name: "Conakry International Airport",
    city: "Conakry",
    country: "Guinea",
    lat: 9.57689,
    lng: -13.612,
  },
  {
    id: "AAH",
    name: "Aachen-Merzbrück Airport",
    city: "Aachen",
    country: "Germany",
    lat: 50.823055267333984,
    lng: 6.186388969421387,
  },
  {
    id: "FKB",
    name: "Karlsruhe Baden-Baden Airport",
    city: "Karlsruhe/Baden-Baden",
    country: "Germany",
    lat: 48.7793998718,
    lng: 8.08049964905,
  },
  {
    id: "SFB",
    name: "Orlando Sanford International Airport",
    city: "Sanford",
    country: "United States",
    lat: 28.777599334716797,
    lng: -81.23750305175781,
  },
  {
    id: "JST",
    name: "John Murtha Johnstown Cambria County Airport",
    city: "Johnstown",
    country: "United States",
    lat: 40.31610107421875,
    lng: -78.83390045166016,
  },
  {
    id: "LUA",
    name: "Lukla Airport",
    city: "Lukla",
    country: "Nepal",
    lat: 27.686899185180664,
    lng: 86.72969818115234,
  },
  {
    id: "BHP",
    name: "Bhojpur Airport",
    city: "Bhojpur",
    country: "Nepal",
    lat: 27.14739990234375,
    lng: 87.05079650878906,
  },
  {
    id: "LDN",
    name: "Lamidanda Airport",
    city: "Lamidanda",
    country: "Nepal",
    lat: 27.25309944152832,
    lng: 86.66999816894531,
  },
  {
    id: "JMO",
    name: "Jomsom Airport",
    city: "Jomsom",
    country: "Nepal",
    lat: 28.780426,
    lng: 83.723,
  },
  {
    id: "NGX",
    name: "Manang Airport",
    city: "Manang",
    country: "Nepal",
    lat: 28.641399,
    lng: 84.089203,
  },
  {
    id: "PPL",
    name: "Phaplu Airport",
    city: "Phaplu",
    country: "Nepal",
    lat: 27.517787,
    lng: 86.584454,
  },
  {
    id: "RUM",
    name: "Rumjatar Airport",
    city: "Rumjatar",
    country: "Nepal",
    lat: 27.303499221801758,
    lng: 86.55039978027344,
  },
  {
    id: "DNP",
    name: "Tulsipur Airport",
    city: "Dang",
    country: "Nepal",
    lat: 28.111099243164062,
    lng: 82.29419708251953,
  },
  {
    id: "RUK",
    name: "Rukum Chaurjahari Airport",
    city: "Rukumkot",
    country: "Nepal",
    lat: 28.627001,
    lng: 82.195,
  },
  {
    id: "JUM",
    name: "Jumla Airport",
    city: "Jumla",
    country: "Nepal",
    lat: 29.2742,
    lng: 82.193298,
  },
  {
    id: "TPJ",
    name: "Taplejung Airport",
    city: "Taplejung",
    country: "Nepal",
    lat: 27.3509,
    lng: 87.69525,
  },
  {
    id: "TMI",
    name: "Tumling Tar Airport",
    city: "Tumling Tar",
    country: "Nepal",
    lat: 27.315001,
    lng: 87.193298,
  },
  {
    id: "SKH",
    name: "Surkhet Airport",
    city: "Surkhet",
    country: "Nepal",
    lat: 28.586,
    lng: 81.636002,
  },
  {
    id: "IMK",
    name: "Simikot Airport",
    city: "Simikot",
    country: "Nepal",
    lat: 29.971099853515625,
    lng: 81.81890106201172,
  },
  {
    id: "DOP",
    name: "Dolpa Airport",
    city: "Dolpa",
    country: "Nepal",
    lat: 28.985700607299805,
    lng: 82.81909942626953,
  },
  {
    id: "BJH",
    name: "Bajhang Airport",
    city: "Bajhang",
    country: "Nepal",
    lat: 29.538999557495117,
    lng: 81.1854019165039,
  },
  {
    id: "DHI",
    name: "Dhangarhi Airport",
    city: "Dhangarhi",
    country: "Nepal",
    lat: 28.753299713134766,
    lng: 80.58190155029297,
  },
  {
    id: "MWX",
    name: "Muan International Airport",
    city: "Muan",
    country: "South Korea",
    lat: 34.991406,
    lng: 126.382814,
  },
  {
    id: "JTY",
    name: "Astypalaia Airport",
    city: "Astypalaia",
    country: "Greece",
    lat: 36.5798988342,
    lng: 26.3757991791,
  },
  {
    id: "JIK",
    name: "Ikaria Airport",
    city: "Ikaria",
    country: "Greece",
    lat: 37.6827011108,
    lng: 26.3470993042,
  },
  {
    id: "JKL",
    name: "Kalymnos Airport",
    city: "Kalymnos",
    country: "Greece",
    lat: 36.9632987976,
    lng: 26.9405994415,
  },
  {
    id: "MLO",
    name: "Milos Airport",
    city: "Milos",
    country: "Greece",
    lat: 36.696899,
    lng: 24.4769,
  },
  {
    id: "JNX",
    name: "Naxos Airport",
    city: "Cyclades Islands",
    country: "Greece",
    lat: 37.0811004639,
    lng: 25.3680992126,
  },
  {
    id: "PAS",
    name: "Paros National Airport",
    city: "Paros",
    country: "Greece",
    lat: 37.020495,
    lng: 25.113195,
  },
  {
    id: "KZS",
    name: "Kastelorizo Airport",
    city: "Kastelorizo",
    country: "Greece",
    lat: 36.1417007446,
    lng: 29.576400756799995,
  },
  {
    id: "RMF",
    name: "Marsa Alam International Airport",
    city: "Marsa Alam",
    country: "Egypt",
    lat: 25.557100296,
    lng: 34.5836982727,
  },
  {
    id: "NRN",
    name: "Weeze Airport",
    city: "Weeze",
    country: "Germany",
    lat: 51.6024017334,
    lng: 6.14216995239,
  },
  {
    id: "USU",
    name: "Francisco B. Reyes Airport",
    city: "Busuanga",
    country: "Philippines",
    lat: 12.1215000153,
    lng: 120.099998474,
  },
  {
    id: "BXU",
    name: "Bancasi Airport",
    city: "Butuan",
    country: "Philippines",
    lat: 8.9515,
    lng: 125.4788,
  },
  {
    id: "DPL",
    name: "Dipolog Airport",
    city: "Dipolog",
    country: "Philippines",
    lat: 8.60198349877,
    lng: 123.341875076,
  },
  {
    id: "LAO",
    name: "Laoag International Airport",
    city: "Laoag",
    country: "Philippines",
    lat: 18.1781005859375,
    lng: 120.53199768066406,
  },
  {
    id: "LGP",
    name: "Legazpi City International Airport",
    city: "Legazpi",
    country: "Philippines",
    lat: 13.1575,
    lng: 123.735,
  },
  {
    id: "OZC",
    name: "Labo Airport",
    city: "Ozamis",
    country: "Philippines",
    lat: 8.178509712219238,
    lng: 123.84200286865234,
  },
  {
    id: "CEB",
    name: "Mactan Cebu International Airport",
    city: "Cebu",
    country: "Philippines",
    lat: 10.307499885559,
    lng: 123.97899627686,
  },
  {
    id: "NOD",
    name: "Norden-Norddeich Airport",
    city: "Norden",
    country: "Germany",
    lat: 53.633056640599996,
    lng: 7.19027805328,
  },
  {
    id: "JUI",
    name: "Juist Airport",
    city: "Juist",
    country: "Germany",
    lat: 53.68111038208008,
    lng: 7.055832862854004,
  },
  {
    id: "BPS",
    name: "Porto Seguro Airport",
    city: "Porto Seguro",
    country: "Brazil",
    lat: -16.438601,
    lng: -39.080898,
  },
  {
    id: "QIG",
    name: "Iguatu Airport",
    city: "Iguatu",
    country: "Brazil",
    lat: -6.346640110015869,
    lng: -39.293800354003906,
  },
  {
    id: "PMW",
    name: "Brigadeiro Lysias Rodrigues Airport",
    city: "Palmas",
    country: "Brazil",
    lat: -10.291500091600001,
    lng: -48.35699844359999,
  },
  {
    id: "CLV",
    name: "Nelson Ribeiro Guimarães Airport",
    city: "Caldas Novas",
    country: "Brazil",
    lat: -17.725299835205,
    lng: -48.607498168945,
  },
  {
    id: "MSO",
    name: "Missoula International Airport",
    city: "Missoula",
    country: "United States",
    lat: 46.91630173,
    lng: -114.0910034,
  },
  {
    id: "BKQ",
    name: "Blackall Airport",
    city: "Blackall",
    country: "Australia",
    lat: -24.427799224900003,
    lng: 145.429000854,
  },
  {
    id: "BDB",
    name: "Bundaberg Airport",
    city: "Bundaberg",
    country: "Australia",
    lat: -24.903900146499996,
    lng: 152.319000244,
  },
  {
    id: "GCN",
    name: "Grand Canyon National Park Airport",
    city: "Grand Canyon",
    country: "United States",
    lat: 35.95240020751953,
    lng: -112.14700317382812,
  },
  {
    id: "SGR",
    name: "Sugar Land Regional Airport",
    city: "Sugar Land",
    country: "United States",
    lat: 29.622299194336,
    lng: -95.65650177002,
  },
  {
    id: "N",
    name: "Hayman Island Heliport",
    city: "Hayman Island",
    country: "Australia",
    lat: -20.0599,
    lng: 148.8834,
  },
  {
    id: "APA",
    name: "Centennial Airport",
    city: "Denver",
    country: "United States",
    lat: 39.57009888,
    lng: -104.848999,
  },
  {
    id: "CVN",
    name: "Clovis Municipal Airport",
    city: "Clovis",
    country: "United States",
    lat: 34.4250984192,
    lng: -103.07900238,
  },
  {
    id: "FST",
    name: "Fort Stockton Pecos County Airport",
    city: "Fort Stockton",
    country: "United States",
    lat: 30.9157009125,
    lng: -102.916000366,
  },
  {
    id: "LVS",
    name: "Las Vegas Municipal Airport",
    city: "Las Vegas",
    country: "United States",
    lat: 35.6542015076,
    lng: -105.141998291,
  },
  {
    id: "IWS",
    name: "West Houston Airport",
    city: "Houston",
    country: "United States",
    lat: 29.818199157699997,
    lng: -95.67259979250001,
  },
  {
    id: "N",
    name: "La Junta Municipal Airport",
    city: "La Junta",
    country: "United States",
    lat: 38.04970169,
    lng: -103.5090027,
  },
  {
    id: "LRU",
    name: "Las Cruces International Airport",
    city: "Las Cruces",
    country: "United States",
    lat: 32.289398193359375,
    lng: -106.9219970703125,
  },
  {
    id: "BKD",
    name: "Stephens County Airport",
    city: "Breckenridge",
    country: "United States",
    lat: 32.71900177,
    lng: -98.89099884030001,
  },
  {
    id: "TPL",
    name: "Draughon Miller Central Texas Regional Airport",
    city: "Temple",
    country: "United States",
    lat: 31.15250015258789,
    lng: -97.40779876708984,
  },
  {
    id: "OZA",
    name: "Ozona Municipal Airport",
    city: "Ozona",
    country: "United States",
    lat: 30.735300064087,
    lng: -101.20300292969,
  },
  {
    id: "KDM",
    name: "Kaadedhdhoo Airport",
    city: "Kaadedhdhoo",
    country: "Maldives",
    lat: 0.48813098669052124,
    lng: 72.99690246582031,
  },
  {
    id: "LAK",
    name: "Aklavik/Freddie Carmichael Airport",
    city: "Aklavik",
    country: "Canada",
    lat: 68.223297,
    lng: -135.00599,
  },
  {
    id: "YWJ",
    name: "Déline Airport",
    city: "Deline",
    country: "Canada",
    lat: 65.21109771728516,
    lng: -123.43599700927734,
  },
  {
    id: "ZFN",
    name: "Tulita Airport",
    city: "Tulita",
    country: "Canada",
    lat: 64.909697,
    lng: -125.572998,
  },
  {
    id: "YGH",
    name: "Fort Good Hope Airport",
    city: "Fort Good Hope",
    country: "Canada",
    lat: 66.24079895019531,
    lng: -128.6510009765625,
  },
  {
    id: "TAH",
    name: "Tanna Airport",
    city: "Tanna",
    country: "Vanuatu",
    lat: -19.45509910583496,
    lng: 169.2239990234375,
  },
  {
    id: "YPC",
    name: "Paulatuk (Nora Aliqatchialuk Ruben) Airport",
    city: "Paulatuk",
    country: "Canada",
    lat: 69.3608381154,
    lng: -124.075469971,
  },
  {
    id: "SRZ",
    name: "El Trompillo Airport",
    city: "Santa Cruz",
    country: "Bolivia",
    lat: -17.8115997314,
    lng: -63.1715011597,
  },
  {
    id: "SAB",
    name: "Juancho E. Yrausquin Airport",
    city: "Saba",
    country: "Netherlands Antilles",
    lat: 17.645000457763672,
    lng: -63.220001220703125,
  },
  {
    id: "EGE",
    name: "Eagle County Regional Airport",
    city: "Vail",
    country: "United States",
    lat: 39.64260101,
    lng: -106.9179993,
  },
  {
    id: "SKN",
    name: "Stokmarknes Skagen Airport",
    city: "Stokmarknes",
    country: "Norway",
    lat: 68.578826904297,
    lng: 15.033416748047,
  },
  {
    id: "CGF",
    name: "Cuyahoga County Airport",
    city: "Richmond Heights",
    country: "United States",
    lat: 41.5651016235,
    lng: -81.4863967896,
  },
  {
    id: "MFD",
    name: "Mansfield Lahm Regional Airport",
    city: "Mansfield",
    country: "United States",
    lat: 40.82139968869999,
    lng: -82.5166015625,
  },
  {
    id: "CSG",
    name: "Columbus Metropolitan Airport",
    city: "Columbus",
    country: "United States",
    lat: 32.516300201416016,
    lng: -84.93890380859375,
  },
  {
    id: "LAW",
    name: "Lawton Fort Sill Regional Airport",
    city: "Lawton",
    country: "United States",
    lat: 34.5676994324,
    lng: -98.4166030884,
  },
  {
    id: "FNL",
    name: "Northern Colorado Regional Airport",
    city: "Fort Collins",
    country: "United States",
    lat: 40.451804,
    lng: -105.011,
  },
  {
    id: "FLG",
    name: "Flagstaff Pulliam Airport",
    city: "Flagstaff",
    country: "United States",
    lat: 35.13850021,
    lng: -111.6709976,
  },
  {
    id: "TVL",
    name: "Lake Tahoe Airport",
    city: "South Lake Tahoe",
    country: "United States",
    lat: 38.89390182495117,
    lng: -119.99500274658203,
  },
  {
    id: "TWF",
    name: "Joslin Field Magic Valley Regional Airport",
    city: "Twin Falls",
    country: "United States",
    lat: 42.4818,
    lng: -114.487999,
  },
  {
    id: "MVY",
    name: "Martha's Vineyard Airport",
    city: "Vineyard Haven MA",
    country: "United States",
    lat: 41.3931007385,
    lng: -70.6143035889,
  },
  {
    id: "CON",
    name: "Concord Municipal Airport",
    city: "Concord NH",
    country: "United States",
    lat: 43.20270157,
    lng: -71.50229645,
  },
  {
    id: "GON",
    name: "Groton New London Airport",
    city: "Groton CT",
    country: "United States",
    lat: 41.330101013183594,
    lng: -72.04509735107422,
  },
  {
    id: "STC",
    name: "St Cloud Regional Airport",
    city: "Saint Cloud",
    country: "United States",
    lat: 45.546600341796875,
    lng: -94.05989837646484,
  },
  {
    id: "BPE",
    name: "Qinhuangdao Beidaihe Airport",
    city: "Bagan",
    country: "Burma",
    lat: 39.666389,
    lng: 119.058889,
  },
  {
    id: "GTR",
    name: "Golden Triangle Regional Airport",
    city: "Columbus Mississippi",
    country: "United States",
    lat: 33.450298309299995,
    lng: -88.5914001465,
  },
  {
    id: "GOJ",
    name: "Nizhny Novgorod Strigino International Airport",
    city: "Nizhniy Novgorod",
    country: "Russia",
    lat: 56.230098724365,
    lng: 43.784000396729,
  },
  {
    id: "HQM",
    name: "Bowerman Airport",
    city: "Hoquiam",
    country: "United States",
    lat: 46.971199035599994,
    lng: -123.93699646,
  },
  {
    id: "ERI",
    name: "Erie International Tom Ridge Field",
    city: "Erie",
    country: "United States",
    lat: 42.0831270134,
    lng: -80.1738667488,
  },
  {
    id: "HYA",
    name: "Barnstable Municipal Boardman Polando Field",
    city: "Barnstable",
    country: "United States",
    lat: 41.66930008,
    lng: -70.28040314,
  },
  {
    id: "SPR",
    name: "San Pedro Airport",
    city: "San Pedro",
    country: "Belize",
    lat: 17.9139,
    lng: -87.9711,
  },
  {
    id: "SDX",
    name: "Sedona Airport",
    city: "Sedona",
    country: "United States",
    lat: 34.848598480225,
    lng: -111.78800201416,
  },
  {
    id: "MGW",
    name: "Morgantown Municipal Walter L. Bill Hart Field",
    city: "Morgantown",
    country: "United States",
    lat: 39.64289856,
    lng: -79.91629791,
  },
  {
    id: "CRW",
    name: "Yeager Airport",
    city: "Charleston",
    country: "United States",
    lat: 38.37310028076172,
    lng: -81.59320068359375,
  },
  {
    id: "AVP",
    name: "Wilkes Barre Scranton International Airport",
    city: "Scranton",
    country: "United States",
    lat: 41.338500976599995,
    lng: -75.72339630130001,
  },
  {
    id: "BJI",
    name: "Bemidji Regional Airport",
    city: "Bemidji",
    country: "United States",
    lat: 47.50939941,
    lng: -94.93370056,
  },
  {
    id: "THG",
    name: "Thangool Airport",
    city: "Biloela",
    country: "Australia",
    lat: -24.493900299072266,
    lng: 150.5760040283203,
  },
  {
    id: "FGI",
    name: "Fagali'i Airport",
    city: "Apia",
    country: "Samoa",
    lat: -13.848699569699999,
    lng: -171.740005493,
  },
  {
    id: "BNK",
    name: "Ballina Byron Gateway Airport",
    city: "Ballina Byron Bay",
    country: "Australia",
    lat: -28.8339004517,
    lng: 153.56199646,
  },
  {
    id: "FAR",
    name: "Hector International Airport",
    city: "Fargo",
    country: "United States",
    lat: 46.92070007324219,
    lng: -96.81580352783203,
  },
  {
    id: "MKC",
    name: "Charles B. Wheeler Downtown Airport",
    city: "Kansas City",
    country: "United States",
    lat: 39.123199462890625,
    lng: -94.5927963256836,
  },
  {
    id: "RBE",
    name: "Ratanakiri Airport",
    city: "Ratanakiri",
    country: "Cambodia",
    lat: 13.729999542236328,
    lng: 106.98699951171875,
  },
  {
    id: "GCC",
    name: "Gillette Campbell County Airport",
    city: "Gillette",
    country: "United States",
    lat: 44.348899841299996,
    lng: -105.539001465,
  },
  {
    id: "TOF",
    name: "Bogashevo Airport",
    city: "Tomsk",
    country: "Russia",
    lat: 56.380298614502,
    lng: 85.208297729492,
  },
  {
    id: "NZJ",
    name: "El Toro Marine Corps Air Station",
    city: "Santa Ana",
    country: "United States",
    lat: 33.67610168457031,
    lng: -117.73100280761719,
  },
  {
    id: "PHY",
    name: "Phetchabun Airport",
    city: "Phetchabun",
    country: "Thailand",
    lat: 16.6760005951,
    lng: 101.194999695,
  },
  {
    id: "CJM",
    name: "Chumphon Airport",
    city: "Chumphon",
    country: "Thailand",
    lat: 10.711199760437012,
    lng: 99.36170196533203,
  },
  {
    id: "JZH",
    name: "Jiuzhai Huanglong Airport",
    city: "Jiuzhaigou",
    country: "China",
    lat: 32.8533333333,
    lng: 103.682222222,
  },
  {
    id: "SWA",
    name: "Jieyang Chaoshan International Airport",
    city: "Shantou",
    country: "China",
    lat: 23.552,
    lng: 116.5033,
  },
  {
    id: "N",
    name: "Enghien Moisselles Airfield",
    city: "Enghien-moisselles",
    country: "France",
    lat: 49.046398,
    lng: 2.35306,
  },
  {
    id: "GEO",
    name: "Cheddi Jagan International Airport",
    city: "Georgetown",
    country: "Guyana",
    lat: 6.498549938201904,
    lng: -58.25410079956055,
  },
  {
    id: "AGT",
    name: "Guarani International Airport",
    city: "Ciudad del Este",
    country: "Paraguay",
    lat: -25.454516,
    lng: -54.842682,
  },
  {
    id: "OGL",
    name: "Eugene F. Correira International Airport",
    city: "Georgetown",
    country: "Guyana",
    lat: 6.80628,
    lng: -58.1059,
  },
  {
    id: "KAI",
    name: "Kaieteur International Airport",
    city: "Kaieteur",
    country: "Guyana",
    lat: 5.17275476456,
    lng: -59.491481781,
  },
  {
    id: "DNH",
    name: "Dunhuang Airport",
    city: "Dunhuang",
    country: "China",
    lat: 40.16109848022461,
    lng: 94.80919647216797,
  },
  {
    id: "AOI",
    name: "Ancona Falconara Airport",
    city: "Ancona",
    country: "Italy",
    lat: 43.616299,
    lng: 13.3623,
  },
  {
    id: "N",
    name: "Chamonate Airport",
    city: "Copiapo",
    country: "Chile",
    lat: -27.2968997955,
    lng: -70.4131011963,
  },
  {
    id: "TCP",
    name: "Taba International Airport",
    city: "Taba",
    country: "Egypt",
    lat: 29.587799072299998,
    lng: 34.7780990601,
  },
  {
    id: "LYB",
    name: "Edward Bodden Airfield",
    city: "Little Cayman",
    country: "Cayman Islands",
    lat: 19.660161,
    lng: -80.088826,
  },
  {
    id: "BJV",
    name: "Milas Bodrum International Airport",
    city: "Bodrum",
    country: "Turkey",
    lat: 37.25059890749999,
    lng: 27.6643009186,
  },
  {
    id: "TBJ",
    name: "Tabarka 7 Novembre Airport",
    city: "Tabarka",
    country: "Tunisia",
    lat: 36.97999954223633,
    lng: 8.87693977355957,
  },
  {
    id: "SAW",
    name: "Sabiha Gökçen International Airport",
    city: "Istanbul",
    country: "Turkey",
    lat: 40.898601532,
    lng: 29.3092002869,
  },
  {
    id: "SCE",
    name: "University Park Airport",
    city: "State College Pennsylvania",
    country: "United States",
    lat: 40.8493003845,
    lng: -77.84870147710001,
  },
  {
    id: "BME",
    name: "Broome International Airport",
    city: "Broome",
    country: "Australia",
    lat: -17.944700241088867,
    lng: 122.23200225830078,
  },
  {
    id: "NTL",
    name: "Newcastle Airport",
    city: "Newcastle",
    country: "Australia",
    lat: -32.79499816894531,
    lng: 151.83399963378906,
  },
  {
    id: "N",
    name: "Bakki Airport",
    city: "Bakki",
    country: "Iceland",
    lat: 63.55609893798828,
    lng: -20.137500762939453,
  },
  {
    id: "KLU",
    name: "Klagenfurt Airport",
    city: "Klagenfurt",
    country: "Austria",
    lat: 46.642502,
    lng: 14.3377,
  },
  {
    id: "HFT",
    name: "Hammerfest Airport",
    city: "Hammerfest",
    country: "Norway",
    lat: 70.679702758789,
    lng: 23.668600082397,
  },
  {
    id: "HVG",
    name: "Valan Airport",
    city: "Honningsvag",
    country: "Norway",
    lat: 71.009696960449,
    lng: 25.983600616455,
  },
  {
    id: "MEH",
    name: "Mehamn Airport",
    city: "Mehamn",
    country: "Norway",
    lat: 71.02970123291,
    lng: 27.826700210571,
  },
  {
    id: "VDS",
    name: "Vadsø Airport",
    city: "Vadsø",
    country: "Norway",
    lat: 70.065299987793,
    lng: 29.844699859619,
  },
  {
    id: "IKA",
    name: "Imam Khomeini International Airport",
    city: "Tehran",
    country: "Iran",
    lat: 35.416099548339844,
    lng: 51.152198791503906,
  },
  {
    id: "MHD",
    name: "Mashhad International Airport",
    city: "Mashhad",
    country: "Iran",
    lat: 36.235198974609375,
    lng: 59.64099884033203,
  },
  {
    id: "UIK",
    name: "Ust-Ilimsk Airport",
    city: "Ust Ilimsk",
    country: "Russia",
    lat: 58.13610076904297,
    lng: 102.56500244140625,
  },
  {
    id: "MEI",
    name: "Key Field",
    city: "Meridian",
    country: "United States",
    lat: 32.33259963989258,
    lng: -88.75189971923828,
  },
  {
    id: "SPI",
    name: "Abraham Lincoln Capital Airport",
    city: "Springfield",
    country: "United States",
    lat: 39.84410095,
    lng: -89.67790222,
  },
  {
    id: "CEZ",
    name: "Cortez Municipal Airport",
    city: "Cortez",
    country: "United States",
    lat: 37.3030014038,
    lng: -108.627998352,
  },
  {
    id: "HDN",
    name: "Yampa Valley Airport",
    city: "Hayden",
    country: "United States",
    lat: 40.48120117,
    lng: -107.2180023,
  },
  {
    id: "GUP",
    name: "Gallup Municipal Airport",
    city: "Gallup",
    country: "United States",
    lat: 35.511100769,
    lng: -108.789001465,
  },
  {
    id: "LBL",
    name: "Liberal Mid-America Regional Airport",
    city: "Liberal",
    country: "United States",
    lat: 37.0442009,
    lng: -100.9599991,
  },
  {
    id: "LAA",
    name: "Lamar Municipal Airport",
    city: "Lamar",
    country: "United States",
    lat: 38.069698333699996,
    lng: -102.68800354,
  },
  {
    id: "GLD",
    name: "Renner Field-Goodland Municipal Airport",
    city: "Goodland",
    country: "United States",
    lat: 39.37060165,
    lng: -101.6989975,
  },
  {
    id: "COD",
    name: "Yellowstone Regional Airport",
    city: "Cody",
    country: "United States",
    lat: 44.520198822,
    lng: -109.024002075,
  },
  {
    id: "HOV",
    name: "Ørsta-Volda Airport, Hovden",
    city: "Orsta-Volda",
    country: "Norway",
    lat: 62.180000305176,
    lng: 6.0741000175476,
  },
  {
    id: "ISC",
    name: "St. Mary's Airport",
    city: "ST MARY'S",
    country: "United Kingdom",
    lat: 49.913299560546875,
    lng: -6.291669845581055,
  },
  {
    id: "SGF",
    name: "Springfield Branson National Airport",
    city: "Springfield",
    country: "United States",
    lat: 37.24570084,
    lng: -93.38860321,
  },
  {
    id: "NVK",
    name: "Narvik Framnes Airport",
    city: "Narvik",
    country: "Norway",
    lat: 68.436897277832,
    lng: 17.386699676514,
  },
  {
    id: "BVG",
    name: "Berlevåg Airport",
    city: "Berlevag",
    country: "Norway",
    lat: 70.871399,
    lng: 29.034201,
  },
  {
    id: "FBU",
    name: "Oslo, Fornebu Airport",
    city: "Oslo",
    country: "Norway",
    lat: 59.89580154418945,
    lng: 10.617199897766113,
  },
  {
    id: "NSK",
    name: "Norilsk-Alykel Airport",
    city: "Norilsk",
    country: "Russia",
    lat: 69.31109619140625,
    lng: 87.33219909667969,
  },
  {
    id: "AAQ",
    name: "Anapa Vityazevo Airport",
    city: "Anapa",
    country: "Russia",
    lat: 45.002101898193,
    lng: 37.347301483154,
  },
  {
    id: "JLN",
    name: "Joplin Regional Airport",
    city: "Joplin",
    country: "United States",
    lat: 37.151798248291016,
    lng: -94.49829864501953,
  },
  {
    id: "ABE",
    name: "Lehigh Valley International Airport",
    city: "Allentown",
    country: "United States",
    lat: 40.652099609375,
    lng: -75.44080352783203,
  },
  {
    id: "XNA",
    name: "Northwest Arkansas Regional Airport",
    city: "Bentonville",
    country: "United States",
    lat: 36.281898,
    lng: -94.306801,
  },
  {
    id: "GUW",
    name: "Atyrau Airport",
    city: "Atyrau",
    country: "Kazakhstan",
    lat: 47.12189865112305,
    lng: 51.8213996887207,
  },
  {
    id: "KZO",
    name: "Kzyl-Orda Southwest Airport",
    city: "Kzyl-Orda",
    country: "Kazakhstan",
    lat: 44.706902,
    lng: 65.592499,
  },
  {
    id: "SBN",
    name: "South Bend Regional Airport",
    city: "South Bend",
    country: "United States",
    lat: 41.70869827270508,
    lng: -86.31729888916016,
  },
  {
    id: "BKA",
    name: "Bykovo Airport",
    city: "Moscow",
    country: "Russia",
    lat: 55.6171989441,
    lng: 38.0600013733,
  },
  {
    id: "ARH",
    name: "Talagi Airport",
    city: "Arkhangelsk",
    country: "Russia",
    lat: 64.60030364990234,
    lng: 40.71670150756836,
  },
  {
    id: "RTW",
    name: "Saratov Central Airport",
    city: "Saratov",
    country: "Russia",
    lat: 51.564998626708984,
    lng: 46.04669952392578,
  },
  {
    id: "NUX",
    name: "Novy Urengoy Airport",
    city: "Novy Urengoy",
    country: "Russia",
    lat: 66.06939697265625,
    lng: 76.52030181884766,
  },
  {
    id: "NOJ",
    name: "Noyabrsk Airport",
    city: "Noyabrsk",
    country: "Russia",
    lat: 63.18330001831055,
    lng: 75.2699966430664,
  },
  {
    id: "SCO",
    name: "Aktau Airport",
    city: "Aktau",
    country: "Kazakhstan",
    lat: 43.8601,
    lng: 51.091999,
  },
  {
    id: "UCT",
    name: "Ukhta Airport",
    city: "Ukhta",
    country: "Russia",
    lat: 63.566898345947266,
    lng: 53.8046989440918,
  },
  {
    id: "USK",
    name: "Usinsk Airport",
    city: "Usinsk",
    country: "Russia",
    lat: 66.00469970703125,
    lng: 57.3671989440918,
  },
  {
    id: "PEX",
    name: "Pechora Airport",
    city: "Pechora",
    country: "Russia",
    lat: 65.12110137939453,
    lng: 57.13079833984375,
  },
  {
    id: "NNM",
    name: "Naryan Mar Airport",
    city: "Naryan-Mar",
    country: "Russia",
    lat: 67.63999938964844,
    lng: 53.12189865112305,
  },
  {
    id: "PKV",
    name: "Pskov Airport",
    city: "Pskov",
    country: "Russia",
    lat: 57.78390121459961,
    lng: 28.395599365234375,
  },
  {
    id: "KGP",
    name: "Kogalym International Airport",
    city: "Kogalym",
    country: "Russia",
    lat: 62.190399169921875,
    lng: 74.53379821777344,
  },
  {
    id: "KJA",
    name: "Yemelyanovo Airport",
    city: "Krasnoyarsk",
    country: "Russia",
    lat: 56.172901,
    lng: 92.493301,
  },
  {
    id: "KGF",
    name: "Sary-Arka Airport",
    city: "Karaganda",
    country: "Kazakhstan",
    lat: 49.670799255371094,
    lng: 73.33439636230469,
  },
  {
    id: "N",
    name: "Novosibirsk North Airport",
    city: "Novosibirsk",
    country: "Russia",
    lat: 55.09170150756836,
    lng: 82.90670013427734,
  },
  {
    id: "URJ",
    name: "Uray Airport",
    city: "Uraj",
    country: "Russia",
    lat: 60.10329818725586,
    lng: 64.82669830322266,
  },
  {
    id: "IWA",
    name: "Ivanovo South Airport",
    city: "Ivanovo",
    country: "Russia",
    lat: 56.93939971923828,
    lng: 40.940799713134766,
  },
  {
    id: "CGQ",
    name: "Longjia Airport",
    city: "Changchun",
    country: "China",
    lat: 43.9962005615,
    lng: 125.684997559,
  },
  {
    id: "KIJ",
    name: "Niigata Airport",
    city: "Niigata",
    country: "Japan",
    lat: 37.9558982849,
    lng: 139.121002197,
  },
  {
    id: "JON",
    name: "Johnston Atoll Airport",
    city: "Johnston Island",
    country: "Johnston Atoll",
    lat: 16.7285995483,
    lng: -169.533996582,
  },
  {
    id: "SMD",
    name: "Smith Field",
    city: "Fort Wayne IN",
    country: "United States",
    lat: 41.14339828,
    lng: -85.15280151,
  },
  {
    id: "ACV",
    name: "California Redwood Coast-Humboldt County Airport",
    city: "Arcata CA",
    country: "United States",
    lat: 40.978101,
    lng: -124.109,
  },
  {
    id: "OAJ",
    name: "Albert J Ellis Airport",
    city: "Jacksonville NC",
    country: "United States",
    lat: 34.8292007446,
    lng: -77.61209869380001,
  },
  {
    id: "TCL",
    name: "Tuscaloosa Regional Airport",
    city: "Tuscaloosa AL",
    country: "United States",
    lat: 33.220600128174,
    lng: -87.611396789551,
  },
  {
    id: "DBQ",
    name: "Dubuque Regional Airport",
    city: "Dubuque IA",
    country: "United States",
    lat: 42.40200043,
    lng: -90.70950317,
  },
  {
    id: "HHP",
    name: "Shun Tak Heliport",
    city: "Hong Kong",
    country: "Hong Kong",
    lat: 22.2893714905,
    lng: 114.152153015,
  },
  {
    id: "ATD",
    name: "Uru Harbour Airport",
    city: "Atoifi",
    country: "Solomon Islands",
    lat: -8.87333,
    lng: 161.011002,
  },
  {
    id: "AKS",
    name: "Gwaunaru'u Airport",
    city: "Auki",
    country: "Solomon Islands",
    lat: -8.70257,
    lng: 160.682007,
  },
  {
    id: "BAS",
    name: "Ballalae Airport",
    city: "Ballalae",
    country: "Solomon Islands",
    lat: -6.990745,
    lng: 155.886656,
  },
  {
    id: "FRE",
    name: "Fera/Maringe Airport",
    city: "Fera Island",
    country: "Solomon Islands",
    lat: -8.1075,
    lng: 159.576996,
  },
  {
    id: "MBU",
    name: "Babanakira Airport",
    city: "Mbambanakira",
    country: "Solomon Islands",
    lat: -9.7475004196167,
    lng: 159.83900451660156,
  },
  {
    id: "IRA",
    name: "Ngorangora Airport",
    city: "Kirakira",
    country: "Solomon Islands",
    lat: -10.449700355500001,
    lng: 161.897994995,
  },
  {
    id: "SCZ",
    name: "Santa Cruz/Graciosa Bay/Luova Airport",
    city: "Santa Cruz/Graciosa Bay/Luova",
    country: "Solomon Islands",
    lat: -10.72029972076416,
    lng: 165.7949981689453,
  },
  {
    id: "MUA",
    name: "Munda Airport",
    city: "Munda",
    country: "Solomon Islands",
    lat: -8.327969551086426,
    lng: 157.26300048828125,
  },
  {
    id: "GZO",
    name: "Nusatupe Airport",
    city: "Gizo",
    country: "Solomon Islands",
    lat: -8.09778022766,
    lng: 156.863998413,
  },
  {
    id: "MNY",
    name: "Mono Airport",
    city: "Stirling Island",
    country: "Solomon Islands",
    lat: -7.416940212249756,
    lng: 155.56500244140625,
  },
  {
    id: "RNL",
    name: "Rennell/Tingoa Airport",
    city: "Rennell Island",
    country: "Solomon Islands",
    lat: -11.533900260925293,
    lng: 160.06300354003906,
  },
  {
    id: "RUS",
    name: "Marau Airport",
    city: "Marau",
    country: "Solomon Islands",
    lat: -9.861669540409999,
    lng: 160.824996948,
  },
  {
    id: "VAO",
    name: "Suavanao Airport",
    city: "Suavanao",
    country: "Solomon Islands",
    lat: -7.585559844970703,
    lng: 158.7310028076172,
  },
  {
    id: "KGE",
    name: "Kaghau Airport",
    city: "Kagau Island",
    country: "Solomon Islands",
    lat: -7.3305,
    lng: 157.585,
  },
  {
    id: "RBV",
    name: "Ramata Airport",
    city: "Ramata",
    country: "Solomon Islands",
    lat: -8.168060302734375,
    lng: 157.64300537109375,
  },
  {
    id: "BUA",
    name: "Buka Airport",
    city: "Buka Island",
    country: "Papua New Guinea",
    lat: -5.4223198890686035,
    lng: 154.67300415039062,
  },
  {
    id: "CMU",
    name: "Chimbu Airport",
    city: "Kundiawa",
    country: "Papua New Guinea",
    lat: -6.024290084838867,
    lng: 144.9709930419922,
  },
  {
    id: "DAU",
    name: "Daru Airport",
    city: "Daru",
    country: "Papua New Guinea",
    lat: -9.08675956726,
    lng: 143.207992554,
  },
  {
    id: "GUR",
    name: "Gurney Airport",
    city: "Gurney",
    country: "Papua New Guinea",
    lat: -10.3114995956,
    lng: 150.333999634,
  },
  {
    id: "PNP",
    name: "Girua Airport",
    city: "Girua",
    country: "Papua New Guinea",
    lat: -8.80453968048,
    lng: 148.309005737,
  },
  {
    id: "HKN",
    name: "Kimbe Airport",
    city: "Hoskins",
    country: "Papua New Guinea",
    lat: -5.462170124053955,
    lng: 150.40499877929688,
  },
  {
    id: "UNG",
    name: "Kiunga Airport",
    city: "Kiunga",
    country: "Papua New Guinea",
    lat: -6.1257100105285645,
    lng: 141.28199768066406,
  },
  {
    id: "KRI",
    name: "Kikori Airport",
    city: "Kikori",
    country: "Papua New Guinea",
    lat: -7.424379825592041,
    lng: 144.2500762939453,
  },
  {
    id: "KMA",
    name: "Kerema Airport",
    city: "Kerema",
    country: "Papua New Guinea",
    lat: -7.96361017227,
    lng: 145.770996094,
  },
  {
    id: "KVG",
    name: "Kavieng Airport",
    city: "Kavieng",
    country: "Papua New Guinea",
    lat: -2.57940006256,
    lng: 150.807998657,
  },
  {
    id: "MDU",
    name: "Mendi Airport",
    city: "Mendi",
    country: "Papua New Guinea",
    lat: -6.14774,
    lng: 143.656998,
  },
  {
    id: "MAS",
    name: "Momote Airport",
    city: "Momote",
    country: "Papua New Guinea",
    lat: -2.06189,
    lng: 147.423996,
  },
  {
    id: "MXH",
    name: "Moro Airport",
    city: "Moro",
    country: "Papua New Guinea",
    lat: -6.36332988739,
    lng: 143.238006592,
  },
  {
    id: "MIS",
    name: "Misima Island Airport",
    city: "Misima Island",
    country: "Papua New Guinea",
    lat: -10.689200401299999,
    lng: 152.837997437,
  },
  {
    id: "TIZ",
    name: "Tari Airport",
    city: "Tari",
    country: "Papua New Guinea",
    lat: -5.84499979019,
    lng: 142.947998047,
  },
  {
    id: "TBG",
    name: "Tabubil Airport",
    city: "Tabubil",
    country: "Papua New Guinea",
    lat: -5.27861,
    lng: 141.225998,
  },
  {
    id: "RAB",
    name: "Tokua Airport",
    city: "Tokua",
    country: "Papua New Guinea",
    lat: -4.34045982361,
    lng: 152.380004883,
  },
  {
    id: "VAI",
    name: "Vanimo Airport",
    city: "Vanimo",
    country: "Papua New Guinea",
    lat: -2.6926,
    lng: 141.3028,
  },
  {
    id: "WBM",
    name: "Wapenamanda Airport",
    city: "Wapenamanda",
    country: "Papua New Guinea",
    lat: -5.6433000564575195,
    lng: 143.89500427246094,
  },
  {
    id: "LLU",
    name: "Alluitsup Paa Heliport",
    city: "Alluitsup Paa",
    country: "Greenland",
    lat: 60.46445,
    lng: -45.56917,
  },
  {
    id: "CNP",
    name: "Neerlerit Inaat Airport",
    city: "Neerlerit Inaat",
    country: "Greenland",
    lat: 70.7431030273,
    lng: -22.6504993439,
  },
  {
    id: "JFR",
    name: "Paamiut Heliport",
    city: "Paamiut",
    country: "Greenland",
    lat: 61.9921989441,
    lng: -49.6624984741,
  },
  {
    id: "JGO",
    name: "Qeqertarsuaq Heliport",
    city: "Qeqertarsuaq Airport",
    country: "Greenland",
    lat: 69.251181993,
    lng: -53.5148763657,
  },
  {
    id: "JJU",
    name: "Qaqortoq Heliport",
    city: "Qaqortoq",
    country: "Greenland",
    lat: 60.715684155299996,
    lng: -46.0299186409,
  },
  {
    id: "JSU",
    name: "Maniitsoq Airport",
    city: "Maniitsoq",
    country: "Greenland",
    lat: 65.4124984741,
    lng: -52.9393997192,
  },
  {
    id: "JNN",
    name: "Nanortalik Heliport",
    city: "Nanortalik",
    country: "Greenland",
    lat: 60.141883975899994,
    lng: -45.232976675,
  },
  {
    id: "JNS",
    name: "Narsaq Heliport",
    city: "Narsaq",
    country: "Greenland",
    lat: 60.9172827256,
    lng: -46.059923172,
  },
  {
    id: "NAQ",
    name: "Qaanaaq Airport",
    city: "Qaanaaq",
    country: "Greenland",
    lat: 77.4886016846,
    lng: -69.3887023926,
  },
  {
    id: "JHS",
    name: "Sisimiut Airport",
    city: "Sisimiut",
    country: "Greenland",
    lat: 66.9513015747,
    lng: -53.7293014526,
  },
  {
    id: "JUV",
    name: "Upernavik Airport",
    city: "Upernavik",
    country: "Greenland",
    lat: 72.7901992798,
    lng: -56.1305999756,
  },
  {
    id: "JQA",
    name: "Qaarsut Airport",
    city: "Uummannaq",
    country: "Greenland",
    lat: 70.7341995239,
    lng: -52.6962013245,
  },
  {
    id: "GRY",
    name: "Grímsey Airport",
    city: "Grímsey",
    country: "Iceland",
    lat: 66.5458,
    lng: -18.0173,
  },
  {
    id: "THO",
    name: "Thorshofn Airport",
    city: "Thorshofn",
    country: "Iceland",
    lat: 66.21849822998047,
    lng: -15.335599899291992,
  },
  {
    id: "VPN",
    name: "Vopnafjörður Airport",
    city: "Vopnafjörður",
    country: "Iceland",
    lat: 65.72059631347656,
    lng: -14.850600242614746,
  },
  {
    id: "YWS",
    name: "Whistler/Green Lake Water Aerodrome",
    city: "Whistler",
    country: "Canada",
    lat: 50.1436004639,
    lng: -122.948997498,
  },
  {
    id: "YAA",
    name: "Anahim Lake Airport",
    city: "Anahim Lake",
    country: "Canada",
    lat: 52.45249938964844,
    lng: -125.3030014038086,
  },
  {
    id: "YWM",
    name: "Williams Harbour Airport",
    city: "Williams Harbour",
    country: "Canada",
    lat: 52.566898345947266,
    lng: -55.784698486328125,
  },
  {
    id: "YFX",
    name: "St. Lewis (Fox Harbour) Airport",
    city: "St. Lewis",
    country: "Canada",
    lat: 52.372798919677734,
    lng: -55.67390060424805,
  },
  {
    id: "YHA",
    name: "Port Hope Simpson Airport",
    city: "Port Hope Simpson",
    country: "Canada",
    lat: 52.528099060058594,
    lng: -56.28609848022461,
  },
  {
    id: "YRG",
    name: "Rigolet Airport",
    city: "Rigolet",
    country: "Canada",
    lat: 54.1796989440918,
    lng: -58.45750045776367,
  },
  {
    id: "YCK",
    name: "Colville Lake Airport",
    city: "Colville Lake",
    country: "Canada",
    lat: 67.0392,
    lng: -126.08,
  },
  {
    id: "YLE",
    name: "Whatì Airport",
    city: "Whatì",
    country: "Canada",
    lat: 63.13169860839844,
    lng: -117.24600219726562,
  },
  {
    id: "SUR",
    name: "Summer Beaver Airport",
    city: "Summer Beaver",
    country: "Canada",
    lat: 52.70859909057617,
    lng: -88.54190063476562,
  },
  {
    id: "YAX",
    name: "Wapekeka Airport",
    city: "Angling Lake",
    country: "Canada",
    lat: 53.84920120239258,
    lng: -89.57939910888672,
  },
  {
    id: "WNN",
    name: "Wunnumin Lake Airport",
    city: "Wunnumin Lake",
    country: "Canada",
    lat: 52.89390182495117,
    lng: -89.28919982910156,
  },
  {
    id: "YNO",
    name: "North Spirit Lake Airport",
    city: "North Spirit Lake",
    country: "Canada",
    lat: 52.4900016784668,
    lng: -92.97109985351562,
  },
  {
    id: "XBE",
    name: "Bearskin Lake Airport",
    city: "Bearskin Lake",
    country: "Canada",
    lat: 53.965599060058594,
    lng: -91.0271987915039,
  },
  {
    id: "KIF",
    name: "Kingfisher Lake Airport",
    city: "Kingfisher Lake",
    country: "Canada",
    lat: 53.01250076293945,
    lng: -89.85530090332031,
  },
  {
    id: "YOG",
    name: "Ogoki Post Airport",
    city: "Ogoki Post",
    country: "Canada",
    lat: 51.6585998535,
    lng: -85.9017028809,
  },
  {
    id: "YHP",
    name: "Poplar Hill Airport",
    city: "Poplar Hill",
    country: "Canada",
    lat: 52.1133,
    lng: -94.2556,
  },
  {
    id: "YKU",
    name: "Chisasibi Airport",
    city: "Chisasibi",
    country: "Canada",
    lat: 53.805599212646484,
    lng: -78.91690063476562,
  },
  {
    id: "ZTB",
    name: "Tête-à-la-Baleine Airport",
    city: "Tête-à-la-Baleine",
    country: "Canada",
    lat: 50.674400329589844,
    lng: -59.38359832763672,
  },
  {
    id: "ZLT",
    name: "La Tabatière Airport",
    city: "La Tabatière",
    country: "Canada",
    lat: 50.8307991027832,
    lng: -58.97560119628906,
  },
  {
    id: "YAC",
    name: "Cat Lake Airport",
    city: "Cat Lake",
    country: "Canada",
    lat: 51.72719955444336,
    lng: -91.82440185546875,
  },
  {
    id: "YAG",
    name: "Fort Frances Municipal Airport",
    city: "Fort Frances",
    country: "Canada",
    lat: 48.65420150756836,
    lng: -93.439697265625,
  },
  {
    id: "XKS",
    name: "Kasabonika Airport",
    city: "Kasabonika",
    country: "Canada",
    lat: 53.52470016479492,
    lng: -88.6427993774414,
  },
  {
    id: "YKG",
    name: "Kangirsuk Airport",
    city: "Kangirsuk",
    country: "Canada",
    lat: 60.027198791503906,
    lng: -69.99919891357422,
  },
  {
    id: "YAT",
    name: "Attawapiskat Airport",
    city: "Attawapiskat",
    country: "Canada",
    lat: 52.9275016784668,
    lng: -82.43190002441406,
  },
  {
    id: "N",
    name: "Lac Du Bonnet Airport",
    city: "Lac Du Bonnet",
    country: "Canada",
    lat: 50.2943992615,
    lng: -96.0100021362,
  },
  {
    id: "YBE",
    name: "Uranium City Airport",
    city: "Uranium City",
    country: "Canada",
    lat: 59.5614013671875,
    lng: -108.48100280761719,
  },
  {
    id: "YBX",
    name: "Lourdes de Blanc Sablon Airport",
    city: "Lourdes-De-Blanc-Sablon",
    country: "Canada",
    lat: 51.443599700899995,
    lng: -57.185298919699996,
  },
  {
    id: "YRF",
    name: "Cartwright Airport",
    city: "Cartwright",
    country: "Canada",
    lat: 53.68280029296875,
    lng: -57.041900634765625,
  },
  {
    id: "YCS",
    name: "Chesterfield Inlet Airport",
    city: "Chesterfield Inlet",
    country: "Canada",
    lat: 63.346900939899996,
    lng: -90.73110198970001,
  },
  {
    id: "YDP",
    name: "Nain Airport",
    city: "Nain",
    country: "Canada",
    lat: 56.549198150634766,
    lng: -61.680301666259766,
  },
  {
    id: "YER",
    name: "Fort Severn Airport",
    city: "Fort Severn",
    country: "Canada",
    lat: 56.01890182495117,
    lng: -87.67610168457031,
  },
  {
    id: "YFA",
    name: "Fort Albany Airport",
    city: "Fort Albany",
    country: "Canada",
    lat: 52.20140075683594,
    lng: -81.6968994140625,
  },
  {
    id: "YFH",
    name: "Fort Hope Airport",
    city: "Fort Hope",
    country: "Canada",
    lat: 51.5619010925293,
    lng: -87.90779876708984,
  },
  {
    id: "YMN",
    name: "Makkovik Airport",
    city: "Makkovik",
    country: "Canada",
    lat: 55.076900482177734,
    lng: -59.1864013671875,
  },
  {
    id: "YGB",
    name: "Texada Gillies Bay Airport",
    city: "Texada",
    country: "Canada",
    lat: 49.69419860839844,
    lng: -124.51799774169922,
  },
  {
    id: "YGO",
    name: "Gods Lake Narrows Airport",
    city: "Gods Lake Narrows",
    country: "Canada",
    lat: 54.55889892578125,
    lng: -94.49140167236328,
  },
  {
    id: "YGT",
    name: "Igloolik Airport",
    city: "Igloolik",
    country: "Canada",
    lat: 69.3647003174,
    lng: -81.8161010742,
  },
  {
    id: "YGW",
    name: "Kuujjuarapik Airport",
    city: "Kuujjuarapik",
    country: "Canada",
    lat: 55.281898498535156,
    lng: -77.76529693603516,
  },
  {
    id: "YGX",
    name: "Gillam Airport",
    city: "Gillam",
    country: "Canada",
    lat: 56.35749816894531,
    lng: -94.71060180664062,
  },
  {
    id: "YGZ",
    name: "Grise Fiord Airport",
    city: "Grise Fiord",
    country: "Canada",
    lat: 76.4261016846,
    lng: -82.90920257570001,
  },
  {
    id: "YQC",
    name: "Quaqtaq Airport",
    city: "Quaqtaq",
    country: "Canada",
    lat: 61.0463981628418,
    lng: -69.6177978515625,
  },
  {
    id: "CXH",
    name: "Vancouver Harbour Water Aerodrome",
    city: "Vancouver",
    country: "Canada",
    lat: 49.2943992615,
    lng: -123.111000061,
  },
  {
    id: "YNS",
    name: "Nemiscau Airport",
    city: "Nemiscau",
    country: "Canada",
    lat: 51.69110107421875,
    lng: -76.1355972290039,
  },
  {
    id: "YHO",
    name: "Hopedale Airport",
    city: "Hopedale",
    country: "Canada",
    lat: 55.448299407958984,
    lng: -60.228599548339844,
  },
  {
    id: "YHR",
    name: "Chevery Airport",
    city: "Chevery",
    country: "Canada",
    lat: 50.46889877319336,
    lng: -59.63669967651367,
  },
  {
    id: "YIK",
    name: "Ivujivik Airport",
    city: "Ivujivik",
    country: "Canada",
    lat: 62.417301177978516,
    lng: -77.92530059814453,
  },
  {
    id: "YIV",
    name: "Island Lake Airport",
    city: "Island Lake",
    country: "Canada",
    lat: 53.857200622558594,
    lng: -94.65360260009766,
  },
  {
    id: "AKV",
    name: "Akulivik Airport",
    city: "Akulivik",
    country: "Canada",
    lat: 60.818599700927734,
    lng: -78.14859771728516,
  },
  {
    id: "YKQ",
    name: "Waskaganish Airport",
    city: "Waskaganish",
    country: "Canada",
    lat: 51.47330093383789,
    lng: -78.75830078125,
  },
  {
    id: "YPJ",
    name: "Aupaluk Airport",
    city: "Aupaluk",
    country: "Canada",
    lat: 59.29669952392578,
    lng: -69.59970092773438,
  },
  {
    id: "YLC",
    name: "Kimmirut Airport",
    city: "Kimmirut",
    country: "Canada",
    lat: 62.8499984741,
    lng: -69.88330078119999,
  },
  {
    id: "YLH",
    name: "Lansdowne House Airport",
    city: "Lansdowne House",
    country: "Canada",
    lat: 52.19559860229492,
    lng: -87.93419647216797,
  },
  {
    id: "N",
    name: "St Georges Airport",
    city: "Lutselk'e",
    country: "Canada",
    lat: 46.096401,
    lng: -70.714699,
  },
  {
    id: "XGR",
    name: "Kangiqsualujjuaq (Georges River) Airport",
    city: "Kangiqsualujjuaq",
    country: "Canada",
    lat: 58.71139907836914,
    lng: -65.9927978515625,
  },
  {
    id: "YMH",
    name: "Mary's Harbour Airport",
    city: "Mary's Harbour",
    country: "Canada",
    lat: 52.302799224853516,
    lng: -55.847198486328125,
  },
  {
    id: "YMT",
    name: "Chapais Airport",
    city: "Chibougamau",
    country: "Canada",
    lat: 49.77190017700195,
    lng: -74.5280990600586,
  },
  {
    id: "YUD",
    name: "Umiujaq Airport",
    city: "Umiujaq",
    country: "Canada",
    lat: 56.53609848022461,
    lng: -76.51830291748047,
  },
  {
    id: "YNC",
    name: "Wemindji Airport",
    city: "Wemindji",
    country: "Canada",
    lat: 53.01060104370117,
    lng: -78.83110046386719,
  },
  {
    id: "YNE",
    name: "Norway House Airport",
    city: "Norway House",
    country: "Canada",
    lat: 53.95830154418945,
    lng: -97.84420013427734,
  },
  {
    id: "YNL",
    name: "Points North Landing Airport",
    city: "Points North Landing",
    country: "Canada",
    lat: 58.27669906616211,
    lng: -104.08200073242188,
  },
  {
    id: "YOH",
    name: "Oxford House Airport",
    city: "Oxford House",
    country: "Canada",
    lat: 54.93330001831055,
    lng: -95.27890014648438,
  },
  {
    id: "YPH",
    name: "Inukjuak Airport",
    city: "Inukjuak",
    country: "Canada",
    lat: 58.471900939941406,
    lng: -78.07689666748047,
  },
  {
    id: "YPM",
    name: "Pikangikum Airport",
    city: "Pikangikum",
    country: "Canada",
    lat: 51.819698333740234,
    lng: -93.97329711914062,
  },
  {
    id: "YPO",
    name: "Peawanuck Airport",
    city: "Peawanuck",
    country: "Canada",
    lat: 54.98809814453125,
    lng: -85.44329833984375,
  },
  {
    id: "YPW",
    name: "Powell River Airport",
    city: "Powell River",
    country: "Canada",
    lat: 49.83420181274414,
    lng: -124.5,
  },
  {
    id: "YQD",
    name: "The Pas Airport",
    city: "The Pas",
    country: "Canada",
    lat: 53.97140121459961,
    lng: -101.09100341796875,
  },
  {
    id: "YQN",
    name: "Nakina Airport",
    city: "Nakina",
    country: "Canada",
    lat: 50.18280029296875,
    lng: -86.69640350341797,
  },
  {
    id: "YRA",
    name: "Rae Lakes Airport",
    city: "Gamètì",
    country: "Canada",
    lat: 64.11609649658203,
    lng: -117.30999755859375,
  },
  {
    id: "YRL",
    name: "Red Lake Airport",
    city: "Red Lake",
    country: "Canada",
    lat: 51.066898345947266,
    lng: -93.79309844970703,
  },
  {
    id: "YSF",
    name: "Stony Rapids Airport",
    city: "Stony Rapids",
    country: "Canada",
    lat: 59.250301361083984,
    lng: -105.84100341796875,
  },
  {
    id: "YSK",
    name: "Sanikiluaq Airport",
    city: "Sanikiluaq",
    country: "Canada",
    lat: 56.5377998352,
    lng: -79.2466964722,
  },
  {
    id: "YST",
    name: "St. Theresa Point Airport",
    city: "St. Theresa Point",
    country: "Canada",
    lat: 53.84560012817383,
    lng: -94.85189819335938,
  },
  {
    id: "YTL",
    name: "Big Trout Lake Airport",
    city: "Big Trout Lake",
    country: "Canada",
    lat: 53.81779861450195,
    lng: -89.89689636230469,
  },
  {
    id: "YVZ",
    name: "Deer Lake Airport",
    city: "Deer Lake",
    country: "Canada",
    lat: 52.655799865722656,
    lng: -94.0614013671875,
  },
  {
    id: "YWP",
    name: "Webequie Airport",
    city: "Webequie",
    country: "Canada",
    lat: 52.9593933975,
    lng: -87.3748683929,
  },
  {
    id: "YXN",
    name: "Whale Cove Airport",
    city: "Whale Cove",
    country: "Canada",
    lat: 62.24000167849999,
    lng: -92.59809875490001,
  },
  {
    id: "YZG",
    name: "Salluit Airport",
    city: "Salluit",
    country: "Canada",
    lat: 62.17940139770508,
    lng: -75.66719818115234,
  },
  {
    id: "ZAC",
    name: "York Landing Airport",
    city: "York Landing",
    country: "Canada",
    lat: 56.08940124511719,
    lng: -96.08920288085938,
  },
  {
    id: "ILF",
    name: "Ilford Airport",
    city: "Ilford",
    country: "Canada",
    lat: 56.0614013672,
    lng: -95.613899231,
  },
  {
    id: "ZBF",
    name: "Bathurst Airport",
    city: "Bathurst",
    country: "Canada",
    lat: 47.629699707,
    lng: -65.738899231,
  },
  {
    id: "ZEM",
    name: "Eastmain River Airport",
    city: "Eastmain River",
    country: "Canada",
    lat: 52.22639846801758,
    lng: -78.52249908447266,
  },
  {
    id: "ZFD",
    name: "Fond-Du-Lac Airport",
    city: "Fond-Du-Lac",
    country: "Canada",
    lat: 59.33440017700195,
    lng: -107.18199920654297,
  },
  {
    id: "ZGI",
    name: "Gods River Airport",
    city: "Gods River",
    country: "Canada",
    lat: 54.839698791503906,
    lng: -94.07859802246094,
  },
  {
    id: "ZJN",
    name: "Swan River Airport",
    city: "Swan River",
    country: "Canada",
    lat: 52.120601654052734,
    lng: -101.23600006103516,
  },
  {
    id: "ZKE",
    name: "Kashechewan Airport",
    city: "Kashechewan",
    country: "Canada",
    lat: 52.282501220703125,
    lng: -81.67780303955078,
  },
  {
    id: "MSA",
    name: "Muskrat Dam Airport",
    city: "Muskrat Dam",
    country: "Canada",
    lat: 53.44139862060547,
    lng: -91.76280212402344,
  },
  {
    id: "ZMT",
    name: "Masset Airport",
    city: "Masset",
    country: "Canada",
    lat: 54.02750015258789,
    lng: -132.125,
  },
  {
    id: "ZPB",
    name: "Sachigo Lake Airport",
    city: "Sachigo Lake",
    country: "Canada",
    lat: 53.8911018371582,
    lng: -92.19640350341797,
  },
  {
    id: "ZRJ",
    name: "Round Lake (Weagamow Lake) Airport",
    city: "Round Lake",
    country: "Canada",
    lat: 52.943599700927734,
    lng: -91.31279754638672,
  },
  {
    id: "ZSJ",
    name: "Sandy Lake Airport",
    city: "Sandy Lake",
    country: "Canada",
    lat: 53.06420135498047,
    lng: -93.34439849853516,
  },
  {
    id: "ZTM",
    name: "Shamattawa Airport",
    city: "Shamattawa",
    country: "Canada",
    lat: 55.8656005859375,
    lng: -92.0813980102539,
  },
  {
    id: "ZUM",
    name: "Churchill Falls Airport",
    city: "Churchill Falls",
    country: "Canada",
    lat: 53.5619010925293,
    lng: -64.10639953613281,
  },
  {
    id: "ZWL",
    name: "Wollaston Lake Airport",
    city: "Wollaston Lake",
    country: "Canada",
    lat: 58.10689926147461,
    lng: -103.1719970703125,
  },
  {
    id: "BLJ",
    name: "Batna Airport",
    city: "Batna",
    country: "Algeria",
    lat: 35.752101898199996,
    lng: 6.308589935300001,
  },
  {
    id: "CBH",
    name: "Béchar Boudghene Ben Ali Lotfi Airport",
    city: "Béchar",
    country: "Algeria",
    lat: 31.645700454711914,
    lng: -2.269860029220581,
  },
  {
    id: "BMW",
    name: "Bordj Badji Mokhtar Airport",
    city: "Bordj Badji Mokhtar",
    country: "Algeria",
    lat: 21.375,
    lng: 0.923888981342,
  },
  {
    id: "ELU",
    name: "Guemar Airport",
    city: "Guemar",
    country: "Algeria",
    lat: 33.5113983154,
    lng: 6.77679014206,
  },
  {
    id: "KMS",
    name: "Kumasi Airport",
    city: "Kumasi",
    country: "Ghana",
    lat: 6.714560031890869,
    lng: -1.5908199548721313,
  },
  {
    id: "HDF",
    name: "Heringsdorf Airport",
    city: "Heringsdorf",
    country: "Germany",
    lat: 53.8787002563,
    lng: 14.152299881,
  },
  {
    id: "HEI",
    name: "Heide-Büsum Airport",
    city: "Büsum",
    country: "Germany",
    lat: 54.153331756600004,
    lng: 8.90166664124,
  },
  {
    id: "HGL",
    name: "Helgoland-Düne Airport",
    city: "Helgoland",
    country: "Germany",
    lat: 54.185279846200004,
    lng: 7.91583299637,
  },
  {
    id: "SJY",
    name: "Seinäjoki Airport",
    city: "Seinäjoki / Ilmajoki",
    country: "Finland",
    lat: 62.692101,
    lng: 22.8323,
  },
  {
    id: "NQT",
    name: "Nottingham Airport",
    city: "Nottingham",
    country: "United Kingdom",
    lat: 52.91999816894531,
    lng: -1.0791699886322021,
  },
  {
    id: "DSA",
    name: "Robin Hood Doncaster Sheffield Airport",
    city: "Doncaster, Sheffield",
    country: "United Kingdom",
    lat: 53.4805378105,
    lng: -1.01065635681,
  },
  {
    id: "CAL",
    name: "Campbeltown Airport",
    city: "Campbeltown",
    country: "United Kingdom",
    lat: 55.437198638916016,
    lng: -5.686389923095703,
  },
  {
    id: "EOI",
    name: "Eday Airport",
    city: "Eday",
    country: "United Kingdom",
    lat: 59.19060134887695,
    lng: -2.7722198963165283,
  },
  {
    id: "FIE",
    name: "Fair Isle Airport",
    city: "Fair Isle",
    country: "United Kingdom",
    lat: 59.53580093383789,
    lng: -1.628059983253479,
  },
  {
    id: "NRL",
    name: "North Ronaldsay Airport",
    city: "North Ronaldsay",
    country: "United Kingdom",
    lat: 59.3675003052,
    lng: -2.43443989754,
  },
  {
    id: "PPW",
    name: "Papa Westray Airport",
    city: "Papa Westray",
    country: "United Kingdom",
    lat: 59.351699829100006,
    lng: -2.9002799987800003,
  },
  {
    id: "SOY",
    name: "Stronsay Airport",
    city: "Stronsay",
    country: "United Kingdom",
    lat: 59.1553001404,
    lng: -2.64139008522,
  },
  {
    id: "NDY",
    name: "Sanday Airport",
    city: "Sanday",
    country: "United Kingdom",
    lat: 59.250301361083984,
    lng: -2.576669931411743,
  },
  {
    id: "LWK",
    name: "Lerwick / Tingwall Airport",
    city: "Lerwick",
    country: "United Kingdom",
    lat: 60.192199707,
    lng: -1.24361002445,
  },
  {
    id: "WRY",
    name: "Westray Airport",
    city: "Westray",
    country: "United Kingdom",
    lat: 59.3502998352,
    lng: -2.95000004768,
  },
  {
    id: "LEQ",
    name: "Land's End Airport",
    city: "Land's End",
    country: "United Kingdom",
    lat: 50.102798,
    lng: -5.67056,
  },
  {
    id: "PZE",
    name: "Penzance Heliport",
    city: "Penzance",
    country: "United Kingdom",
    lat: 50.128101,
    lng: -5.51845,
  },
  {
    id: "VLY",
    name: "Anglesey Airport",
    city: "Angelsey",
    country: "United Kingdom",
    lat: 53.2481002808,
    lng: -4.53533983231,
  },
  {
    id: "BRR",
    name: "Barra Airport",
    city: "Barra",
    country: "United Kingdom",
    lat: 57.0228,
    lng: -7.44306,
  },
  {
    id: "CFN",
    name: "Donegal Airport",
    city: "Dongloe",
    country: "Ireland",
    lat: 55.0442008972168,
    lng: -8.340999603271484,
  },
  {
    id: "N",
    name: "Weston Airport",
    city: "Leixlip",
    country: "Ireland",
    lat: 53.3521995544,
    lng: -6.48611021042,
  },
  {
    id: "CNL",
    name: "Sindal Airport",
    city: "Sindal",
    country: "Denmark",
    lat: 57.503502,
    lng: 10.2294,
  },
  {
    id: "LKN",
    name: "Leknes Airport",
    city: "Leknes",
    country: "Norway",
    lat: 68.152496337891,
    lng: 13.609399795532,
  },
  {
    id: "OSY",
    name: "Namsos Høknesøra Airport",
    city: "Namsos",
    country: "Norway",
    lat: 64.472198486328,
    lng: 11.57859992981,
  },
  {
    id: "MQN",
    name: "Mo i Rana Airport, Røssvoll",
    city: "Mo i Rana",
    country: "Norway",
    lat: 66.363899230957,
    lng: 14.301400184631,
  },
  {
    id: "RVK",
    name: "Rørvik Airport, Ryum",
    city: "Rørvik",
    country: "Norway",
    lat: 64.838302612305,
    lng: 11.14610004425,
  },
  {
    id: "RET",
    name: "Røst Airport",
    city: "Røst",
    country: "Norway",
    lat: 67.527801513672,
    lng: 12.103300094604,
  },
  {
    id: "SDN",
    name: "Sandane Airport (Anda)",
    city: "Sandane",
    country: "Norway",
    lat: 61.830001831055,
    lng: 6.1058301925659,
  },
  {
    id: "SOG",
    name: "Sogndal Airport",
    city: "Sogndal",
    country: "Norway",
    lat: 61.156101,
    lng: 7.13778,
  },
  {
    id: "SVJ",
    name: "Svolvær Helle Airport",
    city: "Svolvær",
    country: "Norway",
    lat: 68.243301391602,
    lng: 14.669199943542,
  },
  {
    id: "SOJ",
    name: "Sørkjosen Airport",
    city: "Sorkjosen",
    country: "Norway",
    lat: 69.786796569824,
    lng: 20.959400177002,
  },
  {
    id: "VAW",
    name: "Vardø Airport, Svartnes",
    city: "Vardø",
    country: "Norway",
    lat: 70.355400085449,
    lng: 31.044900894165,
  },
  {
    id: "VRY",
    name: "Værøy Heliport",
    city: "Værøy",
    country: "Norway",
    lat: 67.654555,
    lng: 12.727257,
  },
  {
    id: "BZG",
    name: "Bydgoszcz Ignacy Jan Paderewski Airport",
    city: "Bydgoszcz",
    country: "Poland",
    lat: 53.096801757799994,
    lng: 17.9776992798,
  },
  {
    id: "LCJ",
    name: "Łódź Władysław Reymont Airport",
    city: "Lodz",
    country: "Poland",
    lat: 51.721900939899996,
    lng: 19.3980998993,
  },
  {
    id: "OSD",
    name: "Åre Östersund Airport",
    city: "Östersund",
    country: "Sweden",
    lat: 63.194400787354,
    lng: 14.50030040741,
  },
  {
    id: "HFS",
    name: "Hagfors Airport",
    city: "Hagfors",
    country: "Sweden",
    lat: 60.02009963989258,
    lng: 13.578900337219238,
  },
  {
    id: "KSD",
    name: "Karlstad Airport",
    city: "Karlstad",
    country: "Sweden",
    lat: 59.444698333699996,
    lng: 13.337400436400001,
  },
  {
    id: "TYF",
    name: "Torsby Airport",
    city: "Torsby",
    country: "Sweden",
    lat: 60.1576004028,
    lng: 12.991299629199998,
  },
  {
    id: "AGH",
    name: "Ängelholm-Helsingborg Airport",
    city: "Ängelholm",
    country: "Sweden",
    lat: 56.29610061645508,
    lng: 12.847100257873535,
  },
  {
    id: "SQO",
    name: "Storuman Airport",
    city: "Mohed",
    country: "Sweden",
    lat: 64.96089935302734,
    lng: 17.69659996032715,
  },
  {
    id: "HMV",
    name: "Hemavan Airport",
    city: "Hemavan",
    country: "Sweden",
    lat: 65.80609893798828,
    lng: 15.082799911499023,
  },
  {
    id: "VNT",
    name: "Ventspils International Airport",
    city: "Ventspils",
    country: "Latvia",
    lat: 57.35779953,
    lng: 21.5442008972,
  },
  {
    id: "QRA",
    name: "Rand Airport",
    city: "Johannesburg",
    country: "South Africa",
    lat: -26.2425003052,
    lng: 28.1511993408,
  },
  {
    id: "MQP",
    name: "Kruger Mpumalanga International Airport",
    city: "Mpumalanga",
    country: "South Africa",
    lat: -25.3831996918,
    lng: 31.1056003571,
  },
  {
    id: "AAM",
    name: "Malamala Airport",
    city: "Malamala",
    country: "South Africa",
    lat: -24.818099975585938,
    lng: 31.544599533081055,
  },
  {
    id: "MBD",
    name: "Mmabatho International Airport",
    city: "Mafeking",
    country: "South Africa",
    lat: -25.798400878900004,
    lng: 25.548000335699996,
  },
  {
    id: "GNZ",
    name: "Ghanzi Airport",
    city: "Ghanzi",
    country: "Botswana",
    lat: -21.6924991607666,
    lng: 21.658100128173828,
  },
  {
    id: "ORP",
    name: "Orapa Airport",
    city: "Orapa",
    country: "Botswana",
    lat: -21.266701,
    lng: 25.3167,
  },
  {
    id: "SWX",
    name: "Shakawe Airport",
    city: "Shakawe",
    country: "Botswana",
    lat: -18.373899459838867,
    lng: 21.832599639892578,
  },
  {
    id: "TLD",
    name: "Limpopo Valley Airport",
    city: "Tuli Lodge",
    country: "Botswana",
    lat: -22.189199447599997,
    lng: 29.126899719199997,
  },
  {
    id: "DIS",
    name: "Ngot Nzoungou Airport",
    city: "Loubomo",
    country: "Congo (Brazzaville)",
    lat: -4.20635,
    lng: 12.6599,
  },
  {
    id: "CIP",
    name: "Chipata Airport",
    city: "Chipata",
    country: "Zambia",
    lat: -13.558300018310547,
    lng: 32.58720016479492,
  },
  {
    id: "N",
    name: "Los Alamitos Army Air Field",
    city: "Solwesi",
    country: "Zambia",
    lat: 33.79000092,
    lng: -118.052002,
  },
  {
    id: "YVA",
    name: "Iconi Airport",
    city: "Moroni",
    country: "Comoros",
    lat: -11.710800170899999,
    lng: 43.2439002991,
  },
  {
    id: "WAQ",
    name: "Antsalova Airport",
    city: "Antsalova",
    country: "Madagascar",
    lat: -18.701273,
    lng: 44.614921,
  },
  {
    id: "JVA",
    name: "Ankavandra Airport",
    city: "Ankavandra",
    country: "Madagascar",
    lat: -18.80501,
    lng: 45.273467,
  },
  {
    id: "BMD",
    name: "Belo sur Tsiribihina Airport",
    city: "Belo sur Tsiribihina",
    country: "Madagascar",
    lat: -19.6867008209,
    lng: 44.541900634799994,
  },
  {
    id: "MXT",
    name: "Maintirano Airport",
    city: "Maintirano",
    country: "Madagascar",
    lat: -18.049999,
    lng: 44.033001,
  },
  {
    id: "TVA",
    name: "Morafenobe Airport",
    city: "Morafenobe",
    country: "Madagascar",
    lat: -17.850083,
    lng: 44.920467,
  },
  {
    id: "WTA",
    name: "Tambohorano Airport",
    city: "Tambohorano",
    country: "Madagascar",
    lat: -17.47610092163086,
    lng: 43.972801208496094,
  },
  {
    id: "WTS",
    name: "Tsiroanomandidy Airport",
    city: "Tsiroanomandidy",
    country: "Madagascar",
    lat: -18.759677,
    lng: 46.054065,
  },
  {
    id: "WAM",
    name: "Ambatondrazaka Airport",
    city: "Ambatondrazaka",
    country: "Madagascar",
    lat: -17.795378,
    lng: 48.442583,
  },
  {
    id: "WPB",
    name: "Port Bergé Airport",
    city: "Port Bergé",
    country: "Madagascar",
    lat: -15.584286,
    lng: 47.623587,
  },
  {
    id: "N",
    name: "Ambanja Airport",
    city: "Ambanja",
    country: "Madagascar",
    lat: -13.645705,
    lng: 48.459427,
  },
  {
    id: "DWB",
    name: "Soalala Airport",
    city: "Soalala",
    country: "Madagascar",
    lat: -16.10169,
    lng: 45.358837,
  },
  {
    id: "WMP",
    name: "Mampikony Airport",
    city: "Mampikony",
    country: "Madagascar",
    lat: -16.0722693402,
    lng: 47.644164562200004,
  },
  {
    id: "N",
    name: "Nasa Shuttle Landing Facility Airport",
    city: "Tsaratanana",
    country: "Madagascar",
    lat: 28.614999771118164,
    lng: -80.69450378417969,
  },
  {
    id: "WMA",
    name: "Mandritsara Airport",
    city: "Mandritsara",
    country: "Madagascar",
    lat: -15.833049,
    lng: 48.833284,
  },
  {
    id: "MJA",
    name: "Manja Airport",
    city: "Manja",
    country: "Madagascar",
    lat: -21.426105,
    lng: 44.316509,
  },
  {
    id: "CBT",
    name: "Catumbela Airport",
    city: "Catumbela",
    country: "Angola",
    lat: -12.4792,
    lng: 13.4869,
  },
  {
    id: "DUE",
    name: "Dundo Airport",
    city: "Dundo",
    country: "Angola",
    lat: -7.400889873504639,
    lng: 20.818500518798828,
  },
  {
    id: "VPE",
    name: "Ngjiva Pereira Airport",
    city: "Ondjiva",
    country: "Angola",
    lat: -17.0435009003,
    lng: 15.683799743700002,
  },
  {
    id: "MSZ",
    name: "Namibe Airport",
    city: "Mocamedes",
    country: "Angola",
    lat: -15.261199951171875,
    lng: 12.14680004119873,
  },
  {
    id: "KOU",
    name: "Koulamoutou Mabimbi Airport",
    city: "Koulamoutou",
    country: "Gabon",
    lat: -1.1846100091934,
    lng: 12.441300392151,
  },
  {
    id: "MJL",
    name: "Mouilla Ville Airport",
    city: "Mouila",
    country: "Gabon",
    lat: -1.845139980316162,
    lng: 11.056699752807617,
  },
  {
    id: "TCH",
    name: "Tchibanga Airport",
    city: "Tchibanga",
    country: "Gabon",
    lat: -2.8499999046325684,
    lng: 11.017000198364258,
  },
  {
    id: "VPY",
    name: "Chimoio Airport",
    city: "Chimoio",
    country: "Mozambique",
    lat: -19.15130043029785,
    lng: 33.42900085449219,
  },
  {
    id: "SRH",
    name: "Sarh Airport",
    city: "Sarh",
    country: "Chad",
    lat: 9.14444,
    lng: 18.374399,
  },
  {
    id: "CMK",
    name: "Club Makokola Airport",
    city: "Club Makokola",
    country: "Malawi",
    lat: -14.306900024414062,
    lng: 35.13249969482422,
  },
  {
    id: "LUD",
    name: "Luderitz Airport",
    city: "Luderitz",
    country: "Namibia",
    lat: -26.687400817871094,
    lng: 15.242899894714355,
  },
  {
    id: "OND",
    name: "Ondangwa Airport",
    city: "Ondangwa",
    country: "Namibia",
    lat: -17.878201,
    lng: 15.9526,
  },
  {
    id: "OMD",
    name: "Oranjemund Airport",
    city: "Oranjemund",
    country: "Namibia",
    lat: -28.5847,
    lng: 16.446699,
  },
  {
    id: "SWP",
    name: "Swakopmund Airport",
    city: "Swakopmund",
    country: "Namibia",
    lat: -22.66189956665,
    lng: 14.568099975586,
  },
  {
    id: "ERS",
    name: "Eros Airport",
    city: "Windhoek",
    country: "Namibia",
    lat: -22.612199783325195,
    lng: 17.080400466918945,
  },
  {
    id: "BOA",
    name: "Boma Airport",
    city: "Boma",
    country: "Congo (Kinshasa)",
    lat: -5.854000091552734,
    lng: 13.064000129699707,
  },
  {
    id: "MAT",
    name: "Tshimpi Airport",
    city: "Matadi",
    country: "Congo (Kinshasa)",
    lat: -5.799610137939453,
    lng: 13.440400123596191,
  },
  {
    id: "INO",
    name: "Inongo Airport",
    city: "Inongo",
    country: "Congo (Kinshasa)",
    lat: -1.947219967842102,
    lng: 18.28580093383789,
  },
  {
    id: "NIO",
    name: "Nioki Airport",
    city: "Nioki",
    country: "Congo (Kinshasa)",
    lat: -2.7174999713897705,
    lng: 17.68470001220703,
  },
  {
    id: "KRZ",
    name: "Basango Mboliasa Airport",
    city: "Kiri",
    country: "Congo (Kinshasa)",
    lat: -1.434999942779541,
    lng: 19.02400016784668,
  },
  {
    id: "BSU",
    name: "Basankusu Airport",
    city: "Basankusu",
    country: "Congo (Kinshasa)",
    lat: 1.2247200012207031,
    lng: 19.78890037536621,
  },
  {
    id: "TSH",
    name: "Tshikapa Airport",
    city: "Tshikapa",
    country: "Congo (Kinshasa)",
    lat: -6.43833,
    lng: 20.794701,
  },
  {
    id: "LJA",
    name: "Lodja Airport",
    city: "Lodja",
    country: "Congo (Kinshasa)",
    lat: -3.4170000553131104,
    lng: 23.450000762939453,
  },
  {
    id: "PFR",
    name: "Ilebo Airport",
    city: "Ilebo",
    country: "Congo (Kinshasa)",
    lat: -4.329919,
    lng: 20.590124,
  },
  {
    id: "OUK",
    name: "Outer Skerries Airport",
    city: "Outer Skerries",
    country: "United Kingdom",
    lat: 60.4252,
    lng: -0.75,
  },
  {
    id: "GMZ",
    name: "La Gomera Airport",
    city: "La Gomera",
    country: "Spain",
    lat: 28.029600143432617,
    lng: -17.214599609375,
  },
  {
    id: "BTE",
    name: "Sherbro International Airport",
    city: "Bonthe",
    country: "Sierra Leone",
    lat: 7.5324201583862305,
    lng: -12.518899917602539,
  },
  {
    id: "KBS",
    name: "Bo Airport",
    city: "Bo",
    country: "Sierra Leone",
    lat: 7.944399833679199,
    lng: -11.76099967956543,
  },
  {
    id: "KEN",
    name: "Kenema Airport",
    city: "Kenema",
    country: "Sierra Leone",
    lat: 7.891290187835693,
    lng: -11.176600456237793,
  },
  {
    id: "OXB",
    name: "Osvaldo Vieira International Airport",
    city: "Bissau",
    country: "Guinea-Bissau",
    lat: 11.894800186157227,
    lng: -15.65369987487793,
  },
  {
    id: "SMW",
    name: "Smara Airport",
    city: "Smara",
    country: "Western Sahara",
    lat: 26.7318,
    lng: -11.6847,
  },
  {
    id: "VIL",
    name: "Dakhla Airport",
    city: "Dakhla",
    country: "Western Sahara",
    lat: 23.7183,
    lng: -15.932,
  },
  {
    id: "ESU",
    name: "Mogador Airport",
    city: "Essadouira",
    country: "Morocco",
    lat: 31.3974990845,
    lng: -9.6816701889,
  },
  {
    id: "EUN",
    name: "Hassan I Airport",
    city: "El Aaiún",
    country: "Western Sahara",
    lat: 27.151699,
    lng: -13.2192,
  },
  {
    id: "NDR",
    name: "Nador International Airport",
    city: "El Aroui",
    country: "Morocco",
    lat: 34.988800048799995,
    lng: -3.0282099247,
  },
  {
    id: "RAI",
    name: "Praia International Airport",
    city: "Praia, Santiago Island",
    country: "Cape Verde",
    lat: 14.924500465393066,
    lng: -23.493499755859375,
  },
  {
    id: "SFL",
    name: "São Filipe Airport",
    city: "Sao Filipe, Fogo Island",
    country: "Cape Verde",
    lat: 14.8850002289,
    lng: -24.4799995422,
  },
  {
    id: "BCO",
    name: "Baco Airport",
    city: "Baco",
    country: "Ethiopia",
    lat: 5.78287,
    lng: 36.562,
  },
  {
    id: "BEI",
    name: "Beica Airport",
    city: "Beica",
    country: "Ethiopia",
    lat: 9.38638973236084,
    lng: 34.52190017700195,
  },
  {
    id: "DSE",
    name: "Combolcha Airport",
    city: "Dessie",
    country: "Ethiopia",
    lat: 11.082500457763672,
    lng: 39.71139907836914,
  },
  {
    id: "DEM",
    name: "Dembidollo Airport",
    city: "Dembidollo",
    country: "Ethiopia",
    lat: 8.553999900817871,
    lng: 34.858001708984375,
  },
  {
    id: "GDE",
    name: "Gode Airport",
    city: "Gode",
    country: "Ethiopia",
    lat: 5.93513011932,
    lng: 43.5786018372,
  },
  {
    id: "GOR",
    name: "Gore Airport",
    city: "Gore",
    country: "Ethiopia",
    lat: 8.1614,
    lng: 35.5529,
  },
  {
    id: "ABK",
    name: "Kabri Dehar Airport",
    city: "Kabri Dehar",
    country: "Ethiopia",
    lat: 6.734,
    lng: 44.252998,
  },
  {
    id: "MTF",
    name: "Mizan Teferi Airport",
    city: "Mizan Teferi",
    country: "Ethiopia",
    lat: 6.9571,
    lng: 35.5547,
  },
  {
    id: "TIE",
    name: "Tippi Airport",
    city: "Tippi",
    country: "Ethiopia",
    lat: 7.2024,
    lng: 35.415,
  },
  {
    id: "ALU",
    name: "Alula Airport",
    city: "Alula",
    country: "Somalia",
    lat: 11.9582,
    lng: 50.748,
  },
  {
    id: "BSA",
    name: "Bosaso Airport",
    city: "Bosaso",
    country: "Somalia",
    lat: 11.275300025939941,
    lng: 49.14939880371094,
  },
  {
    id: "MGQ",
    name: "Aden Adde International Airport",
    city: "Mogadishu",
    country: "Somalia",
    lat: 2.0144400596618652,
    lng: 45.3046989440918,
  },
  {
    id: "GLK",
    name: "Galcaio Airport",
    city: "Galcaio",
    country: "Somalia",
    lat: 6.78082990646,
    lng: 47.45470047,
  },
  {
    id: "BUO",
    name: "Burao Airport",
    city: "Burao",
    country: "Somalia",
    lat: 9.5275,
    lng: 45.5549,
  },
  {
    id: "AAC",
    name: "El Arish International Airport",
    city: "El Arish",
    country: "Egypt",
    lat: 31.073299408,
    lng: 33.8358001709,
  },
  {
    id: "ATZ",
    name: "Assiut International Airport",
    city: "Asyut",
    country: "Egypt",
    lat: 27.0464992523,
    lng: 31.0119991302,
  },
  {
    id: "ASV",
    name: "Amboseli Airport",
    city: "Amboseli National Park",
    country: "Kenya",
    lat: -2.645050048828125,
    lng: 37.25310134887695,
  },
  {
    id: "LKG",
    name: "Lokichoggio Airport",
    city: "Lokichoggio",
    country: "Kenya",
    lat: 4.20412015914917,
    lng: 34.348201751708984,
  },
  {
    id: "MYD",
    name: "Malindi Airport",
    city: "Malindi",
    country: "Kenya",
    lat: -3.2293100357055664,
    lng: 40.10169982910156,
  },
  {
    id: "NYK",
    name: "Nanyuki Airport",
    city: "Nanyuki",
    country: "Kenya",
    lat: -0.06239889934659004,
    lng: 37.04100799560547,
  },
  {
    id: "SRX",
    name: "Gardabya Airport",
    city: "Sirt",
    country: "Libya",
    lat: 31.063499450699997,
    lng: 16.5949993134,
  },
  {
    id: "TOB",
    name: "Gamal Abdel Nasser Airport",
    city: "Tobruk",
    country: "Libya",
    lat: 31.861,
    lng: 23.907,
  },
  {
    id: "MJI",
    name: "Mitiga Airport",
    city: "Tripoli",
    country: "Libya",
    lat: 32.894100189208984,
    lng: 13.276000022888184,
  },
  {
    id: "LAQ",
    name: "La Abraq Airport",
    city: "Al Bayda'",
    country: "Libya",
    lat: 32.788700103759766,
    lng: 21.96430015563965,
  },
  {
    id: "ATB",
    name: "Atbara Airport",
    city: "Atbara",
    country: "Sudan",
    lat: 17.710344314575195,
    lng: 34.0570182800293,
  },
  {
    id: "UYL",
    name: "Nyala Airport",
    city: "Nyala",
    country: "Sudan",
    lat: 12.053500175476074,
    lng: 24.956199645996094,
  },
  {
    id: "PZU",
    name: "Port Sudan New International Airport",
    city: "Port Sudan",
    country: "Sudan",
    lat: 19.4335994720459,
    lng: 37.234100341796875,
  },
  {
    id: "BKZ",
    name: "Bukoba Airport",
    city: "Bukoba",
    country: "Tanzania",
    lat: -1.332,
    lng: 31.8212,
  },
  {
    id: "TKQ",
    name: "Kigoma Airport",
    city: "Kigoma",
    country: "Tanzania",
    lat: -4.8862,
    lng: 29.6709,
  },
  {
    id: "LDI",
    name: "Lindi Airport",
    city: "Lindi",
    country: "Tanzania",
    lat: -9.85111,
    lng: 39.757801,
  },
  {
    id: "MUZ",
    name: "Musoma Airport",
    city: "Musoma",
    country: "Tanzania",
    lat: -1.503,
    lng: 33.8021,
  },
  {
    id: "SHY",
    name: "Shinyanga Airport",
    city: "Shinyanga",
    country: "Tanzania",
    lat: -3.6093,
    lng: 33.5035,
  },
  {
    id: "TBO",
    name: "Tabora Airport",
    city: "Tabora",
    country: "Tanzania",
    lat: -5.076389789581299,
    lng: 32.83330154418945,
  },
  {
    id: "RUA",
    name: "Arua Airport",
    city: "Arua",
    country: "Uganda",
    lat: 3.049999952316284,
    lng: 30.91699981689453,
  },
  {
    id: "ULU",
    name: "Gulu Airport",
    city: "Gulu",
    country: "Uganda",
    lat: 2.8055601119995117,
    lng: 32.27180099487305,
  },
  {
    id: "DIU",
    name: "Diu Airport",
    city: "Diu",
    country: "India",
    lat: 20.71310043334961,
    lng: 70.92109680175781,
  },
  {
    id: "ABR",
    name: "Aberdeen Regional Airport",
    city: "Aberdeen",
    country: "United States",
    lat: 45.449100494384766,
    lng: -98.42179870605469,
  },
  {
    id: "ABY",
    name: "Southwest Georgia Regional Airport",
    city: "Albany",
    country: "United States",
    lat: 31.535499572753906,
    lng: -84.19450378417969,
  },
  {
    id: "AHN",
    name: "Athens Ben Epps Airport",
    city: "Athens",
    country: "United States",
    lat: 33.94860076904297,
    lng: -83.32630157470703,
  },
  {
    id: "ALM",
    name: "Alamogordo White Sands Regional Airport",
    city: "Alamogordo",
    country: "United States",
    lat: 32.8399009705,
    lng: -105.990997314,
  },
  {
    id: "ALO",
    name: "Waterloo Regional Airport",
    city: "Waterloo",
    country: "United States",
    lat: 42.557098388671875,
    lng: -92.40029907226562,
  },
  {
    id: "ALW",
    name: "Walla Walla Regional Airport",
    city: "Walla Walla",
    country: "United States",
    lat: 46.09489822,
    lng: -118.288002,
  },
  {
    id: "APN",
    name: "Alpena County Regional Airport",
    city: "Alpena",
    country: "United States",
    lat: 45.0780983,
    lng: -83.56030273,
  },
  {
    id: "ATY",
    name: "Watertown Regional Airport",
    city: "Watertown",
    country: "United States",
    lat: 44.91400146,
    lng: -97.15470123,
  },
  {
    id: "BFD",
    name: "Bradford Regional Airport",
    city: "Bradford",
    country: "United States",
    lat: 41.8031005859375,
    lng: -78.64009857177734,
  },
  {
    id: "BFF",
    name: "Western Neb. Rgnl/William B. Heilig Airport",
    city: "Scottsbluff",
    country: "United States",
    lat: 41.87400055,
    lng: -103.5960007,
  },
  {
    id: "BKW",
    name: "Raleigh County Memorial Airport",
    city: "Beckley",
    country: "United States",
    lat: 37.787300109899995,
    lng: -81.1241989136,
  },
  {
    id: "BQK",
    name: "Brunswick Golden Isles Airport",
    city: "Brunswick",
    country: "United States",
    lat: 31.258800506591797,
    lng: -81.46649932861328,
  },
  {
    id: "BRL",
    name: "Southeast Iowa Regional Airport",
    city: "Burlington",
    country: "United States",
    lat: 40.783199310302734,
    lng: -91.12550354003906,
  },
  {
    id: "CEC",
    name: "Jack Mc Namara Field Airport",
    city: "Crescent City",
    country: "United States",
    lat: 41.78020096,
    lng: -124.2369995,
  },
  {
    id: "CGI",
    name: "Cape Girardeau Regional Airport",
    city: "Cape Girardeau",
    country: "United States",
    lat: 37.22529983520508,
    lng: -89.57080078125,
  },
  {
    id: "CIU",
    name: "Chippewa County International Airport",
    city: "Sault Ste Marie",
    country: "United States",
    lat: 46.25080108642578,
    lng: -84.47239685058594,
  },
  {
    id: "CKB",
    name: "North Central West Virginia Airport",
    city: "Clarksburg",
    country: "United States",
    lat: 39.2966003418,
    lng: -80.2281036377,
  },
  {
    id: "CLM",
    name: "William R Fairchild International Airport",
    city: "Port Angeles",
    country: "United States",
    lat: 48.120201110839844,
    lng: -123.5,
  },
  {
    id: "CMX",
    name: "Houghton County Memorial Airport",
    city: "Hancock",
    country: "United States",
    lat: 47.168399810791016,
    lng: -88.48909759521484,
  },
  {
    id: "DDC",
    name: "Dodge City Regional Airport",
    city: "Dodge City",
    country: "United States",
    lat: 37.76340103149414,
    lng: -99.9655990600586,
  },
  {
    id: "DUJ",
    name: "DuBois Regional Airport",
    city: "Du Bois",
    country: "United States",
    lat: 41.17829895,
    lng: -78.8986969,
  },
  {
    id: "EAU",
    name: "Chippewa Valley Regional Airport",
    city: "Eau Claire",
    country: "United States",
    lat: 44.86579895019531,
    lng: -91.48429870605469,
  },
  {
    id: "EKO",
    name: "Elko Regional Airport",
    city: "Elko",
    country: "United States",
    lat: 40.82490158081055,
    lng: -115.79199981689453,
  },
  {
    id: "EWB",
    name: "New Bedford Regional Airport",
    city: "New Bedford",
    country: "United States",
    lat: 41.67610168457031,
    lng: -70.95690155029297,
  },
  {
    id: "FAY",
    name: "Fayetteville Regional Grannis Field",
    city: "Fayetteville",
    country: "United States",
    lat: 34.9911994934082,
    lng: -78.88030242919922,
  },
  {
    id: "GGW",
    name: "Wokal Field Glasgow International Airport",
    city: "Glasgow",
    country: "United States",
    lat: 48.212502,
    lng: -106.614998,
  },
  {
    id: "GRI",
    name: "Central Nebraska Regional Airport",
    city: "Grand Island",
    country: "United States",
    lat: 40.967498779296875,
    lng: -98.30960083007812,
  },
  {
    id: "HOT",
    name: "Memorial Field",
    city: "Hot Springs",
    country: "United States",
    lat: 34.47800064086914,
    lng: -93.09619903564453,
  },
  {
    id: "HTS",
    name: "Tri-State/Milton J. Ferguson Field",
    city: "Huntington",
    country: "United States",
    lat: 38.36669922,
    lng: -82.55799866,
  },
  {
    id: "KIO",
    name: "Kili Airport",
    city: "Kili Island",
    country: "Marshall Islands",
    lat: 5.644515,
    lng: 169.119507,
  },
  {
    id: "IRK",
    name: "Kirksville Regional Airport",
    city: "Kirksville",
    country: "United States",
    lat: 40.09349822998047,
    lng: -92.5448989868164,
  },
  {
    id: "JMS",
    name: "Jamestown Regional Airport",
    city: "Jamestown",
    country: "United States",
    lat: 46.92969894,
    lng: -98.67819977,
  },
  {
    id: "LAR",
    name: "Laramie Regional Airport",
    city: "Laramie",
    country: "United States",
    lat: 41.31209945678711,
    lng: -105.67500305175781,
  },
  {
    id: "LBE",
    name: "Arnold Palmer Regional Airport",
    city: "Latrobe",
    country: "United States",
    lat: 40.27590179,
    lng: -79.40480042,
  },
  {
    id: "LBF",
    name: "North Platte Regional Airport Lee Bird Field",
    city: "North Platte",
    country: "United States",
    lat: 41.12620163,
    lng: -100.6839981,
  },
  {
    id: "LEB",
    name: "Lebanon Municipal Airport",
    city: "Lebanon",
    country: "United States",
    lat: 43.626098632799994,
    lng: -72.30419921880001,
  },
  {
    id: "LMT",
    name: "Crater Lake-Klamath Regional Airport",
    city: "Klamath Falls",
    country: "United States",
    lat: 42.156101,
    lng: -121.733002,
  },
  {
    id: "LNS",
    name: "Lancaster Airport",
    city: "Lancaster",
    country: "United States",
    lat: 40.121700286865234,
    lng: -76.29609680175781,
  },
  {
    id: "LWT",
    name: "Lewistown Municipal Airport",
    city: "Lewistown",
    country: "United States",
    lat: 47.04930114746094,
    lng: -109.46700286865234,
  },
  {
    id: "LYH",
    name: "Lynchburg Regional Preston Glenn Field",
    city: "Lynchburg",
    country: "United States",
    lat: 37.326698303222656,
    lng: -79.20040130615234,
  },
  {
    id: "MKG",
    name: "Muskegon County Airport",
    city: "Muskegon",
    country: "United States",
    lat: 43.16949844,
    lng: -86.23819733,
  },
  {
    id: "MLS",
    name: "Frank Wiley Field",
    city: "Miles City",
    country: "United States",
    lat: 46.428001403808594,
    lng: -105.88600158691406,
  },
  {
    id: "MSL",
    name: "Northwest Alabama Regional Airport",
    city: "Muscle Shoals",
    country: "United States",
    lat: 34.74530029,
    lng: -87.61019897,
  },
  {
    id: "OTH",
    name: "Southwest Oregon Regional Airport",
    city: "North Bend",
    country: "United States",
    lat: 43.41709899902344,
    lng: -124.24600219726562,
  },
  {
    id: "OWB",
    name: "Owensboro Daviess County Airport",
    city: "Owensboro",
    country: "United States",
    lat: 37.74010086,
    lng: -87.16680145,
  },
  {
    id: "PIB",
    name: "Hattiesburg Laurel Regional Airport",
    city: "Hattiesburg/Laurel",
    country: "United States",
    lat: 31.467100143432617,
    lng: -89.33709716796875,
  },
  {
    id: "PIH",
    name: "Pocatello Regional Airport",
    city: "Pocatello",
    country: "United States",
    lat: 42.9098014831543,
    lng: -112.59600067138672,
  },
  {
    id: "PIR",
    name: "Pierre Regional Airport",
    city: "Pierre",
    country: "United States",
    lat: 44.38270187,
    lng: -100.2860031,
  },
  {
    id: "PLN",
    name: "Pellston Regional Airport of Emmet County Airport",
    city: "Pellston",
    country: "United States",
    lat: 45.57089996,
    lng: -84.79669952,
  },
  {
    id: "PSM",
    name: "Portsmouth International at Pease Airport",
    city: "Portsmouth",
    country: "United States",
    lat: 43.0778999329,
    lng: -70.8233032227,
  },
  {
    id: "RDG",
    name: "Reading Regional Carl A Spaatz Field",
    city: "Reading",
    country: "United States",
    lat: 40.378501892089844,
    lng: -75.96520233154297,
  },
  {
    id: "RHI",
    name: "Rhinelander Oneida County Airport",
    city: "Rhinelander",
    country: "United States",
    lat: 45.63119888305664,
    lng: -89.46749877929688,
  },
  {
    id: "RKS",
    name: "Southwest Wyoming Regional Airport",
    city: "Rock Springs",
    country: "United States",
    lat: 41.5942,
    lng: -109.065001,
  },
  {
    id: "RUT",
    name: "Rutland - Southern Vermont Regional Airport",
    city: "Rutland",
    country: "United States",
    lat: 43.52939987,
    lng: -72.94960022,
  },
  {
    id: "SBP",
    name: "San Luis County Regional Airport",
    city: "San Luis Obispo",
    country: "United States",
    lat: 35.236801147499996,
    lng: -120.641998291,
  },
  {
    id: "SHR",
    name: "Sheridan County Airport",
    city: "Sheridan",
    country: "United States",
    lat: 44.76919937133789,
    lng: -106.9800033569336,
  },
  {
    id: "SLK",
    name: "Adirondack Regional Airport",
    city: "Saranac Lake",
    country: "United States",
    lat: 44.38529968261719,
    lng: -74.2061996459961,
  },
  {
    id: "SLN",
    name: "Salina Municipal Airport",
    city: "Salina",
    country: "United States",
    lat: 38.79100036621094,
    lng: -97.6521987915039,
  },
  {
    id: "SMX",
    name: "Santa Maria Pub/Capt G Allan Hancock Field",
    city: "Santa Maria",
    country: "United States",
    lat: 34.89889908,
    lng: -120.4570007,
  },
  {
    id: "TUP",
    name: "Tupelo Regional Airport",
    city: "Tupelo",
    country: "United States",
    lat: 34.26810073852539,
    lng: -88.7698974609375,
  },
  {
    id: "UIN",
    name: "Quincy Regional Baldwin Field",
    city: "Quincy",
    country: "United States",
    lat: 39.94269943,
    lng: -91.19460297,
  },
  {
    id: "VCT",
    name: "Victoria Regional Airport",
    city: "Victoria",
    country: "United States",
    lat: 28.85260009765625,
    lng: -96.91850280761719,
  },
  {
    id: "VLD",
    name: "Valdosta Regional Airport",
    city: "Valdosta",
    country: "United States",
    lat: 30.782499313354492,
    lng: -83.27670288085938,
  },
  {
    id: "WRL",
    name: "Worland Municipal Airport",
    city: "Worland",
    country: "United States",
    lat: 43.9656982421875,
    lng: -107.95099639892578,
  },
  {
    id: "YKM",
    name: "Yakima Air Terminal McAllister Field",
    city: "Yakima",
    country: "United States",
    lat: 46.56819916,
    lng: -120.5439987,
  },
  {
    id: "ECN",
    name: "Ercan International Airport",
    city: "Nicosia",
    country: "Cyprus",
    lat: 35.154701232910156,
    lng: 33.49610137939453,
  },
  {
    id: "RJL",
    name: "Logroño-Agoncillo Airport",
    city: "Logroño-Agoncillo",
    country: "Spain",
    lat: 42.4609534888,
    lng: -2.32223510742,
  },
  {
    id: "IDY",
    name: "Île d'Yeu Airport",
    city: "Île d'Yeu",
    country: "France",
    lat: 46.71860122680664,
    lng: -2.3911099433898926,
  },
  {
    id: "ANE",
    name: "Angers-Loire Airport",
    city: "Angers/Marcé",
    country: "France",
    lat: 47.560299,
    lng: -0.312222,
  },
  {
    id: "LTT",
    name: "La Môle Airport",
    city: "La Môle",
    country: "France",
    lat: 43.205399,
    lng: 6.482,
  },
  {
    id: "JSY",
    name: "Syros Airport",
    city: "Syros Island",
    country: "Greece",
    lat: 37.4227981567,
    lng: 24.950899124099998,
  },
  {
    id: "PEV",
    name: "Pécs-Pogány Airport",
    city: "Pécs-Pogány",
    country: "Hungary",
    lat: 45.990898,
    lng: 18.240996,
  },
  {
    id: "N",
    name: "Győr-Pér International Airport",
    city: "Győr",
    country: "Hungary",
    lat: 47.624401,
    lng: 17.813601,
  },
  {
    id: "SOB",
    name: "Sármellék International Airport",
    city: "Sármellék",
    country: "Hungary",
    lat: 46.686391,
    lng: 17.159084,
  },
  {
    id: "AOT",
    name: "Aosta Airport",
    city: "Aosta",
    country: "Italy",
    lat: 45.738499,
    lng: 7.36872,
  },
  {
    id: "QSR",
    name: "Salerno Costa d'Amalfi Airport",
    city: "Salerno",
    country: "Italy",
    lat: 40.620399,
    lng: 14.9113,
  },
  {
    id: "CVU",
    name: "Corvo Airport",
    city: "Corvo",
    country: "Portugal",
    lat: 39.671501,
    lng: -31.1136,
  },
  {
    id: "BNX",
    name: "Banja Luka International Airport",
    city: "Banja Luka",
    country: "Bosnia and Herzegovina",
    lat: 44.94139862060547,
    lng: 17.297500610351562,
  },
  {
    id: "USQ",
    name: "Uşak Airport",
    city: "Usak",
    country: "Turkey",
    lat: 38.68149948120117,
    lng: 29.47170066833496,
  },
  {
    id: "KSY",
    name: "Kars Airport",
    city: "Kars",
    country: "Turkey",
    lat: 40.562198638916016,
    lng: 43.1150016784668,
  },
  {
    id: "SFQ",
    name: "Şanlıurfa Airport",
    city: "Sanliurfa",
    country: "Turkey",
    lat: 37.09429931640625,
    lng: 38.84709930419922,
  },
  {
    id: "KCM",
    name: "Kahramanmaraş Airport",
    city: "Kahramanmaras",
    country: "Turkey",
    lat: 37.5388259888,
    lng: 36.9535217285,
  },
  {
    id: "AJI",
    name: "Ağrı Airport",
    city: "Agri",
    country: "Turkey",
    lat: 39.654541015625,
    lng: 43.025978088378906,
  },
  {
    id: "ADF",
    name: "Adıyaman Airport",
    city: "Adiyaman",
    country: "Turkey",
    lat: 37.7313995361,
    lng: 38.4688987732,
  },
  {
    id: "ISE",
    name: "Süleyman Demirel International Airport",
    city: "Isparta",
    country: "Turkey",
    lat: 37.8554000854,
    lng: 30.368400573699997,
  },
  {
    id: "EDO",
    name: "Balıkesir Körfez Airport",
    city: "Balikesir Korfez",
    country: "Turkey",
    lat: 39.554599762,
    lng: 27.0137996674,
  },
  {
    id: "SZF",
    name: "Samsun Çarşamba Airport",
    city: "Samsun",
    country: "Turkey",
    lat: 41.254501,
    lng: 36.567101,
  },
  {
    id: "ILZ",
    name: "Žilina Airport",
    city: "Žilina",
    country: "Slovakia",
    lat: 49.231498718299996,
    lng: 18.6135005951,
  },
  {
    id: "GDT",
    name: "JAGS McCartney International Airport",
    city: "Cockburn Town",
    country: "Turks and Caicos Islands",
    lat: 21.444499969482422,
    lng: -71.14230346679688,
  },
  {
    id: "MDS",
    name: "Middle Caicos Airport",
    city: "Middle Caicos",
    country: "Turks and Caicos Islands",
    lat: 21.82602,
    lng: -71.8025,
  },
  {
    id: "SLX",
    name: "Salt Cay Airport",
    city: "Salt Cay",
    country: "Turks and Caicos Islands",
    lat: 21.333000183099998,
    lng: -71.1999969482,
  },
  {
    id: "AZS",
    name: "Samaná El Catey International Airport",
    city: "Samana",
    country: "Dominican Republic",
    lat: 19.2670001984,
    lng: -69.7419967651,
  },
  {
    id: "JBQ",
    name: "La Isabela International Airport",
    city: "La Isabela",
    country: "Dominican Republic",
    lat: 18.572500228881836,
    lng: -69.98560333251953,
  },
  {
    id: "PBR",
    name: "Puerto Barrios Airport",
    city: "Puerto Barrios",
    country: "Guatemala",
    lat: 15.7309,
    lng: -88.583801,
  },
  {
    id: "AAZ",
    name: "Quezaltenango Airport",
    city: "Quezaltenango",
    country: "Guatemala",
    lat: 14.8656,
    lng: -91.501999,
  },
  {
    id: "UTK",
    name: "Utirik Airport",
    city: "Utirik Island",
    country: "Marshall Islands",
    lat: 11.222,
    lng: 169.852005,
  },
  {
    id: "AHS",
    name: "Ahuas Airport",
    city: "Ahuas",
    country: "Honduras",
    lat: 15.4722,
    lng: -84.352203,
  },
  {
    id: "PEU",
    name: "Puerto Lempira Airport",
    city: "Puerto Lempira",
    country: "Honduras",
    lat: 15.2622,
    lng: -83.781197,
  },
  {
    id: "MIJ",
    name: "Mili Island Airport",
    city: "Mili Island",
    country: "Marshall Islands",
    lat: 6.08333,
    lng: 171.733002,
  },
  {
    id: "CYW",
    name: "Captain Rogelio Castillo National Airport",
    city: "Celaya",
    country: "Mexico",
    lat: 20.546,
    lng: -100.887001,
  },
  {
    id: "CUA",
    name: "Ciudad Constitución Airport",
    city: "Ciudad Constitución",
    country: "Mexico",
    lat: 25.053800582886,
    lng: -111.61499786377,
  },
  {
    id: "GUB",
    name: "Guerrero Negro Airport",
    city: "Guerrero Negro",
    country: "Mexico",
    lat: 28.0261,
    lng: -114.024002,
  },
  {
    id: "JAL",
    name: "El Lencero Airport",
    city: "Jalapa",
    country: "Mexico",
    lat: 19.4750995636,
    lng: -96.7975006104,
  },
  {
    id: "CTD",
    name: "Alonso Valderrama Airport",
    city: "Chitré",
    country: "Panama",
    lat: 7.987840175628662,
    lng: -80.40969848632812,
  },
  {
    id: "ONX",
    name: "Enrique Adolfo Jimenez Airport",
    city: "Colón",
    country: "Panama",
    lat: 9.356639862060547,
    lng: -79.86740112304688,
  },
  {
    id: "JQE",
    name: "Jaqué Airport",
    city: "Jaqué",
    country: "Panama",
    lat: 7.51777982711792,
    lng: -78.1572036743164,
  },
  {
    id: "PLP",
    name: "Captain Ramon Xatruch Airport",
    city: "La Palma",
    country: "Panama",
    lat: 8.406669616699219,
    lng: -78.1417007446289,
  },
  {
    id: "TTQ",
    name: "Aerotortuguero Airport",
    city: "Roxana",
    country: "Costa Rica",
    lat: 10.42,
    lng: -83.6095,
  },
  {
    id: "BCL",
    name: "Barra del Colorado Airport",
    city: "Pococi",
    country: "Costa Rica",
    lat: 10.768699645996094,
    lng: -83.58560180664062,
  },
  {
    id: "N",
    name: "Cabo Velas Airport",
    city: "Nicoya",
    country: "Costa Rica",
    lat: 10.355699539185,
    lng: -85.852897644043,
  },
  {
    id: "PBP",
    name: "Islita Airport",
    city: "Nandayure",
    country: "Costa Rica",
    lat: 9.856109619140625,
    lng: -85.37079620361328,
  },
  {
    id: "PJM",
    name: "Puerto Jimenez Airport",
    city: "Puerto Jimenez",
    country: "Costa Rica",
    lat: 8.533329963684082,
    lng: -83.30000305175781,
  },
  {
    id: "SYQ",
    name: "Tobias Bolanos International Airport",
    city: "San Jose",
    country: "Costa Rica",
    lat: 9.957050323486328,
    lng: -84.13980102539062,
  },
  {
    id: "N",
    name: "(Duplicate) Playa Samara Airport",
    city: "Playa Samara",
    country: "Costa Rica",
    lat: 9.87,
    lng: -85.48,
  },
  {
    id: "JEE",
    name: "Jérémie Airport",
    city: "Jeremie",
    country: "Haiti",
    lat: 18.66309928894043,
    lng: -74.17030334472656,
  },
  {
    id: "PAX",
    name: "Port-de-Paix Airport",
    city: "Port-de-Paix",
    country: "Haiti",
    lat: 19.9335994720459,
    lng: -72.84860229492188,
  },
  {
    id: "N",
    name: "Cayo Coco Airport",
    city: "Cayo Coco",
    country: "Cuba",
    lat: 22.513200759900002,
    lng: -78.51100158690001,
  },
  {
    id: "TND",
    name: "Alberto Delgado Airport",
    city: "Trinidad",
    country: "Cuba",
    lat: 21.788299560546875,
    lng: -79.99720001220703,
  },
  {
    id: "COX",
    name: "Congo Town Airport",
    city: "Andros",
    country: "Bahamas",
    lat: 24.158701,
    lng: -77.589798,
  },
  {
    id: "ATC",
    name: "Arthur's Town Airport",
    city: "Arthur's Town",
    country: "Bahamas",
    lat: 24.6294,
    lng: -75.673797,
  },
  {
    id: "TBI",
    name: "New Bight Airport",
    city: "Cat Island",
    country: "Bahamas",
    lat: 24.3153,
    lng: -75.452301,
  },
  {
    id: "CRI",
    name: "Colonel Hill Airport",
    city: "Colonel Hill",
    country: "Bahamas",
    lat: 22.745599746699998,
    lng: -74.1824035645,
  },
  {
    id: "PID",
    name: "Nassau Paradise Island Airport",
    city: "Nassau",
    country: "Bahamas",
    lat: 25.08300018310547,
    lng: -77.30000305175781,
  },
  {
    id: "AIU",
    name: "Enua Airport",
    city: "Atiu Island",
    country: "Cook Islands",
    lat: -19.96780014038086,
    lng: -158.11900329589844,
  },
  {
    id: "MGS",
    name: "Mangaia Island Airport",
    city: "Mangaia Island",
    country: "Cook Islands",
    lat: -21.895986557006836,
    lng: -157.9066619873047,
  },
  {
    id: "MHX",
    name: "Manihiki Island Airport",
    city: "Manihiki Island",
    country: "Cook Islands",
    lat: -10.376700401306152,
    lng: -161.0019989013672,
  },
  {
    id: "MUK",
    name: "Mauke Airport",
    city: "Mauke Island",
    country: "Cook Islands",
    lat: -20.13610076904297,
    lng: -157.34500122070312,
  },
  {
    id: "MOI",
    name: "Mitiaro Island Airport",
    city: "Mitiaro Island",
    country: "Cook Islands",
    lat: -19.842500686645508,
    lng: -157.7030029296875,
  },
  {
    id: "PYE",
    name: "Tongareva Airport",
    city: "Penrhyn Island",
    country: "Cook Islands",
    lat: -9.01436996459961,
    lng: -158.03240966796875,
  },
  {
    id: "ICI",
    name: "Cicia Airport",
    city: "Cicia",
    country: "Fiji",
    lat: -17.7432994843,
    lng: -179.341995239,
  },
  {
    id: "PTF",
    name: "Malolo Lailai Island Airport",
    city: "Malolo Lailai Island",
    country: "Fiji",
    lat: -17.7779006958,
    lng: 177.197006226,
  },
  {
    id: "KDV",
    name: "Vunisea Airport",
    city: "Vunisea",
    country: "Fiji",
    lat: -19.058099746699998,
    lng: 178.156997681,
  },
  {
    id: "MNF",
    name: "Mana Island Airport",
    city: "Mana Island",
    country: "Fiji",
    lat: -17.6730995178,
    lng: 177.098007202,
  },
  {
    id: "MFJ",
    name: "Moala Airport",
    city: "Moala",
    country: "Fiji",
    lat: -18.566699981699998,
    lng: 179.951004028,
  },
  {
    id: "NGI",
    name: "Ngau Airport",
    city: "Ngau",
    country: "Fiji",
    lat: -18.115600585899998,
    lng: 179.339996338,
  },
  {
    id: "LKB",
    name: "Lakeba Island Airport",
    city: "Lakeba Island",
    country: "Fiji",
    lat: -18.1991996765,
    lng: -178.817001343,
  },
  {
    id: "LBS",
    name: "Labasa Airport",
    city: "Lambasa",
    country: "Fiji",
    lat: -16.466699600219727,
    lng: 179.33999633789062,
  },
  {
    id: "TVU",
    name: "Matei Airport",
    city: "Matei",
    country: "Fiji",
    lat: -16.6905994415,
    lng: -179.876998901,
  },
  {
    id: "KXF",
    name: "Koro Island Airport",
    city: "Koro Island",
    country: "Fiji",
    lat: -17.3458003998,
    lng: 179.42199707,
  },
  {
    id: "RTA",
    name: "Rotuma Airport",
    city: "Rotuma",
    country: "Fiji",
    lat: -12.482500076293945,
    lng: 177.0709991455078,
  },
  {
    id: "SVU",
    name: "Savusavu Airport",
    city: "Savusavu",
    country: "Fiji",
    lat: -16.8027992249,
    lng: 179.341003418,
  },
  {
    id: "EUA",
    name: "Kaufana Airport",
    city: "Eua Island",
    country: "Tonga",
    lat: -21.378299713100002,
    lng: -174.957992554,
  },
  {
    id: "HPA",
    name: "Lifuka Island Airport",
    city: "Lifuka",
    country: "Tonga",
    lat: -19.777000427246094,
    lng: -174.34100341796875,
  },
  {
    id: "NFO",
    name: "Mata'aho Airport",
    city: "Angaha, Niuafo'ou Island",
    country: "Tonga",
    lat: -15.5707998276,
    lng: -175.632995605,
  },
  {
    id: "NTT",
    name: "Kuini Lavenia Airport",
    city: "Niuatoputapu",
    country: "Tonga",
    lat: -15.977297,
    lng: -173.791089,
  },
  {
    id: "VBV",
    name: "Vanua Balavu Airport",
    city: "Vanua Balavu",
    country: "Fiji",
    lat: -17.268999099731445,
    lng: -178.9759979248047,
  },
  {
    id: "IUE",
    name: "Niue International Airport",
    city: "Alofi",
    country: "Niue",
    lat: -19.079030990600586,
    lng: -169.92559814453125,
  },
  {
    id: "FUT",
    name: "Pointe Vele Airport",
    city: "Futuna Island",
    country: "Wallis and Futuna",
    lat: -14.3114004135,
    lng: -178.065994263,
  },
  {
    id: "MXS",
    name: "Maota Airport",
    city: "Savaii Island",
    country: "Samoa",
    lat: -13.742300033569336,
    lng: -172.25799560546875,
  },
  {
    id: "APK",
    name: "Apataki Airport",
    city: "Apataki",
    country: "French Polynesia",
    lat: -15.5736,
    lng: -146.414993,
  },
  {
    id: "AHE",
    name: "Ahe Airport",
    city: "Ahe",
    country: "French Polynesia",
    lat: -14.428099632263184,
    lng: -146.2570037841797,
  },
  {
    id: "AUQ",
    name: "Hiva Oa-Atuona Airport",
    city: "Hiva-oa",
    country: "French Polynesia",
    lat: -9.76879024506,
    lng: -139.011001587,
  },
  {
    id: "UAP",
    name: "Ua Pou Airport",
    city: "Ua Pou",
    country: "French Polynesia",
    lat: -9.35167,
    lng: -140.078003,
  },
  {
    id: "UAH",
    name: "Ua Huka Airport",
    city: "Ua Huka",
    country: "French Polynesia",
    lat: -8.93611,
    lng: -139.552002,
  },
  {
    id: "MTV",
    name: "Mota Lava Airport",
    city: "Ablow",
    country: "Vanuatu",
    lat: -13.6660003662,
    lng: 167.712005615,
  },
  {
    id: "SLH",
    name: "Sola Airport",
    city: "Sola",
    country: "Vanuatu",
    lat: -13.8516998291,
    lng: 167.537002563,
  },
  {
    id: "TOH",
    name: "Torres Airstrip",
    city: "Loh/Linua",
    country: "Vanuatu",
    lat: -13.3280000687,
    lng: 166.638000488,
  },
  {
    id: "EAE",
    name: "Siwo Airport",
    city: "Sangafa",
    country: "Vanuatu",
    lat: -17.0902996063,
    lng: 168.343002319,
  },
  {
    id: "CCV",
    name: "Craig Cove Airport",
    city: "Craig Cove",
    country: "Vanuatu",
    lat: -16.264999,
    lng: 167.923996,
  },
  {
    id: "LOD",
    name: "Longana Airport",
    city: "Longana",
    country: "Vanuatu",
    lat: -15.3066997528,
    lng: 167.966995239,
  },
  {
    id: "SSR",
    name: "Sara Airport",
    city: "Pentecost Island",
    country: "Vanuatu",
    lat: -15.4708003998,
    lng: 168.151992798,
  },
  {
    id: "PBJ",
    name: "Tavie Airport",
    city: "Paama Island",
    country: "Vanuatu",
    lat: -16.438999176,
    lng: 168.257003784,
  },
  {
    id: "LPM",
    name: "Lamap Airport",
    city: "Lamap",
    country: "Vanuatu",
    lat: -16.4611228,
    lng: 167.829253,
  },
  {
    id: "LNB",
    name: "Lamen Bay Airport",
    city: "Lamen Bay",
    country: "Vanuatu",
    lat: -16.584199905400002,
    lng: 168.158996582,
  },
  {
    id: "MWF",
    name: "Maewo-Naone Airport",
    city: "Maewo Island",
    country: "Vanuatu",
    lat: -15.0,
    lng: 168.082992554,
  },
  {
    id: "LNE",
    name: "Lonorore Airport",
    city: "Lonorore",
    country: "Vanuatu",
    lat: -15.865599632299999,
    lng: 168.17199707,
  },
  {
    id: "NUS",
    name: "Norsup Airport",
    city: "Norsup",
    country: "Vanuatu",
    lat: -16.0797,
    lng: 167.401001,
  },
  {
    id: "ZGU",
    name: "Gaua Island Airport",
    city: "Gaua Island",
    country: "Vanuatu",
    lat: -14.218099594099998,
    lng: 167.587005615,
  },
  {
    id: "RCL",
    name: "Redcliffe Airport",
    city: "Redcliffe",
    country: "Vanuatu",
    lat: -15.472000122099999,
    lng: 167.835006714,
  },
  {
    id: "SON",
    name: "Santo Pekoa International Airport",
    city: "Santo",
    country: "Vanuatu",
    lat: -15.505000114399998,
    lng: 167.220001221,
  },
  {
    id: "TGH",
    name: "Tongoa Airport",
    city: "Tongoa Island",
    country: "Vanuatu",
    lat: -16.8910999298,
    lng: 168.550994873,
  },
  {
    id: "ULB",
    name: "Uléi Airport",
    city: "Ambryn Island",
    country: "Vanuatu",
    lat: -16.3297,
    lng: 168.3011,
  },
  {
    id: "VLS",
    name: "Valesdir Airport",
    city: "Valesdir",
    country: "Vanuatu",
    lat: -16.796100616500002,
    lng: 168.177001953,
  },
  {
    id: "SWJ",
    name: "Southwest Bay Airport",
    city: "Malekula Island",
    country: "Vanuatu",
    lat: -16.4864,
    lng: 167.4472,
  },
  {
    id: "OLJ",
    name: "North West Santo Airport",
    city: "Olpoi",
    country: "Vanuatu",
    lat: -14.881699562099998,
    lng: 166.557998657,
  },
  {
    id: "AUY",
    name: "Aneityum Airport",
    city: "Anelghowhat",
    country: "Vanuatu",
    lat: -20.2492008209,
    lng: 169.770996094,
  },
  {
    id: "AWD",
    name: "Aniwa Airport",
    city: "Aniwa",
    country: "Vanuatu",
    lat: -19.2346,
    lng: 169.6009,
  },
  {
    id: "DLY",
    name: "Dillon's Bay Airport",
    city: "Dillon's Bay",
    country: "Vanuatu",
    lat: -18.7693996429,
    lng: 169.00100708,
  },
  {
    id: "FTA",
    name: "Futuna Airport",
    city: "Futuna Island",
    country: "Vanuatu",
    lat: -19.516399383499998,
    lng: 170.231994629,
  },
  {
    id: "IPA",
    name: "Ipota Airport",
    city: "Ipota",
    country: "Vanuatu",
    lat: -18.856389,
    lng: 169.283333,
  },
  {
    id: "TGJ",
    name: "Tiga Airport",
    city: "Tiga",
    country: "New Caledonia",
    lat: -21.096099853515625,
    lng: 167.8040008544922,
  },
  {
    id: "BMY",
    name: "Île Art - Waala Airport",
    city: "Waala",
    country: "New Caledonia",
    lat: -19.720600128173828,
    lng: 163.66099548339844,
  },
  {
    id: "ILP",
    name: "Île des Pins Airport",
    city: "Île des Pins",
    country: "New Caledonia",
    lat: -22.588899612426758,
    lng: 167.45599365234375,
  },
  {
    id: "FBD",
    name: "Fayzabad Airport",
    city: "Faizabad",
    country: "Afghanistan",
    lat: 37.121101,
    lng: 70.518097,
  },
  {
    id: "N",
    name: "Dawadmi Domestic Airport",
    city: "Dawadmi",
    country: "Saudi Arabia",
    lat: 24.5,
    lng: 44.400001525878906,
  },
  {
    id: "AJF",
    name: "Al-Jawf Domestic Airport",
    city: "Al-Jawf",
    country: "Saudi Arabia",
    lat: 29.78510093688965,
    lng: 40.099998474121094,
  },
  {
    id: "WAE",
    name: "Wadi Al Dawasir Airport",
    city: "Wadi-al-dawasir",
    country: "Saudi Arabia",
    lat: 20.504299163800003,
    lng: 45.199600219699995,
  },
  {
    id: "KHD",
    name: "Khoram Abad Airport",
    city: "Khorram Abad",
    country: "Iran",
    lat: 33.43539810180664,
    lng: 48.282901763916016,
  },
  {
    id: "BXR",
    name: "Bam Airport",
    city: "Bam",
    country: "Iran",
    lat: 29.084199905395508,
    lng: 58.45000076293945,
  },
  {
    id: "RJN",
    name: "Rafsanjan Airport",
    city: "Rafsanjan",
    country: "Iran",
    lat: 30.297700881958008,
    lng: 56.05110168457031,
  },
  {
    id: "BJB",
    name: "Bojnord Airport",
    city: "Bojnourd",
    country: "Iran",
    lat: 37.49300003051758,
    lng: 57.30820083618164,
  },
  {
    id: "AFZ",
    name: "Sabzevar National Airport",
    city: "Sabzevar",
    country: "Iran",
    lat: 36.16809844970703,
    lng: 57.59519958496094,
  },
  {
    id: "NSH",
    name: "Noshahr Airport",
    city: "Noshahr",
    country: "Iran",
    lat: 36.663299560546875,
    lng: 51.464698791503906,
  },
  {
    id: "SRY",
    name: "Dasht-e Naz Airport",
    city: "Dasht-e-naz",
    country: "Iran",
    lat: 36.635799408,
    lng: 53.193599700899995,
  },
  {
    id: "LRR",
    name: "Lar Airport",
    city: "Lar",
    country: "Iran",
    lat: 27.6746997833,
    lng: 54.3833007812,
  },
  {
    id: "ADU",
    name: "Ardabil Airport",
    city: "Ardabil",
    country: "Iran",
    lat: 38.3256988525,
    lng: 48.4244003296,
  },
  {
    id: "OMH",
    name: "Urmia Airport",
    city: "Uromiyeh",
    country: "Iran",
    lat: 37.6680984497,
    lng: 45.0686988831,
  },
  {
    id: "AAN",
    name: "Al Ain International Airport",
    city: "Al Ain",
    country: "United Arab Emirates",
    lat: 24.261699676513672,
    lng: 55.60919952392578,
  },
  {
    id: "BNP",
    name: "Bannu Airport",
    city: "Bannu",
    country: "Pakistan",
    lat: 32.9729,
    lng: 70.527901,
  },
  {
    id: "BHV",
    name: "Bahawalpur Airport",
    city: "Bahawalpur",
    country: "Pakistan",
    lat: 29.348100662231445,
    lng: 71.71800231933594,
  },
  {
    id: "CJL",
    name: "Chitral Airport",
    city: "Chitral",
    country: "Pakistan",
    lat: 35.886600494384766,
    lng: 71.80059814453125,
  },
  {
    id: "DBA",
    name: "Dalbandin Airport",
    city: "Dalbandin",
    country: "Pakistan",
    lat: 28.878299713100002,
    lng: 64.3998031616,
  },
  {
    id: "DEA",
    name: "Dera Ghazi Khan Airport",
    city: "Dera Ghazi Khan",
    country: "Pakistan",
    lat: 29.961000442504883,
    lng: 70.48590087890625,
  },
  {
    id: "DSK",
    name: "Dera Ismael Khan Airport",
    city: "Dera Ismael Khan",
    country: "Pakistan",
    lat: 31.909400939941406,
    lng: 70.89659881591797,
  },
  {
    id: "JIW",
    name: "Jiwani Airport",
    city: "Jiwani",
    country: "Pakistan",
    lat: 25.067800521900004,
    lng: 61.8054008484,
  },
  {
    id: "HDD",
    name: "Hyderabad Airport",
    city: "Hyderabad",
    country: "Pakistan",
    lat: 25.3181,
    lng: 68.366096,
  },
  {
    id: "KDD",
    name: "Khuzdar Airport",
    city: "Khuzdar",
    country: "Pakistan",
    lat: 27.790599823,
    lng: 66.6473007202,
  },
  {
    id: "ORW",
    name: "Ormara Airport",
    city: "Ormara Raik",
    country: "Pakistan",
    lat: 25.274700164799995,
    lng: 64.58599853519999,
  },
  {
    id: "PAJ",
    name: "Parachinar Airport",
    city: "Parachinar",
    country: "Pakistan",
    lat: 33.902099609400004,
    lng: 70.0716018677,
  },
  {
    id: "KDU",
    name: "Skardu Airport",
    city: "Skardu",
    country: "Pakistan",
    lat: 35.33549880981445,
    lng: 75.53600311279297,
  },
  {
    id: "SYW",
    name: "Sehwan Sharif Airport",
    city: "Sehwan Sharif",
    country: "Pakistan",
    lat: 26.473100662231445,
    lng: 67.71720123291016,
  },
  {
    id: "TUK",
    name: "Turbat International Airport",
    city: "Turbat",
    country: "Pakistan",
    lat: 25.986400604248047,
    lng: 63.03020095825195,
  },
  {
    id: "ISU",
    name: "Sulaymaniyah International Airport",
    city: "Sulaymaniyah",
    country: "Iraq",
    lat: 35.5617485046,
    lng: 45.316738128699996,
  },
  {
    id: "KAC",
    name: "Kamishly Airport",
    city: "Kamishly",
    country: "Syria",
    lat: 37.020599365234375,
    lng: 41.19139862060547,
  },
  {
    id: "GXF",
    name: "Sayun International Airport",
    city: "Sayun Intl",
    country: "Yemen",
    lat: 15.9660997391,
    lng: 48.78829956049999,
  },
  {
    id: "ADK",
    name: "Adak Airport",
    city: "Adak Island",
    country: "United States",
    lat: 51.87799835205078,
    lng: -176.64599609375,
  },
  {
    id: "GST",
    name: "Gustavus Airport",
    city: "Gustavus",
    country: "United States",
    lat: 58.4253006,
    lng: -135.7070007,
  },
  {
    id: "SGY",
    name: "Skagway Airport",
    city: "Skagway",
    country: "United States",
    lat: 59.46009826660156,
    lng: -135.3159942626953,
  },
  {
    id: "HCR",
    name: "Holy Cross Airport",
    city: "Holy Cross",
    country: "United States",
    lat: 62.18830108642578,
    lng: -159.77499389648438,
  },
  {
    id: "HNS",
    name: "Haines Airport",
    city: "Haines",
    country: "United States",
    lat: 59.24380111694336,
    lng: -135.5240020751953,
  },
  {
    id: "KLG",
    name: "Kalskag Airport",
    city: "Kalskag",
    country: "United States",
    lat: 61.53630065917969,
    lng: -160.34100341796875,
  },
  {
    id: "MCG",
    name: "McGrath Airport",
    city: "Mcgrath",
    country: "United States",
    lat: 62.95289993,
    lng: -155.6060028,
  },
  {
    id: "MOU",
    name: "Mountain Village Airport",
    city: "Mountain Village",
    country: "United States",
    lat: 62.095401763916016,
    lng: -163.6820068359375,
  },
  {
    id: "ANI",
    name: "Aniak Airport",
    city: "Aniak",
    country: "United States",
    lat: 61.581600189208984,
    lng: -159.54299926757812,
  },
  {
    id: "VAK",
    name: "Chevak Airport",
    city: "Chevak",
    country: "United States",
    lat: 61.5409,
    lng: -165.6005,
  },
  {
    id: "WRG",
    name: "Wrangell Airport",
    city: "Wrangell",
    country: "United States",
    lat: 56.48429871,
    lng: -132.3699951,
  },
  {
    id: "OPU",
    name: "Balimo Airport",
    city: "Balimo",
    country: "Papua New Guinea",
    lat: -8.05000019073,
    lng: 142.932998657,
  },
  {
    id: "VMU",
    name: "Baimuru Airport",
    city: "Baimuru",
    country: "Papua New Guinea",
    lat: -7.49686002731,
    lng: 144.819900513,
  },
  {
    id: "LUP",
    name: "Kalaupapa Airport",
    city: "Molokai",
    country: "United States",
    lat: 21.21100044,
    lng: -156.973999,
  },
  {
    id: "ENT",
    name: "Eniwetok Airport",
    city: "Eniwetok Atoll",
    country: "Marshall Islands",
    lat: 11.340700149536133,
    lng: 162.3280029296875,
  },
  {
    id: "LZN",
    name: "Matsu Nangan Airport",
    city: "Matsu Islands",
    country: "Taiwan",
    lat: 26.1598,
    lng: 119.958,
  },
  {
    id: "HCN",
    name: "Hengchun Airport",
    city: "Hengchun",
    country: "Taiwan",
    lat: 22.041099548339844,
    lng: 120.7300033569336,
  },
  {
    id: "MFK",
    name: "Matsu Beigan Airport",
    city: "Matsu Islands",
    country: "Taiwan",
    lat: 26.224199,
    lng: 120.002998,
  },
  {
    id: "KUH",
    name: "Kushiro Airport",
    city: "Kushiro",
    country: "Japan",
    lat: 43.041000366199995,
    lng: 144.192993164,
  },
  {
    id: "OKD",
    name: "Okadama Airport",
    city: "Sapporo",
    country: "Japan",
    lat: 43.117447,
    lng: 141.38134,
  },
  {
    id: "HSG",
    name: "Saga Airport",
    city: "Saga",
    country: "Japan",
    lat: 33.149700164799995,
    lng: 130.302001953,
  },
  {
    id: "NKM",
    name: "Nagoya Airport",
    city: "Nagoya",
    country: "Japan",
    lat: 35.255001068115234,
    lng: 136.9239959716797,
  },
  {
    id: "IWJ",
    name: "Iwami Airport",
    city: "Iwami",
    country: "Japan",
    lat: 34.676399231,
    lng: 131.789993286,
  },
  {
    id: "FKS",
    name: "Fukushima Airport",
    city: "Fukushima",
    country: "Japan",
    lat: 37.22740173339844,
    lng: 140.43099975585938,
  },
  {
    id: "ONJ",
    name: "Odate Noshiro Airport",
    city: "Odate Noshiro",
    country: "Japan",
    lat: 40.1918983459,
    lng: 140.371002197,
  },
  {
    id: "SYO",
    name: "Shonai Airport",
    city: "Shonai",
    country: "Japan",
    lat: 38.81219863889999,
    lng: 139.787002563,
  },
  {
    id: "MYE",
    name: "Miyakejima Airport",
    city: "Miyakejima",
    country: "Japan",
    lat: 34.073600769,
    lng: 139.559997559,
  },
  {
    id: "KUV",
    name: "Kunsan Air Base",
    city: "Kunsan",
    country: "South Korea",
    lat: 35.90380096435547,
    lng: 126.61599731445312,
  },
  {
    id: "MPK",
    name: "Mokpo Heliport",
    city: "Mokpo",
    country: "South Korea",
    lat: 34.7588996887,
    lng: 126.379997253,
  },
  {
    id: "WJU",
    name: "Wonju/Hoengseong Air Base (K-38/K-46)",
    city: "Wonju",
    country: "South Korea",
    lat: 37.441201,
    lng: 127.963858,
  },
  {
    id: "YNY",
    name: "Yangyang International Airport",
    city: "Sokcho / Gangneung",
    country: "South Korea",
    lat: 38.061298,
    lng: 128.669006,
  },
  {
    id: "HIN",
    name: "Sacheon Air Base/Airport",
    city: "Sacheon",
    country: "South Korea",
    lat: 35.088591,
    lng: 128.071747,
  },
  {
    id: "CJJ",
    name: "Cheongju International Airport/Cheongju Air Base (K-59/G-513)",
    city: "Chongju",
    country: "South Korea",
    lat: 36.717008,
    lng: 127.498741,
  },
  {
    id: "SFS",
    name: "Subic Bay International Airport",
    city: "Olongapo City",
    country: "Philippines",
    lat: 14.794400215148926,
    lng: 120.27100372314453,
  },
  {
    id: "CYU",
    name: "Cuyo Airport",
    city: "Cuyo",
    country: "Philippines",
    lat: 10.858099937438965,
    lng: 121.06900024414062,
  },
  {
    id: "N",
    name: "Rajah Buayan Air Base",
    city: "General Santos City",
    country: "Philippines",
    lat: 6.10644006729,
    lng: 125.23500061,
  },
  {
    id: "CGM",
    name: "Camiguin Airport",
    city: "Camiguin",
    country: "Philippines",
    lat: 9.253520011901855,
    lng: 124.70700073242188,
  },
  {
    id: "JOL",
    name: "Jolo Airport",
    city: "Jolo",
    country: "Philippines",
    lat: 6.0536699295043945,
    lng: 121.01100158691406,
  },
  {
    id: "TWT",
    name: "Sanga Sanga Airport",
    city: "Sanga Sanga",
    country: "Philippines",
    lat: 5.046991,
    lng: 119.742996,
  },
  {
    id: "SUG",
    name: "Surigao Airport",
    city: "Sangley Point",
    country: "Philippines",
    lat: 9.755838325629998,
    lng: 125.480947495,
  },
  {
    id: "TDG",
    name: "Tandag Airport",
    city: "Tandag",
    country: "Philippines",
    lat: 9.072110176086426,
    lng: 126.1709976196289,
  },
  {
    id: "WNP",
    name: "Naga Airport",
    city: "Naga",
    country: "Philippines",
    lat: 13.58489990234375,
    lng: 123.2699966430664,
  },
  {
    id: "BSO",
    name: "Basco Airport",
    city: "Basco",
    country: "Philippines",
    lat: 20.4513,
    lng: 121.980003,
  },
  {
    id: "SFE",
    name: "San Fernando Airport",
    city: "San Fernando",
    country: "Philippines",
    lat: 16.595600128173828,
    lng: 120.3030014038086,
  },
  {
    id: "TUG",
    name: "Tuguegarao Airport",
    city: "Tuguegarao",
    country: "Philippines",
    lat: 17.6433676823,
    lng: 121.733150482,
  },
  {
    id: "VRC",
    name: "Virac Airport",
    city: "Virac",
    country: "Philippines",
    lat: 13.576399803161621,
    lng: 124.20600128173828,
  },
  {
    id: "CYP",
    name: "Calbayog Airport",
    city: "Calbayog City",
    country: "Philippines",
    lat: 12.072699546813965,
    lng: 124.54499816894531,
  },
  {
    id: "CRM",
    name: "Catarman National Airport",
    city: "Catarman",
    country: "Philippines",
    lat: 12.502400398254395,
    lng: 124.63600158691406,
  },
  {
    id: "MBT",
    name: "Moises R. Espinosa Airport",
    city: "Masbate",
    country: "Philippines",
    lat: 12.369682,
    lng: 123.630095,
  },
  {
    id: "RXS",
    name: "Roxas Airport",
    city: "Roxas City",
    country: "Philippines",
    lat: 11.597700119018555,
    lng: 122.75199890136719,
  },
  {
    id: "TTG",
    name: "General Enrique Mosconi Airport",
    city: "Tartagal",
    country: "Argentina",
    lat: -22.619600296,
    lng: -63.7937011719,
  },
  {
    id: "LHS",
    name: "Las Heras Airport",
    city: "Las Heras",
    country: "Argentina",
    lat: -46.53829956049999,
    lng: -68.9653015137,
  },
  {
    id: "OES",
    name: "Antoine de Saint Exupéry Airport",
    city: "San Antonio Oeste",
    country: "Argentina",
    lat: -40.7512,
    lng: -65.0343,
  },
  {
    id: "ING",
    name: "Lago Argentino Airport",
    city: "El Calafate",
    country: "Argentina",
    lat: -50.336102,
    lng: -72.248596,
  },
  {
    id: "GGS",
    name: "Gobernador Gregores Airport",
    city: "Gobernador Gregores",
    country: "Argentina",
    lat: -48.7831,
    lng: -70.150002,
  },
  {
    id: "SST",
    name: "Santa Teresita Airport",
    city: "Santa Teresita",
    country: "Argentina",
    lat: -36.5423,
    lng: -56.7218,
  },
  {
    id: "NEC",
    name: "Necochea Airport",
    city: "Necochea",
    country: "Argentina",
    lat: -38.4831,
    lng: -58.8172,
  },
  {
    id: "JDO",
    name: "Orlando Bezerra de Menezes Airport",
    city: "Juazeiro Do Norte",
    country: "Brazil",
    lat: -7.21895980835,
    lng: -39.270099639899996,
  },
  {
    id: "LEC",
    name: "Coronel Horácio de Mattos Airport",
    city: "Lençóis",
    country: "Brazil",
    lat: -12.4822998047,
    lng: -41.2770004272,
  },
  {
    id: "MEA",
    name: "Macaé Airport",
    city: "Macaé",
    country: "Brazil",
    lat: -22.343000412,
    lng: -41.7659988403,
  },
  {
    id: "MII",
    name: "Frank Miloye Milenkowichi–Marília State Airport",
    city: "Marília",
    country: "Brazil",
    lat: -22.1968994141,
    lng: -49.926399231,
  },
  {
    id: "VDC",
    name: "Vitória da Conquista Airport",
    city: "Vitória Da Conquista",
    country: "Brazil",
    lat: -14.8627996445,
    lng: -40.8630981445,
  },
  {
    id: "RIA",
    name: "Santa Maria Airport",
    city: "Santa Maria",
    country: "Brazil",
    lat: -29.711399,
    lng: -53.688202,
  },
  {
    id: "TOW",
    name: "Toledo Airport",
    city: "Toledo",
    country: "Brazil",
    lat: -24.6863,
    lng: -53.697498,
  },
  {
    id: "ESR",
    name: "Ricardo García Posada Airport",
    city: "El Salvador",
    country: "Chile",
    lat: -26.311100006103516,
    lng: -69.76519775390625,
  },
  {
    id: "ZPC",
    name: "Pucón Airport",
    city: "Pucon",
    country: "Chile",
    lat: -39.29280090332031,
    lng: -71.91590118408203,
  },
  {
    id: "SOD",
    name: "Sorocaba Airport",
    city: "Sorocaba",
    country: "Brazil",
    lat: -23.478001,
    lng: -47.490002,
  },
  {
    id: "SCY",
    name: "San Cristóbal Airport",
    city: "San Cristóbal",
    country: "Ecuador",
    lat: -0.910206,
    lng: -89.617401,
  },
  {
    id: "LOH",
    name: "Camilo Ponce Enriquez Airport",
    city: "La Toma (Catamayo)",
    country: "Ecuador",
    lat: -3.99589,
    lng: -79.371902,
  },
  {
    id: "ESM",
    name: "General Rivadeneira Airport",
    city: "Esmeraldas",
    country: "Ecuador",
    lat: 0.9785190224647522,
    lng: -79.62660217285156,
  },
  {
    id: "PSY",
    name: "Port Stanley Airport",
    city: "Stanley",
    country: "Falkland Islands",
    lat: -51.685699462891,
    lng: -57.777599334717,
  },
  {
    id: "CRC",
    name: "Santa Ana Airport",
    city: "Cartago",
    country: "Colombia",
    lat: 4.75818,
    lng: -75.9557,
  },
  {
    id: "N",
    name: "La Jagua Airport",
    city: "Garzón",
    country: "Colombia",
    lat: 2.1464,
    lng: -75.6944,
  },
  {
    id: "LQM",
    name: "Caucaya Airport",
    city: "Puerto Leguízamo",
    country: "Colombia",
    lat: -0.182278,
    lng: -74.7708,
  },
  {
    id: "LPD",
    name: "La Pedrera Airport",
    city: "La Pedrera",
    country: "Colombia",
    lat: -1.32861,
    lng: -69.5797,
  },
  {
    id: "NQU",
    name: "Reyes Murillo Airport",
    city: "Nuquí",
    country: "Colombia",
    lat: 5.6964,
    lng: -77.2806,
  },
  {
    id: "PDA",
    name: "Obando Airport",
    city: "Puerto Inírida",
    country: "Colombia",
    lat: 3.85353,
    lng: -67.9062,
  },
  {
    id: "EYP",
    name: "El Yopal Airport",
    city: "Yopal",
    country: "Colombia",
    lat: 5.31911,
    lng: -72.384,
  },
  {
    id: "GYA",
    name: "Capitán de Av. Emilio Beltrán Airport",
    city: "Guayaramerín",
    country: "Bolivia",
    lat: -10.820599556,
    lng: -65.3455963135,
  },
  {
    id: "PUR",
    name: "Puerto Rico Airport",
    city: "Puerto Rico/Manuripi",
    country: "Bolivia",
    lat: -11.107663,
    lng: -67.551155,
  },
  {
    id: "RIB",
    name: "Capitán Av. Selin Zeitun Lopez Airport",
    city: "Riberalta",
    country: "Bolivia",
    lat: -11.0,
    lng: -66.0,
  },
  {
    id: "REY",
    name: "Reyes Airport",
    city: "Reyes",
    country: "Bolivia",
    lat: -14.3044,
    lng: -67.353401,
  },
  {
    id: "SRJ",
    name: "Capitán Av. German Quiroga G. Airport",
    city: "San Borja",
    country: "Bolivia",
    lat: -14.859199523925781,
    lng: -66.73750305175781,
  },
  {
    id: "ORG",
    name: "Zorg en Hoop Airport",
    city: "Paramaribo",
    country: "Suriname",
    lat: 5.81108,
    lng: -55.190701,
  },
  {
    id: "MVS",
    name: "Mucuri Airport",
    city: "Mucuri",
    country: "Brazil",
    lat: -18.048900604248047,
    lng: -39.864200592041016,
  },
  {
    id: "N",
    name: "Caballococha Airport",
    city: "Caballococha",
    country: "Peru",
    lat: -3.91686010361,
    lng: -70.5082015991,
  },
  {
    id: "CJA",
    name: "Mayor General FAP Armando Revoredo Iglesias Airport",
    city: "Cajamarca",
    country: "Peru",
    lat: -7.1391801834106445,
    lng: -78.4894027709961,
  },
  {
    id: "HUU",
    name: "Alferez Fap David Figueroa Fernandini Airport",
    city: "Huánuco",
    country: "Peru",
    lat: -9.878809928894043,
    lng: -76.20480346679688,
  },
  {
    id: "NZC",
    name: "Maria Reiche Neuman Airport",
    city: "Nazca",
    country: "Peru",
    lat: -14.854000091600001,
    lng: -74.9615020752,
  },
  {
    id: "SRA",
    name: "Santa Rosa Airport",
    city: "Santa Rosa",
    country: "Brazil",
    lat: -27.9067,
    lng: -54.520401,
  },
  {
    id: "N",
    name: "El Jagüel / Punta del Este Airport",
    city: "Maldonado",
    country: "Uruguay",
    lat: -34.9169998169,
    lng: -54.916999816899995,
  },
  {
    id: "MYC",
    name: "Escuela Mariscal Sucre Airport",
    city: "Maracay",
    country: "Venezuela",
    lat: 10.249978065490723,
    lng: -67.64942169189453,
  },
  {
    id: "VIG",
    name: "Juan Pablo Pérez Alfonso Airport",
    city: "El Vigía",
    country: "Venezuela",
    lat: 8.624139,
    lng: -71.672668,
  },
  {
    id: "JPR",
    name: "Ji-Paraná Airport",
    city: "Ji-Paraná",
    country: "Brazil",
    lat: -10.870800018299999,
    lng: -61.8465003967,
  },
  {
    id: "BBQ",
    name: "Codrington Airport",
    city: "Codrington",
    country: "Antigua and Barbuda",
    lat: 17.635799,
    lng: -61.828602,
  },
  {
    id: "DSD",
    name: "La Désirade Airport",
    city: "Grande Anse",
    country: "Guadeloupe",
    lat: 16.296902,
    lng: -61.0844,
  },
  {
    id: "BBR",
    name: "Baillif Airport",
    city: "Basse Terre",
    country: "Guadeloupe",
    lat: 16.0132999420166,
    lng: -61.7421989440918,
  },
  {
    id: "SFC",
    name: "St-François Airport",
    city: "St-François",
    country: "Guadeloupe",
    lat: 16.25779914855957,
    lng: -61.26250076293945,
  },
  {
    id: "GBJ",
    name: "Les Bases Airport",
    city: "Grand Bourg",
    country: "Guadeloupe",
    lat: 15.86870002746582,
    lng: -61.27000045776367,
  },
  {
    id: "NEV",
    name: "Vance W. Amory International Airport",
    city: "Charlestown",
    country: "Saint Kitts and Nevis",
    lat: 17.205699920654297,
    lng: -62.589900970458984,
  },
  {
    id: "VIJ",
    name: "Virgin Gorda Airport",
    city: "Spanish Town",
    country: "British Virgin Islands",
    lat: 18.446399688720703,
    lng: -64.42749786376953,
  },
  {
    id: "BQU",
    name: "J F Mitchell Airport",
    city: "Bequia",
    country: "Saint Vincent and the Grenadines",
    lat: 12.9884004593,
    lng: -61.2620010376,
  },
  {
    id: "UNI",
    name: "Union Island International Airport",
    city: "Union Island",
    country: "Saint Vincent and the Grenadines",
    lat: 12.60013484954834,
    lng: -61.41194534301758,
  },
  {
    id: "KOV",
    name: "Kokshetau Airport",
    city: "Kokshetau",
    country: "Kazakhstan",
    lat: 53.329102,
    lng: 69.594597,
  },
  {
    id: "PPK",
    name: "Petropavlosk South Airport",
    city: "Petropavlosk",
    country: "Kazakhstan",
    lat: 54.77470016479492,
    lng: 69.18389892578125,
  },
  {
    id: "DZN",
    name: "Zhezkazgan Airport",
    city: "Zhezkazgan",
    country: "Kazakhstan",
    lat: 47.708302,
    lng: 67.733299,
  },
  {
    id: "UKK",
    name: "Ust-Kamennogorsk Airport",
    city: "Ust Kamenogorsk",
    country: "Kazakhstan",
    lat: 50.036598205566406,
    lng: 82.49420166015625,
  },
  {
    id: "KSN",
    name: "Kostanay West Airport",
    city: "Kostanay",
    country: "Kazakhstan",
    lat: 53.20690155029297,
    lng: 63.55030059814453,
  },
  {
    id: "KVD",
    name: "Ganja Airport",
    city: "Ganja",
    country: "Azerbaijan",
    lat: 40.737701416015625,
    lng: 46.31760025024414,
  },
  {
    id: "NAJ",
    name: "Nakhchivan Airport",
    city: "Nakhchivan",
    country: "Azerbaijan",
    lat: 39.18880081176758,
    lng: 45.45840072631836,
  },
  {
    id: "NER",
    name: "Chulman Airport",
    city: "Neryungri",
    country: "Russia",
    lat: 56.913898468018,
    lng: 124.91400146484,
  },
  {
    id: "PYJ",
    name: "Polyarny Airport",
    city: "Yakutia",
    country: "Russia",
    lat: 66.4003982544,
    lng: 112.029998779,
  },
  {
    id: "CKH",
    name: "Chokurdakh Airport",
    city: "Chokurdah",
    country: "Russia",
    lat: 70.62310028076172,
    lng: 147.90199279785156,
  },
  {
    id: "CYX",
    name: "Cherskiy Airport",
    city: "Cherskiy",
    country: "Russia",
    lat: 68.7406005859375,
    lng: 161.33799743652344,
  },
  {
    id: "IKS",
    name: "Tiksi Airport",
    city: "Tiksi",
    country: "Russia",
    lat: 71.697700500488,
    lng: 128.90299987793,
  },
  {
    id: "KXK",
    name: "Komsomolsk-on-Amur Airport",
    city: "Komsomolsk-on-Amur",
    country: "Russia",
    lat: 50.409000396728516,
    lng: 136.9340057373047,
  },
  {
    id: "DYR",
    name: "Ugolny Airport",
    city: "Anadyr",
    country: "Russia",
    lat: 64.734902,
    lng: 177.740997,
  },
  {
    id: "OHO",
    name: "Okhotsk Airport",
    city: "Okhotsk",
    country: "Russia",
    lat: 59.410064697265625,
    lng: 143.05650329589844,
  },
  {
    id: "UJE",
    name: "Ujae Atoll Airport",
    city: "Ujae Atoll",
    country: "Marshall Islands",
    lat: 8.92805957794,
    lng: 165.761993408,
  },
  {
    id: "MPW",
    name: "Mariupol International Airport",
    city: "Mariupol International",
    country: "Ukraine",
    lat: 47.07609939575195,
    lng: 37.44960021972656,
  },
  {
    id: "VSG",
    name: "Luhansk International Airport",
    city: "Lugansk",
    country: "Ukraine",
    lat: 48.4174003601,
    lng: 39.3740997314,
  },
  {
    id: "OZH",
    name: "Zaporizhzhia International Airport",
    city: "Zaporozhye",
    country: "Ukraine",
    lat: 47.867000579833984,
    lng: 35.31570053100586,
  },
  {
    id: "KWG",
    name: "Kryvyi Rih International Airport",
    city: "Krivoy Rog",
    country: "Ukraine",
    lat: 48.04330062866211,
    lng: 33.209999084472656,
  },
  {
    id: "HRK",
    name: "Kharkiv International Airport",
    city: "Kharkov",
    country: "Ukraine",
    lat: 49.924800872802734,
    lng: 36.290000915527344,
  },
  {
    id: "IFO",
    name: "Ivano-Frankivsk International Airport",
    city: "Ivano-Frankivsk",
    country: "Ukraine",
    lat: 48.88420104980469,
    lng: 24.686100006103516,
  },
  {
    id: "CWC",
    name: "Chernivtsi International Airport",
    city: "Chernovtsk",
    country: "Ukraine",
    lat: 48.259300231933594,
    lng: 25.98080062866211,
  },
  {
    id: "RWN",
    name: "Rivne International Airport",
    city: "Rivne",
    country: "Ukraine",
    lat: 50.60710144042969,
    lng: 26.141599655151367,
  },
  {
    id: "UDJ",
    name: "Uzhhorod International Airport",
    city: "Uzhgorod",
    country: "Ukraine",
    lat: 48.634300231933594,
    lng: 22.263399124145508,
  },
  {
    id: "CSH",
    name: "Solovki Airport",
    city: "Solovetsky Islands",
    country: "Russia",
    lat: 65.0299987793,
    lng: 35.7333335876,
  },
  {
    id: "CEE",
    name: "Cherepovets Airport",
    city: "Cherepovets",
    country: "Russia",
    lat: 59.273601532,
    lng: 38.015800476100004,
  },
  {
    id: "AMV",
    name: "Amderma Airport",
    city: "Amderma",
    country: "Russia",
    lat: 69.76329803466797,
    lng: 61.556400299072266,
  },
  {
    id: "KSZ",
    name: "Kotlas Airport",
    city: "Kotlas",
    country: "Russia",
    lat: 61.235801696777344,
    lng: 46.6974983215332,
  },
  {
    id: "PES",
    name: "Petrozavodsk Airport",
    city: "Petrozavodsk",
    country: "Russia",
    lat: 61.88520050048828,
    lng: 34.154701232910156,
  },
  {
    id: "GNA",
    name: "Hrodna Airport",
    city: "Hrodna",
    country: "Belarus",
    lat: 53.60200119018555,
    lng: 24.053800582885742,
  },
  {
    id: "MVQ",
    name: "Mogilev Airport",
    city: "Mogilev",
    country: "Belarus",
    lat: 53.954898834228516,
    lng: 30.09510040283203,
  },
  {
    id: "EIE",
    name: "Yeniseysk Airport",
    city: "Yeniseysk",
    country: "Russia",
    lat: 58.47420120239258,
    lng: 92.11250305175781,
  },
  {
    id: "KYZ",
    name: "Kyzyl Airport",
    city: "Kyzyl",
    country: "Russia",
    lat: 51.66939926147461,
    lng: 94.40059661865234,
  },
  {
    id: "NOZ",
    name: "Spichenkovo Airport",
    city: "Novokuznetsk",
    country: "Russia",
    lat: 53.811401,
    lng: 86.877197,
  },
  {
    id: "HTG",
    name: "Khatanga Airport",
    city: "Khatanga",
    country: "Russia",
    lat: 71.97810363769531,
    lng: 102.49099731445312,
  },
  {
    id: "IAA",
    name: "Igarka Airport",
    city: "Igarka",
    country: "Russia",
    lat: 67.43720245361328,
    lng: 86.62190246582031,
  },
  {
    id: "N",
    name: "Khankala Air Base",
    city: "Grozny",
    country: "Russia",
    lat: 43.298099517822266,
    lng: 45.78409957885742,
  },
  {
    id: "NAL",
    name: "Nalchik Airport",
    city: "Nalchik",
    country: "Russia",
    lat: 43.512901306152344,
    lng: 43.636600494384766,
  },
  {
    id: "OGZ",
    name: "Beslan Airport",
    city: "Beslan",
    country: "Russia",
    lat: 43.2051010132,
    lng: 44.6066017151,
  },
  {
    id: "ESL",
    name: "Elista Airport",
    city: "Elista",
    country: "Russia",
    lat: 46.3739013671875,
    lng: 44.33089828491211,
  },
  {
    id: "WKK",
    name: "Aleknagik / New Airport",
    city: "Aleknagik",
    country: "United States",
    lat: 59.2826004028,
    lng: -158.617996216,
  },
  {
    id: "BLF",
    name: "Mercer County Airport",
    city: "Bluefield",
    country: "United States",
    lat: 37.295799255371094,
    lng: -81.20770263671875,
  },
  {
    id: "GLH",
    name: "Mid Delta Regional Airport",
    city: "Greenville",
    country: "United States",
    lat: 33.4828987121582,
    lng: -90.98560333251953,
  },
  {
    id: "PSC",
    name: "Tri Cities Airport",
    city: "Pasco",
    country: "United States",
    lat: 46.26470184326172,
    lng: -119.11900329589844,
  },
  {
    id: "KQA",
    name: "Akutan Seaplane Base",
    city: "Akutan",
    country: "United States",
    lat: 54.1337704415,
    lng: -165.778895617,
  },
  {
    id: "LPS",
    name: "Lopez Island Airport",
    city: "Lopez",
    country: "United States",
    lat: 48.4838981628418,
    lng: -122.93800354003906,
  },
  {
    id: "SLY",
    name: "Salekhard Airport",
    city: "Salekhard",
    country: "Russia",
    lat: 66.5907974243164,
    lng: 66.61100006103516,
  },
  {
    id: "HMA",
    name: "Khanty Mansiysk Airport",
    city: "Khanty-Mansiysk",
    country: "Russia",
    lat: 61.028499603271484,
    lng: 69.08609771728516,
  },
  {
    id: "NYA",
    name: "Nyagan Airport",
    city: "Nyagan",
    country: "Russia",
    lat: 62.110001,
    lng: 65.614998,
  },
  {
    id: "OVS",
    name: "Sovetskiy Airport",
    city: "Sovetskiy",
    country: "Russia",
    lat: 61.326622009277344,
    lng: 63.60191345214844,
  },
  {
    id: "IJK",
    name: "Izhevsk Airport",
    city: "Izhevsk",
    country: "Russia",
    lat: 56.82809829711914,
    lng: 53.45750045776367,
  },
  {
    id: "KVX",
    name: "Pobedilovo Airport",
    city: "Kirov",
    country: "Russia",
    lat: 58.503299713135,
    lng: 49.348300933838,
  },
  {
    id: "NYM",
    name: "Nadym Airport",
    city: "Nadym",
    country: "Russia",
    lat: 65.48090362548828,
    lng: 72.69889831542969,
  },
  {
    id: "RAT",
    name: "Raduzhny Airport",
    city: "Raduzhnyi",
    country: "Russia",
    lat: 62.1585998535,
    lng: 77.32890319820001,
  },
  {
    id: "NFG",
    name: "Nefteyugansk Airport",
    city: "Nefteyugansk",
    country: "Russia",
    lat: 61.108299255371094,
    lng: 72.6500015258789,
  },
  {
    id: "KRO",
    name: "Kurgan Airport",
    city: "Kurgan",
    country: "Russia",
    lat: 55.47529983520508,
    lng: 65.41560363769531,
  },
  {
    id: "LBD",
    name: "Khudzhand Airport",
    city: "Khudzhand",
    country: "Tajikistan",
    lat: 40.21540069580078,
    lng: 69.6947021484375,
  },
  {
    id: "AZN",
    name: "Andizhan Airport",
    city: "Andizhan",
    country: "Uzbekistan",
    lat: 40.7276992798,
    lng: 72.2939987183,
  },
  {
    id: "FEG",
    name: "Fergana International Airport",
    city: "Fergana",
    country: "Uzbekistan",
    lat: 40.358798980699994,
    lng: 71.7450027466,
  },
  {
    id: "NMA",
    name: "Namangan Airport",
    city: "Namangan",
    country: "Uzbekistan",
    lat: 40.9846000671,
    lng: 71.5567016602,
  },
  {
    id: "NCU",
    name: "Nukus Airport",
    city: "Nukus",
    country: "Uzbekistan",
    lat: 42.488399505615234,
    lng: 59.62329864501953,
  },
  {
    id: "UGC",
    name: "Urgench Airport",
    city: "Urgench",
    country: "Uzbekistan",
    lat: 41.58430099487305,
    lng: 60.641700744628906,
  },
  {
    id: "KSQ",
    name: "Karshi Khanabad Airport",
    city: "Khanabad",
    country: "Uzbekistan",
    lat: 38.8335990906,
    lng: 65.9215011597,
  },
  {
    id: "TMJ",
    name: "Termez Airport",
    city: "Termez",
    country: "Uzbekistan",
    lat: 37.28670120239258,
    lng: 67.30999755859375,
  },
  {
    id: "RYB",
    name: "Staroselye Airport",
    city: "Rybinsk",
    country: "Russia",
    lat: 58.10419845581055,
    lng: 38.92940139770508,
  },
  {
    id: "EGO",
    name: "Belgorod International Airport",
    city: "Belgorod",
    country: "Russia",
    lat: 50.643798828125,
    lng: 36.5900993347168,
  },
  {
    id: "URS",
    name: "Kursk East Airport",
    city: "Kursk",
    country: "Russia",
    lat: 51.7505989074707,
    lng: 36.29560089111328,
  },
  {
    id: "LPK",
    name: "Lipetsk Airport",
    city: "Lipetsk",
    country: "Russia",
    lat: 52.70280075073242,
    lng: 39.53779983520508,
  },
  {
    id: "VKT",
    name: "Vorkuta Airport",
    city: "Vorkuta",
    country: "Russia",
    lat: 67.48860168457031,
    lng: 63.993099212646484,
  },
  {
    id: "UUA",
    name: "Bugulma Airport",
    city: "Bugulma",
    country: "Russia",
    lat: 54.63999938964844,
    lng: 52.801700592041016,
  },
  {
    id: "JOK",
    name: "Yoshkar-Ola Airport",
    city: "Yoshkar-Ola",
    country: "Russia",
    lat: 56.700599670410156,
    lng: 47.904701232910156,
  },
  {
    id: "CSY",
    name: "Cheboksary Airport",
    city: "Cheboksary",
    country: "Russia",
    lat: 56.090301513671875,
    lng: 47.3473014831543,
  },
  {
    id: "ULY",
    name: "Ulyanovsk East Airport",
    city: "Ulyanovsk",
    country: "Russia",
    lat: 54.4010009765625,
    lng: 48.80270004272461,
  },
  {
    id: "OSW",
    name: "Orsk Airport",
    city: "Orsk",
    country: "Russia",
    lat: 51.0724983215332,
    lng: 58.59560012817383,
  },
  {
    id: "PEZ",
    name: "Penza Airport",
    city: "Penza",
    country: "Russia",
    lat: 53.110599517822266,
    lng: 45.02109909057617,
  },
  {
    id: "SKX",
    name: "Saransk Airport",
    city: "Saransk",
    country: "Russia",
    lat: 54.12512969970703,
    lng: 45.212257385253906,
  },
  {
    id: "BWO",
    name: "Balakovo Airport",
    city: "Balakovo",
    country: "Russia",
    lat: 51.8582992554,
    lng: 47.7456016541,
  },
  {
    id: "HBX",
    name: "Hubli Airport",
    city: "Hubli",
    country: "India",
    lat: 15.361700058,
    lng: 75.08489990230001,
  },
  {
    id: "KCT",
    name: "Koggala Airport",
    city: "Koggala",
    country: "Sri Lanka",
    lat: 5.993680000305176,
    lng: 80.32029724121094,
  },
  {
    id: "WRZ",
    name: "Weerawila Airport",
    city: "Wirawila",
    country: "Sri Lanka",
    lat: 6.25448989868,
    lng: 81.23519897460001,
  },
  {
    id: "BBM",
    name: "Battambang Airport",
    city: "Battambang",
    country: "Cambodia",
    lat: 13.095600128173828,
    lng: 103.2239990234375,
  },
  {
    id: "SHL",
    name: "Shillong Airport",
    city: "Shillong",
    country: "India",
    lat: 25.70359992980957,
    lng: 91.97869873046875,
  },
  {
    id: "GAU",
    name: "Lokpriya Gopinath Bordoloi International Airport",
    city: "Guwahati",
    country: "India",
    lat: 26.10610008239746,
    lng: 91.58589935302734,
  },
  {
    id: "DMU",
    name: "Dimapur Airport",
    city: "Dimapur",
    country: "India",
    lat: 25.883899688699998,
    lng: 93.77110290530001,
  },
  {
    id: "TEZ",
    name: "Tezpur Airport",
    city: "Tezpur",
    country: "India",
    lat: 26.7091007232666,
    lng: 92.78469848632812,
  },
  {
    id: "BZL",
    name: "Barisal Airport",
    city: "Barisal",
    country: "Bangladesh",
    lat: 22.801000595092773,
    lng: 90.30120086669922,
  },
  {
    id: "HOE",
    name: "Ban Huoeisay Airport",
    city: "Huay Xai",
    country: "Laos",
    lat: 20.2572994232,
    lng: 100.43699646,
  },
  {
    id: "BHR",
    name: "Bharatpur Airport",
    city: "Bharatpur",
    country: "Nepal",
    lat: 27.678101,
    lng: 84.429398,
  },
  {
    id: "BDP",
    name: "Bhadrapur Airport",
    city: "Chandragarhi",
    country: "Nepal",
    lat: 26.5708007812,
    lng: 88.07959747310001,
  },
  {
    id: "MEY",
    name: "Meghauli Airport",
    city: "Meghauli",
    country: "Nepal",
    lat: 27.5774,
    lng: 84.22875,
  },
  {
    id: "KEP",
    name: "Nepalgunj Airport",
    city: "Nepalgunj",
    country: "Nepal",
    lat: 28.103599548339844,
    lng: 81.66699981689453,
  },
  {
    id: "GAN",
    name: "Gan International Airport",
    city: "Gan Island",
    country: "Maldives",
    lat: -0.693342,
    lng: 73.155602,
  },
  {
    id: "HAQ",
    name: "Hanimaadhoo Airport",
    city: "Haa Dhaalu Atoll",
    country: "Maldives",
    lat: 6.744229793548584,
    lng: 73.17050170898438,
  },
  {
    id: "KDO",
    name: "Kadhdhoo Airport",
    city: "Laamu Atoll",
    country: "Maldives",
    lat: 1.8591699600219727,
    lng: 73.52189636230469,
  },
  {
    id: "MAQ",
    name: "Mae Sot Airport",
    city: "Tak",
    country: "Thailand",
    lat: 16.699899673461914,
    lng: 98.54509735107422,
  },
  {
    id: "BMV",
    name: "Buon Ma Thuot Airport",
    city: "Buonmethuot",
    country: "Vietnam",
    lat: 12.668299675,
    lng: 108.120002747,
  },
  {
    id: "HPH",
    name: "Cat Bi International Airport",
    city: "Haiphong",
    country: "Vietnam",
    lat: 20.819400787353516,
    lng: 106.7249984741211,
  },
  {
    id: "CXR",
    name: "Cam Ranh Airport",
    city: "Nha Trang",
    country: "Vietnam",
    lat: 11.998200416564941,
    lng: 109.21900177001953,
  },
  {
    id: "VCS",
    name: "Co Ong Airport",
    city: "Conson",
    country: "Vietnam",
    lat: 8.73183,
    lng: 106.633003,
  },
  {
    id: "VCA",
    name: "Can Tho International Airport",
    city: "Can Tho",
    country: "Vietnam",
    lat: 10.085100174,
    lng: 105.711997986,
  },
  {
    id: "DIN",
    name: "Dien Bien Phu Airport",
    city: "Dienbienphu",
    country: "Vietnam",
    lat: 21.3974990845,
    lng: 103.008003235,
  },
  {
    id: "UIH",
    name: "Phu Cat Airport",
    city: "Phucat",
    country: "Vietnam",
    lat: 13.955,
    lng: 109.042,
  },
  {
    id: "PXU",
    name: "Pleiku Airport",
    city: "Pleiku",
    country: "Vietnam",
    lat: 14.004500389099121,
    lng: 108.01699829101562,
  },
  {
    id: "VII",
    name: "Vinh Airport",
    city: "Vinh",
    country: "Vietnam",
    lat: 18.7376003265,
    lng: 105.67099762,
  },
  {
    id: "BMO",
    name: "Banmaw Airport",
    city: "Banmaw",
    country: "Burma",
    lat: 24.268999099731445,
    lng: 97.24620056152344,
  },
  {
    id: "TVY",
    name: "Dawei Airport",
    city: "Dawei",
    country: "Burma",
    lat: 14.103899955749512,
    lng: 98.20359802246094,
  },
  {
    id: "KAW",
    name: "Kawthoung Airport",
    city: "Kawthoung",
    country: "Burma",
    lat: 10.049300193786621,
    lng: 98.53800201416016,
  },
  {
    id: "LIW",
    name: "Loikaw Airport",
    city: "Loikaw",
    country: "Burma",
    lat: 19.691499710083008,
    lng: 97.21479797363281,
  },
  {
    id: "MNU",
    name: "Mawlamyine Airport",
    city: "Mawlamyine",
    country: "Burma",
    lat: 16.444700241088867,
    lng: 97.66069793701172,
  },
  {
    id: "BSX",
    name: "Pathein Airport",
    city: "Pathein",
    country: "Burma",
    lat: 16.815201,
    lng: 94.7799,
  },
  {
    id: "PKK",
    name: "Pakhokku Airport",
    city: "Pakhokku",
    country: "Burma",
    lat: 21.4043,
    lng: 95.11125,
  },
  {
    id: "SWQ",
    name: "Sumbawa Besar Airport",
    city: "Sumbawa Island",
    country: "Indonesia",
    lat: -8.48904037475586,
    lng: 117.41200256347656,
  },
  {
    id: "TMC",
    name: "Tambolaka Airport",
    city: "Waikabubak-Sumba Island",
    country: "Indonesia",
    lat: -9.40972,
    lng: 119.244003,
  },
  {
    id: "BUI",
    name: "Bokondini Airport",
    city: "Bokondini-Papua Island",
    country: "Indonesia",
    lat: -3.6822,
    lng: 138.6755,
  },
  {
    id: "SEH",
    name: "Senggeh Airport",
    city: "Senggeh-Papua Island",
    country: "Indonesia",
    lat: -3.45,
    lng: 140.779,
  },
  {
    id: "TJS",
    name: "Tanjung Harapan Airport",
    city: "Tanjung Selor-Borneo Island",
    country: "Indonesia",
    lat: 2.83583333333,
    lng: 117.373611111,
  },
  {
    id: "DTD",
    name: "Datadawai Airport",
    city: "Datadawai-Borneo Island",
    country: "Indonesia",
    lat: 0.8106,
    lng: 114.5306,
  },
  {
    id: "BEJ",
    name: "Kalimarau Airport",
    city: "Tanjung Redep-Borneo Island",
    country: "Indonesia",
    lat: 2.1555,
    lng: 117.431999,
  },
  {
    id: "TJG",
    name: "Warukin Airport",
    city: "Tanjung-Borneo Island",
    country: "Indonesia",
    lat: -2.21655988693,
    lng: 115.435997009,
  },
  {
    id: "SMQ",
    name: "Sampit(Hasan) Airport",
    city: "Sampit-Borneo Island",
    country: "Indonesia",
    lat: -2.49919009209,
    lng: 112.974998474,
  },
  {
    id: "LUV",
    name: "Dumatumbun Airport",
    city: "Langgur-Kei Islands",
    country: "Indonesia",
    lat: -5.661620140075684,
    lng: 132.7310028076172,
  },
  {
    id: "ARD",
    name: "Mali Airport",
    city: "Alor Island",
    country: "Indonesia",
    lat: -8.132340431213379,
    lng: 124.59700012207031,
  },
  {
    id: "BLG",
    name: "Belaga Airport",
    city: "Belaga",
    country: "Malaysia",
    lat: 2.65000009537,
    lng: 113.766998291,
  },
  {
    id: "LGL",
    name: "Long Lellang Airport",
    city: "Long Datih",
    country: "Malaysia",
    lat: 3.4210000038099997,
    lng: 115.153999329,
  },
  {
    id: "ODN",
    name: "Long Seridan Airport",
    city: "Long Seridan",
    country: "Malaysia",
    lat: 3.9670000076293945,
    lng: 115.05000305175781,
  },
  {
    id: "MKM",
    name: "Mukah Airport",
    city: "Mukah",
    country: "Malaysia",
    lat: 2.90639,
    lng: 112.080002,
  },
  {
    id: "BKM",
    name: "Bakalalan Airport",
    city: "Bakalalan",
    country: "Malaysia",
    lat: 3.9739999771118164,
    lng: 115.61799621582031,
  },
  {
    id: "LWY",
    name: "Lawas Airport",
    city: "Lawas",
    country: "Malaysia",
    lat: 4.84917,
    lng: 115.407997,
  },
  {
    id: "BBN",
    name: "Bario Airport",
    city: "Bario",
    country: "Malaysia",
    lat: 3.7338900566101074,
    lng: 115.47899627685547,
  },
  {
    id: "TMG",
    name: "Tomanggong Airport",
    city: "Tomanggong",
    country: "Malaysia",
    lat: 5.40257,
    lng: 118.65763,
  },
  {
    id: "KUD",
    name: "Kudat Airport",
    city: "Kudat",
    country: "Malaysia",
    lat: 6.922500133514404,
    lng: 116.83599853515625,
  },
  {
    id: "TKG",
    name: "Radin Inten II (Branti) Airport",
    city: "Bandar Lampung-Sumatra Island",
    country: "Indonesia",
    lat: -5.240556,
    lng: 105.175556,
  },
  {
    id: "HLP",
    name: "Halim Perdanakusuma International Airport",
    city: "Jakarta",
    country: "Indonesia",
    lat: -6.266610145568848,
    lng: 106.89099884033203,
  },
  {
    id: "NTX",
    name: "Ranai Airport",
    city: "Ranai-Natuna Besar Island",
    country: "Indonesia",
    lat: 3.90871,
    lng: 108.388,
  },
  {
    id: "PSU",
    name: "Pangsuma Airport",
    city: "Putussibau-Borneo Island",
    country: "Indonesia",
    lat: 0.8355780243873596,
    lng: 112.93699645996094,
  },
  {
    id: "SQG",
    name: "Sintang(Susilo) Airport",
    city: "Sintang-Borneo Island",
    country: "Indonesia",
    lat: 0.06361900269985199,
    lng: 111.4729995727539,
  },
  {
    id: "PDO",
    name: "Pendopo Airport",
    city: "Talang Gudang-Sumatra Island",
    country: "Indonesia",
    lat: -3.2860701084136963,
    lng: 103.87999725341797,
  },
  {
    id: "LSW",
    name: "Malikus Saleh Airport",
    city: "Lhok Seumawe-Sumatra Island",
    country: "Indonesia",
    lat: 5.226679801940918,
    lng: 96.95030212402344,
  },
  {
    id: "PKG",
    name: "Pulau Pangkor Airport",
    city: "Pangkor Island",
    country: "Malaysia",
    lat: 4.244719982147217,
    lng: 100.5530014038086,
  },
  {
    id: "LBW",
    name: "Long Bawan Airport",
    city: "Long Bawan-Borneo Island",
    country: "Indonesia",
    lat: 3.9028,
    lng: 115.6921,
  },
  {
    id: "NNX",
    name: "Nunukan Airport",
    city: "Nunukan-Nunukan Island",
    country: "Indonesia",
    lat: 4.13333333333,
    lng: 117.666666667,
  },
  {
    id: "LPU",
    name: "Long Apung Airport",
    city: "Long Apung-Borneo Island",
    country: "Indonesia",
    lat: 1.704486,
    lng: 114.970297,
  },
  {
    id: "ALH",
    name: "Albany Airport",
    city: "Albany",
    country: "Australia",
    lat: -34.94329833984375,
    lng: 117.80899810791016,
  },
  {
    id: "GYL",
    name: "Argyle Airport",
    city: "Argyle",
    country: "Australia",
    lat: -16.6369,
    lng: 128.451004,
  },
  {
    id: "AUU",
    name: "Aurukun Airport",
    city: "Aurukun",
    country: "Australia",
    lat: -13.354067,
    lng: 141.72065,
  },
  {
    id: "BCI",
    name: "Barcaldine Airport",
    city: "Barcaldine",
    country: "Australia",
    lat: -23.5652999878,
    lng: 145.307006836,
  },
  {
    id: "BDD",
    name: "Badu Island Airport",
    city: "Badu Island",
    country: "Australia",
    lat: -10.149999618499999,
    lng: 142.1734,
  },
  {
    id: "BVI",
    name: "Birdsville Airport",
    city: "Birdsville",
    country: "Australia",
    lat: -25.897499084472656,
    lng: 139.34800720214844,
  },
  {
    id: "BHQ",
    name: "Broken Hill Airport",
    city: "Broken Hill",
    country: "Australia",
    lat: -32.0013999939,
    lng: 141.472000122,
  },
  {
    id: "HTI",
    name: "Hamilton Island Airport",
    city: "Hamilton Island",
    country: "Australia",
    lat: -20.3581008911,
    lng: 148.95199585,
  },
  {
    id: "BEU",
    name: "Bedourie Airport",
    city: "Bedourie",
    country: "Australia",
    lat: -24.346099853515625,
    lng: 139.4600067138672,
  },
  {
    id: "BRK",
    name: "Bourke Airport",
    city: "Bourke",
    country: "Australia",
    lat: -30.039199829101562,
    lng: 145.95199584960938,
  },
  {
    id: "BUC",
    name: "Burketown Airport",
    city: "Burketown",
    country: "Australia",
    lat: -17.748600006103516,
    lng: 139.53399658203125,
  },
  {
    id: "GIC",
    name: "Boigu Airport",
    city: "Boigu",
    country: "Australia",
    lat: -9.23278045654,
    lng: 142.218002319,
  },
  {
    id: "OKY",
    name: "Oakey Airport",
    city: "Oakey",
    country: "Australia",
    lat: -27.411399841308594,
    lng: 151.73500061035156,
  },
  {
    id: "BQL",
    name: "Boulia Airport",
    city: "Boulia",
    country: "Australia",
    lat: -22.913299560546875,
    lng: 139.89999389648438,
  },
  {
    id: "BHS",
    name: "Bathurst Airport",
    city: "Bathurst",
    country: "Australia",
    lat: -33.4094009399,
    lng: 149.651992798,
  },
  {
    id: "BLT",
    name: "Blackwater Airport",
    city: "Blackwater",
    country: "Australia",
    lat: -23.603099822998047,
    lng: 148.8070068359375,
  },
  {
    id: "CVQ",
    name: "Carnarvon Airport",
    city: "Carnarvon",
    country: "Australia",
    lat: -24.880211,
    lng: 113.67174,
  },
  {
    id: "CAZ",
    name: "Cobar Airport",
    city: "Cobar",
    country: "Australia",
    lat: -31.538299560546875,
    lng: 145.79400634765625,
  },
  {
    id: "CPD",
    name: "Coober Pedy Airport",
    city: "Coober Pedy",
    country: "Australia",
    lat: -29.040000915527344,
    lng: 134.7209930419922,
  },
  {
    id: "CNC",
    name: "Coconut Island Airport",
    city: "Coconut Island",
    country: "Australia",
    lat: -10.050000190734863,
    lng: 143.07000732421875,
  },
  {
    id: "CNJ",
    name: "Cloncurry Airport",
    city: "Cloncurry",
    country: "Australia",
    lat: -20.668600082399998,
    lng: 140.503997803,
  },
  {
    id: "CED",
    name: "Ceduna Airport",
    city: "Ceduna",
    country: "Australia",
    lat: -32.13059997558594,
    lng: 133.7100067138672,
  },
  {
    id: "CTN",
    name: "Cooktown Airport",
    city: "Cooktown",
    country: "Australia",
    lat: -15.444700241088867,
    lng: 145.1840057373047,
  },
  {
    id: "CMA",
    name: "Cunnamulla Airport",
    city: "Cunnamulla",
    country: "Australia",
    lat: -28.030000686645508,
    lng: 145.6219940185547,
  },
  {
    id: "CNB",
    name: "Coonamble Airport",
    city: "Coonamble",
    country: "Australia",
    lat: -30.983299255371094,
    lng: 148.37600708007812,
  },
  {
    id: "CUQ",
    name: "Coen Airport",
    city: "Coen",
    country: "Australia",
    lat: -13.761133,
    lng: 143.113311,
  },
  {
    id: "OOM",
    name: "Cooma Snowy Mountains Airport",
    city: "Cooma",
    country: "Australia",
    lat: -36.3005981445,
    lng: 148.973999023,
  },
  {
    id: "DMD",
    name: "Doomadgee Airport",
    city: "Doomadgee",
    country: "Australia",
    lat: -17.9403,
    lng: 138.822006,
  },
  {
    id: "NLF",
    name: "Darnley Island Airport",
    city: "Darnley Island",
    country: "Australia",
    lat: -9.583330154418945,
    lng: 143.76699829101562,
  },
  {
    id: "DPO",
    name: "Devonport Airport",
    city: "Devonport",
    country: "Australia",
    lat: -41.1697006226,
    lng: 146.429992676,
  },
  {
    id: "ELC",
    name: "Elcho Island Airport",
    city: "Elcho Island",
    country: "Australia",
    lat: -12.019399642899998,
    lng: 135.570999146,
  },
  {
    id: "EPR",
    name: "Esperance Airport",
    city: "Esperance",
    country: "Australia",
    lat: -33.684399,
    lng: 121.822998,
  },
  {
    id: "FLS",
    name: "Flinders Island Airport",
    city: "Flinders Island",
    country: "Australia",
    lat: -40.0917015076,
    lng: 147.992996216,
  },
  {
    id: "GET",
    name: "Geraldton Airport",
    city: "Geraldton",
    country: "Australia",
    lat: -28.796101,
    lng: 114.707001,
  },
  {
    id: "GLT",
    name: "Gladstone Airport",
    city: "Gladstone",
    country: "Australia",
    lat: -23.869699,
    lng: 151.223007,
  },
  {
    id: "GTE",
    name: "Groote Eylandt Airport",
    city: "Groote Eylandt",
    country: "Australia",
    lat: -13.975000381500001,
    lng: 136.460006714,
  },
  {
    id: "GFF",
    name: "Griffith Airport",
    city: "Griffith",
    country: "Australia",
    lat: -34.2508010864,
    lng: 146.067001343,
  },
  {
    id: "HID",
    name: "Horn Island Airport",
    city: "Horn Island",
    country: "Australia",
    lat: -10.586400032,
    lng: 142.289993286,
  },
  {
    id: "HOK",
    name: "Hooker Creek Airport",
    city: "Hooker Creek",
    country: "Australia",
    lat: -18.3367004395,
    lng: 130.638000488,
  },
  {
    id: "MHU",
    name: "Mount Hotham Airport",
    city: "Mount Hotham",
    country: "Australia",
    lat: -37.0475006104,
    lng: 147.333999634,
  },
  {
    id: "HGD",
    name: "Hughenden Airport",
    city: "Hughenden",
    country: "Australia",
    lat: -20.815000534057617,
    lng: 144.22500610351562,
  },
  {
    id: "JCK",
    name: "Julia Creek Airport",
    city: "Julia Creek",
    country: "Australia",
    lat: -20.66830062866211,
    lng: 141.72300720214844,
  },
  {
    id: "KAX",
    name: "Kalbarri Airport",
    city: "Kalbarri",
    country: "Australia",
    lat: -27.692813,
    lng: 114.259169,
  },
  {
    id: "KNS",
    name: "King Island Airport",
    city: "King Island",
    country: "Australia",
    lat: -39.877498626708984,
    lng: 143.8780059814453,
  },
  {
    id: "KFG",
    name: "Kalkgurung Airport",
    city: "Kalkgurung",
    country: "Australia",
    lat: -17.431900024414062,
    lng: 130.80799865722656,
  },
  {
    id: "KRB",
    name: "Karumba Airport",
    city: "Karumba",
    country: "Australia",
    lat: -17.45669937133789,
    lng: 140.8300018310547,
  },
  {
    id: "KWM",
    name: "Kowanyama Airport",
    city: "Kowanyama",
    country: "Australia",
    lat: -15.485600471496582,
    lng: 141.75100708007812,
  },
  {
    id: "KUG",
    name: "Kubin Airport",
    city: "Kubin",
    country: "Australia",
    lat: -10.225000381500001,
    lng: 142.218002319,
  },
  {
    id: "LNO",
    name: "Leonora Airport",
    city: "Leonora",
    country: "Australia",
    lat: -28.87809944152832,
    lng: 121.31500244140625,
  },
  {
    id: "LEL",
    name: "Lake Evella Airport",
    city: "Lake Evella",
    country: "Australia",
    lat: -12.498900413513184,
    lng: 135.80599975585938,
  },
  {
    id: "LDH",
    name: "Lord Howe Island Airport",
    city: "Lord Howe Island",
    country: "Australia",
    lat: -31.5382995605,
    lng: 159.07699585,
  },
  {
    id: "IRG",
    name: "Lockhart River Airport",
    city: "Lockhart River",
    country: "Australia",
    lat: -12.7869,
    lng: 143.304993,
  },
  {
    id: "LSY",
    name: "Lismore Airport",
    city: "Lismore",
    country: "Australia",
    lat: -28.8302993774,
    lng: 153.259994507,
  },
  {
    id: "LHG",
    name: "Lightning Ridge Airport",
    city: "Lightning Ridge",
    country: "Australia",
    lat: -29.45669937133789,
    lng: 147.98399353027344,
  },
  {
    id: "LRE",
    name: "Longreach Airport",
    city: "Longreach",
    country: "Australia",
    lat: -23.4342002869,
    lng: 144.279998779,
  },
  {
    id: "LER",
    name: "Leinster Airport",
    city: "Leinster",
    country: "Australia",
    lat: -27.843299865722656,
    lng: 120.7030029296875,
  },
  {
    id: "LVO",
    name: "Laverton Airport",
    city: "Laverton",
    country: "Australia",
    lat: -28.61359977722168,
    lng: 122.42400360107422,
  },
  {
    id: "UBB",
    name: "Mabuiag Island Airport",
    city: "Mabuiag Island",
    country: "Australia",
    lat: -9.949999809265137,
    lng: 142.18299865722656,
  },
  {
    id: "MKR",
    name: "Meekatharra Airport",
    city: "Meekatharra",
    country: "Australia",
    lat: -26.6117000579834,
    lng: 118.5479965209961,
  },
  {
    id: "MIM",
    name: "Merimbula Airport",
    city: "Merimbula",
    country: "Australia",
    lat: -36.9085998535,
    lng: 149.901000977,
  },
  {
    id: "MGT",
    name: "Milingimbi Airport",
    city: "Milingimbi",
    country: "Australia",
    lat: -12.0944004059,
    lng: 134.893997192,
  },
  {
    id: "MNG",
    name: "Maningrida Airport",
    city: "Maningrida",
    country: "Australia",
    lat: -12.0560998917,
    lng: 134.23399353,
  },
  {
    id: "MCV",
    name: "McArthur River Mine Airport",
    city: "McArthur River Mine",
    country: "Australia",
    lat: -16.4424991608,
    lng: 136.083999634,
  },
  {
    id: "MQL",
    name: "Mildura Airport",
    city: "Mildura",
    country: "Australia",
    lat: -34.229198455799995,
    lng: 142.085998535,
  },
  {
    id: "MMG",
    name: "Mount Magnet Airport",
    city: "Mount Magnet",
    country: "Australia",
    lat: -28.116100311279297,
    lng: 117.84200286865234,
  },
  {
    id: "MRZ",
    name: "Moree Airport",
    city: "Moree",
    country: "Australia",
    lat: -29.498899459799997,
    lng: 149.845001221,
  },
  {
    id: "MOV",
    name: "Moranbah Airport",
    city: "Moranbah",
    country: "Australia",
    lat: -22.057800293,
    lng: 148.07699585,
  },
  {
    id: "MYA",
    name: "Moruya Airport",
    city: "Moruya",
    country: "Australia",
    lat: -35.8978004456,
    lng: 150.143997192,
  },
  {
    id: "MGB",
    name: "Mount Gambier Airport",
    city: "Mount Gambier",
    country: "Australia",
    lat: -37.745601654052734,
    lng: 140.78500366210938,
  },
  {
    id: "ONG",
    name: "Mornington Island Airport",
    city: "Mornington Island",
    country: "Australia",
    lat: -16.662500381469727,
    lng: 139.17799377441406,
  },
  {
    id: "MYI",
    name: "Murray Island Airport",
    city: "Murray Island",
    country: "Australia",
    lat: -9.91666984558,
    lng: 144.054992676,
  },
  {
    id: "MBH",
    name: "Maryborough Airport",
    city: "Maryborough",
    country: "Australia",
    lat: -25.5133,
    lng: 152.714996,
  },
  {
    id: "NRA",
    name: "Narrandera Airport",
    city: "Narrandera",
    country: "Australia",
    lat: -34.7022018433,
    lng: 146.511993408,
  },
  {
    id: "NAA",
    name: "Narrabri Airport",
    city: "Narrabri",
    country: "Australia",
    lat: -30.3192005157,
    lng: 149.82699585,
  },
  {
    id: "NTN",
    name: "Normanton Airport",
    city: "Normanton",
    country: "Australia",
    lat: -17.68409,
    lng: 141.069664,
  },
  {
    id: "ZNE",
    name: "Newman Airport",
    city: "Newman",
    country: "Australia",
    lat: -23.417800903299998,
    lng: 119.803001404,
  },
  {
    id: "OLP",
    name: "Olympic Dam Airport",
    city: "Olympic Dam",
    country: "Australia",
    lat: -30.485000610399997,
    lng: 136.876998901,
  },
  {
    id: "PUG",
    name: "Port Augusta Airport",
    city: "Argyle",
    country: "Australia",
    lat: -32.506900787353516,
    lng: 137.7169952392578,
  },
  {
    id: "PMK",
    name: "Palm Island Airport",
    city: "Palm Island",
    country: "Australia",
    lat: -18.755300521850586,
    lng: 146.58099365234375,
  },
  {
    id: "PBO",
    name: "Paraburdoo Airport",
    city: "Paraburdoo",
    country: "Australia",
    lat: -23.1711006165,
    lng: 117.745002747,
  },
  {
    id: "CCK",
    name: "Cocos (Keeling) Islands Airport",
    city: "Cocos Keeling Island",
    country: "Cocos (Keeling) Islands",
    lat: -12.1883001328,
    lng: 96.8339004517,
  },
  {
    id: "GOV",
    name: "Gove Airport",
    city: "Gove",
    country: "Australia",
    lat: -12.269399642899998,
    lng: 136.817993164,
  },
  {
    id: "PKE",
    name: "Parkes Airport",
    city: "Parkes",
    country: "Australia",
    lat: -33.131401062,
    lng: 148.238998413,
  },
  {
    id: "PLO",
    name: "Port Lincoln Airport",
    city: "Port Lincoln",
    country: "Australia",
    lat: -34.6053009033,
    lng: 135.880004883,
  },
  {
    id: "EDR",
    name: "Pormpuraaw Airport",
    city: "Pormpuraaw",
    country: "Australia",
    lat: -14.896451,
    lng: 141.60908,
  },
  {
    id: "PQQ",
    name: "Port Macquarie Airport",
    city: "Port Macquarie",
    country: "Australia",
    lat: -31.4358005524,
    lng: 152.863006592,
  },
  {
    id: "PTJ",
    name: "Portland Airport",
    city: "Portland",
    country: "Australia",
    lat: -38.31809997558594,
    lng: 141.4709930419922,
  },
  {
    id: "ULP",
    name: "Quilpie Airport",
    city: "Quilpie",
    country: "Australia",
    lat: -26.612199783325195,
    lng: 144.2530059814453,
  },
  {
    id: "RAM",
    name: "Ramingining Airport",
    city: "Ramingining",
    country: "Australia",
    lat: -12.356399536132812,
    lng: 134.8979949951172,
  },
  {
    id: "RMA",
    name: "Roma Airport",
    city: "Roma",
    country: "Australia",
    lat: -26.545000076300003,
    lng: 148.774993896,
  },
  {
    id: "SGO",
    name: "St George Airport",
    city: "St George",
    country: "Australia",
    lat: -28.049699783325195,
    lng: 148.59500122070312,
  },
  {
    id: "MJK",
    name: "Shark Bay Airport",
    city: "Shark Bay",
    country: "Australia",
    lat: -25.8938999176,
    lng: 113.577003479,
  },
  {
    id: "SBR",
    name: "Saibai Island Airport",
    city: "Saibai Island",
    country: "Australia",
    lat: -9.378330230710002,
    lng: 142.625,
  },
  {
    id: "SRN",
    name: "Strahan Airport",
    city: "Strahan",
    country: "Australia",
    lat: -42.154998779296875,
    lng: 145.29200744628906,
  },
  {
    id: "XTG",
    name: "Thargomindah Airport",
    city: "Thargomindah",
    country: "Australia",
    lat: -27.986400604248047,
    lng: 143.81100463867188,
  },
  {
    id: "TCA",
    name: "Tennant Creek Airport",
    city: "Tennant Creek",
    country: "Australia",
    lat: -19.6343994140625,
    lng: 134.18299865722656,
  },
  {
    id: "VCD",
    name: "Victoria River Downs Airport",
    city: "Victoria River Downs",
    country: "Australia",
    lat: -16.402124404907227,
    lng: 131.00497436523438,
  },
  {
    id: "SYU",
    name: "Warraber Island Airport",
    city: "Sue Islet",
    country: "Australia",
    lat: -10.20829963684082,
    lng: 142.8249969482422,
  },
  {
    id: "WNR",
    name: "Windorah Airport",
    city: "Windorah",
    country: "Australia",
    lat: -25.41309928894043,
    lng: 142.66700744628906,
  },
  {
    id: "WYA",
    name: "Whyalla Airport",
    city: "Whyalla",
    country: "Australia",
    lat: -33.05889892578125,
    lng: 137.51400756835938,
  },
  {
    id: "WUN",
    name: "Wiluna Airport",
    city: "Wiluna",
    country: "Australia",
    lat: -26.629199981689453,
    lng: 120.22100067138672,
  },
  {
    id: "WOL",
    name: "Wollongong Airport",
    city: "Wollongong",
    country: "Australia",
    lat: -34.561100006103516,
    lng: 150.78900146484375,
  },
  {
    id: "WIN",
    name: "Winton Airport",
    city: "Winton",
    country: "Australia",
    lat: -22.36359977722168,
    lng: 143.08599853515625,
  },
  {
    id: "BWT",
    name: "Wynyard Airport",
    city: "Burnie",
    country: "Australia",
    lat: -40.9989013671875,
    lng: 145.7310028076172,
  },
  {
    id: "OKR",
    name: "Yorke Island Airport",
    city: "Yorke Island",
    country: "Australia",
    lat: -9.752801,
    lng: 143.405673,
  },
  {
    id: "XMY",
    name: "Yam Island Airport",
    city: "Yam Island",
    country: "Australia",
    lat: -9.90110969543457,
    lng: 142.7760009765625,
  },
  {
    id: "NAY",
    name: "Beijing Nanyuan Airport",
    city: "Beijing",
    country: "China",
    lat: 39.782798767089844,
    lng: 116.38800048828125,
  },
  {
    id: "CIF",
    name: "Chifeng Airport",
    city: "Chifeng",
    country: "China",
    lat: 42.23500061035156,
    lng: 118.90799713134766,
  },
  {
    id: "CIH",
    name: "Changzhi Airport",
    city: "Changzhi",
    country: "China",
    lat: 36.247501,
    lng: 113.125999,
  },
  {
    id: "DAT",
    name: "Datong Airport",
    city: "Datong",
    country: "China",
    lat: 40.060299,
    lng: 113.482002,
  },
  {
    id: "HET",
    name: "Baita International Airport",
    city: "Hohhot",
    country: "China",
    lat: 40.851398,
    lng: 111.823997,
  },
  {
    id: "BAV",
    name: "Baotou Airport",
    city: "Baotou",
    country: "China",
    lat: 40.560001373291016,
    lng: 109.99700164794922,
  },
  {
    id: "SJW",
    name: "Shijiazhuang Daguocun International Airport",
    city: "Shijiazhuang",
    country: "China",
    lat: 38.28070068359375,
    lng: 114.6969985961914,
  },
  {
    id: "TGO",
    name: "Tongliao Airport",
    city: "Tongliao",
    country: "China",
    lat: 43.556702,
    lng: 122.199997,
  },
  {
    id: "HLH",
    name: "Ulanhot Airport",
    city: "Ulanhot",
    country: "China",
    lat: 46.195333,
    lng: 122.008333,
  },
  {
    id: "XIL",
    name: "Xilinhot Airport",
    city: "Xilinhot",
    country: "China",
    lat: 43.91559982299805,
    lng: 115.96399688720703,
  },
  {
    id: "BHY",
    name: "Beihai Airport",
    city: "Beihai",
    country: "China",
    lat: 21.5394,
    lng: 109.293999,
  },
  {
    id: "CGD",
    name: "Changde Airport",
    city: "Changde",
    country: "China",
    lat: 28.9188995361,
    lng: 111.63999939,
  },
  {
    id: "DYG",
    name: "Dayong Airport",
    city: "Dayong",
    country: "China",
    lat: 29.1028,
    lng: 110.443001,
  },
  {
    id: "MXZ",
    name: "Meixian Airport",
    city: "Meixian",
    country: "China",
    lat: 24.350000381469727,
    lng: 116.13300323486328,
  },
  {
    id: "ZUH",
    name: "Zhuhai Jinwan Airport",
    city: "Zhuhai",
    country: "China",
    lat: 22.006399,
    lng: 113.375999,
  },
  {
    id: "LZH",
    name: "Liuzhou Bailian Airport",
    city: "Liuzhou",
    country: "China",
    lat: 24.2075,
    lng: 109.390999,
  },
  {
    id: "ZHA",
    name: "Zhanjiang Airport",
    city: "Zhanjiang",
    country: "China",
    lat: 21.214399,
    lng: 110.358002,
  },
  {
    id: "ENH",
    name: "Enshi Airport",
    city: "Enshi",
    country: "China",
    lat: 30.3202991486,
    lng: 109.48500061,
  },
  {
    id: "NNY",
    name: "Nanyang Jiangying Airport",
    city: "Nanyang",
    country: "China",
    lat: 32.980801,
    lng: 112.614998,
  },
  {
    id: "XFN",
    name: "Xiangyang Liuji Airport",
    city: "Xiangfan",
    country: "China",
    lat: 32.1506,
    lng: 112.291,
  },
  {
    id: "YIH",
    name: "Yichang Sanxia Airport",
    city: "Yichang",
    country: "China",
    lat: 30.55655,
    lng: 111.479988,
  },
  {
    id: "AKA",
    name: "Ankang Wulipu Airport",
    city: "Ankang",
    country: "China",
    lat: 32.708099,
    lng: 108.931,
  },
  {
    id: "GOQ",
    name: "Golmud Airport",
    city: "Golmud",
    country: "China",
    lat: 36.4006,
    lng: 94.786102,
  },
  {
    id: "HZG",
    name: "Hanzhong Chenggu Airport",
    city: "Hanzhong",
    country: "China",
    lat: 33.134136,
    lng: 107.206014,
  },
  {
    id: "IQN",
    name: "Qingyang Airport",
    city: "Qingyang",
    country: "China",
    lat: 35.799702,
    lng: 107.602997,
  },
  {
    id: "XNN",
    name: "Xining Caojiabu Airport",
    city: "Xining",
    country: "China",
    lat: 36.5275,
    lng: 102.042999,
  },
  {
    id: "ENY",
    name: "Yan'an Ershilipu Airport",
    city: "Yan'an",
    country: "China",
    lat: 36.636902,
    lng: 109.554001,
  },
  {
    id: "UYN",
    name: "Yulin Yuyang Airport",
    city: "Yulin",
    country: "China",
    lat: 38.35971,
    lng: 109.590927,
  },
  {
    id: "AVK",
    name: "Arvaikheer Airport",
    city: "Arvaikheer",
    country: "Mongolia",
    lat: 46.250301361083984,
    lng: 102.802001953125,
  },
  {
    id: "LTI",
    name: "Altai Airport",
    city: "Altai",
    country: "Mongolia",
    lat: 46.376399993896484,
    lng: 96.22109985351562,
  },
  {
    id: "BYN",
    name: "Bayankhongor Airport",
    city: "Bayankhongor",
    country: "Mongolia",
    lat: 46.163299560546875,
    lng: 100.7040023803711,
  },
  {
    id: "DLZ",
    name: "Dalanzadgad Airport",
    city: "Dalanzadgad",
    country: "Mongolia",
    lat: 43.59170150756836,
    lng: 104.43000030517578,
  },
  {
    id: "HVD",
    name: "Khovd Airport",
    city: "Khovd",
    country: "Mongolia",
    lat: 47.9541015625,
    lng: 91.6281967163086,
  },
  {
    id: "MXV",
    name: "Mörön Airport",
    city: "Muren",
    country: "Mongolia",
    lat: 49.663299560546875,
    lng: 100.0989990234375,
  },
  {
    id: "DIG",
    name: "Diqing Airport",
    city: "Shangri-La",
    country: "China",
    lat: 27.7936,
    lng: 99.6772,
  },
  {
    id: "LUM",
    name: "Mangshi Airport",
    city: "Luxi",
    country: "China",
    lat: 24.4011,
    lng: 98.5317,
  },
  {
    id: "SYM",
    name: "Pu'er Simao Airport",
    city: "Simao",
    country: "China",
    lat: 22.793301,
    lng: 100.959,
  },
  {
    id: "ZAT",
    name: "Zhaotong Airport",
    city: "Zhaotong",
    country: "China",
    lat: 27.325599670410156,
    lng: 103.75499725341797,
  },
  {
    id: "KOW",
    name: "Ganzhou Airport",
    city: "Ganzhou",
    country: "China",
    lat: 25.853333,
    lng: 114.778889,
  },
  {
    id: "JDZ",
    name: "Jingdezhen Airport",
    city: "Jingdezhen",
    country: "China",
    lat: 29.3386001587,
    lng: 117.176002502,
  },
  {
    id: "JIU",
    name: "Jiujiang Lushan Airport",
    city: "Jiujiang",
    country: "China",
    lat: 29.476944,
    lng: 115.801111,
  },
  {
    id: "JUZ",
    name: "Quzhou Airport",
    city: "Quzhou",
    country: "China",
    lat: 28.965799,
    lng: 118.899002,
  },
  {
    id: "LYG",
    name: "Lianyungang Airport",
    city: "Lianyungang",
    country: "China",
    lat: 34.571667,
    lng: 118.873611,
  },
  {
    id: "HYN",
    name: "Huangyan Luqiao Airport",
    city: "Huangyan",
    country: "China",
    lat: 28.56220054626465,
    lng: 121.42900085449219,
  },
  {
    id: "LYI",
    name: "Shubuling Airport",
    city: "Linyi",
    country: "China",
    lat: 35.04610061645508,
    lng: 118.41200256347656,
  },
  {
    id: "JJN",
    name: "Quanzhou Jinjiang International Airport",
    city: "Quanzhou",
    country: "China",
    lat: 24.7964,
    lng: 118.589996,
  },
  {
    id: "TXN",
    name: "Tunxi International Airport",
    city: "Huangshan",
    country: "China",
    lat: 29.733299255371094,
    lng: 118.25599670410156,
  },
  {
    id: "WEF",
    name: "Weifang Airport",
    city: "Weifang",
    country: "China",
    lat: 36.646702,
    lng: 119.119003,
  },
  {
    id: "WEH",
    name: "Weihai Airport",
    city: "Weihai",
    country: "China",
    lat: 37.18709945678711,
    lng: 122.22899627685547,
  },
  {
    id: "WUX",
    name: "Sunan Shuofang International Airport",
    city: "Wuxi",
    country: "China",
    lat: 31.494400024399997,
    lng: 120.429000854,
  },
  {
    id: "WUS",
    name: "Nanping Wuyishan Airport",
    city: "Wuyishan",
    country: "China",
    lat: 27.7019,
    lng: 118.000999,
  },
  {
    id: "WNZ",
    name: "Wenzhou Longwan International Airport",
    city: "Wenzhou",
    country: "China",
    lat: 27.912201,
    lng: 120.851997,
  },
  {
    id: "YNZ",
    name: "Yancheng Airport",
    city: "Yancheng",
    country: "China",
    lat: 33.425833,
    lng: 120.203056,
  },
  {
    id: "YIW",
    name: "Yiwu Airport",
    city: "Yiwu",
    country: "China",
    lat: 29.3446998596,
    lng: 120.031997681,
  },
  {
    id: "HSN",
    name: "Zhoushan Airport",
    city: "Zhoushan",
    country: "China",
    lat: 29.9342002869,
    lng: 122.361999512,
  },
  {
    id: "BPX",
    name: "Qamdo Bangda Airport",
    city: "Bangda",
    country: "China",
    lat: 30.553600311279297,
    lng: 97.1082992553711,
  },
  {
    id: "DAX",
    name: "Dachuan Airport",
    city: "Dazhou",
    country: "China",
    lat: 31.1302,
    lng: 107.4295,
  },
  {
    id: "GYS",
    name: "Guangyuan Airport",
    city: "Guangyuan",
    country: "China",
    lat: 32.3911018371582,
    lng: 105.7020034790039,
  },
  {
    id: "LZO",
    name: "Luzhou Airport",
    city: "Luzhou",
    country: "China",
    lat: 28.85219955444336,
    lng: 105.39299774169922,
  },
  {
    id: "MIG",
    name: "Mianyang Airport",
    city: "Mianyang",
    country: "China",
    lat: 31.4281005859375,
    lng: 104.74099731445312,
  },
  {
    id: "NAO",
    name: "Nanchong Airport",
    city: "Nanchong",
    country: "China",
    lat: 30.79545,
    lng: 106.1626,
  },
  {
    id: "LZY",
    name: "Nyingchi Airport",
    city: "Nyingchi",
    country: "China",
    lat: 29.303300857543945,
    lng: 94.33529663085938,
  },
  {
    id: "WXN",
    name: "Wanxian Airport",
    city: "Wanxian",
    country: "China",
    lat: 30.8017,
    lng: 108.433,
  },
  {
    id: "AKU",
    name: "Aksu Airport",
    city: "Aksu",
    country: "China",
    lat: 41.262501,
    lng: 80.291702,
  },
  {
    id: "IQM",
    name: "Qiemo Yudu Airport",
    city: "Qiemo",
    country: "China",
    lat: 38.233611,
    lng: 85.465556,
  },
  {
    id: "KCA",
    name: "Kuqa Airport",
    city: "Kuqa",
    country: "China",
    lat: 41.677856,
    lng: 82.872917,
  },
  {
    id: "KRL",
    name: "Korla Airport",
    city: "Korla",
    country: "China",
    lat: 41.69779968261719,
    lng: 86.12889862060547,
  },
  {
    id: "KRY",
    name: "Karamay Airport",
    city: "Karamay",
    country: "China",
    lat: 45.46655,
    lng: 84.9527,
  },
  {
    id: "YIN",
    name: "Yining Airport",
    city: "Yining",
    country: "China",
    lat: 43.955799,
    lng: 81.330299,
  },
  {
    id: "HEK",
    name: "Heihe Airport",
    city: "Heihe",
    country: "China",
    lat: 50.1716209371,
    lng: 127.308883667,
  },
  {
    id: "JMU",
    name: "Jiamusi Airport",
    city: "Jiamusi",
    country: "China",
    lat: 46.84339904789999,
    lng: 130.464996338,
  },
  {
    id: "JNZ",
    name: "Jinzhou Airport",
    city: "Jinzhou",
    country: "China",
    lat: 41.10139846801758,
    lng: 121.06199645996094,
  },
  {
    id: "NDG",
    name: "Qiqihar Sanjiazi Airport",
    city: "Qiqihar",
    country: "China",
    lat: 47.239601135253906,
    lng: 123.91799926757812,
  },
  {
    id: "YNJ",
    name: "Yanji Chaoyangchuan Airport",
    city: "Yanji",
    country: "China",
    lat: 42.8828010559,
    lng: 129.451004028,
  },
  {
    id: "WKL",
    name: "Waikoloa Heliport",
    city: "Waikoloa Village",
    country: "United States",
    lat: 19.9205,
    lng: -155.8607,
  },
  {
    id: "WME",
    name: "Mount Keith Airport",
    city: "Mount Keith",
    country: "Australia",
    lat: -27.286399841308594,
    lng: 120.55500030517578,
  },
  {
    id: "LRV",
    name: "Los Roques Airport",
    city: "Los Roques",
    country: "Venezuela",
    lat: 11.9499998093,
    lng: -66.66999816890001,
  },
  {
    id: "IOR",
    name: "Inishmore Aerodrome",
    city: "Inis Mor",
    country: "Ireland",
    lat: 53.1067008972168,
    lng: -9.653610229492188,
  },
  {
    id: "NNR",
    name: "Connemara Regional Airport",
    city: "Indreabhan",
    country: "Ireland",
    lat: 53.23030090332031,
    lng: -9.467780113220215,
  },
  {
    id: "GTI",
    name: "Rügen Airport",
    city: "Ruegen",
    country: "Germany",
    lat: 54.3833312988,
    lng: 13.3255558014,
  },
  {
    id: "EZV",
    name: "Berezovo Airport",
    city: "Berezovo",
    country: "Russia",
    lat: 63.92100143432617,
    lng: 65.03050231933594,
  },
  {
    id: "N",
    name: "Szczecin-Dąbie Airport",
    city: "Szczecin",
    country: "Poland",
    lat: 53.3921012878418,
    lng: 14.63379955291748,
  },
  {
    id: "ORH",
    name: "Worcester Regional Airport",
    city: "Worcester",
    country: "United States",
    lat: 42.26729965209961,
    lng: -71.87570190429688,
  },
  {
    id: "AQG",
    name: "Anqing Tianzhushan Airport",
    city: "Anqing",
    country: "China",
    lat: 30.582199,
    lng: 117.050003,
  },
  {
    id: "SHP",
    name: "Shanhaiguan Airport",
    city: "Qinhuangdao",
    country: "China",
    lat: 39.968102,
    lng: 119.731003,
  },
  {
    id: "YCU",
    name: "Yuncheng Guangong Airport",
    city: "Yuncheng",
    country: "China",
    lat: 35.116391,
    lng: 111.031388889,
  },
  {
    id: "N",
    name: "Lanzhou City Airport",
    city: "Lanzhou",
    country: "China",
    lat: 36.033333,
    lng: 103.86667,
  },
  {
    id: "JGN",
    name: "Jiayuguan Airport",
    city: "Jiayuguan",
    country: "China",
    lat: 39.856899,
    lng: 98.3414,
  },
  {
    id: "DDG",
    name: "Dandong Airport",
    city: "Dandong",
    country: "China",
    lat: 40.0247,
    lng: 124.286003,
  },
  {
    id: "DSN",
    name: "Ordos Ejin Horo Airport",
    city: "Dongsheng",
    country: "China",
    lat: 39.49,
    lng: 109.861388889,
  },
  {
    id: "PZI",
    name: "Bao'anying Airport",
    city: "Panzhihua",
    country: "China",
    lat: 26.54,
    lng: 101.79852,
  },
  {
    id: "PWT",
    name: "Bremerton National Airport",
    city: "Bremerton",
    country: "United States",
    lat: 47.490200042725,
    lng: -122.76499938965,
  },
  {
    id: "SPW",
    name: "Spencer Municipal Airport",
    city: "Spencer",
    country: "United States",
    lat: 43.165500640869,
    lng: -95.202796936035,
  },
  {
    id: "JEF",
    name: "Jefferson City Memorial Airport",
    city: "Jefferson City",
    country: "United States",
    lat: 38.5912017822,
    lng: -92.15609741210001,
  },
  {
    id: "N",
    name: "Tannheim Airfield",
    city: "Tannheim",
    country: "Germany",
    lat: 48.009998,
    lng: 10.098611,
  },
  {
    id: "UNT",
    name: "Unst Airport",
    city: "Unst",
    country: "United Kingdom",
    lat: 60.74720001220703,
    lng: -0.8538500070571899,
  },
  {
    id: "N",
    name: "Berkley Structures Heliport",
    city: "Pagerungan",
    country: "Indonesia",
    lat: 47.682043,
    lng: -122.148456,
  },
  {
    id: "PVC",
    name: "Provincetown Municipal Airport",
    city: "Provincetown",
    country: "United States",
    lat: 42.0718994141,
    lng: -70.2213973999,
  },
  {
    id: "N",
    name: "Anduki Airport",
    city: "Seria",
    country: "Brunei",
    lat: 4.637000083920001,
    lng: 114.382003784,
  },
  {
    id: "SBH",
    name: "Gustaf III Airport",
    city: "Gustavia",
    country: "France",
    lat: 17.904399871826172,
    lng: -62.84360122680664,
  },
  {
    id: "KMW",
    name: "Kostroma Sokerkino Airport",
    city: "Kostroma",
    country: "Russia",
    lat: 57.7969017029,
    lng: 41.019401550299996,
  },
  {
    id: "SUI",
    name: "Sukhumi Dranda Airport",
    city: "Sukhumi",
    country: "Georgia",
    lat: 42.8582000732,
    lng: 41.128101348899996,
  },
  {
    id: "TBW",
    name: "Donskoye Airport",
    city: "Tambow",
    country: "Russia",
    lat: 52.806098937988,
    lng: 41.482799530029,
  },
  {
    id: "OBN",
    name: "Oban Airport",
    city: "North Connel",
    country: "United Kingdom",
    lat: 56.4635009765625,
    lng: -5.399670124053955,
  },
  {
    id: "ERM",
    name: "Erechim Airport",
    city: "Erechim",
    country: "Brazil",
    lat: -27.66189956665039,
    lng: -52.2682991027832,
  },
  {
    id: "N",
    name: "La Côte Airport",
    city: "Prangins",
    country: "Switzerland",
    lat: 46.40639877319336,
    lng: 6.258059978485107,
  },
  {
    id: "CVF",
    name: "Courchevel Airport",
    city: "Courcheval",
    country: "France",
    lat: 45.39670181274414,
    lng: 6.6347198486328125,
  },
  {
    id: "FUL",
    name: "Fullerton Municipal Airport",
    city: "Fullerton",
    country: "United States",
    lat: 33.8720016479,
    lng: -117.980003357,
  },
  {
    id: "USA",
    name: "Concord-Padgett Regional Airport",
    city: "Concord",
    country: "United States",
    lat: 35.387798,
    lng: -80.709099,
  },
  {
    id: "N",
    name: "Isle of Wight / Sandown Airport",
    city: "Isle Of Wight",
    country: "United Kingdom",
    lat: 50.653099,
    lng: -1.18221998,
  },
  {
    id: "NVI",
    name: "Navoi Airport",
    city: "Navoi",
    country: "Uzbekistan",
    lat: 40.1171989440918,
    lng: 65.1707992553711,
  },
  {
    id: "N",
    name: "Andernos Les Bains Airport",
    city: "Andernos-Les-Bains",
    country: "France",
    lat: 44.7561,
    lng: -1.06333,
  },
  {
    id: "N",
    name: "Bienenfarm Airport",
    city: "Nauen",
    country: "Germany",
    lat: 52.661667,
    lng: 12.745833,
  },
  {
    id: "QSF",
    name: "Ain Arnat Airport",
    city: "Setif",
    country: "Algeria",
    lat: 36.178100585900005,
    lng: 5.3244900703399995,
  },
  {
    id: "LRH",
    name: "La Rochelle-Île de Ré Airport",
    city: "La Rochelle",
    country: "France",
    lat: 46.17919921875,
    lng: -1.1952799558639526,
  },
  {
    id: "SUN",
    name: "Friedman Memorial Airport",
    city: "Hailey",
    country: "United States",
    lat: 43.50439835,
    lng: -114.2959976,
  },
  {
    id: "N",
    name: "Yverdon-les-Bains Airport",
    city: "Yverdon-Les-Bains",
    country: "Switzerland",
    lat: 46.7619018555,
    lng: 6.61332988739,
  },
  {
    id: "N",
    name: "Bielsko Biala Airport",
    city: "Bielsko-Biala",
    country: "Poland",
    lat: 49.80500030517578,
    lng: 19.00189971923828,
  },
  {
    id: "MCW",
    name: "Mason City Municipal Airport",
    city: "Mason City",
    country: "United States",
    lat: 43.157798767100005,
    lng: -93.3312988281,
  },
  {
    id: "AZA",
    name: "Phoenix-Mesa-Gateway Airport",
    city: "Mesa",
    country: "United States",
    lat: 33.30780029,
    lng: -111.6549988,
  },
  {
    id: "XAU",
    name: "Saúl Airport",
    city: "Saul",
    country: "French Guiana",
    lat: 3.61361,
    lng: -53.204201,
  },
  {
    id: "N",
    name: "Tekapo Aerodrome",
    city: "Lake Tekapo",
    country: "New Zealand",
    lat: -44.0052986145,
    lng: 170.444000244,
  },
  {
    id: "N",
    name: "Niederoeblarn Airport",
    city: "Niederoeblarn",
    country: "Austria",
    lat: 47.478298,
    lng: 14.0083,
  },
  {
    id: "N",
    name: "Vöslau Airport",
    city: "Bad Voeslau",
    country: "Austria",
    lat: 47.96500015258789,
    lng: 16.260000228881836,
  },
  {
    id: "N",
    name: "Uetersen/Heist Airport",
    city: "Uetersen",
    country: "Germany",
    lat: 53.64638900756836,
    lng: 9.704167366027832,
  },
  {
    id: "AKP",
    name: "Anaktuvuk Pass Airport",
    city: "Anaktuvuk Pass",
    country: "United States",
    lat: 68.13359833,
    lng: -151.7429962,
  },
  {
    id: "ANV",
    name: "Anvik Airport",
    city: "Anvik",
    country: "United States",
    lat: 62.646702,
    lng: -160.190994,
  },
  {
    id: "ATK",
    name: "Atqasuk Edward Burnell Sr Memorial Airport",
    city: "Atqasuk",
    country: "United States",
    lat: 70.46730041503906,
    lng: -157.43600463867188,
  },
  {
    id: "GAM",
    name: "Gambell Airport",
    city: "Gambell",
    country: "United States",
    lat: 63.76679992675781,
    lng: -171.73300170898438,
  },
  {
    id: "HPB",
    name: "Hooper Bay Airport",
    city: "Hooper Bay",
    country: "United States",
    lat: 61.52389908,
    lng: -166.1470032,
  },
  {
    id: "KAL",
    name: "Kaltag Airport",
    city: "Kaltag",
    country: "United States",
    lat: 64.31909943,
    lng: -158.7409973,
  },
  {
    id: "KSM",
    name: "St Mary's Airport",
    city: "St Mary's",
    country: "United States",
    lat: 62.0605011,
    lng: -163.302002,
  },
  {
    id: "KVL",
    name: "Kivalina Airport",
    city: "Kivalina",
    country: "United States",
    lat: 67.73619842529297,
    lng: -164.56300354003906,
  },
  {
    id: "MYU",
    name: "Mekoryuk Airport",
    city: "Mekoryuk",
    country: "United States",
    lat: 60.37139892578125,
    lng: -166.27099609375,
  },
  {
    id: "RBY",
    name: "Ruby Airport",
    city: "Ruby",
    country: "United States",
    lat: 64.72720337,
    lng: -155.4700012,
  },
  {
    id: "SHH",
    name: "Shishmaref Airport",
    city: "Shishmaref",
    country: "United States",
    lat: 66.249604,
    lng: -166.089112,
  },
  {
    id: "SVA",
    name: "Savoonga Airport",
    city: "Savoonga",
    country: "United States",
    lat: 63.6864013671875,
    lng: -170.4929962158203,
  },
  {
    id: "WTK",
    name: "Noatak Airport",
    city: "Noatak",
    country: "United States",
    lat: 67.56610107421875,
    lng: -162.97500610351562,
  },
  {
    id: "OMC",
    name: "Ormoc Airport",
    city: "Ormoc City",
    country: "Philippines",
    lat: 11.057999610900879,
    lng: 124.56500244140625,
  },
  {
    id: "YPX",
    name: "Puvirnituq Airport",
    city: "Puvirnituq",
    country: "Canada",
    lat: 60.05059814453125,
    lng: -77.28690338134766,
  },
  {
    id: "YTQ",
    name: "Tasiujaq Airport",
    city: "Tasiujaq",
    country: "Canada",
    lat: 58.66780090332031,
    lng: -69.95580291748047,
  },
  {
    id: "ARC",
    name: "Arctic Village Airport",
    city: "Arctic Village",
    country: "United States",
    lat: 68.1147,
    lng: -145.578995,
  },
  {
    id: "QOW",
    name: "Sam Mbakwe International Airport",
    city: "Imo",
    country: "Nigeria",
    lat: 5.427060127258301,
    lng: 7.206029891967773,
  },
  {
    id: "FON",
    name: "Arenal Airport",
    city: "La Fortuna/San Carlos",
    country: "Costa Rica",
    lat: 10.478,
    lng: -84.634499,
  },
  {
    id: "TMU",
    name: "Tambor Airport",
    city: "Nicoya",
    country: "Costa Rica",
    lat: 9.73852,
    lng: -85.013802,
  },
  {
    id: "CYZ",
    name: "Cauayan Airport",
    city: "Cauayan",
    country: "Philippines",
    lat: 16.9298992157,
    lng: 121.752998352,
  },
  {
    id: "KVK",
    name: "Kirovsk-Apatity Airport",
    city: "Apatity",
    country: "Russia",
    lat: 67.46330261230469,
    lng: 33.58829879760742,
  },
  {
    id: "GVR",
    name: "Coronel Altino Machado de Oliveira Airport",
    city: "Governador Valadares",
    country: "Brazil",
    lat: -18.89520072937,
    lng: -41.982200622559,
  },
  {
    id: "KPC",
    name: "Port Clarence Coast Guard Station",
    city: "Port Clarence",
    country: "United States",
    lat: 65.2537002563,
    lng: -166.85899353,
  },
  {
    id: "PJA",
    name: "Pajala Airport",
    city: "Pajala",
    country: "Sweden",
    lat: 67.24559783935547,
    lng: 23.068899154663086,
  },
  {
    id: "QBC",
    name: "Bella Coola Airport",
    city: "Bella Coola",
    country: "Canada",
    lat: 52.387501,
    lng: -126.596001,
  },
  {
    id: "HGR",
    name: "Hagerstown Regional Richard A Henson Field",
    city: "Hagerstown",
    country: "United States",
    lat: 39.707901,
    lng: -77.72949982,
  },
  {
    id: "ACR",
    name: "Araracuara Airport",
    city: "Araracuara",
    country: "Colombia",
    lat: -0.5833,
    lng: -72.4083,
  },
  {
    id: "GOP",
    name: "Gorakhpur Airport",
    city: "Gorakhpur",
    country: "India",
    lat: 26.739700317399997,
    lng: 83.4496994019,
  },
  {
    id: "SDP",
    name: "Sand Point Airport",
    city: "Sand Point",
    country: "United States",
    lat: 55.314998626708984,
    lng: -160.5229949951172,
  },
  {
    id: "HMI",
    name: "Hami Airport",
    city: "Hami",
    country: "China",
    lat: 42.8414,
    lng: 93.669197,
  },
  {
    id: "WUZ",
    name: "Wuzhou Changzhoudao Airport",
    city: "Wuzhou",
    country: "China",
    lat: 23.456699,
    lng: 111.248001,
  },
  {
    id: "TBH",
    name: "Tugdan Airport",
    city: "Romblon",
    country: "Philippines",
    lat: 12.3109998703,
    lng: 122.084999084,
  },
  {
    id: "ACP",
    name: "Sahand Airport",
    city: "Maragheh",
    country: "Iran",
    lat: 37.347999572753906,
    lng: 46.127899169921875,
  },
  {
    id: "GBT",
    name: "Gorgan Airport",
    city: "Gorgan",
    country: "Iran",
    lat: 36.909400939899996,
    lng: 54.4012985229,
  },
  {
    id: "IIL",
    name: "Ilam Airport",
    city: "Ilam",
    country: "Iran",
    lat: 33.58660125732422,
    lng: 46.40480041503906,
  },
  {
    id: "PFQ",
    name: "Parsabade Moghan Airport",
    city: "Parsabad",
    country: "Iran",
    lat: 39.60359954834,
    lng: 47.881500244141,
  },
  {
    id: "N",
    name: "Tocache Airport",
    city: "Tocache",
    country: "Peru",
    lat: -8.1829996109,
    lng: -76.516998291,
  },
  {
    id: "TCG",
    name: "Tacheng Airport",
    city: "Tacheng",
    country: "China",
    lat: 46.67250061035156,
    lng: 83.3407974243164,
  },
  {
    id: "MQM",
    name: "Mardin Airport",
    city: "Mardin",
    country: "Turkey",
    lat: 37.223300933800004,
    lng: 40.6316986084,
  },
  {
    id: "AFS",
    name: "Sugraly Airport",
    city: "Zarafshan",
    country: "Uzbekistan",
    lat: 41.61389923095703,
    lng: 64.23320007324219,
  },
  {
    id: "DRG",
    name: "Deering Airport",
    city: "Deering",
    country: "United States",
    lat: 66.0696029663,
    lng: -162.76600647,
  },
  {
    id: "LEN",
    name: "Leon Airport",
    city: "Leon",
    country: "Spain",
    lat: 42.5890007019043,
    lng: -5.65556001663208,
  },
  {
    id: "RGS",
    name: "Burgos Airport",
    city: "Burgos",
    country: "Spain",
    lat: 42.357601,
    lng: -3.62076,
  },
  {
    id: "EGM",
    name: "Sege Airport",
    city: "Sege",
    country: "Solomon Islands",
    lat: -8.578889846801758,
    lng: 157.87600708007812,
  },
  {
    id: "CQD",
    name: "Shahrekord Airport",
    city: "Shahre Kord",
    country: "Iran",
    lat: 32.2971992493,
    lng: 50.842201232899995,
  },
  {
    id: "DHM",
    name: "Kangra Airport",
    city: "Kangra",
    country: "India",
    lat: 32.16510009765625,
    lng: 76.26339721679688,
  },
  {
    id: "NDC",
    name: "Nanded Airport",
    city: "Nanded",
    country: "India",
    lat: 19.1833000183,
    lng: 77.31670379639999,
  },
  {
    id: "SLV",
    name: "Shimla Airport",
    city: "Shimla",
    country: "India",
    lat: 31.0818,
    lng: 77.068001,
  },
  {
    id: "IGG",
    name: "Igiugig Airport",
    city: "Igiugig",
    country: "United States",
    lat: 59.32400131225586,
    lng: -155.90199279785156,
  },
  {
    id: "KNW",
    name: "New Stuyahok Airport",
    city: "New Stuyahok",
    country: "United States",
    lat: 59.4499015808,
    lng: -157.32800293,
  },
  {
    id: "KVC",
    name: "King Cove Airport",
    city: "King Cove",
    country: "United States",
    lat: 55.11629867553711,
    lng: -162.26600646972656,
  },
  {
    id: "PTH",
    name: "Port Heiden Airport",
    city: "Port Heiden",
    country: "United States",
    lat: 56.95909881591797,
    lng: -158.63299560546875,
  },
  {
    id: "TOG",
    name: "Togiak Airport",
    city: "Togiak Village",
    country: "United States",
    lat: 59.052799224853516,
    lng: -160.39700317382812,
  },
  {
    id: "EGN",
    name: "Geneina Airport",
    city: "Geneina",
    country: "Sudan",
    lat: 13.48169994354248,
    lng: 22.467199325561523,
  },
  {
    id: "LKH",
    name: "Long Akah Airport",
    city: "Long Akah",
    country: "Malaysia",
    lat: 3.299999952316284,
    lng: 114.78299713134766,
  },
  {
    id: "WLH",
    name: "Walaha Airport",
    city: "Walaha",
    country: "Vanuatu",
    lat: -15.411999702500001,
    lng: 167.690994263,
  },
  {
    id: "CHG",
    name: "Chaoyang Airport",
    city: "Chaoyang",
    country: "China",
    lat: 41.538101,
    lng: 120.434998,
  },
  {
    id: "UAS",
    name: "Buffalo Spring",
    city: "Samburu South",
    country: "Kenya",
    lat: 0.530583,
    lng: 37.534195,
  },
  {
    id: "BHG",
    name: "Brus Laguna Airport",
    city: "Brus Laguna",
    country: "Honduras",
    lat: 15.7631,
    lng: -84.543602,
  },
  {
    id: "YVB",
    name: "Bonaventure Airport",
    city: "Bonaventure",
    country: "Canada",
    lat: 48.07109832763672,
    lng: -65.46029663085938,
  },
  {
    id: "SKT",
    name: "Sialkot Airport",
    city: "Sialkot",
    country: "Pakistan",
    lat: 32.5355567932,
    lng: 74.3638916016,
  },
  {
    id: "PDP",
    name: "Capitan Corbeta CA Curbelo International Airport",
    city: "Punta del Este",
    country: "Uruguay",
    lat: -34.855098724365234,
    lng: -55.09429931640625,
  },
  {
    id: "WVB",
    name: "Walvis Bay Airport",
    city: "Walvis Bay",
    country: "Namibia",
    lat: -22.9799,
    lng: 14.6453,
  },
  {
    id: "MPA",
    name: "Katima Mulilo Airport",
    city: "Mpacha",
    country: "Namibia",
    lat: -17.634399,
    lng: 24.176701,
  },
  {
    id: "AOE",
    name: "Anadolu Airport",
    city: "Eskissehir",
    country: "Turkey",
    lat: 39.809898,
    lng: 30.5194,
  },
  {
    id: "CKZ",
    name: "Çanakkale Airport",
    city: "Canakkale",
    country: "Turkey",
    lat: 40.1376991272,
    lng: 26.4267997742,
  },
  {
    id: "MSR",
    name: "Muş Airport",
    city: "Mus",
    country: "Turkey",
    lat: 38.747798919677734,
    lng: 41.66120147705078,
  },
  {
    id: "NOP",
    name: "Sinop Airport",
    city: "Sinop",
    country: "Turkey",
    lat: 42.015800476074,
    lng: 35.066398620605,
  },
  {
    id: "TEQ",
    name: "Tekirdağ Çorlu Airport",
    city: "Çorlu",
    country: "Turkey",
    lat: 41.13819885253906,
    lng: 27.919099807739258,
  },
  {
    id: "YEI",
    name: "Bursa Yenişehir Airport",
    city: "Yenisehir",
    country: "Turkey",
    lat: 40.2551994324,
    lng: 29.5625991821,
  },
  {
    id: "LSS",
    name: "Terre-de-Haut Airport",
    city: "Les Saintes",
    country: "Guadeloupe",
    lat: 15.86439991,
    lng: -61.5806007385,
  },
  {
    id: "KMV",
    name: "Kalay Airport",
    city: "Kalemyo",
    country: "Myanmar",
    lat: 23.188800811767578,
    lng: 94.05110168457031,
  },
  {
    id: "VQS",
    name: "Vieques Airport",
    city: "Vieques Island",
    country: "Puerto Rico",
    lat: 18.115800857500002,
    lng: -65.4226989746,
  },
  {
    id: "YIF",
    name: "St Augustin Airport",
    city: "St-Augustin",
    country: "Canada",
    lat: 51.2117004395,
    lng: -58.6582984924,
  },
  {
    id: "HDM",
    name: "Hamadan Airport",
    city: "Hamadan",
    country: "Iran",
    lat: 34.86920166015625,
    lng: 48.5525016784668,
  },
  {
    id: "MRQ",
    name: "Marinduque Airport",
    city: "Gasan",
    country: "Philippines",
    lat: 13.361000061035156,
    lng: 121.82599639892578,
  },
  {
    id: "GFN",
    name: "Grafton Airport",
    city: "Grafton",
    country: "Australia",
    lat: -29.7593994140625,
    lng: 153.02999877929688,
  },
  {
    id: "OAG",
    name: "Orange Airport",
    city: "Orange",
    country: "Australia",
    lat: -33.3816986084,
    lng: 149.132995605,
  },
  {
    id: "TRO",
    name: "Taree Airport",
    city: "Taree",
    country: "Australia",
    lat: -31.8885993958,
    lng: 152.514007568,
  },
  {
    id: "COQ",
    name: "Choibalsan Airport",
    city: "Choibalsan",
    country: "Mongolia",
    lat: 48.13570022583008,
    lng: 114.64600372314453,
  },
  {
    id: "HOH",
    name: "Hohenems-Dornbirn Airport",
    city: "Hohenems",
    country: "Austria",
    lat: 47.3849983215,
    lng: 9.69999980927,
  },
  {
    id: "N",
    name: "Weser-Wümme Airport",
    city: "Hellwege",
    country: "Germany",
    lat: 53.053890228271484,
    lng: 9.208610534667969,
  },
  {
    id: "N",
    name: "Krems Airport",
    city: "Krems",
    country: "Austria",
    lat: 48.446389,
    lng: 15.634167,
  },
  {
    id: "ESC",
    name: "Delta County Airport",
    city: "Escanaba",
    country: "United States",
    lat: 45.7226982117,
    lng: -87.0936965942,
  },
  {
    id: "YAK",
    name: "Yakutat Airport",
    city: "Yakutat",
    country: "United States",
    lat: 59.5032997131,
    lng: -139.660003662,
  },
  {
    id: "GUL",
    name: "Goulburn Airport",
    city: "Goulburn",
    country: "Australia",
    lat: -34.810298919677734,
    lng: 149.7259979248047,
  },
  {
    id: "CES",
    name: "Cessnock Airport",
    city: "Cessnock",
    country: "Australia",
    lat: -32.787498,
    lng: 151.341995,
  },
  {
    id: "NSO",
    name: "Scone Airport",
    city: "Scone",
    country: "Australia",
    lat: -32.037200927734375,
    lng: 150.83200073242188,
  },
  {
    id: "DGE",
    name: "Mudgee Airport",
    city: "Mudgee",
    country: "Australia",
    lat: -32.5625,
    lng: 149.610992432,
  },
  {
    id: "MTL",
    name: "Maitland Airport",
    city: "Maitland",
    country: "Australia",
    lat: -32.701265,
    lng: 151.492912,
  },
  {
    id: "CPX",
    name: "Benjamin Rivera Noriega Airport",
    city: "Culebra Island",
    country: "Puerto Rico",
    lat: 18.313289,
    lng: -65.304324,
  },
  {
    id: "N",
    name: "Raron Airport",
    city: "Raron",
    country: "Switzerland",
    lat: 46.3036003112793,
    lng: 7.823329925537109,
  },
  {
    id: "N",
    name: "Borovaya Airfield",
    city: "Minsk",
    country: "Belarus",
    lat: 53.9604611,
    lng: 27.6505961,
  },
  {
    id: "N",
    name: "Amlikon Glider Airport",
    city: "Amlikon",
    country: "Switzerland",
    lat: 47.57419967651367,
    lng: 9.047499656677246,
  },
  {
    id: "N",
    name: "Lommis Airfield",
    city: "Lommis",
    country: "Switzerland",
    lat: 47.524399,
    lng: 9.00306,
  },
  {
    id: "MWA",
    name: "Williamson County Regional Airport",
    city: "Marion",
    country: "United States",
    lat: 37.75500107,
    lng: -89.01110077,
  },
  {
    id: "N",
    name: "Burnet Municipal Kate Craddock Field",
    city: "Bamburi",
    country: "Kenya",
    lat: 30.73889923095703,
    lng: -98.23860168457031,
  },
  {
    id: "OCN",
    name: "Oceanside Municipal Airport",
    city: "Fraser Island",
    country: "Australia",
    lat: 33.217300415039,
    lng: -117.35399627686,
  },
  {
    id: "N",
    name: "Flugplatz Finsterwalde/Heinrichsruh",
    city: "Finsterwalde",
    country: "Germany",
    lat: 51.634445,
    lng: 13.675556,
  },
  {
    id: "KIK",
    name: "Kirkuk Air Base",
    city: "Kirkuk",
    country: "Iraq",
    lat: 35.46950149536133,
    lng: 44.348899841308594,
  },
  {
    id: "XJD",
    name: "Al Udeid Air Base",
    city: "Doha",
    country: "Qatar",
    lat: 25.1173000336,
    lng: 51.3149986267,
  },
  {
    id: "GBZ",
    name: "Great Barrier Aerodrome",
    city: "Claris",
    country: "New Zealand",
    lat: -36.24140167236328,
    lng: 175.4720001220703,
  },
  {
    id: "IMT",
    name: "Ford Airport",
    city: "Iron Mountain",
    country: "United States",
    lat: 45.8184013367,
    lng: -88.1145019531,
  },
  {
    id: "N",
    name: "Marquette Airport",
    city: "Marquette",
    country: "United States",
    lat: 46.53390121459961,
    lng: -87.5614013671875,
  },
  {
    id: "AET",
    name: "Allakaket Airport",
    city: "Allakaket",
    country: "United States",
    lat: 66.5518035889,
    lng: -152.621994019,
  },
  {
    id: "N",
    name: "Dinslaken/Schwarze Heide Airport",
    city: "Dinslaken",
    country: "Germany",
    lat: 51.616112,
    lng: 6.865278,
  },
  {
    id: "N",
    name: "Höxter-Holzminden Airport",
    city: "Hoexter Holzminden",
    country: "Germany",
    lat: 51.80666732788086,
    lng: 9.37833309173584,
  },
  {
    id: "N",
    name: "Niijima Airport",
    city: "Niijima",
    country: "Japan",
    lat: 34.3694000244,
    lng: 139.268997192,
  },
  {
    id: "MGC",
    name: "Michigan City Municipal Airport",
    city: "Michigan City",
    country: "United States",
    lat: 41.703300476100004,
    lng: -86.8211975098,
  },
  {
    id: "SWD",
    name: "Seward Airport",
    city: "Seward",
    country: "United States",
    lat: 60.12689971923828,
    lng: -149.41900634765625,
  },
  {
    id: "GRM",
    name: "Grand Marais Cook County Airport",
    city: "Grand Marais",
    country: "United States",
    lat: 47.8382987976,
    lng: -90.38289642330001,
  },
  {
    id: "AUW",
    name: "Wausau Downtown Airport",
    city: "Wausau",
    country: "United States",
    lat: 44.9262008667,
    lng: -89.6266021729,
  },
  {
    id: "N",
    name: "Kalundborg Airport",
    city: "Kalundborg",
    country: "Denmark",
    lat: 55.70029830932617,
    lng: 11.25,
  },
  {
    id: "MYP",
    name: "Mary Airport",
    city: "Mary",
    country: "Turkmenistan",
    lat: 37.6194,
    lng: 61.896702,
  },
  {
    id: "N",
    name: "Bungle Bungle Airport",
    city: "Bungle Bungle",
    country: "Australia",
    lat: -17.545299530029297,
    lng: 128.3070068359375,
  },
  {
    id: "N",
    name: "Sazená Airport",
    city: "Sazena",
    country: "Czech Republic",
    lat: 50.3246994019,
    lng: 14.2588996887,
  },
  {
    id: "N",
    name: "Spray View Airport",
    city: "Spray View",
    country: "Zimbabwe",
    lat: -17.91699981689453,
    lng: 25.816999435424805,
  },
  {
    id: "MVA",
    name: "Reykjahlíð Airport",
    city: "Myvatn",
    country: "Iceland",
    lat: 65.65579986572266,
    lng: -16.918100357055664,
  },
  {
    id: "QSA",
    name: "Sabadell Airport",
    city: "Sabadell",
    country: "Spain",
    lat: 41.52090072631836,
    lng: 2.1050798892974854,
  },
  {
    id: "WSY",
    name: "Whitsunday Island Airport",
    city: "Airlie Beach",
    country: "Australia",
    lat: -20.27611,
    lng: 148.755,
  },
  {
    id: "MIE",
    name: "Delaware County Johnson Field",
    city: "Muncie",
    country: "United States",
    lat: 40.2422981262207,
    lng: -85.3958969116211,
  },
  {
    id: "LAF",
    name: "Purdue University Airport",
    city: "Lafayette",
    country: "United States",
    lat: 40.41230010986328,
    lng: -86.93689727783203,
  },
  {
    id: "N",
    name: "Brown County Airport",
    city: "Georgetown",
    country: "United States",
    lat: 38.881900787353516,
    lng: -83.88269805908203,
  },
  {
    id: "VGT",
    name: "North Las Vegas Airport",
    city: "Las Vegas",
    country: "United States",
    lat: 36.21070098877,
    lng: -115.19400024414,
  },
  {
    id: "ENW",
    name: "Kenosha Regional Airport",
    city: "Kenosha",
    country: "United States",
    lat: 42.59569931,
    lng: -87.92780304,
  },
  {
    id: "MTJ",
    name: "Montrose Regional Airport",
    city: "Montrose CO",
    country: "United States",
    lat: 38.509799957300004,
    lng: -107.893997192,
  },
  {
    id: "RIW",
    name: "Riverton Regional Airport",
    city: "Riverton WY",
    country: "United States",
    lat: 43.064201355,
    lng: -108.459999084,
  },
  {
    id: "PDT",
    name: "Eastern Oregon Regional At Pendleton Airport",
    city: "Pendleton",
    country: "United States",
    lat: 45.695098877,
    lng: -118.841003418,
  },
  {
    id: "LYM",
    name: "Lympne Airport",
    city: "Lympne",
    country: "United Kingdom",
    lat: 51.08,
    lng: 1.013,
  },
  {
    id: "PKH",
    name: "Porto Cheli Airport",
    city: "Porto Heli",
    country: "Greece",
    lat: 37.297501,
    lng: 23.1478,
  },
  {
    id: "N",
    name: "Zell Am See Airport",
    city: "Zell am See",
    country: "Austria",
    lat: 47.292222,
    lng: 12.7875,
  },
  {
    id: "N",
    name: "RAAF Base Amberley",
    city: "Amberley",
    country: "Australia",
    lat: -27.6406,
    lng: 152.712006,
  },
  {
    id: "KTR",
    name: "Tindal Airport",
    city: "Katherine",
    country: "Australia",
    lat: -14.521100044250488,
    lng: 132.3780059814453,
  },
  {
    id: "N",
    name: "RAAF Williams, Laverton Base",
    city: "Laverton",
    country: "Australia",
    lat: -37.86360168457031,
    lng: 144.74600219726562,
  },
  {
    id: "NOA",
    name: "Nowra Airport",
    city: "Nowra",
    country: "Australia",
    lat: -34.94889831542969,
    lng: 150.53700256347656,
  },
  {
    id: "UCK",
    name: "Lutsk Airport",
    city: "Lutsk",
    country: "Ukraine",
    lat: 50.678404,
    lng: 25.487165,
  },
  {
    id: "CEJ",
    name: "Chernihiv Shestovitsa Airport",
    city: "Chernigov",
    country: "Ukraine",
    lat: 51.4021987915,
    lng: 31.1583003998,
  },
  {
    id: "N",
    name: "Ternopil International Airport",
    city: "Ternopol",
    country: "Ukraine",
    lat: 49.5242,
    lng: 25.7001,
  },
  {
    id: "BQT",
    name: "Brest Airport",
    city: "Brest",
    country: "Belarus",
    lat: 52.108299,
    lng: 23.8981,
  },
  {
    id: "OSH",
    name: "Wittman Regional Airport",
    city: "Oshkosh",
    country: "United States",
    lat: 43.98440170288086,
    lng: -88.55699920654297,
  },
  {
    id: "N",
    name: "Harle Airport",
    city: "Harlesiel",
    country: "Germany",
    lat: 53.706668853759766,
    lng: 7.820278167724609,
  },
  {
    id: "AGE",
    name: "Wangerooge Airport",
    city: "Wangerooge",
    country: "Germany",
    lat: 53.782779693603516,
    lng: 7.913888931274414,
  },
  {
    id: "N",
    name: "RAAF Base Pearce",
    city: "Perth",
    country: "Australia",
    lat: -31.667800903320312,
    lng: 116.01499938964844,
  },
  {
    id: "BXG",
    name: "Bendigo Airport",
    city: "Bendigo",
    country: "Australia",
    lat: -36.7393989563,
    lng: 144.330001831,
  },
  {
    id: "EAT",
    name: "Pangborn Memorial Airport",
    city: "Wenatchee",
    country: "United States",
    lat: 47.3988990784,
    lng: -120.207000732,
  },
  {
    id: "ARE",
    name: "Antonio Nery Juarbe Pol Airport",
    city: "Arecibo",
    country: "Puerto Rico",
    lat: 18.4500007629,
    lng: -66.6753005981,
  },
  {
    id: "RIN",
    name: "Ringi Cove Airport",
    city: "Ringi Cove",
    country: "Solomon Islands",
    lat: -8.12639045715332,
    lng: 157.14300537109375,
  },
  {
    id: "KCK",
    name: "Kirensk Airport",
    city: "Kirensk",
    country: "Russia",
    lat: 57.773,
    lng: 108.064,
  },
  {
    id: "UKX",
    name: "Ust-Kut Airport",
    city: "Ust-Kut",
    country: "Russia",
    lat: 56.8567008972168,
    lng: 105.7300033569336,
  },
  {
    id: "RMT",
    name: "Rimatara Airport",
    city: "Rimatara",
    country: "French Polynesia",
    lat: -22.63725,
    lng: -152.8059,
  },
  {
    id: "N",
    name: "Triengen Airport",
    city: "Triengen",
    country: "Switzerland",
    lat: 47.22669982910156,
    lng: 8.078060150146484,
  },
  {
    id: "QLS",
    name: "Lausanne-Blécherette Airport",
    city: "Lausanne",
    country: "Switzerland",
    lat: 46.54529953,
    lng: 6.61667013168,
  },
  {
    id: "N",
    name: "Speck-Fehraltorf Airport",
    city: "Fehraltorf",
    country: "Switzerland",
    lat: 47.376399993896484,
    lng: 8.757499694824219,
  },
  {
    id: "ZJI",
    name: "Locarno Airport",
    city: "Locarno",
    country: "Switzerland",
    lat: 46.160800933800004,
    lng: 8.87860965729,
  },
  {
    id: "QNC",
    name: "Neuchatel Airport",
    city: "Neuchatel",
    country: "Switzerland",
    lat: 46.9575004578,
    lng: 6.86471986771,
  },
  {
    id: "TGK",
    name: "Taganrog Yuzhny Airport",
    city: "Taganrog",
    country: "Russia",
    lat: 47.1983333,
    lng: 38.8491667,
  },
  {
    id: "GDZ",
    name: "Gelendzhik Airport",
    city: "Gelendzhik",
    country: "Russia",
    lat: 44.5820926295,
    lng: 38.0124807358,
  },
  {
    id: "ZIA",
    name: "Zhukovsky International Airport",
    city: "Ramenskoe",
    country: "Russia",
    lat: 55.553299,
    lng: 38.150002,
  },
  {
    id: "N",
    name: "Irkutsk Northwest Airport",
    city: "Irkutsk",
    country: "Russia",
    lat: 52.36830139160156,
    lng: 104.18299865722656,
  },
  {
    id: "N",
    name: "Khabarovsk Airport",
    city: "Khabarovsk",
    country: "Russia",
    lat: 48.525001525878906,
    lng: 135.1529998779297,
  },
  {
    id: "N",
    name: "Dzemgi Airport",
    city: "Komsomolsk-on-Amur",
    country: "Russia",
    lat: 50.60559844970703,
    lng: 137.08099365234375,
  },
  {
    id: "N",
    name: "Belaya Air Base",
    city: "Sredniiy",
    country: "Russia",
    lat: 52.915000915527344,
    lng: 103.57499694824219,
  },
  {
    id: "IAR",
    name: "Tunoshna Airport",
    city: "Yaroslavl",
    country: "Russia",
    lat: 57.560699462890625,
    lng: 40.15739822387695,
  },
  {
    id: "OHE",
    name: "Gu-Lian Airport",
    city: "Mohe County",
    country: "China",
    lat: 52.912777777799995,
    lng: 122.43,
  },
  {
    id: "JNG",
    name: "Jining Qufu Airport",
    city: "Jining",
    country: "China",
    lat: 35.292778,
    lng: 116.346667,
  },
  {
    id: "DRK",
    name: "Drake Bay Airport",
    city: "Puntarenas",
    country: "Costa Rica",
    lat: 8.71889019012,
    lng: -83.6417007446,
  },
  {
    id: "AAT",
    name: "Altay Air Base",
    city: "Altay",
    country: "China",
    lat: 47.7498855591,
    lng: 88.08580780030002,
  },
  {
    id: "TZL",
    name: "Tuzla International Airport",
    city: "Null",
    country: "Bosnia and Herzegovina",
    lat: 44.45869827270508,
    lng: 18.72480010986328,
  },
  {
    id: "FWH",
    name: "NAS Fort Worth JRB/Carswell Field",
    city: "Dallas",
    country: "United States",
    lat: 32.76919937,
    lng: -97.4414978,
  },
  {
    id: "NYT",
    name: "Naypyidaw Airport",
    city: "Naypyidaw",
    country: "Burma",
    lat: 19.623501,
    lng: 96.200996,
  },
  {
    id: "N",
    name: "Kyaukhtu South Airport",
    city: "Kyauktu",
    country: "Burma",
    lat: 21.406700134277344,
    lng: 94.13030242919922,
  },
  {
    id: "N",
    name: "Jan Mayensfield",
    city: "Jan Mayen",
    country: "Norway",
    lat: 70.9441166,
    lng: -8.6520736,
  },
  {
    id: "VBP",
    name: "Bokpyinn Airport",
    city: "Bokepyin",
    country: "Burma",
    lat: 11.1494,
    lng: 98.735901,
  },
  {
    id: "NZH",
    name: "Manzhouli Xijiao Airport",
    city: "Manzhouli",
    country: "China",
    lat: 49.566667,
    lng: 117.33,
  },
  {
    id: "WUA",
    name: "Wuhai Airport",
    city: "Wuhai",
    country: "China",
    lat: 39.7934,
    lng: 106.7993,
  },
  {
    id: "GYY",
    name: "Gary Chicago International Airport",
    city: "Gary",
    country: "United States",
    lat: 41.61629867553711,
    lng: -87.41280364990234,
  },
  {
    id: "BRD",
    name: "Brainerd Lakes Regional Airport",
    city: "Brainerd",
    country: "United States",
    lat: 46.39830017,
    lng: -94.13809967,
  },
  {
    id: "LWB",
    name: "Greenbrier Valley Airport",
    city: "Lewisburg",
    country: "United States",
    lat: 37.8582992554,
    lng: -80.3994979858,
  },
  {
    id: "PGV",
    name: "Pitt Greenville Airport",
    city: "Greenville",
    country: "United States",
    lat: 35.6352005,
    lng: -77.38529968,
  },
  {
    id: "CYF",
    name: "Chefornak Airport",
    city: "Chefornak",
    country: "United States",
    lat: 60.1492004395,
    lng: -164.285995483,
  },
  {
    id: "OXR",
    name: "Oxnard Airport",
    city: "Oxnard",
    country: "United States",
    lat: 34.200801849365,
    lng: -119.20700073242,
  },
  {
    id: "BKG",
    name: "Branson Airport",
    city: "Branson",
    country: "United States",
    lat: 36.532082,
    lng: -93.200544,
  },
  {
    id: "TEN",
    name: "Tongren Fenghuang Airport",
    city: "Tongren",
    country: "China",
    lat: 27.883333,
    lng: 109.308889,
  },
  {
    id: "JGS",
    name: "Jinggangshan Airport",
    city: "Jian",
    country: "China",
    lat: 26.856899261499997,
    lng: 114.736999512,
  },
  {
    id: "NIU",
    name: "Naiu Airport",
    city: "Niau",
    country: "French Polynesia",
    lat: -16.1191,
    lng: -146.3683,
  },
  {
    id: "SCH",
    name: "Schenectady County Airport",
    city: "Scotia NY",
    country: "United States",
    lat: 42.852500915527,
    lng: -73.928901672363,
  },
  {
    id: "NBC",
    name: "Begishevo Airport",
    city: "Nizhnekamsk",
    country: "Russia",
    lat: 55.564701080322266,
    lng: 52.092498779296875,
  },
  {
    id: "QRW",
    name: "Warri Airport",
    city: "Osubi",
    country: "Nigeria",
    lat: 5.59611,
    lng: 5.81778,
  },
  {
    id: "N",
    name: "Volkel Air Base",
    city: "Volkel",
    country: "Netherlands",
    lat: 51.657222,
    lng: 5.7077778,
  },
  {
    id: "IAO",
    name: "Siargao Airport",
    city: "Siargao",
    country: "Philippines",
    lat: 9.8591,
    lng: 126.014,
  },
  {
    id: "LGO",
    name: "Langeoog Airport",
    city: "Langeoog",
    country: "Germany",
    lat: 53.74250030517578,
    lng: 7.497777938842773,
  },
  {
    id: "N",
    name: "Biel-Kappelen Airport",
    city: "Biel",
    country: "Switzerland",
    lat: 47.08919906616211,
    lng: 7.289999961853027,
  },
  {
    id: "NLP",
    name: "Nelspruit Airport",
    city: "Nelspruit",
    country: "South Africa",
    lat: -25.5,
    lng: 30.9137992859,
  },
  {
    id: "CKC",
    name: "Cherkasy International Airport",
    city: "Cherkassy",
    country: "Ukraine",
    lat: 49.41559982299805,
    lng: 31.99530029296875,
  },
  {
    id: "UST",
    name: "Northeast Florida Regional Airport",
    city: "St. Augustine Airport",
    country: "United States",
    lat: 29.9592,
    lng: -81.339798,
  },
  {
    id: "NLV",
    name: "Mykolaiv International Airport",
    city: "Nikolayev",
    country: "Ukraine",
    lat: 47.057899475097656,
    lng: 31.9197998046875,
  },
  {
    id: "RHP",
    name: "Ramechhap Airport",
    city: "Ramechhap",
    country: "Nepal",
    lat: 27.393999099731445,
    lng: 86.0614013671875,
  },
  {
    id: "STS",
    name: "Charles M. Schulz Sonoma County Airport",
    city: "Santa Rosa",
    country: "United States",
    lat: 38.50899887,
    lng: -122.8130035,
  },
  {
    id: "ISM",
    name: "Kissimmee Gateway Airport",
    city: "Kissimmee",
    country: "United States",
    lat: 28.2898006439,
    lng: -81.4371032715,
  },
  {
    id: "LCQ",
    name: "Lake City Gateway Airport",
    city: "Lake City",
    country: "United States",
    lat: 30.1819992065,
    lng: -82.57689666750001,
  },
  {
    id: "N",
    name: "Deland Municipal Sidney H Taylor Field",
    city: "DeLand",
    country: "United States",
    lat: 29.06699944,
    lng: -81.28379822,
  },
  {
    id: "N",
    name: "Haller Airpark",
    city: "Green Cove Springs",
    country: "United States",
    lat: 29.904057,
    lng: -81.68515,
  },
  {
    id: "N",
    name: "Palmar Airport",
    city: "Santa Lucia",
    country: "Peru",
    lat: -18.97166633605957,
    lng: -62.97533416748047,
  },
  {
    id: "LGU",
    name: "Logan-Cache Airport",
    city: "Logan",
    country: "United States",
    lat: 41.7911987305,
    lng: -111.851997375,
  },
  {
    id: "BMC",
    name: "Brigham City Regional Airport",
    city: "Brigham City",
    country: "United States",
    lat: 41.552399,
    lng: -112.061996,
  },
  {
    id: "N",
    name: "Malad City Airport",
    city: "Malad City",
    country: "United States",
    lat: 42.16659927368164,
    lng: -112.2969970703125,
  },
  {
    id: "ASE",
    name: "Aspen-Pitkin Co/Sardy Field",
    city: "Aspen",
    country: "United States",
    lat: 39.22320175,
    lng: -106.8690033,
  },
  {
    id: "ULV",
    name: "Ulyanovsk Baratayevka Airport",
    city: "Ulyanovsk",
    country: "Russia",
    lat: 54.26829910279999,
    lng: 48.226699829100006,
  },
  {
    id: "ERV",
    name: "Kerrville Municipal Louis Schreiner Field",
    city: "Kerrville",
    country: "United States",
    lat: 29.9766998291,
    lng: -99.08570098879999,
  },
  {
    id: "N",
    name: "Birrfeld Airport",
    city: "Birrfeld",
    country: "Switzerland",
    lat: 47.4436,
    lng: 8.23361,
  },
  {
    id: "GED",
    name: "Sussex County Airport",
    city: "Georgetown",
    country: "United States",
    lat: 38.68920135,
    lng: -75.35890198,
  },
  {
    id: "ZSW",
    name: "Prince Rupert/Seal Cove Seaplane Base",
    city: "Prince Rupert",
    country: "Canada",
    lat: 54.33330154418945,
    lng: -130.2830047607422,
  },
  {
    id: "GBD",
    name: "Great Bend Municipal Airport",
    city: "Great Bend",
    country: "United States",
    lat: 38.3442993164,
    lng: -98.8591995239,
  },
  {
    id: "HYS",
    name: "Hays Regional Airport",
    city: "Hays",
    country: "United States",
    lat: 38.84220123,
    lng: -99.27320099,
  },
  {
    id: "SUS",
    name: "Spirit of St Louis Airport",
    city: "Null",
    country: "United States",
    lat: 38.662101745605,
    lng: -90.652000427246,
  },
  {
    id: "LYU",
    name: "Ely Municipal Airport",
    city: "Ely",
    country: "United States",
    lat: 47.82450104,
    lng: -91.83070374,
  },
  {
    id: "GPZ",
    name: "Grand Rapids Itasca Co-Gordon Newstrom field",
    city: "Grand Rapids MN",
    country: "United States",
    lat: 47.21110153,
    lng: -93.50980377,
  },
  {
    id: "TVF",
    name: "Thief River Falls Regional Airport",
    city: "Thief River Falls",
    country: "United States",
    lat: 48.06570053,
    lng: -96.18499756,
  },
  {
    id: "EGV",
    name: "Eagle River Union Airport",
    city: "Eagle River",
    country: "United States",
    lat: 45.932300567599995,
    lng: -89.26830291750001,
  },
  {
    id: "ARV",
    name: "Lakeland-Noble F. Lee Memorial field",
    city: "Minocqua - Woodruff",
    country: "United States",
    lat: 45.92789841,
    lng: -89.73090363,
  },
  {
    id: "N",
    name: "Ankeny Regional Airport",
    city: "Ankeny",
    country: "United States",
    lat: 41.69139862060547,
    lng: -93.56639862060547,
  },
  {
    id: "YBV",
    name: "Berens River Airport",
    city: "Berens River",
    country: "Canada",
    lat: 52.358898,
    lng: -97.018303,
  },
  {
    id: "N",
    name: "Corpus Christi Naval Air Station/Truax Field",
    city: "Corpus Christi",
    country: "United States",
    lat: 27.69260025,
    lng: -97.29109955,
  },
  {
    id: "AVX",
    name: "Catalina Airport",
    city: "Catalina Island",
    country: "United States",
    lat: 33.4049,
    lng: -118.416,
  },
  {
    id: "MHV",
    name: "Mojave Airport",
    city: "Mojave",
    country: "United States",
    lat: 35.05939865,
    lng: -118.1520004,
  },
  {
    id: "ZIN",
    name: "Interlaken Air Base",
    city: "Interlaken",
    country: "Switzerland",
    lat: 46.6766014,
    lng: 7.8790798,
  },
  {
    id: "INQ",
    name: "Inisheer Aerodrome",
    city: "Inisheer",
    country: "Ireland",
    lat: 53.064701080322266,
    lng: -9.510899543762207,
  },
  {
    id: "SWT",
    name: "Strezhevoy Airport",
    city: "Strezhevoy",
    country: "Russia",
    lat: 60.709400177,
    lng: 77.66000366210001,
  },
  {
    id: "HUT",
    name: "Hutchinson Municipal Airport",
    city: "Hutchinson",
    country: "United States",
    lat: 38.0654983521,
    lng: -97.86060333250002,
  },
  {
    id: "OAI",
    name: "Bagram Air Base",
    city: "Kabul",
    country: "Afghanistan",
    lat: 34.9460983276,
    lng: 69.26499938959999,
  },
  {
    id: "AKH",
    name: "Prince Sultan Air Base",
    city: "Al Kharj",
    country: "Saudi Arabia",
    lat: 24.062700271606445,
    lng: 47.580501556396484,
  },
  {
    id: "STJ",
    name: "Rosecrans Memorial Airport",
    city: "Rosecrans",
    country: "United States",
    lat: 39.771900177002,
    lng: -94.909698486328,
  },
  {
    id: "N",
    name: "Pápa Air Base",
    city: "Papa",
    country: "Hungary",
    lat: 47.3636016846,
    lng: 17.5007991791,
  },
  {
    id: "N",
    name: "Whiting Field Naval Air Station South Airport",
    city: "Cuxhaven",
    country: "Germany",
    lat: 30.70439910888672,
    lng: -87.02300262451172,
  },
  {
    id: "VOK",
    name: "Volk Field",
    city: "Camp Douglas",
    country: "United States",
    lat: 43.938999176025,
    lng: -90.253402709961,
  },
  {
    id: "GUC",
    name: "Gunnison Crested Butte Regional Airport",
    city: "Gunnison",
    country: "United States",
    lat: 38.53390121,
    lng: -106.9329987,
  },
  {
    id: "SIA",
    name: "Xi'an Xiguan Airport",
    city: "Xi'AN",
    country: "China",
    lat: 34.376701,
    lng: 109.120003,
  },
  {
    id: "TOA",
    name: "Zamperini Field",
    city: "Torrance",
    country: "United States",
    lat: 33.803398132324,
    lng: -118.33999633789,
  },
  {
    id: "MBL",
    name: "Manistee Co Blacker Airport",
    city: "Manistee",
    country: "United States",
    lat: 44.2723999,
    lng: -86.24690247,
  },
  {
    id: "PGD",
    name: "Charlotte County Airport",
    city: "Punta Gorda",
    country: "United States",
    lat: 26.92020035,
    lng: -81.9905014,
  },
  {
    id: "WFK",
    name: "Northern Aroostook Regional Airport",
    city: "Frenchville",
    country: "United States",
    lat: 47.2854995728,
    lng: -68.31279754639999,
  },
  {
    id: "JHW",
    name: "Chautauqua County-Jamestown Airport",
    city: "Jamestown",
    country: "United States",
    lat: 42.15340042,
    lng: -79.25800323,
  },
  {
    id: "YTM",
    name: "La Macaza / Mont-Tremblant International Inc Airport",
    city: "Mont-Tremblant",
    country: "Canada",
    lat: 46.409400939899996,
    lng: -74.7799987793,
  },
  {
    id: "SME",
    name: "Lake Cumberland Regional Airport",
    city: "Somerset",
    country: "United States",
    lat: 37.053398132299996,
    lng: -84.6158981323,
  },
  {
    id: "SHD",
    name: "Shenandoah Valley Regional Airport",
    city: "Weyers Cave",
    country: "United States",
    lat: 38.2638015747,
    lng: -78.8964004517,
  },
  {
    id: "DVL",
    name: "Devils Lake Regional Airport",
    city: "Devils Lake",
    country: "United States",
    lat: 48.11420059,
    lng: -98.90879822,
  },
  {
    id: "DIK",
    name: "Dickinson Theodore Roosevelt Regional Airport",
    city: "Dickinson",
    country: "United States",
    lat: 46.7974014282,
    lng: -102.802001953,
  },
  {
    id: "SDY",
    name: "Sidney - Richland Regional Airport",
    city: "Sidney",
    country: "United States",
    lat: 47.706902,
    lng: -104.193001,
  },
  {
    id: "CDR",
    name: "Chadron Municipal Airport",
    city: "Chadron",
    country: "United States",
    lat: 42.837600708,
    lng: -103.095001221,
  },
  {
    id: "AIA",
    name: "Alliance Municipal Airport",
    city: "Alliance",
    country: "United States",
    lat: 42.0531997681,
    lng: -102.804000854,
  },
  {
    id: "MCK",
    name: "Mc Cook Ben Nelson Regional Airport",
    city: "McCook",
    country: "United States",
    lat: 40.20629883,
    lng: -100.5920029,
  },
  {
    id: "MTH",
    name: "The Florida Keys Marathon Airport",
    city: "Marathon",
    country: "United States",
    lat: 24.726101,
    lng: -81.051399,
  },
  {
    id: "GDV",
    name: "Dawson Community Airport",
    city: "Glendive",
    country: "United States",
    lat: 47.13869858,
    lng: -104.8069992,
  },
  {
    id: "OLF",
    name: "L M Clayton Airport",
    city: "Wolf Point",
    country: "United States",
    lat: 48.094501495399996,
    lng: -105.574996948,
  },
  {
    id: "WYS",
    name: "Yellowstone Airport",
    city: "West Yellowstone",
    country: "United States",
    lat: 44.68840027,
    lng: -111.1179962,
  },
  {
    id: "ALS",
    name: "San Luis Valley Regional Bergman Field",
    city: "Alamosa",
    country: "United States",
    lat: 37.434898,
    lng: -105.866997,
  },
  {
    id: "CNY",
    name: "Canyonlands Field",
    city: "Moab",
    country: "United States",
    lat: 38.75500107,
    lng: -109.7549973,
  },
  {
    id: "ELY",
    name: "Ely Airport Yelland Field",
    city: "Ely",
    country: "United States",
    lat: 39.29970169,
    lng: -114.8420029,
  },
  {
    id: "VEL",
    name: "Vernal Regional Airport",
    city: "Vernal",
    country: "United States",
    lat: 40.4408989,
    lng: -109.5100021,
  },
  {
    id: "RUI",
    name: "Sierra Blanca Regional Airport",
    city: "Ruidoso",
    country: "United States",
    lat: 33.462799072266,
    lng: -105.53500366211,
  },
  {
    id: "SOW",
    name: "Show Low Regional Airport",
    city: "Show Low",
    country: "United States",
    lat: 34.265499115,
    lng: -110.005996704,
  },
  {
    id: "MYL",
    name: "McCall Municipal Airport",
    city: "McCall",
    country: "United States",
    lat: 44.88970184,
    lng: -116.1009979,
  },
  {
    id: "SMN",
    name: "Lemhi County Airport",
    city: "Salmon",
    country: "United States",
    lat: 45.1237983704,
    lng: -113.880996704,
  },
  {
    id: "MMH",
    name: "Mammoth Yosemite Airport",
    city: "Mammoth Lakes",
    country: "United States",
    lat: 37.62409973,
    lng: -118.8379974,
  },
  {
    id: "FRD",
    name: "Friday Harbor Airport",
    city: "Friday Harbor",
    country: "United States",
    lat: 48.5219993591,
    lng: -123.024002075,
  },
  {
    id: "ESD",
    name: "Orcas Island Airport",
    city: "Eastsound",
    country: "United States",
    lat: 48.7081985474,
    lng: -122.910003662,
  },
  {
    id: "AST",
    name: "Astoria Regional Airport",
    city: "Astoria",
    country: "United States",
    lat: 46.158000946,
    lng: -123.878997803,
  },
  {
    id: "ONP",
    name: "Newport Municipal Airport",
    city: "Newport",
    country: "United States",
    lat: 44.580399,
    lng: -124.057999,
  },
  {
    id: "EMK",
    name: "Emmonak Airport",
    city: "Emmonak",
    country: "United States",
    lat: 62.78609848,
    lng: -164.4909973,
  },
  {
    id: "UNK",
    name: "Unalakleet Airport",
    city: "Unalakleet",
    country: "United States",
    lat: 63.88840103,
    lng: -160.798996,
  },
  {
    id: "UUK",
    name: "Ugnu-Kuparuk Airport",
    city: "Kuparuk",
    country: "United States",
    lat: 70.33080291750001,
    lng: -149.598007202,
  },
  {
    id: "SHX",
    name: "Shageluk Airport",
    city: "Shageluk",
    country: "United States",
    lat: 62.6922988892,
    lng: -159.569000244,
  },
  {
    id: "CHU",
    name: "Chuathbaluk Airport",
    city: "Chuathbaluk",
    country: "United States",
    lat: 61.579102,
    lng: -159.216003,
  },
  {
    id: "NUI",
    name: "Nuiqsut Airport",
    city: "Nuiqsut",
    country: "United States",
    lat: 70.2099990845,
    lng: -151.005996704,
  },
  {
    id: "EEK",
    name: "Eek Airport",
    city: "Eek",
    country: "United States",
    lat: 60.21367264,
    lng: -162.0438843,
  },
  {
    id: "KUK",
    name: "Kasigluk Airport",
    city: "Kasigluk",
    country: "United States",
    lat: 60.87440109,
    lng: -162.5240021,
  },
  {
    id: "KWT",
    name: "Kwethluk Airport",
    city: "Kwethluk",
    country: "United States",
    lat: 60.790298461899994,
    lng: -161.444000244,
  },
  {
    id: "KWK",
    name: "Kwigillingok Airport",
    city: "Kwigillingok",
    country: "United States",
    lat: 59.876499,
    lng: -163.169005,
  },
  {
    id: "MLL",
    name: "Marshall Don Hunter Sr Airport",
    city: "Marshall",
    country: "United States",
    lat: 61.8642997742,
    lng: -162.026000977,
  },
  {
    id: "RSH",
    name: "Russian Mission Airport",
    city: "Russian Mission",
    country: "United States",
    lat: 61.7788848877,
    lng: -161.319458008,
  },
  {
    id: "KGK",
    name: "Koliganek Airport",
    city: "Koliganek",
    country: "United States",
    lat: 59.726600647,
    lng: -157.259002686,
  },
  {
    id: "KMO",
    name: "Manokotak Airport",
    city: "Manokotak",
    country: "United States",
    lat: 58.990200042699996,
    lng: -159.050003052,
  },
  {
    id: "CIK",
    name: "Chalkyitsik Airport",
    city: "Chalkyitsik",
    country: "United States",
    lat: 66.6449966431,
    lng: -143.740005493,
  },
  {
    id: "EAA",
    name: "Eagle Airport",
    city: "Eagle",
    country: "United States",
    lat: 64.77639771,
    lng: -141.151001,
  },
  {
    id: "HUS",
    name: "Hughes Airport",
    city: "Hughes",
    country: "United States",
    lat: 66.04109955,
    lng: -154.2630005,
  },
  {
    id: "HSL",
    name: "Huslia Airport",
    city: "Huslia",
    country: "United States",
    lat: 65.69789886,
    lng: -156.3509979,
  },
  {
    id: "NUL",
    name: "Nulato Airport",
    city: "Nulato",
    country: "United States",
    lat: 64.729301,
    lng: -158.074005,
  },
  {
    id: "VEE",
    name: "Venetie Airport",
    city: "Venetie",
    country: "United States",
    lat: 67.0086975098,
    lng: -146.365997314,
  },
  {
    id: "WBQ",
    name: "Beaver Airport",
    city: "Beaver",
    country: "United States",
    lat: 66.362197876,
    lng: -147.406997681,
  },
  {
    id: "CEM",
    name: "Central Airport",
    city: "Central",
    country: "United States",
    lat: 65.57379913,
    lng: -144.7830048,
  },
  {
    id: "SHG",
    name: "Shungnak Airport",
    city: "Shungnak",
    country: "United States",
    lat: 66.88809967041,
    lng: -157.16200256348,
  },
  {
    id: "IYK",
    name: "Inyokern Airport",
    city: "Inyokern",
    country: "United States",
    lat: 35.65879822,
    lng: -117.8300018,
  },
  {
    id: "VIS",
    name: "Visalia Municipal Airport",
    city: "Visalia",
    country: "United States",
    lat: 36.3186988831,
    lng: -119.392997742,
  },
  {
    id: "MCE",
    name: "Merced Regional Macready Field",
    city: "Merced",
    country: "United States",
    lat: 37.28469849,
    lng: -120.5139999,
  },
  {
    id: "CYR",
    name: "Laguna de Los Patos International Airport",
    city: "Colonia",
    country: "Uruguay",
    lat: -34.456401824951,
    lng: -57.770599365234,
  },
  {
    id: "CPQ",
    name: "Amarais Airport",
    city: "Campinas",
    country: "Brazil",
    lat: -22.85919952392578,
    lng: -47.10820007324219,
  },
  {
    id: "GYR",
    name: "Phoenix Goodyear Airport",
    city: "Goodyear",
    country: "United States",
    lat: 33.4225006104,
    lng: -112.375999451,
  },
  {
    id: "TWB",
    name: "Toowoomba Airport",
    city: "Toowoomba",
    country: "Australia",
    lat: -27.542801,
    lng: 151.916,
  },
  {
    id: "BBL",
    name: "Ballera Airport",
    city: "Ballera",
    country: "Australia",
    lat: -27.405633,
    lng: 141.809458,
  },
  {
    id: "N",
    name: "Gatton Campus Airport",
    city: "Gatton",
    country: "Australia",
    lat: -27.5604060653,
    lng: 152.340459824,
  },
  {
    id: "AYK",
    name: "Arkalyk North Airport",
    city: "Arkalyk",
    country: "Kazakhstan",
    lat: 50.318599700927734,
    lng: 66.95279693603516,
  },
  {
    id: "N",
    name: "Nabern/Teck Airport",
    city: "Kirchheim-Teck",
    country: "Germany",
    lat: 48.61277771,
    lng: 9.477222442629998,
  },
  {
    id: "AGN",
    name: "Angoon Seaplane Base",
    city: "Angoon",
    country: "United States",
    lat: 57.503601,
    lng: -134.585007,
  },
  {
    id: "ELV",
    name: "Elfin Cove Seaplane Base",
    city: "Elfin Cove",
    country: "United States",
    lat: 58.195201873799995,
    lng: -136.347000122,
  },
  {
    id: "FNR",
    name: "Funter Bay Seaplane Base",
    city: "Funter Bay",
    country: "United States",
    lat: 58.2543983459,
    lng: -134.897994995,
  },
  {
    id: "HNH",
    name: "Hoonah Airport",
    city: "Hoonah",
    country: "United States",
    lat: 58.0961,
    lng: -135.410111,
  },
  {
    id: "N",
    name: "Kake Airport",
    city: "Kake",
    country: "United States",
    lat: 56.9613990784,
    lng: -133.910003662,
  },
  {
    id: "MTM",
    name: "Metlakatla Seaplane Base",
    city: "Metakatla",
    country: "United States",
    lat: 55.131001,
    lng: -131.578003,
  },
  {
    id: "HYG",
    name: "Hydaburg Seaplane Base",
    city: "Hydaburg",
    country: "United States",
    lat: 55.206298828125,
    lng: -132.8280029296875,
  },
  {
    id: "EGX",
    name: "Egegik Airport",
    city: "Egegik",
    country: "United States",
    lat: 58.1855010986,
    lng: -157.375,
  },
  {
    id: "KPV",
    name: "Perryville Airport",
    city: "Perryville",
    country: "United States",
    lat: 55.905998,
    lng: -159.162993,
  },
  {
    id: "PIP",
    name: "Pilot Point Airport",
    city: "Pilot Point",
    country: "United States",
    lat: 57.5803985596,
    lng: -157.572006226,
  },
  {
    id: "WSN",
    name: "South Naknek Nr 2 Airport",
    city: "South Naknek",
    country: "United States",
    lat: 58.7033996582,
    lng: -157.007995605,
  },
  {
    id: "AKK",
    name: "Akhiok Airport",
    city: "Akhiok",
    country: "United States",
    lat: 56.9387016296,
    lng: -154.182998657,
  },
  {
    id: "KYK",
    name: "Karluk Airport",
    city: "Karluk",
    country: "United States",
    lat: 57.5671005249,
    lng: -154.449996948,
  },
  {
    id: "KLN",
    name: "Larsen Bay Airport",
    city: "Larsen Bay",
    country: "United States",
    lat: 57.5350990295,
    lng: -153.977996826,
  },
  {
    id: "ABL",
    name: "Ambler Airport",
    city: "Ambler",
    country: "United States",
    lat: 67.1063,
    lng: -157.856989,
  },
  {
    id: "BKC",
    name: "Buckland Airport",
    city: "Buckland",
    country: "United States",
    lat: 65.9815979004,
    lng: -161.149002075,
  },
  {
    id: "IAN",
    name: "Bob Baker Memorial Airport",
    city: "Kiana",
    country: "United States",
    lat: 66.9759979248,
    lng: -160.43699646,
  },
  {
    id: "OBU",
    name: "Kobuk Airport",
    city: "Kobuk",
    country: "United States",
    lat: 66.9123001099,
    lng: -156.897003174,
  },
  {
    id: "ORV",
    name: "Robert (Bob) Curtis Memorial Airport",
    city: "Noorvik",
    country: "United States",
    lat: 66.81790161,
    lng: -161.0189972,
  },
  {
    id: "WLK",
    name: "Selawik Airport",
    city: "Selawik",
    country: "United States",
    lat: 66.60009766,
    lng: -159.9859924,
  },
  {
    id: "KTS",
    name: "Brevig Mission Airport",
    city: "Brevig Mission",
    country: "United States",
    lat: 65.3312988281,
    lng: -166.466003418,
  },
  {
    id: "ELI",
    name: "Elim Airport",
    city: "Elim",
    country: "United States",
    lat: 64.61470032,
    lng: -162.2720032,
  },
  {
    id: "GLV",
    name: "Golovin Airport",
    city: "Golovin",
    country: "United States",
    lat: 64.5504989624,
    lng: -163.007003784,
  },
  {
    id: "TLA",
    name: "Teller Airport",
    city: "Teller",
    country: "United States",
    lat: 65.2404022217,
    lng: -166.339004517,
  },
  {
    id: "WAA",
    name: "Wales Airport",
    city: "Wales",
    country: "United States",
    lat: 65.622593,
    lng: -168.095,
  },
  {
    id: "WMO",
    name: "White Mountain Airport",
    city: "White Mountain",
    country: "United States",
    lat: 64.689201355,
    lng: -163.412994385,
  },
  {
    id: "KKA",
    name: "Koyuk Alfred Adams Airport",
    city: "Koyuk",
    country: "United States",
    lat: 64.9394989014,
    lng: -161.154006958,
  },
  {
    id: "SMK",
    name: "St Michael Airport",
    city: "St. Michael",
    country: "United States",
    lat: 63.49010086,
    lng: -162.1100006,
  },
  {
    id: "SKK",
    name: "Shaktoolik Airport",
    city: "Shaktoolik",
    country: "United States",
    lat: 64.37110138,
    lng: -161.223999,
  },
  {
    id: "TNC",
    name: "Tin City Long Range Radar Station Airport",
    city: "Tin City",
    country: "United States",
    lat: 65.56310272,
    lng: -167.9219971,
  },
  {
    id: "AKB",
    name: "Atka Airport",
    city: "Atka",
    country: "United States",
    lat: 52.22029877,
    lng: -174.2059937,
  },
  {
    id: "IKO",
    name: "Nikolski Air Station",
    city: "Nikolski",
    country: "United States",
    lat: 52.94160079956055,
    lng: -168.8489990234375,
  },
  {
    id: "CYT",
    name: "Yakataga Airport",
    city: "Yakataga",
    country: "United States",
    lat: 60.080974,
    lng: -142.494541,
  },
  {
    id: "AUK",
    name: "Alakanuk Airport",
    city: "Alakanuk",
    country: "United States",
    lat: 62.680042266799994,
    lng: -164.659927368,
  },
  {
    id: "KPN",
    name: "Kipnuk Airport",
    city: "Kipnuk",
    country: "United States",
    lat: 59.932998657199995,
    lng: -164.031005859,
  },
  {
    id: "KFP",
    name: "False Pass Airport",
    city: "False Pass",
    country: "United States",
    lat: 54.8474006652832,
    lng: -163.41000366210938,
  },
  {
    id: "NLG",
    name: "Nelson Lagoon Airport",
    city: "Nelson Lagoon",
    country: "United States",
    lat: 56.007499694824,
    lng: -161.16000366211,
  },
  {
    id: "PML",
    name: "Port Moller Airport",
    city: "Cold Bay",
    country: "United States",
    lat: 56.0060005188,
    lng: -160.561004639,
  },
  {
    id: "KLW",
    name: "Klawock Airport",
    city: "Klawock",
    country: "United States",
    lat: 55.579200744599994,
    lng: -133.076004028,
  },
  {
    id: "KWN",
    name: "Quinhagak Airport",
    city: "Quinhagak",
    country: "United States",
    lat: 59.7551,
    lng: -161.845,
  },
  {
    id: "KOT",
    name: "Kotlik Airport",
    city: "Kotlik",
    country: "United States",
    lat: 63.0306015015,
    lng: -163.533004761,
  },
  {
    id: "KYU",
    name: "Koyukuk Airport",
    city: "Koyukuk",
    country: "United States",
    lat: 64.8760986328,
    lng: -157.727005005,
  },
  {
    id: "SCM",
    name: "Scammon Bay Airport",
    city: "Scammon Bay",
    country: "United States",
    lat: 61.845298767100005,
    lng: -165.570999146,
  },
  {
    id: "NNL",
    name: "Nondalton Airport",
    city: "Nondalton",
    country: "United States",
    lat: 59.980201721191,
    lng: -154.8390045166,
  },
  {
    id: "KKH",
    name: "Kongiganak Airport",
    city: "Kongiganak",
    country: "United States",
    lat: 59.960800170899994,
    lng: -162.880996704,
  },
  {
    id: "NIB",
    name: "Nikolai Airport",
    city: "Nikolai",
    country: "United States",
    lat: 63.0186,
    lng: -154.358002,
  },
  {
    id: "AKI",
    name: "Akiak Airport",
    city: "Akiak",
    country: "United States",
    lat: 60.9029006958,
    lng: -161.231002808,
  },
  {
    id: "AIN",
    name: "Wainwright Airport",
    city: "Wainwright",
    country: "United States",
    lat: 70.6380004883,
    lng: -159.994995117,
  },
  {
    id: "APZ",
    name: "Zapala Airport",
    city: "ZAPALA",
    country: "Argentina",
    lat: -38.975498,
    lng: -70.113602,
  },
  {
    id: "RDS",
    name: "Rincon De Los Sauces Airport",
    city: "Rincon de los Sauces",
    country: "Argentina",
    lat: -37.3905982971,
    lng: -68.9041976929,
  },
  {
    id: "PNT",
    name: "Tte. Julio Gallardo Airport",
    city: "Puerto Natales",
    country: "Chile",
    lat: -51.67150115966797,
    lng: -72.52839660644531,
  },
  {
    id: "SGV",
    name: "Sierra Grande Airport",
    city: "Sierra Grande",
    country: "Argentina",
    lat: -41.5917015076,
    lng: -65.33940124509999,
  },
  {
    id: "IGB",
    name: "Cabo F.A.A. H. R. Bordón Airport",
    city: "Ingeniero Jacobacci",
    country: "Argentina",
    lat: -41.320899963399995,
    lng: -69.5748977661,
  },
  {
    id: "NCN",
    name: "Chenega Bay Airport",
    city: "Chenega",
    country: "United States",
    lat: 60.0773010254,
    lng: -147.992004395,
  },
  {
    id: "TKJ",
    name: "Tok Junction Airport",
    city: "Tok",
    country: "United States",
    lat: 63.32949829,
    lng: -142.9539948,
  },
  {
    id: "IRC",
    name: "Circle City /New/ Airport",
    city: "Circle",
    country: "United States",
    lat: 65.830498,
    lng: -144.076008,
  },
  {
    id: "SLQ",
    name: "Sleetmute Airport",
    city: "Sleetmute",
    country: "United States",
    lat: 61.7005004883,
    lng: -157.166000366,
  },
  {
    id: "N",
    name: "Healy River Airport",
    city: "Healy",
    country: "United States",
    lat: 63.8661994934082,
    lng: -148.968994140625,
  },
  {
    id: "N",
    name: "Klawock Seaplane Base",
    city: "Klawock",
    country: "United States",
    lat: 55.5546989440918,
    lng: -133.1020050048828,
  },
  {
    id: "LMA",
    name: "Minchumina Airport",
    city: "Lake Minchumina",
    country: "United States",
    lat: 63.886002,
    lng: -152.302002,
  },
  {
    id: "MLY",
    name: "Manley Hot Springs Airport",
    city: "Manley Hot Springs",
    country: "United States",
    lat: 64.99759674069999,
    lng: -150.643997192,
  },
  {
    id: "YNP",
    name: "Natuashish Airport",
    city: "Natuashish",
    country: "Canada",
    lat: 55.913898,
    lng: -61.184399,
  },
  {
    id: "YSO",
    name: "Postville Airport",
    city: "Postville",
    country: "Canada",
    lat: 54.9105,
    lng: -59.78507,
  },
  {
    id: "YWB",
    name: "Kangiqsujuaq (Wakeham Bay) Airport",
    city: "Kangiqsujuaq",
    country: "Canada",
    lat: 61.5886001587,
    lng: -71.929397583,
  },
  {
    id: "YTF",
    name: "Alma Airport",
    city: "Alma",
    country: "Canada",
    lat: 48.50889968869999,
    lng: -71.64189910889999,
  },
  {
    id: "YGV",
    name: "Havre St Pierre Airport",
    city: "Havre-Saint-Pierre",
    country: "Canada",
    lat: 50.281898498535156,
    lng: -63.61140060424805,
  },
  {
    id: "YXK",
    name: "Rimouski Airport",
    city: "Rimouski",
    country: "Canada",
    lat: 48.47809982299805,
    lng: -68.49690246582031,
  },
  {
    id: "XTL",
    name: "Tadoule Lake Airport",
    city: "Tadoule Lake",
    country: "Canada",
    lat: 58.7061,
    lng: -98.512199,
  },
  {
    id: "XLB",
    name: "Lac Brochet Airport",
    city: "Lac Brochet",
    country: "Canada",
    lat: 58.6175003052,
    lng: -101.46900177,
  },
  {
    id: "XSI",
    name: "South Indian Lake Airport",
    city: "South Indian Lake",
    country: "Canada",
    lat: 56.7928009033,
    lng: -98.9072036743,
  },
  {
    id: "YBT",
    name: "Brochet Airport",
    city: "Brochet",
    country: "Canada",
    lat: 57.8894,
    lng: -101.679001,
  },
  {
    id: "ZGR",
    name: "Little Grand Rapids Airport",
    city: "Little Grand Rapids",
    country: "Canada",
    lat: 52.04560089111328,
    lng: -95.4657974243164,
  },
  {
    id: "YCR",
    name: "Cross Lake (Charlie Sinclair Memorial) Airport",
    city: "Cross Lake",
    country: "Canada",
    lat: 54.610599517822266,
    lng: -97.76080322265625,
  },
  {
    id: "YRS",
    name: "Red Sucker Lake Airport",
    city: "Red Sucker Lake",
    country: "Canada",
    lat: 54.167198181152344,
    lng: -93.55719757080078,
  },
  {
    id: "YOP",
    name: "Rainbow Lake Airport",
    city: "Rainbow Lake",
    country: "Canada",
    lat: 58.49140167236328,
    lng: -119.40799713134766,
  },
  {
    id: "YBY",
    name: "Bonnyville Airport",
    city: "Bonnyville",
    country: "Canada",
    lat: 54.304199,
    lng: -110.744003,
  },
  {
    id: "ZNA",
    name: "Nanaimo Harbour Water Airport",
    city: "Nanaimo",
    country: "Canada",
    lat: 49.1833000183,
    lng: -123.949996948,
  },
  {
    id: "YGG",
    name: "Ganges Seaplane Base",
    city: "Ganges",
    country: "Canada",
    lat: 48.8545,
    lng: -123.4969,
  },
  {
    id: "N",
    name: "Fort St James Airport",
    city: "Fort St. James",
    country: "Canada",
    lat: 54.39720153808594,
    lng: -124.26300048828125,
  },
  {
    id: "YDT",
    name: "Boundary Bay Airport",
    city: "Boundary Bay",
    country: "Canada",
    lat: 49.0742,
    lng: -123.012001,
  },
  {
    id: "YLY",
    name: "Langley Airport",
    city: "Langley Township",
    country: "Canada",
    lat: 49.10079956049999,
    lng: -122.630996704,
  },
  {
    id: "N",
    name: "Denny Island Airport",
    city: "Bella Bella",
    country: "Canada",
    lat: 52.137937,
    lng: -128.059748,
  },
  {
    id: "YFJ",
    name: "Wekweètì Airport",
    city: "Wekweeti",
    country: "Canada",
    lat: 64.190804,
    lng: -114.077002,
  },
  {
    id: "N",
    name: "Camaguey-Campo Cuatro Milpas Airport",
    city: "Guasave",
    country: "Mexico",
    lat: 25.652200698853,
    lng: -108.53800201416,
  },
  {
    id: "N",
    name: "Cabo San Lucas International Airport",
    city: "Cabo San Lucas",
    country: "Mexico",
    lat: 22.947701,
    lng: -109.936996,
  },
  {
    id: "RNI",
    name: "Corn Island",
    city: "Corn Island",
    country: "Nicaragua",
    lat: 12.1628999710083,
    lng: -83.06379699707031,
  },
  {
    id: "BZA",
    name: "San Pedro Airport",
    city: "Bonanza",
    country: "Nicaragua",
    lat: 13.949999809265137,
    lng: -84.5999984741211,
  },
  {
    id: "RFS",
    name: "Rosita Airport",
    city: "Rosita",
    country: "Nicaragua",
    lat: 13.889699935913086,
    lng: -84.40889739990234,
  },
  {
    id: "SIU",
    name: "Siuna",
    city: "Siuna",
    country: "Nicaragua",
    lat: 13.727222442626953,
    lng: -84.77777862548828,
  },
  {
    id: "WSP",
    name: "Waspam Airport",
    city: "Waspam",
    country: "Nicaragua",
    lat: 14.7391996383667,
    lng: -83.96939849853516,
  },
  {
    id: "NCR",
    name: "San Carlos",
    city: "San Carlos",
    country: "Nicaragua",
    lat: 11.133399963378906,
    lng: -84.7699966430664,
  },
  {
    id: "PLD",
    name: "Playa Samara/Carrillo Airport",
    city: "Carrillo",
    country: "Costa Rica",
    lat: 9.8705101013184,
    lng: -85.481399536133,
  },
  {
    id: "COZ",
    name: "Constanza - Expedición 14 de Junio National Airport",
    city: "Constanza",
    country: "Dominican Republic",
    lat: 18.907499313354,
    lng: -70.721900939941,
  },
  {
    id: "NEG",
    name: "Negril Airport",
    city: "Negril",
    country: "Jamaica",
    lat: 18.34280014038086,
    lng: -78.33209991455078,
  },
  {
    id: "NRR",
    name: "José Aponte de la Torre Airport",
    city: "Ceiba",
    country: "Puerto Rico",
    lat: 18.245300293,
    lng: -65.6434020996,
  },
  {
    id: "SPB",
    name: "Charlotte Amalie Harbor Seaplane Base",
    city: "Charlotte Amalie",
    country: "Virgin Islands",
    lat: 18.338600158691406,
    lng: -64.9406967163086,
  },
  {
    id: "ARR",
    name: "D. Casimiro Szlapelis Airport",
    city: "Alto Rio Senguer",
    country: "Argentina",
    lat: -45.013599,
    lng: -70.812202,
  },
  {
    id: "JSM",
    name: "Jose De San Martin Airport",
    city: "Jose de San Martin",
    country: "Argentina",
    lat: -44.048599243199995,
    lng: -70.4589004517,
  },
  {
    id: "UYU",
    name: "Uyuni Airport",
    city: "Uyuni",
    country: "Bolivia",
    lat: -20.446300506599997,
    lng: -66.8483963013,
  },
  {
    id: "RBQ",
    name: "Rurenabaque Airport",
    city: "Rerrenabaque",
    country: "Bolivia",
    lat: -14.427900314299999,
    lng: -67.4968032837,
  },
  {
    id: "ABF",
    name: "Abaiang Airport",
    city: "Abaiang Atoll",
    country: "Kiribati",
    lat: 1.798609972000122,
    lng: 173.04100036621094,
  },
  {
    id: "N",
    name: "Afobakka Airstrip",
    city: "Afobaka",
    country: "Suriname",
    lat: 4.998505,
    lng: -54.992033,
  },
  {
    id: "N",
    name: "Alalapadu Airstrip",
    city: "Alapadu",
    country: "Suriname",
    lat: 2.5235,
    lng: -56.3247,
  },
  {
    id: "ABN",
    name: "Albina Airport",
    city: "Albina",
    country: "Suriname",
    lat: 5.512720108032227,
    lng: -54.05009841918945,
  },
  {
    id: "N",
    name: "Lawa Anapaike Airstrip",
    city: "Anapaike",
    country: "Suriname",
    lat: 3.411301,
    lng: -54.028049,
  },
  {
    id: "N",
    name: "Apetina Airstrip",
    city: "Apetina",
    country: "Suriname",
    lat: 3.50278,
    lng: -55.058791,
  },
  {
    id: "DRJ",
    name: "Drietabbetje Airport",
    city: "Drietabbetje",
    country: "Suriname",
    lat: 4.111359,
    lng: -54.672766,
  },
  {
    id: "N",
    name: "Kabalebo Airport",
    city: "Kabalebo",
    country: "Suriname",
    lat: 4.406,
    lng: -57.223,
  },
  {
    id: "N",
    name: "Kayser Airport",
    city: "Kayser",
    country: "Suriname",
    lat: 3.094343,
    lng: -56.472702,
  },
  {
    id: "N",
    name: "Kwamalasoemoetoe Airport",
    city: "Kwamelasemoetoe",
    country: "Suriname",
    lat: 2.354427,
    lng: -56.792431,
  },
  {
    id: "MOJ",
    name: "Moengo Airstrip",
    city: "Moengo",
    country: "Suriname",
    lat: 5.6076,
    lng: -54.4003,
  },
  {
    id: "ICK",
    name: "Nieuw Nickerie Airport",
    city: "Nieuw Nickerie",
    country: "Suriname",
    lat: 5.955560207366943,
    lng: -57.039398193359375,
  },
  {
    id: "OEM",
    name: "Vincent Fayks Airport",
    city: "Paloemeu",
    country: "Suriname",
    lat: 3.3452799320220947,
    lng: -55.442501068115234,
  },
  {
    id: "N",
    name: "Sarakreek Airstrip",
    city: "Sarakreek",
    country: "Suriname",
    lat: 4.319444,
    lng: -54.966667,
  },
  {
    id: "N",
    name: "Sipaliwini Airport",
    city: "Sipaliwini",
    country: "Suriname",
    lat: 2.026438,
    lng: -56.126412,
  },
  {
    id: "SMZ",
    name: "Stoelmanseiland Airport",
    city: "Stoelmans Eiland",
    country: "Suriname",
    lat: 4.349999904632568,
    lng: -54.41666793823242,
  },
  {
    id: "TOT",
    name: "Totness Airport",
    city: "Totness",
    country: "Suriname",
    lat: 5.865829944610596,
    lng: -56.32749938964844,
  },
  {
    id: "AGI",
    name: "Wageningen Airstrip",
    city: "Wageningen",
    country: "Suriname",
    lat: 5.841128,
    lng: -56.673328,
  },
  {
    id: "N",
    name: "Codela Airport",
    city: "Guapiles",
    country: "Costa Rica",
    lat: 10.4139995575,
    lng: -85.0916976929,
  },
  {
    id: "ORJ",
    name: "Orinduik Airport",
    city: "Orinduik",
    country: "Guyana",
    lat: 4.725269794464111,
    lng: -60.03499984741211,
  },
  {
    id: "NAI",
    name: "Annai Airport",
    city: "Annai",
    country: "Guyana",
    lat: 3.959439992904663,
    lng: -59.12419891357422,
  },
  {
    id: "N",
    name: "Apoteri Airport",
    city: "Apoteri",
    country: "Guyana",
    lat: 4.013879776000977,
    lng: -58.60499954223633,
  },
  {
    id: "IMB",
    name: "Imbaimadai Airport",
    city: "Imbaimadai",
    country: "Guyana",
    lat: 5.7081098556518555,
    lng: -60.2942008972168,
  },
  {
    id: "KAR",
    name: "Kamarang Airport",
    city: "Kamarang",
    country: "Guyana",
    lat: 5.865340232849121,
    lng: -60.614200592041016,
  },
  {
    id: "USI",
    name: "Mabaruma Airport",
    city: "Mabaruma",
    country: "Guyana",
    lat: 8.199999809265137,
    lng: -59.78329849243164,
  },
  {
    id: "MHA",
    name: "Mahdia Airport",
    city: "Mahdia",
    country: "Guyana",
    lat: 5.277490139007568,
    lng: -59.151100158691406,
  },
  {
    id: "PJC",
    name: "Dr Augusto Roberto Fuster International Airport",
    city: "Pedro Juan Caballero",
    country: "Paraguay",
    lat: -22.639999389648438,
    lng: -55.83000183105469,
  },
  {
    id: "ACD",
    name: "Alcides Fernández Airport",
    city: "Acandi",
    country: "Colombia",
    lat: 8.51667,
    lng: -77.3,
  },
  {
    id: "RVE",
    name: "Los Colonizadores Airport",
    city: "Saravena",
    country: "Colombia",
    lat: 6.951868,
    lng: -71.857179,
  },
  {
    id: "BQJ",
    name: "Batagay Airport",
    city: "Batagay",
    country: "Russia",
    lat: 67.648002624512,
    lng: 134.69500732422,
  },
  {
    id: "VGZ",
    name: "Villa Garzón Airport",
    city: "Villa Garzon",
    country: "Colombia",
    lat: 0.978767,
    lng: -76.6056,
  },
  {
    id: "EBG",
    name: "El Bagre Airport",
    city: "El Bagre",
    country: "Colombia",
    lat: 7.59647,
    lng: -74.8089,
  },
  {
    id: "CAQ",
    name: "Juan H White Airport",
    city: "Caucasia",
    country: "Colombia",
    lat: 7.96847,
    lng: -75.1985,
  },
  {
    id: "COG",
    name: "Mandinga Airport",
    city: "Condoto",
    country: "Colombia",
    lat: 5.08333,
    lng: -76.7,
  },
  {
    id: "TLU",
    name: "Golfo de Morrosquillo Airport",
    city: "Tolu",
    country: "Colombia",
    lat: 9.50945,
    lng: -75.5854,
  },
  {
    id: "CFB",
    name: "Cabo Frio Airport",
    city: "Cabo Frio",
    country: "Brazil",
    lat: -22.921699523900003,
    lng: -42.074298858599995,
  },
  {
    id: "OPS",
    name: "Presidente João Batista Figueiredo Airport",
    city: "Sinop",
    country: "Brazil",
    lat: -11.885000228881836,
    lng: -55.58610916137695,
  },
  {
    id: "GRP",
    name: "Gurupi Airport",
    city: "Gurupi",
    country: "Brazil",
    lat: -11.73960018157959,
    lng: -49.132198333740234,
  },
  {
    id: "CMP",
    name: "Santana do Araguaia Airport",
    city: "Santana do Araguaia",
    country: "Brazil",
    lat: -9.31997013092041,
    lng: -50.32849884033203,
  },
  {
    id: "BVS",
    name: "Breves Airport",
    city: "Breves",
    country: "Brazil",
    lat: -1.6365300416946411,
    lng: -50.443599700927734,
  },
  {
    id: "SFK",
    name: "Soure Airport",
    city: "Soure",
    country: "Brazil",
    lat: -0.6994310021400452,
    lng: -48.520999908447266,
  },
  {
    id: "PIN",
    name: "Parintins Airport",
    city: "Parintins",
    country: "Brazil",
    lat: -2.6730198860168457,
    lng: -56.777198791503906,
  },
  {
    id: "BRA",
    name: "Barreiras Airport",
    city: "Barreiras",
    country: "Brazil",
    lat: -12.078900337219238,
    lng: -45.00899887084961,
  },
  {
    id: "STZ",
    name: "Santa Terezinha Airport",
    city: "Santa Terezinha",
    country: "Brazil",
    lat: -10.4647216796875,
    lng: -50.518611907958984,
  },
  {
    id: "MQH",
    name: "Minaçu Airport",
    city: "Minacu",
    country: "Brazil",
    lat: -13.5491,
    lng: -48.195301,
  },
  {
    id: "AUX",
    name: "Araguaína Airport",
    city: "Araguaina",
    country: "Brazil",
    lat: -7.22787,
    lng: -48.240501,
  },
  {
    id: "NVP",
    name: "Novo Aripuanã Airport",
    city: "Novo Aripuana",
    country: "Brazil",
    lat: -5.118030071258545,
    lng: -60.364898681640625,
  },
  {
    id: "N",
    name: "Fazenda Colen Airport",
    city: "Lucas do Rio Verde",
    country: "Brazil",
    lat: -13.314443588256836,
    lng: -56.11277770996094,
  },
  {
    id: "FRC",
    name: "Tenente Lund Pressoto Airport",
    city: "Franca",
    country: "Brazil",
    lat: -20.592199,
    lng: -47.3829,
  },
  {
    id: "DOU",
    name: "Dourados Airport",
    city: "Dourados",
    country: "Brazil",
    lat: -22.2019,
    lng: -54.926601,
  },
  {
    id: "LBR",
    name: "Lábrea Airport",
    city: "Labrea",
    country: "Brazil",
    lat: -7.278969764709473,
    lng: -64.76950073242188,
  },
  {
    id: "ROO",
    name: "Maestro Marinho Franco Airport",
    city: "Rondonopolis",
    country: "Brazil",
    lat: -16.586,
    lng: -54.7248,
  },
  {
    id: "GPB",
    name: "Tancredo Thomas de Faria Airport",
    city: "Guarapuava",
    country: "Brazil",
    lat: -25.3875007629,
    lng: -51.520198822,
  },
  {
    id: "JCB",
    name: "Santa Terezinha Airport",
    city: "Joacaba",
    country: "Brazil",
    lat: -27.1714000702,
    lng: -51.5532989502,
  },
  {
    id: "RVD",
    name: "General Leite de Castro Airport",
    city: "Rio Verde",
    country: "Brazil",
    lat: -17.8347225189209,
    lng: -50.956111907958984,
  },
  {
    id: "AAX",
    name: "Romeu Zema Airport",
    city: "Araxa",
    country: "Brazil",
    lat: -19.563199996948,
    lng: -46.960399627686,
  },
  {
    id: "MBZ",
    name: "Maués Airport",
    city: "Maues",
    country: "Brazil",
    lat: -3.37217,
    lng: -57.7248,
  },
  {
    id: "RBB",
    name: "Borba Airport",
    city: "Borba",
    country: "Brazil",
    lat: -4.4063401222229,
    lng: -59.60240173339844,
  },
  {
    id: "CIZ",
    name: "Coari Airport",
    city: "Coari",
    country: "Brazil",
    lat: -4.134059906005859,
    lng: -63.132598876953125,
  },
  {
    id: "BAZ",
    name: "Barcelos Airport",
    city: "Barcelos",
    country: "Brazil",
    lat: -0.981292,
    lng: -62.919601,
  },
  {
    id: "DMT",
    name: "Diamantino Airport",
    city: "Diamantino",
    country: "Brazil",
    lat: -14.376899719238281,
    lng: -56.40039825439453,
  },
  {
    id: "GNM",
    name: "Guanambi Airport",
    city: "Guanambi",
    country: "Brazil",
    lat: -14.208200454711914,
    lng: -42.74610137939453,
  },
  {
    id: "QDJ",
    name: "Tsletsi Airport",
    city: "Djelfa",
    country: "Algeria",
    lat: 34.6657,
    lng: 3.351,
  },
  {
    id: "NZA",
    name: "Nzagi Airport",
    city: "Nzagi",
    country: "Angola",
    lat: -7.716939926149999,
    lng: 21.358200073200003,
  },
  {
    id: "LBZ",
    name: "Lucapa Airport",
    city: "Lucapa",
    country: "Angola",
    lat: -8.445727348330001,
    lng: 20.7320861816,
  },
  {
    id: "KNP",
    name: "Capanda Airport",
    city: "Kapanda",
    country: "Angola",
    lat: -9.76937007904,
    lng: 15.4553194046,
  },
  {
    id: "AMC",
    name: "Am Timan Airport",
    city: "Am Timan",
    country: "Chad",
    lat: 11.0340003967,
    lng: 20.274000167799997,
  },
  {
    id: "GSQ",
    name: "Shark El Oweinat International Airport",
    city: "Sharq Al-Owainat",
    country: "Egypt",
    lat: 22.5856990814209,
    lng: 28.71660041809082,
  },
  {
    id: "MRB",
    name: "Eastern WV Regional Airport/Shepherd Field",
    city: "Martinsburg",
    country: "United States",
    lat: 39.40190125,
    lng: -77.98459625,
  },
  {
    id: "AWA",
    name: "Awassa Airport",
    city: "Awasa",
    country: "Ethiopia",
    lat: 7.066999912261963,
    lng: 38.5,
  },
  {
    id: "JIJ",
    name: "Wilwal International Airport",
    city: "Jijiga",
    country: "Ethiopia",
    lat: 9.3325,
    lng: 42.9121,
  },
  {
    id: "MKS",
    name: "Mekane Selam Airport",
    city: "Mekane Selam",
    country: "Ethiopia",
    lat: 10.7254,
    lng: 38.7415,
  },
  {
    id: "DBM",
    name: "Debra Marcos Airport",
    city: "Debre Marqos",
    country: "Ethiopia",
    lat: 10.350000381469727,
    lng: 37.71699905395508,
  },
  {
    id: "DBT",
    name: "Debre Tabor Airport",
    city: "Debre Tabor",
    country: "Ethiopia",
    lat: 11.967000007629395,
    lng: 38.0,
  },
  {
    id: "QHR",
    name: "Harar Meda Airport",
    city: "Debre Zeyit",
    country: "Ethiopia",
    lat: 8.7163,
    lng: 39.0059,
  },
  {
    id: "GOB",
    name: "Robe Airport",
    city: "Goba",
    country: "Ethiopia",
    lat: 7.1160634,
    lng: 40.0463033,
  },
  {
    id: "MYB",
    name: "Mayumba Airport",
    city: "Mayumba",
    country: "Gabon",
    lat: -3.4584197998046875,
    lng: 10.674076080322266,
  },
  {
    id: "MRE",
    name: "Mara Serena Lodge Airstrip",
    city: "Masai Mara",
    country: "Kenya",
    lat: -1.406111,
    lng: 35.008057,
  },
  {
    id: "JJM",
    name: "Mulika Lodge Airport",
    city: "Meru National Park",
    country: "Kenya",
    lat: 0.165083006024,
    lng: 38.1951408386,
  },
  {
    id: "RBX",
    name: "Rumbek Airport",
    city: "Rumbek",
    country: "Sudan",
    lat: 6.8249998092699995,
    lng: 29.6690006256,
  },
  {
    id: "N",
    name: "Yei Airport",
    city: "Yei",
    country: "Sudan",
    lat: 4.13028160099,
    lng: 30.7280731201,
  },
  {
    id: "CPA",
    name: "Cape Palmas Airport",
    city: "Greenville",
    country: "Liberia",
    lat: 4.3790202140808105,
    lng: -7.6969499588012695,
  },
  {
    id: "N",
    name: "Ecuvillens Airport",
    city: "Ecuvillens",
    country: "Switzerland",
    lat: 46.755001068115234,
    lng: 7.076109886169434,
  },
  {
    id: "IHC",
    name: "Inhaca Airport",
    city: "Inhaca",
    country: "Mozambique",
    lat: -25.9971446991,
    lng: 32.929351806599996,
  },
  {
    id: "MAX",
    name: "Ouro Sogui Airport",
    city: "Matam",
    country: "Senegal",
    lat: 15.593600273132324,
    lng: -13.322799682617188,
  },
  {
    id: "BDI",
    name: "Bird Island Airport",
    city: "Bird Island",
    country: "Seychelles",
    lat: -3.72472,
    lng: 55.205299,
  },
  {
    id: "WHF",
    name: "Wadi Halfa Airport",
    city: "Wadi Halfa",
    country: "Sudan",
    lat: 21.802698135375977,
    lng: 31.521577835083008,
  },
  {
    id: "NBE",
    name: "Enfidha - Hammamet International Airport",
    city: "Enfidha",
    country: "Tunisia",
    lat: 36.075833,
    lng: 10.438611,
  },
  {
    id: "N",
    name: "Kidepo Airport",
    city: "Kidepo",
    country: "Uganda",
    lat: 3.7176,
    lng: 33.7487,
  },
  {
    id: "N",
    name: "Kitgum Airport",
    city: "Kitgum",
    country: "Uganda",
    lat: 3.2817,
    lng: 32.8882,
  },
  {
    id: "N",
    name: "Bugungu Airport",
    city: "Pakuba",
    country: "Uganda",
    lat: 2.2,
    lng: 31.55,
  },
  {
    id: "N",
    name: "Svea Airport",
    city: "Sveagruva",
    country: "Svalbard",
    lat: 77.8969444,
    lng: 16.725,
  },
  {
    id: "N",
    name: "Ny-Ålesund Airport (Hamnerabben)",
    city: "Ny-Alesund",
    country: "Svalbard",
    lat: 78.9274978638,
    lng: 11.8743,
  },
  {
    id: "HTY",
    name: "Hatay Airport",
    city: "Hatay",
    country: "Turkey",
    lat: 36.36277771,
    lng: 36.282222747800006,
  },
  {
    id: "N",
    name: "Kihnu Airfield",
    city: "Kihnu",
    country: "Estonia",
    lat: 58.14830017089844,
    lng: 24.002500534057617,
  },
  {
    id: "N",
    name: "Ruhnu Airfield",
    city: "Ruhnu",
    country: "Estonia",
    lat: 57.78390121459961,
    lng: 23.26609992980957,
  },
  {
    id: "RVV",
    name: "Raivavae Airport",
    city: "Raivavae",
    country: "French Polynesia",
    lat: -23.885200500499998,
    lng: -147.662002563,
  },
  {
    id: "FUO",
    name: "Foshan Shadi Airport",
    city: "Foshan",
    country: "China",
    lat: 23.083299636799996,
    lng: 113.069999695,
  },
  {
    id: "HUZ",
    name: "Huizhou Airport",
    city: "Huizhou",
    country: "China",
    lat: 23.0499992371,
    lng: 114.599998474,
  },
  {
    id: "ILD",
    name: "Lleida-Alguaire Airport",
    city: "Lleida",
    country: "Spain",
    lat: 41.728185,
    lng: 0.535023,
  },
  {
    id: "N",
    name: "Ouessant Airport",
    city: "Ouessant",
    country: "France",
    lat: 48.463199615478516,
    lng: -5.06358003616333,
  },
  {
    id: "BIU",
    name: "Bildudalur Airport",
    city: "Bildudalur",
    country: "Iceland",
    lat: 65.64129638671875,
    lng: -23.546199798583984,
  },
  {
    id: "GJR",
    name: "Gjögur Airport",
    city: "Gjogur",
    country: "Iceland",
    lat: 65.99530029296875,
    lng: -21.326900482177734,
  },
  {
    id: "SAK",
    name: "Sauðárkrókur Airport",
    city: "Saudarkrokur",
    country: "Iceland",
    lat: 65.73169708249999,
    lng: -19.572799682599996,
  },
  {
    id: "N",
    name: "Selfoss Airport",
    city: "Selfoss",
    country: "Iceland",
    lat: 63.92919921875,
    lng: -21.037799835205078,
  },
  {
    id: "IIA",
    name: "Inishmaan Aerodrome",
    city: "Inishmaan",
    country: "Ireland",
    lat: 53.09299850463867,
    lng: -9.568059921264648,
  },
  {
    id: "N",
    name: "Ak Bashat Airport",
    city: "Taldykorgan",
    country: "Kazakhstan",
    lat: 42.88958,
    lng: 73.602004,
  },
  {
    id: "ULG",
    name: "Ulgii Mongolei Airport",
    city: "Olgii",
    country: "Mongolia",
    lat: 48.9933013916,
    lng: 89.9225006104,
  },
  {
    id: "KQT",
    name: "Qurghonteppa International Airport",
    city: "Kurgan Tyube",
    country: "Tajikistan",
    lat: 37.86640167236328,
    lng: 68.86470031738281,
  },
  {
    id: "VGD",
    name: "Vologda Airport",
    city: "Vologda",
    country: "Russia",
    lat: 59.282501220703125,
    lng: 39.944400787353516,
  },
  {
    id: "N",
    name: "Severo-Evensk Airport",
    city: "Evensk",
    country: "Russia",
    lat: 61.92166519165039,
    lng: 159.22999572753906,
  },
  {
    id: "ONK",
    name: "Olenyok Airport",
    city: "Olenyok",
    country: "Russia",
    lat: 68.514999,
    lng: 112.480003,
  },
  {
    id: "SYS",
    name: "Saskylakh Airport",
    city: "Saskylakh",
    country: "Russia",
    lat: 71.92790222168,
    lng: 114.08000183105,
  },
  {
    id: "LDG",
    name: "Leshukonskoye Airport",
    city: "Arkhangelsk",
    country: "Russia",
    lat: 64.8960037231,
    lng: 45.7229995728,
  },
  {
    id: "N",
    name: "Nizhneangarsk Airport",
    city: "Nizhneangarsk",
    country: "Russia",
    lat: 55.80080032348633,
    lng: 109.59500122070312,
  },
  {
    id: "N",
    name: "Vanavara Airport",
    city: "Vanavara",
    country: "Russia",
    lat: 60.35969924926758,
    lng: 102.3239974975586,
  },
  {
    id: "N",
    name: "Aykhal Airport",
    city: "Aykhal",
    country: "Russia",
    lat: 65.959197998047,
    lng: 111.54650115967,
  },
  {
    id: "N",
    name: "Uktus Airport",
    city: "Yekaterinburg",
    country: "Russia",
    lat: 56.701698303222656,
    lng: 60.790000915527344,
  },
  {
    id: "N",
    name: "Baykit Airport",
    city: "Baykit",
    country: "Russia",
    lat: 61.676700592041016,
    lng: 96.3550033569336,
  },
  {
    id: "N",
    name: "Biysk Airport",
    city: "Biysk",
    country: "Russia",
    lat: 52.47999954223633,
    lng: 85.33999633789062,
  },
  {
    id: "HSK",
    name: "Huesca/Pirineos Airport",
    city: "Huesca",
    country: "Spain",
    lat: 42.0760993958,
    lng: -0.316666990519,
  },
  {
    id: "CQM",
    name: "Ciudad Real Central Airport",
    city: "Ciudad Real",
    country: "Spain",
    lat: 38.8563888889,
    lng: -3.97,
  },
  {
    id: "NJF",
    name: "Al Najaf International Airport",
    city: "Najaf",
    country: "Iraq",
    lat: 31.989853,
    lng: 44.404317,
  },
  {
    id: "CSA",
    name: "Colonsay Airstrip",
    city: "Colonsay",
    country: "United Kingdom",
    lat: 56.0574989319,
    lng: -6.243060112,
  },
  {
    id: "RKH",
    name: "Rock Hill - York County Airport",
    city: "Rock Hill",
    country: "United States",
    lat: 34.9878006,
    lng: -81.05719757,
  },
  {
    id: "AGC",
    name: "Allegheny County Airport",
    city: "Pittsburgh",
    country: "United States",
    lat: 40.354400634765625,
    lng: -79.9301986694336,
  },
  {
    id: "VQQ",
    name: "Cecil Airport",
    city: "Jacksonville",
    country: "United States",
    lat: 30.2187004089,
    lng: -81.876701355,
  },
  {
    id: "FTY",
    name: "Fulton County Airport Brown Field",
    city: "Atlanta",
    country: "United States",
    lat: 33.7790985107,
    lng: -84.5214004517,
  },
  {
    id: "N",
    name: "Tresco Heliport",
    city: "Tresco",
    country: "United Kingdom",
    lat: 49.94559860229492,
    lng: -6.331389904022217,
  },
  {
    id: "TII",
    name: "Tarin Kowt Airport",
    city: "Tarin Kowt",
    country: "Afghanistan",
    lat: 32.604198455799995,
    lng: 65.8657989502,
  },
  {
    id: "ZAJ",
    name: "Zaranj Airport",
    city: "Zaranj",
    country: "Afghanistan",
    lat: 30.972222,
    lng: 61.865833,
  },
  {
    id: "CCN",
    name: "Chakcharan Airport",
    city: "Chaghcharan",
    country: "Afghanistan",
    lat: 34.53300094604492,
    lng: 65.26699829101562,
  },
  {
    id: "FUG",
    name: "Fuyang Xiguan Airport",
    city: "Fuyang",
    country: "China",
    lat: 32.882157,
    lng: 115.734364,
  },
  {
    id: "LCX",
    name: "Longyan Guanzhishan Airport",
    city: "Longyan",
    country: "China",
    lat: 25.6746997833,
    lng: 116.747001648,
  },
  {
    id: "BSD",
    name: "Baoshan Yunduan Airport",
    city: "Baoshan",
    country: "China",
    lat: 25.053301,
    lng: 99.168297,
  },
  {
    id: "ACX",
    name: "Xingyi Airport",
    city: "Xingyi",
    country: "China",
    lat: 25.0863888889,
    lng: 104.959444444,
  },
  {
    id: "HZH",
    name: "Liping Airport",
    city: "Liping",
    country: "China",
    lat: 26.32217,
    lng: 109.1499,
  },
  {
    id: "N",
    name: "Stepanakert Air Base",
    city: "Stepanakert",
    country: "Azerbaijan",
    lat: 39.90140151977539,
    lng: 46.7869987487793,
  },
  {
    id: "OSU",
    name: "The Ohio State University Airport - Don Scott Field",
    city: "Columbus",
    country: "United States",
    lat: 40.0798,
    lng: -83.072998,
  },
  {
    id: "ADS",
    name: "Addison Airport",
    city: "Addison",
    country: "United States",
    lat: 32.9686012268,
    lng: -96.8364028931,
  },
  {
    id: "DSI",
    name: "Destin Executive Airport",
    city: "Destin",
    country: "United States",
    lat: 30.40010071,
    lng: -86.47149658,
  },
  {
    id: "KHE",
    name: "Kherson International Airport",
    city: "Kherson",
    country: "Ukraine",
    lat: 46.6758,
    lng: 32.506401,
  },
  {
    id: "SZS",
    name: "Ryan's Creek Aerodrome",
    city: "Stewart Island",
    country: "New Zealand",
    lat: -46.8997,
    lng: 168.100998,
  },
  {
    id: "N",
    name: "Assumption Island Airport",
    city: "Assumption Island",
    country: "Seychelles",
    lat: -9.7422199993,
    lng: 46.506802,
  },
  {
    id: "HJJ",
    name: "Zhijiang Airport",
    city: "Zhijiang",
    country: "China",
    lat: 27.4411111111,
    lng: 109.7,
  },
  {
    id: "YQI",
    name: "Yarmouth Airport",
    city: "Yarmouth",
    country: "Canada",
    lat: 43.826900482177734,
    lng: -66.08809661865234,
  },
  {
    id: "ISO",
    name: "Kinston Regional Jetport At Stallings Field",
    city: "Kinston",
    country: "United States",
    lat: 35.331401825,
    lng: -77.60880279540001,
  },
  {
    id: "FFA",
    name: "First Flight Airport",
    city: "Kill Devil Hills",
    country: "United States",
    lat: 36.0181999207,
    lng: -75.67130279540001,
  },
  {
    id: "LNJ",
    name: "Lintsang Airfield",
    city: "Lincang",
    country: "China",
    lat: 23.738100051900002,
    lng: 100.025001526,
  },
  {
    id: "N",
    name: "Maturacá Airport",
    city: "Maturaca",
    country: "Brazil",
    lat: 0.6282690167427063,
    lng: -66.11509704589844,
  },
  {
    id: "CKS",
    name: "Carajás Airport",
    city: "Parauapebas",
    country: "Brazil",
    lat: -6.11527776718,
    lng: -50.0013885498,
  },
  {
    id: "N",
    name: "Centro de Lançamento de Alcântara Airport",
    city: "Alcantara",
    country: "Brazil",
    lat: -2.372999906539917,
    lng: -44.396400451660156,
  },
  {
    id: "MWK",
    name: "Tarempa Airport",
    city: "Anambas Islands",
    country: "Indonesia",
    lat: 3.3481199741363525,
    lng: 106.25800323486328,
  },
  {
    id: "N",
    name: "Würzburg-Schenkenturm Airport",
    city: "Wuerzburg",
    country: "Germany",
    lat: 49.81778,
    lng: 9.8975,
  },
  {
    id: "N",
    name: "São Jacinto Airport",
    city: "Aveiro",
    country: "Portugal",
    lat: 40.656741,
    lng: -8.741544,
  },
  {
    id: "N",
    name: "Hopsten Air Base",
    city: "Hopsten",
    country: "Germany",
    lat: 52.33869934082031,
    lng: 7.541329860687256,
  },
  {
    id: "PGU",
    name: "Persian Gulf International Airport",
    city: "Khalije Fars",
    country: "Iran",
    lat: 27.379601,
    lng: 52.737701,
  },
  {
    id: "YES",
    name: "Yasouj Airport",
    city: "Yasuj",
    country: "Iran",
    lat: 30.700500488281,
    lng: 51.545101165771,
  },
  {
    id: "OSM",
    name: "Mosul International Airport",
    city: "Mosul",
    country: "Iraq",
    lat: 36.305801,
    lng: 43.1474,
  },
  {
    id: "TJH",
    name: "Tajima Airport",
    city: "Toyooka",
    country: "Japan",
    lat: 35.51279830932617,
    lng: 134.78700256347656,
  },
  {
    id: "AXJ",
    name: "Amakusa Airport",
    city: "Amakusa",
    country: "Japan",
    lat: 32.482498,
    lng: 130.158997,
  },
  {
    id: "KKX",
    name: "Kikai Airport",
    city: "Kikai",
    country: "Japan",
    lat: 28.321300506599997,
    lng: 129.927993774,
  },
  {
    id: "AGJ",
    name: "Aguni Airport",
    city: "Aguni",
    country: "Japan",
    lat: 26.5925006866,
    lng: 127.240997314,
  },
  {
    id: "ULZ",
    name: "Donoi Airport",
    city: "Uliastai",
    country: "Mongolia",
    lat: 47.7093,
    lng: 96.5258,
  },
  {
    id: "UGA",
    name: "Bulgan Airport",
    city: "Bulgan",
    country: "Mongolia",
    lat: 48.85499954223633,
    lng: 103.47599792480469,
  },
  {
    id: "ULO",
    name: "Ulaangom Airport",
    city: "Ulaangom",
    country: "Mongolia",
    lat: 50.066588,
    lng: 91.938273,
  },
  {
    id: "N",
    name: "Borongan Airport",
    city: "Borongan",
    country: "Philippines",
    lat: 11.674300193799999,
    lng: 125.478996277,
  },
  {
    id: "LBX",
    name: "Lubang Airport",
    city: "Lubang",
    country: "Philippines",
    lat: 13.855400085449219,
    lng: 120.1050033569336,
  },
  {
    id: "TJU",
    name: "Kulob Airport",
    city: "Kulyab",
    country: "Tajikistan",
    lat: 37.98809814453125,
    lng: 69.80500030517578,
  },
  {
    id: "CMJ",
    name: "Chi Mei Airport",
    city: "Cimei",
    country: "Taiwan",
    lat: 23.2131004333,
    lng: 119.417999268,
  },
  {
    id: "TAZ",
    name: "Daşoguz Airport",
    city: "Dasoguz",
    country: "Turkmenistan",
    lat: 41.761101,
    lng: 59.826698,
  },
  {
    id: "BWB",
    name: "Barrow Island Airport",
    city: "Barrow Island",
    country: "Australia",
    lat: -20.86440086364746,
    lng: 115.40599822998047,
  },
  {
    id: "DRB",
    name: "Derby Airport",
    city: "Derby",
    country: "Australia",
    lat: -17.3700008392334,
    lng: 123.66100311279297,
  },
  {
    id: "WGE",
    name: "Walgett Airport",
    city: "Walgett",
    country: "Australia",
    lat: -30.032800674438477,
    lng: 148.12600708007812,
  },
  {
    id: "BRT",
    name: "Bathurst Island Airport",
    city: "Bathurst Island",
    country: "Australia",
    lat: -11.769200325012207,
    lng: 130.6199951171875,
  },
  {
    id: "DKI",
    name: "Dunk Island Airport",
    city: "Dunk Island",
    country: "Australia",
    lat: -17.9416999817,
    lng: 146.13999939,
  },
  {
    id: "LZR",
    name: "Lizard Island Airport",
    city: "Lizard Island",
    country: "Australia",
    lat: -14.673273,
    lng: 145.454571,
  },
  {
    id: "HLT",
    name: "Hamilton Airport",
    city: "Hamilton",
    country: "Australia",
    lat: -37.64889907836914,
    lng: 142.06500244140625,
  },
  {
    id: "HCQ",
    name: "Halls Creek Airport",
    city: "Halls Creek",
    country: "Australia",
    lat: -18.23390007019043,
    lng: 127.66999816894531,
  },
  {
    id: "FIZ",
    name: "Fitzroy Crossing Airport",
    city: "Fitzroy Crossing",
    country: "Australia",
    lat: -18.181900024414062,
    lng: 125.55899810791016,
  },
  {
    id: "RVT",
    name: "Ravensthorpe Airport",
    city: "Ravensthorpe",
    country: "Australia",
    lat: -33.7971992493,
    lng: 120.208000183,
  },
  {
    id: "N",
    name: "Wilkins Runway",
    city: "Budd Coast",
    country: "Antarctica",
    lat: -66.690833,
    lng: 111.523611,
  },
  {
    id: "PVU",
    name: "Provo Municipal Airport",
    city: "Provo",
    country: "United States",
    lat: 40.219200134277,
    lng: -111.72299957275,
  },
  {
    id: "SBS",
    name: "Steamboat Springs Bob Adams Field",
    city: "Steamboat Springs",
    country: "United States",
    lat: 40.5163002,
    lng: -106.8659973,
  },
  {
    id: "DTA",
    name: "Delta Municipal Airport",
    city: "Delta",
    country: "United States",
    lat: 39.3805999756,
    lng: -112.508003235,
  },
  {
    id: "N",
    name: "Richfield Municipal Airport",
    city: "Richfield",
    country: "United States",
    lat: 38.73640060424805,
    lng: -112.0989990234375,
  },
  {
    id: "PUC",
    name: "Carbon County Regional/Buck Davis Field",
    city: "Price",
    country: "United States",
    lat: 39.61389923,
    lng: -110.7509995,
  },
  {
    id: "LAM",
    name: "Los Alamos Airport",
    city: "Los Alamos",
    country: "United States",
    lat: 35.8797988892,
    lng: -106.268997192,
  },
  {
    id: "HII",
    name: "Lake Havasu City Airport",
    city: "Lake Havasu City",
    country: "United States",
    lat: 34.571098,
    lng: -114.358002,
  },
  {
    id: "INW",
    name: "Winslow Lindbergh Regional Airport",
    city: "Winslow",
    country: "United States",
    lat: 35.021900177,
    lng: -110.722999573,
  },
  {
    id: "DGL",
    name: "Douglas Municipal Airport",
    city: "Douglas",
    country: "United States",
    lat: 31.3425998688,
    lng: -109.505996704,
  },
  {
    id: "MZK",
    name: "Marakei Airport",
    city: "Marakei",
    country: "Kiribati",
    lat: 2.058609962463379,
    lng: 173.27099609375,
  },
  {
    id: "AEA",
    name: "Abemama Atoll Airport",
    city: "Abemama",
    country: "Kiribati",
    lat: 0.49083301424980164,
    lng: 173.82899475097656,
  },
  {
    id: "AAK",
    name: "Buariki Airport",
    city: "Buariki",
    country: "Kiribati",
    lat: 0.1852779984474182,
    lng: 173.63699340820312,
  },
  {
    id: "KUC",
    name: "Kuria Airport",
    city: "Kuria",
    country: "Kiribati",
    lat: 0.2186110019683838,
    lng: 173.44200134277344,
  },
  {
    id: "AIS",
    name: "Arorae Island Airport",
    city: "Arorae",
    country: "Kiribati",
    lat: -2.61611008644104,
    lng: 176.80299377441406,
  },
  {
    id: "TMN",
    name: "Tamana Island Airport",
    city: "Tamana",
    country: "Kiribati",
    lat: -2.485830068588257,
    lng: 175.97000122070312,
  },
  {
    id: "BEZ",
    name: "Beru Airport",
    city: "Beru Island",
    country: "Kiribati",
    lat: -1.3547199964523315,
    lng: 176.0070037841797,
  },
  {
    id: "NIG",
    name: "Nikunau Airport",
    city: "Nikunau",
    country: "Kiribati",
    lat: -1.31444001198,
    lng: 176.410003662,
  },
  {
    id: "BBG",
    name: "Butaritari Atoll Airport",
    city: "Butaritari",
    country: "Kiribati",
    lat: 3.08583,
    lng: 172.811005,
  },
  {
    id: "MTK",
    name: "Makin Island Airport",
    city: "Makin",
    country: "Kiribati",
    lat: 3.3744399547576904,
    lng: 172.99200439453125,
  },
  {
    id: "MNK",
    name: "Maiana Airport",
    city: "Maiana",
    country: "Kiribati",
    lat: 1.0036100149154663,
    lng: 173.031005859375,
  },
  {
    id: "NON",
    name: "Nonouti Airport",
    city: "Nonouti",
    country: "Kiribati",
    lat: -0.6397219896316528,
    lng: 174.42799377441406,
  },
  {
    id: "TSU",
    name: "Tabiteuea South Airport",
    city: "Tabiteuea",
    country: "Kiribati",
    lat: -1.4744399785995483,
    lng: 175.06399536132812,
  },
  {
    id: "WTZ",
    name: "Whitianga Airport",
    city: "Whitianga",
    country: "New Zealand",
    lat: -36.83169937133789,
    lng: 175.6790008544922,
  },
  {
    id: "KTF",
    name: "Takaka Airport",
    city: "Takaka",
    country: "New Zealand",
    lat: -40.81330108642578,
    lng: 172.77499389648438,
  },
  {
    id: "AFT",
    name: "Afutara Aerodrome",
    city: "Afutara",
    country: "Solomon Islands",
    lat: -9.19138888889,
    lng: 160.948611111,
  },
  {
    id: "RNA",
    name: "Ulawa Airport",
    city: "Ulawa",
    country: "Solomon Islands",
    lat: -9.86054358262,
    lng: 161.979546547,
  },
  {
    id: "CHY",
    name: "Choiseul Bay Airport",
    city: "Choiseul Bay",
    country: "Solomon Islands",
    lat: -6.711944,
    lng: 156.396111,
  },
  {
    id: "NNB",
    name: "Santa Ana Airport",
    city: "Santa Ana",
    country: "Solomon Islands",
    lat: -10.847994,
    lng: 162.454108,
  },
  {
    id: "XYA",
    name: "Yandina Airport",
    city: "Yandina",
    country: "Solomon Islands",
    lat: -9.092816,
    lng: 159.21841,
  },
  {
    id: "BPF",
    name: "Batuna Aerodrome",
    city: "Batuna",
    country: "Solomon Islands",
    lat: -8.56202777778,
    lng: 158.119305556,
  },
  {
    id: "BOW",
    name: "Bartow Municipal Airport",
    city: "Bartow",
    country: "United States",
    lat: 27.943399429299998,
    lng: -81.78340148930002,
  },
  {
    id: "N",
    name: "Dyagilevo Air Base",
    city: "Kostroma",
    country: "Russia",
    lat: 54.64469909667969,
    lng: 39.57040023803711,
  },
  {
    id: "FTI",
    name: "Fitiuta Airport",
    city: "Fiti'uta",
    country: "American Samoa",
    lat: -14.2172,
    lng: -169.425003,
  },
  {
    id: "LVK",
    name: "Livermore Municipal Airport",
    city: "Livermore",
    country: "United States",
    lat: 37.6934013367,
    lng: -121.819999695,
  },
  {
    id: "RMY",
    name: "Mariposa Yosemite Airport",
    city: "Mariposa",
    country: "United States",
    lat: 37.5108985901,
    lng: -120.040000916,
  },
  {
    id: "GFY",
    name: "Grootfontein Airport",
    city: "Grootfontein",
    country: "Namibia",
    lat: -19.60219955444336,
    lng: 18.122699737548828,
  },
  {
    id: "NDU",
    name: "Rundu Airport",
    city: "Rundu",
    country: "Namibia",
    lat: -17.956499099731,
    lng: 19.719400405884,
  },
  {
    id: "N",
    name: "Tasiilaq Heliport",
    city: "Angmagssalik",
    country: "Greenland",
    lat: 65.612296,
    lng: -37.618335,
  },
  {
    id: "TRM",
    name: "Jacqueline Cochran Regional Airport",
    city: "Palm Springs",
    country: "United States",
    lat: 33.62670135498,
    lng: -116.16000366211,
  },
  {
    id: "SMO",
    name: "Santa Monica Municipal Airport",
    city: "Santa Monica",
    country: "United States",
    lat: 34.015800476100004,
    lng: -118.450996399,
  },
  {
    id: "UDD",
    name: "Bermuda Dunes Airport",
    city: "Palm Springs",
    country: "United States",
    lat: 33.748401641846,
    lng: -116.27500152588,
  },
  {
    id: "SCF",
    name: "Scottsdale Airport",
    city: "Scottsdale",
    country: "United States",
    lat: 33.622898101807,
    lng: -111.91100311279,
  },
  {
    id: "OLM",
    name: "Olympia Regional Airport",
    city: "Olympia",
    country: "United States",
    lat: 46.9693985,
    lng: -122.9029999,
  },
  {
    id: "N",
    name: "Yolo County Davis Woodland Winters Airport",
    city: "Davis-Woodland-Winters",
    country: "United States",
    lat: 38.57910156,
    lng: -121.8570023,
  },
  {
    id: "RIL",
    name: "Garfield County Regional Airport",
    city: "Rifle",
    country: "United States",
    lat: 39.526299,
    lng: -107.726997,
  },
  {
    id: "SAA",
    name: "Shively Field",
    city: "SARATOGA",
    country: "United States",
    lat: 41.444901,
    lng: -106.823997,
  },
  {
    id: "PDK",
    name: "DeKalb Peachtree Airport",
    city: "Atlanta",
    country: "United States",
    lat: 33.8755989075,
    lng: -84.3020019531,
  },
  {
    id: "BMG",
    name: "Monroe County Airport",
    city: "Bloomington",
    country: "United States",
    lat: 39.145999908447266,
    lng: -86.61669921875,
  },
  {
    id: "SUA",
    name: "Witham Field",
    city: "Stuart",
    country: "United States",
    lat: 27.18169975,
    lng: -80.22109985,
  },
  {
    id: "MMU",
    name: "Morristown Municipal Airport",
    city: "Morristown",
    country: "United States",
    lat: 40.799400329589844,
    lng: -74.41490173339844,
  },
  {
    id: "APC",
    name: "Napa County Airport",
    city: "Napa",
    country: "United States",
    lat: 38.2132,
    lng: -122.280998,
  },
  {
    id: "SDM",
    name: "Brown Field Municipal Airport",
    city: "San Diego",
    country: "United States",
    lat: 32.572299957275,
    lng: -116.98000335693,
  },
  {
    id: "N",
    name: "Wangen-Lachen Airport",
    city: "Wangen-Lachen",
    country: "Switzerland",
    lat: 47.2047,
    lng: 8.8675,
  },
  {
    id: "VNC",
    name: "Venice Municipal Airport",
    city: "Venice",
    country: "United States",
    lat: 27.071599960327,
    lng: -82.440299987793,
  },
  {
    id: "PHK",
    name: "Palm Beach County Glades Airport",
    city: "Pahokee",
    country: "United States",
    lat: 26.78499985,
    lng: -80.69339752,
  },
  {
    id: "ECP",
    name: "Northwest Florida Beaches International Airport",
    city: "Panama City",
    country: "United States",
    lat: 30.357106,
    lng: -85.795414,
  },
  {
    id: "SBD",
    name: "San Bernardino International Airport",
    city: "San Bernardino",
    country: "United States",
    lat: 34.0954017639,
    lng: -117.23500061,
  },
  {
    id: "VAL",
    name: "Valença Airport",
    city: "Valenca",
    country: "Brazil",
    lat: -13.2965,
    lng: -38.992401,
  },
  {
    id: "CAU",
    name: "Caruaru Airport",
    city: "Caruaru",
    country: "Brazil",
    lat: -8.282389640808105,
    lng: -36.01350021362305,
  },
  {
    id: "AWK",
    name: "Wake Island Airfield",
    city: "Wake island",
    country: "Wake Island",
    lat: 19.282100677490234,
    lng: 166.63600158691406,
  },
  {
    id: "QNV",
    name: "Aeroclube Airport",
    city: "Nova Iguacu",
    country: "Brazil",
    lat: -22.74530029296875,
    lng: -43.46030044555664,
  },
  {
    id: "SQL",
    name: "San Carlos Airport",
    city: "San Carlos",
    country: "United States",
    lat: 37.511901855469,
    lng: -122.25,
  },
  {
    id: "N",
    name: "Courtelary Airport",
    city: "Courtelary ",
    country: "Switzerland",
    lat: 47.18360137939453,
    lng: 7.090829849243164,
  },
  {
    id: "N",
    name: "Lotnisko Korne",
    city: "Koszalin",
    country: "Poland",
    lat: 54.129583,
    lng: 17.844972,
  },
  {
    id: "N",
    name: "Camp Okavango Airport",
    city: "Okavango Delta",
    country: "Botswana",
    lat: -19.131115,
    lng: 23.102505,
  },
  {
    id: "RWI",
    name: "Rocky Mount Wilson Regional Airport",
    city: "Rocky Mount",
    country: "United States",
    lat: 35.856300354003906,
    lng: -77.89189910888672,
  },
  {
    id: "N",
    name: "Whittier Airport",
    city: "Whittier",
    country: "United States",
    lat: 60.777198791503906,
    lng: -148.7220001220703,
  },
  {
    id: "SXQ",
    name: "Soldotna Airport",
    city: "Soldotna",
    country: "United States",
    lat: 60.47570037841797,
    lng: -151.03399658203125,
  },
  {
    id: "SEE",
    name: "Gillespie Field",
    city: "El Cajon",
    country: "United States",
    lat: 32.826198577881,
    lng: -116.97200012207,
  },
  {
    id: "N",
    name: "San Clemente Island Naval Auxiliary Landing Field",
    city: "San Clemente Island",
    country: "United States",
    lat: 33.02270126,
    lng: -118.5879974,
  },
  {
    id: "PHA",
    name: "Phan Rang Airport",
    city: "Phan Rang",
    country: "Vietnam",
    lat: 11.6335000992,
    lng: 108.952003479,
  },
  {
    id: "SQH",
    name: "Na-San Airport",
    city: "Son-La",
    country: "Vietnam",
    lat: 21.216999053955078,
    lng: 104.03299713134766,
  },
  {
    id: "TKF",
    name: "Truckee Tahoe Airport",
    city: "Truckee",
    country: "United States",
    lat: 39.319999694799996,
    lng: -120.13999939,
  },
  {
    id: "FRJ",
    name: "Fréjus Airport",
    city: "Frejus",
    country: "France",
    lat: 43.4175,
    lng: 6.7357,
  },
  {
    id: "GEX",
    name: "Geelong Airport",
    city: "Geelong",
    country: "Australia",
    lat: -38.224998474121094,
    lng: 144.33299255371094,
  },
  {
    id: "N",
    name: "Mezen Airport",
    city: "Mezen",
    country: "Russia",
    lat: 65.87833404541016,
    lng: 44.21500015258789,
  },
  {
    id: "N",
    name: "Vaskovo Airport",
    city: "Arkhangelsk",
    country: "Russia",
    lat: 64.44170379639999,
    lng: 40.421699523899996,
  },
  {
    id: "N",
    name: "Cobb County-Mc Collum Field",
    city: "Atlanta",
    country: "United States",
    lat: 34.01319885,
    lng: -84.59860229,
  },
  {
    id: "N",
    name: "Brumowski  Air Base",
    city: "Tulln",
    country: "Austria",
    lat: 48.3167,
    lng: 16.116699,
  },
  {
    id: "N",
    name: "Dell Flight Strip",
    city: "Dell",
    country: "United States",
    lat: 44.7356987,
    lng: -112.720001221,
  },
  {
    id: "LVM",
    name: "Mission Field",
    city: "Livingston-Montana",
    country: "United States",
    lat: 45.6994018555,
    lng: -110.447998047,
  },
  {
    id: "N",
    name: "Big Timber Airport",
    city: "Big Timber",
    country: "United States",
    lat: 45.806400299072266,
    lng: -109.98100280761719,
  },
  {
    id: "N",
    name: "Tulip City Airport",
    city: "Holland",
    country: "United States",
    lat: 42.742900848389,
    lng: -86.107398986816,
  },
  {
    id: "N",
    name: "London Heliport",
    city: "London",
    country: "United Kingdom",
    lat: 51.46972274779999,
    lng: -0.179444000125,
  },
  {
    id: "N",
    name: "Venice-Lido Airport",
    city: "Venice",
    country: "Italy",
    lat: 45.428299,
    lng: 12.3881,
  },
  {
    id: "N",
    name: "Tallinn Linnahall Heliport",
    city: "Tallinn",
    country: "Estonia",
    lat: 59.4486198425293,
    lng: 24.75322723388672,
  },
  {
    id: "N",
    name: "Hernesaari Heliport",
    city: "Helsinki",
    country: "Finland",
    lat: 60.14777755737305,
    lng: 24.9244441986084,
  },
  {
    id: "N",
    name: "Linkenheim Airport",
    city: "Linkenheim",
    country: "Germany",
    lat: 49.141666412353516,
    lng: 8.394721984863281,
  },
  {
    id: "GMV",
    name: "Monument Valley Airport",
    city: "Monument Valley",
    country: "United States",
    lat: 37.016700744599994,
    lng: -110.200996399,
  },
  {
    id: "N",
    name: "Hilversum Airfield",
    city: "Hilversum",
    country: "Netherlands",
    lat: 52.191898,
    lng: 5.14694,
  },
  {
    id: "JRA",
    name: "West 30th St. Heliport",
    city: "New York",
    country: "United States",
    lat: 40.754501,
    lng: -74.007103,
  },
  {
    id: "N",
    name: "Texel Airfield",
    city: "Texel",
    country: "Netherlands",
    lat: 53.115299,
    lng: 4.83361,
  },
  {
    id: "N",
    name: "La Cerdanya Airport",
    city: "Das i Fontanals de Cerdanya",
    country: "Spain",
    lat: 42.38639831542969,
    lng: 1.86667001247406,
  },
  {
    id: "LAL",
    name: "Lakeland Linder International Airport",
    city: "Lakeland",
    country: "United States",
    lat: 27.988899,
    lng: -82.018602,
  },
  {
    id: "N",
    name: "Stary Oskol Airport",
    city: "Stary Oskol",
    country: "Russia",
    lat: 51.32921600341797,
    lng: 37.76884841918945,
  },
  {
    id: "SYH",
    name: "Syangboche Airport",
    city: "Syangboche",
    country: "Nepal",
    lat: 27.8112,
    lng: 86.7124,
  },
  {
    id: "N",
    name: "Indianola Municipal Airport",
    city: "New York",
    country: "United States",
    lat: 33.485699,
    lng: -90.678902,
  },
  {
    id: "N",
    name: "Cheremshanka Airport",
    city: "Krasnoyarsk",
    country: "Russia",
    lat: 56.176998138399995,
    lng: 92.5400009155,
  },
  {
    id: "RBK",
    name: "French Valley Airport",
    city: "Murrieta-Temecula",
    country: "United States",
    lat: 33.5741996765,
    lng: -117.127998352,
  },
  {
    id: "FNU",
    name: "Oristano-Fenosu Airport",
    city: "Oristano",
    country: "Italy",
    lat: 39.895308,
    lng: 8.642661,
  },
  {
    id: "N",
    name: "White Waltham Airfield",
    city: "Maidenhead",
    country: "United Kingdom",
    lat: 51.500801086399996,
    lng: -0.774443984032,
  },
  {
    id: "MYQ",
    name: "Mysore Airport",
    city: "Mysore",
    country: "India",
    lat: 12.23,
    lng: 76.655833,
  },
  {
    id: "N",
    name: "Carl R Keller Field",
    city: "Port Clinton",
    country: "United States",
    lat: 41.516300201416016,
    lng: -82.86869812011719,
  },
  {
    id: "MGY",
    name: "Dayton-Wright Brothers Airport",
    city: "Dayton",
    country: "United States",
    lat: 39.5890007019,
    lng: -84.224899292,
  },
  {
    id: "N",
    name: "Richmond Municipal Airport",
    city: "Richmond",
    country: "United States",
    lat: 39.757198333740234,
    lng: -84.8427963256836,
  },
  {
    id: "FDY",
    name: "Findlay Airport",
    city: "Findley",
    country: "United States",
    lat: 41.013500213600004,
    lng: -83.66870117190001,
  },
  {
    id: "N",
    name: "Burlington Executive",
    city: "Burlington",
    country: "Canada",
    lat: 43.4414531515,
    lng: -79.850102663,
  },
  {
    id: "PEA",
    name: "Penneshaw Airport",
    city: "Penneshaw",
    country: "Australia",
    lat: -35.7558462874,
    lng: 137.962875366,
  },
  {
    id: "N",
    name: "Engels heliport",
    city: "Ebenhofen",
    country: "Germany",
    lat: 51.211666107177734,
    lng: 4.5808329582214355,
  },
  {
    id: "EMP",
    name: "Emporia Municipal Airport",
    city: "Kempten",
    country: "Germany",
    lat: 38.3320999146,
    lng: -96.19120025630001,
  },
  {
    id: "N",
    name: "Skå-Edeby Airport",
    city: "Essen",
    country: "Germany",
    lat: 59.34510040283203,
    lng: 17.74049949645996,
  },
  {
    id: "HYC",
    name: "Wycombe Air Park",
    city: "Wycombe",
    country: "United Kingdom",
    lat: 51.6116981506,
    lng: -0.8083329796790001,
  },
  {
    id: "BBP",
    name: "Bembridge Airport",
    city: "Bembridge",
    country: "United Kingdom",
    lat: 50.6781005859,
    lng: -1.10943996906,
  },
  {
    id: "N",
    name: "Waterville / Kings County Municipal Airport",
    city: "Waterville",
    country: "Canada",
    lat: 45.0518989563,
    lng: -64.6517028809,
  },
  {
    id: "SPF",
    name: "Black Hills Airport-Clyde Ice Field",
    city: "Spearfish-South Dakota",
    country: "United States",
    lat: 44.48030090332,
    lng: -103.78299713135,
  },
  {
    id: "N",
    name: "Westkapelle heliport",
    city: "Knokke",
    country: "Belgium",
    lat: 51.32222366333,
    lng: 3.2930560112,
  },
  {
    id: "N",
    name: "Redcliffe Airport",
    city: "Rothwell",
    country: "Australia",
    lat: -27.20669937133789,
    lng: 153.0679931640625,
  },
  {
    id: "QYD",
    name: "Oksywie Military Air Base",
    city: "Gdynia",
    country: "Poland",
    lat: 54.57970047,
    lng: 18.51720047,
  },
  {
    id: "N",
    name: "Malbork Military Air Base",
    city: "Malbork",
    country: "Poland",
    lat: 54.0269012451,
    lng: 19.134199142499998,
  },
  {
    id: "N",
    name: "Lask Military Air Base",
    city: "Lask",
    country: "Poland",
    lat: 51.551700592,
    lng: 19.179100036599998,
  },
  {
    id: "N",
    name: "Miroslawiec Military Air Base",
    city: "Miroslawiec",
    country: "Poland",
    lat: 53.395099639899996,
    lng: 16.0827999115,
  },
  {
    id: "N",
    name: "Krzesiny Military Air Base",
    city: "Poznan",
    country: "Poland",
    lat: 52.3316993713,
    lng: 16.9664001465,
  },
  {
    id: "OLV",
    name: "Olive Branch Airport",
    city: "Olive Branch",
    country: "United States",
    lat: 34.9786987305,
    lng: -89.78690338130001,
  },
  {
    id: "KNA",
    name: "Viña del mar Airport",
    city: "Vina del Mar",
    country: "Chile",
    lat: -32.9496,
    lng: -71.4786,
  },
  {
    id: "N",
    name: "Brampton Airport",
    city: "Brampton",
    country: "Canada",
    lat: 43.7602996826,
    lng: -79.875,
  },
  {
    id: "ONQ",
    name: "Zonguldak Airport",
    city: "Zonguldak",
    country: "Turkey",
    lat: 41.506401062,
    lng: 32.0886001587,
  },
  {
    id: "BJC",
    name: "Rocky Mountain Metropolitan Airport",
    city: "Broomfield-CO",
    country: "United States",
    lat: 39.90879822,
    lng: -105.1169968,
  },
  {
    id: "SLE",
    name: "Salem Municipal Airport/McNary Field",
    city: "Salem",
    country: "United States",
    lat: 44.90950012,
    lng: -123.0029984,
  },
  {
    id: "UTM",
    name: "Tunica Municipal Airport",
    city: "Tunica",
    country: "United States",
    lat: 34.680999755859,
    lng: -90.346702575684,
  },
  {
    id: "N",
    name: "Batken Airport",
    city: "Batken",
    country: "Kyrgyzstan",
    lat: 40.042899,
    lng: 70.83784,
  },
  {
    id: "ZKB",
    name: "Kasaba Bay Airport",
    city: "Kasaba Bay",
    country: "Zambia",
    lat: -8.524999618530273,
    lng: 30.663000106811523,
  },
  {
    id: "LND",
    name: "Hunt Field",
    city: "Lindau",
    country: "Germany",
    lat: 42.8152008057,
    lng: -108.730003357,
  },
  {
    id: "N",
    name: "Hoogeveen Airfield",
    city: "Hoogeveen",
    country: "Netherlands",
    lat: 52.730801,
    lng: 6.51611,
  },
  {
    id: "N",
    name: "Teuge Airport",
    city: "Deventer",
    country: "Netherlands",
    lat: 52.2447013855,
    lng: 6.04666996002,
  },
  {
    id: "N",
    name: "Midden-Zeeland Airport",
    city: "Middelburg",
    country: "Netherlands",
    lat: 51.5121994019,
    lng: 3.73111009598,
  },
  {
    id: "N",
    name: "Ameland Airfield",
    city: "Ameland",
    country: "Netherlands",
    lat: 53.451698,
    lng: 5.67722,
  },
  {
    id: "N",
    name: "Saint-Cyr-l'École Airport",
    city: "Saint-Cyr",
    country: "France",
    lat: 48.8114013671875,
    lng: 2.0747199058532715,
  },
  {
    id: "MWC",
    name: "Lawrence J Timmerman Airport",
    city: "Milwaukee",
    country: "United States",
    lat: 43.110401,
    lng: -88.034401,
  },
  {
    id: "JVL",
    name: "Southern Wisconsin Regional Airport",
    city: "Janesville",
    country: "United States",
    lat: 42.620300293,
    lng: -89.0416030884,
  },
  {
    id: "N",
    name: "Mantsonyane Airport",
    city: "Mantsonyane",
    country: "Lesotho",
    lat: -29.546100616455078,
    lng: 28.270999908447266,
  },
  {
    id: "N",
    name: "Arlington Municipal Airport",
    city: "Arlington",
    country: "United States",
    lat: 32.66389846801758,
    lng: -97.09429931640625,
  },
  {
    id: "LZU",
    name: "Gwinnett County Briscoe Field",
    city: "Lawrenceville",
    country: "United States",
    lat: 33.97809982,
    lng: -83.96240234,
  },
  {
    id: "BWG",
    name: "Bowling Green Warren County Regional Airport",
    city: "Bowling Green",
    country: "United States",
    lat: 36.964500427199994,
    lng: -86.41970062259999,
  },
  {
    id: "RVS",
    name: "Richard Lloyd Jones Jr Airport",
    city: "Tulsa",
    country: "United States",
    lat: 36.039600372314,
    lng: -95.984596252441,
  },
  {
    id: "NHD",
    name: "Al Minhad Air Base",
    city: "Minhad AB",
    country: "United Arab Emirates",
    lat: 25.0268001556,
    lng: 55.3661994934,
  },
  {
    id: "KGO",
    name: "Kirovograd Airport",
    city: "Kirovograd",
    country: "Ukraine",
    lat: 48.54280090332031,
    lng: 32.28499984741211,
  },
  {
    id: "N",
    name: "Roitzschjora Airfield",
    city: "Roitzschjora",
    country: "Germany",
    lat: 51.577778,
    lng: 12.494444,
  },
  {
    id: "DBB",
    name: "El Alamein International Airport",
    city: "Dabaa City",
    country: "Egypt",
    lat: 30.92449951171875,
    lng: 28.46139907836914,
  },
  {
    id: "BCE",
    name: "Bryce Canyon Airport",
    city: "Bryce Canyon",
    country: "United States",
    lat: 37.706401825,
    lng: -112.144996643,
  },
  {
    id: "N",
    name: "Burlington Alamance Regional Airport",
    city: "Burlington",
    country: "United States",
    lat: 36.048500061035156,
    lng: -79.47489929199219,
  },
  {
    id: "CKL",
    name: "Chkalovskiy Air Base",
    city: "Shchyolkovo",
    country: "Russia",
    lat: 55.8783,
    lng: 38.061699,
  },
  {
    id: "TCZ",
    name: "Tengchong Tuofeng Airport",
    city: "Tengchong",
    country: "China",
    lat: 24.9380555556,
    lng: 98.48583333330001,
  },
  {
    id: "UKS",
    name: "Belbek Airport",
    city: "Sevastopol",
    country: "Ukraine",
    lat: 44.688999176,
    lng: 33.570999145500004,
  },
  {
    id: "N",
    name: "De Peel Air Base",
    city: "Deurne",
    country: "Netherlands",
    lat: 51.51729965209961,
    lng: 5.855720043182373,
  },
  {
    id: "OAZ",
    name: "Camp Bastion Airport",
    city: "Camp Bastion",
    country: "Afghanistan",
    lat: 31.863800048799998,
    lng: 64.2246017456,
  },
  {
    id: "JCI",
    name: "New Century Aircenter Airport",
    city: "Olathe",
    country: "United States",
    lat: 38.8308982849,
    lng: -94.890296936,
  },
  {
    id: "ESN",
    name: "Easton Newnam Field",
    city: "Easton",
    country: "United States",
    lat: 38.8041992188,
    lng: -76.06900024410001,
  },
  {
    id: "HMR",
    name: "Stafsberg Airport",
    city: "Hamar",
    country: "Norway",
    lat: 60.81809997558594,
    lng: 11.067999839782715,
  },
  {
    id: "N",
    name: "Ringebu Airfield Frya",
    city: "Frya",
    country: "Norway",
    lat: 61.545440673,
    lng: 10.061588287,
  },
  {
    id: "MYV",
    name: "Yuba County Airport",
    city: "Yuba City",
    country: "United States",
    lat: 39.09780121,
    lng: -121.5699997,
  },
  {
    id: "N",
    name: "Phillip Island Airport",
    city: "Phillip Island",
    country: "Australia",
    lat: -38.52330017089844,
    lng: 145.32699584960938,
  },
  {
    id: "DUC",
    name: "Halliburton Field",
    city: "Duncan",
    country: "United States",
    lat: 34.47090149,
    lng: -97.9598999,
  },
  {
    id: "UVA",
    name: "Garner Field",
    city: "Uvalde",
    country: "United States",
    lat: 29.2112998962,
    lng: -99.743598938,
  },
  {
    id: "LOT",
    name: "Lewis University Airport",
    city: "Lockport",
    country: "United States",
    lat: 41.6072998,
    lng: -88.09619904,
  },
  {
    id: "CCR",
    name: "Buchanan Field",
    city: "Concord",
    country: "United States",
    lat: 37.9897003174,
    lng: -122.056999207,
  },
  {
    id: "OCA",
    name: "Ocean Reef Club Airport",
    city: "Ocean Reef Club Airport",
    country: "United States",
    lat: 25.325399398804,
    lng: -80.274803161621,
  },
  {
    id: "N",
    name: "Strasbourg Neuhof Airfield",
    city: "Strasbourg Neudorf",
    country: "France",
    lat: 48.554401,
    lng: 7.77806,
  },
  {
    id: "N",
    name: "Nannhausen Airport",
    city: "Nannhausen",
    country: "Germany",
    lat: 49.9702796936,
    lng: 7.47916698456,
  },
  {
    id: "YUS",
    name: "Yushu Batang Airport",
    city: "Yushu",
    country: "China",
    lat: 32.836388888900004,
    lng: 97.0363888889,
  },
  {
    id: "HIA",
    name: "Lianshui Airport",
    city: "Huai An",
    country: "China",
    lat: 33.7908333333,
    lng: 119.125,
  },
  {
    id: "YOO",
    name: "Toronto/Oshawa Executive Airport",
    city: "Oshawa",
    country: "Canada",
    lat: 43.922798,
    lng: -78.894997,
  },
  {
    id: "N",
    name: "Marl-Loemühle Airfield",
    city: "Recklinghausen",
    country: "Germany",
    lat: 51.647202,
    lng: 7.16333,
  },
  {
    id: "N",
    name: "Färila Air Base",
    city: "Farila",
    country: "Sweden",
    lat: 61.897998809814,
    lng: 15.705300331116,
  },
  {
    id: "LHA",
    name: "Lahr Airport",
    city: "Lahr",
    country: "Germany",
    lat: 48.3693008423,
    lng: 7.82772016525,
  },
  {
    id: "NYW",
    name: "Monywar Airport",
    city: "Monywa",
    country: "Burma",
    lat: 22.221638,
    lng: 95.093479,
  },
  {
    id: "ATO",
    name: "Ohio University Snyder Field",
    city: "Athens",
    country: "United States",
    lat: 39.2109985352,
    lng: -82.23139953610001,
  },
  {
    id: "SGH",
    name: "Springfield-Beckley Municipal Airport",
    city: "Springfield",
    country: "United States",
    lat: 39.840301513672,
    lng: -83.840202331543,
  },
  {
    id: "N",
    name: "Sun Island Resort and SPA",
    city: "South Aari Atoll",
    country: "Maldives",
    lat: 3.488334,
    lng: 72.862989,
  },
  {
    id: "N",
    name: "Fes Sefrou Airport",
    city: "Fes",
    country: "Morocco",
    lat: 34.00809860229492,
    lng: -4.965559959411621,
  },
  {
    id: "HEX",
    name: "Herrera Airport",
    city: "Santo Domingo",
    country: "Dominican Republic",
    lat: 18.4696998596,
    lng: -69.9693984985,
  },
  {
    id: "CDA",
    name: "Cooinda Airport",
    city: "Cooinda",
    country: "Australia",
    lat: -12.903300285339355,
    lng: 132.53199768066406,
  },
  {
    id: "JAB",
    name: "Jabiru Airport",
    city: "Jabiru",
    country: "Australia",
    lat: -12.658300399780273,
    lng: 132.89300537109375,
  },
  {
    id: "N",
    name: "Regensburg-Oberhub Airport",
    city: "Regensburg",
    country: "Germany",
    lat: 49.141944885253906,
    lng: 12.081944465637207,
  },
  {
    id: "HGS",
    name: "Hastings Airport",
    city: "Freetown",
    country: "Sierra Leone",
    lat: 8.397130012512207,
    lng: -13.12909984588623,
  },
  {
    id: "TOP",
    name: "Philip Billard Municipal Airport",
    city: "Topeka",
    country: "United States",
    lat: 39.068698883057,
    lng: -95.622497558594,
  },
  {
    id: "N",
    name: "Benson Airstrip",
    city: "Uvalde",
    country: "United States",
    lat: 29.229400634765625,
    lng: -99.82389831542969,
  },
  {
    id: "N",
    name: "Rough River State Park Airport",
    city: "Null",
    country: "United States",
    lat: 37.610022,
    lng: -86.507262,
  },
  {
    id: "MQY",
    name: "Smyrna Airport",
    city: "Smyrna",
    country: "United States",
    lat: 36.0089988708,
    lng: -86.5201034546,
  },
  {
    id: "UOS",
    name: "Franklin County Airport",
    city: "Sewanee",
    country: "United States",
    lat: 35.205101013184,
    lng: -85.898101806641,
  },
  {
    id: "NGQ",
    name: "Ngari Gunsa Airport",
    city: "Shiquanhe",
    country: "China",
    lat: 32.1,
    lng: 80.0530555556,
  },
  {
    id: "CSO",
    name: "Cochstedt Airport",
    city: "Cochstedt",
    country: "Germany",
    lat: 51.8563995361,
    lng: 11.42029953,
  },
  {
    id: "N",
    name: "Collin County Regional At Mc Kinney Airport",
    city: "DALLAS",
    country: "United States",
    lat: 33.17789841,
    lng: -96.59049988,
  },
  {
    id: "PWK",
    name: "Chicago Executive Airport",
    city: "Chicago-Wheeling",
    country: "United States",
    lat: 42.114222,
    lng: -87.901494,
  },
  {
    id: "KLS",
    name: "Southwest Washington Regional Airport",
    city: "Kelso",
    country: "United States",
    lat: 46.11800003049999,
    lng: -122.898002625,
  },
  {
    id: "N",
    name: "Benešov Airport",
    city: "Benesov",
    country: "Czech Republic",
    lat: 49.74079895019531,
    lng: 14.644700050354004,
  },
  {
    id: "N",
    name: "Bougouni Airport",
    city: "Bougouni",
    country: "Mali",
    lat: 11.449999809265137,
    lng: -7.517000198364258,
  },
  {
    id: "ZTA",
    name: "Tureia Airport",
    city: "Tureia",
    country: "French Polynesia",
    lat: -20.78969955444336,
    lng: -138.57000732421875,
  },
  {
    id: "N",
    name: "McMurdo Station Ice Runway",
    city: "Ross Island",
    country: "Antarctica",
    lat: -77.85399627685547,
    lng: 166.468994140625,
  },
  {
    id: "N",
    name: "Keekorok Airport",
    city: "Keekorok",
    country: "Kenya",
    lat: -1.5829999446868896,
    lng: 35.25,
  },
  {
    id: "PUE",
    name: "Puerto Obaldia Airport",
    city: "Puerto Obaldia",
    country: "Panama",
    lat: 8.667,
    lng: -77.418,
  },
  {
    id: "KHC",
    name: "Kerch Airport",
    city: "Kerch",
    country: "Ukraine",
    lat: 45.372501373291016,
    lng: 36.40140151977539,
  },
  {
    id: "UKA",
    name: "Ukunda Airstrip",
    city: "Ukunda",
    country: "Kenya",
    lat: -4.29333,
    lng: 39.571098,
  },
  {
    id: "ILN",
    name: "Wilmington Airpark",
    city: "Wilmington",
    country: "United States",
    lat: 39.427898407,
    lng: -83.792098999,
  },
  {
    id: "AVW",
    name: "Marana Regional Airport",
    city: "Tucson",
    country: "United States",
    lat: 32.4095993042,
    lng: -111.218002319,
  },
  {
    id: "CGZ",
    name: "Casa Grande Municipal Airport",
    city: "Casa Grande",
    country: "United States",
    lat: 32.954899,
    lng: -111.766998,
  },
  {
    id: "N",
    name: "Mobile Airport",
    city: "Mobile",
    country: "United States",
    lat: 33.111900329589844,
    lng: -112.26899719238281,
  },
  {
    id: "BXK",
    name: "Buckeye Municipal Airport",
    city: "Buckeye",
    country: "United States",
    lat: 33.42039871,
    lng: -112.685997,
  },
  {
    id: "N",
    name: "Gila Bend Municipal Airport",
    city: "Gila Bend",
    country: "United States",
    lat: 32.95809937,
    lng: -112.6780014,
  },
  {
    id: "MMI",
    name: "McMinn County Airport",
    city: "Athens",
    country: "United States",
    lat: 35.39730072,
    lng: -84.56259918,
  },
  {
    id: "STK",
    name: "Sterling Municipal Airport",
    city: "Sterling",
    country: "United States",
    lat: 40.61529922,
    lng: -103.2649994,
  },
  {
    id: "RWL",
    name: "Rawlins Municipal Airport/Harvey Field",
    city: "Rawlins",
    country: "United States",
    lat: 41.80559921,
    lng: -107.1999969,
  },
  {
    id: "N",
    name: "Mackenzie Airport",
    city: "Mackenzie British Columbia",
    country: "Canada",
    lat: 55.304402,
    lng: -123.132004,
  },
  {
    id: "CDW",
    name: "Essex County Airport",
    city: "Caldwell",
    country: "United States",
    lat: 40.875198364300005,
    lng: -74.2814025879,
  },
  {
    id: "AIZ",
    name: "Lee C Fine Memorial Airport",
    city: "Kaiser Lake Ozark",
    country: "United States",
    lat: 38.0960006714,
    lng: -92.54949951170002,
  },
  {
    id: "TVI",
    name: "Thomasville Regional Airport",
    city: "Thomasville",
    country: "United States",
    lat: 30.901599884033,
    lng: -83.881301879883,
  },
  {
    id: "HSH",
    name: "Henderson Executive Airport",
    city: "Henderson",
    country: "United States",
    lat: 35.9728012085,
    lng: -115.134002686,
  },
  {
    id: "GML",
    name: "Gostomel Airport",
    city: "Kiev",
    country: "Ukraine",
    lat: 50.60350036621094,
    lng: 30.1919002532959,
  },
  {
    id: "TMA",
    name: "Henry Tift Myers Airport",
    city: "Tifton",
    country: "United States",
    lat: 31.4290008545,
    lng: -83.4885025024,
  },
  {
    id: "N",
    name: "Landshut Airport",
    city: "Landshut",
    country: "Germany",
    lat: 48.51166534423828,
    lng: 12.033332824707031,
  },
  {
    id: "N",
    name: "Itzehoe/Hungriger Wolf Airport",
    city: "Itzehoe",
    country: "Germany",
    lat: 53.99444580078125,
    lng: 9.578611373901367,
  },
  {
    id: "RDO",
    name: "Radom Airport",
    city: "RADOM",
    country: "Poland",
    lat: 51.3891983032,
    lng: 21.213300705,
  },
  {
    id: "DVT",
    name: "Phoenix Deer Valley Airport",
    city: "Phoenix ",
    country: "United States",
    lat: 33.6883010864,
    lng: -112.083000183,
  },
  {
    id: "N",
    name: "Calgary / Springbank Airport",
    city: "Calgary",
    country: "Canada",
    lat: 51.103099823,
    lng: -114.374000549,
  },
  {
    id: "N",
    name: "Golden Airport",
    city: "Golden",
    country: "Canada",
    lat: 51.299196,
    lng: -116.982002,
  },
  {
    id: "YRV",
    name: "Revelstoke Airport",
    city: "Revelstoke",
    country: "Canada",
    lat: 50.9667015076,
    lng: -118.182998657,
  },
  {
    id: "FRG",
    name: "Republic Airport",
    city: "Farmingdale",
    country: "United States",
    lat: 40.7288017273,
    lng: -73.4133987427,
  },
  {
    id: "N",
    name: "Allstedt Airport",
    city: "Allstedt",
    country: "Germany",
    lat: 51.38055419921875,
    lng: 11.446666717529297,
  },
  {
    id: "N",
    name: "General Freire Airport",
    city: "Curico",
    country: "Chile",
    lat: -34.96666717529297,
    lng: -71.21639251708984,
  },
  {
    id: "N",
    name: "Peine-Eddesse Airport",
    city: "Peine",
    country: "Germany",
    lat: 52.402500152600005,
    lng: 10.228889465299998,
  },
  {
    id: "N",
    name: "South Texas Regional Airport at Hondo",
    city: "Hondo",
    country: "United States",
    lat: 29.35950088501,
    lng: -99.176696777344,
  },
  {
    id: "ZHY",
    name: "Zhongwei Shapotou Airport",
    city: "Zhongwei",
    country: "China",
    lat: 37.573125,
    lng: 105.154454,
  },
  {
    id: "MCL",
    name: "McKinley National Park Airport",
    city: "McKinley Park",
    country: "United States",
    lat: 63.7326011658,
    lng: -148.910995483,
  },
  {
    id: "N",
    name: "Lake Hood Airport",
    city: "Anchorage",
    country: "United States",
    lat: 61.186946,
    lng: -149.965442,
  },
  {
    id: "PPC",
    name: "Prospect Creek Airport",
    city: "Prospect Creek",
    country: "United States",
    lat: 66.814102172852,
    lng: -150.64399719238,
  },
  {
    id: "KHW",
    name: "Khwai River Lodge Airport",
    city: "Khwai River",
    country: "Botswana",
    lat: -19.149999618530273,
    lng: 23.783000946044922,
  },
  {
    id: "N",
    name: "Spremberg-Welzow Airport",
    city: "Welzow",
    country: "Germany",
    lat: 51.575557708740234,
    lng: 14.136943817138672,
  },
  {
    id: "TXG",
    name: "Taichung Airport",
    city: "Taichung",
    country: "Taiwan",
    lat: 24.18630027770996,
    lng: 120.65399932861328,
  },
  {
    id: "HLG",
    name: "Wheeling Ohio County Airport",
    city: "Wheeling",
    country: "United States",
    lat: 40.1749992371,
    lng: -80.6463012695,
  },
  {
    id: "N",
    name: "Fitzgerald Municipal Airport",
    city: "Fitzgerald",
    country: "United States",
    lat: 31.683700561523438,
    lng: -83.27050018310547,
  },
  {
    id: "XYE",
    name: "Ye Airport",
    city: "Ye",
    country: "Burma",
    lat: 15.300000190734863,
    lng: 97.86699676513672,
  },
  {
    id: "N",
    name: "Isla San Felix Airport",
    city: "Isla San Felix",
    country: "Chile",
    lat: -26.293899536132812,
    lng: -80.09619903564453,
  },
  {
    id: "N",
    name: "Shaibah Airport",
    city: "Shaybah",
    country: "Saudi Arabia",
    lat: 22.51449966430664,
    lng: 53.9640998840332,
  },
  {
    id: "DWC",
    name: "Al Maktoum International Airport",
    city: "Dubai",
    country: "United Arab Emirates",
    lat: 24.896356,
    lng: 55.161389,
  },
  {
    id: "RKP",
    name: "Aransas County Airport",
    city: "Rockport",
    country: "United States",
    lat: 28.0867996216,
    lng: -97.0446014404,
  },
  {
    id: "MVV",
    name: "Megève Airport",
    city: "Verdun",
    country: "France",
    lat: 45.82080078125,
    lng: 6.652219772338867,
  },
  {
    id: "MFX",
    name: "Méribel Altiport",
    city: "Ajaccio",
    country: "France",
    lat: 45.407003,
    lng: 6.577942,
  },
  {
    id: "AEB",
    name: "Baise Youjiang Airport",
    city: "Baise",
    country: "China",
    lat: 23.7206001282,
    lng: 106.959999084,
  },
  {
    id: "OKF",
    name: "Okaukuejo Airport",
    city: "Okaukuejo",
    country: "Namibia",
    lat: -19.149200439453125,
    lng: 15.91189956665039,
  },
  {
    id: "OKU",
    name: "Mokuti Lodge Airport",
    city: "Mokuti Lodge",
    country: "Namibia",
    lat: -18.81279945373535,
    lng: 17.05940055847168,
  },
  {
    id: "N",
    name: "Rotenburg (Wümme) Airport",
    city: "Rotenburg Wuemme",
    country: "Germany",
    lat: 53.128334045410156,
    lng: 9.348610877990723,
  },
  {
    id: "N",
    name: "Wipperfürth-Neye Airport",
    city: "Wipperfuerth",
    country: "Germany",
    lat: 51.124168395996094,
    lng: 7.373610973358154,
  },
  {
    id: "N",
    name: "Osnabrück-Atterheide Airport",
    city: "Osnabrueck",
    country: "Germany",
    lat: 52.286388,
    lng: 7.969722,
  },
  {
    id: "N",
    name: "Flugplatz Ballenstedt",
    city: "Ballenstedt",
    country: "Germany",
    lat: 51.745834,
    lng: 11.229722,
  },
  {
    id: "N",
    name: "Flugplatz Hartenholm",
    city: "Hasenmoor",
    country: "Germany",
    lat: 53.915001,
    lng: 10.035556,
  },
  {
    id: "N",
    name: "Ganderkesee Atlas Airfield",
    city: "Ganderkesee",
    country: "Germany",
    lat: 53.03611,
    lng: 8.505556,
  },
  {
    id: "N",
    name: "Nienburg-Holzbalge Airport",
    city: "Nienburg Weser",
    country: "Germany",
    lat: 52.709720611572266,
    lng: 9.162500381469727,
  },
  {
    id: "N",
    name: "Damme Airfield",
    city: "Damme",
    country: "Germany",
    lat: 52.487499,
    lng: 8.185556,
  },
  {
    id: "N",
    name: "Borkenberge Airport",
    city: "Duelmen",
    country: "Germany",
    lat: 51.779998779299994,
    lng: 7.28805589676,
  },
  {
    id: "N",
    name: "Obermehler-Schlotheim Airport",
    city: "Obermehler",
    country: "Germany",
    lat: 51.26777648925781,
    lng: 10.634721755981445,
  },
  {
    id: "N",
    name: "Hodenhagen Airport",
    city: "Hodenhagen",
    country: "Germany",
    lat: 52.761865,
    lng: 9.61056,
  },
  {
    id: "N",
    name: "Grube Airport",
    city: "Grube",
    country: "Germany",
    lat: 54.24444580078125,
    lng: 11.0247220993042,
  },
  {
    id: "N",
    name: "Tønder Airport",
    city: "Toender",
    country: "Denmark",
    lat: 54.9296989440918,
    lng: 8.840570449829102,
  },
  {
    id: "N",
    name: "Celle-Arloh Airport",
    city: "Celle",
    country: "Germany",
    lat: 52.68722152709961,
    lng: 10.11138916015625,
  },
  {
    id: "N",
    name: "Uelzen Airport",
    city: "Uelzen",
    country: "Germany",
    lat: 52.9838905334,
    lng: 10.4650001526,
  },
  {
    id: "N",
    name: "Hamm-Lippewiesen Airport",
    city: "Hamm",
    country: "Germany",
    lat: 51.689720153808594,
    lng: 7.816111087799072,
  },
  {
    id: "N",
    name: "Lüsse Airport",
    city: "Luesse",
    country: "Germany",
    lat: 52.141109466552734,
    lng: 12.664722442626953,
  },
  {
    id: "N",
    name: "Porta Westfalica Airport",
    city: "Bad Oeynhausen",
    country: "Germany",
    lat: 52.22083282470703,
    lng: 8.859167098999023,
  },
  {
    id: "N",
    name: "Brilon/Hochsauerlandkreis Airfield",
    city: "Brilon",
    country: "Germany",
    lat: 51.4025,
    lng: 8.641667,
  },
  {
    id: "N",
    name: "Hameln-Pyrmont Airport",
    city: "Bad Pyrmont",
    country: "Germany",
    lat: 51.96666717529297,
    lng: 9.291666984558105,
  },
  {
    id: "N",
    name: "Nordholz-Spieka Airfield",
    city: "Cuxhaven",
    country: "Germany",
    lat: 53.767223,
    lng: 8.643611,
  },
  {
    id: "KOQ",
    name: "Köthen Airport",
    city: "Koethen",
    country: "Germany",
    lat: 51.7211112976,
    lng: 11.952777862500001,
  },
  {
    id: "N",
    name: "St. Michaelisdonn Airport",
    city: "Sankt Michaelisdonn",
    country: "Germany",
    lat: 53.978057861328125,
    lng: 9.144721984863281,
  },
  {
    id: "N",
    name: "Salzgitter-Drütte Airport",
    city: "Salzgitter",
    country: "Germany",
    lat: 52.15444564819336,
    lng: 10.426667213439941,
  },
  {
    id: "N",
    name: "Karlshöfen Airport",
    city: "Karlshoefen",
    country: "Germany",
    lat: 53.33277893066406,
    lng: 9.028332710266113,
  },
  {
    id: "N",
    name: "Oldenburg-Hatten Airfield",
    city: "Oldenburg",
    country: "Germany",
    lat: 53.06889,
    lng: 8.313611,
  },
  {
    id: "N",
    name: "Rinteln Airport",
    city: "Rinteln",
    country: "Germany",
    lat: 52.17527770996094,
    lng: 9.053333282470703,
  },
  {
    id: "N",
    name: "Münster-Telgte Airport",
    city: "Muenster",
    country: "Germany",
    lat: 51.94444274902344,
    lng: 7.773889064788818,
  },
  {
    id: "PSH",
    name: "St. Peter-Ording Airport",
    city: "Sankt Peter-Ording",
    country: "Germany",
    lat: 54.30888748168945,
    lng: 8.686944007873535,
  },
  {
    id: "N",
    name: "Lüchow-Rehbeck Airport",
    city: "Luechow",
    country: "Germany",
    lat: 53.016109466552734,
    lng: 11.144444465637207,
  },
  {
    id: "N",
    name: "Klietz/Scharlibbe Airport",
    city: "Scharlibbe",
    country: "Germany",
    lat: 52.709442138671875,
    lng: 12.073332786560059,
  },
  {
    id: "N",
    name: "Burg Airport",
    city: "Burg",
    country: "Germany",
    lat: 52.241668701171875,
    lng: 11.856110572814941,
  },
  {
    id: "N",
    name: "Crisp County Cordele Airport",
    city: "Cordele",
    country: "United States",
    lat: 31.98880005,
    lng: -83.77390289,
  },
  {
    id: "N",
    name: "Ormond Beach Municipal Airport",
    city: "Ormond Beach",
    country: "United States",
    lat: 29.300600051879883,
    lng: -81.11360168457031,
  },
  {
    id: "N",
    name: "Bad Neuenahr-Ahrweiler Airfield",
    city: "Bad Neuenahr",
    country: "Germany",
    lat: 50.557777,
    lng: 7.136389,
  },
  {
    id: "N",
    name: "Bad Dürkheim Airport",
    city: "Bad Duerkheim",
    country: "Germany",
    lat: 49.47305679321289,
    lng: 8.196389198303223,
  },
  {
    id: "TTD",
    name: "Portland Troutdale Airport",
    city: "Troutdale",
    country: "United States",
    lat: 45.54940032959,
    lng: -122.40100097656,
  },
  {
    id: "HIO",
    name: "Portland Hillsboro Airport",
    city: "Hillsboro",
    country: "United States",
    lat: 45.540401,
    lng: -122.949997,
  },
  {
    id: "N",
    name: "One Police Plaza Heliport",
    city: "New York",
    country: "United States",
    lat: 40.71260070800781,
    lng: -73.99960327148438,
  },
  {
    id: "N",
    name: "Leverkusen Airport",
    city: "Leverkusen",
    country: "Germany",
    lat: 51.01527786254883,
    lng: 7.005556106567383,
  },
  {
    id: "N",
    name: "Wershofen/Eifel Airfield",
    city: "Wershofen",
    country: "Germany",
    lat: 50.451389,
    lng: 6.783333,
  },
  {
    id: "KHT",
    name: "Khost Airport",
    city: "Khost",
    country: "Afghanistan",
    lat: 33.3334007263,
    lng: 69.952003479,
  },
  {
    id: "NMT",
    name: "Namtu Airport",
    city: "Naypyidaw",
    country: "Burma",
    lat: 23.083,
    lng: 97.383003,
  },
  {
    id: "N",
    name: "Bend Municipal Airport",
    city: "Bend",
    country: "United States",
    lat: 44.09479904,
    lng: -121.2009964,
  },
  {
    id: "N",
    name: "Christmas Valley Airport",
    city: "Christmas Valley",
    country: "United States",
    lat: 43.23649978637695,
    lng: -120.66600036621094,
  },
  {
    id: "BNO",
    name: "Burns Municipal Airport",
    city: "Burns",
    country: "United States",
    lat: 43.5918998718,
    lng: -118.955001831,
  },
  {
    id: "PRZ",
    name: "Prineville Airport",
    city: "Prineville",
    country: "United States",
    lat: 44.286998748779,
    lng: -120.90399932861,
  },
  {
    id: "RBL",
    name: "Red Bluff Municipal Airport",
    city: "Red Bluff",
    country: "United States",
    lat: 40.1506996155,
    lng: -122.251998901,
  },
  {
    id: "NOT",
    name: "Marin County Airport - Gnoss Field",
    city: "Novato",
    country: "United States",
    lat: 38.143600463867,
    lng: -122.55599975586,
  },
  {
    id: "LKV",
    name: "Lake County Airport",
    city: "Lakeview",
    country: "United States",
    lat: 42.161098480199996,
    lng: -120.399002075,
  },
  {
    id: "OTK",
    name: "Tillamook Airport",
    city: "Tillamook",
    country: "United States",
    lat: 45.4182014465,
    lng: -123.814002991,
  },
  {
    id: "ONO",
    name: "Ontario Municipal Airport",
    city: "Ontario",
    country: "United States",
    lat: 44.020500183105,
    lng: -117.01399993896,
  },
  {
    id: "DLS",
    name: "Columbia Gorge Regional the Dalles Municipal Airport",
    city: "The Dalles",
    country: "United States",
    lat: 45.6184997559,
    lng: -121.166999817,
  },
  {
    id: "GAI",
    name: "Montgomery County Airpark",
    city: "Gaithersburg",
    country: "United States",
    lat: 39.168300628699996,
    lng: -77.1660003662,
  },
  {
    id: "OAS",
    name: "Sharana Airstrip",
    city: "Sharona",
    country: "Afghanistan",
    lat: 33.12575,
    lng: 68.838517,
  },
  {
    id: "YTA",
    name: "Pembroke Airport",
    city: "Pembroke",
    country: "Canada",
    lat: 45.86439895629883,
    lng: -77.25170135498047,
  },
  {
    id: "TSB",
    name: "Tsumeb Airport",
    city: "Tsumeb",
    country: "Namibia",
    lat: -19.26189994812,
    lng: 17.732500076294,
  },
  {
    id: "YSD",
    name: "Suffield Heliport",
    city: "Suffield",
    country: "Canada",
    lat: 50.266700744628906,
    lng: -111.18299865722656,
  },
  {
    id: "BNU",
    name: "Blumenau Airport",
    city: "BLUMENAU",
    country: "Brazil",
    lat: -26.83060073852539,
    lng: -49.090301513671875,
  },
  {
    id: "N",
    name: "Bolshoye Gryzlovo Airfield",
    city: "Stupino",
    country: "Russia",
    lat: 54.785,
    lng: 37.645,
  },
  {
    id: "N",
    name: "Charlevoix Municipal Airport",
    city: "Charelvoix",
    country: "United States",
    lat: 45.3047981262207,
    lng: -85.2748031616211,
  },
  {
    id: "N",
    name: "Mykines Heliport",
    city: "Mykines",
    country: "Faroe Islands",
    lat: 62.1021003723,
    lng: -7.645919799800001,
  },
  {
    id: "YCC",
    name: "Cornwall Regional Airport",
    city: "Cornwall",
    country: "Canada",
    lat: 45.09280014038086,
    lng: -74.56330108642578,
  },
  {
    id: "N",
    name: "Seppe Airfield",
    city: "Bosschenhoofd",
    country: "Netherlands",
    lat: 51.554699,
    lng: 4.5525,
  },
  {
    id: "N",
    name: "St Stephan Airport",
    city: "St.Stephan",
    country: "Switzerland",
    lat: 46.497398376464844,
    lng: 7.412569999694824,
  },
  {
    id: "IZA",
    name: "Zona da Mata Regional Airport",
    city: "Juiz de Fora",
    country: "Brazil",
    lat: -21.5130558014,
    lng: -43.1730575562,
  },
  {
    id: "N",
    name: "IAR Gimbav Heliport",
    city: "Brasov",
    country: "Romania",
    lat: 45.686443,
    lng: 25.529058,
  },
  {
    id: "N",
    name: "Flagler Executive Airport",
    city: "Flagler",
    country: "United States",
    lat: 29.4674,
    lng: -81.206299,
  },
  {
    id: "MVL",
    name: "Morrisville Stowe State Airport",
    city: "Morrisville",
    country: "United States",
    lat: 44.53459930419999,
    lng: -72.6139984131,
  },
  {
    id: "RBD",
    name: "Dallas Executive Airport",
    city: "Dallas",
    country: "United States",
    lat: 32.6809005737,
    lng: -96.8682022095,
  },
  {
    id: "N",
    name: "Como (Idroscalo - Water Ad) Hidroport",
    city: "Como",
    country: "Italy",
    lat: 45.814701,
    lng: 9.06972,
  },
  {
    id: "BXY",
    name: "Krainiy Airport",
    city: "Baikonur",
    country: "Kazakhstan",
    lat: 45.621994,
    lng: 63.210773,
  },
  {
    id: "WST",
    name: "Westerly State Airport",
    city: "Washington County",
    country: "United States",
    lat: 41.3496017456,
    lng: -71.8033981323,
  },
  {
    id: "BID",
    name: "Block Island State Airport",
    city: "Block Island",
    country: "United States",
    lat: 41.1680984497,
    lng: -71.577796936,
  },
  {
    id: "NME",
    name: "Nightmute Airport",
    city: "Nightmute",
    country: "United States",
    lat: 60.471000671387,
    lng: -164.70100402832,
  },
  {
    id: "OOK",
    name: "Toksook Bay Airport",
    city: "Toksook Bay",
    country: "United States",
    lat: 60.54140091,
    lng: -165.0870056,
  },
  {
    id: "OBY",
    name: "Ittoqqortoormiit Heliport",
    city: "Ittoqqortoormiit",
    country: "Greenland",
    lat: 70.4882288244,
    lng: -21.971679925900002,
  },
  {
    id: "VIN",
    name: "Vinnytsia/Gavyryshivka Airport",
    city: "Vinnitsa",
    country: "Ukraine",
    lat: 49.242531,
    lng: 28.613778,
  },
  {
    id: "BGE",
    name: "Decatur County Industrial Air Park",
    city: "Bainbridge",
    country: "United States",
    lat: 30.9715004,
    lng: -84.63739777,
  },
  {
    id: "ZGS",
    name: "La Romaine Airport",
    city: "La Romaine",
    country: "Canada",
    lat: 50.259701,
    lng: -60.679401,
  },
  {
    id: "ZKG",
    name: "Kegaska Airport",
    city: "Kegaska",
    country: "Canada",
    lat: 50.1958007812,
    lng: -61.265800476100004,
  },
  {
    id: "YBI",
    name: "Black Tickle Airport",
    city: "Black Tickle",
    country: "Canada",
    lat: 53.4693984985,
    lng: -55.784999847399995,
  },
  {
    id: "N",
    name: "Silver Springs Airport",
    city: "Silver Springs",
    country: "United States",
    lat: 39.40299987792969,
    lng: -119.2509994506836,
  },
  {
    id: "WHP",
    name: "Whiteman Airport",
    city: "Los Angeles",
    country: "United States",
    lat: 34.2593002319,
    lng: -118.413002014,
  },
  {
    id: "MAE",
    name: "Madera Municipal Airport",
    city: "Madera",
    country: "United States",
    lat: 36.9886016846,
    lng: -120.111999512,
  },
  {
    id: "YZZ",
    name: "Trail Airport",
    city: "Trail",
    country: "Canada",
    lat: 49.0555992126,
    lng: -117.60900116,
  },
  {
    id: "N",
    name: "Victoria Airport",
    city: "Patricia Bay",
    country: "Canada",
    lat: 48.6538920506,
    lng: -123.450450897,
  },
  {
    id: "YAB",
    name: "Old Arctic Bay Airport",
    city: "Arctic Bay",
    country: "Canada",
    lat: 73.0058922479,
    lng: -85.0325489044,
  },
  {
    id: "N",
    name: "Birchwood Airport",
    city: "Belmopan",
    country: "Belize",
    lat: 61.41650009,
    lng: -149.5070038,
  },
  {
    id: "GSI",
    name: "Grand-Santi Airport",
    city: "Grand-Santi",
    country: "French Guiana",
    lat: 4.285833,
    lng: -54.373056,
  },
  {
    id: "MPY",
    name: "Maripasoula Airport",
    city: "Maripasoula",
    country: "French Guiana",
    lat: 3.6575,
    lng: -54.037201,
  },
  {
    id: "LDX",
    name: "Saint-Laurent-du-Maroni Airport",
    city: "Saint-Laurent-du-Maroni",
    country: "French Guiana",
    lat: 5.48306,
    lng: -54.034401,
  },
  {
    id: "KJI",
    name: "Kanas Airport",
    city: "Burqin",
    country: "China",
    lat: 48.2223,
    lng: 86.9959,
  },
  {
    id: "CPB",
    name: "Capurganá Airport",
    city: "Capurgana",
    country: "Colombia",
    lat: 8.63333,
    lng: -77.35,
  },
  {
    id: "HMB",
    name: "Sohag International Airport",
    city: "Sohag",
    country: "Egypt",
    lat: 26.342778,
    lng: 31.742778,
  },
  {
    id: "RVY",
    name: "Presidente General Don Oscar D. Gestido International Airport",
    city: "Rivera",
    country: "Uruguay",
    lat: -30.974599838256836,
    lng: -55.476200103759766,
  },
  {
    id: "POJ",
    name: "Patos de Minas Airport",
    city: "Patos de Minas",
    country: "Brazil",
    lat: -18.672800064086914,
    lng: -46.4911994934082,
  },
  {
    id: "JTC",
    name: "Bauru - Arealva Airport",
    city: "Bauru",
    country: "Brazil",
    lat: -22.166859140899998,
    lng: -49.0502866745,
  },
  {
    id: "OIA",
    name: "Ourilândia do Norte Airport",
    city: "Ourilandia do Norte",
    country: "Brazil",
    lat: -6.763100147250001,
    lng: -51.0499000549,
  },
  {
    id: "RDC",
    name: "Redenção Airport",
    city: "Redencao",
    country: "Brazil",
    lat: -8.033289909362793,
    lng: -49.97990036010742,
  },
  {
    id: "SXX",
    name: "São Félix do Xingu Airport",
    city: "Sao Felix do Xingu",
    country: "Brazil",
    lat: -6.6413,
    lng: -51.9523,
  },
  {
    id: "BYO",
    name: "Bonito Airport",
    city: "Bointo",
    country: "Brazil",
    lat: -21.247299,
    lng: -56.452499,
  },
  {
    id: "SXO",
    name: "São Félix do Araguaia Airport",
    city: "Sao Felix do Araguaia",
    country: "Brazil",
    lat: -11.632399559020996,
    lng: -50.68960189819336,
  },
  {
    id: "CFC",
    name: "Caçador Airport",
    city: "Cacador",
    country: "Brazil",
    lat: -26.78840065,
    lng: -50.9398002625,
  },
  {
    id: "CAF",
    name: "Carauari Airport",
    city: "Carauari",
    country: "Brazil",
    lat: -4.871520042419434,
    lng: -66.89749908447266,
  },
  {
    id: "N",
    name: "Urucu Airport",
    city: "Porto Urucu",
    country: "Brazil",
    lat: -4.88422012329,
    lng: -65.3554000854,
  },
  {
    id: "ERN",
    name: "Eirunepé Airport",
    city: "Eirunepe",
    country: "Brazil",
    lat: -6.639530181884766,
    lng: -69.87979888916016,
  },
  {
    id: "CCI",
    name: "Concórdia Airport",
    city: "Concordia",
    country: "Brazil",
    lat: -27.180599212646484,
    lng: -52.05270004272461,
  },
  {
    id: "FBE",
    name: "Francisco Beltrão Airport",
    city: "Francisco Beltrao",
    country: "Brazil",
    lat: -26.059200286865234,
    lng: -53.063499450683594,
  },
  {
    id: "CFO",
    name: "Confresa Airport",
    city: "Confresa",
    country: "Brazil",
    lat: -10.634400367736816,
    lng: -51.5635986328125,
  },
  {
    id: "AAF",
    name: "Apalachicola Regional Airport",
    city: "Apalachicola",
    country: "United States",
    lat: 29.72750092,
    lng: -85.02749634,
  },
  {
    id: "UMU",
    name: "Umuarama Airport",
    city: "Umuarama",
    country: "Brazil",
    lat: -23.7987003326416,
    lng: -53.31380081176758,
  },
  {
    id: "DTI",
    name: "Diamantina Airport",
    city: "Diamantina",
    country: "Brazil",
    lat: -18.232000351,
    lng: -43.650398254399995,
  },
  {
    id: "FBA",
    name: "Fonte Boa Airport",
    city: "Fonte Boa",
    country: "Brazil",
    lat: -2.5326099395800004,
    lng: -66.0831985474,
  },
  {
    id: "OLC",
    name: "Senadora Eunice Micheles Airport",
    city: "Sao Paulo de Olivenca",
    country: "Brazil",
    lat: -3.46792950765,
    lng: -68.9204120636,
  },
  {
    id: "HUW",
    name: "Humaitá Airport",
    city: "Humaita",
    country: "Brazil",
    lat: -7.532120227810001,
    lng: -63.072101593,
  },
  {
    id: "IRZ",
    name: "Tapuruquara Airport",
    city: "Santa Isabel do Rio Negro",
    country: "Brazil",
    lat: -0.3786,
    lng: -64.9923,
  },
  {
    id: "ORX",
    name: "Oriximiná Airport",
    city: "Oriximina",
    country: "Brazil",
    lat: -1.7140799760818481,
    lng: -55.83620071411133,
  },
  {
    id: "UNA",
    name: "Hotel Transamérica Airport",
    city: "Una",
    country: "Brazil",
    lat: -15.355199813799999,
    lng: -38.9990005493,
  },
  {
    id: "TEF",
    name: "Telfer Airport",
    city: "Telfer",
    country: "Australia",
    lat: -21.71500015258789,
    lng: 122.22899627685547,
  },
  {
    id: "GZP",
    name: "Gazipaşa Airport",
    city: "Alanya",
    country: "Turkey",
    lat: 36.299217,
    lng: 32.300598,
  },
  {
    id: "OAA",
    name: "Shank Air Base",
    city: "Shank",
    country: "Afghanistan",
    lat: 33.9225,
    lng: 69.07722222219999,
  },
  {
    id: "N",
    name: "Douglas Municipal Airport",
    city: "Douglas",
    country: "United States",
    lat: 31.476699829101562,
    lng: -82.8604965209961,
  },
  {
    id: "FPR",
    name: "St Lucie County International Airport",
    city: "Fort Pierce",
    country: "United States",
    lat: 27.49510002,
    lng: -80.36830139,
  },
  {
    id: "N",
    name: "Taunton Municipal King Field",
    city: "Taunton",
    country: "United States",
    lat: 41.8744010925293,
    lng: -71.0166015625,
  },
  {
    id: "PYM",
    name: "Plymouth Municipal Airport",
    city: "Plymouth",
    country: "United States",
    lat: 41.909,
    lng: -70.728798,
  },
  {
    id: "NCO",
    name: "Quonset State Airport",
    city: "North Kingstown",
    country: "United States",
    lat: 41.597099304199,
    lng: -71.412101745605,
  },
  {
    id: "OWD",
    name: "Norwood Memorial Airport",
    city: "Norwood",
    country: "United States",
    lat: 42.1904983521,
    lng: -71.1728973389,
  },
  {
    id: "BAF",
    name: "Westfield-Barnes Regional Airport",
    city: "Westfield",
    country: "United States",
    lat: 42.157799,
    lng: -72.715599,
  },
  {
    id: "N",
    name: "Windham Airport",
    city: "Willimantic",
    country: "United States",
    lat: 41.74399948120117,
    lng: -72.1802978515625,
  },
  {
    id: "MGJ",
    name: "Orange County Airport",
    city: "Montgomery",
    country: "United States",
    lat: 41.50999832,
    lng: -74.26460266,
  },
  {
    id: "HAR",
    name: "Capital City Airport",
    city: "Harrisburg",
    country: "United States",
    lat: 40.2170982361,
    lng: -76.85150146480001,
  },
  {
    id: "N",
    name: "Marshfield Municipal George Harlow Field",
    city: "Marshfield",
    country: "United States",
    lat: 42.09830093383789,
    lng: -70.67220306396484,
  },
  {
    id: "DXR",
    name: "Danbury Municipal Airport",
    city: "Danbury",
    country: "United States",
    lat: 41.371498107899995,
    lng: -73.48220062259999,
  },
  {
    id: "ASH",
    name: "Boire Field",
    city: "Nashua",
    country: "United States",
    lat: 42.7817001343,
    lng: -71.51480102539999,
  },
  {
    id: "LWM",
    name: "Lawrence Municipal Airport",
    city: "Lawrence",
    country: "United States",
    lat: 42.717201232899995,
    lng: -71.1233978271,
  },
  {
    id: "OXC",
    name: "Waterbury Oxford Airport",
    city: "Oxford",
    country: "United States",
    lat: 41.47859954834,
    lng: -73.135200500488,
  },
  {
    id: "N",
    name: "Fitchburg Municipal Airport",
    city: "Fitchburg",
    country: "United States",
    lat: 42.554100036621094,
    lng: -71.75900268554688,
  },
  {
    id: "N",
    name: "Earl L. Small Jr. Field/Stockmar Airport",
    city: "Villa Rica",
    country: "United States",
    lat: 33.756500244099996,
    lng: -84.88469696039999,
  },
  {
    id: "N",
    name: "Cartersville Airport",
    city: "Cartersville",
    country: "United States",
    lat: 34.12310028076172,
    lng: -84.84870147705078,
  },
  {
    id: "N",
    name: "Centre-Piedmont-Cherokee County Regional Airport",
    city: "Centre",
    country: "United States",
    lat: 34.089977,
    lng: -85.610069,
  },
  {
    id: "RMG",
    name: "Richard B Russell Airport",
    city: "Rome",
    country: "United States",
    lat: 34.3506011963,
    lng: -85.15799713130001,
  },
  {
    id: "GAD",
    name: "Northeast Alabama Regional Airport",
    city: "Gadsden",
    country: "United States",
    lat: 33.972599,
    lng: -86.088996,
  },
  {
    id: "N",
    name: "Knoxville Downtown Island Airport",
    city: "Knoxville",
    country: "United States",
    lat: 35.96390151977539,
    lng: -83.8739013671875,
  },
  {
    id: "WDR",
    name: "Barrow County Airport",
    city: "Winder",
    country: "United States",
    lat: 33.98289871,
    lng: -83.66739655,
  },
  {
    id: "N",
    name: "Plantation Airpark",
    city: "Sylvania",
    country: "United States",
    lat: 32.645301818847656,
    lng: -81.59709930419922,
  },
  {
    id: "DNN",
    name: "Dalton Municipal Airport",
    city: "Dalton",
    country: "United States",
    lat: 34.72290039,
    lng: -84.87020111,
  },
  {
    id: "N",
    name: "West Georgia Regional O V Gray Field",
    city: "Carrollton",
    country: "United States",
    lat: 33.63100051879883,
    lng: -85.1520004272461,
  },
  {
    id: "LGC",
    name: "LaGrange Callaway Airport",
    city: "LaGrange",
    country: "United States",
    lat: 33.0089,
    lng: -85.072601,
  },
  {
    id: "N",
    name: "Baldwin County Regional Airport",
    city: "Milledgeville",
    country: "United States",
    lat: 33.154202,
    lng: -83.240701,
  },
  {
    id: "PIM",
    name: "Harris County Airport",
    city: "Pine Mountain",
    country: "United States",
    lat: 32.8406982422,
    lng: -84.8824005127,
  },
  {
    id: "N",
    name: "Peachtree City Falcon Field",
    city: "Atlanta",
    country: "United States",
    lat: 33.3572998046875,
    lng: -84.5718002319336,
  },
  {
    id: "GVL",
    name: "Lee Gilmer Memorial Airport",
    city: "Gainesville",
    country: "United States",
    lat: 34.27259827,
    lng: -83.8302002,
  },
  {
    id: "PHD",
    name: "Harry Clever Field",
    city: "New Philadelpha",
    country: "United States",
    lat: 40.470901489258,
    lng: -81.419700622559,
  },
  {
    id: "N",
    name: "Darlington County Airport",
    city: "Darlington",
    country: "United States",
    lat: 34.449401,
    lng: -79.890098,
  },
  {
    id: "HHH",
    name: "Hilton Head Airport",
    city: "Hilton Head Island",
    country: "United States",
    lat: 32.2243995667,
    lng: -80.6975021362,
  },
  {
    id: "DNL",
    name: "Daniel Field",
    city: "Augusta",
    country: "United States",
    lat: 33.4664993286,
    lng: -82.0393981934,
  },
  {
    id: "MRN",
    name: "Foothills Regional Airport",
    city: "Morganton",
    country: "United States",
    lat: 35.820202,
    lng: -81.611397,
  },
  {
    id: "PVL",
    name: "Pike County-Hatcher Field",
    city: "Pikeville",
    country: "United States",
    lat: 37.5617981,
    lng: -82.56639862,
  },
  {
    id: "N",
    name: "Mallards Landing Airport",
    city: "Locust Grove",
    country: "United States",
    lat: 33.365699768066406,
    lng: -84.16519927978516,
  },
  {
    id: "TOC",
    name: "Toccoa Airport - R.G. Letourneau Field",
    city: "Toccoa",
    country: "United States",
    lat: 34.59379959,
    lng: -83.29579926,
  },
  {
    id: "N",
    name: "Compton Abbas Aerodrome",
    city: "Shaftesbury",
    country: "United Kingdom",
    lat: 50.967201232910156,
    lng: -2.1536099910736084,
  },
  {
    id: "PLV",
    name: "Suprunovka Airport",
    city: "Poltava",
    country: "Ukraine",
    lat: 49.568599700927734,
    lng: 34.39720153808594,
  },
  {
    id: "N",
    name: "Aweil Airport",
    city: "Aweil",
    country: "Sudan",
    lat: 8.767000198364258,
    lng: 27.399999618530273,
  },
  {
    id: "WUU",
    name: "Wau Airport",
    city: "Wau",
    country: "Sudan",
    lat: 7.7258300781199996,
    lng: 27.9750003815,
  },
  {
    id: "HUE",
    name: "Humera Airport",
    city: "Humera",
    country: "Ethiopia",
    lat: 14.25,
    lng: 36.58300018310547,
  },
  {
    id: "OYL",
    name: "Moyale Airport",
    city: "Moyale",
    country: "Kenya",
    lat: 3.46972,
    lng: 39.101398,
  },
  {
    id: "OZG",
    name: "Zagora Airport",
    city: "Zagora",
    country: "Morocco",
    lat: 30.3202991486,
    lng: -5.86667013168,
  },
  {
    id: "WYE",
    name: "Yengema Airport",
    city: "Yengema",
    country: "Sierra Leone",
    lat: 8.610469818115234,
    lng: -11.04539966583252,
  },
  {
    id: "GBK",
    name: "Gbangbatok Airport",
    city: "Gbangbatok",
    country: "Sierra Leone",
    lat: 7.767000198364258,
    lng: -12.383000373840332,
  },
  {
    id: "THX",
    name: "Turukhansk Airport",
    city: "Turukhansk",
    country: "Russia",
    lat: 65.797203064,
    lng: 87.9353027344,
  },
  {
    id: "TGP",
    name: "Podkamennaya Tunguska Airport",
    city: "Bor",
    country: "Russia",
    lat: 61.589699,
    lng: 89.994003,
  },
  {
    id: "AFW",
    name: "Fort Worth Alliance Airport",
    city: "Fort Worth",
    country: "United States",
    lat: 32.9875984192,
    lng: -97.31880187990001,
  },
  {
    id: "N",
    name: "East Troy Municipal Airport",
    city: "East Troy",
    country: "United States",
    lat: 42.79719924926758,
    lng: -88.37259674072266,
  },
  {
    id: "N",
    name: "Kolpashevo Airport",
    city: "Kolpashevo",
    country: "Russia",
    lat: 58.32529830932617,
    lng: 82.93250274658203,
  },
  {
    id: "N",
    name: "Ali Al Salem Air Base",
    city: "Kuwait",
    country: "Kuwait",
    lat: 29.34670066833496,
    lng: 47.52080154418945,
  },
  {
    id: "RMK",
    name: "Renmark Airport",
    city: "Renmark",
    country: "Australia",
    lat: -34.1963996887207,
    lng: 140.6739959716797,
  },
  {
    id: "LGH",
    name: "Leigh Creek Airport",
    city: "Leigh Creek",
    country: "Australia",
    lat: -30.59830093383789,
    lng: 138.42599487304688,
  },
  {
    id: "N",
    name: "Warburton Airport",
    city: "Warburton Community",
    country: "Australia",
    lat: -26.128299713134766,
    lng: 126.58300018310547,
  },
  {
    id: "N",
    name: "Cunderdin Airport",
    city: "Cunderdin",
    country: "Australia",
    lat: -31.62220001220703,
    lng: 117.21700286865234,
  },
  {
    id: "RTS",
    name: "Rottnest Island Airport",
    city: "Rottnest Island",
    country: "Australia",
    lat: -32.006699,
    lng: 115.540001,
  },
  {
    id: "FOS",
    name: "Forrest Airport",
    city: "Forrest",
    country: "Australia",
    lat: -30.83810043334961,
    lng: 128.11500549316406,
  },
  {
    id: "N",
    name: "Ballarat Airport",
    city: "Ballarat",
    country: "Australia",
    lat: -37.51169967651367,
    lng: 143.79100036621094,
  },
  {
    id: "KEW",
    name: "Keewaywin Airport",
    city: "Keewaywin",
    country: "Canada",
    lat: 52.991100311299995,
    lng: -92.8364028931,
  },
  {
    id: "YSP",
    name: "Marathon Airport",
    city: "Marathon",
    country: "Canada",
    lat: 48.75529861450195,
    lng: -86.34439849853516,
  },
  {
    id: "YHF",
    name: "Hearst René Fontaine Municipal Airport",
    city: "Hearst",
    country: "Canada",
    lat: 49.71419906616211,
    lng: -83.68609619140625,
  },
  {
    id: "YHN",
    name: "Hornepayne Municipal Airport",
    city: "Hornepayne",
    country: "Canada",
    lat: 49.19309997558594,
    lng: -84.75890350341797,
  },
  {
    id: "YKX",
    name: "Kirkland Lake Airport",
    city: "Kirkland Lake",
    country: "Canada",
    lat: 48.21030044555664,
    lng: -79.98139953613281,
  },
  {
    id: "YMG",
    name: "Manitouwadge Airport",
    city: "Manitouwadge",
    country: "Canada",
    lat: 49.083900451660156,
    lng: -85.86060333251953,
  },
  {
    id: "YXZ",
    name: "Wawa Airport",
    city: "Wawa",
    country: "Canada",
    lat: 47.96670150756836,
    lng: -84.78669738769531,
  },
  {
    id: "YEM",
    name: "Manitoulin East Municipal Airport",
    city: "Manitowaning",
    country: "Canada",
    lat: 45.84280014038086,
    lng: -81.85810089111328,
  },
  {
    id: "N",
    name: "Slate Falls Airport",
    city: "Slate Falls",
    country: "Canada",
    lat: 51.130001068115234,
    lng: -91.66560363769531,
  },
  {
    id: "N",
    name: "Collingwood Airport",
    city: "Collingwood",
    country: "Canada",
    lat: 44.4491996765,
    lng: -80.1583023071,
  },
  {
    id: "N",
    name: "Brantford Municipal Airport",
    city: "Brantford",
    country: "Canada",
    lat: 43.13140106201172,
    lng: -80.34249877929688,
  },
  {
    id: "LWC",
    name: "Lawrence Municipal Airport",
    city: "Lawrence",
    country: "United States",
    lat: 39.01119995,
    lng: -95.21659851,
  },
  {
    id: "N",
    name: "Wellington Municipal Airport",
    city: "Wellington",
    country: "United States",
    lat: 37.32360076904297,
    lng: -97.38829803466797,
  },
  {
    id: "PPM",
    name: "Pompano Beach Airpark",
    city: "Pompano Beach",
    country: "United States",
    lat: 26.247100830078,
    lng: -80.111099243164,
  },
  {
    id: "XMC",
    name: "Mallacoota Airport",
    city: "Mallacoota",
    country: "Australia",
    lat: -37.59830093383789,
    lng: 149.72000122070312,
  },
  {
    id: "ULH",
    name: "Majeed Bin Abdulaziz Airport",
    city: "Al-Ula",
    country: "Saudi Arabia",
    lat: 26.48,
    lng: 38.1288888889,
  },
  {
    id: "N",
    name: "Shelby County Airport",
    city: "Alabaster",
    country: "United States",
    lat: 33.17699814,
    lng: -86.78279877,
  },
  {
    id: "YUE",
    name: "Yuendumu Airport",
    city: "Yuendumu ",
    country: "Australia",
    lat: -22.254199981689453,
    lng: 131.78199768066406,
  },
  {
    id: "N",
    name: "Sky Ranch At Carefree Airport",
    city: "Carefree",
    country: "United States",
    lat: 33.81809997558594,
    lng: -111.89800262451172,
  },
  {
    id: "LOP",
    name: "Lombok International Airport",
    city: "Praya",
    country: "Indonesia",
    lat: -8.757322,
    lng: 116.276675,
  },
  {
    id: "N",
    name: "One Hundred Mile House Airport",
    city: "One Hundred Mile House",
    country: "Canada",
    lat: 51.64250183105469,
    lng: -121.30699920654297,
  },
  {
    id: "ZMH",
    name: "South Cariboo Region / 108 Mile Airport",
    city: "108 Mile Ranch",
    country: "Canada",
    lat: 51.736099243199995,
    lng: -121.333000183,
  },
  {
    id: "N",
    name: "Glasgow City Heliport",
    city: "Glasgow",
    country: "United Kingdom",
    lat: 55.86138916015625,
    lng: -4.2969441413879395,
  },
  {
    id: "N",
    name: "Yarram Airport",
    city: "Yarram",
    country: "Australia",
    lat: -38.56669998168945,
    lng: 146.7550048828125,
  },
  {
    id: "HDG",
    name: "Handan Airport",
    city: "Handan",
    country: "China",
    lat: 36.5258333333,
    lng: 114.425555556,
  },
  {
    id: "N",
    name: "Indianapolis Metropolitan Airport",
    city: "Indianapolis",
    country: "United States",
    lat: 39.93519974,
    lng: -86.04499817,
  },
  {
    id: "LOZ",
    name: "London-Corbin Airport/Magee Field",
    city: "London",
    country: "United States",
    lat: 37.0821990967,
    lng: -84.08489990230001,
  },
  {
    id: "FBG",
    name: "Simmons Army Air Field",
    city: "Fredericksburg",
    country: "United States",
    lat: 35.13180161,
    lng: -78.93669891,
  },
  {
    id: "WMI",
    name: "Modlin Airport",
    city: "Warsaw",
    country: "Poland",
    lat: 52.451099,
    lng: 20.6518,
  },
  {
    id: "JXA",
    name: "Jixi Xingkaihu Airport",
    city: "Jixi",
    country: "China",
    lat: 45.293,
    lng: 131.193,
  },
  {
    id: "JDG",
    name: "Jeongseok Airport",
    city: "Seogwipo",
    country: "South Korea",
    lat: 33.3996009827,
    lng: 126.711997986,
  },
  {
    id: "YGM",
    name: "Gimli Industrial Park Airport",
    city: "Gimli",
    country: "Canada",
    lat: 50.62810134887695,
    lng: -97.04329681396484,
  },
  {
    id: "N",
    name: "Matheson Island Airport",
    city: "Matheson Island",
    country: "Canada",
    lat: 51.732200622558594,
    lng: -96.93440246582031,
  },
  {
    id: "N",
    name: "Tura Mountain Airport",
    city: "Tura",
    country: "Russia",
    lat: 64.333511352539,
    lng: 100.4328918457,
  },
  {
    id: "EYK",
    name: "Beloyarskiy Airport",
    city: "Beloyarsky",
    country: "Russia",
    lat: 63.686901,
    lng: 66.698601,
  },
  {
    id: "RAC",
    name: "John H Batten Airport",
    city: "Racine",
    country: "United States",
    lat: 42.7606010437,
    lng: -87.8152008057,
  },
  {
    id: "RZP",
    name: "Cesar Lim Rodriguez Airport",
    city: "Taytay",
    country: "Philippines",
    lat: 10.81874,
    lng: 119.507697,
  },
  {
    id: "N",
    name: "Gera-Leumnitz Airfield",
    city: "Gera",
    country: "Germany",
    lat: 50.881668,
    lng: 12.135833,
  },
  {
    id: "N",
    name: "Kasimovo Airfield",
    city: "Saint-Petersburg",
    country: "Russia",
    lat: 60.198299,
    lng: 30.334999,
  },
  {
    id: "N",
    name: "Terlet Glider Field",
    city: "Arnhem",
    country: "Netherlands",
    lat: 52.057201,
    lng: 5.92444,
  },
  {
    id: "RKZ",
    name: "Shigatse Air Base",
    city: "Shigatse",
    country: "China",
    lat: 29.3519,
    lng: 89.311401,
  },
  {
    id: "N",
    name: "Redlands Municipal Airport",
    city: "Redlands",
    country: "United States",
    lat: 34.08530044555664,
    lng: -117.14600372314453,
  },
  {
    id: "N",
    name: "Flabob Airport",
    city: "Riverside",
    country: "United States",
    lat: 33.98970031738281,
    lng: -117.41100311279297,
  },
  {
    id: "TIW",
    name: "Tacoma Narrows Airport",
    city: "Tacoma",
    country: "United States",
    lat: 47.26789856,
    lng: -122.5780029,
  },
  {
    id: "N",
    name: "Oerlinghausen Airport",
    city: "TELGTE",
    country: "Germany",
    lat: 51.932220458984375,
    lng: 8.661666870117188,
  },
  {
    id: "GUF",
    name: "Jack Edwards Airport",
    city: "Gulf Shores",
    country: "United States",
    lat: 30.29050064,
    lng: -87.67179871,
  },
  {
    id: "IBB",
    name: "General Villamil Airport",
    city: "Isabela",
    country: "Ecuador",
    lat: -0.942628026009,
    lng: -90.9530029297,
  },
  {
    id: "N",
    name: "Balzers Heliport",
    city: "Balzers",
    country: "Switzerland",
    lat: 47.0681,
    lng: 9.48111,
  },
  {
    id: "N",
    name: "Flugplatz Punitz",
    city: "Punitz-Guessing",
    country: "Austria",
    lat: 47.14653,
    lng: 16.316843,
  },
  {
    id: "HMJ",
    name: "Khmelnytskyi Airport",
    city: "Khmeinitskiy",
    country: "Ukraine",
    lat: 49.359699,
    lng: 26.933399,
  },
  {
    id: "HIW",
    name: "Hiroshimanishi Airport",
    city: "Hiroshima",
    country: "Japan",
    lat: 34.36690139770508,
    lng: 132.41400146484375,
  },
  {
    id: "KYI",
    name: "Yalata Mission Airport",
    city: "Yalata",
    country: "Australia",
    lat: -31.470600128173828,
    lng: 131.8249969482422,
  },
  {
    id: "HZL",
    name: "Hazleton Municipal Airport",
    city: "Hazleton",
    country: "United States",
    lat: 40.986801147499996,
    lng: -75.9949035645,
  },
  {
    id: "CBE",
    name: "Greater Cumberland Regional Airport",
    city: "Cumberland",
    country: "United States",
    lat: 39.615398407,
    lng: -78.7609024048,
  },
  {
    id: "N",
    name: "Sugar Loaf Shores Airport",
    city: "Key West",
    country: "United States",
    lat: 24.648799896240234,
    lng: -81.57980346679688,
  },
  {
    id: "WYN",
    name: "Wyndham Airport",
    city: "Wyndham",
    country: "Australia",
    lat: -15.51140022277832,
    lng: 128.1529998779297,
  },
  {
    id: "YBO",
    name: "Bob Quinn Lake Airport",
    city: "Bob Quinn Lake",
    country: "Canada",
    lat: 56.9667015076,
    lng: -130.25,
  },
  {
    id: "N",
    name: "Msembe Airport",
    city: "Msembe",
    country: "Tanzania",
    lat: -7.684811,
    lng: 34.922282,
  },
  {
    id: "KLF",
    name: "Grabtsevo Airport",
    city: "Kaluga",
    country: "Russia",
    lat: 54.5499992371,
    lng: 36.3666687012,
  },
  {
    id: "LNR",
    name: "Tri-County Regional Airport",
    city: "Lone Rock",
    country: "United States",
    lat: 43.2117004395,
    lng: -90.181602478,
  },
  {
    id: "N",
    name: "Price County Airport",
    city: "Phillips",
    country: "United States",
    lat: 45.70899963378906,
    lng: -90.40249633789062,
  },
  {
    id: "N",
    name: "Monroe Municipal Airport",
    city: "Monroe",
    country: "United States",
    lat: 42.614898681640625,
    lng: -89.59040069580078,
  },
  {
    id: "JOT",
    name: "Joliet Regional Airport",
    city: "Joliet",
    country: "United States",
    lat: 41.51779938,
    lng: -88.17549896,
  },
  {
    id: "VYS",
    name: "Illinois Valley Regional Airport-Walter A Duncan Field",
    city: "Peru",
    country: "United States",
    lat: 41.351898,
    lng: -89.153099,
  },
  {
    id: "JXN",
    name: "Jackson County Reynolds Field",
    city: "Jackson",
    country: "United States",
    lat: 42.259799957300004,
    lng: -84.45939636230001,
  },
  {
    id: "N",
    name: "Fuerstenwalde Airport",
    city: "Furstenwalde",
    country: "Germany",
    lat: 52.3905982971,
    lng: 14.0972003937,
  },
  {
    id: "N",
    name: "Eberswalde-Finow Airport",
    city: "Eberswalde",
    country: "Germany",
    lat: 52.82722091674805,
    lng: 13.693611145019531,
  },
  {
    id: "N",
    name: "Joseph A. Hardy Connellsville Airport",
    city: "Connellsville",
    country: "United States",
    lat: 39.95920181,
    lng: -79.65709686,
  },
  {
    id: "N",
    name: "Bedford County Airport",
    city: "Bedford",
    country: "United States",
    lat: 40.08530045,
    lng: -78.5121994,
  },
  {
    id: "BBX",
    name: "Wings Field",
    city: "Philadelphia",
    country: "United States",
    lat: 40.1375007629,
    lng: -75.2650985718,
  },
  {
    id: "OBE",
    name: "Okeechobee County Airport",
    city: "Okeechobee",
    country: "United States",
    lat: 27.262800216699997,
    lng: -80.8498001099,
  },
  {
    id: "SEF",
    name: "Sebring Regional Airport",
    city: "Sebring",
    country: "United States",
    lat: 27.45639992,
    lng: -81.3423996,
  },
  {
    id: "AVO",
    name: "Avon Park Executive Airport",
    city: "Avon Park",
    country: "United States",
    lat: 27.59119987,
    lng: -81.52780151,
  },
  {
    id: "GIF",
    name: "Winter Haven Regional Airport - Gilbert Field",
    city: "Winter Haven",
    country: "United States",
    lat: 28.062901,
    lng: -81.753304,
  },
  {
    id: "ZPH",
    name: "Zephyrhills Municipal Airport",
    city: "Zephyrhills",
    country: "United States",
    lat: 28.2282009125,
    lng: -82.15589904790001,
  },
  {
    id: "OCF",
    name: "Ocala International Airport - Jim Taylor Field",
    city: "Ocala",
    country: "United States",
    lat: 29.17259979,
    lng: -82.22419739,
  },
  {
    id: "N",
    name: "Jesup Wayne County Airport",
    city: "Jesup",
    country: "United States",
    lat: 31.55400085,
    lng: -81.88249969,
  },
  {
    id: "N",
    name: "Madison Municipal Airport",
    city: "Madison",
    country: "United States",
    lat: 33.6120986938,
    lng: -83.46040344240001,
  },
  {
    id: "N",
    name: "Newnan Coweta County Airport",
    city: "Newnan",
    country: "United States",
    lat: 33.31159973144531,
    lng: -84.7697982788086,
  },
  {
    id: "N",
    name: "Thomson-McDuffie County Airport",
    city: "Thomson",
    country: "United States",
    lat: 33.52970123,
    lng: -82.51650238,
  },
  {
    id: "AIK",
    name: "Aiken Regional Airport",
    city: "Aiken",
    country: "United States",
    lat: 33.649399,
    lng: -81.684998,
  },
  {
    id: "CDN",
    name: "Woodward Field",
    city: "Camden",
    country: "United States",
    lat: 34.2835998535,
    lng: -80.56490325930001,
  },
  {
    id: "LBT",
    name: "Lumberton Regional Airport",
    city: "Lumberton",
    country: "United States",
    lat: 34.6099014282,
    lng: -79.05940246579999,
  },
  {
    id: "SOP",
    name: "Moore County Airport",
    city: "Pinehurst-Southern Pines",
    country: "United States",
    lat: 35.23740005,
    lng: -79.3911972,
  },
  {
    id: "N",
    name: "Richmond County Airport",
    city: "Rockingham",
    country: "United States",
    lat: 34.8913,
    lng: -79.759598,
  },
  {
    id: "N",
    name: "Baraboo Wisconsin Dells Airport",
    city: "Baraboo",
    country: "United States",
    lat: 43.52270126,
    lng: -89.77020264,
  },
  {
    id: "SVH",
    name: "Statesville Regional Airport",
    city: "Statesville",
    country: "United States",
    lat: 35.765300750732,
    lng: -80.953903198242,
  },
  {
    id: "N",
    name: "Burlington Municipal Airport",
    city: "Burlington",
    country: "United States",
    lat: 42.69070053100586,
    lng: -88.30460357666016,
  },
  {
    id: "LHV",
    name: "William T. Piper Memorial Airport",
    city: "Lock Haven",
    country: "United States",
    lat: 41.13560104,
    lng: -77.42230225,
  },
  {
    id: "N",
    name: "Zelienople Municipal Airport",
    city: "Zelienople",
    country: "United States",
    lat: 40.80160141,
    lng: -80.16069794,
  },
  {
    id: "N",
    name: "Lorain County Regional Airport",
    city: "Lorain-Elyria",
    country: "United States",
    lat: 41.34429932,
    lng: -82.17759705,
  },
  {
    id: "BKL",
    name: "Burke Lakefront Airport",
    city: "Cleveland",
    country: "United States",
    lat: 41.51750183105469,
    lng: -81.68329620361328,
  },
  {
    id: "DKK",
    name: "Chautauqua County-Dunkirk Airport",
    city: "Dunkirk",
    country: "United States",
    lat: 42.49330139,
    lng: -79.27200317,
  },
  {
    id: "LLY",
    name: "South Jersey Regional Airport",
    city: "Mount Holly",
    country: "United States",
    lat: 39.942901611299995,
    lng: -74.845703125,
  },
  {
    id: "LDJ",
    name: "Linden Airport",
    city: "Linden",
    country: "United States",
    lat: 40.617401123,
    lng: -74.2445983887,
  },
  {
    id: "ANQ",
    name: "Tri State Steuben County Airport",
    city: "Angola",
    country: "United States",
    lat: 41.639702,
    lng: -85.083504,
  },
  {
    id: "N",
    name: "Warsaw Municipal Airport",
    city: "Warsaw",
    country: "United States",
    lat: 41.27470016479492,
    lng: -85.84010314941406,
  },
  {
    id: "N",
    name: "Van Wert County Airport",
    city: "Van Wert",
    country: "United States",
    lat: 40.86470031738281,
    lng: -84.6093978881836,
  },
  {
    id: "N",
    name: "Brooks Field",
    city: "Marshall",
    country: "United States",
    lat: 42.25120162963867,
    lng: -84.95549774169922,
  },
  {
    id: "N",
    name: "Genesee County Airport",
    city: "Batavia",
    country: "United States",
    lat: 43.03170013,
    lng: -78.16760254,
  },
  {
    id: "CLW",
    name: "Clearwater Air Park",
    city: "Clearwater",
    country: "United States",
    lat: 27.9766998291,
    lng: -82.7586975098,
  },
  {
    id: "N",
    name: "Orlampa Inc Airport",
    city: "Forties Alpha",
    country: "United Kingdom",
    lat: 28.166999816900002,
    lng: -81.80809783939999,
  },
  {
    id: "CGX",
    name: "Chicago Meigs Airport",
    city: "Chicago",
    country: "United States",
    lat: 41.85879898071289,
    lng: -87.60790252685547,
  },
  {
    id: "N",
    name: "Pickens County Airport",
    city: "Jasper",
    country: "United States",
    lat: 34.453399658203125,
    lng: -84.4573974609375,
  },
  {
    id: "N",
    name: "Saarmund Airport",
    city: "Saarmund",
    country: "Germany",
    lat: 52.30833435058594,
    lng: 13.100556373596191,
  },
  {
    id: "CRE",
    name: "Grand Strand Airport",
    city: "North Myrtle Beach",
    country: "United States",
    lat: 33.8116989136,
    lng: -78.72389984130001,
  },
  {
    id: "N",
    name: "Lansing Municipal Airport",
    city: "Lansing",
    country: "United States",
    lat: 41.5349006652832,
    lng: -87.52950286865234,
  },
  {
    id: "N",
    name: "Ramona Airport",
    city: "Ramona",
    country: "United States",
    lat: 33.0392,
    lng: -116.915001,
  },
  {
    id: "N",
    name: "Pont Sur Yonne Airfield",
    city: "Pont Sur Yonne",
    country: "France",
    lat: 48.289172,
    lng: 3.247912,
  },
  {
    id: "N",
    name: "St Florentin Cheu Airfield",
    city: "St Florentin Cheu",
    country: "France",
    lat: 47.98019,
    lng: 3.775583,
  },
  {
    id: "N",
    name: "Saulieu Liernais Airfield",
    city: "Saulieu",
    country: "France",
    lat: 47.239399,
    lng: 4.26583,
  },
  {
    id: "N",
    name: "Olten Airport",
    city: "Olten",
    country: "Switzerland",
    lat: 47.344398498535156,
    lng: 7.889440059661865,
  },
  {
    id: "BXO",
    name: "Buochs Airport",
    city: "Buochs",
    country: "Switzerland",
    lat: 46.974444,
    lng: 8.396944,
  },
  {
    id: "N",
    name: "Ambri Airport",
    city: "Quinto",
    country: "Switzerland",
    lat: 46.512501,
    lng: 8.68978,
  },
  {
    id: "N",
    name: "Lodrino Air Base",
    city: "Lodrino",
    country: "Switzerland",
    lat: 46.2958984375,
    lng: 8.992130279541016,
  },
  {
    id: "N",
    name: "Roudnice Airport",
    city: "Roudnice nad Lebem",
    country: "Czech Republic",
    lat: 50.41059875,
    lng: 14.2261,
  },
  {
    id: "N",
    name: "Usti Nad Labem Airfield",
    city: "Usti Nad Labem",
    country: "Czech Republic",
    lat: 50.699699,
    lng: 13.9697,
  },
  {
    id: "N",
    name: "Mauterndorf Airport",
    city: "Mauterndorf",
    country: "Austria",
    lat: 47.13249969482422,
    lng: 13.696900367736816,
  },
  {
    id: "N",
    name: "Nötsch Im Gailtal Airport",
    city: "Notsch Im Gailtal",
    country: "Austria",
    lat: 46.58110046386719,
    lng: 13.629199981689453,
  },
  {
    id: "N",
    name: "Sinsheim Airfield",
    city: "Karlsruhe",
    country: "Germany",
    lat: 49.2472,
    lng: 8.8938,
  },
  {
    id: "N",
    name: "Weinheim/Bergstraße Airport",
    city: "Weinheim",
    country: "Germany",
    lat: 49.567501068115234,
    lng: 8.610555648803711,
  },
  {
    id: "N",
    name: "Meaux Esbly Airport",
    city: "Meaux",
    country: "France",
    lat: 48.927799224853516,
    lng: 2.835279941558838,
  },
  {
    id: "N",
    name: "Château-Thierry - Belleau Airfield",
    city: "Chateau-Thierry",
    country: "France",
    lat: 49.0672,
    lng: 3.35694,
  },
  {
    id: "N",
    name: "Branch County Memorial Airport",
    city: "Coldwater",
    country: "United States",
    lat: 41.9333992,
    lng: -85.05259705,
  },
  {
    id: "WBW",
    name: "Wilkes Barre Wyoming Valley Airport",
    city: "Wilkes-Barre",
    country: "United States",
    lat: 41.2971992493,
    lng: -75.8511962891,
  },
  {
    id: "LNN",
    name: "Willoughby Lost Nation Municipal Airport",
    city: "Willoughby",
    country: "United States",
    lat: 41.683998107899995,
    lng: -81.3897018433,
  },
  {
    id: "N",
    name: "Taoyuan Air Base",
    city: "Taoyuan",
    country: "Taiwan",
    lat: 25.05660057067871,
    lng: 121.2442626953125,
  },
  {
    id: "UMD",
    name: "Uummannaq Heliport",
    city: "Uummannaq",
    country: "Greenland",
    lat: 70.6804279261,
    lng: -52.111630439799995,
  },
  {
    id: "RLK",
    name: "Bayannur Tianjitai Airport",
    city: "Bayannur",
    country: "China",
    lat: 40.926,
    lng: 107.7428,
  },
  {
    id: "FFT",
    name: "Capital City Airport",
    city: "Frankfort",
    country: "United States",
    lat: 38.18249893,
    lng: -84.90470123,
  },
  {
    id: "LEW",
    name: "Auburn Lewiston Municipal Airport",
    city: "Lewiston",
    country: "United States",
    lat: 44.048500061,
    lng: -70.2835006714,
  },
  {
    id: "N",
    name: "Inowroclaw Military Air Base",
    city: "Inowroclaw",
    country: "Poland",
    lat: 52.8293991089,
    lng: 18.3306007385,
  },
  {
    id: "N",
    name: "Pruszcz Gdanski Air Base",
    city: "Pruszcz Gdansk",
    country: "Poland",
    lat: 54.248001,
    lng: 18.6716,
  },
  {
    id: "N",
    name: "Bloyer Field",
    city: "Tomah",
    country: "United States",
    lat: 43.97499847,
    lng: -90.48349762,
  },
  {
    id: "MRK",
    name: "Marco Island Executive Airport",
    city: "Marco Island Airport",
    country: "United States",
    lat: 25.995001,
    lng: -81.672501,
  },
  {
    id: "DRE",
    name: "Drummond Island Airport",
    city: "Drummond Island",
    country: "United States",
    lat: 46.0093002319,
    lng: -83.74389648440001,
  },
  {
    id: "GDW",
    name: "Gladwin Zettel Memorial Airport",
    city: "Gladwin",
    country: "United States",
    lat: 43.9706001282,
    lng: -84.47499847410002,
  },
  {
    id: "N",
    name: "South Haven Area Regional Airport",
    city: "South Haven",
    country: "United States",
    lat: 42.351200103759766,
    lng: -86.25569915771484,
  },
  {
    id: "MFI",
    name: "Marshfield Municipal Airport",
    city: "Marshfield",
    country: "United States",
    lat: 44.6369018555,
    lng: -90.18930053710001,
  },
  {
    id: "ISW",
    name: "Alexander Field South Wood County Airport",
    city: "Wisconsin Rapids",
    country: "United States",
    lat: 44.3602981567,
    lng: -89.83899688720001,
  },
  {
    id: "CWI",
    name: "Clinton Municipal Airport",
    city: "Clinton",
    country: "United States",
    lat: 41.8311004639,
    lng: -90.3291015625,
  },
  {
    id: "BVY",
    name: "Beverly Municipal Airport",
    city: "Beverly",
    country: "United States",
    lat: 42.584201812699995,
    lng: -70.91649627689999,
  },
  {
    id: "N",
    name: "Nagaur Airport",
    city: "Nagaur",
    country: "India",
    lat: 27.20829963684082,
    lng: 73.7114028930664,
  },
  {
    id: "OSF",
    name: "Ostafyevo International Airport",
    city: "Moscow",
    country: "Russia",
    lat: 55.511667,
    lng: 37.507222,
  },
  {
    id: "YRQ",
    name: "Trois-Rivières Airport",
    city: "Trois Rivieres",
    country: "Canada",
    lat: 46.35279846191406,
    lng: -72.67939758300781,
  },
  {
    id: "POF",
    name: "Poplar Bluff Municipal Airport",
    city: "Poplar Bluff",
    country: "United States",
    lat: 36.773899078369,
    lng: -90.324897766113,
  },
  {
    id: "N",
    name: "Somerset Airport",
    city: "Somerville",
    country: "United States",
    lat: 40.625999450683594,
    lng: -74.67019653320312,
  },
  {
    id: "N",
    name: "Eastport Municipal Airport",
    city: "Eastport",
    country: "United States",
    lat: 44.910099029541016,
    lng: -67.01270294189453,
  },
  {
    id: "EOK",
    name: "Keokuk Municipal Airport",
    city: "Keokuk",
    country: "United States",
    lat: 40.459899902299995,
    lng: -91.4284973145,
  },
  {
    id: "PSL",
    name: "Perth/Scone Airport",
    city: "Perth",
    country: "United Kingdom",
    lat: 56.43920135498047,
    lng: -3.372220039367676,
  },
  {
    id: "N",
    name: "Caernarfon Airport",
    city: "Caernarfon",
    country: "United Kingdom",
    lat: 53.101819,
    lng: -4.337614,
  },
  {
    id: "N",
    name: "Grefrath-Niershorst Airport",
    city: "Grefrath",
    country: "Germany",
    lat: 51.33388900756836,
    lng: 6.3594441413879395,
  },
  {
    id: "STP",
    name: "St Paul Downtown Holman Field",
    city: "St. Paul",
    country: "United States",
    lat: 44.93450164794922,
    lng: -93.05999755859375,
  },
  {
    id: "SOO",
    name: "Söderhamn Airport",
    city: "Soderhamn",
    country: "Sweden",
    lat: 61.26150131225586,
    lng: 17.09910011291504,
  },
  {
    id: "N",
    name: "Newcastle Aerodrome",
    city: "Newcastle",
    country: "Ireland",
    lat: 53.07109832763672,
    lng: -6.0452799797058105,
  },
  {
    id: "VNA",
    name: "Saravane Airport",
    city: "Saravane",
    country: "Laos",
    lat: 15.709439207700001,
    lng: 106.410698891,
  },
  {
    id: "N",
    name: "Segeletz Airport",
    city: "Segeletz",
    country: "Germany",
    lat: 52.82666778564453,
    lng: 12.541943550109863,
  },
  {
    id: "N",
    name: "Fuentemilanos Airport",
    city: "Segovia",
    country: "Spain",
    lat: 40.888610839799995,
    lng: -4.23750019073,
  },
  {
    id: "N",
    name: "Akeno Airport",
    city: "Akeno",
    country: "Japan",
    lat: 34.53329849243164,
    lng: 136.6719970703125,
  },
  {
    id: "N",
    name: "Ust-Kamchatsk Airport",
    city: "Ust Kamchatsk",
    country: "Russia",
    lat: 56.23860168457031,
    lng: 162.68800354003906,
  },
  {
    id: "N",
    name: "Oconomowoc Airport",
    city: "Oconomowoc",
    country: "United States",
    lat: 43.13890075683594,
    lng: -88.47229766845703,
  },
  {
    id: "N",
    name: "Kozyrevsk Airport",
    city: "Kozyrevsk",
    country: "Russia",
    lat: 56.09000015258789,
    lng: 159.8766632080078,
  },
  {
    id: "DKS",
    name: "Dikson Airport",
    city: "Dikson",
    country: "Russia",
    lat: 73.51780700683594,
    lng: 80.37966918945312,
  },
  {
    id: "N",
    name: "Beverley Airport",
    city: "Mine Site",
    country: "Australia",
    lat: -30.18670082092285,
    lng: 139.55799865722656,
  },
  {
    id: "BYT",
    name: "Bantry Aerodrome",
    city: "Bantry",
    country: "Ireland",
    lat: 51.66859817504883,
    lng: -9.484169960021973,
  },
  {
    id: "N",
    name: "Aliwal North Airport",
    city: "Aliwal North",
    country: "South Africa",
    lat: -30.68000030517578,
    lng: 26.729999542236328,
  },
  {
    id: "N",
    name: "Alkantpan Copper Airport",
    city: "Alkantpan",
    country: "South Africa",
    lat: -29.906400680541992,
    lng: 22.316699981689453,
  },
  {
    id: "ADY",
    name: "Alldays Airport",
    city: "Alldays",
    country: "South Africa",
    lat: -22.6790008545,
    lng: 29.0555000305,
  },
  {
    id: "N",
    name: "Bredasdorp Airport",
    city: "Barberton",
    country: "South Africa",
    lat: -34.665,
    lng: 20.0628,
  },
  {
    id: "HAO",
    name: "Butler Co Regional Airport - Hogan Field",
    city: "Hamilton",
    country: "United States",
    lat: 39.363800048799995,
    lng: -84.5220031738,
  },
  {
    id: "N",
    name: "Bungoma Airport",
    city: "Bungoma",
    country: "Kenya",
    lat: 0.5762079954147339,
    lng: 34.55345153808594,
  },
  {
    id: "N",
    name: "Bura East Airport",
    city: "Bura",
    country: "Kenya",
    lat: -1.100000023841858,
    lng: 39.95000076293945,
  },
  {
    id: "N",
    name: "Busia Airport",
    city: "Busia",
    country: "Kenya",
    lat: 0.4570850133895874,
    lng: 34.130279541015625,
  },
  {
    id: "N",
    name: "Embu Airport",
    city: "Embu",
    country: "Kenya",
    lat: -0.57327,
    lng: 37.49726,
  },
  {
    id: "N",
    name: "Garba Tula Airport",
    city: "Garba Tula",
    country: "Kenya",
    lat: 0.533333,
    lng: 38.516667,
  },
  {
    id: "GAS",
    name: "Garissa Airport",
    city: "Garissa",
    country: "Kenya",
    lat: -0.4635080099105835,
    lng: 39.64830017089844,
  },
  {
    id: "HOA",
    name: "Hola Airport",
    city: "Hola",
    country: "Kenya",
    lat: -1.5219999551773071,
    lng: 40.00400161743164,
  },
  {
    id: "N",
    name: "Homa Bay Airport",
    city: "Homa Bay",
    country: "Kenya",
    lat: -0.6000000238418579,
    lng: 34.46699905395508,
  },
  {
    id: "N",
    name: "Isiolo Airport",
    city: "Isiolo",
    country: "Kenya",
    lat: 0.33817094564437866,
    lng: 37.59169387817383,
  },
  {
    id: "KEY",
    name: "Kericho Airport",
    city: "Kericho",
    country: "Kenya",
    lat: -0.3899,
    lng: 35.242093,
  },
  {
    id: "ILU",
    name: "Kilaguni Airport",
    city: "Kilaguni",
    country: "Kenya",
    lat: -2.9106099605560303,
    lng: 38.06520080566406,
  },
  {
    id: "ATJ",
    name: "Antsirabe Airport",
    city: "Antsirabe",
    country: "Madagascar",
    lat: -19.8392214824,
    lng: 47.063713073699994,
  },
  {
    id: "OVA",
    name: "Bekily Airport",
    city: "Bekily",
    country: "Madagascar",
    lat: -24.235694754699995,
    lng: 45.3045272827,
  },
  {
    id: "UTS",
    name: "Ust-Tsylma Airport",
    city: "Ust-Tsylma",
    country: "Russia",
    lat: 65.43729400630001,
    lng: 52.20033645629999,
  },
  {
    id: "RGK",
    name: "Gorno-Altaysk Airport",
    city: "Gorno-Altaysk",
    country: "Russia",
    lat: 51.9667015076,
    lng: 85.8332977295,
  },
  {
    id: "FLD",
    name: "Fond du Lac County Airport",
    city: "Fond du Lac",
    country: "United States",
    lat: 43.7711982727,
    lng: -88.48840332030001,
  },
  {
    id: "N",
    name: "Waupaca Municipal Airport",
    city: "Waupaca",
    country: "United States",
    lat: 44.33330154,
    lng: -89.01979828,
  },
  {
    id: "STE",
    name: "Stevens Point Municipal Airport",
    city: "Stevens Point",
    country: "United States",
    lat: 44.5452003479,
    lng: -89.530296325684,
  },
  {
    id: "N",
    name: "Mys Shmidta Airport",
    city: "Mys Shmidta",
    country: "Russia",
    lat: 68.86830139160156,
    lng: -179.3730010986328,
  },
  {
    id: "MQJ",
    name: "Moma Airport",
    city: "Honuu",
    country: "Russia",
    lat: 66.450861,
    lng: 143.261551,
  },
  {
    id: "N",
    name: "Luce County Airport",
    city: "Newberry",
    country: "United States",
    lat: 46.31119918823242,
    lng: -85.4572982788086,
  },
  {
    id: "PEF",
    name: "Peenemünde Airport",
    city: "Peenemunde",
    country: "Germany",
    lat: 54.1577796936,
    lng: 13.774443626399998,
  },
  {
    id: "N",
    name: "Góraszka Airport",
    city: "Goraszka",
    country: "Poland",
    lat: 52.18444061279297,
    lng: 21.281110763549805,
  },
  {
    id: "CJN",
    name: "Nusawiru Airport",
    city: "Nusawiru",
    country: "Indonesia",
    lat: -7.719895,
    lng: 108.488995,
  },
  {
    id: "GQQ",
    name: "Galion Municipal Airport",
    city: "Galion",
    country: "United States",
    lat: 40.7533988953,
    lng: -82.7238006592,
  },
  {
    id: "TPN",
    name: "Tiputini Airport",
    city: "Tiputini",
    country: "Ecuador",
    lat: -0.7761110067367554,
    lng: -75.52639770507812,
  },
  {
    id: "PTZ",
    name: "Rio Amazonas Airport",
    city: "Pastaza",
    country: "Ecuador",
    lat: -1.5052399635299998,
    lng: -78.0626983643,
  },
  {
    id: "CKV",
    name: "Clarksville–Montgomery County Regional Airport",
    city: "Clarksville",
    country: "United States",
    lat: 36.6218986511,
    lng: -87.4150009155,
  },
  {
    id: "LPC",
    name: "Lompoc Airport",
    city: "Lompoc",
    country: "United States",
    lat: 34.665599823,
    lng: -120.468002319,
  },
  {
    id: "CTH",
    name: "Chester County G O Carlson Airport",
    city: "Coatesville",
    country: "United States",
    lat: 39.97900009,
    lng: -75.8655014,
  },
  {
    id: "BST",
    name: "Bost Airport",
    city: "Lashkar Gah",
    country: "Afghanistan",
    lat: 31.55970001220703,
    lng: 64.36499786376953,
  },
  {
    id: "LLK",
    name: "Lankaran International Airport",
    city: "Lankaran",
    country: "Azerbaijan",
    lat: 38.746398925799994,
    lng: 48.8180007935,
  },
  {
    id: "GBB",
    name: "Gabala International Airport",
    city: "Qabala",
    country: "Azerbaijan",
    lat: 40.826667,
    lng: 47.7125,
  },
  {
    id: "ZTU",
    name: "Zaqatala International Airport",
    city: "Zaqatala",
    country: "Azerbaijan",
    lat: 41.562222,
    lng: 46.667221,
  },
  {
    id: "LKP",
    name: "Lake Placid Airport",
    city: "Lake Placid",
    country: "United States",
    lat: 44.2644996643,
    lng: -73.96189880370001,
  },
  {
    id: "KDY",
    name: "Typliy Klyuch Airport",
    city: "Khandyga",
    country: "Russia",
    lat: 62.7890014648,
    lng: 136.854995728,
  },
  {
    id: "GYG",
    name: "Magan Airport",
    city: "Yakutsk",
    country: "Russia",
    lat: 62.103484,
    lng: 129.545288,
  },
  {
    id: "JIQ",
    name: "Qianjiang Wulingshan Airport",
    city: "Qianjiang",
    country: "China",
    lat: 29.5133333333,
    lng: 108.831111111,
  },
  {
    id: "N",
    name: "Cooma Hospital Helipad",
    city: "Yuzhno-Kurilsk",
    country: "Russia",
    lat: -36.242155,
    lng: 149.130147,
  },
  {
    id: "AOH",
    name: "Lima Allen County Airport",
    city: "Lima",
    country: "United States",
    lat: 40.706902,
    lng: -84.026703,
  },
  {
    id: "DSO",
    name: "Sondok Airport",
    city: "Hamhung",
    country: "North Korea",
    lat: 39.745201,
    lng: 127.473999,
  },
  {
    id: "SSI",
    name: "Malcolm McKinnon Airport",
    city: "Brunswick",
    country: "United States",
    lat: 31.15180016,
    lng: -81.39129639,
  },
  {
    id: "BFP",
    name: "Beaver County Airport",
    city: "Beaver Falls",
    country: "United States",
    lat: 40.7724990845,
    lng: -80.39140319820001,
  },
  {
    id: "GGE",
    name: "Georgetown County Airport",
    city: "Georgetown",
    country: "United States",
    lat: 33.3116989136,
    lng: -79.3196029663,
  },
  {
    id: "HDI",
    name: "Hardwick Field",
    city: "Cleveland",
    country: "United States",
    lat: 35.22010040283203,
    lng: -84.8323974609375,
  },
  {
    id: "RNT",
    name: "Renton Municipal Airport",
    city: "Renton",
    country: "United States",
    lat: 47.4930992126,
    lng: -122.216003418,
  },
  {
    id: "POC",
    name: "Brackett Field",
    city: "La Verne",
    country: "United States",
    lat: 34.091598510742,
    lng: -117.78199768066,
  },
  {
    id: "CTY",
    name: "Cross City Airport",
    city: "Cross City",
    country: "United States",
    lat: 29.6354999542,
    lng: -83.10479736330001,
  },
  {
    id: "CEU",
    name: "Oconee County Regional Airport",
    city: "Clemson",
    country: "United States",
    lat: 34.6719017,
    lng: -82.8864975,
  },
  {
    id: "BEC",
    name: "Beech Factory Airport",
    city: "Wichita",
    country: "United States",
    lat: 37.694499969499994,
    lng: -97.21499633790002,
  },
  {
    id: "N",
    name: "Tabing Airport",
    city: "Padang",
    country: "Indonesia",
    lat: -0.874989,
    lng: 100.351997,
  },
  {
    id: "N",
    name: "Tom B. David Field",
    city: "Calhoun",
    country: "United States",
    lat: 34.45539856,
    lng: -84.93920135,
  },
  {
    id: "N",
    name: "Habersham County Airport",
    city: "Cornelia",
    country: "United States",
    lat: 34.49990082,
    lng: -83.55670166,
  },
  {
    id: "N",
    name: "Georgetown Municipal Airport",
    city: "Georgetown",
    country: "United States",
    lat: 30.678800582885742,
    lng: -97.67939758300781,
  },
  {
    id: "N",
    name: "Old Rhinebeck Airport",
    city: "Rhinebeck",
    country: "United States",
    lat: 41.9715004,
    lng: -73.86289978,
  },
  {
    id: "QFO",
    name: "Duxford Aerodrome",
    city: "Duxford",
    country: "United Kingdom",
    lat: 52.090801,
    lng: 0.131944,
  },
  {
    id: "SNY",
    name: "Sidney Municipal-Lloyd W Carr Field",
    city: "Sidney",
    country: "United States",
    lat: 41.10129929,
    lng: -102.9850006,
  },
  {
    id: "N",
    name: "Newnan Hospital Heliport",
    city: "Bengassi",
    country: "Mali",
    lat: 33.38090133666992,
    lng: -84.8010025024414,
  },
  {
    id: "GKL",
    name: "Great Keppel Is Airport",
    city: "Great Keppel Island",
    country: "Australia",
    lat: -23.1833000183,
    lng: 150.942001343,
  },
  {
    id: "RPB",
    name: "Roper Bar Airport",
    city: "Roper Bar",
    country: "Australia",
    lat: -14.734814,
    lng: 134.525485,
  },
  {
    id: "N",
    name: "Mount Garnet Airport",
    city: "Mount Garnet",
    country: "Australia",
    lat: -17.700000762939453,
    lng: 145.14999389648438,
  },
  {
    id: "IFL",
    name: "Innisfail Airport",
    city: "Innisfail",
    country: "Australia",
    lat: -17.55940055847168,
    lng: 146.01199340820312,
  },
  {
    id: "JRF",
    name: "Kalaeloa Airport",
    city: "Kapolei",
    country: "United States",
    lat: 21.3074,
    lng: -158.070009,
  },
  {
    id: "BIN",
    name: "Bamiyan Airport",
    city: "Bamyan",
    country: "Afghanistan",
    lat: 34.81700134277344,
    lng: 67.81700134277344,
  },
  {
    id: "NBS",
    name: "Changbaishan Airport",
    city: "Baishan",
    country: "China",
    lat: 42.066944,
    lng: 127.602222,
  },
  {
    id: "RGO",
    name: "Orang Airport",
    city: "Chongjin",
    country: "North Korea",
    lat: 41.428538,
    lng: 129.647555,
  },
  {
    id: "MOO",
    name: "Moomba Airport",
    city: "Moomba",
    country: "Australia",
    lat: -28.09939956665039,
    lng: 140.19700622558594,
  },
  {
    id: "LUZ",
    name: "Lublin Airport",
    city: "Lublin",
    country: "Poland",
    lat: 51.240278,
    lng: 22.713611,
  },
  {
    id: "ECA",
    name: "Iosco County Airport",
    city: "East Tawas",
    country: "United States",
    lat: 44.312801,
    lng: -83.422302,
  },
  {
    id: "N",
    name: "Madison County Executive Airport-Tom Sharp Jr Field",
    city: "Huntsville",
    country: "United States",
    lat: 34.8614006,
    lng: -86.55750275,
  },
  {
    id: "N",
    name: "Leesburg Executive Airport",
    city: "Leesburg",
    country: "United States",
    lat: 39.077999,
    lng: -77.557503,
  },
  {
    id: "N",
    name: "Anoka County-Blaine (Janes Field) Airport",
    city: "Anoka",
    country: "United States",
    lat: 45.145,
    lng: -93.211401,
  },
  {
    id: "N",
    name: "Robinson Crusoe Airport",
    city: "San Juan Bautista",
    country: "Chile",
    lat: -33.6650009155,
    lng: -78.9297027588,
  },
  {
    id: "VAM",
    name: "Villa Airport",
    city: "Maamigili",
    country: "Maldives",
    lat: 3.47055555556,
    lng: 72.8358333333,
  },
  {
    id: "LLF",
    name: "Lingling Airport",
    city: "Yongzhou",
    country: "China",
    lat: 26.338661,
    lng: 111.610043,
  },
  {
    id: "LSZ",
    name: "Lošinj Island Airport",
    city: "Mali Losinj",
    country: "Croatia",
    lat: 44.5657997131,
    lng: 14.3930997849,
  },
  {
    id: "ONS",
    name: "Onslow Airport",
    city: "Onslow",
    country: "Australia",
    lat: -21.668300628662,
    lng: 115.1129989624,
  },
  {
    id: "TDR",
    name: "Theodore Airport",
    city: "Theodore",
    country: "Australia",
    lat: -24.99329948425293,
    lng: 150.09300231933594,
  },
  {
    id: "N",
    name: "Williamson Sodus Airport",
    city: "Williamson",
    country: "United States",
    lat: 43.234699,
    lng: -77.121,
  },
  {
    id: "N",
    name: "Fairoaks Airport",
    city: "Fairoaks",
    country: "United Kingdom",
    lat: 51.3480987549,
    lng: -0.558888971806,
  },
  {
    id: "WBU",
    name: "Boulder Municipal Airport",
    city: "Boulder",
    country: "United States",
    lat: 40.0393981934,
    lng: -105.225997925,
  },
  {
    id: "N",
    name: "Neustadt-Glewe Airport",
    city: "Neustadt-Glewe",
    country: "Germany",
    lat: 53.35972213745117,
    lng: 11.615278244018555,
  },
  {
    id: "N",
    name: "Goetsenhoven Air Base",
    city: "GOETSENHOVEN",
    country: "Belgium",
    lat: 50.781700134277344,
    lng: 4.957779884338379,
  },
  {
    id: "N",
    name: "Tutow Airport",
    city: "Wildenrath",
    country: "Germany",
    lat: 53.92194366455078,
    lng: 13.218889236450195,
  },
  {
    id: "N",
    name: "Bremgarten Airport",
    city: "Bremgarten",
    country: "Germany",
    lat: 47.9027786255,
    lng: 7.6177778244,
  },
  {
    id: "BBJ",
    name: "Bitburg Airport",
    city: "Birburg",
    country: "Germany",
    lat: 49.945278,
    lng: 6.565,
  },
  {
    id: "PAO",
    name: "Palo Alto Airport of Santa Clara County",
    city: "Palo Alto",
    country: "United States",
    lat: 37.461101532,
    lng: -122.114997864,
  },
  {
    id: "USR",
    name: "Ust-Nera Airport",
    city: "Ust-Nera",
    country: "Russia",
    lat: 64.550003051758,
    lng: 143.11500549316,
  },
  {
    id: "N",
    name: "Letiště Vysoké Mýto",
    city: "Vysoke Myto",
    country: "Czech Republic",
    lat: 49.926899,
    lng: 16.185801,
  },
  {
    id: "N",
    name: "Spa (la Sauvenière) Airfield",
    city: "Spa",
    country: "Belgium",
    lat: 50.482498,
    lng: 5.9103,
  },
  {
    id: "MSC",
    name: "Falcon Field",
    city: "Mesa",
    country: "United States",
    lat: 33.4608001709,
    lng: -111.727996826,
  },
  {
    id: "N",
    name: "Coolidge Municipal Airport",
    city: "Cooldige",
    country: "United States",
    lat: 32.9359016418457,
    lng: -111.427001953125,
  },
  {
    id: "N",
    name: "Cottonwood Airport",
    city: "Cottonwood",
    country: "United States",
    lat: 34.7299995422,
    lng: -112.035003662,
  },
  {
    id: "N",
    name: "Namur-Suarlée Airfield",
    city: "Namur",
    country: "Belgium",
    lat: 50.487999,
    lng: 4.76892,
  },
  {
    id: "N",
    name: "Kiewit Airfield Hasselt",
    city: "Hasselt",
    country: "Belgium",
    lat: 50.970001,
    lng: 5.37507,
  },
  {
    id: "N",
    name: "Ak-Chin Regional Airport",
    city: "Phoenix",
    country: "United States",
    lat: 32.990806,
    lng: -111.918528,
  },
  {
    id: "N",
    name: "Wickenburg Municipal Airport",
    city: "Wickenburg",
    country: "United States",
    lat: 33.96889877,
    lng: -112.7990036,
  },
  {
    id: "YTY",
    name: "Yangzhou Taizhou Airport",
    city: "Yangzhou",
    country: "China",
    lat: 32.5634,
    lng: 119.7198,
  },
  {
    id: "PTK",
    name: "Oakland County International Airport",
    city: "Pontiac",
    country: "United States",
    lat: 42.665500640869,
    lng: -83.420097351074,
  },
  {
    id: "KSI",
    name: "Kissidougou Airport",
    city: "Kissidougou",
    country: "Guinea",
    lat: 9.1605596542358,
    lng: -10.124400138855,
  },
  {
    id: "EEN",
    name: "Dillant Hopkins Airport",
    city: "Keene",
    country: "United States",
    lat: 42.898399353027344,
    lng: -72.27079772949219,
  },
  {
    id: "THQ",
    name: "Tianshui Maijishan Airport",
    city: "Tianshui",
    country: "China",
    lat: 34.5593986511,
    lng: 105.86000061,
  },
  {
    id: "VRO",
    name: "Kawama Airport",
    city: "Kawama",
    country: "Cuba",
    lat: 23.1240005493,
    lng: -81.3015975952,
  },
  {
    id: "GKK",
    name: "Kooddoo Airport",
    city: "Kooddoo",
    country: "Maldives",
    lat: 0.7324,
    lng: 73.4336,
  },
  {
    id: "N",
    name: "Glasgow Industrial Airport",
    city: "Glasgow",
    country: "United States",
    lat: 48.42110061645508,
    lng: -106.52799987792969,
  },
  {
    id: "RCS",
    name: "Rochester Airport",
    city: "Rochester",
    country: "United Kingdom",
    lat: 51.351898193359375,
    lng: 0.5033329725265503,
  },
  {
    id: "RHD",
    name: "Termas de Río Hondo international Airport",
    city: "Rio Hondo",
    country: "Argentina",
    lat: -27.4966,
    lng: -64.93595,
  },
  {
    id: "KMP",
    name: "Keetmanshoop Airport",
    city: "Keetmanshoop",
    country: "Namibia",
    lat: -26.5398006439209,
    lng: 18.111400604248047,
  },
  {
    id: "KGT",
    name: "Kangding Airport",
    city: "Kangding",
    country: "China",
    lat: 30.1575,
    lng: 101.734722,
  },
  {
    id: "VUS",
    name: "Velikiy Ustyug Airport",
    city: "Veliky Ustyug",
    country: "Russia",
    lat: 60.788299560546875,
    lng: 46.2599983215332,
  },
  {
    id: "IOW",
    name: "Iowa City Municipal Airport",
    city: "Iowa City",
    country: "United States",
    lat: 41.639198303200004,
    lng: -91.5465011597,
  },
  {
    id: "TLQ",
    name: "Turpan Jiaohe Airport",
    city: "Turpan",
    country: "China",
    lat: 43.0308,
    lng: 89.0987,
  },
  {
    id: "N",
    name: "Lorenzo Airport",
    city: "Morro de Sao Paulo",
    country: "Brazil",
    lat: -13.389444351196289,
    lng: -38.90999984741211,
  },
  {
    id: "N",
    name: "Windom Municipal Airport",
    city: "Windom",
    country: "United States",
    lat: 43.91339874267578,
    lng: -95.1093978881836,
  },
  {
    id: "N",
    name: "Longview Ranch Airport",
    city: "Longview",
    country: "United States",
    lat: 44.66170120239258,
    lng: -119.6520004272461,
  },
  {
    id: "N",
    name: "Rothera Research Station",
    city: "Rothera Research Station",
    country: "United Kingdom",
    lat: -67.5675,
    lng: -68.1274027778,
  },
  {
    id: "N",
    name: "Sortavala Airport",
    city: "Sortavala",
    country: "Russia",
    lat: 61.73609924316406,
    lng: 30.673599243164062,
  },
  {
    id: "ANP",
    name: "Lee Airport",
    city: "Annapolis",
    country: "United States",
    lat: 38.942902,
    lng: -76.568398,
  },
  {
    id: "FXO",
    name: "Cuamba Airport",
    city: "Cuamba",
    country: "Mozambique",
    lat: -14.815,
    lng: 36.529999,
  },
  {
    id: "ODO",
    name: "Bodaybo Airport",
    city: "Bodaibo",
    country: "Russia",
    lat: 57.866100311299995,
    lng: 114.242996216,
  },
  {
    id: "ZTR",
    name: "Zhytomyr Airport",
    city: "Zhytomyr",
    country: "Ukraine",
    lat: 50.270556,
    lng: 28.738611,
  },
  {
    id: "N",
    name: "Paluknys Airport",
    city: "Paluknys",
    country: "Lithuania",
    lat: 54.48484802246094,
    lng: 24.98737335205078,
  },
  {
    id: "HRI",
    name: "Mattala Rajapaksa International Airport",
    city: "Mattala",
    country: "Sri Lanka",
    lat: 6.284467,
    lng: 81.124128,
  },
  {
    id: "PEQ",
    name: "Pecos Municipal Airport",
    city: "Pecos",
    country: "United States",
    lat: 31.382400512695,
    lng: -103.51100158691,
  },
  {
    id: "HBG",
    name: "Hattiesburg Bobby L Chain Municipal Airport",
    city: "Hattiesburg",
    country: "United States",
    lat: 31.26479912,
    lng: -89.25279999,
  },
  {
    id: "QCJ",
    name: "Botucatu - Tancredo de Almeida Neves Airport",
    city: "Botucatu",
    country: "Brazil",
    lat: -22.939501,
    lng: -48.467999,
  },
  {
    id: "N",
    name: "Base Aérea Airport",
    city: "Anapolis",
    country: "Brazil",
    lat: -16.2292,
    lng: -48.964298,
  },
  {
    id: "QSC",
    name: "Mário Pereira Lopes–São Carlos Airport",
    city: "Sao Carlos",
    country: "Brazil",
    lat: -21.875401,
    lng: -47.903703,
  },
  {
    id: "YKN",
    name: "Chan Gurney Municipal Airport",
    city: "Yankton",
    country: "United States",
    lat: 42.916698455811,
    lng: -97.385902404785,
  },
  {
    id: "XSB",
    name: "Sir Bani Yas Airport",
    city: "Sir Bani Yas Island",
    country: "United Arab Emirates",
    lat: 24.283611,
    lng: 52.580278,
  },
  {
    id: "ZBM",
    name: "Bromont (Roland Desourdy) Airport",
    city: "Bromont",
    country: "Canada",
    lat: 45.2907981873,
    lng: -72.74140167239999,
  },
  {
    id: "N",
    name: "Beccles Airport",
    city: "Beccles",
    country: "United Kingdom",
    lat: 52.435298919699996,
    lng: 1.6183300018300002,
  },
  {
    id: "KTI",
    name: "Kratie Airport",
    city: "Kratie",
    country: "Cambodia",
    lat: 12.48799991607666,
    lng: 106.05500030517578,
  },
  {
    id: "N",
    name: "Caldera Airport",
    city: "Caldera",
    country: "Chile",
    lat: -27.078100204467773,
    lng: -70.79530334472656,
  },
  {
    id: "N",
    name: "San Pedro de Atacama Airport",
    city: "San Pedro de Atacama",
    country: "Chile",
    lat: -22.92169952392578,
    lng: -68.15840148925781,
  },
  {
    id: "N",
    name: "Copacabana Airport",
    city: "Copacabana",
    country: "Bolivia",
    lat: -16.191099166870117,
    lng: -69.09559631347656,
  },
  {
    id: "GYU",
    name: "Guyuan Liupanshan Airport",
    city: "Guyuan",
    country: "China",
    lat: 36.0788888889,
    lng: 106.216944444,
  },
  {
    id: "N",
    name: "RAF Brawdy",
    city: "Brawdy",
    country: "United Kingdom",
    lat: 51.88375,
    lng: -5.119972,
  },
  {
    id: "CNI",
    name: "Changhai Airport",
    city: "Changhai",
    country: "China",
    lat: 39.2666666667,
    lng: 122.666944444,
  },
  {
    id: "KRH",
    name: "Redhill Aerodrome",
    city: "Redhill",
    country: "United Kingdom",
    lat: 51.2136001587,
    lng: -0.138611003757,
  },
  {
    id: "JGD",
    name: "Jiagedaqi Airport",
    city: "Jiagedaqi District",
    country: "China",
    lat: 50.371389,
    lng: 124.1175,
  },
  {
    id: "CCL",
    name: "Chinchilla Airport",
    city: "Chinchilla",
    country: "Australia",
    lat: -26.774999618530273,
    lng: 150.61700439453125,
  },
  {
    id: "HWD",
    name: "Hayward Executive Airport",
    city: "Hayward",
    country: "United States",
    lat: 37.659198761,
    lng: -122.122001648,
  },
  {
    id: "MZP",
    name: "Motueka Airport",
    city: "Motueka",
    country: "New Zealand",
    lat: -41.12329864501953,
    lng: 172.98899841308594,
  },
  {
    id: "JHQ",
    name: "Shute Harbour Airport",
    city: "Shute Harbour",
    country: "Australia",
    lat: -20.277221,
    lng: 148.755556,
  },
  {
    id: "N",
    name: "Enstone Aerodrome",
    city: "Enstone",
    country: "United Kingdom",
    lat: 51.928166666699994,
    lng: -1.4285,
  },
  {
    id: "ARB",
    name: "Ann Arbor Municipal Airport",
    city: "Ann Arbor",
    country: "United States",
    lat: 42.2229995728,
    lng: -83.74559783939999,
  },
  {
    id: "SHT",
    name: "Shepparton Airport",
    city: "Shepparton",
    country: "Australia",
    lat: -36.42890167236328,
    lng: 145.39300537109375,
  },
  {
    id: "TEM",
    name: "Temora Airport",
    city: "Temora",
    country: "Australia",
    lat: -34.4213981628418,
    lng: 147.51199340820312,
  },
  {
    id: "GAH",
    name: "Gayndah Airport",
    city: "Gayndah",
    country: "Australia",
    lat: -25.61440086364746,
    lng: 151.61900329589844,
  },
  {
    id: "WIO",
    name: "Wilcannia Airport",
    city: "Wilcannia",
    country: "Australia",
    lat: -31.526399612426758,
    lng: 143.375,
  },
  {
    id: "N",
    name: "Ivanhoe Airport",
    city: "Ivanhoe",
    country: "Australia",
    lat: -32.88330078125,
    lng: 144.30999755859375,
  },
  {
    id: "N",
    name: "Menindee Airport",
    city: "Menindee",
    country: "Australia",
    lat: -32.36669921875,
    lng: 142.40499877929688,
  },
  {
    id: "N",
    name: "Pooncarie Airport",
    city: "Pooncarie",
    country: "Australia",
    lat: -33.36669921875,
    lng: 142.58799743652344,
  },
  {
    id: "N",
    name: "Tilpa Airport",
    city: "Tilpa",
    country: "Australia",
    lat: -30.933300018310547,
    lng: 144.41700744628906,
  },
  {
    id: "N",
    name: "Reichenbach Air Base",
    city: "Reichenbach im Kandertal",
    country: "Switzerland",
    lat: 46.61360168457031,
    lng: 7.6777801513671875,
  },
  {
    id: "BFJ",
    name: "Bijie Feixiong Airport",
    city: "Bijie",
    country: "China",
    lat: 27.267066,
    lng: 105.472097,
  },
  {
    id: "ULK",
    name: "Lensk Airport",
    city: "Lensk",
    country: "Russia",
    lat: 60.7206001282,
    lng: 114.825996399,
  },
  {
    id: "KVR",
    name: "Kavalerovo Airport",
    city: "Kavalerovo",
    country: "Russia",
    lat: 44.2726,
    lng: 135.029,
  },
  {
    id: "IGD",
    name: "Iğdır Airport",
    city: "Igdir",
    country: "Turkey",
    lat: 39.9766273499,
    lng: 43.8766479492,
  },
  {
    id: "GNY",
    name: "Şanlıurfa GAP Airport",
    city: "Sanliurfa",
    country: "Turkey",
    lat: 37.445663,
    lng: 38.895592,
  },
  {
    id: "KZR",
    name: "Zafer Airport",
    city: "Kutahya",
    country: "Turkey",
    lat: 39.113079,
    lng: 30.128111,
  },
  {
    id: "VLU",
    name: "Velikiye Luki Airport",
    city: "Velikiye Luki",
    country: "Russia",
    lat: 56.381099700927734,
    lng: 30.60810089111328,
  },
  {
    id: "N",
    name: "Yelahanka Air Force Station",
    city: "Bangalore",
    country: "India",
    lat: 13.135499954223633,
    lng: 77.60600280761719,
  },
  {
    id: "N",
    name: "Yeltsovka Airport",
    city: "Novosibirsk",
    country: "Russia",
    lat: 55.09239959716797,
    lng: 83.00450134277344,
  },
  {
    id: "N",
    name: "Kodinsk Airport",
    city: "Kodinsk",
    country: "Russia",
    lat: 58.479400634765625,
    lng: 99.09390258789062,
  },
  {
    id: "BEO",
    name: "Lake Macquarie Airport",
    city: "Lake Macquarie",
    country: "Australia",
    lat: -33.0667,
    lng: 151.647995,
  },
  {
    id: "N",
    name: "Henry County Airport",
    city: "Hampton",
    country: "United States",
    lat: 33.389099,
    lng: -84.332397,
  },
  {
    id: "BMP",
    name: "Brampton Island Airport",
    city: "Brampton Island",
    country: "Australia",
    lat: -20.803300857543945,
    lng: 149.27000427246094,
  },
  {
    id: "NGZ",
    name: "Alameda Naval Air Station",
    city: "Alameda",
    country: "United States",
    lat: 37.78889846801758,
    lng: -122.31999969482422,
  },
  {
    id: "N",
    name: "Endelave Flyveplads",
    city: "Endelage",
    country: "Denmark",
    lat: 55.7565,
    lng: 10.2485,
  },
  {
    id: "N",
    name: "St. Johann In Tirol Airport",
    city: "St. Johann in Tirol",
    country: "Austria",
    lat: 47.5201,
    lng: 12.4497,
  },
  {
    id: "N",
    name: "Thalmässing-Waizenhofen Airport",
    city: "Thalmaessing",
    country: "Germany",
    lat: 49.06416702270508,
    lng: 11.209166526794434,
  },
  {
    id: "YCN",
    name: "Cochrane Airport",
    city: "Cochrane",
    country: "Canada",
    lat: 49.10559844970703,
    lng: -81.01360321044922,
  },
  {
    id: "BJP",
    name: "Estadual Arthur Siqueira Airport",
    city: "Braganca Paulista",
    country: "Brazil",
    lat: -22.979162,
    lng: -46.537508,
  },
  {
    id: "BQB",
    name: "Busselton Regional Airport",
    city: "Brusselton",
    country: "Australia",
    lat: -33.6884231567,
    lng: 115.401596069,
  },
  {
    id: "SEK",
    name: "Srednekolymsk Airport",
    city: "Srednekolymsk",
    country: "Russia",
    lat: 67.4805,
    lng: 153.7364,
  },
  {
    id: "N",
    name: "Comarapa Airport",
    city: "Salt Lake City",
    country: "United States",
    lat: -17.91360092163086,
    lng: -64.5177993774414,
  },
  {
    id: "IVR",
    name: "Inverell Airport",
    city: "Inverell",
    country: "Australia",
    lat: -29.888299942,
    lng: 151.143997192,
  },
  {
    id: "GLI",
    name: "Glen Innes Airport",
    city: "Glen Innes",
    country: "Australia",
    lat: -29.674999237060547,
    lng: 151.68899536132812,
  },
  {
    id: "N",
    name: "Ansbach-Petersdorf Airport",
    city: "Ansbach",
    country: "Germany",
    lat: 49.361111,
    lng: 10.669444,
  },
  {
    id: "IMM",
    name: "Immokalee Regional Airport",
    city: "Immokalee ",
    country: "United States",
    lat: 26.43320084,
    lng: -81.40100098,
  },
  {
    id: "TQQ",
    name: "Maranggo Airport",
    city: "Sulawesi Tenggara",
    country: "Indonesia",
    lat: -5.7645702362061,
    lng: 123.91699981689,
  },
  {
    id: "N",
    name: "Rancho San Simeon Airport",
    city: "Cambria",
    country: "United States",
    lat: 35.60770034790039,
    lng: -121.11000061035156,
  },
  {
    id: "YIC",
    name: "Yichun Mingyueshan Airport",
    city: "Yichun",
    country: "China",
    lat: 27.8025,
    lng: 114.3062,
  },
  {
    id: "PTB",
    name: "Dinwiddie County Airport",
    city: "Petersburg",
    country: "United States",
    lat: 37.183799743652,
    lng: -77.507400512695,
  },
  {
    id: "N",
    name: "Kasongo Airport",
    city: "Kasongo",
    country: "Congo (Kinshasa)",
    lat: -4.5329999923706055,
    lng: 26.617000579833984,
  },
  {
    id: "N",
    name: "McMurdo Station Pegasus Field",
    city: "McMurdo Station",
    country: "Antarctica",
    lat: -77.9634017944336,
    lng: 166.52499389648438,
  },
  {
    id: "N",
    name: "Klatovy Airport",
    city: "Klatovy",
    country: "Czech Republic",
    lat: 49.41830062866211,
    lng: 13.321900367736816,
  },
  {
    id: "SBM",
    name: "Sheboygan County Memorial Airport",
    city: "Sheboygan",
    country: "United States",
    lat: 43.76959991,
    lng: -87.85140228,
  },
  {
    id: "KFE",
    name: "Fortescue - Dave Forrest Aerodrome",
    city: "Cloudbreak",
    country: "Australia",
    lat: -22.290754,
    lng: 119.437143,
  },
  {
    id: "N",
    name: "Kangel Danda Airport",
    city: "Kangel Danda",
    country: "Nepal",
    lat: 27.4106333137,
    lng: 86.6465950012,
  },
  {
    id: "BJU",
    name: "Bajura Airport",
    city: "Bajura",
    country: "Nepal",
    lat: 29.50200080871582,
    lng: 81.66899871826172,
  },
  {
    id: "N",
    name: "Chara Airport",
    city: "Chara",
    country: "Russia",
    lat: 56.913333892822266,
    lng: 118.2699966430664,
  },
  {
    id: "N",
    name: "Herning Airport",
    city: "Herning",
    country: "Denmark",
    lat: 56.18470001220703,
    lng: 9.044449806213379,
  },
  {
    id: "N",
    name: "Oberschleißheim Airfield",
    city: "Schleissheim",
    country: "Germany",
    lat: 48.239445,
    lng: 11.561389,
  },
  {
    id: "MZJ",
    name: "Pinal Airpark",
    city: "Marana",
    country: "United States",
    lat: 32.5106010437,
    lng: -111.32800293,
  },
  {
    id: "N",
    name: "Glendale Municipal Airport",
    city: "Glendale",
    country: "United States",
    lat: 33.52690124511719,
    lng: -112.29499816894531,
  },
  {
    id: "SAD",
    name: "Safford Regional Airport",
    city: "Safford",
    country: "United States",
    lat: 32.85480118,
    lng: -109.6350021,
  },
  {
    id: "N",
    name: "Verden-Scharnhorst Airfield",
    city: "Verden",
    country: "Germany",
    lat: 52.965279,
    lng: 9.282778,
  },
  {
    id: "SLJ",
    name: "Solomon Airport",
    city: "Solomon",
    country: "Australia",
    lat: -22.2554,
    lng: 117.7627,
  },
  {
    id: "N",
    name: "Nittenau-Bruck Airport",
    city: "Nittenau",
    country: "Germany",
    lat: 49.22249984741211,
    lng: 12.296667098999023,
  },
  {
    id: "KJP",
    name: "Kerama Airport",
    city: "Kerama",
    country: "Japan",
    lat: 26.168300628699996,
    lng: 127.292999268,
  },
  {
    id: "N",
    name: "Americana Airport",
    city: "Americana",
    country: "Brazil",
    lat: -22.755800247192383,
    lng: -47.26940155029297,
  },
  {
    id: "EKB",
    name: "Ekibastuz Airport",
    city: "Ekibastuz",
    country: "Kazakhstan",
    lat: 51.590999603271484,
    lng: 75.21499633789062,
  },
  {
    id: "N",
    name: "Adamovka",
    city: "Adamovka",
    country: "Russia",
    lat: 51.5,
    lng: 59.936111,
  },
  {
    id: "N",
    name: "Kvarkeno",
    city: "Kvarkeno",
    country: "Russia",
    lat: 52.078333,
    lng: 59.683333,
  },
  {
    id: "SIK",
    name: "Sikeston Memorial Municipal Airport",
    city: "Sikeston",
    country: "United States",
    lat: 36.898899078369,
    lng: -89.561798095703,
  },
  {
    id: "TTI",
    name: "Tetiaroa Airport",
    city: "Tetiaroa",
    country: "French Polynesia",
    lat: -17.0132999420166,
    lng: -149.58700561523438,
  },
  {
    id: "GFL",
    name: "Floyd Bennett Memorial Airport",
    city: "Queensbury",
    country: "United States",
    lat: 43.3412017822,
    lng: -73.6102981567,
  },
  {
    id: "N",
    name: "Saratoga County Airport",
    city: "Ballston Spa",
    country: "United States",
    lat: 43.05130005,
    lng: -73.86119843,
  },
  {
    id: "N",
    name: "Crystal River Airport",
    city: "Crystal River",
    country: "United States",
    lat: 28.867300033569336,
    lng: -82.57129669189453,
  },
  {
    id: "MTN",
    name: "Martin State Airport",
    city: "Baltimore",
    country: "United States",
    lat: 39.325699,
    lng: -76.413803,
  },
  {
    id: "N",
    name: "Lincoln Regional Karl Harder Field",
    city: "Lincoln",
    country: "United States",
    lat: 38.90919876098633,
    lng: -121.35099792480469,
  },
  {
    id: "N",
    name: "Fostoria Metropolitan Airport",
    city: "Fostoria",
    country: "United States",
    lat: 41.19079971,
    lng: -83.39450073,
  },
  {
    id: "FRY",
    name: "Eastern Slopes Regional Airport",
    city: "Fryeburg",
    country: "United States",
    lat: 43.991100311299995,
    lng: -70.9478988647,
  },
  {
    id: "N",
    name: "Coral Creek Airport",
    city: "Placida",
    country: "United States",
    lat: 26.85449981689453,
    lng: -82.2511978149414,
  },
  {
    id: "NEW",
    name: "Lakefront Airport",
    city: "New Orleans",
    country: "United States",
    lat: 30.042400360107,
    lng: -90.028297424316,
  },
  {
    id: "COE",
    name: "Coeur D'Alene - Pappy Boyington Field",
    city: "Coeur d'Alene",
    country: "United States",
    lat: 47.77429962,
    lng: -116.8199997,
  },
  {
    id: "BMT",
    name: "Beaumont Municipal Airport",
    city: "Beaumont",
    country: "United States",
    lat: 30.0706996918,
    lng: -94.21579742430002,
  },
  {
    id: "DNV",
    name: "Vermilion Regional Airport",
    city: "Danville",
    country: "United States",
    lat: 40.19919968,
    lng: -87.59590149,
  },
  {
    id: "COJ",
    name: "Coonabarabran Airport",
    city: "Coonabarabran",
    country: "Australia",
    lat: -31.332500457763672,
    lng: 149.26699829101562,
  },
  {
    id: "TIX",
    name: "Space Coast Regional Airport",
    city: "Titusville",
    country: "United States",
    lat: 28.514799118042,
    lng: -80.799201965332,
  },
  {
    id: "BZH",
    name: "Bumi Airport",
    city: "Bumi Hills",
    country: "Zimbabwe",
    lat: -16.8169994354,
    lng: 28.3500003815,
  },
  {
    id: "N",
    name: "Warnervale Airport",
    city: "Warnervale Airport",
    country: "Australia",
    lat: -33.240278,
    lng: 151.429722,
  },
  {
    id: "UAR",
    name: "Bouarfa Airport",
    city: "Bouarfa",
    country: "Morocco",
    lat: 32.5143055556,
    lng: -1.98305555556,
  },
  {
    id: "NYE",
    name: "Nyeri Airport",
    city: "NYERI",
    country: "Kenya",
    lat: -0.3644140064716339,
    lng: 36.978485107421875,
  },
  {
    id: "AAP",
    name: "Andrau Airpark",
    city: "Houston",
    country: "United States",
    lat: 29.722499847399998,
    lng: -95.58830261230001,
  },
  {
    id: "FCM",
    name: "Flying Cloud Airport",
    city: "Eden Prairie",
    country: "United States",
    lat: 44.8272018433,
    lng: -93.45709991460001,
  },
  {
    id: "LIX",
    name: "Likoma Island Airport",
    city: "Likoma Island",
    country: "Malawi",
    lat: -12.075833,
    lng: 34.737222,
  },
  {
    id: "OJC",
    name: "Johnson County Executive Airport",
    city: "Olathe",
    country: "United States",
    lat: 38.84759903,
    lng: -94.73760223,
  },
  {
    id: "GIU",
    name: "Sigiriya Air Force Base",
    city: "Sigiriya",
    country: "Sri Lanka",
    lat: 7.956669807430001,
    lng: 80.7285003662,
  },
  {
    id: "EUM",
    name: "Neumünster Airport",
    city: "Neumuenster",
    country: "Germany",
    lat: 54.079444885253906,
    lng: 9.941389083862305,
  },
  {
    id: "TKT",
    name: "Tak Airport",
    city: "Tak",
    country: "Thailand",
    lat: 16.895999908447266,
    lng: 99.25330352783203,
  },
  {
    id: "YLK",
    name: "Barrie-Orillia (Lake Simcoe Regional Airport)",
    city: "Barrie-Orillia",
    country: "Canada",
    lat: 44.4852981567,
    lng: -79.55560302730001,
  },
  {
    id: "N",
    name: "Huronia Airport",
    city: "Midland",
    country: "Canada",
    lat: 44.6833000183,
    lng: -79.9282989502,
  },
  {
    id: "N",
    name: "Markham Airport",
    city: "Markham",
    country: "Canada",
    lat: 43.93579864501953,
    lng: -79.26219940185547,
  },
  {
    id: "N",
    name: "Stanhope Municipal Airport",
    city: "Haliburton",
    country: "Canada",
    lat: 45.1108333333,
    lng: -78.64,
  },
  {
    id: "N",
    name: "Kawartha Lakes (Lindsay) Airport",
    city: "Lindsay",
    country: "Canada",
    lat: 44.3647,
    lng: -78.783897,
  },
  {
    id: "YCM",
    name: "Niagara District Airport",
    city: "Saint Catherines",
    country: "Canada",
    lat: 43.19169998168945,
    lng: -79.17169952392578,
  },
  {
    id: "N",
    name: "Edenvale Aerodrome",
    city: "Edenvale",
    country: "Canada",
    lat: 44.441101,
    lng: -79.962799,
  },
  {
    id: "N",
    name: "Orillia Airport",
    city: "Orillia",
    country: "Canada",
    lat: 44.67765578389999,
    lng: -79.31021690370001,
  },
  {
    id: "N",
    name: "Holland Landing Airpark",
    city: "Holland Landing",
    country: "Canada",
    lat: 44.08940124511719,
    lng: -79.49500274658203,
  },
  {
    id: "YPD",
    name: "Parry Sound Area Municipal Airport",
    city: "Parry Sound",
    country: "Canada",
    lat: 45.2575,
    lng: -79.829697,
  },
  {
    id: "N",
    name: "Hanover / Saugeen Municipal Airport",
    city: "Hanover",
    country: "Canada",
    lat: 44.158298,
    lng: -81.062798,
  },
  {
    id: "N",
    name: "Brandywine Airport",
    city: "West Goshen Township",
    country: "United States",
    lat: 39.9901008605957,
    lng: -75.58190155029297,
  },
  {
    id: "MNZ",
    name: "Manassas Regional Airport/Harry P. Davis Field",
    city: "Manassas",
    country: "United States",
    lat: 38.72140121,
    lng: -77.51540375,
  },
  {
    id: "LJN",
    name: "Texas Gulf Coast Regional Airport",
    city: "Angleton",
    country: "United States",
    lat: 29.1086006165,
    lng: -95.462097168,
  },
  {
    id: "N",
    name: "Bubovice Airport",
    city: "Bubovice",
    country: "Czech Republic",
    lat: 49.97439956665039,
    lng: 14.178099632263184,
  },
  {
    id: "N",
    name: "Rakkestad Astorp Airport",
    city: "Rakkestad",
    country: "Norway",
    lat: 59.397499,
    lng: 11.3469,
  },
  {
    id: "BGG",
    name: "Bingöl Çeltiksuyu Airport",
    city: "Bingol",
    country: "Turkey",
    lat: 38.8592605591,
    lng: 40.5959625244,
  },
  {
    id: "KFS",
    name: "Kastamonu Airport",
    city: "Kastamonu",
    country: "Turkey",
    lat: 41.31420135498047,
    lng: 33.795799255371094,
  },
  {
    id: "N",
    name: "Elstree Airfield",
    city: "Elstree",
    country: "United Kingdom",
    lat: 51.6557998657,
    lng: -0.325832992792,
  },
  {
    id: "N",
    name: "Sandtoft Airfield",
    city: "Sandtoft",
    country: "United Kingdom",
    lat: 53.559700012200004,
    lng: -0.8583329916,
  },
  {
    id: "N",
    name: "Torit Airport",
    city: "Torit",
    country: "South Sudan",
    lat: 4.400000095367432,
    lng: 32.58300018310547,
  },
  {
    id: "N",
    name: "Shelby County Airport",
    city: "Shelbyville",
    country: "United States",
    lat: 39.410400390599996,
    lng: -88.8453979492,
  },
  {
    id: "LLV",
    name: "Lüliang Airport",
    city: "Lvliang",
    country: "China",
    lat: 37.683333,
    lng: 111.142778,
  },
  {
    id: "DCY",
    name: "Daocheng Yading Airport",
    city: "Daocheng",
    country: "China",
    lat: 29.323056,
    lng: 100.053333,
  },
  {
    id: "GXH",
    name: "Gannan Xiahe Airport",
    city: "Xiahe city",
    country: "China",
    lat: 34.8105,
    lng: 102.6447,
  },
  {
    id: "N",
    name: "Vängsö Airport",
    city: "Vangso",
    country: "Sweden",
    lat: 59.10110092163086,
    lng: 17.21109962463379,
  },
  {
    id: "CIY",
    name: "Comiso Airport",
    city: "Comiso",
    country: "Italy",
    lat: 36.994601,
    lng: 14.607182,
  },
  {
    id: "N",
    name: "Enumclaw Airport",
    city: "Enumclaw",
    country: "United States",
    lat: 47.195701599121094,
    lng: -122.02200317382812,
  },
  {
    id: "KVM",
    name: "Markovo Airport",
    city: "Markovo",
    country: "Russia",
    lat: 64.667,
    lng: 170.417007,
  },
  {
    id: "N",
    name: "Seymchan Airport",
    city: "Seymchan",
    country: "Russia",
    lat: 62.920780181884766,
    lng: 152.4227752685547,
  },
  {
    id: "ZKP",
    name: "Zyryanka Airport",
    city: "Zyryanka",
    country: "Russia",
    lat: 65.7485,
    lng: 150.8889,
  },
  {
    id: "N",
    name: "Susuman Airport",
    city: "Susuman",
    country: "Russia",
    lat: 62.766666412353516,
    lng: 148.14666748046875,
  },
  {
    id: "UMS",
    name: "Ust-Maya Airport",
    city: "Ust-Maya",
    country: "Russia",
    lat: 60.356998443604,
    lng: 134.43499755859,
  },
  {
    id: "ADH",
    name: "Aldan Airport",
    city: "Aldan",
    country: "Russia",
    lat: 58.60279846191406,
    lng: 125.40899658203125,
  },
  {
    id: "OLZ",
    name: "Olyokminsk Airport",
    city: "Olekminsk",
    country: "Russia",
    lat: 60.397499,
    lng: 120.471001,
  },
  {
    id: "N",
    name: "Vitim Airport",
    city: "Vitim",
    country: "Russia",
    lat: 59.458,
    lng: 112.563004,
  },
  {
    id: "N",
    name: "Pellworm Field",
    city: "Pellworm",
    country: "Germany",
    lat: 54.5363883972,
    lng: 8.68000030518,
  },
  {
    id: "NLT",
    name: "Xinyuan Nalati Airport",
    city: "Xinyuan",
    country: "China",
    lat: 43.4318,
    lng: 83.3786,
  },
  {
    id: "PTA",
    name: "Port Alsworth Airport",
    city: "Port alsworth",
    country: "United States",
    lat: 60.201681,
    lng: -154.325863,
  },
  {
    id: "BOR",
    name: "Fontaine Airport",
    city: "Belfort",
    country: "France",
    lat: 47.655601501465,
    lng: 7.0108299255371,
  },
  {
    id: "N",
    name: "Fairfield County Airport",
    city: "Winnsboro",
    country: "United States",
    lat: 34.31549835205078,
    lng: -81.10880279541016,
  },
  {
    id: "OBC",
    name: "Obock Airport",
    city: "Obock",
    country: "Djibouti",
    lat: 11.967000007629395,
    lng: 43.266998291015625,
  },
  {
    id: "TDJ",
    name: "Tadjoura Airport",
    city: "Tadjoura",
    country: "Djibouti",
    lat: 11.782999992370605,
    lng: 42.91699981689453,
  },
  {
    id: "AQB",
    name: "Santa Cruz del Quiche Airport",
    city: "Santa Cruz des Quiche",
    country: "Guatemala",
    lat: 15.012200355529785,
    lng: -91.15059661865234,
  },
  {
    id: "NOR",
    name: "Norðfjörður Airport",
    city: "Nordfjordur",
    country: "Iceland",
    lat: 65.13189697265625,
    lng: -13.746399879455566,
  },
  {
    id: "BTZ",
    name: "Bursa Airport",
    city: "Bursa",
    country: "Turkey",
    lat: 40.233299255371094,
    lng: 29.009199142456055,
  },
  {
    id: "N",
    name: "Skyhaven Airport",
    city: "Rochester",
    country: "United States",
    lat: 43.28409957885742,
    lng: -70.9292984008789,
  },
  {
    id: "WAR",
    name: "Waris Airport",
    city: "Waris-Papua Island",
    country: "Indonesia",
    lat: -3.235,
    lng: 140.994,
  },
  {
    id: "EWK",
    name: "Newton City-County Airport",
    city: "Newton",
    country: "United States",
    lat: 38.058200836199994,
    lng: -97.2744979858,
  },
  {
    id: "N",
    name: "La Ferté Alais Airfield",
    city: "La Ferte Alais",
    country: "France",
    lat: 48.498652,
    lng: 2.338867,
  },
  {
    id: "BSJ",
    name: "Bairnsdale Airport",
    city: "Bairnsdale",
    country: "Australia",
    lat: -37.88750076293945,
    lng: 147.5679931640625,
  },
  {
    id: "TZR",
    name: "Taszár Air Base",
    city: "Columbus",
    country: "United States",
    lat: 46.39310073852539,
    lng: 17.917499542236328,
  },
  {
    id: "FBR",
    name: "Fort Bridger Airport",
    city: "Fort Bridger",
    country: "United States",
    lat: 41.3918991089,
    lng: -110.406997681,
  },
  {
    id: "N",
    name: "Prosser Airport",
    city: "Prosser",
    country: "United States",
    lat: 46.21340179,
    lng: -119.7910004,
  },
  {
    id: "CLS",
    name: "Chehalis Centralia Airport",
    city: "Chehalis",
    country: "United States",
    lat: 46.676998138399995,
    lng: -122.983001709,
  },
  {
    id: "N",
    name: "Desert Aire Regional Airport",
    city: "Mattawa",
    country: "United States",
    lat: 46.687401,
    lng: -119.920998,
  },
  {
    id: "EVW",
    name: "Evanston-Uinta County Airport-Burns Field",
    city: "Evanston",
    country: "United States",
    lat: 41.27479935,
    lng: -111.0350037,
  },
  {
    id: "N",
    name: "Sabetha Municipal Airport",
    city: "Sabetha",
    country: "United States",
    lat: 39.90420150756836,
    lng: -95.77940368652344,
  },
  {
    id: "N",
    name: "Mt Pleasant Regional-Faison field",
    city: "Mount Pleasant",
    country: "United States",
    lat: 32.89780045,
    lng: -79.78289795,
  },
  {
    id: "N",
    name: "Jimmy Carter Regional Airport",
    city: "Americus",
    country: "United States",
    lat: 32.110802,
    lng: -84.188904,
  },
  {
    id: "EUF",
    name: "Weedon Field",
    city: "Eufala",
    country: "United States",
    lat: 31.9512996674,
    lng: -85.1288986206,
  },
  {
    id: "N",
    name: "Saluda County Airport",
    city: "Saluda",
    country: "United States",
    lat: 33.92679977416992,
    lng: -81.79460144042969,
  },
  {
    id: "MEO",
    name: "Dare County Regional Airport",
    city: "Manteo",
    country: "United States",
    lat: 35.91899872,
    lng: -75.69550323,
  },
  {
    id: "AUO",
    name: "Auburn University Regional Airport",
    city: "Auburn",
    country: "United States",
    lat: 32.615101,
    lng: -85.433998,
  },
  {
    id: "N",
    name: "Tri Cities Airport",
    city: "Endicott",
    country: "United States",
    lat: 42.078499,
    lng: -76.096296,
  },
  {
    id: "N",
    name: "Bessemer Airport",
    city: "Bessemer",
    country: "United States",
    lat: 33.31290054,
    lng: -86.92590332,
  },
  {
    id: "N",
    name: "Colorado Springs East Airport",
    city: "Ellicott",
    country: "United States",
    lat: 38.8744010925293,
    lng: -104.41000366210938,
  },
  {
    id: "N",
    name: "Crystal Airport",
    city: "Crystal",
    country: "United States",
    lat: 45.0620002746582,
    lng: -93.35389709472656,
  },
  {
    id: "N",
    name: "Clarke County Airport",
    city: "Quitman",
    country: "United States",
    lat: 32.0849,
    lng: -88.738897,
  },
  {
    id: "DBN",
    name: "W H 'Bud' Barron Airport",
    city: "Dublin",
    country: "United States",
    lat: 32.56439972,
    lng: -82.98529816,
  },
  {
    id: "PUK",
    name: "Pukarua Airport",
    city: "Pukarua",
    country: "French Polynesia",
    lat: -18.29560089111328,
    lng: -137.01699829101562,
  },
  {
    id: "N",
    name: "Kabale Airport",
    city: "Kabale",
    country: "Uganda",
    lat: -1.226111,
    lng: 29.96,
  },
  {
    id: "N",
    name: "Guatuso Airport",
    city: "Marigot",
    country: "France",
    lat: 10.683333396911621,
    lng: -84.83333587646484,
  },
  {
    id: "N",
    name: "Central Bolívar Airport",
    city: "Sevilla",
    country: "Spain",
    lat: 8.916666984558105,
    lng: -71.93333435058594,
  },
  {
    id: "CVO",
    name: "Corvallis Municipal Airport",
    city: "Corvallis",
    country: "United States",
    lat: 44.49720001,
    lng: -123.2900009,
  },
  {
    id: "N",
    name: "Tuzla Romania Airport",
    city: "Tuzla",
    country: "Romania",
    lat: 43.98419952392578,
    lng: 28.609699249267578,
  },
  {
    id: "N",
    name: "El Almendro Airport",
    city: "Scranton",
    country: "United States",
    lat: -35.96055603027344,
    lng: -71.7933349609375,
  },
  {
    id: "N",
    name: "San Agustin Airport",
    city: "Morristown",
    country: "United States",
    lat: 10.066666603088379,
    lng: -84.88333129882812,
  },
  {
    id: "N",
    name: "Samambaia Heliport",
    city: "Saint Denis",
    country: "Reunion",
    lat: -22.462499618530273,
    lng: -43.13055419921875,
  },
  {
    id: "N",
    name: "Fazenda Campo Verde Airport",
    city: "Sihanoukville",
    country: "Cambodia",
    lat: 1.04278004169,
    lng: -50.516700744599994,
  },
  {
    id: "PXH",
    name: "Prominent Hill Airport",
    city: "Prominent Hill",
    country: "Australia",
    lat: -29.716,
    lng: 135.5244,
  },
  {
    id: "CWT",
    name: "Cowra Airport",
    city: "Chatsworth",
    country: "Australia",
    lat: -33.84469985961914,
    lng: 148.6490020751953,
  },
  {
    id: "N",
    name: "Coral Bay Airport",
    city: "Coral Bay",
    country: "Australia",
    lat: -23.1299991607666,
    lng: 113.7770004272461,
  },
  {
    id: "OGD",
    name: "Ogden Hinckley Airport",
    city: "Ogden",
    country: "United States",
    lat: 41.195899963379,
    lng: -112.0120010376,
  },
  {
    id: "N",
    name: "Lake Country Regional Airport",
    city: "Clarksville",
    country: "United Arab Emirates",
    lat: 36.5957984924,
    lng: -78.56009674070002,
  },
  {
    id: "N",
    name: "Robert S Kerr Airport",
    city: "Poteau",
    country: "United States",
    lat: 35.02159881591797,
    lng: -94.62129974365234,
  },
  {
    id: "AKO",
    name: "Colorado Plains Regional Airport",
    city: "Akron",
    country: "United States",
    lat: 40.1755981445,
    lng: -103.222000122,
  },
  {
    id: "SHN",
    name: "Sanderson Field",
    city: "Shelton",
    country: "United States",
    lat: 47.233600616455,
    lng: -123.14800262451,
  },
  {
    id: "WNA",
    name: "Napakiak Airport",
    city: "Napakiak",
    country: "United States",
    lat: 60.69029998779297,
    lng: -161.97900390625,
  },
  {
    id: "PKA",
    name: "Napaskiak Airport",
    city: "Napaskiak",
    country: "United States",
    lat: 60.70289993,
    lng: -161.7779999,
  },
  {
    id: "N",
    name: "Tok Airport",
    city: "Tok",
    country: "United States",
    lat: 63.303333,
    lng: -143.001111,
  },
  {
    id: "YBW",
    name: "Bedwell Harbour Seaplane Base",
    city: "Bedwell Harbour",
    country: "Canada",
    lat: 48.75,
    lng: -123.233001709,
  },
  {
    id: "WSO",
    name: "Washabo Airport",
    city: "Washabo",
    country: "Suriname",
    lat: 5.215277,
    lng: -57.185302,
  },
  {
    id: "N",
    name: "Popham Airfield",
    city: "Popham",
    country: "United Kingdom",
    lat: 51.193901,
    lng: -1.23472,
  },
  {
    id: "N",
    name: "Causey Airport",
    city: "Liberty",
    country: "United States",
    lat: 35.911800384521484,
    lng: -79.61759948730469,
  },
  {
    id: "WKR",
    name: "Abaco I Walker C Airport",
    city: "Walker's Cay",
    country: "Bahamas",
    lat: 27.266700744628906,
    lng: -78.39969635009766,
  },
  {
    id: "N",
    name: "Black Point Airstrip",
    city: "Black Point",
    country: "Bahamas",
    lat: 24.089488448799997,
    lng: -76.3979172707,
  },
  {
    id: "GFO",
    name: "Bartica A Airport",
    city: "Bartica",
    country: "Guyana",
    lat: 6.358864,
    lng: -58.655207,
  },
  {
    id: "DYL",
    name: "Doylestown Airport",
    city: "Doylestown",
    country: "United States",
    lat: 40.3330001831,
    lng: -75.1222991943,
  },
  {
    id: "N",
    name: "Cape Town Waterfort Heliport",
    city: "Cap Town",
    country: "South Africa",
    lat: 0.0,
    lng: 0.0,
  },
  {
    id: "TGI",
    name: "Tingo Maria Airport",
    city: "Tingo Maria",
    country: "Peru",
    lat: -9.133000373840332,
    lng: -75.94999694824219,
  },
  {
    id: "TJL",
    name: "Plínio Alarcom Airport",
    city: "Tres Lagoas",
    country: "Brazil",
    lat: -20.754199981689,
    lng: -51.684200286865,
  },
  {
    id: "YZY",
    name: "Zhangye Ganzhou Airport",
    city: "Zhangye",
    country: "China",
    lat: 38.8018989563,
    lng: 100.675003052,
  },
  {
    id: "OAL",
    name: "Cacoal Airport",
    city: "Cacoal",
    country: "Brazil",
    lat: -11.496,
    lng: -61.4508,
  },
  {
    id: "OCW",
    name: "Warren Field",
    city: "Washington",
    country: "United States",
    lat: 35.570499420166,
    lng: -77.049797058105,
  },
  {
    id: "N",
    name: "Hyde County Airport",
    city: "Engelhard",
    country: "United States",
    lat: 35.562400817871094,
    lng: -75.9552001953125,
  },
  {
    id: "MHC",
    name: "Mocopulli Airport",
    city: "Castro",
    country: "Chile",
    lat: -42.340388,
    lng: -73.715693,
  },
  {
    id: "SWO",
    name: "Stillwater Regional Airport",
    city: "Stillwater",
    country: "United States",
    lat: 36.161201477051,
    lng: -97.08570098877,
  },
  {
    id: "OKM",
    name: "Okmulgee Regional Airport",
    city: "Okmulgee",
    country: "United States",
    lat: 35.668098449707,
    lng: -95.948699951172,
  },
  {
    id: "CUH",
    name: "Cushing Municipal Airport",
    city: "Cushing",
    country: "United States",
    lat: 35.9499015808,
    lng: -96.7731018066,
  },
  {
    id: "CSM",
    name: "Clinton Sherman Airport",
    city: "Clinton",
    country: "United States",
    lat: 35.3398017883,
    lng: -99.20050048830001,
  },
  {
    id: "WLD",
    name: "Strother Field",
    city: "Winfield",
    country: "United States",
    lat: 37.168598175,
    lng: -97.0375976562,
  },
  {
    id: "PWA",
    name: "Wiley Post Airport",
    city: "Oklahoma City",
    country: "United States",
    lat: 35.53419876,
    lng: -97.64710236,
  },
  {
    id: "DTN",
    name: "Shreveport Downtown Airport",
    city: "Shreveport",
    country: "United States",
    lat: 32.5401992798,
    lng: -93.7450027466,
  },
  {
    id: "SEP",
    name: "Stephenville Clark Regional Airport",
    city: "Stephenville",
    country: "United States",
    lat: 32.215301513672,
    lng: -98.177696228027,
  },
  {
    id: "N",
    name: "Perry Municipal Airport",
    city: "Perry",
    country: "United States",
    lat: 36.38560104370117,
    lng: -97.2771987915039,
  },
  {
    id: "N",
    name: "Hamilton Municipal Airport",
    city: "Hamilton",
    country: "United States",
    lat: 31.6658992767334,
    lng: -98.14859771728516,
  },
  {
    id: "ADT",
    name: "Ada Regional Airport",
    city: "Ada",
    country: "United States",
    lat: 34.804298,
    lng: -96.671303,
  },
  {
    id: "N",
    name: "Mesquite Metro Airport",
    city: "Misquite",
    country: "United States",
    lat: 32.74700164794922,
    lng: -96.53040313720703,
  },
  {
    id: "N",
    name: "Denton Municipal Airport",
    city: "Denton",
    country: "United States",
    lat: 33.2006988525,
    lng: -97.19799804690001,
  },
  {
    id: "N",
    name: "Austin Executive Airport",
    city: "Austin",
    country: "United States",
    lat: 30.3974931,
    lng: -97.5663935,
  },
  {
    id: "N",
    name: "Lago Vista Tx Rusty Allen Airport",
    city: "Lago Vista",
    country: "United States",
    lat: 30.498600006103516,
    lng: -97.96949768066406,
  },
  {
    id: "N",
    name: "Brenham Municipal Airport",
    city: "Brenham",
    country: "United States",
    lat: 30.21899986,
    lng: -96.3742981,
  },
  {
    id: "N",
    name: "Lakeway Airpark",
    city: "Lakeway",
    country: "United States",
    lat: 30.357500076293945,
    lng: -97.99449920654297,
  },
  {
    id: "IRB",
    name: "Iraan Municipal Airport",
    city: "Iraan",
    country: "United States",
    lat: 30.9057006836,
    lng: -101.891998291,
  },
  {
    id: "N",
    name: "Kestrel Airpark",
    city: "San Antonio",
    country: "United States",
    lat: 29.812700271606445,
    lng: -98.42530059814453,
  },
  {
    id: "YEL",
    name: "Elliot Lake Municipal Airport",
    city: "ELLIOT LAKE",
    country: "Canada",
    lat: 46.351398468,
    lng: -82.5614013672,
  },
  {
    id: "IKB",
    name: "Wilkes County Airport",
    city: "North Wilkesboro",
    country: "United States",
    lat: 36.2228012085,
    lng: -81.09829711910001,
  },
  {
    id: "N",
    name: "Charleston Executive Airport",
    city: "Charleston",
    country: "United States",
    lat: 32.70090103149414,
    lng: -80.00289916992188,
  },
  {
    id: "DAN",
    name: "Danville Regional Airport",
    city: "Danville",
    country: "United States",
    lat: 36.572898864746094,
    lng: -79.33609771728516,
  },
  {
    id: "N",
    name: "Brookneal/Campbell County Airport",
    city: "Brookneal",
    country: "United States",
    lat: 37.141700744599994,
    lng: -79.01640319820001,
  },
  {
    id: "ERG",
    name: "Yerbogachen Airport",
    city: "Yerbogachen",
    country: "Russia",
    lat: 61.2750015259,
    lng: 108.029998779,
  },
  {
    id: "HCW",
    name: "Cheraw Municipal Airport/Lynch Bellinger Field",
    city: "Cheraw",
    country: "United States",
    lat: 34.71289825,
    lng: -79.95700073,
  },
  {
    id: "N",
    name: "Wauchula Municipal Airport",
    city: "Wuchula",
    country: "United States",
    lat: 27.51490020752,
    lng: -81.880500793457,
  },
  {
    id: "N",
    name: "Lilydale Airport",
    city: "Lilydale",
    country: "Australia",
    lat: -37.69169998168945,
    lng: 145.36700439453125,
  },
  {
    id: "BEM",
    name: "Beni Mellal Airport",
    city: "Beni Mellal",
    country: "Morocco",
    lat: 32.401895,
    lng: -6.315905,
  },
  {
    id: "NKT",
    name: "Şırnak Şerafettin Elçi Airport",
    city: "Cizre",
    country: "Turkey",
    lat: 37.3647,
    lng: 42.0582,
  },
  {
    id: "SUY",
    name: "Suntar Airport",
    city: "Suntar",
    country: "Russia",
    lat: 62.185001373291,
    lng: 117.63500213623,
  },
  {
    id: "OUZ",
    name: "Tazadit Airport",
    city: "Zouerat",
    country: "Mauritania",
    lat: 22.756399154663086,
    lng: -12.483599662780762,
  },
  {
    id: "ABB",
    name: "Asaba International Airport",
    city: "Asaba",
    country: "Nigeria",
    lat: 6.204167,
    lng: 6.665278,
  },
  {
    id: "QUO",
    name: "Akwa Ibom International Airport",
    city: "Uyo",
    country: "Nigeria",
    lat: 4.8725,
    lng: 8.093,
  },
  {
    id: "KAA",
    name: "Kasama Airport",
    city: "Kasama",
    country: "Zambia",
    lat: -10.216699600219727,
    lng: 31.13330078125,
  },
  {
    id: "N",
    name: "Mbeya Airport",
    city: "Mbeya",
    country: "Tanzania",
    lat: -8.919444,
    lng: 33.463889,
  },
  {
    id: "N",
    name: "Mpanda Airport",
    city: "Mpanda",
    country: "Tanzania",
    lat: -6.355374,
    lng: 31.084116,
  },
  {
    id: "SGX",
    name: "Songea Airport",
    city: "Songea",
    country: "Tanzania",
    lat: -10.682999610900879,
    lng: 35.58300018310547,
  },
  {
    id: "N",
    name: "Morogoro Airport",
    city: "Morogoro",
    country: "Tanzania",
    lat: -6.797220230102539,
    lng: 37.653099060058594,
  },
  {
    id: "JUH",
    name: "Jiuhuashan Airport",
    city: "Chizhou",
    country: "China",
    lat: 30.7403,
    lng: 117.6856,
  },
  {
    id: "AOG",
    name: "Anshan Air Base",
    city: "Anshan",
    country: "China",
    lat: 41.105301,
    lng: 122.853996,
  },
  {
    id: "DQA",
    name: "Saertu Airport",
    city: "Daqing",
    country: "China",
    lat: 46.7463888889,
    lng: 125.140555556,
  },
  {
    id: "ZYI",
    name: "Zunyi Xinzhou Airport",
    city: "Zunyi",
    country: "China",
    lat: 27.5895,
    lng: 107.0007,
  },
  {
    id: "N",
    name: "Conway Horry County Airport",
    city: "Conway",
    country: "United States",
    lat: 33.82849884,
    lng: -79.12220001,
  },
  {
    id: "LDS",
    name: "Lindu Airport",
    city: "Yinchun",
    country: "China",
    lat: 47.7520555556,
    lng: 129.019125,
  },
  {
    id: "AVA",
    name: "Anshun Huangguoshu Airport",
    city: "Anshun",
    country: "China",
    lat: 26.2605555556,
    lng: 105.873333333,
  },
  {
    id: "KSS",
    name: "Sikasso Airport",
    city: "Sikasso",
    country: "Mali",
    lat: 11.333000183105469,
    lng: -5.699999809265137,
  },
  {
    id: "WTB",
    name: "Toowoomba Wellcamp Airport",
    city: "Toowoomba",
    country: "Australia",
    lat: -27.558332,
    lng: 151.793335,
  },
  {
    id: "TNH",
    name: "Tonghua Sanyuanpu Airport",
    city: "Tonghua",
    country: "China",
    lat: 42.2538888889,
    lng: 125.703333333,
  },
  {
    id: "SZV",
    name: "Suzhou Guangfu Airport",
    city: "Suzhou",
    country: "China",
    lat: 31.2631,
    lng: 120.401001,
  },
  {
    id: "N",
    name: "City Airport Manchester",
    city: "Manchester",
    country: "United Kingdom",
    lat: 53.471698761,
    lng: -2.38971996307,
  },
  {
    id: "N",
    name: "Sleap Airport",
    city: "Shrewsbury",
    country: "United Kingdom",
    lat: 52.833900451699996,
    lng: -2.77167010307,
  },
  {
    id: "N",
    name: "Tatenhill Airfield",
    city: "Burton-on-Trent",
    country: "United Kingdom",
    lat: 52.814701080300004,
    lng: -1.76110994816,
  },
  {
    id: "N",
    name: "Full Sutton Airfield",
    city: "York",
    country: "United Kingdom",
    lat: 53.980598,
    lng: -0.864722,
  },
  {
    id: "N",
    name: "Sherburn-In-Elmet Airfield",
    city: "Leeds",
    country: "United Kingdom",
    lat: 53.788458,
    lng: -1.216877,
  },
  {
    id: "N",
    name: "Beringin Airport",
    city: "Muara Teweh",
    country: "Indonesia",
    lat: -0.940325021744,
    lng: 114.893875122,
  },
  {
    id: "LII",
    name: "Mulia Airport",
    city: "Mulia",
    country: "Indonesia",
    lat: -3.7018,
    lng: 137.957,
  },
  {
    id: "NTI",
    name: "Stenkol Airport",
    city: "Bintuni",
    country: "Indonesia",
    lat: -2.1033,
    lng: 133.5164,
  },
  {
    id: "WSR",
    name: "Wasior Airport",
    city: "Wasior",
    country: "Indonesia",
    lat: -2.721,
    lng: 134.5061,
  },
  {
    id: "DTB",
    name: "Silangit Airport",
    city: "Siborong-Borong",
    country: "Indonesia",
    lat: 2.25973,
    lng: 98.991898,
  },
  {
    id: "N",
    name: "Lasikin Airport",
    city: "Sinabang",
    country: "Indonesia",
    lat: 2.4102799892425537,
    lng: 96.32559967041016,
  },
  {
    id: "MEQ",
    name: "Seunagan Airport",
    city: "Nagan Raya",
    country: "Indonesia",
    lat: 4.25,
    lng: 96.21700286865234,
  },
  {
    id: "BUW",
    name: "Betoambari Airport",
    city: "Bau-Bau",
    country: "Indonesia",
    lat: -5.486879825592041,
    lng: 122.56900024414062,
  },
  {
    id: "KAZ",
    name: "Kao Airport",
    city: "Kao",
    country: "Indonesia",
    lat: 1.1852799654006958,
    lng: 127.89600372314453,
  },
  {
    id: "MNA",
    name: "Melangguane Airport",
    city: "Melonguane",
    country: "Indonesia",
    lat: 4.00694,
    lng: 126.672997,
  },
  {
    id: "SGQ",
    name: "Sanggata/Sangkimah Airport",
    city: "Sanggata",
    country: "Indonesia",
    lat: 0.3847,
    lng: 117.543,
  },
  {
    id: "BUU",
    name: "Muara Bungo Airport",
    city: "Muara Bungo",
    country: "Indonesia",
    lat: -1.1278,
    lng: 102.135,
  },
  {
    id: "N",
    name: "Selayar/Aroepala Airport",
    city: "Selayar",
    country: "Indonesia",
    lat: -6.1751,
    lng: 120.4362,
  },
  {
    id: "ILA",
    name: "Illaga Airport",
    city: "Illaga",
    country: "Indonesia",
    lat: -3.97648,
    lng: 137.6225,
  },
  {
    id: "OKL",
    name: "Oksibil Airport",
    city: "Oksibil",
    country: "Indonesia",
    lat: -4.9071,
    lng: 140.6277,
  },
  {
    id: "KOX",
    name: "Kokonau Airport",
    city: "Kokonau",
    country: "Indonesia",
    lat: -4.71075,
    lng: 136.43515,
  },
  {
    id: "CMQ",
    name: "Clermont Airport",
    city: "Clermont",
    country: "Australia",
    lat: -22.773099899291992,
    lng: 147.62100219726562,
  },
  {
    id: "WMB",
    name: "Warrnambool Airport",
    city: "Warrnambool",
    country: "Australia",
    lat: -38.2952995300293,
    lng: 142.44700622558594,
  },
  {
    id: "RCM",
    name: "Richmond Airport",
    city: "Richmond",
    country: "Australia",
    lat: -20.701900482177734,
    lng: 143.11500549316406,
  },
  {
    id: "DCN",
    name: "RAAF Base Curtin",
    city: "Derby",
    country: "Australia",
    lat: -17.5813999176,
    lng: 123.82800293,
  },
  {
    id: "KNO",
    name: "Kualanamu International Airport",
    city: "Medan",
    country: "Indonesia",
    lat: 3.642222,
    lng: 98.885278,
  },
  {
    id: "AMN",
    name: "Gratiot Community Airport",
    city: "Kamloops",
    country: "Canada",
    lat: 43.322101593,
    lng: -84.68800354,
  },
  {
    id: "N",
    name: "Asheboro Regional Airport",
    city: "Asheboro",
    country: "United States",
    lat: 35.65449905,
    lng: -79.8946991,
  },
  {
    id: "HMY",
    name: "Seosan Air Base",
    city: "Seosan",
    country: "South Korea",
    lat: 36.703999,
    lng: 126.486,
  },
  {
    id: "N",
    name: "Henderson Field",
    city: "Wallace",
    country: "United States",
    lat: 34.717899322509766,
    lng: -78.00360107421875,
  },
  {
    id: "N",
    name: "Emporia Greensville Regional Airport",
    city: "Emporia",
    country: "United States",
    lat: 36.6869010925293,
    lng: -77.48280334472656,
  },
  {
    id: "EMT",
    name: "San Gabriel Valley Airport",
    city: "El Monte",
    country: "United States",
    lat: 34.086102,
    lng: -118.035004,
  },
  {
    id: "FAH",
    name: "Farah Airport",
    city: "Farah",
    country: "Afghanistan",
    lat: 32.367000579833984,
    lng: 62.18299865722656,
  },
  {
    id: "IXT",
    name: "Pasighat Airport",
    city: "Pasighat",
    country: "India",
    lat: 28.066099166870117,
    lng: 95.33560180664062,
  },
  {
    id: "N",
    name: "Kee Field",
    city: "Pineville",
    country: "United States",
    lat: 37.600399017333984,
    lng: -81.5593032836914,
  },
  {
    id: "KRQ",
    name: "Kramatorsk Airport",
    city: "Kramatorsk",
    country: "Ukraine",
    lat: 48.70560073852539,
    lng: 37.62889862060547,
  },
  {
    id: "QKX",
    name: "Kautokeino Air Base",
    city: "Kautokeino",
    country: "Norway",
    lat: 69.04029846191406,
    lng: 23.034000396728516,
  },
  {
    id: "N",
    name: "Lille/Marcq-en-Baroeul Airport",
    city: "Marcq En Baroeul",
    country: "France",
    lat: 50.687198638916016,
    lng: 3.0755600929260254,
  },
  {
    id: "N",
    name: "Kawass Airport",
    city: "Kamsar",
    country: "Guinea",
    lat: 10.651000022888,
    lng: -14.533599853516,
  },
  {
    id: "SSF",
    name: "Stinson Municipal Airport",
    city: "Stinson",
    country: "United States",
    lat: 29.336999893188,
    lng: -98.471099853516,
  },
  {
    id: "N",
    name: "Sallisaw Municipal Airport",
    city: "Sallisaw",
    country: "United States",
    lat: 35.4382019,
    lng: -94.80280304,
  },
  {
    id: "JAS",
    name: "Jasper County Airport-Bell Field",
    city: "Jasper",
    country: "United States",
    lat: 30.88570023,
    lng: -94.03489685,
  },
  {
    id: "N",
    name: "El Dorado Springs Memorial Airport",
    city: "El dorado springs",
    country: "United States",
    lat: 37.8567008972168,
    lng: -93.99909973144531,
  },
  {
    id: "MRF",
    name: "Marfa Municipal Airport",
    city: "Marfa",
    country: "United States",
    lat: 30.371099,
    lng: -104.017997,
  },
  {
    id: "ALE",
    name: "Alpine Casparis Municipal Airport",
    city: "Alpine",
    country: "United States",
    lat: 30.384199142499998,
    lng: -103.683998108,
  },
  {
    id: "BQE",
    name: "Bubaque Airport",
    city: "Bubaque",
    country: "Guinea-Bissau",
    lat: 11.297355651855469,
    lng: -15.838079452514648,
  },
  {
    id: "CZA",
    name: "Chichen Itza International Airport",
    city: "Chichen Itza",
    country: "Mexico",
    lat: 20.6413002014,
    lng: -88.4461975098,
  },
  {
    id: "BUY",
    name: "Bunbury Airport",
    city: "Bunbury",
    country: "Australia",
    lat: -33.378299713134766,
    lng: 115.677001953125,
  },
  {
    id: "CCB",
    name: "Cable Airport",
    city: "Upland",
    country: "United States",
    lat: 34.1115989685,
    lng: -117.68800354,
  },
  {
    id: "N",
    name: "Mount Sterling Montgomery County Airport",
    city: "Mount Sterling",
    country: "United States",
    lat: 38.05810165,
    lng: -83.979599,
  },
  {
    id: "EKI",
    name: "Elkhart Municipal Airport",
    city: "Elkhart",
    country: "United States",
    lat: 41.7193984985,
    lng: -86.00319671630001,
  },
  {
    id: "N",
    name: "Nappanee Municipal Airport",
    city: "Nappanee ",
    country: "United States",
    lat: 41.44620132446289,
    lng: -85.93479919433594,
  },
  {
    id: "CUB",
    name: "Jim Hamilton L.B. Owens Airport",
    city: "Columbia",
    country: "United States",
    lat: 33.970500946,
    lng: -80.9952011108,
  },
  {
    id: "N",
    name: "Grove Municipal Airport",
    city: "Grove",
    country: "United States",
    lat: 36.60680008,
    lng: -94.73860168,
  },
  {
    id: "N",
    name: "Mc Pherson Airport",
    city: "Mc Pherson",
    country: "United States",
    lat: 38.35240173,
    lng: -97.69129944,
  },
  {
    id: "GDC",
    name: "Donaldson Field Airport",
    city: "Greenville",
    country: "United States",
    lat: 34.758301,
    lng: -82.376404,
  },
  {
    id: "N",
    name: "Perry Houston County Airport",
    city: "Perry",
    country: "United States",
    lat: 32.51060104370117,
    lng: -83.76730346679688,
  },
  {
    id: "HVS",
    name: "Hartsville Regional Airport",
    city: "Hartsville",
    country: "United States",
    lat: 34.4030990601,
    lng: -80.11920166019999,
  },
  {
    id: "N",
    name: "Horace Williams Airport",
    city: "Chapel Hill",
    country: "United States",
    lat: 35.935001,
    lng: -79.065902,
  },
  {
    id: "SZT",
    name: "San Cristobal de las Casas Airport",
    city: "San Cristobal de las Casas",
    country: "Mexico",
    lat: 16.690299987793,
    lng: -92.530097961426,
  },
  {
    id: "DU9",
    name: "Dunnville Airport",
    city: "Dunnville",
    country: "Canada",
    lat: 42.872200012200004,
    lng: -79.5958023071,
  },
  {
    id: "N",
    name: "Brunswick County Airport",
    city: "Oak Island",
    country: "United States",
    lat: 33.9292984,
    lng: -78.07499695,
  },
  {
    id: "N",
    name: "Chesterfield County Airport",
    city: "Richmond",
    country: "United States",
    lat: 37.40650177,
    lng: -77.52500153,
  },
  {
    id: "N",
    name: "Atherton Airport",
    city: "Atherton",
    country: "Australia",
    lat: -17.2616996765,
    lng: 145.51499939,
  },
  {
    id: "N",
    name: "Bagdarin Airport",
    city: "Bagdarin",
    country: "Russia",
    lat: 54.36920166015625,
    lng: 113.47899627685547,
  },
  {
    id: "RIH",
    name: "Scarlett Martinez International Airport",
    city: "Rio Hato",
    country: "Panama",
    lat: 8.375880241394,
    lng: -80.127899169922,
  },
  {
    id: "N",
    name: "Henderson Oxford Airport",
    city: "Oxford",
    country: "United States",
    lat: 36.36159897,
    lng: -78.52919769,
  },
  {
    id: "LEE",
    name: "Leesburg International Airport",
    city: "Leesburg",
    country: "United States",
    lat: 28.82309914,
    lng: -81.80870056,
  },
  {
    id: "N",
    name: "Semyazino Airport",
    city: "Vladimir",
    country: "Russia",
    lat: 56.12670135498047,
    lng: 40.314998626708984,
  },
  {
    id: "N",
    name: "Witberg Tswalu Airport",
    city: "Dedeben",
    country: "South Africa",
    lat: -27.204999923706055,
    lng: 22.48189926147461,
  },
  {
    id: "N",
    name: "Mana Pools Airport",
    city: "Mana Pools",
    country: "Zimbabwe",
    lat: -15.768735,
    lng: 29.385617,
  },
  {
    id: "PPY",
    name: "Pouso Alegre Airport",
    city: "Pouso Alegre",
    country: "Brazil",
    lat: -22.289199829101562,
    lng: -45.91910171508789,
  },
  {
    id: "DIQ",
    name: "Brigadeiro Cabral Airport",
    city: "Divinopolis",
    country: "Brazil",
    lat: -20.180700302124,
    lng: -44.870899200439,
  },
  {
    id: "EIK",
    name: "Yeysk Airport",
    city: "Eysk",
    country: "Russia",
    lat: 46.68,
    lng: 38.21,
  },
  {
    id: "ERD",
    name: "Berdyansk Airport",
    city: "Berdyansk",
    country: "Ukraine",
    lat: 46.814998626708984,
    lng: 36.75809860229492,
  },
  {
    id: "BWX",
    name: "Blimbingsari Airport",
    city: "Banyuwangi",
    country: "Indonesia",
    lat: -8.31015,
    lng: 114.3401,
  },
  {
    id: "ERL",
    name: "Erenhot Saiwusu International Airport",
    city: "Erenhot",
    country: "China",
    lat: 43.4225,
    lng: 112.096667,
  },
  {
    id: "N",
    name: "Shobdon Aerodrome",
    city: "Shobdon",
    country: "United Kingdom",
    lat: 52.2416992188,
    lng: -2.8811099529299997,
  },
  {
    id: "CNO",
    name: "Chino Airport",
    city: "Chino",
    country: "United States",
    lat: 33.97470093,
    lng: -117.637001,
  },
  {
    id: "N",
    name: "Kamigoto Airport",
    city: "Shin-kamigoto",
    country: "Japan",
    lat: 33.0130996704,
    lng: 129.192001343,
  },
  {
    id: "N",
    name: "Ojika Airport",
    city: "Odika",
    country: "Japan",
    lat: 33.1907997131,
    lng: 129.089996338,
  },
  {
    id: "N",
    name: "Chofu Airport",
    city: "Tokyo",
    country: "Japan",
    lat: 35.67169952392578,
    lng: 139.5279998779297,
  },
  {
    id: "HTR",
    name: "Hateruma Airport",
    city: "Taketomi",
    country: "Japan",
    lat: 24.0589008331,
    lng: 123.805999756,
  },
  {
    id: "N",
    name: "Madison County Airport",
    city: "London",
    country: "United States",
    lat: 39.93270111,
    lng: -83.46199799,
  },
  {
    id: "BWW",
    name: "Las Brujas Airport",
    city: "Cayo Santa Maria",
    country: "Cuba",
    lat: 22.621299743699996,
    lng: -79.1472015381,
  },
  {
    id: "N",
    name: "Digby (General Hospital) Heliport",
    city: "Tremblay-en-France",
    country: "France",
    lat: 44.6161003112793,
    lng: -65.76190185546875,
  },
  {
    id: "N",
    name: "Thun Airport",
    city: "Thun",
    country: "Switzerland",
    lat: 46.756401062,
    lng: 7.60056018829,
  },
  {
    id: "N",
    name: "Lavrentiya Airport",
    city: "Lavrentiya",
    country: "Russia",
    lat: 65.58000183105469,
    lng: -170.99667358398438,
  },
  {
    id: "PRB",
    name: "Paso Robles Municipal Airport",
    city: "Paso Robles",
    country: "United States",
    lat: 35.67290115,
    lng: -120.6269989,
  },
  {
    id: "N",
    name: "N 104 Helipad",
    city: "Ulleung",
    country: "South Korea",
    lat: 37.479166666699996,
    lng: 130.895555556,
  },
  {
    id: "PKX",
    name: "Beijing Daxing International Airport",
    city: "Beijing",
    country: "China",
    lat: 39.509945,
    lng: 116.41092,
  },
  {
    id: "N",
    name: "Kymi Airport",
    city: "Kotka",
    country: "Finland",
    lat: 60.5713996887207,
    lng: 26.896099090576172,
  },
  {
    id: "HAF",
    name: "Half Moon Bay Airport",
    city: "Half Moon Bay",
    country: "United States",
    lat: 37.513401031499995,
    lng: -122.500999451,
  },
  {
    id: "HCJ",
    name: "Hechi Jinchengjiang Airport",
    city: "Hechi",
    country: "China",
    lat: 24.805,
    lng: 107.6997,
  },
  {
    id: "N",
    name: "Kadina Airport",
    city: "Kadina",
    country: "Australia",
    lat: -33.97669982910156,
    lng: 137.66000366210938,
  },
  {
    id: "WJF",
    name: "General WM J Fox Airfield",
    city: "Lancaster",
    country: "United States",
    lat: 34.74110031,
    lng: -118.2190018,
  },
  {
    id: "CJF",
    name: "Coondewanna Airport",
    city: "Coondewanna",
    country: "Australia",
    lat: -22.96669960022,
    lng: 118.81300354004,
  },
  {
    id: "GUZ",
    name: "Guarapari Airport",
    city: "Guarapari",
    country: "Brazil",
    lat: -20.646499633800005,
    lng: -40.491901397700005,
  },
  {
    id: "UBT",
    name: "Ubatuba Airport",
    city: "Ubatuba",
    country: "Brazil",
    lat: -23.441099166870117,
    lng: -45.075599670410156,
  },
  {
    id: "N",
    name: "Ali Air Base",
    city: "Nasiriyah",
    country: "Iraq",
    lat: 30.935800552368164,
    lng: 46.0900993347168,
  },
  {
    id: "N",
    name: "Ota Air Base",
    city: "Ota",
    country: "Portugal",
    lat: 39.087502,
    lng: -8.96278,
  },
  {
    id: "BOX",
    name: "Borroloola Airport",
    city: "Borroloola",
    country: "Australia",
    lat: -16.075300216674805,
    lng: 136.302001953125,
  },
  {
    id: "N",
    name: "Elsenthal Grafe Airport",
    city: "Elsenthal",
    country: "Germany",
    lat: 48.822498,
    lng: 13.3675,
  },
  {
    id: "N",
    name: "Newtownards Airport",
    city: "Newtownards",
    country: "United Kingdom",
    lat: 54.5811004639,
    lng: -5.69193983078,
  },
  {
    id: "N",
    name: "Lashenden (Headcorn) Airfield",
    city: "Headcorn",
    country: "United Kingdom",
    lat: 51.156898,
    lng: 0.641667,
  },
  {
    id: "N",
    name: "Panshanger Aerodrome",
    city: "Panshanger",
    country: "United Kingdom",
    lat: 51.80250167849999,
    lng: -0.158056005836,
  },
  {
    id: "N",
    name: "Thurrock Airfield",
    city: "Thurrock",
    country: "United Kingdom",
    lat: 51.537505,
    lng: 0.367634,
  },
  {
    id: "N",
    name: "Stapleford Aerodrome",
    city: "Stapleford",
    country: "United Kingdom",
    lat: 51.652500152600005,
    lng: 0.155833005905,
  },
  {
    id: "N",
    name: "HAL Airport",
    city: "Bangalore",
    country: "India",
    lat: 12.9499998093,
    lng: 77.6681976318,
  },
  {
    id: "QUG",
    name: "Chichester/Goodwood Airport",
    city: "Goodwood",
    country: "United Kingdom",
    lat: 50.85940170288086,
    lng: -0.7591670155525208,
  },
  {
    id: "N",
    name: "Omarama Glider Airport",
    city: "Omarama",
    country: "New Zealand",
    lat: -44.486698150634766,
    lng: 169.98599243164062,
  },
  {
    id: "N",
    name: "Haast Aerodrome",
    city: "Haast",
    country: "New Zealand",
    lat: -43.865299224853516,
    lng: 169.04100036621094,
  },
  {
    id: "N",
    name: "Meschede-Schüren Airport",
    city: "Meschede",
    country: "Germany",
    lat: 51.30277633666992,
    lng: 8.239167213439941,
  },
  {
    id: "TNW",
    name: "Jumandy Airport",
    city: "Tena",
    country: "Ecuador",
    lat: -1.059722,
    lng: -77.583333,
  },
  {
    id: "N",
    name: "Morro da Urca Heliport",
    city: "Rio de Janeiro",
    country: "Brazil",
    lat: -22.95166778564453,
    lng: -43.16583251953125,
  },
  {
    id: "FYJ",
    name: "Dongji Aiport",
    city: "Fuyuan",
    country: "China",
    lat: 48.199494,
    lng: 134.366447,
  },
  {
    id: "N",
    name: "Skúvoy Heliport",
    city: "Skuvoy",
    country: "Faroe Islands",
    lat: 61.76959991455078,
    lng: -6.803410053253174,
  },
  {
    id: "N",
    name: "Stóra Dímun Heliport",
    city: "Stora Dimun",
    country: "Faroe Islands",
    lat: 61.685298919677734,
    lng: -6.758500099182129,
  },
  {
    id: "N",
    name: "Frooba Heliport",
    city: "Frooba",
    country: "Faroe Islands",
    lat: 61.543701171875,
    lng: -6.774419784545898,
  },
  {
    id: "N",
    name: "Person County Airport",
    city: "Roxboro",
    country: "United States",
    lat: 36.28490067,
    lng: -78.98419952,
  },
  {
    id: "PZL",
    name: "Zulu Inyala Airport",
    city: "Phinda",
    country: "South Africa",
    lat: -27.84939956665039,
    lng: 32.30970001220703,
  },
  {
    id: "LPF",
    name: "Liupanshui Yuezhao Airport",
    city: "Liupanshui",
    country: "China",
    lat: 26.609417,
    lng: 104.979,
  },
  {
    id: "KJH",
    name: "Kaili Airport",
    city: "Kaili",
    country: "China",
    lat: 26.972,
    lng: 107.988,
  },
  {
    id: "HPG",
    name: "Shennongjia Hongping Airport",
    city: "Shennongjia",
    country: "China",
    lat: 31.626,
    lng: 110.34,
  },
  {
    id: "ZQZ",
    name: "Zhangjiakou Ningyuan Airport",
    city: "Zhangjiakou",
    country: "China",
    lat: 40.7386016846,
    lng: 114.930000305,
  },
  {
    id: "YIE",
    name: "Arxan Yi'ershi Airport",
    city: "Arxan",
    country: "China",
    lat: 47.3106,
    lng: 119.9117,
  },
  {
    id: "HNY",
    name: "Hengyang Nanyue Airport",
    city: "Hengyang",
    country: "China",
    lat: 26.9053,
    lng: 112.627998,
  },
  {
    id: "AHJ",
    name: "Hongyuan Airport",
    city: "Ngawa",
    country: "China",
    lat: 32.53154,
    lng: 102.35224,
  },
  {
    id: "WOS",
    name: "Wonsan Kalma International Airport",
    city: "Wonsan",
    country: "North Korea",
    lat: 39.166801,
    lng: 127.486,
  },
  {
    id: "N",
    name: "Mestia Queen Tamar Airport",
    city: "Mestia",
    country: "Georgia",
    lat: 43.053597,
    lng: 42.749012,
  },
  {
    id: "IGT",
    name: "Magas Airport",
    city: "Magas",
    country: "Russia",
    lat: 43.322299957300004,
    lng: 45.0125999451,
  },
  {
    id: "ASN",
    name: "Talladega Municipal Airport",
    city: "Talladega",
    country: "United States",
    lat: 33.569900512699995,
    lng: -86.05090332030001,
  },
  {
    id: "GMU",
    name: "Greenville Downtown Airport",
    city: "Greenville",
    country: "United States",
    lat: 34.847900390599996,
    lng: -82.34999847410002,
  },
  {
    id: "N",
    name: "Mankato Regional Airport",
    city: "Mankato",
    country: "United States",
    lat: 44.22159958,
    lng: -93.91870117,
  },
  {
    id: "NGD",
    name: "Captain Auguste George Airport",
    city: "Anegada",
    country: "British Virgin Islands",
    lat: 18.72719955444336,
    lng: -64.32969665527344,
  },
  {
    id: "TOI",
    name: "Troy Municipal Airport at N Kenneth Campbell Field",
    city: "Troy",
    country: "United States",
    lat: 31.860399,
    lng: -86.012101,
  },
  {
    id: "N",
    name: "Merkel Field Sylacauga Municipal Airport",
    city: "Sylacauga",
    country: "United States",
    lat: 33.17179870605469,
    lng: -86.30549621582031,
  },
  {
    id: "ETS",
    name: "Enterprise Municipal Airport",
    city: "Enterprise",
    country: "United States",
    lat: 31.29969978,
    lng: -85.89990234,
  },
  {
    id: "N",
    name: "Ryan Field",
    city: "Tucson",
    country: "United States",
    lat: 32.1422004699707,
    lng: -111.17500305175781,
  },
  {
    id: "EFG",
    name: "Efogi Airport",
    city: "Efogi",
    country: "Papua New Guinea",
    lat: -9.15380555556,
    lng: 147.659805556,
  },
  {
    id: "KGW",
    name: "Kagi Airport",
    city: "Kagi",
    country: "Papua New Guinea",
    lat: -9.135916666670001,
    lng: 147.669444444,
  },
  {
    id: "NDN",
    name: "Nadunumu Airport",
    city: "Nadunumu",
    country: "Papua New Guinea",
    lat: -9.14355555556,
    lng: 147.68425,
  },
  {
    id: "BNM",
    name: "Bodinumu Airport",
    city: "Bodinumu",
    country: "Papua New Guinea",
    lat: -9.107777777779999,
    lng: 147.666722222,
  },
  {
    id: "ALX",
    name: "Thomas C Russell Field",
    city: "Alexander City",
    country: "United States",
    lat: 32.914699554399995,
    lng: -85.9629974365,
  },
  {
    id: "PKT",
    name: "Port Keats Airport",
    city: "Wadeye",
    country: "Australia",
    lat: -14.25,
    lng: 129.5290069580078,
  },
  {
    id: "GPN",
    name: "Garden Point Airport",
    city: "Pirlangimpi",
    country: "Australia",
    lat: -11.40250015258789,
    lng: 130.4219970703125,
  },
  {
    id: "N",
    name: "Stade Airport",
    city: "Stade",
    country: "Germany",
    lat: 53.56111145019531,
    lng: 9.499167442321777,
  },
  {
    id: "N",
    name: "Meriden Markham Municipal Airport",
    city: "Meriden",
    country: "United States",
    lat: 41.50870132446289,
    lng: -72.82949829101562,
  },
  {
    id: "N",
    name: "Flinders Island Airport",
    city: "Elliston",
    country: "Australia",
    lat: -33.730989,
    lng: 134.501,
  },
  {
    id: "N",
    name: "Luzern-Beromunster Airport",
    city: "Lucerne",
    country: "Switzerland",
    lat: 47.189998626708984,
    lng: 8.204719543457031,
  },
  {
    id: "N",
    name: "La Grand'combe Airport",
    city: "La Grand'Combe",
    country: "France",
    lat: 44.24440002441406,
    lng: 4.0122199058532715,
  },
  {
    id: "DOH",
    name: "Hamad International Airport",
    city: "Doha",
    country: "Qatar",
    lat: 25.273056,
    lng: 51.608056,
  },
  {
    id: "HZP",
    name: "Fort Mackay / Horizon Airport",
    city: "Wood Buffalo",
    country: "Canada",
    lat: 57.3816986084,
    lng: -111.700996399,
  },
  {
    id: "N",
    name: "Canmore Municipal Heliport",
    city: "Canmore",
    country: "Canada",
    lat: 51.07780075069999,
    lng: -115.337997437,
  },
  {
    id: "N",
    name: "Krasnokamensk Airport",
    city: "Krasnokamensk",
    country: "Russia",
    lat: 50.03310775756836,
    lng: 118.06114196777344,
  },
  {
    id: "N",
    name: "Ridgely Airpark",
    city: "Ridgely",
    country: "United States",
    lat: 38.97010040283203,
    lng: -75.86630249023438,
  },
  {
    id: "N",
    name: "New Castle Henry Co. Municipal Airport",
    city: "New Castle",
    country: "United States",
    lat: 39.87590027,
    lng: -85.32649994,
  },
  {
    id: "N",
    name: "Scott City Municipal Airport",
    city: "Scott City",
    country: "United States",
    lat: 38.474300384521484,
    lng: -100.88500213623047,
  },
  {
    id: "HDE",
    name: "Brewster Field",
    city: "Holdredge",
    country: "United States",
    lat: 40.452099,
    lng: -99.336502,
  },
  {
    id: "PTT",
    name: "Pratt Regional Airport",
    city: "Pratt",
    country: "United States",
    lat: 37.70159912,
    lng: -98.74690247,
  },
  {
    id: "N",
    name: "Yubileyniy Airfield",
    city: "Baikonur",
    country: "Kazakhstan",
    lat: 46.05500030517578,
    lng: 63.25,
  },
  {
    id: "N",
    name: "Wahoo Municipal Airport",
    city: "Wahoo",
    country: "United States",
    lat: 41.2412986755,
    lng: -96.59400177,
  },
  {
    id: "LXN",
    name: "Jim Kelly Field",
    city: "Lexington",
    country: "United States",
    lat: 40.791000366199995,
    lng: -99.7772979736,
  },
  {
    id: "N",
    name: "Sublette Municipal Airport",
    city: "Sublette",
    country: "United States",
    lat: 37.49140167,
    lng: -100.8300018,
  },
  {
    id: "CBF",
    name: "Council Bluffs Municipal Airport",
    city: "Council Bluffs",
    country: "United States",
    lat: 41.2592010498,
    lng: -95.760597229,
  },
  {
    id: "OKK",
    name: "Kokomo Municipal Airport",
    city: "Kokomo",
    country: "United States",
    lat: 40.528198242188,
    lng: -86.05899810791,
  },
  {
    id: "N",
    name: "Neodesha Municipal Airport",
    city: "Neodesha",
    country: "United States",
    lat: 37.43539810180664,
    lng: -95.64610290527344,
  },
  {
    id: "N",
    name: "King Ranch Airport",
    city: "Sutton",
    country: "United States",
    lat: 61.79560089111328,
    lng: -148.35499572753906,
  },
  {
    id: "N",
    name: "Elkhart Morton County Airport",
    city: "Elkhart",
    country: "United States",
    lat: 37.000702,
    lng: -101.879997,
  },
  {
    id: "N",
    name: "Front Range Airport",
    city: "Denver",
    country: "United States",
    lat: 39.785301208496094,
    lng: -104.54299926757812,
  },
  {
    id: "GBG",
    name: "Galesburg Municipal Airport",
    city: "Galesburg",
    country: "United States",
    lat: 40.937999725299996,
    lng: -90.431098938,
  },
  {
    id: "GUY",
    name: "Guymon Municipal Airport",
    city: "Guymon",
    country: "United States",
    lat: 36.6851005554,
    lng: -101.508003235,
  },
  {
    id: "N",
    name: "Meade Municipal Airport",
    city: "Meade",
    country: "United States",
    lat: 37.27690124511719,
    lng: -100.35600280761719,
  },
  {
    id: "N",
    name: "Turkey Mountain Estates Airport",
    city: "Shell Knob",
    country: "United States",
    lat: 36.59170150756836,
    lng: -93.66690063476562,
  },
  {
    id: "N",
    name: "Ulysses Airport",
    city: "Ulysses",
    country: "United States",
    lat: 37.60400009,
    lng: -101.3740005,
  },
  {
    id: "N",
    name: "Flagler Aerial Spraying Inc Airport",
    city: "Flagler",
    country: "United States",
    lat: 39.279998779296875,
    lng: -103.06700134277344,
  },
  {
    id: "IDP",
    name: "Independence Municipal Airport",
    city: "Independence",
    country: "United States",
    lat: 37.1584014893,
    lng: -95.77839660640001,
  },
  {
    id: "N",
    name: "Augusta Municipal Airport",
    city: "Augusta",
    country: "United States",
    lat: 37.671600341796875,
    lng: -97.0779037475586,
  },
  {
    id: "N",
    name: "Larned Pawnee County Airport",
    city: "Larned",
    country: "United States",
    lat: 38.20859909,
    lng: -99.08599854,
  },
  {
    id: "N",
    name: "Lampasas Airport",
    city: "Lampasas",
    country: "United States",
    lat: 31.106199264526367,
    lng: -98.1958999633789,
  },
  {
    id: "BBC",
    name: "Bay City Municipal Airport",
    city: "Bay City",
    country: "United States",
    lat: 28.9733009338,
    lng: -95.8635025024,
  },
  {
    id: "PRX",
    name: "Cox Field",
    city: "Paris",
    country: "United States",
    lat: 33.636600494385,
    lng: -95.450798034668,
  },
  {
    id: "CFV",
    name: "Coffeyville Municipal Airport",
    city: "Coffeyville",
    country: "United States",
    lat: 37.09400177,
    lng: -95.5718994141,
  },
  {
    id: "N",
    name: "The Farm Airport",
    city: "Summit",
    country: "United States",
    lat: 33.93579864501953,
    lng: -81.42970275878906,
  },
  {
    id: "GXY",
    name: "Greeley–Weld County Airport",
    city: "Greeley",
    country: "United States",
    lat: 40.4374008179,
    lng: -104.633003235,
  },
  {
    id: "N",
    name: "General Dewitt Spain Airport",
    city: "Memphis",
    country: "United States",
    lat: 35.20069885,
    lng: -90.05400085,
  },
  {
    id: "OEL",
    name: "Oryol Yuzhny Airport",
    city: "Oakley",
    country: "United States",
    lat: 52.934700012200004,
    lng: 36.0022010803,
  },
  {
    id: "FET",
    name: "Fremont Municipal Airport",
    city: "Fremont",
    country: "United States",
    lat: 41.44910049,
    lng: -96.52020264,
  },
  {
    id: "LGD",
    name: "La Grande/Union County Airport",
    city: "La Grande",
    country: "United States",
    lat: 45.2901992798,
    lng: -118.007003784,
  },
  {
    id: "SZY",
    name: "Olsztyn-Mazury Airport",
    city: "Szczytno-Szymany",
    country: "Poland",
    lat: 53.481899,
    lng: 20.9377,
  },
  {
    id: "MPO",
    name: "Pocono Mountains Municipal Airport",
    city: "Mount Pocono",
    country: "United States",
    lat: 41.137503,
    lng: -75.378897,
  },
  {
    id: "UKT",
    name: "Quakertown Airport",
    city: "Quakertown",
    country: "United States",
    lat: 40.435199737549,
    lng: -75.381896972656,
  },
  {
    id: "YBA",
    name: "Banff Airport",
    city: "Banff",
    country: "Canada",
    lat: 51.207340469900004,
    lng: -115.541861057,
  },
  {
    id: "N",
    name: "Nordborg Flyveplads",
    city: "Nordborg",
    country: "Denmark",
    lat: 55.07485,
    lng: 9.753379,
  },
  {
    id: "BNG",
    name: "Banning Municipal Airport",
    city: "Banning",
    country: "United States",
    lat: 33.9230995178,
    lng: -116.850997925,
  },
  {
    id: "N",
    name: "Gießen-Lützellinden Airport",
    city: "Giessen",
    country: "Germany",
    lat: 50.543888092041016,
    lng: 8.590277671813965,
  },
  {
    id: "N",
    name: "Tököl Airport",
    city: "Budapest",
    country: "Hungary",
    lat: 47.345298767100005,
    lng: 18.980800628699996,
  },
  {
    id: "OFK",
    name: "Karl Stefan Memorial Airport",
    city: "Norfolk  Nebraska",
    country: "United States",
    lat: 41.985500335693,
    lng: -97.435096740723,
  },
  {
    id: "N",
    name: "Kotido Airport",
    city: "Kotido",
    country: "Uganda",
    lat: 2.953,
    lng: 34.1232,
  },
  {
    id: "N",
    name: "Kajjansi Airfield",
    city: "Kampala",
    country: "Uganda",
    lat: 0.1968,
    lng: 32.55297,
  },
  {
    id: "N",
    name: "Arlington Municipal Airport",
    city: "Arlington",
    country: "United States",
    lat: 48.16070175,
    lng: -122.1589966,
  },
  {
    id: "N",
    name: "Paracatu Airport",
    city: "Paracatu",
    country: "Brazil",
    lat: -17.242599487304688,
    lng: -46.88309860229492,
  },
  {
    id: "N",
    name: "Das Bandeirinhas Airport",
    city: "Conselheiro Lafaiete",
    country: "Brazil",
    lat: -20.738585,
    lng: -43.797444,
  },
  {
    id: "N",
    name: "Janaúba Airport",
    city: "Janauba",
    country: "Brazil",
    lat: -15.732,
    lng: -43.323102,
  },
  {
    id: "TFL",
    name: "Juscelino Kubitscheck Airport",
    city: "Teofilo Otoni",
    country: "Brazil",
    lat: -17.89229965209961,
    lng: -41.51359939575195,
  },
  {
    id: "N",
    name: "Cristiano Ferreira Varella Airport",
    city: "Muriae",
    country: "Brazil",
    lat: -21.126100540161133,
    lng: -42.39440155029297,
  },
  {
    id: "TPF",
    name: "Peter O Knight Airport",
    city: "Tampa",
    country: "United States",
    lat: 27.915599822998,
    lng: -82.44930267334,
  },
  {
    id: "N",
    name: "Lure Malbouhans Air Base",
    city: "Malbouhans",
    country: "France",
    lat: 47.7047,
    lng: 6.54583,
  },
  {
    id: "N",
    name: "Parati Airport",
    city: "Paraty",
    country: "Brazil",
    lat: -23.2243995667,
    lng: -44.720298767100005,
  },
  {
    id: "BZC",
    name: "Umberto Modiano Airport",
    city: "Buzios",
    country: "Brazil",
    lat: -22.770999908447266,
    lng: -41.96289825439453,
  },
  {
    id: "N",
    name: "Angra dos Reis Airport",
    city: "Angra dos Reis",
    country: "Brazil",
    lat: -22.975299835205078,
    lng: -44.307098388671875,
  },
  {
    id: "ITP",
    name: "Itaperuna Airport",
    city: "Itaperuna",
    country: "Brazil",
    lat: -21.219299316399997,
    lng: -41.8759002686,
  },
  {
    id: "N",
    name: "Maricá Airport",
    city: "Marica",
    country: "Brazil",
    lat: -22.9195,
    lng: -42.830898,
  },
  {
    id: "REZ",
    name: "Resende Airport",
    city: "Resende",
    country: "Brazil",
    lat: -22.4785003662,
    lng: -44.4803009033,
  },
  {
    id: "N",
    name: "Saquarema Airport",
    city: "Saquarema",
    country: "Brazil",
    lat: -22.92972183227539,
    lng: -42.50694274902344,
  },
  {
    id: "N",
    name: "Drumheller Municipal Airport",
    city: "Drumheller",
    country: "Canada",
    lat: 51.49639892578125,
    lng: -112.7490005493164,
  },
  {
    id: "N",
    name: "Mwene-Ditu Airport",
    city: "Mwene-Ditu",
    country: "Congo (Kinshasa)",
    lat: -6.982999801635742,
    lng: 23.08300018310547,
  },
  {
    id: "KBN",
    name: "Tunta Airport",
    city: "Kabinda",
    country: "Congo (Kinshasa)",
    lat: -6.132999897,
    lng: 24.4829998016,
  },
  {
    id: "IKL",
    name: "Ikela Airport",
    city: "Ikela",
    country: "Congo (Kinshasa)",
    lat: -1.048109,
    lng: 23.372501,
  },
  {
    id: "AIR",
    name: "Aripuanã Airport",
    city: "Aripuana",
    country: "Brazil",
    lat: -10.188278,
    lng: -59.457273,
  },
  {
    id: "JRN",
    name: "Juruena Airport",
    city: "Juruena",
    country: "Brazil",
    lat: -10.305832862854004,
    lng: -58.489444732666016,
  },
  {
    id: "JIA",
    name: "Juína Airport",
    city: "Juina",
    country: "Brazil",
    lat: -11.419444,
    lng: -58.701668,
  },
  {
    id: "VLP",
    name: "Vila Rica Airport",
    city: "Vila Rica",
    country: "Brazil",
    lat: -9.979443550109863,
    lng: -51.1422233581543,
  },
  {
    id: "JUA",
    name: "Inácio Luís do Nascimento Airport",
    city: "Juara",
    country: "Brazil",
    lat: -11.2966,
    lng: -57.5495,
  },
  {
    id: "CCX",
    name: "Cáceres Airport",
    city: "Caceres",
    country: "Brazil",
    lat: -16.04360008239746,
    lng: -57.62990188598633,
  },
  {
    id: "N",
    name: "Posto Leonardo Vilas Boas Airport",
    city: "Chapada dos Guimaraes",
    country: "Brazil",
    lat: -12.198332786560059,
    lng: -53.38166809082031,
  },
  {
    id: "TGQ",
    name: "Tangará da Serra Airport",
    city: "Tangara da Serra",
    country: "Brazil",
    lat: -14.661999702500001,
    lng: -57.4435005188,
  },
  {
    id: "CQA",
    name: "Canarana Airport",
    city: "Canarana",
    country: "Brazil",
    lat: -13.574443817138672,
    lng: -52.27055740356445,
  },
  {
    id: "MTG",
    name: "Vila Bela da Santíssima Trindade Airport",
    city: "Vila Bela da Santissima Trindade ",
    country: "Brazil",
    lat: -14.9942,
    lng: -59.9458,
  },
  {
    id: "BMB",
    name: "Bumbar Airport",
    city: "Bumba",
    country: "Congo (Kinshasa)",
    lat: 2.18278,
    lng: 22.481701,
  },
  {
    id: "N",
    name: "Sobral Airport",
    city: "Sobral",
    country: "Brazil",
    lat: -3.67889,
    lng: -40.336802,
  },
  {
    id: "APQ",
    name: "Arapiraca Airport",
    city: "Arapiraca",
    country: "Brazil",
    lat: -9.775360107421875,
    lng: -36.62919998168945,
  },
  {
    id: "FLB",
    name: "Cangapara Airport",
    city: "Floriano",
    country: "Brazil",
    lat: -6.8463897705078125,
    lng: -43.077301025390625,
  },
  {
    id: "PCS",
    name: "Picos Airport",
    city: "Picos",
    country: "Brazil",
    lat: -7.0620598793029785,
    lng: -41.52370071411133,
  },
  {
    id: "BNC",
    name: "Beni Airport",
    city: "Beni",
    country: "Congo (Kinshasa)",
    lat: 0.575,
    lng: 29.4739,
  },
  {
    id: "BNB",
    name: "Boende Airport",
    city: "Boende",
    country: "Congo (Kinshasa)",
    lat: -0.21699999272823334,
    lng: 20.850000381469727,
  },
  {
    id: "MTP",
    name: "Montauk Airport",
    city: "Montauk",
    country: "United States",
    lat: 41.0765,
    lng: -71.920797,
  },
  {
    id: "VPZ",
    name: "Porter County Municipal Airport",
    city: "Valparaiso IN",
    country: "United States",
    lat: 41.45399857,
    lng: -87.00710297,
  },
  {
    id: "DRV",
    name: "Dharavandhoo Airport",
    city: "DHARAVANDHOO",
    country: "Maldives",
    lat: 5.1561,
    lng: 73.1302,
  },
  {
    id: "SXK",
    name: "Saumlaki/Olilit Airport",
    city: "Saumlaki",
    country: "Indonesia",
    lat: -7.9886097908,
    lng: 131.305999756,
  },
  {
    id: "MLZ",
    name: "Cerro Largo International Airport",
    city: "Melo",
    country: "Uruguay",
    lat: -32.33789825439453,
    lng: -54.21670150756836,
  },
  {
    id: "PDU",
    name: "Tydeo Larre Borges Airport",
    city: "Paysandu",
    country: "Uruguay",
    lat: -32.36330032348633,
    lng: -58.0619010925293,
  },
  {
    id: "ATI",
    name: "Artigas International Airport",
    city: "Artigas ",
    country: "Uruguay",
    lat: -30.400699615478516,
    lng: -56.50790023803711,
  },
  {
    id: "N",
    name: "Murray Bridge Airport",
    city: "Murray Bridge",
    country: "Australia",
    lat: -35.06669998168945,
    lng: 139.2270050048828,
  },
  {
    id: "HSM",
    name: "Horsham Airport",
    city: "Horsham",
    country: "Australia",
    lat: -36.669700622558594,
    lng: 142.17300415039062,
  },
  {
    id: "SWH",
    name: "Swan Hill Airport",
    city: "Swan Hill",
    country: "Australia",
    lat: -35.37580108642578,
    lng: 143.5330047607422,
  },
  {
    id: "TTL",
    name: "Turtle Island Seaplane Base",
    city: "Turtle Island",
    country: "Fiji",
    lat: -16.966,
    lng: 177.368,
  },
  {
    id: "KWB",
    name: "Dewadaru - Kemujan Island",
    city: "Karimunjawa",
    country: "Indonesia",
    lat: -5.80091,
    lng: 110.47838,
  },
  {
    id: "KOO",
    name: "Kongolo Airport",
    city: "Kongolo",
    country: "Congo (Kinshasa)",
    lat: -5.39444,
    lng: 26.99,
  },
  {
    id: "AOU",
    name: "Attopeu Airport",
    city: "Attopeu",
    country: "Laos",
    lat: 14.814715357,
    lng: 106.821699142,
  },
  {
    id: "N",
    name: "Kahemba Airport",
    city: "Kahemba",
    country: "Congo (Kinshasa)",
    lat: -7.333000183105469,
    lng: 19.017000198364258,
  },
  {
    id: "N",
    name: "Francisco de Miranda Airport",
    city: "Caracas",
    country: "Venezuela",
    lat: 10.485033035299999,
    lng: -66.8435134888,
  },
  {
    id: "SQX",
    name: "São Miguel do Oeste Airport",
    city: "Sao Miguel do Oeste",
    country: "Brazil",
    lat: -26.781600952148438,
    lng: -53.503501892089844,
  },
  {
    id: "LDM",
    name: "Mason County Airport",
    city: "Ludington",
    country: "United States",
    lat: 43.96250153,
    lng: -86.40789795,
  },
  {
    id: "RHV",
    name: "Reid-Hillview Airport of Santa Clara County",
    city: "San Jose",
    country: "United States",
    lat: 37.332901001,
    lng: -121.819000244,
  },
  {
    id: "OHS",
    name: "Sohar Airport",
    city: "Sohar",
    country: "Oman",
    lat: 24.38604,
    lng: 56.62541,
  },
  {
    id: "KCF",
    name: "Kadanwari Airport",
    city: "Kadanwari",
    country: "Pakistan",
    lat: 27.1667003632,
    lng: 69.31670379639999,
  },
  {
    id: "RZS",
    name: "Sawan Airport",
    city: "Sindh",
    country: "Pakistan",
    lat: 26.9662,
    lng: 68.878098,
  },
  {
    id: "N",
    name: "Thamkharka Airport",
    city: "Thamkharka",
    country: "Nepal",
    lat: 27.04787,
    lng: 86.858022,
  },
  {
    id: "TMF",
    name: "Thimarafushi Airport",
    city: "Thimarafushi",
    country: "Maldives",
    lat: 2.211,
    lng: 73.1533,
  },
  {
    id: "IFU",
    name: "Ifuru Airport",
    city: "Ifuru",
    country: "Maldives",
    lat: 5.7083,
    lng: 73.025,
  },
  {
    id: "KZF",
    name: "Kaintiba Airport",
    city: "Kieta",
    country: "Papua New Guinea",
    lat: -7.50025,
    lng: 146.033833333,
  },
  {
    id: "OGU",
    name: "Ordu Giresun Airport",
    city: "Ordu-Giresun",
    country: "Turkey",
    lat: 40.966047,
    lng: 38.080994,
  },
  {
    id: "YKO",
    name: "Hakkari Yüksekova Airport",
    city: "Hakkari",
    country: "Turkey",
    lat: 37.5497,
    lng: 44.2381,
  },
  {
    id: "N",
    name: "Jelenia Góra Glider Airport",
    city: "Jelenia Gora",
    country: "Poland",
    lat: 50.89889907836914,
    lng: 15.785599708557129,
  },
  {
    id: "BUT",
    name: "Bathpalathang Airport",
    city: "Jakar",
    country: "Bhutan",
    lat: 27.5622,
    lng: 90.7471,
  },
  {
    id: "TLI",
    name: "Sultan Bantilan Airport",
    city: "Toli-Toli",
    country: "Indonesia",
    lat: 1.123428,
    lng: 120.793658,
  },
  {
    id: "N",
    name: "Vuktyl Airport",
    city: "Vuktyl",
    country: "Russia",
    lat: 63.823299407958984,
    lng: 57.279998779296875,
  },
  {
    id: "N",
    name: "Berezniki Airport",
    city: "Berezniki",
    country: "Russia",
    lat: 59.57954788208008,
    lng: 56.85768127441406,
  },
  {
    id: "N",
    name: "San Sebastián Airport",
    city: "San Sebastian",
    country: "Chile",
    lat: -53.31700134277344,
    lng: -68.6500015258789,
  },
  {
    id: "N",
    name: "Tolwin Observatory Airport",
    city: "Tolhuin",
    country: "Argentina",
    lat: -54.521900177,
    lng: -67.1989974976,
  },
  {
    id: "TQL",
    name: "Tarko-Sale Airport",
    city: "Tarko-Sale",
    country: "Russia",
    lat: 64.9308013916,
    lng: 77.81809997559999,
  },
  {
    id: "N",
    name: "Camarillo Airport",
    city: "Camarillo - CA",
    country: "United States",
    lat: 34.21369934082031,
    lng: -119.09400177001953,
  },
  {
    id: "N",
    name: "Leopoldsburg Airfield",
    city: "Leopoldsburg",
    country: "Belgium",
    lat: 51.12,
    lng: 5.3072222,
  },
  {
    id: "JIC",
    name: "Jinchuan Airport",
    city: "Jinchuan",
    country: "China",
    lat: 38.542222222199996,
    lng: 102.348333333,
  },
  {
    id: "N",
    name: "Omtepe Airport",
    city: "Moyogalpa",
    country: "Nicaragua",
    lat: 11.523616,
    lng: -85.702995,
  },
  {
    id: "BPL",
    name: "Alashankou Bole (Bortala) airport",
    city: "Bole",
    country: "China",
    lat: 44.895,
    lng: 82.3,
  },
  {
    id: "FYN",
    name: "Fuyun Koktokay Airport",
    city: "Fuyun",
    country: "China",
    lat: 46.804169,
    lng: 89.512006,
  },
  {
    id: "ACS",
    name: "Achinsk Airport",
    city: "Achinsk",
    country: "Russia",
    lat: 56.2682991027832,
    lng: 90.57080078125,
  },
  {
    id: "LFQ",
    name: "Linfen Qiaoli Airport",
    city: "LINFEN",
    country: "China",
    lat: 36.132629,
    lng: 111.641236,
  },
  {
    id: "YJP",
    name: "Hinton/Jasper-Hinton Airport",
    city: "Hinton",
    country: "Canada",
    lat: 53.3191986084,
    lng: -117.752998352,
  },
  {
    id: "WVI",
    name: "Watsonville Municipal Airport",
    city: "Watsonville",
    country: "United States",
    lat: 36.9356994629,
    lng: -121.790000916,
  },
  {
    id: "GLU",
    name: "Gelephu Airport",
    city: "Gelephu",
    country: "Bhutan",
    lat: 26.88456,
    lng: 90.46412,
  },
  {
    id: "HLI",
    name: "Hollister Municipal Airport",
    city: "Hollister",
    country: "United States",
    lat: 36.8932991028,
    lng: -121.410003662,
  },
  {
    id: "N",
    name: "Williamsburg Jamestown Airport",
    city: "Williamsburg",
    country: "United States",
    lat: 37.239200592041016,
    lng: -76.71610260009766,
  },
  {
    id: "DLK",
    name: "Dulkaninna Airport",
    city: "Dulkaninna",
    country: "Australia",
    lat: -29.0132999420166,
    lng: 138.4810028076172,
  },
  {
    id: "N",
    name: "William Creek Airport",
    city: "William Creek",
    country: "Australia",
    lat: -28.906700134277344,
    lng: 136.3419952392578,
  },
  {
    id: "N",
    name: "Kenora Seaplane Base",
    city: "Kenora",
    country: "Canada",
    lat: 49.767424,
    lng: -94.49274,
  },
  {
    id: "N",
    name: "Rumbula Air Base",
    city: "Riga",
    country: "Latvia",
    lat: 56.8833007812,
    lng: 24.2266998291,
  },
  {
    id: "N",
    name: "Siquijor Airport",
    city: "Siquijor",
    country: "Philippines",
    lat: 9.214203223190001,
    lng: 123.472251892,
  },
  {
    id: "YBS",
    name: "Opapimiskan Lake Airport",
    city: "Musselwhite Mine",
    country: "Canada",
    lat: 52.6067008972,
    lng: -90.3768997192,
  },
  {
    id: "RIZ",
    name: "Rizhao Shanzihe Airport",
    city: "Rizhao",
    country: "China",
    lat: 35.405033,
    lng: 119.324403,
  },
  {
    id: "SQJ",
    name: "Shaxian Airport",
    city: "Sanming",
    country: "China",
    lat: 26.4263,
    lng: 117.8336,
  },
  {
    id: "XTO",
    name: "Taroom Airport",
    city: "Taroom",
    country: "Australia",
    lat: -25.801700592041016,
    lng: 149.89999389648438,
  },
  {
    id: "N",
    name: "Gelnhausen Airport",
    city: "Gelnhausen",
    country: "Germany",
    lat: 50.19722366333008,
    lng: 9.170000076293945,
  },
  {
    id: "N",
    name: "Ærø Airport",
    city: "Aero",
    country: "Denmark",
    lat: 54.85279846191406,
    lng: 10.456399917602539,
  },
  {
    id: "N",
    name: "Lauterbach Airport",
    city: "Lauterbach-Wernges",
    country: "Germany",
    lat: 50.683334,
    lng: 9.410833,
  },
  {
    id: "N",
    name: "Aschaffenburg Airport",
    city: "Aschaffenburg",
    country: "Germany",
    lat: 49.93888854980469,
    lng: 9.063888549804688,
  },
  {
    id: "YSE",
    name: "Squamish Airport",
    city: "Squamish",
    country: "Canada",
    lat: 49.7817001343,
    lng: -123.162002563,
  },
  {
    id: "N",
    name: "Reichelsheim Airport",
    city: "Reichelsheim",
    country: "Germany",
    lat: 50.33583450317383,
    lng: 8.878055572509766,
  },
  {
    id: "N",
    name: "Marburg-Schönstadt Airport",
    city: "Schoenstadt",
    country: "Germany",
    lat: 50.87444305419922,
    lng: 8.8149995803833,
  },
  {
    id: "N",
    name: "Lauenbrück Airport",
    city: "Lauenbrueck",
    country: "Germany",
    lat: 53.20750045776367,
    lng: 9.573332786560059,
  },
  {
    id: "N",
    name: "Hüttenbusch Airport",
    city: "Huettenbusch",
    country: "Germany",
    lat: 53.28666687011719,
    lng: 8.947221755981445,
  },
  {
    id: "N",
    name: "Vrsar Crljenka Airport",
    city: "Vsar",
    country: "Croatia",
    lat: 45.141700744628906,
    lng: 13.630599975585938,
  },
  {
    id: "N",
    name: "Union County Airport",
    city: "Marysville",
    country: "United States",
    lat: 40.224700927734375,
    lng: -83.35160064697266,
  },
  {
    id: "YAH",
    name: "La Grande-4 Airport",
    city: "La Grande-4",
    country: "Canada",
    lat: 53.754699707,
    lng: -73.6753005981,
  },
  {
    id: "YAL",
    name: "Alert Bay Airport",
    city: "Alert Bay",
    country: "Canada",
    lat: 50.58219909667969,
    lng: -126.91600036621094,
  },
  {
    id: "N",
    name: "Liverpool South Shore Regional Airport",
    city: "Liverpool",
    country: "Canada",
    lat: 44.2303009033,
    lng: -64.85610198970001,
  },
  {
    id: "N",
    name: "Nipawin Airport",
    city: "Nipawin",
    country: "Canada",
    lat: 53.33250045776367,
    lng: -104.00800323486328,
  },
  {
    id: "YCE",
    name: "Centralia / James T. Field Memorial Aerodrome",
    city: "Centralia",
    country: "Canada",
    lat: 43.285599,
    lng: -81.508301,
  },
  {
    id: "N",
    name: "Blue River Airport",
    city: "Blue River",
    country: "Canada",
    lat: 52.11669921875,
    lng: -119.28299713134766,
  },
  {
    id: "YCQ",
    name: "Chetwynd Airport",
    city: "Chetwynd",
    country: "Canada",
    lat: 55.687198638916016,
    lng: -121.62699890136719,
  },
  {
    id: "XRR",
    name: "Ross River Airport",
    city: "Ross River",
    country: "Canada",
    lat: 61.9706001282,
    lng: -132.42300415,
  },
  {
    id: "YDO",
    name: "Dolbeau St Felicien Airport",
    city: "Dolbeau-St-Félicien",
    country: "Canada",
    lat: 48.778499603271,
    lng: -72.375,
  },
  {
    id: "YEY",
    name: "Amos/Magny Airport",
    city: "Amos",
    country: "Canada",
    lat: 48.563903,
    lng: -78.249702,
  },
  {
    id: "N",
    name: "Goderich Airport",
    city: "Goderich",
    country: "Canada",
    lat: 43.7668991089,
    lng: -81.7106018066,
  },
  {
    id: "YHE",
    name: "Hope Airport",
    city: "Hope",
    country: "Canada",
    lat: 49.3683013916,
    lng: -121.498001099,
  },
  {
    id: "YHT",
    name: "Haines Junction Airport",
    city: "Haines Junction",
    country: "Canada",
    lat: 60.78919982910156,
    lng: -137.54600524902344,
  },
  {
    id: "YDG",
    name: "Digby / Annapolis Regional Airport",
    city: "Digby",
    country: "Canada",
    lat: 44.5458450365,
    lng: -65.7854247093,
  },
  {
    id: "YJF",
    name: "Fort Liard Airport",
    city: "Fort Liard",
    country: "Canada",
    lat: 60.235801696799996,
    lng: -123.46900177,
  },
  {
    id: "YKJ",
    name: "Key Lake Airport",
    city: "Key Lake",
    country: "Canada",
    lat: 57.256099700927734,
    lng: -105.61799621582031,
  },
  {
    id: "YLR",
    name: "Leaf Rapids Airport",
    city: "Leaf Rapids",
    country: "Canada",
    lat: 56.513301849365234,
    lng: -99.98529815673828,
  },
  {
    id: "YME",
    name: "Matane Airport",
    city: "Matane",
    country: "Canada",
    lat: 48.85689926147461,
    lng: -67.45330047607422,
  },
  {
    id: "YML",
    name: "Charlevoix Airport",
    city: "Charlevoix",
    country: "Canada",
    lat: 47.59749984741211,
    lng: -70.2238998413086,
  },
  {
    id: "N",
    name: "Nejanilini Lake Airport",
    city: "Nejanilini Lake",
    country: "Canada",
    lat: 59.4874992371,
    lng: -97.78029632570001,
  },
  {
    id: "YOS",
    name: "Owen Sound / Billy Bishop Regional Airport",
    city: "Owen Sound",
    country: "Canada",
    lat: 44.5903015137,
    lng: -80.8375015259,
  },
  {
    id: "YPS",
    name: "Port Hawkesbury Airport",
    city: "Port Hawkesbury",
    country: "Canada",
    lat: 45.6567001343,
    lng: -61.3680992126,
  },
  {
    id: "YQS",
    name: "St Thomas Municipal Airport",
    city: "St Thomas",
    country: "Canada",
    lat: 42.77000045776367,
    lng: -81.11080169677734,
  },
  {
    id: "YRO",
    name: "Ottawa / Rockcliffe Airport",
    city: "Ottawa",
    country: "Canada",
    lat: 45.4603004456,
    lng: -75.64610290530001,
  },
  {
    id: "N",
    name: "Ottawa / Carp Airport",
    city: "Ottawa",
    country: "Canada",
    lat: 45.3191986084,
    lng: -76.0222015381,
  },
  {
    id: "YSH",
    name: "Smiths Falls-Montague (Russ Beach) Airport",
    city: "Smiths Falls",
    country: "Canada",
    lat: 44.94580078125,
    lng: -75.94059753417969,
  },
  {
    id: "YSL",
    name: "St Leonard Airport",
    city: "St Leonard",
    country: "Canada",
    lat: 47.157501220703125,
    lng: -67.83470153808594,
  },
  {
    id: "N",
    name: "Virden/R.J. (Bob) Andrew Field Regional Aerodrome",
    city: "Virden",
    country: "Canada",
    lat: 49.8782997131,
    lng: -100.917999268,
  },
  {
    id: "YVE",
    name: "Vernon Airport",
    city: "Vernon",
    country: "Canada",
    lat: 50.24810028076172,
    lng: -119.33100128173828,
  },
  {
    id: "YXQ",
    name: "Beaver Creek Airport",
    city: "Beaver Creek",
    country: "Canada",
    lat: 62.410301208496094,
    lng: -140.86700439453125,
  },
  {
    id: "YSN",
    name: "Shuswap Regional Airport",
    city: "Salmon Arm",
    country: "Canada",
    lat: 50.682802,
    lng: -119.228996,
  },
  {
    id: "KES",
    name: "Kelsey Airport",
    city: "Kelsey",
    country: "Canada",
    lat: 56.0374984741,
    lng: -96.50969696039999,
  },
  {
    id: "XPK",
    name: "Pukatawagan Airport",
    city: "Pukatawagan",
    country: "Canada",
    lat: 55.7491989136,
    lng: -101.26599884,
  },
  {
    id: "ZGF",
    name: "Grand Forks Airport",
    city: "Grand Forks",
    country: "Canada",
    lat: 49.01559829711914,
    lng: -118.43099975585938,
  },
  {
    id: "ZJG",
    name: "Jenpeg Airport",
    city: "Jenpeg",
    country: "Canada",
    lat: 54.51890182495117,
    lng: -98.04609680175781,
  },
  {
    id: "YTD",
    name: "Thicket Portage Airport",
    city: "Thicket Portage",
    country: "Canada",
    lat: 55.31890106201172,
    lng: -97.70780181884766,
  },
  {
    id: "PIW",
    name: "Pikwitonei Airport",
    city: "Pikwitonei",
    country: "Canada",
    lat: 55.58890151977539,
    lng: -97.16419982910156,
  },
  {
    id: "XPP",
    name: "Poplar River Airport",
    city: "Poplar River",
    country: "Canada",
    lat: 52.9965258788,
    lng: -97.2741937637,
  },
  {
    id: "WPC",
    name: "Pincher Creek Airport",
    city: "Pincher Creek",
    country: "Canada",
    lat: 49.520599365200006,
    lng: -113.997001648,
  },
  {
    id: "ZST",
    name: "Stewart Airport",
    city: "Stewart",
    country: "Canada",
    lat: 55.935410448,
    lng: -129.982434511,
  },
  {
    id: "ZUC",
    name: "Ignace Municipal Airport",
    city: "Ignace",
    country: "Canada",
    lat: 49.4296989440918,
    lng: -91.7177963256836,
  },
  {
    id: "FNB",
    name: "Neubrandenburg Airport",
    city: "Neubrandenburg",
    country: "Germany",
    lat: 53.6022,
    lng: 13.306,
  },
  {
    id: "N",
    name: "Airport Bamberg-Breitenau",
    city: "Bamberg",
    country: "Germany",
    lat: 49.920403,
    lng: 10.914233,
  },
  {
    id: "N",
    name: "Zerbst Airport",
    city: "Zerbst/Anhalt",
    country: "Germany",
    lat: 52.000832,
    lng: 12.148611,
  },
  {
    id: "N",
    name: "RAF Spadeadam",
    city: "Spadeadam",
    country: "United Kingdom",
    lat: 55.0499992371,
    lng: -2.54999995232,
  },
  {
    id: "FSS",
    name: "RAF Kinloss",
    city: "Kinloss",
    country: "United Kingdom",
    lat: 57.6493988037,
    lng: -3.56064009666,
  },
  {
    id: "BXP",
    name: "Biała Podlaska Airfield",
    city: "Biała Podlaska",
    country: "Poland",
    lat: 52.00078,
    lng: 23.1325278,
  },
  {
    id: "N",
    name: "Cewice Air Base",
    city: "Lębork",
    country: "Poland",
    lat: 54.416,
    lng: 17.7633,
  },
  {
    id: "N",
    name: "Deblin Military Air Base",
    city: "Dęblin",
    country: "Poland",
    lat: 51.551399231,
    lng: 21.8936004639,
  },
  {
    id: "N",
    name: "Leczyca Military Air Base",
    city: "Leczyca",
    country: "Poland",
    lat: 52.004699707,
    lng: 19.1455993652,
  },
  {
    id: "N",
    name: "Minsk Mazowiecki Military Air Base",
    city: "",
    country: "Poland",
    lat: 52.1954994202,
    lng: 21.6558990479,
  },
  {
    id: "N",
    name: "Powidz Military Air Base",
    city: "",
    country: "Poland",
    lat: 52.379398,
    lng: 17.853901,
  },
  {
    id: "N",
    name: "Tomaszow Mazowiecki Military Air Base",
    city: "Tomaszów Mazowiecki",
    country: "Poland",
    lat: 51.584400177,
    lng: 20.0977993011,
  },
  {
    id: "N",
    name: "Björkvik Air Base",
    city: "Björkvik",
    country: "Sweden",
    lat: 58.79079818725586,
    lng: 16.571199417114258,
  },
  {
    id: "N",
    name: "Ljungbyhed Airport",
    city: "Ljungbyhed",
    country: "Sweden",
    lat: 56.082801818847656,
    lng: 13.212499618530273,
  },
  {
    id: "DGP",
    name: "Daugavpils Intrenational Airport",
    city: "Daugavpils",
    country: "Latvia",
    lat: 55.944721221900004,
    lng: 26.6650009155,
  },
  {
    id: "N",
    name: "Jēkabpils Air Base",
    city: "Jēkabpils",
    country: "Latvia",
    lat: 56.534698,
    lng: 25.8925,
  },
  {
    id: "N",
    name: "Jūrmala Airport",
    city: "Tukums",
    country: "Latvia",
    lat: 56.9422,
    lng: 23.2239,
  },
  {
    id: "N",
    name: "Kėdainiai Air Base",
    city: "Kėdainiai",
    country: "Lithuania",
    lat: 55.31169891357422,
    lng: 23.95639991760254,
  },
  {
    id: "LMR",
    name: "Lime Acres Finsch Mine Airport",
    city: "Lime Acres",
    country: "South Africa",
    lat: -28.36009979248047,
    lng: 23.43910026550293,
  },
  {
    id: "SXN",
    name: "Sua Pan Airport",
    city: "Sowa",
    country: "Botswana",
    lat: -20.5534,
    lng: 26.115801,
  },
  {
    id: "N",
    name: "Lusaka City Airport",
    city: "Lusaka",
    country: "Zambia",
    lat: -15.4138002396,
    lng: 28.3306999207,
  },
  {
    id: "NDD",
    name: "Sumbe Airport",
    city: "Sumbe",
    country: "Angola",
    lat: -11.167900085449219,
    lng: 13.84749984741211,
  },
  {
    id: "MAI",
    name: "Mangochi Airport",
    city: "Mangochi",
    country: "Malawi",
    lat: -14.482999801635742,
    lng: 35.266998291015625,
  },
  {
    id: "ADI",
    name: "Arandis Airport",
    city: "Arandis",
    country: "Namibia",
    lat: -22.462200164794922,
    lng: 14.979999542236328,
  },
  {
    id: "N",
    name: "Mariental Airport",
    city: "Mariental",
    country: "Namibia",
    lat: -24.60540008544922,
    lng: 17.925399780273438,
  },
  {
    id: "N",
    name: "Almaza Air Force Base",
    city: "Cairo",
    country: "Egypt",
    lat: 30.091800689697266,
    lng: 31.360000610351562,
  },
  {
    id: "N",
    name: "Beni Suef Air Base",
    city: "Beni Suef",
    country: "Egypt",
    lat: 29.20829963684082,
    lng: 31.016599655151367,
  },
  {
    id: "N",
    name: "Jiyanklis Air Base",
    city: "Jiyanklis",
    country: "Egypt",
    lat: 30.819799423217773,
    lng: 30.191200256347656,
  },
  {
    id: "MWE",
    name: "Merowe New Airport",
    city: "Merowe",
    country: "Sudan",
    lat: 18.4433333333,
    lng: 31.8433333333,
  },
  {
    id: "ALN",
    name: "St Louis Regional Airport",
    city: "Alton/St Louis",
    country: "United States",
    lat: 38.89030075069999,
    lng: -90.0459976196,
  },
  {
    id: "AXN",
    name: "Chandler Field",
    city: "Alexandria",
    country: "United States",
    lat: 45.8662986755,
    lng: -95.39469909670001,
  },
  {
    id: "CLU",
    name: "Columbus Municipal Airport",
    city: "Columbus",
    country: "United States",
    lat: 39.2619018555,
    lng: -85.8963012695,
  },
  {
    id: "BBD",
    name: "Curtis Field",
    city: "Brady",
    country: "United States",
    lat: 31.1793003082,
    lng: -99.3238983154,
  },
  {
    id: "BIH",
    name: "Eastern Sierra Regional Airport",
    city: "Bishop",
    country: "United States",
    lat: 37.3731002808,
    lng: -118.363998413,
  },
  {
    id: "BKE",
    name: "Baker City Municipal Airport",
    city: "Baker City",
    country: "United States",
    lat: 44.837299346900004,
    lng: -117.808998108,
  },
  {
    id: "BPI",
    name: "Miley Memorial Field",
    city: "Big Piney",
    country: "United States",
    lat: 42.58509827,
    lng: -110.1110001,
  },
  {
    id: "WMH",
    name: "Ozark Regional Airport",
    city: "Mountain Home",
    country: "United States",
    lat: 36.3689002991,
    lng: -92.47049713130001,
  },
  {
    id: "BTL",
    name: "W K Kellogg Airport",
    city: "Battle Creek",
    country: "United States",
    lat: 42.307300567599995,
    lng: -85.2515029907,
  },
  {
    id: "BYI",
    name: "Burley Municipal Airport",
    city: "Burley",
    country: "United States",
    lat: 42.542598724399994,
    lng: -113.772003174,
  },
  {
    id: "CCY",
    name: "Northeast Iowa Regional Airport",
    city: "Charles City",
    country: "United States",
    lat: 43.0726013184,
    lng: -92.6108016968,
  },
  {
    id: "CNU",
    name: "Chanute Martin Johnson Airport",
    city: "Chanute",
    country: "United States",
    lat: 37.668800354,
    lng: -95.4850997925,
  },
  {
    id: "CRG",
    name: "Jacksonville Executive at Craig Airport",
    city: "Jacksonville",
    country: "United States",
    lat: 30.3362998962,
    lng: -81.51439666750001,
  },
  {
    id: "CSV",
    name: "Crossville Memorial Whitson Field",
    city: "Crossville",
    country: "United States",
    lat: 35.9513015747,
    lng: -85.08499908450001,
  },
  {
    id: "DAA",
    name: "Davison Army Air Field",
    city: "Fort Belvoir",
    country: "United States",
    lat: 38.715000152600005,
    lng: -77.1809997559,
  },
  {
    id: "DAG",
    name: "Barstow Daggett Airport",
    city: "Daggett",
    country: "United States",
    lat: 34.85369873,
    lng: -116.7870026,
  },
  {
    id: "DMN",
    name: "Deming Municipal Airport",
    city: "Deming",
    country: "United States",
    lat: 32.262298584,
    lng: -107.721000671,
  },
  {
    id: "DRA",
    name: "Desert Rock Airport",
    city: "Mercury",
    country: "United States",
    lat: 36.6194,
    lng: -116.032997,
  },
  {
    id: "EED",
    name: "Needles Airport",
    city: "Needles",
    country: "United States",
    lat: 34.7663002014,
    lng: -114.623001099,
  },
  {
    id: "EGI",
    name: "Duke Field",
    city: "Crestview",
    country: "United States",
    lat: 30.65040016,
    lng: -86.52290344,
  },
  {
    id: "EKA",
    name: "Murray Field",
    city: "Eureka",
    country: "United States",
    lat: 40.803398132299996,
    lng: -124.112998962,
  },
  {
    id: "N",
    name: "San Marcos Regional Airport",
    city: "San Marcos",
    country: "United States",
    lat: 29.8927,
    lng: -97.862999,
  },
  {
    id: "HYR",
    name: "Sawyer County Airport",
    city: "Hayward",
    country: "United States",
    lat: 46.025199890100005,
    lng: -91.44429779050002,
  },
  {
    id: "JCT",
    name: "Kimble County Airport",
    city: "Junction",
    country: "United States",
    lat: 30.5112991333,
    lng: -99.7634963989,
  },
  {
    id: "N",
    name: "Monticello Municipal Ellis Field",
    city: "Monticello",
    country: "United States",
    lat: 33.6385994,
    lng: -91.75099945,
  },
  {
    id: "LOL",
    name: "Derby Field",
    city: "Lovelock",
    country: "United States",
    lat: 40.0663986206,
    lng: -118.565002441,
  },
  {
    id: "MBG",
    name: "Mobridge Municipal Airport",
    city: "Mobridge",
    country: "United States",
    lat: 45.54650116,
    lng: -100.4079971,
  },
  {
    id: "MCB",
    name: "Mc Comb/Pike County Airport/John E Lewis Field",
    city: "Mc Comb",
    country: "United States",
    lat: 31.17849922,
    lng: -90.47190094,
  },
  {
    id: "MDH",
    name: "Southern Illinois Airport",
    city: "Carbondale/Murphysboro",
    country: "United States",
    lat: 37.778099060058594,
    lng: -89.25199890136719,
  },
  {
    id: "MMT",
    name: "Mc Entire Joint National Guard Base",
    city: "Eastover",
    country: "United States",
    lat: 33.92079926,
    lng: -80.80130005,
  },
  {
    id: "NHZ",
    name: "Brunswick Executive Airport",
    city: "Brunswick",
    country: "United States",
    lat: 43.89220047,
    lng: -69.93859863,
  },
  {
    id: "NRB",
    name: "Naval Station Mayport (Admiral David L. Mcdonald Field)",
    city: "Mayport",
    country: "United States",
    lat: 30.39109993,
    lng: -81.42469788,
  },
  {
    id: "OGB",
    name: "Orangeburg Municipal Airport",
    city: "Orangeburg",
    country: "United States",
    lat: 33.456798553467,
    lng: -80.859497070312,
  },
  {
    id: "N",
    name: "Columbus Municipal Airport",
    city: "Columbus",
    country: "United States",
    lat: 41.44800186,
    lng: -97.34259796,
  },
  {
    id: "OTM",
    name: "Ottumwa Regional Airport",
    city: "Ottumwa",
    country: "United States",
    lat: 41.10660172,
    lng: -92.44789886,
  },
  {
    id: "OZR",
    name: "Cairns AAF (Fort Rucker) Air Field",
    city: "Fort Rucker/Ozark",
    country: "United States",
    lat: 31.27569962,
    lng: -85.71340179,
  },
  {
    id: "PWY",
    name: "Ralph Wenz Field",
    city: "Pinedale",
    country: "United States",
    lat: 42.79550171,
    lng: -109.8069992,
  },
  {
    id: "POU",
    name: "Dutchess County Airport",
    city: "Poughkeepsie",
    country: "United States",
    lat: 41.6265983581543,
    lng: -73.88420104980469,
  },
  {
    id: "N",
    name: "New Richmond Regional Airport",
    city: "New Richmond",
    country: "United States",
    lat: 45.14830017,
    lng: -92.5381012,
  },
  {
    id: "RSL",
    name: "Russell Municipal Airport",
    city: "Russell",
    country: "United States",
    lat: 38.872100830078,
    lng: -98.811798095703,
  },
  {
    id: "RWF",
    name: "Redwood Falls Municipal Airport",
    city: "Redwood Falls",
    country: "United States",
    lat: 44.54719925,
    lng: -95.08229828,
  },
  {
    id: "SNS",
    name: "Salinas Municipal Airport",
    city: "Salinas",
    country: "United States",
    lat: 36.662799835205,
    lng: -121.60600280762,
  },
  {
    id: "N",
    name: "Sonora Municipal Airport",
    city: "Sonora",
    country: "United States",
    lat: 30.585699081421,
    lng: -100.6490020752,
  },
  {
    id: "N",
    name: "Saline County Regional Airport",
    city: "Benton",
    country: "United States",
    lat: 34.59059906,
    lng: -92.47940063,
  },
  {
    id: "TPH",
    name: "Tonopah Airport",
    city: "Tonopah",
    country: "United States",
    lat: 38.06019974,
    lng: -117.086998,
  },
  {
    id: "N",
    name: "Aurora State Airport",
    city: "Aurora",
    country: "United States",
    lat: 45.247100830078125,
    lng: -122.7699966430664,
  },
  {
    id: "UKI",
    name: "Ukiah Municipal Airport",
    city: "Ukiah",
    country: "United States",
    lat: 39.125999450684,
    lng: -123.20099639893,
  },
  {
    id: "UOX",
    name: "University Oxford Airport",
    city: "Oxford",
    country: "United States",
    lat: 34.384300231934,
    lng: -89.536796569824,
  },
  {
    id: "HTV",
    name: "Huntsville Regional Airport",
    city: "Huntsville",
    country: "United States",
    lat: 30.7469005585,
    lng: -95.5871963501,
  },
  {
    id: "VTN",
    name: "Miller Field",
    city: "Valentine",
    country: "United States",
    lat: 42.85779953,
    lng: -100.5479965,
  },
  {
    id: "WMC",
    name: "Winnemucca Municipal Airport",
    city: "Winnemucca",
    country: "United States",
    lat: 40.8965988159,
    lng: -117.805999756,
  },
  {
    id: "WWR",
    name: "West Woodward Airport",
    city: "Woodward",
    country: "United States",
    lat: 36.438,
    lng: -99.5226667,
  },
  {
    id: "N",
    name: "Cape Canaveral AFS Skid Strip",
    city: "Cocoa Beach",
    country: "United States",
    lat: 28.4675998688,
    lng: -80.56659698490002,
  },
  {
    id: "N",
    name: "Homey (Area 51) Airport",
    city: "Groom Lake",
    country: "United States",
    lat: 37.23500061035156,
    lng: -115.81099700927734,
  },
  {
    id: "ZZV",
    name: "Zanesville Municipal Airport",
    city: "Zanesville",
    country: "United States",
    lat: 39.9444007874,
    lng: -81.89209747310001,
  },
  {
    id: "N",
    name: "Gjadër Air Base",
    city: "Gjadër",
    country: "Albania",
    lat: 41.895199,
    lng: 19.5987,
  },
  {
    id: "N",
    name: "Kukës Airport",
    city: "Kukës",
    country: "Albania",
    lat: 42.033699035599994,
    lng: 20.4158992767,
  },
  {
    id: "N",
    name: "Kuçovë Air Base",
    city: "Kuçovë",
    country: "Albania",
    lat: 40.77190017700195,
    lng: 19.901899337768555,
  },
  {
    id: "N",
    name: "Vlorë Air Base",
    city: "Vlorë",
    country: "Albania",
    lat: 40.47610092163086,
    lng: 19.474199295043945,
  },
  {
    id: "N",
    name: "Haskovo Malevo Airport",
    city: "Haskovo",
    country: "Bulgaria",
    lat: 41.976398,
    lng: 25.5898,
  },
  {
    id: "N",
    name: "Gabrovnitsa Air Base",
    city: "Gabrovnitsa",
    country: "Bulgaria",
    lat: 43.5443000793457,
    lng: 23.272499084472656,
  },
  {
    id: "N",
    name: "Graf Ignatievo Air Base",
    city: "Graf Ignatievo",
    country: "Bulgaria",
    lat: 42.290401458740234,
    lng: 24.714000701904297,
  },
  {
    id: "N",
    name: "Dolna Mitropoliya Air Base",
    city: "Dolna Mitropoliya",
    country: "Bulgaria",
    lat: 43.451401,
    lng: 24.5028,
  },
  {
    id: "N",
    name: "Balchik Air Base",
    city: "Balchik",
    country: "Bulgaria",
    lat: 43.42380142211914,
    lng: 28.181299209594727,
  },
  {
    id: "ECV",
    name: "Cuatro Vientos Airport",
    city: "Madrid",
    country: "Spain",
    lat: 40.370701,
    lng: -3.78514,
  },
  {
    id: "CDT",
    name: "Castellón-Costa Azahar Airport",
    city: "Castellón de la Plana",
    country: "Spain",
    lat: 40.213889,
    lng: 0.073333,
  },
  {
    id: "TEV",
    name: "Teruel Airport",
    city: "Teruel",
    country: "Spain",
    lat: 40.403,
    lng: -1.2183,
  },
  {
    id: "N",
    name: "Blois-Le Breuil Airport",
    city: "Blois/Le Breuil",
    country: "France",
    lat: 47.678502,
    lng: 1.20884,
  },
  {
    id: "N",
    name: "Trento-Mattarello Airport",
    city: "Trento (TN)",
    country: "Italy",
    lat: 46.0214,
    lng: 11.1242,
  },
  {
    id: "N",
    name: "Alessandria Airport",
    city: "Alessandria",
    country: "Italy",
    lat: 44.925201,
    lng: 8.62513,
  },
  {
    id: "N",
    name: "Biella-Cerrione Airport",
    city: "Biella (BI)",
    country: "Italy",
    lat: 45.4953,
    lng: 8.10278,
  },
  {
    id: "N",
    name: "Vercelli Airport",
    city: "Vercelli",
    country: "Italy",
    lat: 45.310233,
    lng: 8.417935,
  },
  {
    id: "N",
    name: "Casale Monferrato Airport",
    city: "Casale Monferrato",
    country: "Italy",
    lat: 45.111198,
    lng: 8.45603,
  },
  {
    id: "N",
    name: "Varese-Venegono Airport",
    city: "Varese",
    country: "Italy",
    lat: 45.742199,
    lng: 8.888233,
  },
  {
    id: "N",
    name: "Novi Ligure Airport",
    city: "Novi Ligure",
    country: "Italy",
    lat: 44.779999,
    lng: 8.78639,
  },
  {
    id: "QLP",
    name: "Sarzana-Luni Air Base",
    city: "Sarzana (SP)",
    country: "Italy",
    lat: 44.088001,
    lng: 9.98795,
  },
  {
    id: "N",
    name: "Câmpia Turzii Air Base",
    city: "Câmpia Turzii",
    country: "Romania",
    lat: 46.50230026245117,
    lng: 23.885900497436523,
  },
  {
    id: "N",
    name: "Mărculeşti International Airport",
    city: "Mărculeşti",
    country: "Moldova",
    lat: 47.862701416015625,
    lng: 28.212799072265625,
  },
  {
    id: "N",
    name: "Cahul International Airport",
    city: "Cahul",
    country: "Moldova",
    lat: 45.8437995911,
    lng: 28.263700485199998,
  },
  {
    id: "N",
    name: "Tiraspol Airport",
    city: "Tiraspol",
    country: "Moldova",
    lat: 46.868099212646484,
    lng: 29.590599060058594,
  },
  {
    id: "BJY",
    name: "Batajnica Air Base",
    city: "Batajnica",
    country: "Serbia",
    lat: 44.935299,
    lng: 20.2575,
  },
  {
    id: "RUV",
    name: "Rubelsanto Airport",
    city: "Rubelsanto",
    country: "Guatemala",
    lat: 15.991999626159668,
    lng: -90.44529724121094,
  },
  {
    id: "XPL",
    name: "Coronel Enrique Soto Cano Air Base",
    city: "Comayagua",
    country: "Honduras",
    lat: 14.3824,
    lng: -87.621201,
  },
  {
    id: "UPL",
    name: "Upala Airport",
    city: "Upala",
    country: "Costa Rica",
    lat: 10.8922,
    lng: -85.016197,
  },
  {
    id: "QSN",
    name: "San Nicolas De Bari Airport",
    city: "San Nicolás",
    country: "Cuba",
    lat: 22.756099700927734,
    lng: -81.9208984375,
  },
  {
    id: "SNJ",
    name: "San Julian Air Base",
    city: "Pinar Del Rio",
    country: "Cuba",
    lat: 22.095300674438477,
    lng: -84.1520004272461,
  },
  {
    id: "DWD",
    name: "King Salman Abdulaziz Airport",
    city: "",
    country: "Saudi Arabia",
    lat: 24.4499,
    lng: 44.121201,
  },
  {
    id: "KMX",
    name: "King Khaled Air Base",
    city: "",
    country: "Saudi Arabia",
    lat: 18.297300338745117,
    lng: 42.80350112915039,
  },
  {
    id: "XXN",
    name: "Riyadh Air Base",
    city: "Riyadh",
    country: "Saudi Arabia",
    lat: 24.709800720214844,
    lng: 46.72520065307617,
  },
  {
    id: "KNR",
    name: "Jam Airport",
    city: "Kangan",
    country: "Iran",
    lat: 27.820499420166016,
    lng: 52.35219955444336,
  },
  {
    id: "N",
    name: "Hamadan Air Base",
    city: "Hamadan",
    country: "Iran",
    lat: 35.21160125732422,
    lng: 48.65340042114258,
  },
  {
    id: "PYK",
    name: "Payam International Airport",
    city: "Karaj",
    country: "Iran",
    lat: 35.776100158691,
    lng: 50.826698303223,
  },
  {
    id: "XIJ",
    name: "Ahmed Al Jaber Air Base",
    city: "Ahmed Al Jaber AB",
    country: "Kuwait",
    lat: 28.9347991943,
    lng: 47.791900634799994,
  },
  {
    id: "N",
    name: "Rayak Air Base",
    city: "Rayak",
    country: "Lebanon",
    lat: 33.850799560546875,
    lng: 35.987701416015625,
  },
  {
    id: "N",
    name: "Mirpur Khas Air Base",
    city: "Mirpur Khas",
    country: "Pakistan",
    lat: 25.682501,
    lng: 69.0728,
  },
  {
    id: "ATG",
    name: "Minhas Air Base",
    city: "Kamra",
    country: "Pakistan",
    lat: 33.8690986633,
    lng: 72.4009017944,
  },
  {
    id: "N",
    name: "Rafiqui Air Base",
    city: "Shorkot",
    country: "Pakistan",
    lat: 30.758100509643555,
    lng: 72.28250122070312,
  },
  {
    id: "N",
    name: "Faisal Air Base",
    city: "Karachi",
    country: "Pakistan",
    lat: 24.87420082092285,
    lng: 67.11849975585938,
  },
  {
    id: "SGI",
    name: "Mushaf Air Base",
    city: "Sargodha",
    country: "Pakistan",
    lat: 32.04859924316406,
    lng: 72.66500091552734,
  },
  {
    id: "RQW",
    name: "Qayyarah West Airport",
    city: "Qayyarah",
    country: "Iraq",
    lat: 35.76720047,
    lng: 43.125099182099994,
  },
  {
    id: "N",
    name: "Al Sahra Army Air Field",
    city: "Tikrit",
    country: "Iraq",
    lat: 34.67319869995117,
    lng: 43.542999267578125,
  },
  {
    id: "N",
    name: "Tall Afar Army Air Field",
    city: "Tall Afar",
    country: "Iraq",
    lat: 36.28310012817383,
    lng: 42.40299987792969,
  },
  {
    id: "N",
    name: "Al Taji Army Air Field",
    city: "Taji",
    country: "Iraq",
    lat: 33.52389907836914,
    lng: 44.25669860839844,
  },
  {
    id: "N",
    name: "Ubaydah Bin Al Jarrah Airport",
    city: "Al Cut",
    country: "Iraq",
    lat: 32.481998443603516,
    lng: 45.75709915161133,
  },
  {
    id: "ENN",
    name: "Nenana Municipal Airport",
    city: "Nenana",
    country: "United States",
    lat: 64.54730224609375,
    lng: -149.07400512695312,
  },
  {
    id: "WWA",
    name: "Wasilla Airport",
    city: "Wasilla",
    country: "United States",
    lat: 61.5717010498,
    lng: -149.539993286,
  },
  {
    id: "N",
    name: "Gangshan Air Force Base",
    city: "Gangshan",
    country: "Taiwan",
    lat: 22.782499313354492,
    lng: 120.26300048828125,
  },
  {
    id: "N",
    name: "Asahikawa Airfield",
    city: "",
    country: "Japan",
    lat: 43.794734,
    lng: 142.365432,
  },
  {
    id: "IWK",
    name: "Iwakuni Marine Corps Air Station",
    city: "Iwakuni",
    country: "Japan",
    lat: 34.143902,
    lng: 132.235992,
  },
  {
    id: "N",
    name: "Utsunomiya Airport",
    city: "",
    country: "Japan",
    lat: 36.5145,
    lng: 139.87101,
  },
  {
    id: "N",
    name: "Jungwon Air Base/Chungju Airport",
    city: "",
    country: "South Korea",
    lat: 37.03024,
    lng: 127.886353,
  },
  {
    id: "IEJ",
    name: "Ie Jima Airport",
    city: "Ie",
    country: "Japan",
    lat: 26.7220001221,
    lng: 127.785003662,
  },
  {
    id: "AAV",
    name: "Allah Valley Airport",
    city: "Surallah",
    country: "Philippines",
    lat: 6.366819858551025,
    lng: 124.7509994506836,
  },
  {
    id: "BPH",
    name: "Bislig Airport",
    city: "",
    country: "Philippines",
    lat: 8.19594955444336,
    lng: 126.3219985961914,
  },
  {
    id: "MXI",
    name: "Mati National Airport",
    city: "",
    country: "Philippines",
    lat: 6.949091,
    lng: 126.27368,
  },
  {
    id: "N",
    name: "Presidente Néstor Kirchner Regionsl Airport",
    city: "Villa Maria",
    country: "Argentina",
    lat: -32.3201,
    lng: -63.22663,
  },
  {
    id: "BAT",
    name: "Chafei Amsei Airport",
    city: "Barretos",
    country: "Brazil",
    lat: -20.584499359131,
    lng: -48.594100952148,
  },
  {
    id: "QHP",
    name: "Base de Aviação de Taubaté Airport",
    city: "Taubaté",
    country: "Brazil",
    lat: -23.04010009765625,
    lng: -45.51599884033203,
  },
  {
    id: "TOQ",
    name: "Barriles Airport",
    city: "Tocopilla",
    country: "Chile",
    lat: -22.14109992980957,
    lng: -70.06289672851562,
  },
  {
    id: "N",
    name: "Schroeder's field",
    city: "Cochrane",
    country: "Chile",
    lat: 35.071718,
    lng: -91.738801,
  },
  {
    id: "CNR",
    name: "Chañaral Airport",
    city: "Chañaral",
    country: "Chile",
    lat: -26.332500457763672,
    lng: -70.6072998046875,
  },
  {
    id: "TLX",
    name: "Panguilemo Airport",
    city: "Talca",
    country: "Chile",
    lat: -35.37779998779297,
    lng: -71.60169982910156,
  },
  {
    id: "ZIC",
    name: "Victoria Airport",
    city: "Victoria",
    country: "Chile",
    lat: -38.245601654052734,
    lng: -72.34860229492188,
  },
  {
    id: "TTC",
    name: "Las Breas Airport",
    city: "Taltal",
    country: "Chile",
    lat: -25.564300537109375,
    lng: -70.37590026855469,
  },
  {
    id: "API",
    name: "Gomez Nino Apiay Air Base",
    city: "Apiay",
    country: "Colombia",
    lat: 4.07607,
    lng: -73.5627,
  },
  {
    id: "CVE",
    name: "Coveñas Airport",
    city: "Coveñas",
    country: "Colombia",
    lat: 9.40092,
    lng: -75.6913,
  },
  {
    id: "PAL",
    name: "German Olano Air Base",
    city: "La Dorada",
    country: "Colombia",
    lat: 5.48361,
    lng: -74.6574,
  },
  {
    id: "PZA",
    name: "Paz De Ariporo Airport",
    city: "Paz De Ariporo",
    country: "Colombia",
    lat: 5.87615,
    lng: -71.8866,
  },
  {
    id: "N",
    name: "Tunja Airport",
    city: "Tunja",
    country: "Colombia",
    lat: 5.54138,
    lng: -73.3445,
  },
  {
    id: "TQS",
    name: "Tres Esquinas Air Base",
    city: "Tres Esquinas",
    country: "Colombia",
    lat: 0.7459,
    lng: -75.234,
  },
  {
    id: "N",
    name: "Marandúa Air Base",
    city: "Marandúa",
    country: "Colombia",
    lat: 5.52448,
    lng: -68.6856,
  },
  {
    id: "RIJ",
    name: "Juan Simons Vela Airport",
    city: "Rioja",
    country: "Peru",
    lat: -6.067860126495361,
    lng: -77.16000366210938,
  },
  {
    id: "JAE",
    name: "Shumba Airport",
    city: "Jaén",
    country: "Peru",
    lat: -5.59248,
    lng: -78.774002,
  },
  {
    id: "N",
    name: "Metropolitano Airport",
    city: "",
    country: "Venezuela",
    lat: 10.133169174194336,
    lng: -66.78782653808594,
  },
  {
    id: "IKU",
    name: "Issyk-Kul International Airport",
    city: "Tamchy",
    country: "Kyrgyzstan",
    lat: 42.58792,
    lng: 76.713046,
  },
  {
    id: "N",
    name: "Kant Air Base",
    city: "Kant",
    country: "Kyrgyzstan",
    lat: 42.85319900512695,
    lng: 74.84649658203125,
  },
  {
    id: "N",
    name: "Ayaguz Airport",
    city: "Ayaguz",
    country: "Kazakhstan",
    lat: 47.91859817504883,
    lng: 80.45279693603516,
  },
  {
    id: "N",
    name: "Chelkar Airport",
    city: "Chelkar",
    country: "Kazakhstan",
    lat: 47.904998779296875,
    lng: 59.619998931884766,
  },
  {
    id: "N",
    name: "Kyzyl-Syr Airport",
    city: "Kyzyl-Syr",
    country: "Russia",
    lat: 63.8849983215332,
    lng: 122.7770004272461,
  },
  {
    id: "VYI",
    name: "Vilyuisk Airport",
    city: "Vilyuisk",
    country: "Russia",
    lat: 63.75666809082,
    lng: 121.69333648682,
  },
  {
    id: "BGN",
    name: "Belaya Gora Airport",
    city: "",
    country: "Russia",
    lat: 68.556602,
    lng: 146.231506,
  },
  {
    id: "N",
    name: "Dzhermuk Airport",
    city: "Dzhermuk",
    country: "Armenia",
    lat: 39.8240013123,
    lng: 45.673999786399996,
  },
  {
    id: "N",
    name: "Kamenny Ruchey Naval Air Base",
    city: "Sovetskaya Gavan",
    country: "Russia",
    lat: 49.23570251464844,
    lng: 140.19309997558594,
  },
  {
    id: "GVN",
    name: "Maygatka Airport.",
    city: "Sovetskaya Gavan",
    country: "Russia",
    lat: 48.926998138399995,
    lng: 140.033996582,
  },
  {
    id: "N",
    name: "Omsukchan Airport",
    city: "Omsukchan",
    country: "Russia",
    lat: 62.457000732421875,
    lng: 155.7449951171875,
  },
  {
    id: "N",
    name: "Chaybukha Airport",
    city: "Chaybukha",
    country: "Russia",
    lat: 61.834999084472656,
    lng: 160.54800415039062,
  },
  {
    id: "N",
    name: "Keperveem Airport",
    city: "Keperveem",
    country: "Russia",
    lat: 67.8450012207,
    lng: 166.13999939,
  },
  {
    id: "N",
    name: "Magadan-13 Airport",
    city: "Magadan",
    country: "Russia",
    lat: 59.62329864501953,
    lng: 150.9219970703125,
  },
  {
    id: "NLI",
    name: "Nikolayevsk-na-Amure Airport",
    city: "Nikolayevsk-na-Amure Airport",
    country: "Russia",
    lat: 53.154999,
    lng: 140.649994,
  },
  {
    id: "N",
    name: "Palana Airport",
    city: "Palana",
    country: "Russia",
    lat: 59.08169937133789,
    lng: 159.88800048828125,
  },
  {
    id: "N",
    name: "Zheleznogorsk Airport",
    city: "Zheleznogorsk-Ilimsky",
    country: "Russia",
    lat: 56.487701416015625,
    lng: 104.10600280761719,
  },
  {
    id: "N",
    name: "Gvardeyskoe Air Base",
    city: "Sarabuz",
    country: "Ukraine",
    lat: 45.1150016784668,
    lng: 33.97700119018555,
  },
  {
    id: "N",
    name: "Saki Air Base",
    city: "Saki",
    country: "Ukraine",
    lat: 45.09299850463867,
    lng: 33.595001220703125,
  },
  {
    id: "N",
    name: "Dzhankoy Airport",
    city: "Dzhankoy",
    country: "Ukraine",
    lat: 45.70090103149414,
    lng: 34.41889953613281,
  },
  {
    id: "N",
    name: "Ozerne Air Base",
    city: "Zhytomyr",
    country: "Ukraine",
    lat: 50.158298,
    lng: 28.7383,
  },
  {
    id: "N",
    name: "Severomorsk-1 Naval Air Base",
    city: "Severomorsk",
    country: "Russia",
    lat: 69.03166961669922,
    lng: 33.418331146240234,
  },
  {
    id: "N",
    name: "Pushkin Airport",
    city: "St. Petersburg",
    country: "Russia",
    lat: 59.685001,
    lng: 30.338301,
  },
  {
    id: "N",
    name: "Siversky Air Base",
    city: "Siversky",
    country: "Russia",
    lat: 59.3567008972168,
    lng: 30.036699295043945,
  },
  {
    id: "N",
    name: "Staraya Russa Air Base",
    city: "Staraya Russa",
    country: "Russia",
    lat: 57.961399,
    lng: 31.384399,
  },
  {
    id: "N",
    name: "Peski Airport",
    city: "Petrozavodsk",
    country: "Russia",
    lat: 61.83194351196289,
    lng: 34.295555114746094,
  },
  {
    id: "N",
    name: "Baranavichi Air Base",
    city: "Baranavichi",
    country: "Belarus",
    lat: 53.099998474121094,
    lng: 26.049999237060547,
  },
  {
    id: "N",
    name: "Babruisk Air Base",
    city: "Babruisk",
    country: "Belarus",
    lat: 53.105,
    lng: 29.205,
  },
  {
    id: "N",
    name: "Severo-Eniseysk Airport",
    city: "Severo-Eniseysk",
    country: "Russia",
    lat: 60.37329864501953,
    lng: 93.01170349121094,
  },
  {
    id: "N",
    name: "Sharypovo Airport",
    city: "Sharypovo",
    country: "Russia",
    lat: 55.454914093,
    lng: 89.1738815308,
  },
  {
    id: "N",
    name: "Omsk Severny Airport",
    city: "Omsk",
    country: "Russia",
    lat: 54.9749984741,
    lng: 73.5550003052,
  },
  {
    id: "N",
    name: "Nagurskoye",
    city: "Murmansk",
    country: "Russia",
    lat: 80.803207,
    lng: 47.663586,
  },
  {
    id: "N",
    name: "Svetlogorsk Airport",
    city: "Svetlogorsk",
    country: "Russia",
    lat: 66.83999633789062,
    lng: 88.40333557128906,
  },
  {
    id: "N",
    name: "Valek Airport",
    city: "Valek",
    country: "Russia",
    lat: 69.39690399169922,
    lng: 88.35368347167969,
  },
  {
    id: "N",
    name: "Khanskaya Air Base",
    city: "Maykop",
    country: "Russia",
    lat: 44.68,
    lng: 40.035,
  },
  {
    id: "N",
    name: "Dudinka Airport",
    city: "Dudinka",
    country: "Russia",
    lat: 69.375,
    lng: 86.15666961669922,
  },
  {
    id: "VLK",
    name: "Volgodonsk Airport",
    city: "",
    country: "Russia",
    lat: 47.682098388671875,
    lng: 42.07279968261719,
  },
  {
    id: "N",
    name: "Tashkent East Airport",
    city: "Tashkent",
    country: "Uzbekistan",
    lat: 41.31269836425781,
    lng: 69.39140319824219,
  },
  {
    id: "N",
    name: "Myachkovo Airport",
    city: "Moscow",
    country: "Russia",
    lat: 55.5600013733,
    lng: 37.9850006104,
  },
  {
    id: "N",
    name: "Tretyakovo Airport",
    city: "Lukhovitsy",
    country: "Russia",
    lat: 54.904998779299994,
    lng: 39.02666854859999,
  },
  {
    id: "N",
    name: "Yermolino Airport",
    city: "Balabanovo",
    country: "Russia",
    lat: 55.2283325195,
    lng: 36.6083335876,
  },
  {
    id: "INA",
    name: "Inta Airport",
    city: "Inta",
    country: "Russia",
    lat: 66.0548324584961,
    lng: 60.110321044921875,
  },
  {
    id: "N",
    name: "Izhma Airport",
    city: "Izhma",
    country: "Russia",
    lat: 65.03170013427734,
    lng: 53.970001220703125,
  },
  {
    id: "N",
    name: "Borisoglebskoye Airport",
    city: "Kazan",
    country: "Russia",
    lat: 55.86669921875,
    lng: 49.13330078125,
  },
  {
    id: "ZIX",
    name: "Zhigansk Airport",
    city: "Zhigansk",
    country: "Russia",
    lat: 66.7965011597,
    lng: 123.361000061,
  },
  {
    id: "N",
    name: "Maksimovka Airport",
    city: "Ufa",
    country: "Russia",
    lat: 54.83000183105469,
    lng: 56.16830062866211,
  },
  {
    id: "N",
    name: "Buguruslan Severny Airport",
    city: "Buguruslan",
    country: "Russia",
    lat: 53.71839904789999,
    lng: 52.3718986511,
  },
  {
    id: "N",
    name: "Bezymyanka Airfield",
    city: "Samara",
    country: "Russia",
    lat: 53.220001220703125,
    lng: 50.32500076293945,
  },
  {
    id: "RTC",
    name: "Ratnagiri Airport",
    city: "",
    country: "India",
    lat: 17.013599,
    lng: 73.327797,
  },
  {
    id: "HIM",
    name: "Hingurakgoda Air Force Base",
    city: "Polonnaruwa Town",
    country: "Sri Lanka",
    lat: 8.04981,
    lng: 80.9814,
  },
  {
    id: "RDP",
    name: "Kazi Nazrul Islam Airport",
    city: "Durgapur",
    country: "India",
    lat: 23.6225,
    lng: 87.243,
  },
  {
    id: "N",
    name: "Ambala Air Force Station",
    city: "",
    country: "India",
    lat: 30.368099212646484,
    lng: 76.81670379638672,
  },
  {
    id: "N",
    name: "Sirsa Air Force Station",
    city: "",
    country: "India",
    lat: 29.56060028076172,
    lng: 75.006103515625,
  },
  {
    id: "N",
    name: "Udhampur Air Force Station",
    city: "",
    country: "India",
    lat: 32.902198791503906,
    lng: 75.15619659423828,
  },
  {
    id: "PUT",
    name: "Sri Sathya Sai Airport",
    city: "Puttaparthi",
    country: "India",
    lat: 14.1492996216,
    lng: 77.7910995483,
  },
  {
    id: "N",
    name: "Meiktila Air Base",
    city: "Meiktila",
    country: "Burma",
    lat: 20.88640022277832,
    lng: 95.89279174804688,
  },
  {
    id: "N",
    name: "Changi Air Base (East)",
    city: "Singapore",
    country: "Singapore",
    lat: 1.3441400528,
    lng: 104.009002686,
  },
  {
    id: "N",
    name: "Soltsy-2 Air Base",
    city: "Soltsy",
    country: "Russia",
    lat: 58.139545,
    lng: 30.33042,
  },
  {
    id: "N",
    name: "Severomorsk-3 Naval Air Base",
    city: "Severomorsk",
    country: "Russia",
    lat: 68.866669,
    lng: 33.716667,
  },
  {
    id: "N",
    name: "Fedotovo Naval Air Base",
    city: "Kipelovo",
    country: "Russia",
    lat: 59.193031,
    lng: 39.129411,
  },
  {
    id: "N",
    name: "Lebyazhye Air Base",
    city: "Kamyshin",
    country: "Russia",
    lat: 50.201698303200004,
    lng: 45.2083015442,
  },
  {
    id: "LNX",
    name: "Smolensk North Airport",
    city: "Smolensk",
    country: "Russia",
    lat: 54.824,
    lng: 32.025,
  },
  {
    id: "N",
    name: "Rtishchevo Air Base",
    city: "Rtishchevo",
    country: "Russia",
    lat: 52.297317,
    lng: 43.7241,
  },
  {
    id: "ABH",
    name: "Alpha Airport",
    city: "Alpha",
    country: "Australia",
    lat: -23.646099,
    lng: 146.584,
  },
  {
    id: "ARY",
    name: "Ararat Airport",
    city: "",
    country: "Australia",
    lat: -37.30939865112305,
    lng: 142.98899841308594,
  },
  {
    id: "BLN",
    name: "Benalla Airport",
    city: "",
    country: "Australia",
    lat: -36.55189895629883,
    lng: 146.0070037841797,
  },
  {
    id: "BZD",
    name: "Balranald Airport",
    city: "",
    country: "Australia",
    lat: -34.623600006103516,
    lng: 143.5780029296875,
  },
  {
    id: "BWQ",
    name: "Brewarrina Airport",
    city: "",
    country: "Australia",
    lat: -29.973899841308594,
    lng: 146.81700134277344,
  },
  {
    id: "CVC",
    name: "Cleve Airport",
    city: "",
    country: "Australia",
    lat: -33.70970153808594,
    lng: 136.5050048828125,
  },
  {
    id: "CWW",
    name: "Corowa Airport",
    city: "",
    country: "Australia",
    lat: -35.99470138549805,
    lng: 146.35699462890625,
  },
  {
    id: "CYG",
    name: "Corryong Airport",
    city: "",
    country: "Australia",
    lat: -36.18280029296875,
    lng: 147.88800048828125,
  },
  {
    id: "CMD",
    name: "Cootamundra Airport",
    city: "",
    country: "Australia",
    lat: -34.6239013671875,
    lng: 148.0279998779297,
  },
  {
    id: "DRN",
    name: "Dirranbandi Airport",
    city: "",
    country: "Australia",
    lat: -28.591699600219727,
    lng: 148.2169952392578,
  },
  {
    id: "DNQ",
    name: "Deniliquin Airport",
    city: "Deniliquin",
    country: "Australia",
    lat: -35.5593986511,
    lng: 144.945999146,
  },
  {
    id: "DYA",
    name: "Dysart Airport",
    city: "",
    country: "Australia",
    lat: -22.62220001220703,
    lng: 148.36399841308594,
  },
  {
    id: "ECH",
    name: "Echuca Airport",
    city: "",
    country: "Australia",
    lat: -36.15719985961914,
    lng: 144.76199340820312,
  },
  {
    id: "FRB",
    name: "Forbes Airport",
    city: "Forbes",
    country: "Australia",
    lat: -33.363602,
    lng: 147.934998,
  },
  {
    id: "GUH",
    name: "Gunnedah Airport",
    city: "",
    country: "Australia",
    lat: -30.96109962463379,
    lng: 150.25100708007812,
  },
  {
    id: "HXX",
    name: "Hay Airport",
    city: "",
    country: "Australia",
    lat: -34.53139877319336,
    lng: 144.8300018310547,
  },
  {
    id: "HTU",
    name: "Hopetoun Airport",
    city: "",
    country: "Australia",
    lat: -35.715301513671875,
    lng: 142.36000061035156,
  },
  {
    id: "KRA",
    name: "Kerang Airport",
    city: "",
    country: "Australia",
    lat: -35.751399993896484,
    lng: 143.93899536132812,
  },
  {
    id: "KPS",
    name: "Kempsey Airport",
    city: "",
    country: "Australia",
    lat: -31.074399948120117,
    lng: 152.77000427246094,
  },
  {
    id: "KGY",
    name: "Kingaroy Airport",
    city: "",
    country: "Australia",
    lat: -26.580799102783203,
    lng: 151.84100341796875,
  },
  {
    id: "TGN",
    name: "Latrobe Valley Airport",
    city: "Morwell",
    country: "Australia",
    lat: -38.207199,
    lng: 146.470001,
  },
  {
    id: "MRG",
    name: "Mareeba Airport",
    city: "",
    country: "Australia",
    lat: -17.06920051574707,
    lng: 145.41900634765625,
  },
  {
    id: "RPM",
    name: "Ngukurr Airport",
    city: "",
    country: "Australia",
    lat: -14.722800254821777,
    lng: 134.7469940185547,
  },
  {
    id: "QRM",
    name: "Narromine Airport",
    city: "",
    country: "Australia",
    lat: -32.214698791503906,
    lng: 148.22500610351562,
  },
  {
    id: "PPI",
    name: "Port Pirie Airport",
    city: "",
    country: "Australia",
    lat: -33.23889923095703,
    lng: 137.9949951171875,
  },
  {
    id: "SIO",
    name: "Smithton Airport",
    city: "",
    country: "Australia",
    lat: -40.834999084472656,
    lng: 145.08399963378906,
  },
  {
    id: "SNB",
    name: "Snake Bay Airport",
    city: "",
    country: "Australia",
    lat: -11.422800064086914,
    lng: 130.6540069580078,
  },
  {
    id: "SWC",
    name: "Stawell Airport",
    city: "",
    country: "Australia",
    lat: -37.07170104980469,
    lng: 142.74099731445312,
  },
  {
    id: "TYB",
    name: "Tibooburra Airport",
    city: "",
    country: "Australia",
    lat: -29.451099395751953,
    lng: 142.05799865722656,
  },
  {
    id: "TUM",
    name: "Tumut Airport",
    city: "",
    country: "Australia",
    lat: -35.26279830932617,
    lng: 148.24099731445312,
  },
  {
    id: "WGT",
    name: "Wangaratta Airport",
    city: "",
    country: "Australia",
    lat: -36.41579818725586,
    lng: 146.3070068359375,
  },
  {
    id: "WKB",
    name: "Warracknabeal Airport",
    city: "",
    country: "Australia",
    lat: -36.32109832763672,
    lng: 142.41900634765625,
  },
  {
    id: "QRR",
    name: "Warren Airport",
    city: "",
    country: "Australia",
    lat: -31.733299255371094,
    lng: 147.80299377441406,
  },
  {
    id: "SXE",
    name: "West Sale Airport",
    city: "Sale",
    country: "Australia",
    lat: -38.090827,
    lng: 146.965335,
  },
  {
    id: "WWY",
    name: "West Wyalong Airport",
    city: "West Wyalong",
    country: "Australia",
    lat: -33.9371986389,
    lng: 147.190994263,
  },
  {
    id: "NGA",
    name: "Young Airport",
    city: "",
    country: "Australia",
    lat: -34.25559997558594,
    lng: 148.2480010986328,
  },
  {
    id: "LHK",
    name: "Guangzhou MR Air Base",
    city: "Guanghua",
    country: "China",
    lat: 32.389400482177734,
    lng: 111.69499969482422,
  },
  {
    id: "WDS",
    name: "Shiyan Wudangshan Airport",
    city: "Shiyan",
    country: "China",
    lat: 32.591667,
    lng: 110.907778,
  },
  {
    id: "N",
    name: "Sunchon Air Base",
    city: "Sunchon",
    country: "North Korea",
    lat: 39.415699,
    lng: 125.894997,
  },
  {
    id: "HTT",
    name: "Huatugou Airport",
    city: "Mengnai",
    country: "China",
    lat: 38.201984,
    lng: 90.841495,
  },
  {
    id: "UUN",
    name: "Baruun Urt Airport",
    city: "",
    country: "Mongolia",
    lat: 46.660301208496094,
    lng: 113.28500366210938,
  },
  {
    id: "BFU",
    name: "Bengbu Airport",
    city: "Bengbu",
    country: "China",
    lat: 32.8477333333,
    lng: 117.320244444,
  },
  {
    id: "RUG",
    name: "Rugao Air Base",
    city: "Rugao",
    country: "China",
    lat: 32.25788497924805,
    lng: 120.50165557861328,
  },
  {
    id: "WHU",
    name: "Wuhu Air Base",
    city: "Wuhu",
    country: "China",
    lat: 31.3906,
    lng: 118.408997,
  },
  {
    id: "SXJ",
    name: "Shanshan Airport",
    city: "Shanshan",
    country: "China",
    lat: 42.91170120239258,
    lng: 90.24749755859375,
  },
  {
    id: "YKH",
    name: "Yingkou Lanqi Airport",
    city: "Yingkou",
    country: "China",
    lat: 40.542524,
    lng: 122.3586,
  },
  {
    id: "N",
    name: "Shenyang Dongta Airport",
    city: "Shenyang",
    country: "China",
    lat: 41.784400939941406,
    lng: 123.49600219726562,
  },
  {
    id: "BQG",
    name: "Bogorodskoye Airport",
    city: "Bogorodskoe",
    country: "Russia",
    lat: 52.38,
    lng: 140.448,
  },
  {
    id: "N",
    name: "Itapiranga Airport",
    city: "Itapiranga",
    country: "Brazil",
    lat: -27.142499923706055,
    lng: -53.68579864501953,
  },
  {
    id: "N",
    name: "Aguas Calientes Airport",
    city: "Aguas Calientes",
    country: "Peru",
    lat: -8.833330154418945,
    lng: -74.68329620361328,
  },
  {
    id: "HYD",
    name: "Rajiv Gandhi International Airport",
    city: "Hyderabad",
    country: "India",
    lat: 17.2313175201,
    lng: 78.4298553467,
  },
  {
    id: "N",
    name: "Vancouver International Seaplane Base",
    city: "Vancouver",
    country: "Canada",
    lat: 49.177047,
    lng: -123.168154,
  },
  {
    id: "N",
    name: "Bressaucourt Airport",
    city: "Bressaucourt-Porrentruy",
    country: "Switzerland",
    lat: 47.392677,
    lng: 7.028648,
  },
  {
    id: "PKO",
    name: "Parakou Airport",
    city: "Parakou",
    country: "Benin",
    lat: 9.35768985748291,
    lng: 2.609679937362671,
  },
  {
    id: "KDC",
    name: "Kandi Airport",
    city: "Kandi",
    country: "Benin",
    lat: 11.14479,
    lng: 2.940381,
  },
  {
    id: "N",
    name: "Sokodé Airport",
    city: "Sokode",
    country: "Togo",
    lat: 8.994275,
    lng: 1.153004,
  },
  {
    id: "N",
    name: "Sansanné-Mango Airport",
    city: "Mango",
    country: "Togo",
    lat: 10.373010635375977,
    lng: 0.47138214111328125,
  },
  {
    id: "N",
    name: "Arnbruck Airport",
    city: "Arnbruck",
    country: "Germany",
    lat: 49.12472152709961,
    lng: 12.985555648803711,
  },
  {
    id: "N",
    name: "Jacarepaguá - Roberto Marinho Airport",
    city: "Rio de Janeiro",
    country: "Brazil",
    lat: -22.987499,
    lng: -43.369999,
  },
  {
    id: "N",
    name: "Hacaritama Airport",
    city: "Aguachica",
    country: "Colombia",
    lat: 8.247,
    lng: -73.5814,
  },
  {
    id: "HMG",
    name: "Hermannsburg Airport",
    city: "Hermannsburg",
    country: "Australia",
    lat: -23.93000030517578,
    lng: 132.80499267578125,
  },
  {
    id: "N",
    name: "Mount Davies Airport",
    city: "Pipalyatjara",
    country: "Australia",
    lat: -26.16670036315918,
    lng: 129.13299560546875,
  },
  {
    id: "N",
    name: "Areyonga Airport",
    city: "Areyonga",
    country: "Australia",
    lat: -24.066699981689453,
    lng: 132.26699829101562,
  },
  {
    id: "N",
    name: "Tracy Municipal Airport",
    city: "Tracy",
    country: "United States",
    lat: 37.68899917602539,
    lng: -121.44200134277344,
  },
  {
    id: "N",
    name: "Mount Allan Airport",
    city: "Yuelamu",
    country: "Australia",
    lat: -22.274999618530273,
    lng: 132.2169952392578,
  },
  {
    id: "N",
    name: "Everard Park Airport",
    city: "Mimili",
    country: "Australia",
    lat: -27.016700744628906,
    lng: 132.7169952392578,
  },
  {
    id: "N",
    name: "Warrabri Airport",
    city: "Ali-Curung",
    country: "Australia",
    lat: -21.0,
    lng: 134.39700317382812,
  },
  {
    id: "N",
    name: "Krefeld-Egelsberg Airport",
    city: "Krefeld",
    country: "Germany",
    lat: 51.3849983215332,
    lng: 6.587778091430664,
  },
  {
    id: "BIB",
    name: "Baidoa Airport",
    city: "Baidoa",
    country: "Somalia",
    lat: 3.102220058441162,
    lng: 43.62860107421875,
  },
  {
    id: "N",
    name: "Ampilatwatja Airport",
    city: "Ampilatwatja",
    country: "Australia",
    lat: -21.655000686645508,
    lng: 135.22999572753906,
  },
  {
    id: "KCS",
    name: "Kings Creek Airport",
    city: "Petermann",
    country: "Australia",
    lat: -24.42329978942871,
    lng: 131.8350067138672,
  },
  {
    id: "N",
    name: "Harts Range Airport",
    city: "Harts Range",
    country: "Australia",
    lat: -22.985000610351562,
    lng: 134.91799926757812,
  },
  {
    id: "N",
    name: "Elliott Airport",
    city: "Elliott",
    country: "Australia",
    lat: -17.527429580688477,
    lng: 133.52989196777344,
  },
  {
    id: "N",
    name: "Papunya Airport",
    city: "Papunya",
    country: "Australia",
    lat: -23.246700286865234,
    lng: 131.9029998779297,
  },
  {
    id: "N",
    name: "Fregon Airport",
    city: "Fregon",
    country: "Australia",
    lat: -26.774999618530273,
    lng: 132.01699829101562,
  },
  {
    id: "N",
    name: "Mount Liebig Airport",
    city: "Mt Liebig",
    country: "Australia",
    lat: -23.24329948425293,
    lng: 131.25999450683594,
  },
  {
    id: "N",
    name: "Bolton Field",
    city: "Columbus",
    country: "United States",
    lat: 39.90119934082031,
    lng: -83.13690185546875,
  },
  {
    id: "BMR",
    name: "Baltrum Airport",
    city: "Baltrum",
    country: "Germany",
    lat: 53.72472381591797,
    lng: 7.373332977294922,
  },
  {
    id: "MVW",
    name: "Skagit Regional Airport",
    city: "Skagit",
    country: "United States",
    lat: 48.4709014893,
    lng: -122.42099762,
  },
  {
    id: "GOO",
    name: "Goondiwindi Airport",
    city: "Goondiwindi",
    country: "Australia",
    lat: -28.521400451660156,
    lng: 150.32000732421875,
  },
  {
    id: "N",
    name: "Liman Airfield",
    city: "Odesa",
    country: "Ukraine",
    lat: 46.57851,
    lng: 30.703053,
  },
  {
    id: "N",
    name: "Lognes Emerainville Airport",
    city: "Lognes",
    country: "France",
    lat: 48.821028,
    lng: 2.625967,
  },
  {
    id: "APT",
    name: "Marion County Brown Field",
    city: "Jasper",
    country: "United States",
    lat: 35.060699,
    lng: -85.585297,
  },
  {
    id: "N",
    name: "Evergreen Regional Airport/Middleton Field",
    city: "Evergreen",
    country: "United States",
    lat: 31.4158,
    lng: -87.043999,
  },
  {
    id: "DCU",
    name: "Pryor Field Regional Airport",
    city: "Decatur",
    country: "United States",
    lat: 34.652698516799994,
    lng: -86.94539642330001,
  },
  {
    id: "GLW",
    name: "Glasgow Municipal Airport",
    city: "Glasgow",
    country: "United States",
    lat: 37.03179932,
    lng: -85.9536972,
  },
  {
    id: "N",
    name: "Danielson Airport",
    city: "Danielson",
    country: "United States",
    lat: 41.819698333740234,
    lng: -71.9010009765625,
  },
  {
    id: "DKV",
    name: "Docker River Airport",
    city: "Docker River",
    country: "Australia",
    lat: -24.860000610351562,
    lng: 129.07000732421875,
  },
  {
    id: "N",
    name: "Clearfield Lawrence Airport",
    city: "Clearfield",
    country: "United States",
    lat: 41.04859924316406,
    lng: -78.41310119628906,
  },
  {
    id: "RNZ",
    name: "Jasper County Airport",
    city: "Rensselaer",
    country: "United States",
    lat: 40.9478988647,
    lng: -87.1826019287,
  },
  {
    id: "N",
    name: "Ti Tree Airport",
    city: "Ti Tree",
    country: "Australia",
    lat: -22.13170051574707,
    lng: 133.4199981689453,
  },
  {
    id: "SBT",
    name: "Sabetta International Airport",
    city: "Sabetta",
    country: "Russia",
    lat: 71.219167,
    lng: 72.052222,
  },
  {
    id: "AXF",
    name: "Alxa Left Banner Bayanhot Airport",
    city: "Alxa Left Banner",
    country: "China",
    lat: 38.74831,
    lng: 105.58858,
  },
  {
    id: "N",
    name: "El Fuentero Airport",
    city: "Svenborg",
    country: "Denmark",
    lat: 7.099999904632568,
    lng: -69.58333587646484,
  },
  {
    id: "N",
    name: "Sturgate Airfield",
    city: "Eger",
    country: "Hungary",
    lat: 53.381099700927734,
    lng: -0.6852779984474182,
  },
  {
    id: "NIS",
    name: "Simberi Airport",
    city: "Simberi Island",
    country: "Papua New Guinea",
    lat: -2.66222222222,
    lng: 151.997777778,
  },
  {
    id: "BUL",
    name: "Bulolo Airport",
    city: "Bulolo",
    country: "Papua New Guinea",
    lat: -7.216286671410001,
    lng: 146.649541855,
  },
  {
    id: "N",
    name: "Kintore Airport",
    city: "Kintore",
    country: "Australia",
    lat: -23.264999389648438,
    lng: 129.38699340820312,
  },
  {
    id: "TBR",
    name: "Statesboro Bulloch County Airport",
    city: "Statesboro",
    country: "United States",
    lat: 32.4827003479,
    lng: -81.73690032959999,
  },
  {
    id: "N",
    name: "Utopia Airport",
    city: "Utopia",
    country: "Australia",
    lat: -22.05500030517578,
    lng: 134.7899932861328,
  },
  {
    id: "N",
    name: "Nyrripi Airport",
    city: "Nyirripi",
    country: "Australia",
    lat: -22.645299911499023,
    lng: 130.56500244140625,
  },
  {
    id: "AMT",
    name: "Amata Airport",
    city: "Amata",
    country: "Australia",
    lat: -26.108299255371094,
    lng: 131.20700073242188,
  },
  {
    id: "N",
    name: "Glacier Country Heliport",
    city: "Franz Josef",
    country: "New Zealand",
    lat: -43.38722,
    lng: 170.18,
  },
  {
    id: "EDD",
    name: "Erldunda Airport",
    city: "Erldunda",
    country: "Australia",
    lat: -25.205799102800004,
    lng: 133.253997803,
  },
  {
    id: "N",
    name: "Helisul I Heliport",
    city: "Foz do Iguassu",
    country: "Brazil",
    lat: -25.604167938232422,
    lng: -54.49361038208008,
  },
  {
    id: "FIK",
    name: "Finke Airport",
    city: "Finke",
    country: "Australia",
    lat: -25.5946998596,
    lng: 134.582992554,
  },
  {
    id: "JJG",
    name: "Humberto Ghizzo Bortoluzzi Regional Airport",
    city: "Jaguaruna",
    country: "Brazil",
    lat: -28.6753,
    lng: -49.0596,
  },
  {
    id: "N",
    name: "Nypari Airport",
    city: "Angatja Homeland",
    country: "Australia",
    lat: -26.200000762939453,
    lng: 130.23300170898438,
  },
  {
    id: "N",
    name: "Ihtiman Airfield",
    city: "Ihtiman",
    country: "Bulgaria",
    lat: 42.42189,
    lng: 23.767221,
  },
  {
    id: "N",
    name: "Vogtareuth Airport",
    city: "Vogtareuth",
    country: "Germany",
    lat: 47.946109771728516,
    lng: 12.20472240447998,
  },
  {
    id: "N",
    name: "[Duplicate] Illertissen see EDMI - ED-0425 location moved out-of-the way",
    city: "Not Specified",
    country: "New Zealand",
    lat: 89.5,
    lng: 0.0001,
  },
  {
    id: "N",
    name: "New Smyrna Beach Municipal Airport",
    city: "New Smyrna Beach",
    country: "United States",
    lat: 29.055700302124023,
    lng: -80.94889831542969,
  },
  {
    id: "N",
    name: "Las Vegas Helicopters Heliport",
    city: "Las vegas",
    country: "United States",
    lat: 36.10810089111328,
    lng: -115.17400360107422,
  },
  {
    id: "N",
    name: "Delta Camp Airport",
    city: "Delta Camp",
    country: "Botswana",
    lat: -19.5323,
    lng: 23.0925,
  },
  {
    id: "WKI",
    name: "Hwange (Town) Airport",
    city: "Hwange",
    country: "Zimbabwe",
    lat: -18.362967,
    lng: 26.519791,
  },
  {
    id: "N",
    name: "Harbour (Public) Heliport",
    city: "Vancouver",
    country: "Canada",
    lat: 49.2868921105,
    lng: -123.106112257,
  },
  {
    id: "N",
    name: "Victoria Harbour (Camel Point) Heliport",
    city: "Victoria",
    country: "Canada",
    lat: 48.41809844970703,
    lng: -123.38800048828125,
  },
  {
    id: "N",
    name: "Shushenskoye Airport",
    city: "Shushenskoye",
    country: "Russia",
    lat: 53.3849983215332,
    lng: 92.04499816894531,
  },
  {
    id: "N",
    name: "Stockerau Airport",
    city: "Stockerau",
    country: "Austria",
    lat: 48.40999984741211,
    lng: 16.191699981689453,
  },
  {
    id: "KLJ",
    name: "Klaipėda Airport",
    city: "Klaipeda",
    country: "Lithuania",
    lat: 55.7118988037,
    lng: 21.242799758900002,
  },
  {
    id: "N",
    name: "Iowa County Airport",
    city: "MINERAL POINT",
    country: "United States",
    lat: 42.886799,
    lng: -90.236198,
  },
  {
    id: "ETB",
    name: "West Bend Municipal Airport",
    city: "WEST BEND",
    country: "United States",
    lat: 43.4221992493,
    lng: -88.1278991699,
  },
  {
    id: "GLR",
    name: "Gaylord Regional Airport",
    city: "GAYLORD",
    country: "United States",
    lat: 45.013500213600004,
    lng: -84.7035980225,
  },
  {
    id: "AID",
    name: "Anderson Municipal Darlington Field",
    city: "ANDERSON",
    country: "United States",
    lat: 40.10860061649999,
    lng: -85.6129989624,
  },
  {
    id: "QND",
    name: "Cenej Airport",
    city: "Novi Sad",
    country: "Serbia",
    lat: 45.385799,
    lng: 19.839199,
  },
  {
    id: "GUU",
    name: "Grundarfjörður Airport",
    city: "Grundarfjordur",
    country: "Iceland",
    lat: 64.99140167236328,
    lng: -23.224700927734375,
  },
  {
    id: "PCD",
    name: "Prairie Du Chien Municipal Airport",
    city: "Prairie du Chien",
    country: "United States",
    lat: 43.019298553467,
    lng: -91.12370300293,
  },
  {
    id: "N",
    name: "Cascade Heliport",
    city: "Kobok",
    country: "Indonesia",
    lat: 47.512346,
    lng: -120.488691,
  },
  {
    id: "N",
    name: "Air Orlando Heliport",
    city: "Orlando",
    country: "United States",
    lat: 28.43560028076172,
    lng: -81.47309875488281,
  },
  {
    id: "N",
    name: "Tórshavn/Bodanes Heliport",
    city: "Torshavn",
    country: "Faroe Islands",
    lat: 62.02170181274414,
    lng: -6.757420063018799,
  },
  {
    id: "OTJ",
    name: "Otjiwarongo Airport",
    city: "Otjiwarongo",
    country: "Namibia",
    lat: -20.434700012207,
    lng: 16.660800933838,
  },
  {
    id: "N",
    name: "RAF Mona",
    city: "Mona",
    country: "United Kingdom",
    lat: 53.258598,
    lng: -4.37355,
  },
  {
    id: "N",
    name: "Rerik-Zweedorf Airport",
    city: "Rerik",
    country: "Germany",
    lat: 54.08194351196289,
    lng: 11.64916706085205,
  },
  {
    id: "N",
    name: "Fazenda Vaticano Airport",
    city: "Cruz",
    country: "Brazil",
    lat: -21.294443,
    lng: -56.11861,
  },
  {
    id: "N",
    name: "Stanly County Airport",
    city: "Albemarle",
    country: "United States",
    lat: 35.416698455811,
    lng: -80.150802612305,
  },
  {
    id: "N",
    name: "Davidson County Airport",
    city: "Lexington",
    country: "United States",
    lat: 35.78110122680664,
    lng: -80.30380249023438,
  },
  {
    id: "N",
    name: "Windwood Fly-In Resort Airport",
    city: "Davis",
    country: "United States",
    lat: 39.055099487300005,
    lng: -79.43139648440001,
  },
  {
    id: "N",
    name: "Lathan Strip",
    city: "Mocksville",
    country: "United States",
    lat: 34.87630081176758,
    lng: -80.61920166015625,
  },
  {
    id: "N",
    name: "Double Eagle II Airport",
    city: "Albuquerque",
    country: "United States",
    lat: 35.145198822021484,
    lng: -106.79499816894531,
  },
  {
    id: "N",
    name: "Socorro Municipal Airport",
    city: "Socorro",
    country: "United States",
    lat: 34.022499084472656,
    lng: -106.90299987792969,
  },
  {
    id: "N",
    name: "Bentonville Municipal-Louise M Thaden Field",
    city: "Bentonville",
    country: "United States",
    lat: 36.34569931,
    lng: -94.21929932,
  },
  {
    id: "N",
    name: "Blue Ridge Airport",
    city: "Martinsville",
    country: "United States",
    lat: 36.630699157714844,
    lng: -80.01830291748047,
  },
  {
    id: "N",
    name: "Mount Airy Surry County Airport",
    city: "Mount Airy",
    country: "United States",
    lat: 36.45970154,
    lng: -80.5530014,
  },
  {
    id: "TSM",
    name: "Taos Regional Airport",
    city: "Taos",
    country: "United States",
    lat: 36.45819855,
    lng: -105.6719971,
  },
  {
    id: "RTN",
    name: "Raton Municipal-Crews Field",
    city: "Raton",
    country: "United States",
    lat: 36.74150085,
    lng: -104.5019989,
  },
  {
    id: "N",
    name: "Rusk County Airport",
    city: "Ladysmith",
    country: "United States",
    lat: 45.49679946899414,
    lng: -91.00050354003906,
  },
  {
    id: "PPA",
    name: "Perry Lefors Field",
    city: "Pampa",
    country: "United States",
    lat: 35.612998962402,
    lng: -100.99600219727,
  },
  {
    id: "N",
    name: "William R. Pogue Municipal Airport",
    city: "Sand Springs",
    country: "United States",
    lat: 36.1753006,
    lng: -96.15180206,
  },
  {
    id: "FLP",
    name: "Marion County Regional Airport",
    city: "Flippin",
    country: "United States",
    lat: 36.29090118,
    lng: -92.59030151,
  },
  {
    id: "BGD",
    name: "Hutchinson County Airport",
    city: "Borger",
    country: "United States",
    lat: 35.700901031499995,
    lng: -101.393997192,
  },
  {
    id: "N",
    name: "Budaörs Airfield",
    city: "Budaoers",
    country: "Hungary",
    lat: 47.451099,
    lng: 18.9806,
  },
  {
    id: "N",
    name: "Jakabszállás Airport",
    city: "Jakabszallas",
    country: "Hungary",
    lat: 46.74720001220703,
    lng: 19.605600357055664,
  },
  {
    id: "HLE",
    name: "St. Helena Airport",
    city: "Longwood",
    country: "United Kingdom",
    lat: -15.957725,
    lng: -5.645943,
  },
  {
    id: "BNJ",
    name: "Bonn-Hangelar Airport",
    city: "Sankt-Augustin",
    country: "Germany",
    lat: 50.7688903809,
    lng: 7.16333293915,
  },
  {
    id: "NGK",
    name: "Nogliki Airport",
    city: "Nogliki",
    country: "Russia",
    lat: 51.780102,
    lng: 143.139008,
  },
  {
    id: "SQA",
    name: "Santa Ynez Airport",
    city: "Santa Ynez",
    country: "United States",
    lat: 34.60680008,
    lng: -120.0759964,
  },
  {
    id: "HXD",
    name: "Delingha Airport",
    city: "Haixi",
    country: "China",
    lat: 37.125286,
    lng: 97.268658,
  },
  {
    id: "BAR",
    name: "Qionghai Bo'ao Airport",
    city: "Qionghai",
    country: "China",
    lat: 19.13824,
    lng: 110.454775,
  },
  {
    id: "N",
    name: "Northeim Airport",
    city: "Northeim",
    country: "Germany",
    lat: 51.706390380859375,
    lng: 10.039722442626953,
  },
  {
    id: "N",
    name: "Reggio Emilia Airport",
    city: "Reggio Emilia",
    country: "Italy",
    lat: 44.698299,
    lng: 10.6628,
  },
  {
    id: "ZBO",
    name: "Bowen Airport",
    city: "Bowen",
    country: "Australia",
    lat: -20.018299102783203,
    lng: 148.21499633789062,
  },
  {
    id: "UCB",
    name: "Ulanqab Jining Airport",
    city: "Wulanchabu",
    country: "China",
    lat: 41.129722,
    lng: 113.108056,
  },
  {
    id: "KEO",
    name: "Odienne Airport",
    city: "Odienne",
    country: "Cote d'Ivoire",
    lat: 9.5,
    lng: -7.566999912261963,
  },
  {
    id: "GII",
    name: "Siguiri Airport",
    city: "Siguiri",
    country: "Guinea",
    lat: 11.432999610901,
    lng: -9.1669998168945,
  },
  {
    id: "NZE",
    name: "Nzérékoré Airport",
    city: "Nzerekore",
    country: "Guinea",
    lat: 7.8060193061829,
    lng: -8.7017974853516,
  },
  {
    id: "OCM",
    name: "Boolgeeda",
    city: "Brockman",
    country: "Australia",
    lat: -22.54,
    lng: 117.275,
  },
  {
    id: "WGN",
    name: "Shaoyang Wugang Airport",
    city: "Shaoyang",
    country: "China",
    lat: 26.802,
    lng: 110.642,
  },
  {
    id: "TXF",
    name: "9 de Maio - Teixeira de Freitas Airport",
    city: "Teixeira de Freitas",
    country: "Brazil",
    lat: -17.524499893188,
    lng: -39.66849899292,
  },
  {
    id: "SPA",
    name: "Spartanburg Downtown Memorial Airport",
    city: "Spartangurg",
    country: "United States",
    lat: 34.915699005127,
    lng: -81.956497192383,
  },
  {
    id: "BJW",
    name: "Bajawa Soa Airport",
    city: "Bajawa",
    country: "Indonesia",
    lat: -8.70743498008,
    lng: 121.057426929,
  },
  {
    id: "N",
    name: "Torgau-Beilrode Airport",
    city: "Gransee",
    country: "Germany",
    lat: 51.570907,
    lng: 13.051641,
  },
  {
    id: "NBN",
    name: "Annobón Airport",
    city: "San Antonio de Pale",
    country: "Equatorial Guinea",
    lat: -1.410277,
    lng: 5.621944,
  },
  {
    id: "N",
    name: "Renk Airport",
    city: "Huangshan",
    country: "China",
    lat: 11.8324692723,
    lng: 32.810497283900006,
  },
  {
    id: "OLL",
    name: "Oyo Ollombo Airport",
    city: "Oyo",
    country: "Congo (Brazzaville)",
    lat: -1.226666,
    lng: 15.91,
  },
  {
    id: "N",
    name: "Port Hardy Seaplane Base",
    city: "Port Hardy",
    country: "Canada",
    lat: 50.71670150756836,
    lng: -127.48300170898438,
  },
  {
    id: "PPF",
    name: "Tri-City Airport",
    city: "Parsons",
    country: "United States",
    lat: 37.32989883,
    lng: -95.5062027,
  },
  {
    id: "PCQ",
    name: "Boun Neau Airport",
    city: "Phongsaly",
    country: "Laos",
    lat: 21.6475,
    lng: 101.9,
  },
  {
    id: "AYS",
    name: "Waycross Ware County Airport",
    city: "Waycross",
    country: "United States",
    lat: 31.2490997314,
    lng: -82.39550018310001,
  },
  {
    id: "DSS",
    name: "Blaise Diagne International Airport",
    city: "Diass",
    country: "Senegal",
    lat: 14.67,
    lng: -17.073333,
  },
  {
    id: "N",
    name: "Mid-State Regional Airport",
    city: "Philipsburg",
    country: "United States",
    lat: 40.884399414062,
    lng: -78.087303161621,
  },
  {
    id: "PMH",
    name: "Greater Portsmouth Regional Airport",
    city: "Portsmouth",
    country: "United States",
    lat: 38.8404998779,
    lng: -82.84729766850002,
  },
  {
    id: "N",
    name: "Coonawarra Airport",
    city: "Coonawarra",
    country: "Australia",
    lat: -37.28329849243164,
    lng: 140.8000030517578,
  },
  {
    id: "NAC",
    name: "Naracoorte Airport",
    city: "Naracoorte",
    country: "Australia",
    lat: -36.98529815673828,
    lng: 140.72500610351562,
  },
  {
    id: "N",
    name: "Camilla Mitchell County Airport",
    city: "Camilla",
    country: "United States",
    lat: 31.212900161743164,
    lng: -84.23680114746094,
  },
  {
    id: "N",
    name: "Clarenville Airport",
    city: "Clarenville",
    country: "Canada",
    lat: 48.27470016479492,
    lng: -53.92390060424805,
  },
  {
    id: "PGZ",
    name: "Ponta Grossa Airport - Comandante Antonio Amilton Beraldo",
    city: "Ponta Grossa",
    country: "Brazil",
    lat: -25.1847,
    lng: -50.1441,
  },
  {
    id: "PQM",
    name: "Palenque International Airport",
    city: "Palenque",
    country: "Mexico",
    lat: 17.533153,
    lng: -92.015484,
  },
  {
    id: "CUD",
    name: "Caloundra Airport",
    city: "Caloundra",
    country: "Australia",
    lat: -26.799999237060547,
    lng: 153.10000610351562,
  },
  {
    id: "CLP",
    name: "Clarks Point Airport",
    city: "Clarks Point",
    country: "United States",
    lat: 58.83369827,
    lng: -158.529007,
  },
  {
    id: "N",
    name: "Ospika Airport",
    city: "Williston Lake",
    country: "Canada",
    lat: 56.275001525878906,
    lng: -124.052001953125,
  },
  {
    id: "N",
    name: "Charlottetown Airport",
    city: "Charlottetown",
    country: "Canada",
    lat: 52.76499938964844,
    lng: -56.1156005859375,
  },
  {
    id: "JOJ",
    name: "Doris Lake",
    city: "Doris Lake",
    country: "Canada",
    lat: 68.1252746582,
    lng: -106.585281372,
  },
  {
    id: "ECI",
    name: "Costa Esmeralda Airport",
    city: "Tola",
    country: "Nicaragua",
    lat: 11.427542,
    lng: -86.033361,
  },
  {
    id: "N",
    name: "Monte Cristi Airport",
    city: "Montecristi",
    country: "Dominican Republic",
    lat: 19.865299224900003,
    lng: -71.6453018188,
  },
  {
    id: "N",
    name: "El Papalon Airport",
    city: "San Miguel",
    country: "El Salvador",
    lat: 13.444100379943848,
    lng: -88.12699890136719,
  },
  {
    id: "N",
    name: "Sandpoint Airport",
    city: "Sandpoint",
    country: "United States",
    lat: 48.299499511719,
    lng: -116.55999755859,
  },
  {
    id: "QGQ",
    name: "Attu Heliport",
    city: "Attu",
    country: "Greenland",
    lat: 67.9406628551,
    lng: -53.6218696833,
  },
  {
    id: "QPW",
    name: "Kangaatsiaq Heliport",
    city: "Kangaatsiaq",
    country: "Greenland",
    lat: 68.3126574861,
    lng: -53.4602075815,
  },
  {
    id: "QJE",
    name: "Kitsissuarsuit Heliport",
    city: "Kitsissuarsuit",
    country: "Greenland",
    lat: 68.85792599759999,
    lng: -53.123295307199996,
  },
  {
    id: "N",
    name: "Niaqornaarsuk Heliport",
    city: "Niaqornaarsuk",
    country: "Greenland",
    lat: 68.236381,
    lng: -52.852148,
  },
  {
    id: "XIQ",
    name: "Ilimanaq Heliport",
    city: "Ilimanaq",
    country: "Greenland",
    lat: 69.0809150007,
    lng: -51.1143153906,
  },
  {
    id: "QQT",
    name: "Qeqertaq Heliport",
    city: "Qeqertaq",
    country: "Greenland",
    lat: 69.9958611087,
    lng: -51.3009166718,
  },
  {
    id: "N",
    name: "Saqqaq Heliport",
    city: "Saqqaq",
    country: "Greenland",
    lat: 70.011448,
    lng: -51.932142,
  },
  {
    id: "N",
    name: "Savissivik Heliport",
    city: "Savissivik",
    country: "Greenland",
    lat: 76.01861346460001,
    lng: -65.1176834106,
  },
  {
    id: "N",
    name: "Siorapaluk Heliport",
    city: "Siorapaluk",
    country: "Greenland",
    lat: 77.7865173475,
    lng: -70.6386566162,
  },
  {
    id: "N",
    name: "Aappilattoq (Qaasuitsup) Heliport",
    city: "Aappilattoq",
    country: "Greenland",
    lat: 72.8870298223,
    lng: -55.5962866545,
  },
  {
    id: "N",
    name: "Innarsuit Heliport",
    city: "Innaarsuit",
    country: "Greenland",
    lat: 73.1998953377,
    lng: -56.0108166933,
  },
  {
    id: "N",
    name: "Kangersuatsiaq Heliport",
    city: "Kangersuatsiaq",
    country: "Greenland",
    lat: 72.38109155069999,
    lng: -55.53658604619999,
  },
  {
    id: "N",
    name: "Kullorsuaq Heliport",
    city: "Kullorsuaq",
    country: "Greenland",
    lat: 74.5780498288,
    lng: -57.226828336699995,
  },
  {
    id: "N",
    name: "Nuussuaq Heliport",
    city: "Nuussuaq",
    country: "Greenland",
    lat: 74.1098528514,
    lng: -57.065037488899996,
  },
  {
    id: "N",
    name: "Tasiusaq (Qaasuitsup) Heliport",
    city: "Tasiusaq",
    country: "Greenland",
    lat: 73.37305450439999,
    lng: -56.060279846200004,
  },
  {
    id: "N",
    name: "Upernavik Kujalleq Heliport",
    city: "Upernavik Kujalleq",
    country: "Greenland",
    lat: 72.1527425265,
    lng: -55.5309855938,
  },
  {
    id: "N",
    name: "Aappilattoq (Kujalleq) Heliport",
    city: "Aappilattoq",
    country: "Greenland",
    lat: 60.148357,
    lng: -44.286916,
  },
  {
    id: "N",
    name: "Tasiusaq (Kujalleq) Heliport",
    city: "Tasiusaq",
    country: "Greenland",
    lat: 60.1943053097,
    lng: -44.8134469986,
  },
  {
    id: "N",
    name: "Narsaq Kujalleq Heliport",
    city: "Narsaq Kujalleq",
    country: "Greenland",
    lat: 60.004694,
    lng: -44.656935,
  },
  {
    id: "QJI",
    name: "Ikamiut Heliport",
    city: "Ikamiut",
    country: "Greenland",
    lat: 68.6342530984,
    lng: -51.8322622776,
  },
  {
    id: "N",
    name: "Ammassivik Heliport",
    city: "Ammassivik",
    country: "Greenland",
    lat: 60.597376,
    lng: -45.382445,
  },
  {
    id: "QFG",
    name: "Eqalugaarsuit Heliport",
    city: "Eqalugaarsuit",
    country: "Greenland",
    lat: 60.6197196536,
    lng: -45.9140619636,
  },
  {
    id: "N",
    name: "Qassimiut Heliport",
    city: "Qassimiut",
    country: "Greenland",
    lat: 60.7809592284,
    lng: -47.156249284699996,
  },
  {
    id: "N",
    name: "Tiniteqilaaq Heliport",
    city: "Tiniteqilaaq",
    country: "Greenland",
    lat: 65.8920273392,
    lng: -37.7834093571,
  },
  {
    id: "N",
    name: "Isortoq Heliport",
    city: "Isortoq",
    country: "Greenland",
    lat: 65.5477923903,
    lng: -38.9765524864,
  },
  {
    id: "N",
    name: "Kuummiut Heliport",
    city: "Kuummiit",
    country: "Greenland",
    lat: 65.8639347361,
    lng: -36.9979190826,
  },
  {
    id: "N",
    name: "Sermiligaaq Heliport",
    city: "Sermiligaaq",
    country: "Greenland",
    lat: 65.9059197626,
    lng: -36.3782536983,
  },
  {
    id: "QRY",
    name: "Ikerassaarsuk Heliport",
    city: "Ikerasaarsuk",
    country: "Greenland",
    lat: 68.14088100629999,
    lng: -53.4414589405,
  },
  {
    id: "N",
    name: "Illorsuit Heliport",
    city: "Illorsuit",
    country: "Greenland",
    lat: 71.2419440428,
    lng: -53.5628771782,
  },
  {
    id: "N",
    name: "Nuugaatsiaq Heliport",
    city: "Nuugaatsiaq",
    country: "Greenland",
    lat: 71.5387687528,
    lng: -53.205038309100004,
  },
  {
    id: "N",
    name: "Saattut Heliport",
    city: "Saattut",
    country: "Greenland",
    lat: 70.8111719824,
    lng: -51.6312897205,
  },
  {
    id: "N",
    name: "Ikerasak Heliport",
    city: "Ikerasak",
    country: "Greenland",
    lat: 70.4981453548,
    lng: -51.3030838966,
  },
  {
    id: "N",
    name: "Niaqornat Heliport",
    city: "Niaqornat",
    country: "Greenland",
    lat: 70.7893846882,
    lng: -53.6629450321,
  },
  {
    id: "N",
    name: "Ukkusissat Heliport",
    city: "Ukkusissat",
    country: "Greenland",
    lat: 71.0494384946,
    lng: -51.8900156021,
  },
  {
    id: "N",
    name: "Olhos D`água Airport",
    city: "Agua Boa",
    country: "Brazil",
    lat: -14.019444,
    lng: -52.152222,
  },
  {
    id: "NPR",
    name: "Novo Progresso Airport",
    city: "Novo Progresso",
    country: "Brazil",
    lat: -7.125833,
    lng: -55.400833,
  },
  {
    id: "SMT",
    name: "Adolino Bedin Regional Airport",
    city: "Sorriso",
    country: "Brazil",
    lat: -12.479177,
    lng: -55.672341,
  },
  {
    id: "N",
    name: "Serra da Capivara Airport",
    city: "Sao Raimundo Nonato",
    country: "Brazil",
    lat: -9.082778,
    lng: -42.644444,
  },
  {
    id: "ENO",
    name: "Encarnación Airport",
    city: "Encarnacion",
    country: "Paraguay",
    lat: -27.227366,
    lng: -55.837495,
  },
  {
    id: "N",
    name: "Amatopo Airstrip",
    city: "Amatopo",
    country: "Suriname",
    lat: 3.547885,
    lng: -57.633958,
  },
  {
    id: "N",
    name: "Poeketi Airstrip",
    city: "Poeketi",
    country: "Suriname",
    lat: 4.126389,
    lng: -54.623611,
  },
  {
    id: "N",
    name: "Godo Holo Airstrip",
    city: "Pikienkondre of Miranda",
    country: "Suriname",
    lat: 4.0583,
    lng: -54.7861,
  },
  {
    id: "N",
    name: "Anholt Airport",
    city: "Anholt",
    country: "Denmark",
    lat: 56.698898315399994,
    lng: 11.5558996201,
  },
  {
    id: "N",
    name: "St Pierre d'Oléron Airfield",
    city: "Saint Pierre d'Oleron",
    country: "France",
    lat: 45.959202,
    lng: -1.31611,
  },
  {
    id: "N",
    name: "Semur En Auxois Airfield",
    city: "Semur en Auxois",
    country: "France",
    lat: 47.481899,
    lng: 4.34417,
  },
  {
    id: "UZR",
    name: "Urzhar Airport",
    city: "Urzhar",
    country: "Kazakhstan",
    lat: 47.09115,
    lng: 81.66521,
  },
  {
    id: "N",
    name: "Pyramiden Heliport",
    city: "Pyramiden",
    country: "Norway",
    lat: 78.652322,
    lng: 16.337208,
  },
  {
    id: "N",
    name: "Lipki Air Base",
    city: "Minsk",
    country: "Belarus",
    lat: 53.913545,
    lng: 27.708775,
  },
  {
    id: "N",
    name: "Zermatt  Heliport",
    city: "Zermatt",
    country: "Switzerland",
    lat: 46.029319763183594,
    lng: 7.753366470336914,
  },
  {
    id: "N",
    name: "Nikolskoye Airport",
    city: "Nikolskoye",
    country: "Russia",
    lat: 55.1783332824707,
    lng: 166.04833984375,
  },
  {
    id: "N",
    name: "Tilichiki Airport",
    city: "Tilichiki",
    country: "Russia",
    lat: 60.3828010559082,
    lng: 166.0260009765625,
  },
  {
    id: "NYR",
    name: "Nyurba Airport",
    city: "Nyurba",
    country: "Russia",
    lat: 63.294998,
    lng: 118.336998,
  },
  {
    id: "SUK",
    name: "Sakkyryr Airport",
    city: "Batagay-Alyta",
    country: "Russia",
    lat: 67.792,
    lng: 130.394,
  },
  {
    id: "UKG",
    name: "Ust-Kuyga Airport",
    city: "Ust-Kuyga",
    country: "Russia",
    lat: 70.011001586914,
    lng: 135.64500427246,
  },
  {
    id: "VHV",
    name: "Verkhnevilyuisk Airport",
    city: "Verkhnevilyuysk",
    country: "Russia",
    lat: 63.458057403564,
    lng: 120.26916503906,
  },
  {
    id: "DEE",
    name: "Mendeleyevo Airport",
    city: "Yuzhno-Kurilsk",
    country: "Russia",
    lat: 43.9584007263,
    lng: 145.682998657,
  },
  {
    id: "N",
    name: "Yamburg Airport",
    city: "Yamburg",
    country: "Russia",
    lat: 67.986664,
    lng: 75.099998,
  },
  {
    id: "EKS",
    name: "Shakhtyorsk Airport",
    city: "Shakhtyorsk",
    country: "Russia",
    lat: 49.1903,
    lng: 142.082993,
  },
  {
    id: "TLK",
    name: "Talakan Airport",
    city: "Talakan",
    country: "Russia",
    lat: 59.876389,
    lng: 111.044444,
  },
  {
    id: "N",
    name: "Mama Airport",
    city: "Mama",
    country: "Russia",
    lat: 58.313331604003906,
    lng: 112.88999938964844,
  },
  {
    id: "N",
    name: "Aarhus Seaplne Terminal",
    city: "Aarhus",
    country: "Denmark",
    lat: 56.151717,
    lng: 10.248428,
  },
  {
    id: "N",
    name: "Oakland Troy Airport",
    city: "Troy",
    country: "United States",
    lat: 42.54290009,
    lng: -83.17790222,
  },
  {
    id: "N",
    name: "Stratford Municipal Airport",
    city: "Stratford",
    country: "Canada",
    lat: 43.415599823,
    lng: -80.93440246579999,
  },
  {
    id: "N",
    name: "Edmundston Airport",
    city: "Edmundston",
    country: "Canada",
    lat: 47.4906005859375,
    lng: -68.48190307617188,
  },
  {
    id: "RDB",
    name: "Red Dog Airport",
    city: "Red Dog",
    country: "United States",
    lat: 68.03209686279999,
    lng: -162.899002075,
  },
  {
    id: "ION",
    name: "Impfondo Airport",
    city: "Impfondo",
    country: "Congo (Brazzaville)",
    lat: 1.6169999837875366,
    lng: 18.066999435424805,
  },
  {
    id: "EBH",
    name: "El Bayadh Airport",
    city: "El Bayadh",
    country: "Algeria",
    lat: 33.721666666699996,
    lng: 1.0925,
  },
  {
    id: "ZIS",
    name: "Alzintan Airport",
    city: "Zintan",
    country: "Libya",
    lat: 31.774878,
    lng: 12.25006,
  },
  {
    id: "MYZ",
    name: "Monkey Bay Airport",
    city: "Monkey Bay",
    country: "Malawi",
    lat: -14.083600044299999,
    lng: 34.9197006226,
  },
  {
    id: "N",
    name: "Suwałki Airport",
    city: "Suwalki",
    country: "Poland",
    lat: 54.07279968261719,
    lng: 22.899200439453125,
  },
  {
    id: "N",
    name: "Srr Ahmadu Bello International Airport",
    city: "Birnin Kebbi",
    country: "Nigeria",
    lat: 12.480556,
    lng: 4.369445,
  },
  {
    id: "BCU",
    name: "Sir Abubakar Tafawa Balewa International Airport",
    city: "Bauchi",
    country: "Nigeria",
    lat: 10.482833,
    lng: 9.744,
  },
  {
    id: "GMO",
    name: "Gombe Lawanti International Airport",
    city: "Gombe",
    country: "Nigeria",
    lat: 10.298333333299999,
    lng: 10.896388888899999,
  },
  {
    id: "N",
    name: "Dutse International Airport",
    city: "Dutse",
    country: "Nigeria",
    lat: 11.795168,
    lng: 9.311667,
  },
  {
    id: "N",
    name: "Jalingo Airport",
    city: "Jalingo",
    country: "Nigeria",
    lat: 8.900587,
    lng: 11.27946,
  },
  {
    id: "KDA",
    name: "Kolda North Airport",
    city: "Kolda",
    country: "Senegal",
    lat: 12.898500442504883,
    lng: -14.968099594116211,
  },
  {
    id: "SHO",
    name: "King Mswati III International Airport",
    city: "Manzini",
    country: "Swaziland",
    lat: -26.358611,
    lng: 31.716944,
  },
  {
    id: "KIY",
    name: "Kilwa Masoko Airport",
    city: "Kilwa Masoko",
    country: "Tanzania",
    lat: -8.91123,
    lng: 39.508619,
  },
  {
    id: "N",
    name: "West Kilimanjaro Airport",
    city: "Kilimanjaro",
    country: "Tanzania",
    lat: -3.049999952316284,
    lng: 37.0,
  },
  {
    id: "QSI",
    name: "Moshi Airport",
    city: "Moshi",
    country: "Tanzania",
    lat: -3.3633298873901367,
    lng: 37.326900482177734,
  },
  {
    id: "MNS",
    name: "Mansa Airport",
    city: "Mansa",
    country: "Zambia",
    lat: -11.13700008392334,
    lng: 28.872600555419922,
  },
  {
    id: "GZI",
    name: "Ghazni Airport",
    city: "Ghazni",
    country: "Afghanistan",
    lat: 33.5312004089,
    lng: 68.412902832,
  },
  {
    id: "DBC",
    name: "Baicheng Chang'an Airport",
    city: "Baicheng",
    country: "China",
    lat: 45.505278,
    lng: 123.019722,
  },
  {
    id: "LNL",
    name: "Longnan Chengzhou Airport",
    city: "Longnan",
    country: "China",
    lat: 33.788,
    lng: 105.797,
  },
  {
    id: "SQD",
    name: "Shangrao Sanqingshan Airport",
    city: "Shangrao",
    country: "China",
    lat: 28.3797,
    lng: 117.9643,
  },
  {
    id: "YSQ",
    name: "Songyuan Chaganhu Airport",
    city: "Songyuan",
    country: "China",
    lat: 44.938114,
    lng: 124.550178,
  },
  {
    id: "JSJ",
    name: "Jiansanjiang Airport",
    city: "Jiansanjiang",
    country: "China",
    lat: 47.11,
    lng: 132.660278,
  },
  {
    id: "WMT",
    name: "Zunyi Maotai Airport",
    city: "Zunyi",
    country: "China",
    lat: 27.81638,
    lng: 106.33268,
  },
  {
    id: "LLB",
    name: "Libo Airport",
    city: "Libo",
    country: "China",
    lat: 25.4525,
    lng: 107.961667,
  },
  {
    id: "CDE",
    name: "Chengde Puning Airport",
    city: "Chengde",
    country: "China",
    lat: 41.1225,
    lng: 118.073889,
  },
  {
    id: "DTU",
    name: "Wudalianchi Dedu Airport",
    city: "Wudalianchi",
    country: "China",
    lat: 48.445,
    lng: 126.133,
  },
  {
    id: "EJN",
    name: "Ejin Banner-Taolai Airport",
    city: "Ejin Banner",
    country: "China",
    lat: 42.0155,
    lng: 101.0005,
  },
  {
    id: "RHT",
    name: "Alxa Right Banner Badanjilin Airport",
    city: "Alxa Right Banner",
    country: "China",
    lat: 39.225,
    lng: 101.546,
  },
  {
    id: "HUO",
    name: "Holingol Huolinhe Airport",
    city: "Holingol",
    country: "China",
    lat: 45.487222,
    lng: 119.407222,
  },
  {
    id: "GMQ",
    name: "Golog Maqin Airport",
    city: "Golog",
    country: "China",
    lat: 34.418066,
    lng: 100.301144,
  },
  {
    id: "QSZ",
    name: "Yeerqiang Airport",
    city: "Yarkant",
    country: "China",
    lat: 38.281055,
    lng: 77.075192,
  },
  {
    id: "TEI",
    name: "Tezu Airport",
    city: "Tezu",
    country: "India",
    lat: 27.9412002563,
    lng: 96.1343994141,
  },
  {
    id: "CWJ",
    name: "Cangyuan Washan Airport",
    city: "Cangyuan",
    country: "China",
    lat: 23.273889,
    lng: 99.373611,
  },
  {
    id: "JMJ",
    name: "Lancang Jingmai Airport",
    city: "Lancang Lahu",
    country: "China",
    lat: 22.415833,
    lng: 99.786389,
  },
  {
    id: "NLH",
    name: "Ninglang Luguhu Airport",
    city: "Ninglang",
    country: "China",
    lat: 27.5403,
    lng: 100.7593,
  },
  {
    id: "PBQ",
    name: "Pimenta Bueno Airport",
    city: "Pimenta Bueno",
    country: "Brazil",
    lat: -11.641599655151367,
    lng: -61.179100036621094,
  },
  {
    id: "N",
    name: "Ariquemes Airport",
    city: "ARIQUEMES",
    country: "Brazil",
    lat: -9.884721755981445,
    lng: -63.04888916015625,
  },
  {
    id: "N",
    name: "Fazenda Spartacus Airport",
    city: "COLNIZA",
    country: "Brazil",
    lat: -24.0,
    lng: -48.608333587646484,
  },
  {
    id: "WUT",
    name: "Xinzhou Wutaishan Airport",
    city: "Xinzhou",
    country: "China",
    lat: 38.597456,
    lng: 112.969173,
  },
  {
    id: "NZL",
    name: "Chengjisihan Airport",
    city: "Zhalantun",
    country: "China",
    lat: 47.865833,
    lng: 122.767503,
  },
  {
    id: "N",
    name: "Fazenda Mequens Airport",
    city: "ALTA FLORESTA D'OESTE",
    country: "Brazil",
    lat: -13.061944007873535,
    lng: -62.25749969482422,
  },
  {
    id: "N",
    name: "Prainha Airport",
    city: "APUI",
    country: "Brazil",
    lat: -7.17287015914917,
    lng: -59.839599609375,
  },
  {
    id: "N",
    name: "Mostardas Airport",
    city: "SANTO ANTONIO DO MATUPI",
    country: "Brazil",
    lat: -31.103599548339844,
    lng: -50.910301208496094,
  },
  {
    id: "N",
    name: "Santo Domingo Airport",
    city: "CONSELVAN",
    country: "Brazil",
    lat: -33.65639877319336,
    lng: -71.6144027709961,
  },
  {
    id: "AIP",
    name: "Adampur Airport",
    city: "Adampur",
    country: "India",
    lat: 31.4338,
    lng: 75.758797,
  },
  {
    id: "VDY",
    name: "Vijayanagar Aerodrome (JSW)",
    city: "Toranagallu",
    country: "India",
    lat: 15.1749666667,
    lng: 76.6349472222,
  },
  {
    id: "SAG",
    name: "Shirdi Airport",
    city: "Shirdi",
    country: "India",
    lat: 19.688611,
    lng: 74.378889,
  },
  {
    id: "PYB",
    name: "Jeypore Airport",
    city: "Jeypore",
    country: "India",
    lat: 18.8799991607666,
    lng: 82.552001953125,
  },
  {
    id: "SUP",
    name: "Trunojoyo Airport",
    city: "Sumenep",
    country: "Indonesia",
    lat: -7.0242,
    lng: 113.89023,
  },
  {
    id: "N",
    name: "Lasondre Airport",
    city: "Batu Islands",
    country: "Indonesia",
    lat: -0.01924,
    lng: 98.30097,
  },
  {
    id: "RKO",
    name: "Rokot Airport",
    city: "Sipora",
    country: "Indonesia",
    lat: -2.0991199016571045,
    lng: 99.70069885253906,
  },
  {
    id: "PPR",
    name: "Pasir Pangaraan Airport",
    city: "Pasir Pangaraian",
    country: "Indonesia",
    lat: 0.8454310297966003,
    lng: 100.37000274658203,
  },
  {
    id: "TJB",
    name: "Sei Bati Airport",
    city: "Tanjung Balai Karimun",
    country: "Indonesia",
    lat: 1.0527,
    lng: 103.3931,
  },
  {
    id: "KRC",
    name: "Departi Parbo Airport",
    city: "Kerinci Regency",
    country: "Indonesia",
    lat: -2.093,
    lng: 101.4683,
  },
  {
    id: "NRE",
    name: "Namrole Airport",
    city: "Buru Island",
    country: "Indonesia",
    lat: -3.8548,
    lng: 126.7012,
  },
  {
    id: "NAM",
    name: "Namlea Airport",
    city: "Namlea",
    country: "Indonesia",
    lat: -3.235569953918457,
    lng: 127.0999984741211,
  },
  {
    id: "DOB",
    name: "Rar Gwamar Airport",
    city: "Dobo",
    country: "Indonesia",
    lat: -5.7722201347399995,
    lng: 134.212005615,
  },
  {
    id: "SQN",
    name: "Emalamo Sanana Airport",
    city: "Sanana",
    country: "Indonesia",
    lat: -2.080509901046753,
    lng: 125.96700286865234,
  },
  {
    id: "AYW",
    name: "Ayawasi Airport",
    city: "Ayawasi",
    country: "Indonesia",
    lat: -1.1593,
    lng: 132.4633,
  },
  {
    id: "BYQ",
    name: "Bunyu Airport",
    city: "Bunyu",
    country: "Indonesia",
    lat: 3.45571994781,
    lng: 117.866996765,
  },
  {
    id: "UOL",
    name: "Buol Airport",
    city: "Buol",
    country: "Indonesia",
    lat: 1.1027,
    lng: 121.4141,
  },
  {
    id: "RAQ",
    name: "Sugimanuru Airport",
    city: "Raha",
    country: "Indonesia",
    lat: -4.760557,
    lng: 122.569371,
  },
  {
    id: "JSK",
    name: "Jask Airport",
    city: "Jask",
    country: "Iran",
    lat: 25.653601,
    lng: 57.799301,
  },
  {
    id: "N",
    name: "Frankfort Dow Memorial Field",
    city: "Frankfort",
    country: "United States",
    lat: 44.62519836425781,
    lng: -86.20079803466797,
  },
  {
    id: "N",
    name: "Cheboygan County Airport",
    city: "Cheboygan",
    country: "United States",
    lat: 45.65370178,
    lng: -84.51930237,
  },
  {
    id: "N",
    name: "Kozushima Airport",
    city: "Kozushima",
    country: "Japan",
    lat: 34.189998626699996,
    lng: 139.134002686,
  },
  {
    id: "N",
    name: "Kazarman Airport",
    city: "Kazarman",
    country: "Kyrgyzstan",
    lat: 41.4102908129,
    lng: 74.044418335,
  },
  {
    id: "N",
    name: "Kerben Airport",
    city: "Kerben",
    country: "Kyrgyzstan",
    lat: 41.484500885,
    lng: 71.7337036133,
  },
  {
    id: "N",
    name: "Naryn Airport",
    city: "Naryn",
    country: "Kyrgyzstan",
    lat: 41.44150161739999,
    lng: 76.13059997559999,
  },
  {
    id: "ZBY",
    name: "Sayaboury Airport",
    city: "Sainyabuli",
    country: "Laos",
    lat: 19.2436,
    lng: 101.7093,
  },
  {
    id: "BGL",
    name: "Baglung Airport",
    city: "Baglung",
    country: "Nepal",
    lat: 28.212799072265625,
    lng: 83.66629791259766,
  },
  {
    id: "RJB",
    name: "Rajbiraj Airport",
    city: "Rajbiraj",
    country: "Nepal",
    lat: 26.510066,
    lng: 86.733902,
  },
  {
    id: "DQM",
    name: "Duqm International Airport",
    city: "Duqm",
    country: "Oman",
    lat: 19.501944,
    lng: 57.634167,
  },
  {
    id: "N",
    name: "Palanan Community Airport",
    city: "Palanan",
    country: "Philippines",
    lat: 17.065667,
    lng: 122.427671,
  },
  {
    id: "N",
    name: "Itbayat Airport",
    city: "Itbayat",
    country: "Philippines",
    lat: 20.722521,
    lng: 121.809969,
  },
  {
    id: "N",
    name: "Catbalogan Airport",
    city: "Catbalogan City",
    country: "Philippines",
    lat: 11.81,
    lng: 124.83,
  },
  {
    id: "N",
    name: "Maasin Airport",
    city: "Maasin",
    country: "Philippines",
    lat: 10.187299728393555,
    lng: 124.78199768066406,
  },
  {
    id: "N",
    name: "Bantayan Airport",
    city: "Bantayan",
    country: "Philippines",
    lat: 11.1624,
    lng: 123.7848,
  },
  {
    id: "N",
    name: "Biliran Airport",
    city: "Biliran",
    country: "Philippines",
    lat: 11.5159178299,
    lng: 124.428985119,
  },
  {
    id: "N",
    name: "Fazenda Várzea Funda Airport",
    city: "PRIMAVERA D'OESTE",
    country: "Brazil",
    lat: -16.58361053466797,
    lng: -57.73222351074219,
  },
  {
    id: "N",
    name: "Primavera do Leste Airport",
    city: "PRIMAVERA DO LESTE",
    country: "Brazil",
    lat: -15.565555572509766,
    lng: -54.33777618408203,
  },
  {
    id: "CKI",
    name: "Croker Island Airport",
    city: "Croker Island",
    country: "Australia",
    lat: -11.164999961853027,
    lng: 132.48300170898438,
  },
  {
    id: "N",
    name: "The Granites Airport",
    city: "The Granites",
    country: "Australia",
    lat: -20.54829978942871,
    lng: 130.3470001220703,
  },
  {
    id: "BYP",
    name: "Barimunya Airport",
    city: "Barimunya",
    country: "Australia",
    lat: -22.673900604248,
    lng: 119.16600036621,
  },
  {
    id: "LUC",
    name: "Laucala Island Airport",
    city: "Laucala",
    country: "Fiji",
    lat: -16.74810028076172,
    lng: -179.66700744628906,
  },
  {
    id: "YAS",
    name: "Yasawa Island Airport",
    city: "Yasawa Island",
    country: "Fiji",
    lat: -16.758899688720703,
    lng: 177.5449981689453,
  },
  {
    id: "N",
    name: "North Shore Aerodrome",
    city: "North Shore",
    country: "New Zealand",
    lat: -36.656700134277344,
    lng: 174.65499877929688,
  },
  {
    id: "N",
    name: "John C Tune Airport",
    city: "Nashville",
    country: "United States",
    lat: 36.18239974975586,
    lng: -86.88670349121094,
  },
  {
    id: "N",
    name: "Okiwi Station Airport",
    city: "Okiwi",
    country: "New Zealand",
    lat: -36.146400451660156,
    lng: 175.41900634765625,
  },
  {
    id: "WIK",
    name: "Waiheke Reeve Airport",
    city: "Waiheke Island",
    country: "New Zealand",
    lat: -36.80889892578125,
    lng: 175.08599853515625,
  },
  {
    id: "N",
    name: "Karamea Airport",
    city: "Karamea",
    country: "New Zealand",
    lat: -41.236698150634766,
    lng: 172.10499572753906,
  },
  {
    id: "N",
    name: "Jastarnia Airport",
    city: "Jastarnia",
    country: "Poland",
    lat: 54.71028137207031,
    lng: 18.645280838012695,
  },
  {
    id: "DEX",
    name: "Nop Goliat Airport",
    city: "Dekai",
    country: "Indonesia",
    lat: -4.8557,
    lng: 139.482006,
  },
  {
    id: "NAU",
    name: "Napuka Island Airport",
    city: "Napuka",
    country: "French Polynesia",
    lat: -14.176799774169922,
    lng: -141.26699829101562,
  },
  {
    id: "FAC",
    name: "Faaite Airport",
    city: "Faaite",
    country: "French Polynesia",
    lat: -16.68670082092285,
    lng: -145.32899475097656,
  },
  {
    id: "NUK",
    name: "Nukutavake Airport",
    city: "Nukutavake",
    country: "French Polynesia",
    lat: -19.28499984741211,
    lng: -138.77200317382812,
  },
  {
    id: "VHZ",
    name: "Vahitahi Airport",
    city: "Vahitahi",
    country: "French Polynesia",
    lat: -18.780000686645508,
    lng: -138.85299682617188,
  },
  {
    id: "HHZ",
    name: "Hikueru Atoll Airport",
    city: "Hikueru",
    country: "French Polynesia",
    lat: -17.544700622558594,
    lng: -142.61399841308594,
  },
  {
    id: "RRR",
    name: "Raroia Airport",
    city: "Raroia",
    country: "French Polynesia",
    lat: -16.045,
    lng: -142.476944,
  },
  {
    id: "KHZ",
    name: "Kauehi Airport",
    city: "Kauehi",
    country: "French Polynesia",
    lat: -15.780799865722656,
    lng: -145.12399291992188,
  },
  {
    id: "TKV",
    name: "Tatakoto Airport",
    city: "Tatakoto",
    country: "French Polynesia",
    lat: -17.355300903320312,
    lng: -138.44500732421875,
  },
  {
    id: "TDS",
    name: "Sasereme Airport",
    city: "Sasereme",
    country: "Papua New Guinea",
    lat: -7.6217,
    lng: 142.868,
  },
  {
    id: "TMH",
    name: "Tanah Merah Airport",
    city: "Boven Digoel",
    country: "Indonesia",
    lat: -6.099219799041748,
    lng: 140.29800415039062,
  },
  {
    id: "N",
    name: "Denali Airport",
    city: "McKinley Park",
    country: "United States",
    lat: 63.64509963989258,
    lng: -148.79800415039062,
  },
  {
    id: "N",
    name: "Comte. Rolim Adolfo Amaro–Jundiaí State Airport",
    city: "Jundiai",
    country: "Brazil",
    lat: -23.180369,
    lng: -46.944408,
  },
  {
    id: "N",
    name: "Potomac Airpark",
    city: "Berkeley Springs",
    country: "United States",
    lat: 39.69260025024414,
    lng: -78.16609954833984,
  },
  {
    id: "N",
    name: "Helisul IV Heliport",
    city: "Foz Do Iguacu",
    country: "Brazil",
    lat: -25.613056182861328,
    lng: -54.39805603027344,
  },
  {
    id: "N",
    name: "Brits Airport",
    city: "Brits",
    country: "South Africa",
    lat: -25.53230094909668,
    lng: 27.77589988708496,
  },
  {
    id: "N",
    name: "West Melton Aerodrome",
    city: "West Melton",
    country: "New Zealand",
    lat: -43.47669982910156,
    lng: 172.39700317382812,
  },
  {
    id: "N",
    name: "Rangiora Airfield",
    city: "Rangiora",
    country: "New Zealand",
    lat: -43.290000915527344,
    lng: 172.54200744628906,
  },
  {
    id: "N",
    name: "Fazenda Jatobasso Airport",
    city: "JARU",
    country: "Brazil",
    lat: -22.429166793823242,
    lng: -55.53333282470703,
  },
  {
    id: "N",
    name: "FIC Heliport",
    city: "MACHADINHO D'OESTE",
    country: "Brazil",
    lat: -22.711389541625977,
    lng: -47.141109466552734,
  },
  {
    id: "NKB",
    name: "Noonkanbah Airport",
    city: "Noonkanbah",
    country: "Australia",
    lat: -18.4946994781,
    lng: 124.851997375,
  },
  {
    id: "AEI",
    name: "Algeciras Heliport",
    city: "Algeciras",
    country: "Spain",
    lat: 36.12888,
    lng: -5.441118,
  },
  {
    id: "N",
    name: "Chepelevka Airport",
    city: "Uzyn",
    country: "Ukraine",
    lat: 49.79059982299805,
    lng: 30.4414005279541,
  },
  {
    id: "N",
    name: "Fazenda São Nicolau Airport",
    city: "COTRIGUACU",
    country: "Brazil",
    lat: -9.8644437789917,
    lng: -58.229167938232,
  },
  {
    id: "N",
    name: "Kisoro Airport",
    city: "Kisoro",
    country: "Uganda",
    lat: -1.2837,
    lng: 29.7197,
  },
  {
    id: "KSE",
    name: "Kasese Airport",
    city: "Kasese",
    country: "Uganda",
    lat: 0.18299999833106995,
    lng: 30.100000381469727,
  },
  {
    id: "N",
    name: "Stennis International Airport",
    city: "Bay St. Louis",
    country: "United States",
    lat: 30.367799758911133,
    lng: -89.45459747314453,
  },
  {
    id: "NCJ",
    name: "Sunchales Aeroclub Airport",
    city: "Sunchales",
    country: "Argentina",
    lat: -30.9575,
    lng: -61.5283,
  },
  {
    id: "IST",
    name: "Istanbul Airport",
    city: "Istanbul",
    country: "Turkey",
    lat: 41.275278,
    lng: 28.751944,
  },
  {
    id: "SOV",
    name: "Seldovia Airport",
    city: "Seldovia",
    country: "United States",
    lat: 59.442401885986,
    lng: -151.70399475098,
  },
  {
    id: "YSG",
    name: "Lutselk'e Airport",
    city: "Lutselk'e",
    country: "Canada",
    lat: 62.418303,
    lng: -110.681998,
  },
  {
    id: "N",
    name: "Engeløy Airport",
    city: "Engeløy",
    country: "Norway",
    lat: 67.967222,
    lng: 14.9925,
  },
  {
    id: "DWA",
    name: "Dwangwa Airport",
    city: "Dwangwa",
    country: "Malawi",
    lat: -12.5183,
    lng: 34.131901,
  },
  {
    id: "HGI",
    name: "Paloich Airport, Heliport",
    city: "Higleig",
    country: "South Sudan",
    lat: 10.529167,
    lng: 32.500556,
  },
  {
    id: "N",
    name: "Julian Carroll Airport",
    city: "Jackson",
    country: "United States",
    lat: 37.59389877319336,
    lng: -83.31729888916016,
  },
  {
    id: "N",
    name: "Beaufort MCAS - Merritt Field",
    city: "Beaufort",
    country: "United States",
    lat: 32.4774017334,
    lng: -80.723197937,
  },
  {
    id: "N",
    name: "Camp Pendleton MCAS (Munn Field) Airport",
    city: "Oceanside",
    country: "United States",
    lat: 33.30130005,
    lng: -117.3550034,
  },
  {
    id: "N",
    name: "Aerodromo de Castelo Branco",
    city: "Castelo Branco",
    country: "Portugal",
    lat: 39.847022,
    lng: -7.44111,
  },
  {
    id: "N",
    name: "Ponte de Sor Airport",
    city: "Ponte de Sôr",
    country: "Portugal",
    lat: 39.211559,
    lng: -8.056542,
  },
  {
    id: "N",
    name: "Vilar de Luz Airfield",
    city: "Maia",
    country: "Portugal",
    lat: 41.27729,
    lng: -8.516209,
  },
  {
    id: "N",
    name: "Hard Bargain Airport",
    city: "",
    country: "Bahamas",
    lat: 23.011194,
    lng: -74.905889,
  },
  {
    id: "N",
    name: "Kenebetsu JASDF Airfield",
    city: "Kenebetsu",
    country: "Japan",
    lat: 43.425154,
    lng: 144.741354,
  },
  {
    id: "N",
    name: "Augusto Severo Airport",
    city: "Natal",
    country: "Brazil",
    lat: -5.91141986847,
    lng: -35.2476997375,
  },
  {
    id: "KQH",
    name: "Kishangarh Airport",
    city: "Ajmer",
    country: "India",
    lat: 26.601473,
    lng: 74.814147,
  },
  {
    id: "CNN",
    name: "Kannur International Airport",
    city: "Kannur",
    country: "India",
    lat: 11.918614,
    lng: 75.547211,
  },
  {
    id: "N",
    name: "Beijing Xijiao Airport",
    city: "Beijing",
    country: "China",
    lat: 39.9608,
    lng: 116.257004,
  },
  {
    id: "N",
    name: "Flores Airport",
    city: "MANAUS",
    country: "Brazil",
    lat: -3.0727779865264893,
    lng: -60.02111053466797,
  },
  {
    id: "N",
    name: "Umuwa Airport",
    city: "Umuwa",
    country: "Australia",
    lat: -26.4867000579834,
    lng: 132.0399932861328,
  },
  {
    id: "ZCO",
    name: "La Araucanía Airport",
    city: "Temuco",
    country: "Chile",
    lat: -38.9259,
    lng: -72.6515,
  },
  {
    id: "ASS",
    name: "Arathusa Safari Lodge Airport",
    city: "Arathusa",
    country: "South Africa",
    lat: -24.744165,
    lng: 31.522499,
  },
  {
    id: "VDI",
    name: "Vidalia Regional Airport",
    city: "Vidalia",
    country: "United States",
    lat: 32.192699432373,
    lng: -82.371200561523,
  },
  {
    id: "N",
    name: "Granbury Regional Airport",
    city: "Granbury",
    country: "United States",
    lat: 32.44440079,
    lng: -97.81690216,
  },
  {
    id: "N",
    name: "Oswego County Airport",
    city: "Fulton",
    country: "United States",
    lat: 43.350799560546875,
    lng: -76.38809967041016,
  },
  {
    id: "ISB",
    name: "New Islamabad International Airport",
    city: "Islamabad",
    country: "Pakistan",
    lat: 33.560713,
    lng: 72.851613,
  },
  {
    id: "N",
    name: "Vumbura Airport",
    city: "Vumburu",
    country: "Botswana",
    lat: -18.955395,
    lng: 22.814533,
  },
  {
    id: "N",
    name: "Farm Whitwater East Landing Strip",
    city: "Hardap",
    country: "Namibia",
    lat: -24.629999,
    lng: 15.9392,
  },
  {
    id: "N",
    name: "Muwaffaq Salti Air Base",
    city: "AZRAQ",
    country: "Jordan",
    lat: 31.8255996704,
    lng: 36.782001495399996,
  },
  {
    id: "N",
    name: "Kirkjubæjarklaustur Airport",
    city: "Kirkjubaejarklaustur ",
    country: "Iceland",
    lat: 63.79079818725586,
    lng: -18.001399993896484,
  },
  {
    id: "N",
    name: "Fazenda Uiapuru Airport",
    city: "COMODORO",
    country: "Brazil",
    lat: -13.663888931274414,
    lng: -56.002220153808594,
  },
  {
    id: "N",
    name: "Whitehorse Seaplane Base",
    city: "Whitehorse",
    country: "Canada",
    lat: 60.69110107421875,
    lng: -135.03700256347656,
  },
  {
    id: "N",
    name: "Pertominsk Airport",
    city: "Pertominsk",
    country: "Russia",
    lat: 64.7900009155,
    lng: 38.4199981689,
  },
  {
    id: "N",
    name: "Mount Weld Airport",
    city: "Laverton",
    country: "Australia",
    lat: -28.771699905395508,
    lng: 122.44000244140625,
  },
  {
    id: "N",
    name: "Kidston Airport",
    city: "Kidston",
    country: "Australia",
    lat: -18.8700008392334,
    lng: 144.17300415039062,
  },
  {
    id: "N",
    name: "Klaksvik Heliport",
    city: "Klaksvik",
    country: "Faroe Islands",
    lat: 62.2178497314,
    lng: -6.5764546394300005,
  },
  {
    id: "MHE",
    name: "Mitchell Municipal Airport",
    city: "Mitchell",
    country: "United States",
    lat: 43.774799346900004,
    lng: -98.03859710690001,
  },
  {
    id: "N",
    name: "Hunda Airport",
    city: "Tubu Tree Camp",
    country: "Botswana",
    lat: -19.2765,
    lng: 22.475646,
  },
  {
    id: "GIT",
    name: "Mchauru Airport",
    city: "Geita",
    country: "Tanzania",
    lat: -2.813667,
    lng: 32.172472,
  },
  {
    id: "GID",
    name: "Gitega Airport",
    city: "Gitega",
    country: "Burundi",
    lat: -3.417209,
    lng: 29.911308,
  },
  {
    id: "RMU",
    name: "Región de Murcia International Airport",
    city: "Murcia",
    country: "Spain",
    lat: 37.803,
    lng: -1.125,
  },
  {
    id: "N",
    name: "Fazenda Kajussol Airport",
    city: "Alta Floresta D'Oeste",
    country: "Brazil",
    lat: -11.9647216796875,
    lng: -61.686668395996094,
  },
  {
    id: "N",
    name: "Pelee Island Airport",
    city: "Pelee",
    country: "Canada",
    lat: 41.780399322509766,
    lng: -82.6780014038086,
  },
  {
    id: "CQS",
    name: "Costa Marques Airport",
    city: "COSTA MARQUES",
    country: "Brazil",
    lat: -12.421099662780762,
    lng: -64.25160217285156,
  },
  {
    id: "N",
    name: "Mangalore Airport",
    city: "Mangalore",
    country: "Australia",
    lat: -36.888301849365234,
    lng: 145.1840057373047,
  },
  {
    id: "N",
    name: "San Isidro del General Airport",
    city: "San Isidro",
    country: "Costa Rica",
    lat: 9.352620124816895,
    lng: -83.71309661865234,
  },
  {
    id: "ZXT",
    name: "Zabrat Airport",
    city: "Baku",
    country: "Azerbaijan",
    lat: 40.4955422161,
    lng: 49.9768066406,
  },
  {
    id: "JAM",
    name: "Bezmer Air Base",
    city: "Yambol",
    country: "Bulgaria",
    lat: 42.4548988342,
    lng: 26.3521995544,
  },
  {
    id: "N",
    name: "Osovtsy Air Base",
    city: "Byaroza",
    country: "Belarus",
    lat: 52.5569992065,
    lng: 24.884000778199997,
  },
  {
    id: "YUA",
    name: "Yuanmou Air Base",
    city: "Yuanmou",
    country: "China",
    lat: 25.737499237061,
    lng: 101.88200378418,
  },
  {
    id: "N",
    name: "Changsha Datuopu Airport/AFB",
    city: "Changsha",
    country: "China",
    lat: 28.0688991547,
    lng: 112.958000183,
  },
  {
    id: "XEN",
    name: "Xingcheng Air Base",
    city: "",
    country: "China",
    lat: 40.580299377399996,
    lng: 120.697998047,
  },
  {
    id: "GEC",
    name: "Lefkoniko Airport",
    city: "Geçitkale",
    country: "Cyprus",
    lat: 35.235947,
    lng: 33.724358,
  },
  {
    id: "MBI",
    name: "Songwe Airport",
    city: "Mbeya",
    country: "Tanzania",
    lat: -8.919942,
    lng: 33.273981,
  },
  {
    id: "N",
    name: "Kalocsa/Foktő Airport",
    city: "Kalocsa/Foktő",
    country: "Hungary",
    lat: 46.549613,
    lng: 18.942421,
  },
  {
    id: "UGU",
    name: "Bilogai-Sugapa Airport",
    city: "Sugapa-Papua Island",
    country: "Indonesia",
    lat: -3.73956,
    lng: 137.031998,
  },
  {
    id: "N",
    name: "Jakkur Aerodrome",
    city: "Bengaluru",
    country: "India",
    lat: 13.07674,
    lng: 77.597645,
  },
  {
    id: "N",
    name: "Jalal-Abad Airport",
    city: "Jalal-Abad",
    country: "Kyrgyzstan",
    lat: 40.944401,
    lng: 72.977798,
  },
  {
    id: "ETM",
    name: "Ramon Airport",
    city: "Eilat",
    country: "Israel",
    lat: 29.723694,
    lng: 35.011416,
  },
  {
    id: "MNH",
    name: "Rustaq Airport",
    city: "Al Masna'ah",
    country: "Oman",
    lat: 23.640556,
    lng: 57.4875,
  },
  {
    id: "CGY",
    name: "Laguindingan Airport",
    city: "Cagayan de Oro City",
    country: "Philippines",
    lat: 8.612203,
    lng: 124.456496,
  },
  {
    id: "N",
    name: "Kostomuksha Airport",
    city: "Kostomuksha",
    country: "Russia",
    lat: 64.61799621579999,
    lng: 30.687000274699997,
  },
  {
    id: "N",
    name: "Privolzhskiy Air Base",
    city: "Astrakhan",
    country: "Russia",
    lat: 46.396,
    lng: 47.893,
  },
  {
    id: "N",
    name: "Kubinka Air Base",
    city: "Kubinka",
    country: "Russia",
    lat: 55.611695,
    lng: 36.650002,
  },
  {
    id: "N",
    name: "Rogachyovo Air Base",
    city: "Belaya",
    country: "Russia",
    lat: 71.61669921880001,
    lng: 52.4782981873,
  },
  {
    id: "N",
    name: "Ulan-Ude East Airport",
    city: "Ulan Ude",
    country: "Russia",
    lat: 51.849998474121094,
    lng: 107.73799896240234,
  },
  {
    id: "N",
    name: "Krechevitsy Air Base",
    city: "Novgorod",
    country: "Russia",
    lat: 58.625,
    lng: 31.385000228881836,
  },
  {
    id: "CPO",
    name: "Desierto de Atacama Airport",
    city: "Copiapo",
    country: "Chile",
    lat: -27.2611999512,
    lng: -70.7791976929,
  },
  {
    id: "N",
    name: "Melitopol Air Base",
    city: "Melitopol",
    country: "Ukraine",
    lat: 46.880001,
    lng: 35.305,
  },
];

export const AIRPORT_DICTIONARY_INDEX = Object.fromEntries(
  AIRPORTS_ARRAY.map((airport) => [airport.id, airport])
);
